webpackJsonp([0],Array(439).concat([
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(518);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(519);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(520);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(521);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(522);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(73);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(822);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./style.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./style.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(777);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../css-loader/index.js??ref--2-rules-1!../../../postcss-loader/lib/index.js??ref--2-rules-3!./bootstrap.css", function() {
        content = require("!!../../../css-loader/index.js??ref--2-rules-1!../../../postcss-loader/lib/index.js??ref--2-rules-3!./bootstrap.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1828)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)(module)))

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Col; });
/* unused harmony export Navbar */
/* unused harmony export NavbarBrand */
/* unused harmony export NavbarToggler */
/* unused harmony export Nav */
/* unused harmony export NavItem */
/* unused harmony export NavDropdown */
/* unused harmony export NavLink */
/* unused harmony export Breadcrumb */
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export ButtonDropdown */
/* unused harmony export ButtonGroup */
/* unused harmony export ButtonToolbar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Dropdown; });
/* unused harmony export DropdownItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DropdownToggle; });
/* unused harmony export Fade */
/* unused harmony export Badge */
/* unused harmony export Card */
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* unused harmony export CardBody */
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* unused harmony export CardHeader */
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export Carousel */
/* unused harmony export UncontrolledCarousel */
/* unused harmony export CarouselControl */
/* unused harmony export CarouselItem */
/* unused harmony export CarouselIndicators */
/* unused harmony export CarouselCaption */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* unused harmony export CardTitle */
/* unused harmony export Popover */
/* unused harmony export PopoverContent */
/* unused harmony export PopoverBody */
/* unused harmony export PopoverTitle */
/* unused harmony export PopoverHeader */
/* unused harmony export Progress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ModalBody; });
/* unused harmony export ModalFooter */
/* unused harmony export PopperContent */
/* unused harmony export PopperTargetHelper */
/* unused harmony export Tooltip */
/* unused harmony export Table */
/* unused harmony export ListGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Form; });
/* unused harmony export FormFeedback */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FormGroup; });
/* unused harmony export FormText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Input; });
/* unused harmony export InputGroup */
/* unused harmony export InputGroupAddon */
/* unused harmony export InputGroupButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Label; });
/* unused harmony export Media */
/* unused harmony export Pagination */
/* unused harmony export PaginationItem */
/* unused harmony export PaginationLink */
/* unused harmony export TabContent */
/* unused harmony export TabPane */
/* unused harmony export Jumbotron */
/* unused harmony export Collapse */
/* unused harmony export ListGroupItem */
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* unused harmony export UncontrolledButtonDropdown */
/* unused harmony export UncontrolledDropdown */
/* unused harmony export UncontrolledNavDropdown */
/* unused harmony export UncontrolledTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);









// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  return parseInt(window.getComputedStyle(document.body, null).getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

function mapToCssModules(className, cssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

function getTarget(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && document) {
    var selection = document.querySelector(target);
    if (selection === null) {
      selection = document.querySelector('#' + target);
    }
    if (selection === null) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }

  return target;
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: stringOrNumberProp,
  pull: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    if (!i && columnProp === undefined) {
      columnProp = true;
    }

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'push' + colSizeInterfix + columnProp.push, columnProp.push || columnProp.push === 0), defineProperty(_classNames, 'pull' + colSizeInterfix + columnProp.pull, columnProp.pull || columnProp.pull === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$8 = {
  isOpen: false,
  dropup: false,
  nav: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        dropup: this.props.dropup
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav']);

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {
        'btn-group': group
      }, defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'dropup', dropup), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (context.isOpen) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];
    var position1 = context.dropup ? 'top' : 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? noFlipModifier : undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm A fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `ENTERING`
   *  - `ENTERED`
   *  - `EXITING`
   *  - `EXITED`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state= { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEventListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          src = _props.src,
          altText = _props.altText,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['src', 'altText', 'in', 'children', 'cssModule', 'slide', 'tag', 'className']);

      var imgClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'd-block', 'img-fluid'), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: itemClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, { className: imgClasses, src: src, alt: altText }),
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  altText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([CarouselCaption])
  }),
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'img',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = { direction: 'right' };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        indicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators', cssModule));
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src,
            src: item.src,
            altText: item.altText
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h4'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var defaultProps$33 = {
  placement: 'auto',
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body'
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'className', 'tag', 'container']);

      var arrowClassName = mapToCssModules('arrow', cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var modifiers = {
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: modifiers }, attrs, { component: tag, className: popperClassName }),
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$35;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$36));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$34;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$37;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$38;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$37;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.originalBodyPadding = null;
    _this.isBodyOverflowing = false;
    _this.togglePortal = _this.togglePortal.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.destroy = _this.destroy.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.togglePortal();
      }
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        // handle portal events/dom updates
        this.togglePortal();
      } else if (this._element) {
        // rerender portal
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy();
      if (this.props.onExit) {
        this.props.onExit();
      }
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      var _this2 = this;

      // so all methods get called before it is unmounted
      setTimeout(function () {
        return _this2.destroy();
      }, 0);
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'togglePortal',
    value: function togglePortal() {
      if (this.props.isOpen) {
        if (this.props.autoFocus) {
          this._focus = true;
        }
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        document.body.removeChild(this._element);
        this._element = null;
      }

      // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
      var classes = document.body.className.replace(/(^| )modal-open( |$)/, ' ');
      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes).trim(), this.props.cssModule);
      setScrollbarWidth(this.originalBodyPadding);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.renderIntoSubtree();
    }
  }, {
    key: 'show',
    value: function show() {
      if (this._dialog) {
        this.props.toggle(true);
        return;
      }
      var classes = document.body.className;
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this.originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, 'modal-open'), this.props.cssModule);

      this.renderIntoSubtree();
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _this3 = this;

      var attributes = omit(this.props, propsToOmit);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-dialog', this.props.className, defineProperty({}, 'modal-' + this.props.size, this.props.size)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this3._dialog = c;
          }
        }, attributes),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);

      // check if modal should receive focus
      if (this._focus) {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
          this._dialog.parentNode.focus();
        }
        this._focus = false;
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          wrapClassName = _props.wrapClassName,
          modalClassName = _props.modalClassName,
          backdropClassName = _props.backdropClassName,
          cssModule = _props.cssModule,
          isOpen = _props.isOpen,
          backdrop = _props.backdrop,
          role = _props.role,
          labelledBy = _props.labelledBy;


      var modalAttributes = {
        onClickCapture: this.handleBackdropClick,
        onKeyUp: this.handleEscape,
        style: { display: 'block' },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };

      var hasTransition = this.props.fade;
      var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });
      var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: mapToCssModules(wrapClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Fade,
          _extends({}, modalAttributes, modalTransition, {
            'in': isOpen,
            onEntered: this.onOpened,
            onExited: this.onClosed,
            cssModule: cssModule,
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
          }),
          this.renderModalDialog()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
          'in': isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$38;

var propTypes$41 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h4',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$41;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$42;
ModalBody.defaultProps = defaultProps$40;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$43;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$44 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$44));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$44;
Tooltip.defaultProps = defaultProps$42;

var propTypes$45 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      hover = props.hover,
      reflow = props.reflow,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'hover', 'reflow', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, inverse ? 'table-inverse' : false, hover ? 'table-hover' : false, reflow ? 'table-reflow' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: 'table-responsive' },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$45;
Table.defaultProps = defaultProps$43;

var propTypes$46 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$46;
ListGroup.defaultProps = defaultProps$44;

var propTypes$47 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

Form.propTypes = propTypes$47;
Form.defaultProps = defaultProps$45;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$46 = {
  tag: 'div'
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'invalid-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$48;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$49;
FormGroup.defaultProps = defaultProps$47;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$50;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the prop "valid"'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  tag: 'p',
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = selectInput || textareaInput ? type : 'input';

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag;
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined') {
        if (state === 'danger') {
          valid = false;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid === false && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$51;
Input.defaultProps = defaultProps$49;

var propTypes$52 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$52;
InputGroup.defaultProps = defaultProps$50;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-addon'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupAddon.propTypes = propTypes$53;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'div'
};

var InputGroupButton = function InputGroupButton(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var groupClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(groupClassName, 'input-group-btn'), cssModule);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, groupAttributes, { className: groupClasses }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { className: className, children: children }))
    );
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-btn'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupButton.propTypes = propTypes$54;
InputGroupButton.defaultProps = defaultProps$52;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: stringOrNumberProp$1,
  pull: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$55 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'push' + colSizeInterfix + columnProp.push, columnProp.push || columnProp.push === 0), defineProperty(_classNames, 'pull' + colSizeInterfix + columnProp.pull, columnProp.pull || columnProp.pull === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false, !check && !colClasses.length ? 'form-control-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$55;
Label.defaultProps = defaultProps$53;

var propTypes$56 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$56;

var propTypes$57 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$54 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$57;
Pagination.defaultProps = defaultProps$54;

var propTypes$58 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$58;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$59 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$59;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$60 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$60));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$60;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$61 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$61;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$62 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$62;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$63 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes)
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, transition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$63;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$64 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$64;
Collapse.defaultProps = defaultProps$61;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item');

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$65;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$66;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$67 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$67;
ListGroupItemText.defaultProps = defaultProps$64;

var Component$1 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

var components = {
  UncontrolledAlert: Alert,
  UncontrolledButtonDropdown: ButtonDropdown,
  UncontrolledDropdown: Dropdown,
  UncontrolledNavDropdown: NavDropdown,
  UncontrolledTooltip: Tooltip
};

Object.keys(components).forEach(function (key) {
  var Tag = components[key];
  var defaultValue = Tag === Alert;

  var Uncontrolled = function (_Component) {
    inherits(Uncontrolled, _Component);

    function Uncontrolled(props) {
      classCallCheck(this, Uncontrolled);

      var _this = possibleConstructorReturn(this, (Uncontrolled.__proto__ || Object.getPrototypeOf(Uncontrolled)).call(this, props));

      _this.state = { isOpen: defaultValue };

      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    createClass(Uncontrolled, [{
      key: 'toggle',
      value: function toggle() {
        this.setState({ isOpen: !this.state.isOpen });
      }
    }, {
      key: 'render',
      value: function render() {
        if (key === 'UncontrolledNavDropdown') {
          warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
      }
    }]);
    return Uncontrolled;
  }(Component$1);

  Uncontrolled.displayName = key;

  components[key] = Uncontrolled;
});

var UncontrolledAlert = components.UncontrolledAlert;
var UncontrolledButtonDropdown = components.UncontrolledButtonDropdown;
var UncontrolledDropdown = components.UncontrolledDropdown;
var UncontrolledNavDropdown = components.UncontrolledNavDropdown;
var UncontrolledTooltip = components.UncontrolledTooltip;


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["l"] = setisNotExpiredLogin;
/* harmony export (immutable) */ __webpack_exports__["g"] = setUserEmail;
/* harmony export (immutable) */ __webpack_exports__["j"] = setUserPassword;
/* harmony export (immutable) */ __webpack_exports__["i"] = setUserName;
/* harmony export (immutable) */ __webpack_exports__["k"] = setUserPhone;
/* harmony export (immutable) */ __webpack_exports__["h"] = setUserInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = setIsShowLoginModal;
/* harmony export (immutable) */ __webpack_exports__["e"] = setIsShowRegisterModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = setIsShowUpdateUserModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = setHaveAgreedToReceiveGogovanUpdates;
/* harmony export (immutable) */ __webpack_exports__["c"] = setHaveAgreedToReceiveThirdPartiesUpdates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(35);
/* eslint-disable import/prefer-default-export */

function login(email, password) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* LOGIN */],
      payload: {
        email: email,
        password: password
      }
    });
  };
}
function setisNotExpiredLogin() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* IS_EXPIRED_LOGIN */]
    });
  };
}
function setUserEmail(email) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_6" /* SET_EMAIL */],
      payload: email
    });
  };
}
function setUserPassword(password) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_13" /* SET_PASSWORD */],
      payload: password
    });
  };
}
function setUserName(name) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_17" /* SET_USERNAME */],
      payload: name
    });
  };
}
function setUserPhone(phone) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_14" /* SET_PHONE_NUMBER */],
      payload: phone
    });
  };
}
function setUserInfo(user) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_18" /* SET_USER_INFO */],
      payload: user
    });
  };
}
function setIsShowLoginModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* IS_SHOW_LOGIN_MODAL */]
    });
  };
}
function setIsShowRegisterModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* IS_SHOW_REGISTER_MODAL */]
    });
  };
}
function setIsShowUpdateUserModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* IS_SHOW_UPDATE_USER_MODAL */]
    });
  };
}
function setHaveAgreedToReceiveGogovanUpdates() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_7" /* SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES */]
    });
  };
}
function setHaveAgreedToReceiveThirdPartiesUpdates() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_8" /* SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES */]
    });
  };
}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","social_media_instagram":"Instagram","close":"Close","menu":"MENU","learn_more":"LEARN MORE","page_home":"HOME","page_/home":"HOME","page_quoting":"GET QUOTE","page_order":"PLACE AN ORDER","page_ordering_order":"PLACE ORDER","page_service":"SERVICES","page_pricing":"PRICING","page_business":"BUSINESS","page_about_us":"ABOUT US","page_about_gogovan":"ABOUT GOGOVAN","page_faq":"FAQ","page_contact":"CONTACT US","page_career":"CAREERS","page_legal":"TERMS & CONDITIONS","page_privacy":"PRIVACY POLICY","page_dashboard":"Dashboard","page_payment":"PAYMENT","page_help_center":"Help Center","page_http://help.gogox.com":"Help Center","page_blog":"BLOG","page_join":"BE A DRIVER","page_driver_site":"BE A DRIVER","page_media":"MEDIA","page_download":"Download GOGOX Apps","page_order_download":"Download GOGOX Apps","page_/order_download":"Download GOGOX Apps","page_sign_out":"Sign Out","page_login":"LOGIN","page_register":"REGISTER","page_profile":"Profile","page_ordering_dashboard":"Dashboard","page_my_order_records":"My Order Records","page_about":"ABOUT US","page_gogoad":"ADVERTISE WITH US","title_company":"COMPANY","title_services_pricing":"SERVICES & PRICING","title_support":"SUPPORT","footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"07:00-24:00","language_zh_cn":"简体中文（中国）","language_en_hk":"English (Hong Kong)","language_zh_hk":"繁體中文（香港）","language_en_in":"English (India)","language_en_sg":"English (Singapore)","language_zh_tw":"正體中文（臺灣）","language_ko_kr":"한국어 (한국)","update_profile_modal_title":"UPDATE PROFILE","register_modal_title":"REGISTER","register_modal_email_input":"Email address","register_modal_username_input":"Your Name","register_modal_phone_input":"Phone","register_modal_password_input":"Password","register_modal_confirm_password_input":"Confirm Password","register_modal_register_btn":"REGISTER","register_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","register_modal_redirect_to_login_btn":"Login here","register_modal_normal_message":" if you have already registered","register_modal_or":"OR","register_info_gogovan_tos":"By joining us, you agree to GOGOX's <a href='https://www.gogox.com/sg/terms' class=\"blue\" target=\"_blank\">Consumer Terms & Conditions</a> and <a href='https://www.gogox.com/sg/privacy' class=\"blue\" target=\"_blank\">Privacy Policy</a>","register_checkbox_gogovan_updates":"I'd like to receive updates about GOGOX's latest promotions, products and service offerings via email and/or SMS.","register_checkbox_third_parties_updates":"I'd like to receive occasional updates from GOGOX on selected third parties' promotions, products and services via email and/or SMS.","pdpa_overlay_ok":"OK","login_modal_title":"LOGIN","login_modal_email_input":"Email address","login_modal_password_input":"Password","login_modal_login_btn":"LOGIN","login_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","login_modal_redirect_to_register_btn":"Register here","login_modal_forgot_password_btn":"I forgot my password","login_modal_normal_message":" if you don’t have an account","login_modal_or":"OR","login_error_modal_title":"Oops! You've been logged out.","login_error_modal_body":"Your session has expired. Please login again to continue.","login_error_modal_login_btn":"LOGIN","error_wrong_modal_title":"Oops! Something went wrong.","error_wrong_modal_body":"Please try again, or contact us if you need help.","error_wrong_modal_help_btn":"HELP","error_wrong_modal_okay_btn":"OKAY","error_message_login_info_incorrect":"Sorry, incorrect email or password","error_message_password_length_not_enough":"Please provide your password with at least 8 characters","error_message_please_confirm_password":"Please confirm your password","error_message_password_not_match":"Sorry, your password does not match each other","error_message_please_fill_password":"Please fill in your password","error_message_please_fill_email_address":"Please fill in the email address","error_message_please_fill_username":"Please provide your name with at least one character","error_message_email_address_invalid":"Please fill in a valid email address","error_message_email_used_error_tag":"Oops: That email address is already in use.<br/>Do you want to <a href='#' style='text-decoration:underline;cursor:pointer;'>log in</a> instead?","error_message_email_used_error_tag_t":"Oops: That email address is already in use.","error_message_email_used_error_tag_t_2":"Do you want to ","error_message_please_enter_telephone_number":"Please enter a valid Hong Kong phone number.","error_message_telephone_number_in_use":"Oops, this phone number is already in use.","download_our_app":"Download Our Apps","download_app":"DOWNLOAD APP","app_download_banner_title":"GoGoVan","app_download_banner_desc":"Asia's leading transportation and logistics App","app_download_banner_open":"Open","app_download_banner_download":"Download","app_download_banner_send_link":"Send Link","app_download_banner_tel_prefix":"+852","app_download_banner_tel_placeholder":"+852 3590-3399","business_account":"Business account","click_here":"click here","no_account":"Don't have an account?","have_account":"Have an account?","sign_up":"Sign up","login":"Login","sign_up_business":"Sign up for GOGOBUSINESS"}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(778);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(780);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(960);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Order.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Order.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/locale.json": 445,
	"./hk/en_hk/setting/general/locale.json": 541,
	"./hk/zh_hk/setting/general/locale.json": 542,
	"./in/setting/general/locale.json": 543,
	"./kr/setting/general/locale.json": 544,
	"./sg/setting/general/locale.json": 545,
	"./tw/setting/general/locale.json": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(880);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./login.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./login.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/hk/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"facebook":"https://www.facebook.com/gogovanhk","googleplus":"https://plus.google.com/+GogovanHk/posts","youtube":"http://www.youtube.com/user/MyGoGoVan","instagram":"https://instagram.com/gogovan_hk/","linkedin":"https://www.linkedin.com/company/gogovan","home":"https://www.gogox.com/","quoting":"/quoting","order":"/order","ordering_order":{"ui-sref":"order"},"ordering_dashboard":{"ui-sref":"dashboard"},"ordering_profile":{"ui-sref":"profile"},"service":"/service","pricing":"/pricing","business":"/business","about":"/about","faq":"/faq","contact":"/contact","career":{"href":"http://gogovan.theresumator.com/","target":"_blank"},"legal":"/legal","privacy":"/privacy","profile":"/profile","dashboard":"/dashboard","my_order_records":"/dashboard","payment":"/payment","password":"/password","help_center":"/faq","blog":{"href":"http://www.gogovan.com.hk/blog/","target":"_blank"},"download":"/#download","order_download":{"href":"/#download","target":"_self"},"sign_out":"#signout","login":"#login","register":"#register","language_en_hk":"https://www.gogovan.com.hk/en","language_zh_hk":"https://www.gogovan.com.hk","language_en_sg":"https://www.gogovan.sg","language_zh_tw":"https://www.gogovan.tw","language_ko_kr":"http://www.gogovan.co.kr","language_zh_cn":"http://www.kuaigou.co","language_en_in":"https://www.gogovan.co.in","youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/","target":"_blank"},"gogoad":{"href":"http://www.mobillboard.co/","target":"_blank"},"qiye":"/qiye","sign_in":"/login","sign_up":"/signup","gogobusiness":"https://hk-business.gogox.com"}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/service/auth.js
var auth = __webpack_require__(149);

// CONCATENATED MODULE: ./src/service/userService.js
/* eslint-disable import/prefer-default-export */

function isNotExpiredLogin(status, fn) {
  if (status === 401) {
    if (fn) {
      fn();
      return false;
    }
  }

  return true;
}
function checkIsLogin(fn) {
  if (typeof Object(auth["b" /* getAuth */])().id === 'undefined' || typeof Object(auth["b" /* getAuth */])().email === 'undefined') {
    isNotExpiredLogin(401, fn); // window.location.href = href;
  }
}
// CONCATENATED MODULE: ./src/service/util.js
/* harmony export (immutable) */ __webpack_exports__["b"] = dateToISO8601String;
/* harmony export (immutable) */ __webpack_exports__["c"] = dateToShowFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = IsValidResponseStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = returnLocaleText;

function dateToISO8601String(date) {
  var now = date || new Date();
  var tzo = -now.getTimezoneOffset();
  var dif = tzo >= 0 ? '+' : '-';

  var pad = function pad(num) {
    var norm = Math.abs(Math.floor(num));
    return (norm < 10 ? '0' : '') + norm;
  };

  var newDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().replace(/Z$/, '');
  var newPad = "".concat(pad(tzo / 60), ":").concat(pad(tzo % 60));
  return "".concat(newDate).concat(dif).concat(newPad);
}
function dateToShowFormat(date) {
  var nDate = new Date(date);
  var m = nDate.getMonth() + 1;
  var min = nDate.getMinutes();

  if (m.toString().length === 1) {
    m = "0".concat(m);
  }

  if (min.toString().length === 1) {
    min = "0".concat(nDate.getMinutes());
  }

  return "".concat(nDate.getDate(), "/").concat(m, "/").concat(nDate.getFullYear(), ", ").concat(nDate.getHours(), ":").concat(min);
}
function IsValidResponseStatus(status, fn) {
  return isNotExpiredLogin(status, fn) && !(status === 404 || status === 401);
} // check locale

function returnLocaleText(t1, t2) {
  if (typeof t1 === 'undefined') {
    return t2;
  }

  return t1;
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(535)('wks');
var uid = __webpack_require__(475);
var Symbol = __webpack_require__(456).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = setIsToggleOn;
/* harmony export (immutable) */ __webpack_exports__["q"] = setOrderVehicleType;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOrderAddress;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateOrderAddress;
/* harmony export (immutable) */ __webpack_exports__["b"] = addOrderImage;
/* harmony export (immutable) */ __webpack_exports__["u"] = updateOrderImage;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeOrderImage;
/* unused harmony export setPassengerCount */
/* unused harmony export setTunnel */
/* unused harmony export setPickupTime */
/* unused harmony export setNeedOver6ft */
/* unused harmony export setRemoveNet */
/* harmony export (immutable) */ __webpack_exports__["f"] = setCartCount;
/* harmony export (immutable) */ __webpack_exports__["n"] = setNeedCart;
/* harmony export (immutable) */ __webpack_exports__["m"] = setNeedCarry;
/* unused harmony export setNeedNewCar */
/* unused harmony export setNeedPet */
/* unused harmony export setNeedWaste */
/* harmony export (immutable) */ __webpack_exports__["r"] = setPayByReceiver;
/* harmony export (immutable) */ __webpack_exports__["o"] = setOrderIDDetail;
/* harmony export (immutable) */ __webpack_exports__["g"] = setDriverBlacklist;
/* harmony export (immutable) */ __webpack_exports__["p"] = setOrderPriceBreakdownDetail;
/* unused harmony export setOrderRemark */
/* unused harmony export setOrderCoupon */
/* harmony export (immutable) */ __webpack_exports__["h"] = setIsClickConfirmOrder;
/* harmony export (immutable) */ __webpack_exports__["l"] = setIsValidOrder;
/* harmony export (immutable) */ __webpack_exports__["c"] = addUploadedOrderImage;
/* harmony export (immutable) */ __webpack_exports__["t"] = updateOrderDetailInfoAction;
/* unused harmony export addOrderDetailInfoAction */
/* harmony export (immutable) */ __webpack_exports__["d"] = initOrderDetailInfoAction;
/* harmony export (immutable) */ __webpack_exports__["i"] = setIsShowCoupon;
/* harmony export (immutable) */ __webpack_exports__["k"] = setIsUploadedClientPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(35);
/* eslint-disable import/prefer-default-export */

function setIsToggleOn() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_9" /* SET_IS_TOGGLE_ON */],
      payload: {}
    });
  };
}
function setOrderVehicleType(vehicle) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["X" /* ORDER_VEHICLE_TYPE */],
      payload: vehicle
    });
  };
}
function addOrderAddress(address) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* ORDER_ADD_ADDRESS */],
      payload: address
    });
  };
}
function updateOrderAddress(address, index) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["V" /* ORDER_UPDATE_ADDRESS */],
      payload: address,
      index: index
    });
  };
}
function addOrderImage(image) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* ORDER_ADD_IMAGE */],
      payload: image
    });
  };
}
function updateOrderImage(image, index) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["W" /* ORDER_UPDATE_IMAGE */],
      payload: image,
      index: index
    });
  };
}
function removeOrderImage(index) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["S" /* ORDER_REMOVE_IMAGE */],
      index: index
    });
  };
}
function setPassengerCount(count) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["N" /* ORDER_PASSENGER_COURT */],
      payload: count
    });
  };
}
function setTunnel(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["U" /* ORDER_TUNNEL */],
      payload: input
    });
  };
} // unless

function setPickupTime(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["P" /* ORDER_PICKUP_TIME */],
      payload: input
    });
  };
}
function setNeedOver6ft(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* ORDER_NEED_OVER_6FT */],
      payload: input
    });
  };
}
function setRemoveNet(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["T" /* ORDER_REMOVE_NET */],
      payload: input
    });
  };
}
function setCartCount(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* ORDER_CART_COUNT */],
      payload: input
    });
  };
}
function setNeedCart(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* ORDER_NEED_CART */],
      payload: input
    });
  };
}
function setNeedCarry(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* ORDER_NEED_CARRY */],
      payload: input
    });
  };
}
function setNeedNewCar(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* ORDER_NEED_NEW_CAR */],
      payload: input
    });
  };
}
function setNeedPet(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["L" /* ORDER_NEED_PET */],
      payload: input
    });
  };
}
function setNeedWaste(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["M" /* ORDER_NEED_WASTE */],
      payload: input
    });
  };
}
function setPayByReceiver(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["O" /* ORDER_PAY_BY_RECEIVER */],
      payload: input
    });
  };
}
function setOrderIDDetail(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* ORDER_ID_DETAIL */],
      payload: input
    });
  };
}
function setDriverBlacklist(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_5" /* SET_DRIVER_BLACKLIST */],
      payload: input
    });
  };
}
function setOrderPriceBreakdownDetail(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["Q" /* ORDER_PRICE_BREAKDOWN_DETAIL */],
      payload: input
    });
  };
}
function setOrderRemark(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["R" /* ORDER_REMARK */],
      payload: input
    });
  };
}
function setOrderCoupon(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* ORDER_COUPON */],
      payload: input
    });
  };
}
function setIsClickConfirmOrder(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* IS_CLICK_CONFIRM_ORDER */],
      payload: input
    });
  };
}
function setIsValidOrder(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* IS_VALID_ORDER */],
      payload: input
    });
  };
}
function addUploadedOrderImage(input) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ADD_UPLOADED_ORDER_IMAGE */],
      payload: input
    });
  };
}
function updateOrderDetailInfoAction(service, service2, payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_19" /* UPDATE_ORDER_DETAIL_INFO */],
      service: service,
      service2: service2,
      payload: payload
    });
  };
}
function addOrderDetailInfoAction(service, payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_ORDER_DETAIL_INFO */],
      service: service,
      payload: payload
    });
  };
}
function initOrderDetailInfoAction(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* INIT_ORDER_DETAIL_INFO */],
      payload: payload
    });
  };
}
function setIsShowCoupon(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* IS_SHOW_COUPON */],
      payload: payload
    });
  };
}
function setIsUploadedClientPhoto(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* IS_UPLOADED_CLIENT_PHOTO */],
      payload: payload
    });
  };
}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(462);
var IE8_DOM_DEFINE = __webpack_require__(577);
var toPrimitive = __webpack_require__(531);
var dP = Object.defineProperty;

exports.f = __webpack_require__(458) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(470)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 459 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var core = __webpack_require__(446);
var ctx = __webpack_require__(573);
var hide = __webpack_require__(464);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSetting; });
function _sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _slicedToArray(arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return _sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }

function getFromAssets(key, currentLocale) {
  var folder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'general';
  var type = arguments.length > 3 ? arguments[3] : undefined;

  var _currentLocale$toLowe = currentLocale.toLowerCase().split('-'),
      _currentLocale$toLowe2 = _slicedToArray(_currentLocale$toLowe, 2),
      lang = _currentLocale$toLowe2[0],
      country = _currentLocale$toLowe2[1];

  var fileLang = country === 'hk' ? "".concat(lang, "_").concat(country, "/") : '';

  var defaultData = __webpack_require__(881)("./".concat(folder, "/").concat(type));

  var data = __webpack_require__(882)("./".concat(country, "/").concat(fileLang, "setting/").concat(folder, "/").concat(type));

  if (typeof data[key] !== 'undefined') {
    return data[key];
  }

  return defaultData[key];
}

function getTranslation(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'locale');
}

function getLink(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'link');
}

function getSetting(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'setting');
}



/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(465);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(769);
var defined = __webpack_require__(529);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(457);
var createDesc = __webpack_require__(474);
module.exports = __webpack_require__(458) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-HK","lang_lib":"en","login_facebook":true,"enable_ordering":true,"enable_google_map":true,"enable_baidu_map":false,"enable_olleh_map":false,"disable_google":false,"disable_lato":false,"redirect_to_mobile_index":false,"info_email":"info@gogovan.hk","phone_number":"35903399","info_business_email":"business@gogovan.hk","business_phone_number":"35908975","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact"]},"header":{"pages":["business","pricing","quoting"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site","gogoad"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["/home","http://help.gogox.com","/order_download"],"footer_nav":["about","service","pricing","business","privacy"]},"sg_pdpa":false,"gogobusiness":true}

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setIsCancelOrderDialogOn */
/* harmony export (immutable) */ __webpack_exports__["a"] = setIsCancelOrderAlertOn;
/* harmony export (immutable) */ __webpack_exports__["l"] = setIsShowStarDialog;
/* harmony export (immutable) */ __webpack_exports__["c"] = setIsShowBlacklistDialog;
/* harmony export (immutable) */ __webpack_exports__["f"] = setIsShowReportIssueDialog;
/* harmony export (immutable) */ __webpack_exports__["d"] = setIsShowBonusPriceDialog;
/* harmony export (immutable) */ __webpack_exports__["e"] = setIsShowExtraMessageDialog;
/* harmony export (immutable) */ __webpack_exports__["g"] = setIsShowSMSPhoneDialog;
/* harmony export (immutable) */ __webpack_exports__["h"] = setIsShowSMSVerfiyDialog;
/* harmony export (immutable) */ __webpack_exports__["b"] = setIsSendingSMS;
/* harmony export (immutable) */ __webpack_exports__["i"] = setIsShowSMSVerfiyLoadingDialog;
/* harmony export (immutable) */ __webpack_exports__["j"] = setIsShowSMSVerfiySuccessDialog;
/* harmony export (immutable) */ __webpack_exports__["k"] = setIsShowSimpleMessageDialog;
/* harmony export (immutable) */ __webpack_exports__["m"] = setSimpleMessage;
/* unused harmony export setIsShowAgreeToReceiveDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(35);
/* eslint-disable import/prefer-default-export */

function setIsCancelOrderDialogOn() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* IS_SHOW_CANCEL_ORDER_DIALOG */]
    });
  };
}
function setIsCancelOrderAlertOn() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* IS_SHOW_CANCEL_ORDER_DIALOG_ALERT */]
    });
  };
}
function setIsShowStarDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* IS_SHOW_STAR_DIALOG */]
    });
  };
}
function setIsShowBlacklistDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* IS_SHOW_BLACKLIST_DIALOG */]
    });
  };
}
function setIsShowReportIssueDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* IS_SHOW_REPORT_ISSUE_DIALOG */]
    });
  };
}
function setIsShowBonusPriceDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* IS_SHOW_BONUS_PRICE_DIALOG */]
    });
  };
}
function setIsShowExtraMessageDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* IS_SHOW_EXTRA_MESSAGE_DIALOG */]
    });
  };
}
function setIsShowSMSPhoneDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* IS_SHOW_SMS_PHONE_DIALOG */]
    });
  };
}
function setIsShowSMSVerfiyDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* IS_SHOW_SMS_VERIFY_DIALOG */]
    });
  };
}
function setIsSendingSMS(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* IS_SENDING_SMS */],
      payload: payload
    });
  };
}
function setIsShowSMSVerfiyLoadingDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* IS_SHOW_SMS_VERIFY_LOADING_DIALOG */]
    });
  };
}
function setIsShowSMSVerfiySuccessDialog(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG */],
      payload: payload
    });
  };
}
function setIsShowSimpleMessageDialog(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* IS_SHOW_SIMPLE_MESSAGE_DIALOG */],
      payload: payload
    });
  };
}
function setSimpleMessage(payload) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_16" /* SET_SIMPLE_MESSAGE */],
      payload: payload
    });
  };
}
function setIsShowAgreeToReceiveDialog() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* IS_SHOW_AGREE_TO_RECEIVER_DIALOG */]
    });
  };
}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = login;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (immutable) */ __webpack_exports__["a"] = facebookLogin;
/* harmony export (immutable) */ __webpack_exports__["f"] = register;
/* harmony export (immutable) */ __webpack_exports__["h"] = userProfileUpdate;
/* harmony export (immutable) */ __webpack_exports__["b"] = fbuserProfileUpdate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUser;
/* unused harmony export setProfilePhoto */
/* harmony export (immutable) */ __webpack_exports__["g"] = sendSMS;
/* harmony export (immutable) */ __webpack_exports__["i"] = verificationSMS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFetch__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_localStorage__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_auth__ = __webpack_require__(149);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable import/prefer-default-export */



/**
 * login
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 */

function login(_x, _x2) {
  return _login.apply(this, arguments);
}
/**
 * Log out
 */

function _login() {
  _login = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/api/w1/users/sign_in.json';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context.prev = 3;
            _context.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", console.warn(_context.t0));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9]]);
  }));
  return _login.apply(this, arguments);
}

function logout() {
  Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["a" /* localStorageClear */])();
}
/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.access_token
 */

function facebookLogin(_x3, _x4) {
  return _facebookLogin.apply(this, arguments);
}
/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 * @param {String} json.phone_number
 * @param {String} json.name
 * @param {Boolean} json.has_agreed_to_receive_gogovan_updates
 * @param {Boolean} json.has_agreed_to_receive_third_parties_updates
 */

function _facebookLogin() {
  _facebookLogin = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = '/api/w1/auth/facebook';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context2.prev = 3;
            _context2.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", console.warn(_context2.t0));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 9]]);
  }));
  return _facebookLogin.apply(this, arguments);
}

function register(_x5, _x6) {
  return _register.apply(this, arguments);
}
/**
 * User Profile Update
 * @param  {Number}   id
 * @param  {Object}   user
 */

function _register() {
  _register = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = '/api/w1/users.json';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context3.prev = 3;
            _context3.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context3.abrupt("return", _context3.sent);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            return _context3.abrupt("return", console.warn(_context3.t0));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[3, 9]]);
  }));
  return _register.apply(this, arguments);
}

function userProfileUpdate(_x7, _x8, _x9) {
  return _userProfileUpdate.apply(this, arguments);
}
/**
 * Update User phone number when login with facebook
 * @param  {Object}   auths
 * @param  {String}   auths.email
 * @param  {String}   auths.phone_number
 * @param  {Object}  user
 * @param  {String}  user.phone_number
 */

function _userProfileUpdate() {
  _userProfileUpdate = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(id, user, locale) {
    var jsonToServer, auth, url, Options, options;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            jsonToServer = {
              user: user
            };
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            url = '/api/w1/users/profile';
            Options = {
              locale: locale
            };
            options = {
              method: 'PUT',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(jsonToServer)
            };
            _context4.prev = 5;
            _context4.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 8:
            return _context4.abrupt("return", _context4.sent);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](5);
            return _context4.abrupt("return", console.warn(_context4.t0));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[5, 11]]);
  }));
  return _userProfileUpdate.apply(this, arguments);
}

function fbuserProfileUpdate(_x10, _x11, _x12) {
  return _fbuserProfileUpdate.apply(this, arguments);
}
/**
 * Get User with Authorization
 */

function _fbuserProfileUpdate() {
  _fbuserProfileUpdate = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(auths, user, locale) {
    var jsonToServer, auth, url, Options, options;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            jsonToServer = {
              user: user
            };
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(auths);
            url = '/api/w1/users/profile';
            Options = {
              locale: locale
            };
            options = {
              method: 'PUT',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(jsonToServer)
            };
            _context5.prev = 5;
            _context5.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 8:
            return _context5.abrupt("return", _context5.sent);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](5);
            return _context5.abrupt("return", console.warn(_context5.t0));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[5, 11]]);
  }));
  return _fbuserProfileUpdate.apply(this, arguments);
}

function getUser(_x13, _x14) {
  return _getUser.apply(this, arguments);
}
/**
 * Set profile photo
 * @param {Object} profilePhoto
 * @param {int} profilePhoto.id
 * @param {Object} profilePhoto.urls
 * @param {String} profilePhoto.urls.square_small
 */

function _getUser() {
  _getUser = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(json, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = '/api/w1/users/profile.json';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context6.prev = 4;
            _context6.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options).then(function (res) {
              if (res !== 401 && res !== 404) {
                res.json().then(function (result) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);
                });
              } else {
                console.warn('getUser failed');
              }
            });

          case 7:
            return _context6.abrupt("return", _context6.sent);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](4);
            return _context6.abrupt("return", console.warn(_context6.t0));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[4, 10]]);
  }));
  return _getUser.apply(this, arguments);
}

function setProfilePhoto(profilePhoto) {
  // try backward compatible as profile_photo doesn't exist before
  if (!profilePhoto || !profilePhoto.urls) {
    return this;
  }

  var id = profilePhoto.id;
  var oldId = Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["b" /* localStorageGet */])('profile_photo_id', '');

  if (id !== oldId && profilePhoto.urls) {
    var url = profilePhoto.urls.square_small;
    Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["d" /* localStorageSet */])('profile_photo_id', id);
    Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["d" /* localStorageSet */])('profile_photo_url', url); // storeProfilePhoto(url);
  }

  return this;
}
/**
 * Send SMS
 * @param {Object} profilePhoto
 * @param {function} fn // callback function for changing isSending
 */

function sendSMS(_x15, _x16) {
  return _sendSMS.apply(this, arguments);
}
/**
 * Send SMS
 * @param {Object} profilePhoto
 */

function _sendSMS() {
  _sendSMS = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(locale, fn) {
    var url, auth, Options, options, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = '/api/w1/users/send_verification_sms';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context7.prev = 4;
            _context7.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options).then(function (result) {
              if (result.status !== 401 && result.status !== 404) {
                if (fn) {
                  fn(true);
                }
              } else {
                console.warn("sendSMS:".concat(result.status));
              }
            });

          case 7:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](4);
            return _context7.abrupt("return", console.warn(_context7.t0));

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[4, 11]]);
  }));
  return _sendSMS.apply(this, arguments);
}

function verificationSMS(_x17, _x18) {
  return _verificationSMS.apply(this, arguments);
}

function _verificationSMS() {
  _verificationSMS = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(params, locale) {
    var url, auth, Options, options, response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = '/api/w1/users/verify';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                verification_code: params
              })
            };
            _context8.prev = 4;
            _context8.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 7:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](4);
            return _context8.abrupt("return", console.warn(_context8.t0));

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 11]]);
  }));
  return _verificationSMS.apply(this, arguments);
}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = {"index_hero_hero_headline":"GET YOUR STUFF MOVING","index_hero_hero_body":"A CONVENIENT NEW LOGISTICS SERVICE AT YOUR FINGERTIPS","index_hero_quoting_first_input":"Enter a Pickup Point","index_hero_quoting_last_input":"Enter a Destination","index_hero_quoting_get_btn":"GET QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is a revolutionary new way to transport goods and passengers around the city. Customers can get access to thousands of drivers directly from their mobile phone. Download the app now.","index_service_service_title":"Services","index_service_service_body":"With over 30,000 professional drivers in Hong Kong, our logistics service can get your item delivered quickly and efficiently.","index_service_button_learn_more":"LEARN MORE","index_service_services_0":"Moving","index_service_services_1":"Pet Shuttle","index_service_services_2":"Oversized Goods","index_service_services_3":"Supplies Transport","index_service_services_4":"Warehouse In & Out","index_service_2_service_title":"Services2","index_service_2_service_body":"No matter which use case you are, with over 30,000 professional drivers in Hong Kong, our logistics service can get your items delivered fast and efficient.","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"COURIER / DELIVERY SERVICE","index_service_2_services_1":"MOVING SERVICE","index_service_2_services_2":"PASSENGER SERVICE","index_service_2_services_3":"TRANSPORT + DRIVER","index_service_2_services_body_0":"Door-to-door service for documents and parcels under 50 kg within 2 hours","index_service_2_services_body_1":"Service for moving your furniture island-wide","index_service_2_services_body_2":"Point-to-point service. Up to 13 passengers per van","index_service_2_services_body_3":"Vehicles of various sizes to carry your bulky, heavy, and odd-shaped goods","index_service_2_button_place_order":"PLACE ORDER","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT PRICE QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"FEEDBACK MATTERS","index_feature_title_6":"LARGEST FLEET IN HK","index_feature_body_1":"Enter the details of your order and receive an instant quote before finalizing the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders through our app anytime","index_feature_body_3":"Once you place your order, the GoGoVan system automatically notifies drivers with the appropriate vehicles in the surrounding area","index_feature_body_4":"Once a driver responds to your order, track his location using the GoGoVan app until the order is fulfilled","index_feature_body_5":"Rate your driver upon the completion of each order to ensure the best possible matches in the future","index_feature_body_6":"GoGoVan has more than 20,000 professional drivers, accommodating your needs in no time","index_howitwork_title":"Hassle-free Ordering","index_howitwork_items_title_1":"1. Request","index_howitwork_items_title_2":"2. Engage","index_howitwork_items_title_3":"3. Rate","index_howitwork_items_body_1":" a driver online or through our mobile app","index_howitwork_items_body_2":" with your designated driver to get the job done","index_howitwork_items_body_3":" the driver and complete your transaction","index_contact_comment_title":"Questions? Contact Us!","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please fill out the form below and we will get back to you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"Are you a driver? Join our network and start earning!","index_newsletter_subscriptions_comment_title":"Newsletter Subscriptions","index_newsletter_subscriptions_comment_bodys":["Thanks for your subscription!","Sign up to receive GOGOVAN email newsletters with updates on news"],"index_newsletter_subscriptions_comment_input_email":"Email","index_newsletter_subscriptions_comment_send_btn":"Submit","index_newsletter_subscriptions_wish_to_receive_news":"I wish to receive the latest news of GoGoVan by e-mail.","index_hero_campaign_gogobusiness_hero_headline":"BUSINESS PLATFORM","index_hero_campaign_gogobusiness_hero_body":"MONTHLY PAYMENT | CASH-FREE | CLEAR REPORTING","index_hero_campaign_gogobusiness_find_out_more":"FIND OUT MORE"}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/link.json": 452,
	"./hk/en_hk/setting/general/link.json": 549,
	"./hk/zh_hk/setting/general/link.json": 552,
	"./in/setting/general/link.json": 555,
	"./kr/setting/general/link.json": 558,
	"./sg/setting/general/link.json": 561,
	"./tw/setting/general/link.json": 564
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hk/scripts/components/setting.json": 854,
	"./in/scripts/components/setting.json": 855,
	"./kr/scripts/components/setting.json": 856,
	"./sg/scripts/components/setting.json": 857,
	"./tw/scripts/components/setting.json": 858
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "986fdc6e.jpg";

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 404","404_title":"Oops!","404_body":"We can’t find the page you’re looking for.","404_sub":"","404_links_title":"Here are some helpful links instead:","404_links_button_link_title":"TAKE ME HOME"}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = {"404_icon_van":{"alt":"Van","src":"icon_van.png","src_2x":"icon_van@2x.png","width":"200"}}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/404","prefix":"404"}],"section_404":{"button_link":"home","links":["service","pricing","faq","driver_site","business"]}}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"about_gogovan_headline":"About GoGoVan","about_gogovan_body":["Established in 2013, GoGoVan is the first app-based platform for transporting goods in Asia. The app GoGoVan was created to connect drivers and customers, and we aim to redefine the everyday logistics experience by providing a convenient and efficient service.","Since its successful July 2013 launch in Hong Kong, GoGoVan has expanded to Singapore, South Korea, China, and Taiwan. The GoGoVan network currently comprises of over 20,000 commercial vehicles and 70,000 registered drivers. It continues to grow rapidly, and our presence will soon encompass additional cities on a global scale."],"about_map_map_headline":"Explore our service near you","about_map_map_stat_name_countries_number":"6","about_map_map_stat_name_countries":"Countries","about_map_map_stat_name_cities_number":"13","about_map_map_stat_name_cities":"Cities","about_map_map_stat_name_registered_number":"150,000+","about_map_map_stat_name_registered":"Registered Vehicles","about_help_help_headline":"Business Partnership","about_help_help_desc":["GoGoVan is constantly exploring the beauty of science and technology, and we’re committed to making our daily lives easier and better. Join us on our mission to explore and expand the frontiers of freight.","Please contact us at <a href='mailto:info@gogovan.hk' class='blue'>info@gogovan.hk</a>"],"about_business_cooperation_business_cooperation_headline":"Business Cooperation","about_investment_investment_headline":"Investor","about_investment_investment_desc":["GoGoVan provides an investment opportunity in Asia as a top ­tier global logistics service platform in Asia.","Founded in 2013 in Hong Kong, we have expanded to Singapore, South Korea, China, Taiwan, India, and we will continue to expand globally.","If you like how GoGoVan is changing the world, and want to invest in our global expansion plans, please contact us at <a href='mailto:info@gogovan.hk' class='blue'>info@gogovan.hk</a>"],"about_hire_hire_headline":"And yes, we are hiring","about_hire_job_opportunity":"JOB LISTINGS"}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"ikea":{"alt":"Ikea","src":"partnerships_ikea.png","src_2x":"partnerships_ikea@2x.png","width":"83","height":"30"},"kfc":{"alt":"KFC","src":"partnerships_kfc.png","src_2x":"partnerships_kfc@2x.png","width":"107","height":"30"},"pizzahut":{"alt":"Pizzahut","src":"partnerships_pizzahut.png","src_2x":"partnerships_pizzahut@2x.png","width":"50","height":"50"},"pricerite":{"alt":"Pricerite","src":"partnerships_pricerite.png","src_2x":"partnerships_pricerite@2x.png","width":"216","height":"30"},"nike":{"alt":"Nike","src":"partnerships_nike.png","src_2x":"partnerships_nike@2x.png","width":"73","height":"30"},"eprint":{"alt":"ePrint","src":"partnerships_logos_eprint.png","src_2x":"partnerships_logos_eprint@2x.png","width":"","height":"30"},"spacious":{"alt":"Spacious","src":"partnerships_logos_spacious.png","src_2x":"partnerships_logos_spacious@2x.png","width":"","height":"30"}}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_business_cooperation","prefix":"about_business_cooperation"},{"type":"sections/about/about_investment","prefix":"about_investment"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_map":{},"about_help":{},"about_business_cooperation":{"items":["Ikea","KFC","Pizzahut","Pricerite","Nike","ePrint","Spacious"]},"about_investment":{},"about_hire":{}}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = {"apply_customized":{"href":"business_services_registration","target":"_blank"},"order_hourly":{"href":"order?hourly_plan","target":"_blank"},"hourly_price_modal":"#hourly-price"}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = {"business_hero_headline":"GOGO Business","business_hero_body":"Same Day Delivery, Guaranteed","business_register_btn":"REGISTER NOW","business_features_headline":"Be One Step Ahead","business_features":[{"headline":"Enjoy monthly payment","body":"No need to pay cash anymore. You can have <b>Monthly Payment</b> with detailed invoice."},{"headline":"Clear record and reporting","body":"All records are shown in dashboard. <b>Monthly Report</b> is provided for your company."},{"headline":"Simple management<span class=\"hide-mobile\"><br />&nbsp;</span>","body":"Create, assign, and manage different level of user account for employees with ease."}],"business_advantages":[{"section_class":"business-advantage blue-section","headline":"LARGEST FLEET IN HONG KONG","body":"<a class=\"blue\">GOGOVAN</a> has more than 20,000 professional drivers, accommodating your needs in no time."},{"section_class":"business-advantage","headline":"SCALE UP, SCALE DOWN","body":"Delight customers when you deliver items on time, especially during seasonal periods. <a class=\"blue\">GOGOVAN</a> allows you the flexibility to scale your logistical operations depending on your needs. With over 19,000,000 successful deliveries -  foods, building hardware and even flowers - trust us to keep deliveries on time."},{"section_class":"business-advantage blue-section","headline":"ALL-ROUND SUPPORT","body":"Our specialists handle all enquiries with professional knowledge. We know your business well, we help your business well."}],"business_contact_headline":"Register for GOGO Business","business_contact_thank_you":["Thank you for registering your interest in GOGO Business.<br />We will send you a welcome email with all the details you need to get started.<br />If you have any enquiries regarding GOGO Business, feel free to contact us at <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> or email us at <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a>."],"business_contact_body":"To get started, please fill up your details below and our sales team will contact you shortly.<br />If you have any enquiries regarding GOGO Business, feel free to contact us at <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> or email us at <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a>.","business_contact_input_name":"Name*","business_contact_input_contact_number":"Contact Number*","business_contact_input_email":"Email*","business_contact_input_company_name":"Company Name*","business_contact_input_company_address":"Company Address","business_contact_input_company_website":"Company Website*","business_contact_input_company_size":"Company Size","business_contact_input_industry":"Industry*","business_contact_industry_options":["零售(Retails)","網購(E-Commerce)","裝修工程(Constructions)","家居佈置及設計(Interior Designs and Production)","製作公司 (Production House)","展覽 (Exhibition)","食品(Food & Beverage)","印刷及出版 (Printing)","成衣 (Clothing)","其他 (Others)"],"business_contact_submit_btn":"SUBMIT","business_business_client_headline":"Business Client"}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"business_feature_1":{"src":"enjoy_monthly_payment.jpg","src_2x":"enjoy_monthly_payment@2x.jpg","height":"200"},"business_feature_2":{"src":"clear_record_and_reporting.jpg","src_2x":"clear_record_and_reporting@2x.jpg","height":"200"},"business_feature_3":{"src":"simple_management.jpg","src_2x":"simple_management@2x.jpg","height":"200"},"business_feature_4":{"src":"multiple_order_in_one_click.jpg","src_2x":"multiple_order_in_one_click@2x.jpg","height":"200"},"business_icon_muji":{"src":"icon_muji.png","src_2x":"icon_muji@2x.png","height":"45"},"business_icon_hktv_mall":{"src":"icon_hktv_mall.png","src_2x":"icon_hktv_mall@2x.png","height":"30"},"business_icon_pricerite":{"src":"icon_pricerite.png","src_2x":"icon_pricerite@2x.png","height":"30"},"business_icon_ifc":{"src":"icon_ifc.png","src_2x":"icon_ifc@2x.png","height":"30"},"business_icon_xiaomi":{"src":"icon_xiaomi.png","src_2x":"icon_xiaomi@2x.png","height":"30"}}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/hk_content","prefix":"business"}],"body_class":"business-page","business":{"form":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSeCUsB9YYMvWVQnAf6QPXyLjLDioH2GnHIq6S0b4VpjVNXtCA/formResponse","name_name":"entry.1061338977","name_contact_number":"entry.853169258","name_email":"entry.699150667","name_company_name":"entry.1831692159","name_company_address":"entry.1047440801","name_company_website":"entry.1698119810","name_company_size":"entry.1354315963","name_industry":"entry.1968665322","name_query_input":"entry.353464387"},"comment_class":"grid-6 grid-tablet-5 grid-mobile-4 left"}}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Business Services Registration","business_services_registration_section_title":"Business Services Registration","business_services_registration_content":"Please fill out the contact form and we will get back to you as soon as possible.","business_services_registration_label_email":"Email","business_services_registration_email":"info@gogovan.hk","business_services_registration_label_hotline":"Hotline","business_services_registration_hotline":"3590-3399","business_services_registration_hotline_link":"35903399","business_services_registration_input_company_name":"Company name*","business_services_registration_input_name":"Name of contact*","business_services_registration_input_phone":"Contact telephone no.*","business_services_registration_input_email":"Contact email*","business_services_registration_input_address":"Contact address","business_services_registration_input_warehouse_address":"Warehouse address (if applicable)","business_services_registration_input_company_industry":"Company industry","business_services_registration_input_company_industry_items":["Food and beverage","Construction","Pets and domesticated animals","Distribution","Entertainment","Electronics","Other:"],"business_services_registration_input_vehicle_type":"Vehicle type (may choose more than one)*","business_services_registration_input_vehicle_type_items":["van Regular van","5.5 ton truck","9 ton truck"],"business_services_registration_input_frequency_of_service":"Frequency of service","business_services_registration_input_frequency_of_service_items":["Daily","Weekly","Other"],"business_services_registration_input_type_of_goods":"Type of goods*","business_services_registration_input_type_of_goods_items":["Plants","Parcels and boxes","Fragile goods","Print goods","Furniture","Construction materials","Animals","Waste","Electronics","Food (Dry)","Food (Wet)","Other"],"business_services_registration_input_budget":"Approximate Monthly Budget (If applicable)","business_services_registration_button_send":"SEND","business_services_registration_thankyou_message":"Thanks for registering. We will respond and start to make arrangements within a few days."}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business_services_registration","prefix":"business_services_registration"}],"business_services_registration_content":{"form":{"url":"https://docs.google.com/forms/d/1WTeHBZzkAcQuh2odUzngCgAHi7Z9mhHxebXYzuYZRx0","company_name":"entry.209227670","company_industry":"738933938","contact_name":"entry.1194288238","contact_telephone_no":"entry.1799123272","contact_email":"entry.1994268153","contact_address":"entry.454440047","contact_warehouse_address":"entry.1861993","vehicle_type":"1686794805","frequency_of_service":"1966491735","type_of_goods":"745353888","budget":"entry.1748170104"},"company_industry_values":["飲食 Food and beverage","建築 Construction","寵物 Pets and domesticated animals","批發 Distribution","娛樂 Entertainment","電子 Electronics","__other_option__"],"vehicle_type_values":["客貨van Regular van","5.5噸貨車 5.5 ton truck","9噸貨車 9 ton truck"],"frequency_of_service_values":["每日一次 Daily","每週一次 Weekly","__other_option__"],"type_of_goods_values":["植物 Plants","一般貨箱 Parcels and boxes","易碎產品 Fragile goods","印刷品 Print goods","家俬 Furniture","建材 Construction materials","動物 Animals","廢料 Waste","電子產品 Electronics","食物(乾貨) Food (Dry)","食物(濕貨) Food (Wet)","__other_option__"]}}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {"contact_section_title":"Contact Us","contact_content":"Please fill out the contact form and we will get back to you as soon as possible.","contact_label_email":"Email","contact_label_hotline":"Hotline","contact_hotline":"3590-3399","contact_business_hotline":"3590-8975","contact_business_title":"GOGO Business Hotline","contact_business_content":"If you have any enquiries with GOGO Business, please contact our logistics support.<br />Service hours :<br />&nbsp;&nbsp;<a class=\"blue\">Monday - Saturday 09:00-18:00</a>","contact_input_name":"Name*","contact_input_email":"Email*","contact_input_title":"Subject","contact_input_message":"Message*","contact_button_send":"SUBMIT","contact_thankyou_message":"Thank you! Your message has been sent."}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/contact","prefix":"contact"}],"show_business_contact":false,"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1fZu7GOdyoccG-n2zzlElvZqsEr4uZdWSjlmzPobh56I","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"faq_headline":"Frequently Asked Questions","faq_body":"","faq_other_questions":"Please call GoGoVan at <a href='tel:35903399'>3590 3399</a> to inquire about any questions you may have that are not mentioned above.","faq_questions":[{"question":"Not sure which district your starting point or destination is in?","answer":"If you don’t see your exact locations in the \"Choose by district\" option, we recommend you to find them with our more visual \"Map\" option."},{"question":"I urgently need a vehicle, but I can’t find a driver! What do I do?","answer":"Drivers may not always be available during peak hours. We recommend that you add some \"bonus\" (there's an option for that) when you make your order, to make it more attractive to drivers and increase their chances of responding to it first."},{"question":"Why were the actual prices a bit different from the quote?","answer":"In far-­away places, the actual price may differ from the quote. We recommend you to clarify the situation with your driver and figure out the actual price of the trip beforehand, to avoid any misunderstandings. You may also call GoGoVan for inquiries."},{"question":"Are tunnel toll fees included in the app’s quoted price?","answer":"No, the app’s quoted price for your order does not include tunnel toll fees. For details on tunnel and bridge fees, please visit the section <a href='pricing.html#tunnels'>\"Tunnel and bridge fees\"</a>."},{"question":"Why doesn’t the license plate number of the van match the one displayed in the app’s information?","answer":"To maintain our strict quality control, GoGoVan does not allow our drivers to shift their orders to another person (ie. a driver not registered with GoGoVan). If the license plate number of the actual van does not match with the one displayed on the app, please call GoGoVan immediately to report the case."},{"question":"My driver is severely late, or has not appeared at all, without any proper notice. What do I do?","answer":"Please call and report this to GoGoVan. We will assign new vehicles for you."},{"question":"What do I do if I either want to change the starting point or destination of my order, cancel the order, or change the vehicle choice after the order has been confirmed?","answer":"If you'd like to cancel or edit the order, please contact your driver directly. Our drivers will be happy to accommodate."},{"question":"I'm not sure if my goods exceed the weight or dimension limits?","answer":"GoGoVan provides different types of vehicles for carrying goods of various weights and dimensions. A regular van can carry up to 1 ton; if the good exceeds 6ft in length, please select the \"Goods exceeding 6ft in length\" option when making your order. If you’re not sure which vehicle to choose, please refer to the <a href='service.html'>Service Description</a>. Alternatively, you may contact your driver directly for inquiries."},{"question":"How can I reissue my order record?","answer":"The order record details your order’s route, time, price, and other related information. If you want to reissue the order record, please tap the menu icon on the top left corner of the app, select \"order record\", choose the record you’d like to see, and tap on / on the top right corner. You may then fill out the email address that you’d like the record to be sent to."},{"question":"I’ve confirmed my order and then received the driver’s information. What should I do now?","answer":"When you see the driver's information, it means that the driver has already received your order. You may now wait for the driver's call to confirm the exact pickup point and destination."},{"question":"What if there's no vehicle type that's suitable for my order?","answer":"If you'd like a 16 ton truck or other vehicle types, please call GoGoVan and we will arrange everything accordingly."},{"question":"What are GoGoVan operating hours?","answer":"Our app works 24/7. Just order on our app anytime for our delivery and moving services. If you’d like to order through our hotline or like to call us for any inquiries, our office hours are from Monday to Sunday morning from 7 a.m. to 12 a.m. midnight."},{"question":"How long is the transaction record stored for?","answer":"Unless you uninstall the GoGoVan app, the transaction record will always remain on your phone."}]}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/faq","prefix":"faq"}]}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"src":"dl_appstore.png","src_2x":"dl_appstore@2x.png","alt":"Appstore","height":"56"},"appstore_outlined":{"src":"dl_appstore_outline.png","src_2x":"dl_appstore_outline@2x.png","alt":"Appstore","width":"180","height":"60"},"appstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"Appstore","width":"180","height":"60"},"appstore_outlined_hover":{"src":"dl_appstore_hover_yl.png","src_2x":"dl_appstore_hover_yl@2x.png","alt":"Appstore","width":"180","height":"60"},"apple_small":{"src":"dl_apple_blue.png","src_2x":"dl_apple_blue@2x.png","alt":"Appstore","width":"14"},"playstore":{"src":"dl_playstore.png","src_2x":"dl_playstore@2x.png","alt":"Playstore","height":"56"},"playstore_outlined":{"src":"dl_android_outline.png","src_2x":"dl_android_outline@2x.png","alt":"Playstore","width":"180","height":"60"},"playstore_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"Playstore","width":"180","height":"60"},"playstore_outlined_hover":{"src":"dl_playstore_hover_yl.png","src_2x":"dl_playstore_hover_yl@2x.png","alt":"Playstore","width":"180","height":"60"},"play_small":{"src":"dl_andriod_blue.png","src_2x":"dl_andriod_blue@2x.png","alt":"Playstore","width":"15"},"facebook":{"src":"icon_facebook.png","src_2x":"icon_facebook@2x.png","alt":"Facebook","width":"30"},"twitter":{"src":"icon_twitter.png","src_2x":"icon_twitter@2x.png","alt":"Twitter","width":"30"},"googleplus":{"src":"icon_googleplus.png","src_2x":"icon_googleplus@2x.png","alt":"Google +","width":"30"},"youtube":{"src":"icon_youtube.png","src_2x":"icon_youtube@2x.png","alt":"Youtube","width":"30"},"instagram":{"src":"icon_instagram.png","src_2x":"icon_instagram@2x.png","alt":"Instagram","width":"30"},"linkedin":{"src":"icon_linkedin.png","src_2x":"icon_linkedin@2x.png","alt":"LinkedIn","width":"30"},"naver":{"src":"icon_naver.png","src_2x":"icon_naver@2x.png","alt":"네이버 블로그","width":"30"},"language_en_hk":{"src":"hongkong.png","alt":"Hong Kong","width":"20"},"language_zh_hk":{"src":"hongkong.png","alt":"Hong Kong","width":"20"},"language_en_in":{"src":"india.png","alt":"India","width":"20"},"language_en_sg":{"src":"singapore.png","alt":"Singapore","width":"20"},"language_zh_tw":{"src":"taiwan.png","alt":"Taiwan","width":"20"},"language_ko_kr":{"src":"south_korea.png","alt":"Korea","width":"20"},"language_zh_cn":{"src":"china.png","alt":"China","width":"20"},"icon_mail":{"src":"icon_mail.png","src_2x":"icon_mail@2x.png","alt":"mail"},"icon_password":{"src":"icon_password.png","src_2x":"icon_password@2x.png","alt":"password"},"icon_avatar":{"src":"icon_avatar.png","src_2x":"icon_avatar@2x.png","alt":"avatar"},"icon_phone":{"src":"icon_phone.png","src_2x":"icon_phone@2x.png","alt":"phone"},"nav_logo":{"title":"GoGoVan","src":"nav_logo.png","src_2x":"nav_logo@2x.png","alt":"GoGoVan"}}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"hero_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":88,"height":51,"alt":"Video"},"hero_nexus":{"src":"hero_nexus_en.png","src_2x":"hero_nexus_en@2x.png","width":217,"height":401,"alt":"GoGoVan"},"moving":{"title":"Moving","src":"icon-courier.png","src_2x":"icon-courier@2x.png","width":56,"height":51},"shuttle":{"title":"Pet Shuttle","src":"icon-pet-shuttle-service.png","src_2x":"icon-pet-shuttle-service@2x.png","width":52,"height":53},"oversized":{"title":"Oversized Goods","src":"icon-send-document.png","src_2x":"icon-send-document@2x.png","width":48,"height":55},"supplies":{"title":"Supplies Transport","src":"icon-building-materials-transport.png","src_2x":"icon-building-materials-transport@2x.png","width":56,"height":45},"warehouse":{"title":"Warehouse In & Out","src":"icon-warehouse-transport.png","src_2x":"icon-warehouse-transport@2x.png","width":57,"height":56},"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":57,"height":50},"featrue_inner_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":36,"height":39},"featrue_inner_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":36,"height":36},"featrue_inner_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":41,"height":31},"featrue_inner_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":24,"height":39},"featrue_inner_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":34,"height":34},"featrue_inner_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":36,"height":32},"feature_lightbox_1":{"src":"feature_lightbox1_en.png","src_2x":"feature_lightbox1_en@2x.png","height":"100%"},"feature_lightbox_2":{"src":"feature_lightbox2.png","src_2x":"feature_lightbox2@2x.png","height":235},"feature_lightbox_3":{"src":"feature_lightbox3.png","src_2x":"feature_lightbox3@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4_en.png","src_2x":"feature_lightbox4_en@2x.png","height":"100%"},"feature_lightbox_5":{"src":"feature_lightbox5_en.png","src_2x":"feature_lightbox5_en@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6_en.png","src_2x":"feature_lightbox6_en@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1_en.png","src_2x":"icon-how-it-work-step1_en@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"icon-how-it-work-step2.png","src_2x":"icon-how-it-work-step2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"icon-how-it-work-step3.png","src_2x":"icon-how-it-work-step3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"howitwork_icon_active_step1":{"src":"icon_steps1_activated.png","src_2x":"icon_steps1_activated@2x.png","width":40,"height":64},"howitwork_icon_active_step2":{"src":"icon_steps2_activated.png","src_2x":"icon_steps2_activated@2x.png","width":"","height":43,"style":"top:23px"},"howitwork_icon_active_step3":{"src":"icon_steps3_activated.png","src_2x":"icon_steps3_activated@2x.png","width":62,"height":59},"howitwork_icon_inactive_step1":{"src":"icon_steps1.png","src_2x":"icon_steps1@2x.png","width":40,"height":64},"howitwork_icon_inactive_step2":{"src":"icon_steps2.png","src_2x":"icon_steps2@2x.png","width":"","height":43,"style":"top:23px"},"howitwork_icon_inactive_step3":{"src":"icon_steps3.png","src_2x":"icon_steps3@2x.png","width":62,"height":59},"howitwork_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":183,"height":102,"alt":"Video"},"media_econtimes":{"src":"media_econtimes.png","src_2x":"media_econtimes@2x.png","height":30},"media_d100":{"src":"media_d100.png","src_2x":"media_d100@2x.png","height":30},"media_appledaily":{"src":"media_appledaily.png","src_2x":"media_appledaily@2x.png","height":30},"media_36kr":{"src":"media_36kr.png","src_2x":"media_36kr@2x.png","height":30},"media_unwire":{"src":"media_unwire.png","src_2x":"media_unwire@2x.png","height":30},"media_techcrunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":30},"media_wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":30},"media_ezone":{"src":"media_ezone.png","src_2x":"media_ezone@2x.png","height":30},"media_metro_broadcast":{"src":"media_metro_broadcast.png","src_2x":"media_metro_broadcast@2x.png","height":30},"media_pcm":{"src":"media_pcm.png","src_2x":"media_pcm@2x.png","height":30},"media_rthk":{"src":"media_rthk.png","src_2x":"media_rthk@2x.png","height":30},"media_singtao":{"src":"media_singtao.png","src_2x":"media_singtao@2x.png","height":30},"media_techinasia":{"src":"media_techinasia.png","src_2x":"media_techinasia@2x.png","height":53},"media_reuters":{"src":"media_reuters.png","src_2x":"media_reuters@2x.png","height":48},"media_forbes":{"src":"media_forbes.png","src_2x":"media_forbes@2x.png","height":30},"icon_right":{"src":"icon-right.png","src_2x":"icon-right@2x.png","height":20,"alt":"action join team"}}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_hero":{"show_phone":false},"index_service":{"parent_width_style":"grid-10 grid-tablet-10 push-1 centered","width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","disable_learn_more":false,"items":[{"img":"moving"},{"img":"shuttle"},{"img":"oversized"},{"img":"supplies"},{"img":"warehouse"}]},"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"moving","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"courier"},{"img":"shuttle","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"moving"},{"img":"oversized","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"transport1"},{"img":"supplies","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"transport"}]},"index_feature":{"class":"grid-2 grid-tablet-2 grid-mobile-2","items":[{"img":"feature_1","img_inner":"featrue_inner_1","img_lightbox":"feature_lightbox_1"},{"img":"feature_2","img_inner":"featrue_inner_2","img_lightbox":"feature_lightbox_2"},{"img":"feature_3","img_inner":"featrue_inner_3","img_lightbox":"feature_lightbox_3"},{"img":"feature_4","img_inner":"featrue_inner_4","img_lightbox":"feature_lightbox_4"},{"img":"feature_5","img_inner":"featrue_inner_5","img_lightbox":"feature_lightbox_5"},{"img":"feature_6","img_inner":"featrue_inner_6","img_lightbox":"feature_lightbox_6"}]},"index_howitwork":{"how_it_works":[{"image":"howitwork_step1","icon_active":"howitwork_icon_active_step1","icon_inactive":"howitwork_icon_inactive_step1"},{"image":"howitwork_step2","icon_active":"howitwork_icon_active_step2","icon_inactive":"howitwork_icon_inactive_step2"},{"image":"howitwork_step3","icon_active":"howitwork_icon_active_step3","icon_inactive":"howitwork_icon_inactive_step3"}]},"index_media":{"items":["media_econtimes","media_d100","media_appledaily","media_36kr","media_unwire","media_wsj","media_ezone","media_metro_broadcast","media_pcm","media_rthk","media_singtao","media_techinasia"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1fZu7GOdyoccG-n2zzlElvZqsEr4uZdWSjlmzPobh56I","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"},"index_newsletter_subscriptions":{"form":{"url":"https://docs.google.com/forms/d/1vtDLFm62ZFN20KInmljN6PCOsE36oGOY8OmxYgBj-bM","name_email":"entry.1148413407"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"legal_headline":"Privacy Policy"}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/en_hk_content"}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Pricing","pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 feet","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Height Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","-","-"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["-","$20/pc (unlimited use)","$20/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Toll Fee","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Tuck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel(09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"],"pricing_header_headline":"Total Fee = Fare + Surcharges (if applicable)","pricing_header_surcharges":"Surcharges","pricing_header_additional_charges":"Additional Charges","pricing_header_tunnel_tolls_and_bridge_tolls":"Toll Fee","pricing_header_parking_fees":"Parking Fee","pricing_header_dangerous_goods":"Dangerous Goods","pricing_header_refer":"Please refer the surcharges listed below and confirm the total fee with driver in advance.","pricing_header_enquiry":"If you have any enquiries, please contact us at ","pricing_header_tel_no":"35903399","pricing_dangerous_goods_dangerous_goods":"Dangerous Goods","pricing_dangerous_goods_title":["Type","Allowed Number","Charge"],"pricing_dangerous_goods_fire_extinguishers":["Fire Extinguishers","Unlimited","No surcharge"],"pricing_dangerous_goods_acetylene_cylinder":["Acetylene Cylinder","2 bottles","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_refrigerant":["Refrigerant","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_nitrogen":["Nitrogen","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_journey_fare_table":"Journey Fare Table for Van","pricing_dangerous_goods_hk_hk":"Hong Kong - Hong Kong","pricing_dangerous_goods_hk_kln":"Hong Kong - Kowloon","pricing_dangerous_goods_hk_nt":"Hong Kong - New Territories","pricing_dangerous_goods_kln_kln":"Kowloon - Kowloon","pricing_dangerous_goods_kln_nt":"Kowloon -  New Territories","pricing_dangerous_goods_nt_nt":"New Territories - New Territories","pricing_vehicle_dropdown_van":"Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5 Ton Truck","pricing_vehicle_dropdown_ton_truck_9":"9 Ton Truck"}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_icon":{"src":"pricing_icon.png","src_2x":"pricing_icon@2x.png","width":"202","height":"268"}}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"Van Pricing":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Password","password_headline":"Reset Password","password_email":"Your Email","password_password":"New Password","password_confirm_password":"Confirm Password","password_button_request_reset":"REQUEST RESET","password_button_submit":"SUBMIT","password_respond":"Request sent. Please check your email to confirm.","password_email_not_found":"Your email address has not been registered. Please <a href=\"#register\" class=\"global-text-blue dialog\">register</a> first.","password_error_password_length":"Your password needs to have at least 8 letters or digits","password_error_password_equal":"Sorry, your passwords do not match each other","password_error_token_expired":"Your link has expired"}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/password","prefix":"password"}]}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"GET A QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 Feet","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","-","-"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["-","$20/pc (unlimited use)","$20/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Tunnels Tolls and Bridge Tolls","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Truck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$75","$100"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$45","$50"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel (09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$14","$30"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"]}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_icon":{"src":"pricing_icon.png","src_2x":"pricing_icon@2x.png","width":"202","height":"268"}}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/pricing/pricing_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"quoting","offset":"-114"},{"target":"pricing-table","offset":"-114"},{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"hk/pricing_pricing_table","prefix":"pricing_pricing_table"},{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"Van Pricing":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = {"quoting_first_input":"Enter a Pickup Point","quoting_last_input":"Enter a Destination","quoting_get_btn":"GET QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_price_prefix":"FROM ","quoting_price_postfix":"","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_van_title":"VAN","quoting_service_van_body":"Carries max. 5 passengers; max. load 700kg ; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","quoting_service_5ton_title":"5.5 TON TRUCK","quoting_service_5ton_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","quoting_service_9ton_title":"9 TON TRUCK","quoting_service_9ton_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width."}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_done":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_van_white":{"src":"icon_van_white.png","src_2x":"icon_van_white@2x.png","width":"72","alt":"VAN"},"icon_van_blue":{"src":"icon_van_blue.png","src_2x":"icon_van_blue@2x.png","width":"72","alt":"VAN"},"icon_5ton_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"5.5 TON TRUCK"},"icon_5ton_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"5.5 TON TRUCK"},"icon_9ton_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"9 TON TRUCK"},"icon_9ton_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"9 TON TRUCK"}}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"van","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"van"}},{"type":"5ton","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mudou"}},{"type":"9ton","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mudou9"}}]}}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = {"quoting_delivery":"/quoting","quoting_moving_service":"/quoting","quoting_transport":"/quoting","quoting_big_cargo":"/quoting","quoting_extra":"/business"}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = {"service_content_headline":"Comprehensive Service Pack Which Suits Your Every Need.","service_content_contents":["No matter if you are moving furnitures, supplies, goods or even pets, our wide range of vehicle types from vans to 9 ton trucks can help."],"service_content_photos_title_0":"Ride With Your Items","service_content_photos_title_1":"Oversized Goods","service_content_photos_title_2":"Pets Shuttle","service_content_photos_title_3":"Moving","service_content_photos_title_4":"Warehouse In & Out","service_content_photos_title_5":"Supplies Moving","service_content_photos_body_0":"We are your hands and feet. Regardless of where you are, sit back, relax, and allow us to handle all of your transportation and delivery needs.","service_content_photos_body_1":"We will allocate the most suitable vehicle for transportation of goods according to your needs.","service_content_photos_body_2":"Unlike other public transportation, we let you ride with your beloved one no matter big or small.","service_content_photos_body_3":"Our vehicles offer the best fit for your moving needs . We also offer additional movers if needed.","service_content_photos_body_4":"With the click of a button, we can help you with moving items in or out of your warehouse unit.","service_content_photos_body_5":"Different materials have their own specific way to transport. No clue? No problem, GoGoVan will find you the best solution.","title":"Service GoGoVan - HK","service_content_sg_delivery_title":"Deliver and Courier Small Goods","service_content_sg_delivery_content":["Door-to-door delivery/ courier service for documents and packages, up to 30x20x20cm or under 10kg each","Examples: Documents, bouquet of roses, cakes, candles, photo albums, electronic items, shoe box, food parcels"],"service_content_sg_delivery_button":"GET QUOTE","service_content_sg_moving_service_title":"Book A Moving Service","service_content_sg_moving_service_content":["Relocation of homes and offices. Includes labour cost of driver to move items","Additional labour can be requested for as necessary"],"service_content_sg_moving_service_button":"GET QUOTE","service_content_sg_transport_title":"Transport Large and Bulky Goods","service_content_sg_transport_content":["Transport service for goods that exceed one parcel size (30x20x20cm) or weigh over 30kg","Additional charges for door-to door service","Examples: Office chairs, pets, bicycles, drum set, ladders, mattresses, sofa, fans"],"service_content_sg_transport_button":"GET QUOTE","service_content_sg_pricing_link":"Pricing Details","service_content_sg_extra_title":"EVERYTHING ELSE","service_content_sg_extra_content":["Need a commercial vehicle for a different reason? Get in touch with us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> for a custom quote.","For corporate deliveries, learn more about <a href='business' class='global-text-blue'>GoGoVan for Business</a> or email <a href='mailto:sales@gogovan.sg'>sales@gogovan.sg</a>."],"service_content_sg_extra_button":"LEARN MORE","service_content_fleets_header":"Vehicle Types","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"Van","service_content_icon_ser_van_body":"Carries max. 5 passengers (not including the driver); max. load 700kg; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","service_content_icon_ser_10ftlorry_title":"5.5 Ton Truck","service_content_icon_ser_10ftlorry_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","service_content_icon_ser_14ftlorry_title":"9 Ton Truck","service_content_icon_ser_14ftlorry_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width.","service_content_additional_header":"Additional Services","service_content_english_speaking_driver_title":"English-speaking Driver","service_content_english_speaking_driver_body":"Yes! We have English-speaking drivers working around the clock to help our non-Chinese speaking users.","service_content_goodsg_longer_than_6ft_title":"Goods Longer Than 6ft","service_content_goodsg_longer_than_6ft_body":"We recommend that you select this option and choose the “Van” vehicle type if your goods exceed 6’ in length, but do not exceed 700kg in weight. Our vans can then be modified to accommodate goods of up to 8’. If your goods exceed 6’ in length and 2’ in height, we recommend you to select the “taller than half net” option in the sub-menu.","service_content_borrow_carts_title":"Borrow Carts (Trolley/Pallet rental)","service_content_borrow_carts_body":"Trolleys and pallets help you move and deliver your goods. Trolleys are made of steel and equipped with a handle. They are more suited for transporting small goods in large quantities, like cardboard boxes. Pallets are made of wood and are more suited for transporting large, single items, like wardrobes.","service_content_forklift_rental_title":"Forklift Rental","service_content_forklift_rental_body":"Forklifts help you move and deliver your goods, and also allow you to manually adjust your goods’ height with the hand-pump. They are more applicable for goods delivered on a 5.5/9 ton truck.","service_content_mover_title":"Mover (Need extra hand)","service_content_mover_body":"Please contact and negotiate with your driver personally if you would like the driver to assist you in manually carrying and moving your goods.","service_content_pets_title":"Pets (Transporting pets)","service_content_pets_body":"We will safely transport your pets no matter how many there are.","service_content_new_vehicle_title":"New Vehicle","service_content_new_vehicle_body":"We will get you a newer vehicle for your goods.","service_content_dumper_construction_waste_title":"Dumper / Construction Waste","service_content_dumper_construction_waste_body":"Select this option if you would like to move construction/industrial waste. Please make sure that it’s within our given dimensions and weight limits for a good.","service_content_hourly_header":"Hourly Rental","service_content_hourly_rental_body":"This option calculates fees based on every half-hour. We recommend this option if you would like to rent GoGoVan for 3 hours or more due to many mid-points/stops in the trip, or if you expect a long waiting time during the trip."}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = {"ride_with_your_items":{"src":"image_ridewithitem.jpg","src_2x":"image_ridewithitem@2x.jpg"},"oversized_goods":{"src":"image_oversizedgoods.jpg","src_2x":"image_oversizedgoods@2x.jpg"},"pets_shuttle":{"src":"image_pet.jpg","src_2x":"image_pet@2x.jpg"},"moving":{"src":"image_moving.jpg","src_2x":"image_moving@2x.jpg"},"warehouse_in_out":{"src":"image_warehouse.jpg","src_2x":"image_warehouse@2x.jpg"},"supplies_moving":{"src":"image_supplies.jpg","src_2x":"image_supplies@2x.jpg"},"icon_ser_sedan":{"src":"icon_ser_sedan.png","src_2x":"icon_ser_sedan@2x.png"},"icon_ser_van":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":32,"height":20},"icon_ser_10ftlorry":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":36,"height":20},"icon_ser_14ftlorry":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":40,"height":22},"english_speaking_driver":{"src":"icon_english_inactive.png","src_2x":"icon_english_inactive@2x.png","width":40,"height":40},"goodsg_longer_than_6ft":{"src":"icon_longergood_inactive.png","src_2x":"icon_longergood_inactive@2x.png","width":40,"height":40},"borrow_carts":{"src":"icon_borrowcart_inactive.png","src_2x":"icon_borrowcart_inactive@2x.png","width":40,"height":40},"forklift_rental":{"src":"icon_borrowcart_inactive.png","src_2x":"icon_borrowcart_inactive@2x.png","width":40,"height":40},"mover":{"src":"icon_porterage_inactive.png","src_2x":"icon_porterage_inactive@2x.png","width":40,"height":40},"pets":{"src":"icon_pets_inactive.png","src_2x":"icon_pets_inactive@2x.png","width":40,"height":40},"new_vehicle":{"src":"icon_newcar_inactive.png","src_2x":"icon_newcar_inactive@2x.png","width":40,"height":40},"dumper_construction_waste":{"src":"icon_constructionwaste_inactive.png","src_2x":"icon_constructionwaste_inactive@2x.png","width":40,"height":40},"hourly_rental":{"src":"icon_hourlyrental_inactive.png","src_2x":"icon_hourlyrental_inactive@2x.png","width":40,"height":40},"delivery":{"src":"icon_ser_courier.png","src_2x":"icon_ser_courier@2x.png","width":90,"alt":"Courier"},"moving_service":{"src":"icon_ser_moving.png","src_2x":"icon_ser_moving@2x.png","width":90,"alt":"Moving"},"transport1":{"src":"icon_ser_passenger.png","src_2x":"icon_ser_passenger@2x.png","width":90,"alt":"Passenger Service"},"transport":{"src":"icon_ser_delivery.png","src_2x":"icon_ser_delivery@2x.png","width":90,"alt":"Delivery"},"extra":{"src":"icon_ser_everythingelse.png","src_2x":"icon_ser_everythingelse@2x.png","width":90,"alt":"Extra"}}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Services","blocks":[{"type":"partials/hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"}],"service_contents":[{"type":"service_headline"},{"type":"service_photos"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"},{"type":"service_fleets","content":"service_content_additional"},{"type":"service_fleets","content":"service_content_hourly"}],"hero":"background-image: url(/img/services_banner_bg.jpg)","service_content_photos":{"photo_grid":["ride_with_your_items","oversized_goods","pets_shuttle","moving","warehouse_in_out","supplies_moving"]},"service_content_sg":{"items":["delivery","transport","moving_service","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry"]},"service_content_additional":{"header":"additional_header","subheader":"","vehicle_types":["english_speaking_driver","goodsg_longer_than_6ft","borrow_carts","forklift_rental","mover","pets","new_vehicle","dumper_construction_waste"]},"service_content_hourly":{"header":"hourly_header","subheader":"","vehicle_types":["hourly_rental"],"button":{"class":"button secondary outlined small fixed","text":"learn_more"}}}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = {"template":"sitemap.xml","extension":".xml","content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"en-hk":"en-hk","zh-hk":"zh-hk"}}}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan"}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular.html"}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan"}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular_no_header.html"}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(798), __esModule: true };

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(772);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(583);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(815);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(819);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(583);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(853);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./dialog.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./dialog.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(580);
var enumBugKeys = __webpack_require__(536);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(792)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(576)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 526 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(783);
var global = __webpack_require__(456);
var hide = __webpack_require__(464);
var Iterators = __webpack_require__(469);
var TO_STRING_TAG = __webpack_require__(454)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 528 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(465);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(462);
var dPs = __webpack_require__(788);
var enumBugKeys = __webpack_require__(536);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(578)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(791).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(535)('keys');
var uid = __webpack_require__(475);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 536 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(457).f;
var has = __webpack_require__(459);
var TAG = __webpack_require__(454)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(454);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var core = __webpack_require__(446);
var LIBRARY = __webpack_require__(530);
var wksExt = __webpack_require__(538);
var defineProperty = __webpack_require__(457).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29672346.png";

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = {"meta":{"description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - GET YOUR STUFF MOVING","og:url":"{{SITE_HTTP_URL}}/en/","og:description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:type":"website","og:site_name":"GoGoVan Hong Kong"},"footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"07:00-24:00","footer_copyright":["© 2016 GoGoVan. All rights reserved."]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = {"close":"關閉","menu":"選單","learn_more":"了解更多","page_home":"主頁","page_/home":"主頁","page_quoting":"報價","page_order":"叫車","page_ordering_order":"叫車","page_service":"服務","page_pricing":"收費表","page_business":"商務合作","page_about_us":"關於GOGOX","page_about_gogovan":"關於GOGOX","page_faq":"常見問題","page_contact":"聯繫我們","page_career":"工作機會","page_legal":"使用條款","page_privacy":"隱私條款","page_dashboard":"柯打管理中心","page_payment":"付款","page_help_center":"幫助中心","page_http://help.gogox.com":"幫助中心","page_blog":"網誌","page_join":"加盟車隊","page_driver_site":"加盟車隊","page_media":"MEDIA","page_download":"下載 GOGOX Apps","page_order_download":"下載 GOGOX Apps","page_/order_download":"下載 GOGOX Apps","page_sign_out":"登出","page_login":"登入","page_register":"註冊","page_ordering_dashboard":"柯打管理中心","page_my_order_records":"柯打管理中心","page_about":"關於GOGOX","page_gogoad":"廣告查詢","title_company":"公司","title_services_pricing":"服務與費用","title_support":"服務支持","footer_hotline":"客戶熱線","footer_monday_sunday":"週一至週日","footer_office_hour":"07:00-24:00","update_profile_modal_title":"更新個人資料","register_modal_title":"註冊","register_modal_email_input":"電郵地址","register_modal_username_input":"姓名","register_modal_phone_input":"電話","register_modal_password_input":"密碼","register_modal_confirm_password_input":"確認密碼","register_modal_register_btn":"註冊","register_modal_login_with_fb_btn":"使用 FACEBOOK 登入","register_modal_redirect_to_login_btn":"登入","register_modal_normal_message":"如果您已經註冊","register_modal_or":"或","login_modal_title":"登入","login_modal_email_input":"電郵地址","login_modal_password_input":"密碼","login_modal_login_btn":"登入","login_modal_login_with_fb_btn":"使用 FACEBOOK 登入","login_modal_redirect_to_register_btn":"註冊","login_modal_forgot_password_btn":"忘記密碼","login_modal_normal_message":"如果您還未註冊","login_modal_or":"或","login_error_modal_title":"噢! 您已經登出了","login_error_modal_body":"您的登入已經過期, 請重新登入","login_error_modal_login_btn":"登入","error_wrong_modal_title":"噢! 發生了一些錯誤","error_wrong_modal_body":"請再次嘗試或聯絡我們如果有需要的話","error_wrong_modal_help_btn":"幫助","error_wrong_modal_okay_btn":"確定","error_message_login_info_incorrect":"對不起, 您的電郵或密碼不正確","error_message_password_length_not_enough":"您的密碼不足8位","error_message_password_not_match":"對不起, 兩次輸入的密碼並不相同","error_message_please_confirm_password":"請您確認密碼","error_message_please_fill_password":"請您填寫您的密碼","error_message_please_fill_email_address":"請填寫電郵地址","error_message_please_fill_username":"請填寫您的姓名","error_message_email_address_invalid":"您的電郵無效","error_message_email_used_error_tag":"此電郵已被登記<br/>現在 <a href='#' style='text-decoration:underline;cursor:pointer;'>登入</a>?","error_message_email_used_error_tag_t":"此電郵已被登記","error_message_email_used_error_tag_t_2":"現在 ","error_message_please_enter_telephone_number":"請輸入有效的香港電話號碼","error_message_telephone_number_in_use":"對不起, 此電話號碼已被使用","download_our_app":"下載 GOGOX Apps","app_download_banner_title":"GoGoVan","app_download_banner_desc":"仲係咁打電話？一個APP，輕鬆搵過萬貨VAN！叫車快到你唔信！","app_download_banner_open":"開啟","app_download_banner_download":"下載","app_download_banner_send_link":"發送鏈接","app_download_banner_tel_prefix":"+852","app_download_banner_tel_placeholder":"+852 3590-3399","meta":{"description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - GET YOUR STUFF MOVING","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:type":"website","og:site_name":"GoGoVan 香港"},"footer_copyright":["© 2016 GoGoVan. All rights reserved."],"business_account":"商業帳戶用戶請","click_here":"按此","no_account":"還沒有帳戶？","have_account":"已經有帳戶了？","sign_up":"註冊帳戶","login":"按此登入"}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = {"page_faq":"HELP CENTER","page_legal":"TERMS","footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"09:00-21:00","error_message_please_enter_telephone_number":"Please enter a valid Indian phone number.","footer_copyright":[""],"need_help_call_us":"Need help? Call ","need_help_number":"75500 46469"}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = {"close":"Close","menu":"메뉴","learn_more":"LEARN MORE","page_home":"홈","page_quoting":"주문하기","page_order":"주문하기","page_ordering_order":"배송신청","page_service":"서비스","page_pricing":"운임 정책","page_business":"사업 투자","page_about_us":"고고밴에 대하여","page_about_gogovan":"고고밴에 대하여","page_faq":"FAQ","page_contact":"고객센터","page_career":"커리어","page_legal":"개인정보 수집 이용 약관","page_tc_consumer":"이용약관","page_tc_location":"위치정보 이용약관","page_privacy":"고객센터","page_dashboard":"대시보드","page_payment":"PAYMENT","page_help_center":"고객센터","page_blog":"SNS","page_join":"BE A DRIVER","page_driver_site":"운전기사 등록","page_media":"미디어","page_download":"고고밴 앱 다운로드","page_order_download":"고고밴 앱 다운로드","page_sign_out":"로그아웃","page_login":"로그인","page_register":"회원가입","page_ordering_dashboard":"주문내역","page_my_order_records":"My Order Records","page_about":"고고밴에 대하여","page_gogoevent":"이벤트","title_company":"회사","title_services_pricing":"서비스 및 가격","title_support":"지원","footer_hotline":"고객센터","footer_monday_sunday":"","footer_office_hour":"","register_modal_title":"회원가입","register_modal_email_input":"이메일 주소","register_modal_username_input":"이름","register_modal_phone_input":"핸드폰 번호","register_modal_password_input":"비밀번호","register_modal_confirm_password_input":"비밀번호 확인","register_modal_register_btn":"회원가입","register_modal_login_with_fb_btn":"페이스북으로 로그인하기","register_modal_redirect_to_login_btn":"여기서 로그인","register_modal_normal_message":"이미 가입하셨디면 ","register_modal_or":"또는","login_modal_title":"로그인","login_modal_email_input":"이메일 주소","login_modal_password_input":"비밀번호","login_modal_login_btn":"로그인","login_modal_login_with_fb_btn":"페이스북으로 로그인하기","login_modal_redirect_to_register_btn":"여기서 회원 가입","login_modal_forgot_password_btn":"비밀번호 찾기","login_modal_normal_message":"아직 고고밴 회원이 아니시면 ","login_modal_or":"또는","login_error_modal_title":"로그아웃 상태입니다.","login_error_modal_body":"미사용으로 인해 로그아웃되었습니다. 계속하시려면 다시 로그인 해 주십시오.","login_error_modal_login_btn":"로그인","error_wrong_modal_title":"비밀번호가 일치하지 않습니다","error_wrong_modal_body":"다시 시도하시거나 문제가 지속적으로 발생된다면 고고밴 코리아로 연락 바랍니다","error_wrong_modal_help_btn":"도움말","error_wrong_modal_okay_btn":"확인","error_message_login_info_incorrect":"이메일 주소나 비밀번호가 잘못되었습니다","error_message_password_length_not_enough":"최소 8자 이상의 비밀번호를 입력해주세요","error_message_please_confirm_password":"비밀번호를 확인해주세요","error_message_password_not_match":"비밀번호가 일치하지 않습니다","error_message_please_fill_password":"비밀번호를 입력해주세요","error_message_please_fill_email_address":"이메일 주소를 입력해주세요","error_message_please_fill_username":"1자 이상의 이름을 입력해주세요","error_message_email_address_invalid":"유효한 이메일 주소를 입력해주세요","error_message_email_used_error_tag":"본 이메일 계정이 이미 사용중입니다.<br/> <a href='#' style='text-decoration:underline;cursor:pointer;'>로그인</a> 하시겠습니까?","error_message_email_used_error_tag_t":"본 이메일 계정이 이미 사용중입니다.<br/> ","error_message_please_enter_telephone_number":"핸드폰 번호를 입력해주세요","error_message_telephone_number_in_use":"이미 등록된 번호입니다, 다시 확인해주세요","download_our_app":"앱을 다운받으세요","download_app":"앱을 다운받으세요","footer_copyright":["2014 (주) 고고밴코리아","대표자: 남경현, 람회연","사업자등록번호: 141-81-44972","화물자동차운송주선사업허가번호: 서초 130012호","주소: 서울특별시 강남구 테헤란로 38길 5 (역삼동 720-9) 10층"],"app_download_banner_title":"GoGoVan","app_download_banner_desc":"고고밴 - Move it!","app_download_banner_open":"열기","app_download_banner_download":"다운로드","app_download_banner_send_link":"링크 받기","app_download_banner_tel_prefix":"+82","app_download_banner_tel_placeholder":"+82 1588-3047"}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","close":"Close","menu":"MENU","page_home":"HOME","page_/home":"HOME","page_quoting":"INSTANT QUOTE","page_order":"PLACE AN ORDER","page_service":"CONSUMER","page_pricing":"PRICING","page_business":"CORPORATE","page_about_us":"ABOUT US","page_about_gogovan":"ABOUT GOGOVAN","page_faq":"FAQ","page_contact":"CONTACT US","page_career":"CAREERS","page_legal":"Terms and Conditions","page_privacy":"Privacy Policy","page_dashboard":"Dashboard","page_payment":"PAYMENT","page_help_center":"Help Center","page_http://help.gogox.com":"Help Center","page_blog":"BLOG","page_join":"BE A DRIVER","page_media":"MEDIA","page_download":"Download GOGOX Apps","page_order_download":"Download GOGOX Apps","page_/order_download":"Download GOGOX Apps","page_sign_out":"Sign Out","page_login":"LOG IN","page_register":"REGISTER","page_ordering_dashboard":"Dashboard","page_my_order_record":"My Order Records","page_about":"About Us","page_driver_site":"DRIVER","page_track_dialog":"TRACK STATUS","title_company":"COMPANY","title_services_pricing":"SERVICES & PRICING","title_support":"SUPPORT","footer_hotline":"Customer Service Hotline","footer_monday_sunday":"AVAILABLE DAILY","footer_office_hour":"09:00-18:00","track_modal_title":"Please enter the Tracking ID / Parcel ID in below","track_modal_tracking_id_label":"Tracking ID","track_modal_tracking_id_placeholder":"Tracking ID (e.g. NH2xVA)","track_modal_parcel_id_label":"Parcel ID","track_modal_parcel_id_placeholder":"Parcel ID (e.g. 2556789)","track_modal_search_btn":"SEARCH","track_modal_error_message_order_not_exist":"The requested order does not exist.","track_modal_error_message_no_input_ids":"Please input an ID.","register_modal_title":"REGISTER","register_modal_email_input":"Email Address","register_modal_username_input":"Your Name","register_modal_phone_input":"Contact Number","register_modal_password_input":"Password","register_modal_confirm_password_input":"Confirm Password","register_modal_register_btn":"REGISTER","register_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","register_modal_redirect_to_login_btn":"Login here","register_modal_normal_message":" if you have already registered","register_modal_or":"OR","login_modal_title":"LOGIN","login_modal_email_input":"Email address","login_modal_password_input":"Password","login_modal_login_btn":"LOGIN","login_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","login_modal_redirect_to_register_btn":"Register here","login_modal_forgot_password_btn":"I forgot my password","login_modal_normal_message":" if you don’t have an account","login_modal_or":"OR","login_error_modal_title":"Oops! You've been logged out.","login_error_modal_body":"Your login session has been expired. Please log in again to continue.","login_error_modal_login_btn":"LOGIN","error_wrong_modal_title":"Oops! Something went wrong.","error_wrong_modal_body":"Please try again, or get in touch if you need help.","error_wrong_modal_help_btn":"HELP","error_wrong_modal_okay_btn":"OKAY","error_message_please_enter_telephone_number":"Please enter a valid Singapore contact number.","app_download_banner_title":"GoGoVan","app_download_banner_desc":"Asia's leading transportation and logistics App","app_download_banner_open":"Open","app_download_banner_download":"Download","app_download_banner_send_link":"Send Link","app_download_banner_tel_prefix":"+65","app_download_banner_tel_placeholder":"+65 68361110","meta":{"description":"GoGoVan champions on demand delivery service by connecting consumers and businesses to drivers for real-time logistic needs with a mobile app with in 2 to 3 hours.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan Singapore | On Demand Delivery App At Your Fingertips","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan champions on demand delivery service by connecting consumers and businesses to drivers for real-time logistic needs with a mobile app with in 2 to 3 hours.","og:type":"website","og:site_name":"GoGoVan"},"business_account":"GOGOBUSINESS account","footer_copyright":["© 2016 GoGoVan. All rights reserved."]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","social_media_instagram":"Instagram","close":"關閉","menu":"選單","learn_more":"了解更多","page_home":"首頁","page_/home":"首頁","page_quoting":"查詢報價","page_order":"網頁下單","page_ordering_order":"下單","page_service":"服務內容","page_pricing":"費用說明","page_business":"企業合作","page_about_us":"關於GOGOX","page_about_gogovan":"ABOUT GOGOX","page_faq":"常見問題","page_contact":"聯繫我們","page_career":"加入我們","page_legal":"使用者條款","page_privacy":"隱私條款","page_dashboard":"訂單記錄","page_ordering_dashboard":"訂單記錄","page_help_center":"幫助中心","page_http://help.gogox.com":"幫助中心","page_blog":"部落格","page_join":"司機招募 ","page_driver_site":"司機招募","page_media":"MEDIA","page_download":"下載 GOGOX Apps","page_order_download":"下載 GOGOX Apps","page_/order_download":"下載 GOGOX Apps","page_sign_out":"登出","page_login":"登入","page_register":"註冊","page_my_order_records":"我的戶口","page_about":"關於GOGOX","title_company":"公司","title_services_pricing":"服務與費用","title_support":"服務支持","footer_hotline":"客服專線","footer_monday_sunday":"週一~週五<br>09:00~18:00","footer_office_hour":"非營業時間，請留言LINE@客服洽詢<br />LINE客服專區ID:<a href=\"#\" onClick=\"return false\">@gogovan.tw</a>","update_profile_modal_title":"更新個人資料","register_modal_title":"會員註冊","register_modal_email_input":"您的E-mail","register_modal_username_input":"姓名","register_modal_phone_input":"電話","register_modal_password_input":"密碼","register_modal_confirm_password_input":"確認密碼","register_modal_register_btn":"註冊","register_modal_login_with_fb_btn":"使用 FACEBOOK 登入","register_modal_redirect_to_login_btn":"登入","register_modal_normal_message":"已註冊會員","register_modal_or":"或","login_modal_title":"登入","login_modal_email_input":"您的E-mail","login_modal_password_input":"密碼","login_modal_login_btn":"會員登入","login_modal_login_with_fb_btn":"使用 FACEBOOK 登入","login_modal_redirect_to_register_btn":"註冊","login_modal_forgot_password_btn":"忘記密碼","login_modal_normal_message":"加入會員","login_modal_or":"或","login_error_modal_title":"噢! 您已經登出了","login_error_modal_body":"您的登入已經過期, 請重新登入","login_error_modal_login_btn":"登入","error_wrong_modal_title":"噢! 發生了一些錯誤","error_wrong_modal_body":"請再次嘗試或聯絡我們如果有需要的話","error_wrong_modal_help_btn":"幫助","error_wrong_modal_okay_btn":"確定","error_message_login_info_incorrect":"對不起, 您的電郵或密碼不正確","error_message_password_length_not_enough":"您的密碼不足8位","error_message_please_confirm_password":"請您確認密碼","error_message_password_not_match":"對不起，兩次輸入的密碼並不相同","error_message_please_fill_password":"請您填寫您的密碼","error_message_please_fill_email_address":"請填寫您的E-mail","error_message_please_fill_username":"請填寫您的姓名","error_message_email_address_invalid":"您的電郵無效","error_message_email_used_error_tag":"此電郵已被登記<br/>你會否 <a href='#' style='text-decoration:underline;cursor:pointer;'>登入</a> 替代?","error_message_email_used_error_tag_t":"此電郵已被登記","error_message_email_used_error_tag_t_2":"你會否 ","error_message_please_enter_telephone_number":"請輸入10位的電話號碼","error_message_telephone_number_in_use":"對不起, 此電話號碼已被使用","download_our_app":"下載GoGoVan","app_download_banner_title":"GoGoVan","app_download_banner_desc":"快遞 快速　快下載","app_download_banner_open":"開啟","app_download_banner_download":"下載","app_download_banner_send_link":"發送連結","app_download_banner_tel_prefix":"+886","app_download_banner_tel_placeholder":"+886 02-2502-1000","meta":{"description":"台灣第一個機車快遞手機APP 立即下載 即時收件 當日送達","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 貨運新方式","og:url":"{{SITE_HTTP_URL}}/","og:description":"台灣第一個機車快遞手機APP 立即下載 即時收件 當日送達","og:type":"website","og:site_name":"GoGoVan 台灣"},"footer_copyright":[""],"business_account":"商業帳戶用戶請","click_here":"按此","no_account":"還沒有帳戶？","have_account":"已經有帳戶了？","sign_up":"註冊帳戶","login":"按此登入"}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-HK","lang_lib":"en","login_facebook":true,"enable_ordering":true,"enable_google_map":true,"enable_baidu_map":false,"enable_olleh_map":false,"disable_google":false,"disable_lato":false,"redirect_to_mobile_index":false,"info_email":"info@gogovan.hk","phone_number":"35903399","info_business_email":"business@gogovan.hk","business_phone_number":"35908975","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact"]},"header":{"pages":["business","pricing","quoting"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site","gogoad"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["home","help_center","order_download"],"footer_nav":["about","service","pricing","business","privacy"]},"sg_pdpa":false,"is_email_primary_identifier":true}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var LoginButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginButton, _React$Component);

  function LoginButton(props) {
    var _this;

    _classCallCheck(this, LoginButton);

    _this = _possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "isB2BUser", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(userLevel) {
        return ['b2b_admin_user', 'b2b_master_user', 'b2b_branch_user', 'b2b_sub_user'].includes(userLevel);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "redirectToGogobusiness", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var country = _this.props.currentLocale.split('-')[1].toLowerCase();

        var href = '/';

        if (country === 'hk' || country === 'sg') {
          href = Object(__WEBPACK_IMPORTED_MODULE_10__service_asset_json__["a" /* getLink */])('gogobusiness', _this.props.currentLocale);
        }

        window.location.href = href;
      }
    });
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json"))
    };
    _this.login = _this.login.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginButton, [{
    key: "login",
    value: function login() {
      var _this2 = this;

      var jsonDev = {
        user: {
          email: this.props.email,
          password: this.props.password
        }
      }; // check whether login is valid

      var isPassCheck = true;
      Object.entries(jsonDev.user).forEach(function (item) {
        if (item[1] === '') {
          isPassCheck = false;
        }
      });
      if (!isPassCheck) return false;

      if (this.props.password.length < 8) {
        return this.props.setErrorCode(1);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__api_user__["d" /* login */])(jsonDev, this.props.currentLocale).then(function (response) {
        if (response.status !== 200) {
          return response;
        }

        return response.json();
      }).then(function (result) {
        var userLevel = result.user && result.user.level;

        if (result.status === 401) {
          _this2.props.setErrorCode(result.status);
        } else if (_this2.isB2BUser(userLevel)) {
          _this2.redirectToGogobusiness();
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo); //

          _this2.props.setUserInfo(result.user);

          _this2.props.toggle();

          setTimeout(function () {
            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }, 200);
        }
      }).catch(function (error) {
        console.warn('Request failed', error);
      });

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("button", {
        onClick: function onClick() {
          _this3.props.onClickisClickButton();

          _this3.login();
        },
        type: "submit",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.login)
      }, void 0, this.props.text);
    }
  }]);

  return LoginButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(LoginButton, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onClickisClickButton: function onClickisClickButton() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_8__actions_user__["h" /* setUserInfo */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a)(LoginButton)));

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"download":"/en#download","order_download":{"href":"/en#download","target":"_self"},"language_en_hk":"/en","language_zh_hk":"","language_en_hk_full":"https://www.gogovan.com.hk/en","language_zh_hk_full":"https://www.gogovan.com.hk","youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/en/","target":"_blank"},"password":"/en/password","dashboard":"/en/dashboard","my_order_records":"/en/dashboard","order":"/en/order","home":"https://www.gogox.com/","quoting":"/en/quoting","service":"https://www.gogox.com/service","pricing":"https://www.gogox.com/pricing","business":"https://www.gogox.com/premium_services","about":"https://www.gogox.com/about","faq":"/en/faq","contact":"/en/contact","legal":"/en/legal","privacy":"https://www.gogox.com/privacy","payment":"/en/payment","help_center":"https://help.gogox.com/hc/en-hk","sign_in":"/en/login","sign_up":"/en/signup"}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hire Platform | GoGoVan Hong Kong","index_contact_join_gogovan_desc":"Are you a driver? Join our network and start earning!","meta":{"description":"GoGoVan is an online logistics platform in Hong Kong that provide professional delivery service 24/7. You can hire a van in 30 seconds by using GoGoVan mobile app or website anywhere anytime.","keywords":"moving service,move,home moving,Van service,Transport,Transporting goods,On-demand logistics,last mile logistics,Delivery,Parcels delivery,Courier,Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hire Platform | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/","og:description":"GoGoVan is an online logistics platform in Hong Kong that provide professional delivery service 24/7. You can hire a van in 30 seconds by using GoGoVan mobile app or website anywhere anytime.","og:type":"website","og:site_name":"GoGoVan Hong Kong"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.com.hk/","logo":"https://www.gogovan.com.hk/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovanhk","https://plus.google.com/+GogovanHk/posts","http://www.youtube.com/user/MyGoGoVan","https://instagram.com/gogovan_hk/","https://www.linkedin.com/company/gogovan"],"contactPoint":[{"@type":"ContactPoint","telephone":"+852-35903399","contactType":"customer service"}]}}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"home":"https://www.gogox.com/hk/","download":"/#download","order_download":{"href":"/#download","target":"_self"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/","target":"_blank"},"order":"/order","dashboard":"/dashboard","my_order_records":"/dashboard","quoting":"/quoting","service":"https://www.gogox.com/hk/service","pricing":"https://www.gogox.com/hk/pricing","business":"https://www.gogox.com/hk/premium_services","about":"https://www.gogox.com/hk/about","privacy":"https://www.gogox.com/hk/privacy","faq":"/faq","contact":"/contact","payment":"/payment","password":"/password","help_center":"https://help.gogox.com/hc/zh-hk"}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"lang":"zh-HK","lang_lib":"zh_TW","order_header_right_extra_option":{"name":"服務說明","link":"service","target":"_blank"}}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台 | GoGoVan 香港","index_hero_hero_headline":"貨運新方式","index_hero_hero_body":"免費下載手機程式，隨時隨地暢享便捷物流。","index_hero_quoting_first_input":"起點","index_hero_quoting_last_input":"目的地","index_hero_quoting_get_btn":"查詢報價","index_hero_quoting_clear_btn":"清除","index_download_about_body":"GoGoVan是一個連接用戶和貨車司機的物流平台。用戶通過手機應用程式，30秒便可找到最適合的貨車即時送貨。現在就立即下載。","index_service_service_title":"服務範圍","index_service_service_body":"GoGoVan 24小時提供不同車種、不同類型的搬運服務。無論是個人用戶、還是企業用戶，都能找到適合您的物流方案。","index_service_button_learn_more":"了解更多","index_service_services_0":"家居搬運","index_service_services_1":"寵物接送","index_service_services_2":"寄送文件","index_service_services_3":"建材運送","index_service_services_4":"倉庫提存","index_feature_feature_title":"應用亮點","index_feature_title_1":"即時報價","index_feature_title_2":"全日無休","index_feature_title_3":"智能配對","index_feature_title_4":"司機定位","index_feature_title_5":"用戶評分","index_feature_title_6":"龐大車隊","index_feature_body_1":"輸入起點和目的地，立即得到路費報價。","index_feature_body_2":"無論晚上11時或淩晨3時，都能隨時下單。","index_feature_body_3":"系統會自動篩選距離您最近的司機，為您節省寶貴時間。","index_feature_body_4":"配對司機後，隨時查看司機所在位置和預計到達時間。","index_feature_body_5":"對使用體驗即時評分。下一次系統將優先為您安排得分高的星級司機。","index_feature_body_6":"超過二萬位専業司機，只需數秒便能指派司機。","index_howitwork_title":"使用步驟","index_howitwork_items_title_1":"在線落單","index_howitwork_items_title_2":"司機定位","index_howitwork_items_title_3":"完成支付","index_howitwork_items_body_1":"選擇起點和終點，填選送貨要求，確認訂單。","index_howitwork_items_body_2":"您將很快收到司機的電話，並可隨時定位司機的所在位置。","index_howitwork_items_body_3":"送貨完成後，現金支付予司機，並給司機打分。","index_contact_comment_title":"給我們留言","index_contact_comment_bodys":["多謝您的留言，我們將會盡快與您聯繫。","如果您有關於 GoGoVan 的任何疑問或建議，歡迎與我們聯絡。"],"index_contact_comment_input_name":"姓名","index_contact_comment_input_email":"電郵","index_contact_comment_input_title":"標題","index_contact_comment_input_body":"您的留言","index_contact_comment_send_btn":"發送","index_contact_join_gogovan_desc":"想訂單源源不斷，加盟 GoGoVan 車隊！","index_newsletter_subscriptions_comment_title":"想知道更多資訊？","index_newsletter_subscriptions_comment_bodys":["感謝您的訂閱！","如果想跟蹤更多有關於GoGoVan的資訊，立刻訂閱我們的電子通訊。"],"index_newsletter_subscriptions_comment_input_email":"電郵","index_newsletter_subscriptions_comment_send_btn":"訂閱","index_newsletter_subscriptions_wish_to_receive_news":"本人願意以電郵收到之後有關GoGoVan的資訊。","index_hero_campaign_gogobusiness_hero_headline":"全新企業平台","index_hero_campaign_gogobusiness_hero_body":"月結服務 | $0現金叫車 | 賬目更一目了然","index_hero_campaign_gogobusiness_find_out_more":"了解更多","meta":{"keywords":"物流O2O,物流,貨運,運輸,速遞,速遞公司,物流公司,物流方案,搬運,搬貨,送貨,提貨,運貨,即日送貨,搬屋,搬家,傢俬搬運,搬寫字樓,迷你倉,入倉提貨存貨,搬野,搬嘢,去機場,機場接送,接送,call van去機場,機場接載,大型行李,港鐵,巴士,通宵去機場,通宵 機場,機場van 接送,寵物旅行,寵物巴士,寵物搭車,寵物的士,搬寫字樓,客貨車電召,客貨車電召中心,貸車電召,香港叫车送货,貨van電召,街車,包車,24小時van,book車,24小時服務,租賃運輸,Call車APP,CallVan,Call車服務,叫車,叫貨車,即時","description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:type":"website","og:site_name":"GoGoVan 香港"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"http://www.gogovan.com.hk/","logo":"http://www.gogovan.com.hk/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovanhk","https://plus.google.com/+GogovanHk/posts","http://www.youtube.com/user/MyGoGoVan","https://instagram.com/gogovan_hk/","https://www.linkedin.com/company/gogovan"],"contactPoint":[{"@type":"ContactPoint","telephone":"+852-35903399","contactType":"customer service"}]}}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"#"},"playstore":{"href":"#"},"playstore_driver":{"href":"https://gogovan-downloads.s3.amazonaws.com/GoGoVanDriver-1.7.169-in.apk","target":"_blank","onclick":"_gaq.push(['_trackEvent', 'download', 'GoGoVanDriver-1.7.169-in.apk'])"},"facebook":"https://www.facebook.com/Gogovan-India-208739682909074/","twitter":"https://twitter.com/TheGoGoVan","instagram":"https://www.instagram.com/gogovan_in/","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.gogovan.sg","target":"_blank"},"youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.sg","target":"_blank"},"home":"https://www.gogox.com/in","help_center":"https://help.gogox.com/hc/en-in","service":"https://www.gogox.com/in/service","pricing":"https://www.gogox.com/in/pricing","business":"https://www.gogox.com/in/business","about":"https://www.gogox.com/in/about","privacy":"https://www.gogox.com/in/privacy"}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-IN","lang_lib":"en","enable_ordering":true,"info_email":"info@gogovan.co.in","phone_number":"044-45534533","tracking":{"optimizely":"2890590220","ga":"UA-45903094-9","mixpanel":"46e0207b380c5045388117b5cda0faae"},"social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","pricing","business","about","career","contact"]},"header":{"pages":["service","pricing"],"options":["dashboard","sign_out"]},"ordering_header":{"left_menu":["ordering_dashboard","order"],"right_menu":["ordering_dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["home","about","career"],["business","service","pricing","order"],["faq","contact","legal","privacy"]],"languages":{"en-IN":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"}}},"gogobusiness":false}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"title":"Same day delivery across India","index_hero_hero_headline":"GET YOUR STUFF MOVING","index_hero_hero_body":"A CONVENIENT NEW LOGISTICS SERVICE AT YOUR FINGERTIPS","index_hero_quoting_first_input":"Enter a Pickup Point","index_hero_quoting_last_input":"Enter a Destination","index_hero_quoting_get_btn":"GET QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is a revolutionary new way to transport goods and passengers around the city. Customers can get access to thousands of drivers directly from their mobile phone. Download the APP now.","index_service_2_service_title":"Services","index_service_service_body":"Our fleet of over 500 professional drivers in Chennai can deliver your items quickly and efficiently.","index_service_2_service_body":"From individual to business operation, GoGoVan offers four different types of logistic services that cover a wide range of needs.","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"COURIER / DELIVERY SERVICE","index_service_2_services_1":"MOVING SERVICE","index_service_2_services_2":"PASSENGER SERVICE","index_service_2_services_3":"TRANSPORT + DRIVER","index_service_2_services_body_0":"Door-to-door service for documents and parcels under 50 kg within 2 hours","index_service_2_services_body_1":"Service for moving your furniture island-wide","index_service_2_services_body_2":"Point-to-point service. Up to 13 passengers per van","index_service_2_services_body_3":"Vehicles of various sizes to carry your bulky, heavy, and odd-shaped goods","index_service_2_button_place_order":"PLACE ORDER","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT PRICE QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"FEEDBACK MATTERS","index_feature_title_6":"MULTIPLE ORDERS","index_feature_body_1":"Enter the details of your order and receive an instant quote before finalizing the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders through our app at anytime","index_feature_body_3":"Once you place your order, the GoGoVan system automatically notifies drivers with the appropriate vehicles in the surrounding area","index_feature_body_4":"Once a driver responds to your order, track his location using the GoGoVan app until the order has been fulfilled","index_feature_body_5":"Rate your driver upon the completion of each order to ensure best possible matches in the future","index_feature_body_6":"You can instantly request another service even if your first order hasn’t been completed","index_howitwork_title":"Hassle Free Ordering","index_howitwork_items_title_1":"1. Request","index_howitwork_items_title_2":"2. Engage","index_howitwork_items_title_3":"3. Rate","index_howitwork_items_body_1":" a driver online or through our mobile app","index_howitwork_items_body_2":" with your designated driver to get the job done","index_howitwork_items_body_3":" the driver and complete your transaction","index_contact_comment_title":"Question? Contact Us!","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please fill out the form below and we will get back to you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"","meta":{"description":"Same day courier, delivery and moving service across India for individuals and businesses","og:image":"/img/aboutus-banner.jpg","og:title":"Same day delivery across India","og:url":"{{SITE_HTTP_URL}}/","og:description":"Same day courier, delivery and moving service across India for individuals and businesses","og:type":"website","og:site_name":"GoGoVan"},"google_knowledgae_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.sg/","logo":"https://www.gogovan.sg/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovansg","https://twitter.com/gogovansg","https://instagram.com/gogovansg/"],"contactPoint":[{"@type":"ContactPoint","telephone":"+044-45534533","contactType":"customer service"}]}}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/kr/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"playstore_driver":{"href":"http://gogovan-downloads.s3.amazonaws.com/GoGoVanDriver-1.7.158.apk","target":"_blank","onclick":"_gaq.push(['_trackEvent', 'download', 'GoGoVanDriver-1.7.158.apk'])"},"facebook":"https://www.facebook.com/gogovankorea","naver":"http://blog.naver.com/ggvkor","instagram":"https://instagram.com/gogovankorea/","youtube":"https://www.youtube.com/gogovankrgogo","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.naver.com/ggvkor","target":"_blank"},"youtube_video":{"href":"https://youtu.be/JMAwixPUSU0","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.co.kr","target":"_blank"},"gogoevent":{"href":"http://www.gogoevent.co.kr"},"tc_consumer":"/tc_consumer","tc_location":"/tc_location"}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"lang":"ko-KR","lang_lib":"kr","login_facebook":true,"enable_ordering":true,"enable_google_map":false,"enable_baidu_map":false,"enable_olleh_map":true,"info_email":"info@gogovan.co.kr","phone_number":"1588-3047","social_media":["facebook","naver","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","about","blog","career","gogoevent","service","business","pricing","contact","tc_consumer"]},"header":{"pages":["service","pricing","gogoevent"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","gogoevent"],["service","business","pricing"],["contact","tc_consumer","legal","tc_location"]],"languages":{"ko-KR":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}}}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 - 퀵서비스부터 원룸이사, 소화물, 기업화물 배송까지","index_hero_hero_headline":"보내고 받고 고고밴","index_hero_hero_body":"퀵서비스부터 원룸이사, 용달, 화물까지 모든 배송은 고고밴으로 통한다","index_hero_quoting_first_input":"출발지","index_hero_quoting_last_input":"도착지","index_hero_quoting_get_btn":"주문하기","index_hero_quoting_clear_btn":"경로재설정","index_download_about_body":"고고밴은 물품 운송을 위해 최적화된 아시아 No.1 모바일 배송 어플리케이션입니다. 홍콩에서 시작하여 대만, 싱가폴 등에서 놀라운 실적을 기록한 스마트 물류 서비스로, 기존의 운송시장을 개선하여 배송기사와 고객에게 모두 만족스러운 서비스가 되기 위해 최선을 다할 것입니다.","index_download_about_coming_soon":"현재는 베타 버전입니다! 곧 정식 버전이 출시 될 예정입니다","index_service_2_service_title":"서비스","index_service_2_service_body":"개인 배송부터 기업 배송까지, 서류부터 화물까지,<br>다양한 물품 배송을 위해 적절한 차량의 운전기사를 1:1 연결시켜드립니다","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"퀵서비스","index_service_2_services_1":"소형용달화물","index_service_2_services_2":"원룸 / 소사무실이사","index_service_2_services_3":"대형화물 / 기업화물","index_service_2_services_body_0":"오토바이, 다마스, 라보, 1톤을 이용한 빠른 배송 서비스","index_service_2_services_body_1":"다마스, 라보 및 1~1.4톤과 같은 소형 트럭을 이용한 당일 배송을 원하시는 소량/중량화물의 경우","index_service_2_services_body_2":"원룸,오피스텔 이사 및 소사무실 등 작은 이사를 도와주는 소형 이사 서비스","index_service_2_services_body_3":"다수의 가구 및 부피가 큰 화물을 배송하는 화물 배송 서비스","index_service_2_button_place_order":"선택","index_service_2_service_not_available_headline":"대형화물 / 기업화물","index_service_2_service_not_available_content":"대형화물 및 기업화물의 배송을 원하시는 경우 고고밴코리아 고객센터 1588-3047으로 연락주시기 바랍니다.","index_feature_feature_title":"장점","index_feature_title_1":"투명 가격제","index_feature_title_2":"24시간 운영","index_feature_title_3":"스마트 매칭","index_feature_title_4":"실시간 위치","index_feature_title_5":"고객 평가","index_feature_title_6":"손쉬운 사용","index_feature_body_1":"실제 운송거리를 기준으로 정확하고 투명한 가격을 확인할 수 있습니다.","index_feature_body_2":"운전기사가 접속 중이라면 24시간 중 어느 때나 주문이 가능합니다.","index_feature_body_3":"주문을 완료하면, 고고밴 시스템이 배송에 적합한 주변 운전기사를 자동 선별하고 즉시 알려줍니다.","index_feature_body_4":"예약이 완료되면 접수된 운전기사의 위치를 알려드립니다.","index_feature_body_5":"완료된 배송에 대하여 기사 평가를 실시하여 차후 더욱 만족스러운 기사와의 연결을 제공하며 고객님의 평가는 보다 나은 서비스 향상에 도움이 됩니다.","index_feature_body_6":"GPS를 통해 고객님의 현 위치를 기준으로 빠르고 쉽게 배송예약을 할 수 있습니다.","index_howitwork_title":"특징","index_howitwork_items_title_1":"","index_howitwork_items_title_2":"","index_howitwork_items_title_3":"","index_howitwork_items_body_1":"고고밴 앱/웹으로 배송 신청","index_howitwork_items_body_2":"배송 기사와 1:1 연결","index_howitwork_items_body_3":"배송 완료 후 고객 평가","index_contact_comment_title":"고객센터","index_contact_comment_bodys":["접수 되었습니다. 감사합니다!","궁금하시거나 문의사항이 있으시면 아래 양식을 작성해 보내주시거나, 고고밴코리아 고객센터로 연락주시기 바랍니다. 서비스 이용에 도움이 되도록 최선을 다해 노력하겠습니다."],"index_contact_comment_input_name":"이름 (필수기재)","index_contact_comment_input_email":"이메일 주소 (필수기재)","index_contact_comment_input_title":"제목","index_contact_comment_input_body":"내용 (필수기재)","index_contact_comment_send_btn":"보내기","index_contact_join_gogovan_desc":"","meta":{"keywords":"용달, 고고밴, 원룸이사, 오피스텔이사, 화물, 용달이사, 기업화물","description":"고고밴은 당일배송 퀵서비스, 용달, 화물까지 모든 운송을 위해 최적화된 아시아 No.1 온라인 물류 회사로 앱, 웹페이지, 카카오톡, 및 전화로 이용가능합니다"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"http://www.gogovan.co.kr/","logo":"http://www.gogovan.co.kkr/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovankorea","https://instagram.com/gogovankorea/","https://www.youtube.com/gogovankrgogo"],"contactPoint":[{"@type":"ContactPoint","telephone":"+82-1588-3047","contactType":"customer service"}]}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj","target":"_blank"},"facebook":"https://www.facebook.com/gogovansg","twitter":"https://twitter.com/gogovansg","instagram":"https://instagram.com/gogovansg/","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.gogovan.sg","target":"_blank"},"youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.sg","target":"_blank"},"track_dialog":{"class":"dialog","data-target":"#track","href":"#"},"gogobusiness":"https://sg-business.gogox.com","home":"https://www.gogox.com/sg","help_center":"https://help.gogox.com/hc/en-sg","service":"https://www.gogox.com/sg/service","pricing":"https://www.gogox.com/sg/pricing","business":"https://www.gogox.com/sg/business","about":"https://www.gogox.com/sg/about","privacy":"https://www.gogox.com/sg/privacy","sign_up_business":"http://bit.ly/ggbpp2020"}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-SG","lang_lib":"en","enable_ordering":true,"info_email":"info@gogovan.sg","phone_number":"68361110","corporate_sales_link":"https://www.gogovanbusiness.com/get-quote/","sg_pdpa":true,"tracking":{"optimizely":"2890590220","ga":"UA-45903094-9","mixpanel":"46e0207b380c5045388117b5cda0faae"},"social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact","track_dialog"]},"header":{"pages":["service","business","driver_site","track_dialog"],"options":["dashboard","profile","sign_out"]},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","profile","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-SG":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery | Courier Singapore","index_hero_hero_headline":"Same Day Delivery, Guaranteed","index_hero_hero_body":"Asia's pioneer same day on-demand delivery management platform","index_hero_quoting_first_input":"Enter a Pick-up point","index_hero_quoting_last_input":"Enter a Drop-off point","index_hero_quoting_get_btn":"GET A QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is Asia's pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","index_service_2_service_title":"Services","index_service_2_service_body":"GoGoVan offers logistic services for both individuals and businesses. Choose the service type that best meets your needs:","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"DELIVER AND COURIER SMALL GOODS","index_service_2_services_1":"TRANSPORT LARGE AND BULKY GOODS","index_service_2_services_2":"BOOK A MOVING SERVICE","index_service_2_services_body_0":"Door-to-door delivery and courier service for documents and parcels, up to 30X20X20cm or under 10kg each","index_service_2_services_body_1":"For goods that exceed 30x20x20cm or weigh over 30kg, additional charge for door-to-door service.","index_service_2_services_body_2":"Relocation for homes and offices, includes labour cost","index_service_2_button_place_order":"GET QUOTE","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"SERVICE RATING","index_feature_title_6":"MULTIPLE ORDERS","index_feature_body_1":"Enter the details of your order to receive an instant quotation before confirming the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders via our mobile or web app 24/7","index_feature_body_3":"Be matched to drivers with the right vehicles in the surrounding area","index_feature_body_4":"Track your order using the GoGoVan app to make sure your goods are delivered successfully","index_feature_body_5":"Rate your driver upon the completion of each order","index_feature_body_6":"You can instantly book a new order even if your previous order hasn't been completed","index_howitwork_title":"Hassle-Free Ordering","index_howitwork_items_title_1":"1. Choose","index_howitwork_items_title_2":"2. Be matched","index_howitwork_items_title_3":"3. Receive","index_howitwork_items_body_1":" service and set route","index_howitwork_items_body_2":" with a driver","index_howitwork_items_body_3":" your items and rate the service","index_contact_comment_title":"Contact Us","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please complete the form below and we will get in touch with you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"","meta":{"description":"GOGOVAN is a Same Day Delivery and Courier pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan Singapore | On Demand Delivery App At Your Fingertips","og:url":"{{SITE_HTTP_URL}}/","og:description":"GOGOVAN is a Same Day Delivery and Courier pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","og:type":"website","og:site_name":"GoGoVan"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.sg/","logo":"https://www.gogovan.sg/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovansg","https://twitter.com/gogovansg","https://instagram.com/gogovansg/"],"contactPoint":[{"@type":"ContactPoint","telephone":"+65-68361110","contactType":"customer service"}]}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/tw/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"facebook":"https://www.facebook.com/gogovan.tw","googleplus":"https://plus.google.com/116908635505238319515/posts","youtube":"https://www.youtube.com/channel/UCjwRT_nO758HyxqUUL3Gq7A","instagram":"https://instagram.com/gogovan.tw","office_address":"https://goo.gl/maps/7xvqvxPXqss","order":"/order","dashboard":"/dashboard","my_order_records":"/dashboard","blog":{"href":"http://blog.gogovan.com.tw","target":"_blank"},"youtube_video":{"href":"https://youtu.be/iESZ5yRqAFE","target":"_blank"},"driver_site":{"href":"http://driver-promote.gogovan.tw/","target":"_blank"},"career":{"href":"https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=4b3d456e3739416a33353d663b41391c92c2c2c284539572654j98","target":"_blank"},"home":"https://www.gogox.com/tw","help_center":"https://help.gogox.com/hc/zh-tw","service":"https://www.gogox.com/tw/service","pricing":"https://www.gogox.com/tw/pricing","business":"https://www.gogox.com/tw/business","about":"https://www.gogox.com/tw/about","privacy":"https://www.gogox.com/tw/privacy"}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"lang":"zh-TW","lang_lib":"zh-TW","login_facebook":true,"enable_ordering":true,"info_email":"info@gogovan.tw","phone_number":"02-2502-1000","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","order","career","blog","faq","contact"]},"header":{"pages":["service","pricing","order"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site"],["service","business","pricing","order"],["faq","contact","legal"]],"languages":{"zh-TW":{"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["home","help_center","order_download"],"footer_nav":["about","service","pricing","business","legal"]},"gogobusiness":false}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"title":"個人專屬的快遞APP，讓物流就像叫車一樣，隨時隨地，即刻送達 | GoGoVan 台灣","index_hero_hero_headline":"物流新方式","index_hero_hero_body":"全新快遞服務<br>配送彈指之間","index_hero_quoting_first_input":"出發地","index_hero_quoting_last_input":"目的地","index_hero_quoting_get_btn":"查詢報價","index_hero_quoting_clear_btn":"清除","index_download_about_body":"GoGoVan是台灣第一個快遞O2O平台，您可以在手機或是電腦，於彈指間將貨件作配送。無論是個人還是企業客戶，都能找到適合您的配送方案。即時報價、GPS追蹤貨件，24小時不打烊，不管是文件、商品、美食外送，即時配送在您的指尖，當日到達沒問題！<br><br><b>快遞　快速　快下載</b>","index_service_service_title":"全方位服務","index_service_service_body":"只有想不到，沒有送不到。","index_service_button_learn_more":"了解更多","index_service_services_0":"運送服務","index_service_services_1":"附加服務","index_service_services_2":"客製服務","index_service_services_content_0":"貨件不設限，文件、商品、食品、行李…統統包，省時省力免煩惱。","index_service_services_content_1":"代辦、代購、代墊取貨、排隊搶票、買菜、送餐…誠心為你代勞。","index_service_services_content_2":"各行各業無限制，企業客戶客製專案，配合度高，歡迎合作洽談。","index_feature_feature_title":"智慧化亮點","index_feature_feature_body":"全程e化真方便，在你指尖即時配送","index_feature_title_1":"即時報價","index_feature_title_2":"全日無休","index_feature_title_3":"即時配對","index_feature_title_4":"全程GPS","index_feature_title_5":"安星評比","index_feature_title_6":"龐大車隊","index_feature_title_7":"方便使用","index_feature_title_8":"貨件保險","index_feature_body_1":"輸入出發地和目的地，價格系統立即顯示，收費優惠合理。","index_feature_body_2":"平台 24hrs不間斷，無論晚上11點或凌晨3點，隨時下單免煩惱。","index_feature_body_3":"系統配對最近的司機收送件，省時間又經濟環保。","index_feature_body_4":"物件全程定位，即時查看貨件所在地及預計到達時間。","index_feature_body_5":"五星評分評比司機服務，品質保證最安心。","index_feature_body_6":"超過萬名專業司機，數秒找到合適的車輛。","index_feature_body_7":"叫件服務一指完成，省時操作免等CALL車配送。","index_feature_body_8":"機車快遞貨件理賠額度高於業界，GoGoVan免費幫你保。","index_howitwork_title":"使用步驟","index_howitwork_items_title_1":"1. 即時下單","index_howitwork_items_title_2":"2. 全程GPS安心追蹤","index_howitwork_items_title_3":"3. 五星級評分機制","index_howitwork_items_body_1":" 輸入地點即時報價 萬名司機快速接單","index_howitwork_items_body_2":" 貨件全程GPS可追蹤 一手掌握配送進度","index_howitwork_items_body_3":" 肯定司機服務良好 服務品質非常滿意","index_contact_comment_title":"給我們留言","index_contact_comment_bodys":["謝謝，您的訊息已經寄送","如果您有關於GoGoVan的任何疑問或建議，歡迎聯繫我們，我們將盡快回覆您。"],"index_contact_comment_input_name":"姓名*","index_contact_comment_input_email":"您的E-mail*","index_contact_comment_input_phone_number":"您的電話號碼*","index_contact_comment_input_title":"標題","index_contact_comment_input_body":"您的留言*","index_contact_comment_send_btn":"發送","index_contact_join_gogovan_desc":"加入GoGoVan，順路就有財路！司機招募","meta":{"description":"全新快遞App服務，配送彈指之間。下載APP快遞當日急件、代買跑腿最方便，即時報價、GPS全程追蹤，24小時不打烊。有了GoGoVan，您可以隨時隨地，輕鬆宅配、快遞。","keywords":"快遞,急件,代買,跑腿,宅配,當日急件","og:image":"/img/aboutus-banner.jpg","og:title":"個人專屬的快遞APP，讓物流就像叫車一樣，隨時隨地，即刻送達 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/","og:description":"全新快遞App服務，配送彈指之間。下載APP快遞當日急件、代買跑腿最方便，即時報價、GPS全程追蹤，24小時不打烊。有了GoGoVan，您可以隨時隨地，輕鬆宅配、快遞。","og:type":"website","og:site_name":"GoGoVan 台灣"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.tw/","logo":"https://www.gogovan.tw/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovan.tw","https://plus.google.com/116908635505238319515/posts","https://www.youtube.com/channel/UCjwRT_nO758HyxqUUL3Gq7A","https://instagram.com/gogovan.tw"],"contactPoint":[{"@type":"ContactPoint","telephone":"+886-02-2502-1000","contactType":"customer service"}]}}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ce17218.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a71eecbb.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36364c00.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(529);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/createFetch.js
var createFetch = __webpack_require__(152);

// EXTERNAL MODULE: ./src/service/auth.js
var service_auth = __webpack_require__(149);

// CONCATENATED MODULE: ./src/api/callback.js
function callback(temp, body, status, headers) {
  var cb = {
    temp: null,
    body: body,
    status: status,
    headers: headers
  };
  return cb;
}
// CONCATENATED MODULE: ./src/api/order.js
/* harmony export (immutable) */ __webpack_exports__["h"] = getOrderPrice;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOrderRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelOrder;
/* harmony export (immutable) */ __webpack_exports__["g"] = getOrderBreakdown;
/* harmony export (immutable) */ __webpack_exports__["j"] = rateDriver;
/* harmony export (immutable) */ __webpack_exports__["e"] = feedback;
/* harmony export (immutable) */ __webpack_exports__["k"] = setBlacklist;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBlacklist;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteBlacklist;
/* unused harmony export clientUpload */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncUpload;
/* harmony export (immutable) */ __webpack_exports__["c"] = createOrder;
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable import/prefer-default-export */

/* eslint-disable consistent-return */



/**
 * Get Order Price
 * @param {Object} data
 * @param {String} data.nickname
 * @param {Object} data.order_request_detail_attributes
 * @param {String} data.phone_number
 * @param {String} data.pickup_time
 * @param {String} data.service_type
 * @param {String} data.vehicle
 * @param {Array} data.waypoints_attributes
 * @param {String} data.waypoints_attributes.address
 * @param {Number} data.waypoints_attributes.lat
 * @param {Number} data.waypoints_attributes.lon
 */

function getOrderPrice(_x, _x2) {
  return _getOrderPrice.apply(this, arguments);
}
/**
 * Get All Order for a user
 * @param {String} id
 */

function _getOrderPrice() {
  _getOrderPrice = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(data, locale) {
    var url, json, Options, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/api/w1/utils/price_breakdown.json';
            json = {
              order: data
            };
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context.prev = 4;
            _context.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options);

          case 7:
            return _context.abrupt("return", _context.sent);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", console.warn(_context.t0));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 10]]);
  }));
  return _getOrderPrice.apply(this, arguments);
}

function getOrderRequest(_x3, _x4) {
  return _getOrderRequest.apply(this, arguments);
}
/**
 * Cancel order
 * @param  {Number}   id
 */

function _getOrderRequest() {
  _getOrderRequest = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(id, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = '/api/w1/order_requests.json';

            if (id !== null) {
              url = "/api/w1/order_requests/".concat(id.toString(), ".json");
            }

            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context2.prev = 5;
            _context2.next = 8;
            return Object(createFetch["a" /* default */])(Options)(url, options);

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](5);
            return _context2.abrupt("return", _context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[5, 11]]);
  }));
  return _getOrderRequest.apply(this, arguments);
}

function cancelOrder(_x5, _x6) {
  return _cancelOrder.apply(this, arguments);
}
/**
 * Get order breakdown
 * @param  {Number}   id
 */

function _cancelOrder() {
  _cancelOrder = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(id, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = "/api/w1/order_requests/".concat(id, "/cancel.json");
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context3.prev = 4;
            _context3.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options);

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](4);
            return _context3.abrupt("return", console.warn(_context3.t0));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[4, 10]]);
  }));
  return _cancelOrder.apply(this, arguments);
}

function getOrderBreakdown(_x7, _x8) {
  return _getOrderBreakdown.apply(this, arguments);
}
/**
 * Rate Driver
 * @param  {Number}   orderNumber
 * @param  {Object}   param
 * @param  {Number}   param.driver_rating
 * @param  {String}   param.client_feedback
 * @param  {Function} callback
 * @return {ApiClient}
 */

function _getOrderBreakdown() {
  _getOrderBreakdown = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(id, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "/api/w1/order_requests/".concat(id, "/breakdown.json");
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context4.prev = 4;
            _context4.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options);

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](4);
            return _context4.abrupt("return", console.warn(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[4, 10]]);
  }));
  return _getOrderBreakdown.apply(this, arguments);
}

function rateDriver(_x9, _x10, _x11) {
  return _rateDriver.apply(this, arguments);
}
/**
 * submit feedback
 * @param  {Number}   orderNumber
 * @param  {String}   name
 * @param  {String}   contact
 * @param  {String}   feedbacks
 */

function _rateDriver() {
  _rateDriver = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(orderNumber, data, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = "/api/w1/order_requests/".concat(orderNumber, "/rate.json");
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            };
            _context5.prev = 4;
            _context5.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              return callback(null, result.body, result.status, result.headers);
            }).catch(function (error) {
              console.warn('Request failed', error);
              return error;
            });

          case 7:
            _context5.next = 12;
            break;

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](4);
            return _context5.abrupt("return", console.warn(_context5.t0));

          case 12:
            return _context5.abrupt("return", null);

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[4, 9]]);
  }));
  return _rateDriver.apply(this, arguments);
}

function feedback(_x12, _x13, _x14, _x15, _x16) {
  return _feedback.apply(this, arguments);
}
/**
 * Set blacklist
 * @param  {Number}  id
 * @param  {Function} callback
 * @return {ApiClient}
 */

function _feedback() {
  _feedback = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(orderNumber, name, contact, feedbacks, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = "/api/w1/feedbacks.json";
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                order_request_id: orderNumber,
                name: name,
                contact: contact,
                feedback: feedbacks
              })
            };
            _context6.prev = 4;
            _context6.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              return callback(null, result.body, result.status, result.headers);
            }).catch(function (error) {
              console.warn('Request failed', error);
              return error;
            });

          case 7:
            _context6.next = 12;
            break;

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](4);
            return _context6.abrupt("return", console.warn(_context6.t0));

          case 12:
            return _context6.abrupt("return", null);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[4, 9]]);
  }));
  return _feedback.apply(this, arguments);
}

function setBlacklist(_x17, _x18, _x19, _x20) {
  return _setBlacklist.apply(this, arguments);
}
/**
 * Get blacklist
 * @param  {Function} fn
 */

function _setBlacklist() {
  _setBlacklist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(id, locale, callbackfn, callbackparam) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = "/api/w1/driver_blacklists.json";
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                driver_blacklist: {
                  driver_id: id
                }
              })
            };
            _context7.prev = 4;
            _context7.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              if (callbackfn) {
                setTimeout(function () {
                  callbackfn(locale, callbackparam);
                }, 300);
              }

              return callback(null, result.body, result.status, result.headers);
            }).catch(function (error) {
              console.warn('Request failed', error);
              return error;
            });

          case 7:
            _context7.next = 12;
            break;

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](4);
            return _context7.abrupt("return", console.warn(_context7.t0));

          case 12:
            return _context7.abrupt("return", null);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[4, 9]]);
  }));
  return _setBlacklist.apply(this, arguments);
}

function getBlacklist(_x21, _x22) {
  return _getBlacklist.apply(this, arguments);
}
/**
 * Delete blacklist
 * @param  {Number}   blacklist id - return from driver_blacklists.json
 * @param  {Function} callbackfn
 * @return {ApiClient}
 */

function _getBlacklist() {
  _getBlacklist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(locale, fn) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = "/api/w1/driver_blacklists.json";
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context8.prev = 4;
            _context8.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              var body = null;

              if (result.status !== 404 && result.status !== 401) {
                result.json().then(function (b) {
                  body = b;

                  if (fn) {
                    fn(callback(null, body, result.status, result.headers));
                  }
                });
              } else {
                callback(null, body, result.status, result.headers);
              }
            }).catch(function (error) {
              return error;
            });

          case 7:
            _context8.next = 12;
            break;

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](4);
            return _context8.abrupt("return", console.warn(_context8.t0));

          case 12:
            return _context8.abrupt("return", null);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 9]]);
  }));
  return _getBlacklist.apply(this, arguments);
}

function deleteBlacklist(_x23, _x24, _x25, _x26) {
  return _deleteBlacklist.apply(this, arguments);
}
/**
 * Upload file
 * @param  {Number}   orderNumber
 * @param  {Object}   file
 * @param  {Function} fn
 */

function _deleteBlacklist() {
  _deleteBlacklist = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9(id, locale, callbackfn, callbackparam) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = "/api/w1/driver_blacklists/".concat(id, ".json");
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'DELETE',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context9.prev = 4;
            _context9.next = 7;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              // Delay the action of getting blacklist after delete driver in blacklist
              // you may need the result
              if (callbackfn) {
                setTimeout(function () {
                  callbackfn(locale, callbackparam);
                }, 300);
              }
            }).catch(function (error) {
              console.warn('Request failed', error);
              return error;
            });

          case 7:
            _context9.next = 12;
            break;

          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](4);
            return _context9.abrupt("return", console.warn(_context9.t0));

          case 12:
            return _context9.abrupt("return", null);

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this, [[4, 9]]);
  }));
  return _deleteBlacklist.apply(this, arguments);
}

function clientUpload(_x27, _x28, _x29) {
  return _clientUpload.apply(this, arguments);
}
/**
 * Upload file
 * @param  {string}   locale // Language
 * @param  {Object}   files
 * @param  {Function} fn // add response to client_uploads
 * @param  {Function} setIsUploadedClientPhoto
 */

function _clientUpload() {
  _clientUpload = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee10(file, locale, fn) {
    var url, auth, formData, Options, options;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            url = "/api/w1/client_uploads.json";
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            formData = new FormData();
            formData.append('file', file, file.name);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth // 'Content-Type': 'multipart/form-data',

              },
              body: formData
            };
            _context10.prev = 6;
            _context10.next = 9;
            return Object(createFetch["a" /* default */])(Options)(url, options).then(function (result) {
              if (result.status === 200) {
                // add image response to UploadedImageList
                result.json().then(function (i) {
                  if (fn) {
                    return fn([i.client_upload]);
                  }
                });
              }
            }).catch(function (error) {
              console.warn('Request failed', error);
              return error;
            });

          case 9:
            _context10.next = 14;
            break;

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](6);
            return _context10.abrupt("return", console.warn(_context10.t0));

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this, [[6, 11]]);
  }));
  return _clientUpload.apply(this, arguments);
}

function asyncUpload(_x30, _x31, _x32, _x33) {
  return _asyncUpload.apply(this, arguments);
}
/**
 * Create order
 * @param  {String} params.vehicle
 * @param  {String} params.service_type
 * @param  {String} params.nickname
 * @param  {String} params.phone_number
 * @param  {String} params.pickup_time
 * @param  {Object} params.waypoints_attributes
 * @param  {Object} params.waypoints_attributes[n].address
 * @param  {Object} params.waypoints_attributes[n].lat
 * @param  {Object} params.waypoints_attributes[n].lon
 */

function _asyncUpload() {
  _asyncUpload = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee11(files, locale, fn, setIsUploadedClientPhoto) {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return Promise.all(files.filter(function (f) {
              return f.name !== undefined;
            }).map(function (file) {
              return clientUpload(file, locale, fn);
            }));

          case 2:
            setTimeout(function () {
              if (setIsUploadedClientPhoto) {
                setIsUploadedClientPhoto(true);
              }
            }, 1000);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));
  return _asyncUpload.apply(this, arguments);
}

function createOrder(_x34, _x35) {
  return _createOrder.apply(this, arguments);
}

function _createOrder() {
  _createOrder = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee12(params, locale) {
    var order, requiredParams, url, i, name, json, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            order = params;
            requiredParams = ['vehicle', 'service_type', 'nickname', 'phone_number', 'pickup_time', 'waypoints_attributes'];
            url = "/api/w1/order_requests.json"; // check whether is valid order

            i = 0;

          case 4:
            if (!(i < requiredParams.length)) {
              _context12.next = 11;
              break;
            }

            name = requiredParams[i];

            if (!(typeof order[name] === 'undefined')) {
              _context12.next = 8;
              break;
            }

            return _context12.abrupt("return", console.warn("No ".concat(name, " specified")));

          case 8:
            i += 1;
            _context12.next = 4;
            break;

          case 11:
            json = {
              order: params
            };
            auth = Object(service_auth["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context12.prev = 15;
            _context12.next = 18;
            return Object(createFetch["a" /* default */])(Options)(url, options);

          case 18:
            return _context12.abrupt("return", _context12.sent);

          case 21:
            _context12.prev = 21;
            _context12.t0 = _context12["catch"](15);
            return _context12.abrupt("return", console.warn(_context12.t0));

          case 24:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, this, [[15, 21]]);
  }));
  return _createOrder.apply(this, arguments);
}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1437684.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(786);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 574 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46049e40.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(530);
var $export = __webpack_require__(460);
var redefine = __webpack_require__(579);
var hide = __webpack_require__(464);
var has = __webpack_require__(459);
var Iterators = __webpack_require__(469);
var $iterCreate = __webpack_require__(787);
var setToStringTag = __webpack_require__(537);
var getPrototypeOf = __webpack_require__(581);
var ITERATOR = __webpack_require__(454)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(458) && !__webpack_require__(470)(function () {
  return Object.defineProperty(__webpack_require__(578)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(465);
var document = __webpack_require__(456).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(464);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(459);
var toIObject = __webpack_require__(463);
var arrayIndexOf = __webpack_require__(789)(false);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(459);
var toObject = __webpack_require__(570);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(528);
var TAG = __webpack_require__(454)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(803);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(805);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(580);
var hiddenKeys = __webpack_require__(536).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(526);
var createDesc = __webpack_require__(474);
var toIObject = __webpack_require__(463);
var toPrimitive = __webpack_require__(531);
var has = __webpack_require__(459);
var IE8_DOM_DEFINE = __webpack_require__(577);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(458) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "260892c0.jpg";

/***/ }),
/* 587 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(877);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Header.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Header.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","order","404","password","legal","quoting","faq","mobile/pricing","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","mobile/pricing","template_for_angular","template_for_angular_no_header","business_services_registration"]

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"title":"About Us | GoGoVan Hong Kong","meta":{"description":"GoGoVan Hong Kong is the market leader in Van Hiring Service by using technology to match logistic needs with van drivers.","keywords":"Van rental,van hire,24 hours service,24/7 service","og:image":"/img/aboutus-banner.jpg","og:title":"About Us | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/about","og:description":"GoGoVan Hong Kong is the market leader in Van Hiring Service by using technology to match logistic needs with van drivers.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Business Package | GoGoVan Hong Kong","meta":{"description":"Choose hourly or monthly plan or any customised logistics services by partnering with GoGoVan.","keywords":"monthly invoice,monthly settlement,driver tracking,real-time tracking,return order,cargo insurance,payment methods,hourly rental,monthly rental,Event logistics,production logistics","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Business Package | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/business","og:description":"Choose hourly or monthly plan or any customised logistics services by partnering with GoGoVan.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"title":"Contact Us | GoGoVan Hong Kong","meta":{"description":"GoGoVan owns the biggest van hiring platform in Hong Kong. Contact GoGoVan at (852) 35903399 or email to info@gogovan.hk for any general enquiries.","og:image":"/img/aboutus-banner.jpg","og:title":"Contact Us | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/contact.html","og:description":"GoGoVan owns the biggest van hiring platform in Hong Kong. Contact GoGoVan at (852) 35903399 or email to info@gogovan.hk for any general enquiries.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"show_business_contact":true}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/dashboard","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"dashboard":{"ng_blocks":["/gogovan/dashboard/hk/hk-dashboard.html"]}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"title":"FAQ | GoGoVan Hong Kong","meta":{"description":"Answers to Frequently Asked Questions regarding Van Hiring in Hong Kong.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:title":"FAQ | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/faq","og:description":"Answers to Frequently Asked Questions regarding Van Hiring in Hong Kong.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_newsletter_subscriptions","prefix":"index_newsletter_subscriptions"},{"type":"sections/index/index_media","prefix":"index_media"}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms and Conditions | GoGoVan Hong Kong","legal_headline":"Terms and Conditions"}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/en_hk_content"}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Pricing | GoGoVan Hong Kong","meta":{"description":"Hire Van with GoGoVan and enjoy transparent pricing and convenient service at your fingertips.","keywords":"Affordable,budget,reasonable price,cheap,cheaper, fair,low-cost,low cost,low-priced ,low price,low,inexpensive,rational,competitive pricing,rate","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Pricing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/pricing","og:description":"Hire Van with GoGoVan and enjoy transparent pricing and convenient service at your fingertips.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy | GoGoVan Hong Kong","privacy_headline":"Privacy Policy"}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/en_hk_content"}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"dollar_code":"$","quoting_first_input":"Enter a Pickup Point","quoting_last_input":"Enter a Destination","quoting_get_btn":"GET QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_price_prefix":"FROM ","quoting_price_postfix":"","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_van_title":"VAN","quoting_service_van_body":"Carries max. 5 passengers; max. load 700kg ; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","quoting_service_5ton_title":"5.5 TON TRUCK","quoting_service_5ton_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","quoting_service_9ton_title":"9 TON TRUCK","quoting_service_9ton_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width.","title":"Van Hiring Quoting | GoGoVan Hong Kong","order_restricted_area_warning":"Restricted Area<br />The following address is restricted to closed road permit holders only.","order_restricted_area_ps":"If you don't have the permit, the fare will be quoted by the driver.  Please contact GOGOVAN specialist for further assistance (Tel: <span class='global-text-blue'>35903399</span> ).","order_restricted_area_error_message":"Address is restricted to closed road permit holders only","order_restricted_area_error_message_no_services":"GOGOVAN may not have services in the address","order_restricted_area_have_lincense":"I have permit","order_restricted_area_question":"Have no permit","order_restricted_area_question_title":"Have no permit?","order_restricted_area_confirm":"I Understand","order_restricted_area_out_ps":"GOGOVAN may not have services at the following address. Please contact GOGOVAN specialist for further assistance (Tel: <span class='global-text-blue'>35903399</span> ).","meta":{"description":"Get a quote with GoGoVan for Hong Kong island, Kowloon and New Territories for delivery.","keywords":"Affordable,budget,reasonable price,cheap,cheaper, ffair,low-cost,low cost,low-priced ,low price,low,inexpensive,rational,competitive pricing,rate,Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Quoting | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/quoting","og:description":"Get a quote with GoGoVan for Hong Kong island, Kowloon and New Territories for delivery.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Services | GoGoVan Hong Kong","meta":{"description":"GoGoVan provides delivery, moving, pet shuttle, goods carrying, warehouse in and out, and more logistics services by simply hiring for a van.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Services | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/service","og:description":"GoGoVan provides delivery, moving, pet shuttle, goods carrying, warehouse in and out, and more logistics services by simply hiring for a van.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"service_contents":[{"type":"service_headline"},{"type":"service_photos"},{"type":"service_fleets","content":"service_content_fleets"},{"type":"service_fleets","content":"service_content_additional"},{"type":"service_fleets","content":"service_content_hourly"}],"hero":"background-image: url(/img/services_banner_bg.jpg)"}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Order Placing | GoGoVan Hong Kong","meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order Placing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/order","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Order Placing | GoGoVan Hong Kong","meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order Placing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/order","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = ["mobile/pricing"]

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"title":"收费表 | GoGoVan 香港","pricing_hero_quoting_headline":"想报价？","pricing_hero_quoting_content":"试试我们的网上报价功能！只需输入起点及目的地，价格一目了然！","pricing_hero_button_quoting":"查询报价","pricing_headline_headline":"收费透明，使用安心","pricing_headline_content":"GoGoVan 的收费通指基本路程费用。不同情况下可能会产生附加服务费、隧道费或停车场费等。现在就对照价目表，查看报价吧。","pricing_quoting_header":"网上报价","pricing_pricing_table_header":"下载价目表","pricing_pricing_table_quoting_header":"网上报价","pricing_pricing_table_van":"货Van","pricing_pricing_table_5.5ton_truck":"5.5吨货车","pricing_pricing_table_9ton_truck":"9吨货车","pricing_pricing_table_item":"项目","pricing_pricing_table_vehicles_and_pricing":"车种及收费","pricing_pricing_table_pricing_header":"下载价目表","pricing_pricing_table_pricing_button_download":"下载价目表","pricing_additionals_header":"附加服务费","pricing_additionals_content":"（以每单计）","pricing_additionals_head_items":["项目","货Van","5.5吨货车","9吨货车"],"pricing_additionals_head_items_mobile":["项目","车种及收费"],"pricing_additionals_need_english_title":"英语司机","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"货物长度超过6呎","pricing_additionals_need_over_6ft_price":["$10","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"货物长度超过6呎<br />（而且超过半网）","pricing_additionals_need_over_6ft_half_net_price":["$20","-","-"],"pricing_additionals_need_cart_title":"租用手推车／板车","pricing_additionals_need_cart_price":["每部$10（无限次使用）","-","-"],"pricing_additionals_need_tailgate_title":"租用唧车","pricing_additionals_need_tailgate_price":["-","每部$20（无限次使用）","每部$20（无限次使用）"],"pricing_additionals_need_carry_title":"帮搬","pricing_additionals_need_carry_price":["与司机议价","与司机议价","与司机议价"],"pricing_additionals_need_pet_title":"接载宠物","pricing_additionals_need_pet_price":["$10（不论​​只数）","$10（不论​​只数）","$10（不论​​只数）"],"pricing_additionals_need_waste_title":"运载泥头／建筑废料","pricing_additionals_need_waste_price":["与司机议价","与司机议价","与司机议价"],"pricing_additionals_enter_landfills_title":"进入堆填区","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"进入建筑地盘","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多层停车场或货仓","pricing_additionals_carpark_price":["第三层起每层$3<br />（例: 第四层$6，第六层$12）","第三层起每层$5<br />（例: 第四层$10，第六层$20）","第三层起每层$5<br />（例: 第四层$10，第六层$20）"],"pricing_additionals_overtime_title":"超时等候","pricing_additionals_overtime_price":["首15分钟: 免费;<br />超时每5分钟: 10元;<br />如有中途点，每点首5分钟免费","首30分钟: 免费;<br />超时每5分钟: 15元;<br />如有中途点，每点首10分钟免费","首30分钟: 免费;<br />超时每5分钟: 15元;<br />如有中途点，每点首10分钟免费"],"pricing_additionals_passenger_count_title":"跟车人数","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免费；3个或以上+$20","最多5人；首2人免费；3个或以上+$20"],"pricing_additionals_night_title":"夜间（21:00 - 23:59）附加费","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加费","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"星期日及公众假期（07:00 - 20:59）附加费*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*如在星期日及公众假期的夜间/凌晨时段上货，司机只收取夜间/凌晨附加费，不再另外收取星期日及公众假期附加费。例：货Van星期日21:30上货，特别时段附加费为$30；星期日03:00上货，特别时段附加费为$80。","pricing_tunnels_header":"隧道费及桥费","pricing_tunnels_content":"（以每次计，实报实销）","pricing_tunnels_head_items":["项目","货Van/5.5吨货车","9吨货车"],"pricing_tunnels_head_items_mobile":["项目","车种及收费"],"pricing_tunnels_cross_harbour_title":"红磡隧道","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"东区隧道","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"西区隧道","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"青马隧道／青屿干线","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"大榄隧道","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"将军澳隧道","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"城门隧道","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"尖山隧道／沙田岭隧道","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"狮子山隧道","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"珀丽湾专区桥费（10:00 - 16:00）","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"愉景湾隧道（09:00-18:00）","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"愉景湾入闸登记费","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"停车场费","pricing_carpark_content":"（以每次计，实报实销）","pricing_carpark_discovery_bay_title":"愉景湾停车场","pricing_carpark_discovery_bay_price":["首2小时：免费<br />第3小或以内：$100<br />第3小时之后每小时：$200"],"pricing_carpark_hkia_3_title":"机场三号停车场","pricing_carpark_hkia_3_price":["每小时$16"],"pricing_carpark_hkia_1_2_title":"机场一号及二号停车场／落货区","pricing_carpark_hkia_1_2_price":["首30分钟：$40<br />次30分钟：$60<br />其后每30分钟：$80"],"meta":{"description":"查询GoGoVan基本路程收费及附加服务费。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 收费表","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查询GoGoVan基本路程收费及附加服务费。","og:type":"website","og:site_name":"GoGoVan"},"pricing_header_headline":"司机收取总金额＝车费＋杂项收费（如适用）","pricing_header_surcharges":"杂项收费:","pricing_header_additional_charges":"附加服务费","pricing_header_tunnel_tolls_and_bridge_tolls":"隧道费及桥费","pricing_header_parking_fees":"停车场费","pricing_header_dangerous_goods":"危险品收费","pricing_header_refer":"有关杂项收费请参阅以下价目表, 并与司机确认总金额。","pricing_header_enquiry":"如有任何疑问, 欢迎致电GoGoVan 查询。","pricing_header_tel_no":"","pricing_dangerous_goods_dangerous_goods":"危险品","pricing_dangerous_goods_title":["种类","限制数量","收费方法"],"pricing_dangerous_goods_fire_extinguishers":["灭火筒","无限","免加收费"],"pricing_dangerous_goods_acetylene_cylinder":["风煤樽","2樽","超额收$10/樽"],"pricing_dangerous_goods_refrigerant":["雪种","1樽","超额收$10/樽"],"pricing_dangerous_goods_nitrogen":["氮气","1樽","超额收$10/樽"],"pricing_dangerous_goods_journey_fare_table":"路程收费表","pricing_dangerous_goods_hk_hk":"香港-香港","pricing_dangerous_goods_hk_kln":"香港-九龙","pricing_dangerous_goods_hk_nt":"香港-新界","pricing_dangerous_goods_kln_kln":"九龙-九龙","pricing_dangerous_goods_kln_nt":"九龙-新界","pricing_dangerous_goods_nt_nt":"新界-新界","pricing_vehicle_dropdown_van":"货Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5吨货车","pricing_vehicle_dropdown_ton_truck_9":"9吨货车"}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","mobile/pricing","sitemap","template_for_angular","template_for_angular_no_header","business_services_registration"]

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"title":"404 | GoGoVan 香港","404_title":"","404_body":"ᒥ爲何人類總要重複同樣的錯誤ᒧ","404_sub":"—— 阿寶","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"愛•回家"}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"title":"關於 Call Van平台 | GoGoVan 香港","about_gogovan_headline":"關於GoGoVan","about_gogovan_body":["GoGoVan（高高客貨車）2013年成立於香港，為亞洲首個以手機應用程式為載體的貨運物流平台。GoGoVan 旨將貨車司機和需求用戶連接，令送貨服務實現隨時隨地隨叫隨到，為客戶提供更加快捷的貨運方式，提高物流效率。","GoGoVan 目前的註冊貨車超過2萬輛。GoGoVan 的版圖正在擴張，業務已擴展到新加坡、韓國、中國內地和台灣等國家和地區。"],"about_map_map_headline":"穿梭城市    改變生活","about_map_map_stat_name_countries":"國家","about_map_map_stat_name_cities":"城市","about_map_map_stat_name_registered":"貨車","about_help_help_headline":"戰略合作夥伴","about_help_help_desc":["GoGoVan 正在不斷發掘科技與貨運結合的多元之美。無論為生活的哪個層面提供助力，我們都期望令平凡的日常生活變得美好和簡單。我們期待結識更多不同行業、不同領域的合作夥伴，共同探索貨運的可能。Move it! Together!","聯絡我們: <a href='mailto:info@gogovan.hk'>info@gogovan.hk</a>"],"about_business_cooperation_business_cooperation_headline":"合作商戶","about_investment_investment_headline":"投資GoGoVan","about_investment_investment_desc":["GoGoVan 提供了一個投資亞洲、以至全球物流服務的平台。2013年成立至今，我們已涉足香港、新加坡、韓國、中國內地及台灣的物流市場，亦正迅速向全球擴展。如果您喜歡 GoGoVan 並希望投資我們的全球擴展計劃，歡迎聯絡 GoGoVan，讓我們一起改變物流未來。","聯絡我們: <a href='mailto:info@gogovan.hk'>info@gogovan.hk</a>"],"about_hire_hire_headline":"想在 GoGoVan 工作？","about_hire_job_opportunity":"工作機會","meta":{"description":"投資GoGoVan或成為Call Van平台合作夥伴。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:image":"/img/aboutus-banner.jpg","og:title":"關於 Call Van平台 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/about","og:description":"投資GoGoVan或成為Call Van平台合作夥伴。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台商務合作 | GoGoVan 香港","business_hero_headline":"GOGO企業","business_hero_body":"車隊管理 前所未有般容易","business_register_btn":"立即登記","business_features_headline":"讓您走多一步","business_features":[{"headline":"月結服務","body":"叫車無需再用現金，您可以使用月結服務，一筆過支付所有叫車開支。"},{"headline":"清晰電子帳單","body":"所有叫車費用，連同隧道費，停車場等雜費開支，清楚記錄在月結單，一目了然。"},{"headline":"簡易管理","body":"每位員工都可以在企業帳戶下設立不同的使用者戶口，管理帳目的同事可以簡單知道所有訂單的進度及狀態。"}],"business_advantages":[{"section_class":"business-advantage blue-section","headline":"龐大車隊","body":"超過二萬位專業司機，只需數秒便能指派司機，為您的業務帶來無限方便。"},{"section_class":"business-advantage","headline":"靈活擴展業務","body":"<a class=\"blue\">GOGOVAN</a>能為您提供彈性的物流方案，方便您的業務。即使遇上叫車高峰期，您也能輕鬆叫車。我們已成功配對超過10,000,000張訂單，無論建築材料、食物甚至花束，<a class=\"blue\">GOGOVAN</a>亦能提供即日送貨。"},{"section_class":"business-advantage blue-section","headline":"全天候支援","body":"<a class=\"blue\">GOGOVAN</a>的銷售專員全面了解您的需要，能為您解答任何疑難。GOGO企業專線全程投入為您服務。"}],"business_contact_headline":"立即登記GOGO企業","business_contact_thank_you":"多謝您的登記，稍後將有專人與貴公司聯絡。<br />如有任何疑問，歡迎隨時致電GOGO企業專線 | <a href=\"tel:35908975\" class=\"blue\">3590 8975</a><br /> 或 電郵至： <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a><br />","business_contact_body":"請填妥此登記表格，稍後將有專人與貴公司聯絡。<br />如有任何疑問，歡迎隨時致電GOGO企業專線    | <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> 或 電郵至： <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a><br />","business_contact_input_name":"姓名 *","business_contact_input_contact_number":"電話號碼*","business_contact_input_email":"電郵地址*","business_contact_input_company_name":"公司名稱*","business_contact_input_company_address":"商業地址","business_contact_input_company_website":"公司網址*","business_contact_input_company_size":"公司人數","business_contact_input_industry":"行業*","business_contact_submit_btn":"發送","business_business_client_headline":"企業客戶","meta":{"description":"使用GoGoVan，選擇適合您的包鐘，包月服務及訂制貨Van服務。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台商務合作 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/business","og:description":"使用GoGoVan，選擇適合您的包鐘，包月服務及訂制貨Van服務。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"title":"企業服務申請 | GoGoVan 香港","business_services_registration_section_title":"企業服務申請","business_services_registration_content":"如有任何建議或意見，請填寫此表格，我們將會儘快與您聯繫。","business_services_registration_label_email":"電郵","business_services_registration_label_hotline":"電話","business_services_registration_input_company_name":"公司名稱*","business_services_registration_input_name":"聯絡人名稱*","business_services_registration_input_phone":"聯絡人電話*","business_services_registration_input_email":"聯絡人電郵*","business_services_registration_input_address":"聯絡地址","business_services_registration_input_warehouse_address":"貨倉地址 (如適用)","business_services_registration_input_company_industry":"公司業務","business_services_registration_input_company_industry_items":["飲食","建築","寵物","批發","娛樂","電子","其他"],"business_services_registration_input_vehicle_type":"車種 (可選多項)*","business_services_registration_input_vehicle_type_items":["客貨van","5.5噸貨車","9噸貨車"],"business_services_registration_input_frequency_of_service":"送貨頻率","business_services_registration_input_frequency_of_service_items":["每日一次","每週一次","其他"],"business_services_registration_input_type_of_goods":"貨物種類*","business_services_registration_input_type_of_goods_items":["植物","一般貨箱","易碎產品","印刷品","家俬","建材","動物","廢料","電子產品","食物(乾貨)","食物(濕貨)","其他"],"business_services_registration_input_budget":"大概每月費用預算 (如適用)","business_services_registration_button_send":"發送","business_services_registration_thankyou_message":"謝謝你的申請，我們會在數天內回覆並作出安排"}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"title":"聯絡我們 | GoGoVan 香港","contact_section_title":"聯絡我們","contact_content":"如有任何建議或意見，請填寫此表格，我們將會儘快與您聯繫。","contact_label_email":"電郵","contact_label_hotline":"電話","contact_business_hotline":"3590-8975","contact_business_title":"GOGO企業客戶專線","contact_business_content":"如對GOGO企業有任何疑問，歡迎與我們的專業物流顧問聯絡。<br />服務時間: <a class=\"blue\">週一至週六 09:00-18:00</a>","contact_input_name":"姓名","contact_input_email":"電郵","contact_input_title":"標題","contact_input_message":"您的留言","contact_button_send":"發送","contact_thankyou_message":"多謝您的留言，我們將會儘快與您聯繫。","meta":{"description":"GoGoVan擁有全香港最大的貨Van車隊。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:image":"/img/aboutus-banner.jpg","og:title":"聯絡我們 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"GoGoVan擁有全香港最大的貨Van車隊。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van常見問題 | GoGoVan 香港","faq_headline":"常見問題","faq_other_questions":"如您遇到的問題不在上述常見問題中，請致電GoGoVan <a href='tel:3590-3399'>3590 3399</a> 查詢。","faq_questions":[{"question":"不清楚上貨或落貨地點屬於哪一區？","answer":"如「分區選擇」中找不到您想選擇的地點，我們建議您選擇「地圖」模式，在地圖中定位確切位置。"},{"question":"我急需用車，但找不到司機怎辦？","answer":"繁忙時段可能沒有司機接單。我們建議您在尋找司機時選擇支付「小費」，提高接單的吸引力，有機會更快找到司機。"},{"question":"為何有些地點會跟報價有誤差?","answer":"有一些地點屬偏遠地區，例如烏蛟騰、梧桐寨、下白泥等，價錢與收費表有輕微誤差。我們建議您上車前與司機了解情況，確認路程費。您亦可致電GoGoVan查詢。"},{"question":"APP 上的車費報價有計算隧道費在內嗎?","answer":"APP上的車費報價不包括隧道費。詳細的隧道收費請查閱收費表中<a href='pricing#tunnels'>「隧道費與橋費」</a>一欄。"},{"question":"為何貨車車牌跟APP上顯示的司機資料不一樣?","answer":"GoGoVan絕對不容許「派單」行為。如貨Van或貨車車牌與APP上顯示的司機資料不一致時，請立即致電GoGoVan。"},{"question":"如司機沒有溝通下嚴重遲到或沒有出現可以怎辦?","answer":"請致電GoGoVan說明，GoGoVan將為您重新安排車輛。"},{"question":"如我想在司機確認柯打後改變主意取消/換車或更改地點怎辦?","answer":"如果您打算取消或更改行程，請與司機聯絡並取得共識。司機會很樂意為您提供最佳的處理方法。"},{"question":"我不清楚自己的貨會否太多載不下?","answer":"GoGoVan提供不同車種以滿足不同的載重或體積要求。一般客貨Van能載貨1噸，貨物長度如超過6呎，請在下單時算擇「貨物超過6呎長」選項。如果您不確定選擇哪一款車，請參考<a href='service'>服務說明</a>。或在上貨前提早向司機查詢。"},{"question":"怎樣可以補發柯打記錄?","answer":"柯打記錄是詳細記錄您某一次柯打路線、時間、車費等信息的表格。如您想補發柯打記錄，請在螢幕左上方按目錄 (icon) >柯打記錄>然後選取你想看的記錄，在右上方按 <img class='icon-email' srcset='/img/icon_email.png 1x, /img/icon_email@2x.png 2x'> / <img class='icon-sendto' srcset='/img/icon_send_to.png 1x, /img/icon_send_to@2x.png 2x'>。你便可以填上你想收取柯打記錄的電郵地址。"},{"question":"確認柯打後，看到司機資料應怎麼辦？","answer":"看到司機資料，証明該司機已接到您的柯打，您只需耐心等待司機的電話，與他確定上落貨地點即可。"},{"question":"如果沒有我想要的車種怎辦？","answer":"如您需要16噸貨車等其它車種，請致電GoGoVan，我們會盡量幫您安排。"},{"question":"GoGoVan營業時間？","answer":"我們的APP為24小時運作。只要您需要Call Van服務，任何時候都可以透過APP落柯打。如透過電話叫車或有其他查殉，請於星期一至日早上7點到晚上12點致電GoGoVan。"},{"question":"叫車記錄會儲存多久？","answer":"除非卸載手機程式，叫車記錄會一直儲存在你的手機中。"}],"meta":{"description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van常見問題 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"index_newsletter_subscriptions":{"form":{"url":"https://docs.google.com/forms/d/1QEoHvQoPPazw3h904pjQGVL_-0sPKqfVwD8KZyAilbw","name_email":"entry.2018695432"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"title":"使用條款 | GoGoVan 香港","legal_headline":"條款及條件"}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/zh_hk_content"}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台收費表 | GoGoVan 香港","pricing_hero_quoting_headline":"想報價？","pricing_hero_quoting_content":"試試我們的網上報價功能！只需輸入起點及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"收費透明，使用安心","pricing_headline_content":"GoGoVan 的收費通指基本路程費用。不同情況下可能會產生附加服務費、隧道費或停車場費等。現在就對照價目表，查看報價吧。","pricing_quoting_header":"網上報價","pricing_pricing_table_header":"下載價目表","pricing_pricing_table_quoting_header":"網上報價","pricing_pricing_table_van":"貨Van","pricing_pricing_table_5.5ton_truck":"5.5噸貨車","pricing_pricing_table_9ton_truck":"9噸貨車","pricing_pricing_table_item":"項目","pricing_pricing_table_vehicles_and_pricing":"車種及收費","pricing_pricing_table_pricing_header":"下載價目表","pricing_pricing_table_pricing_button_download":"下載價目表","pricing_additionals_header":"附加服務費","pricing_additionals_content":"（以每單計）","pricing_additionals_head_items":["項目","貨Van","5.5噸貨車","9噸貨車"],"pricing_additionals_head_items_mobile":["項目","車種及收費"],"pricing_additionals_need_english_title":"英語司機","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"貨物長度超過6呎","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"貨物長度超過6呎，而且高度超過2呎","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"租用手推車／板車","pricing_additionals_need_cart_price":["每部$10（無限次使用）","-","-"],"pricing_additionals_need_tailgate_title":"租用唧車","pricing_additionals_need_tailgate_price":["-","每部$20（無限次使用）","每部$20（無限次使用）"],"pricing_additionals_need_carry_title":"幫搬","pricing_additionals_need_carry_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_need_pet_title":"接載寵物","pricing_additionals_need_pet_price":["$10（不論隻數）","$10（不論隻數）","$10（不論隻數）"],"pricing_additionals_need_waste_title":"運載泥頭／建築廢料","pricing_additionals_need_waste_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_enter_landfills_title":"進入堆填區","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"進入建築地盤","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多層停車場或貨倉","pricing_additionals_carpark_price":["第三層起每層 $3<br />（例: 第四層$6，第六層$12）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）"],"pricing_additionals_overtime_title":"超時等候","pricing_additionals_overtime_price":["首15分鐘: 免費;<br />超時每5分鐘: 10元;<br />如有中途點，每點首5分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費"],"pricing_additionals_passenger_count_title":"跟車人數","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免費；3個或以上+$20","最多5人；首2人免費；3個或以上+$20"],"pricing_additionals_night_title":"夜間（21:00 - 23:59）附加費","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加費","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"星期日及公眾假期（07:00 - 20:59）附加費*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*如在星期日及公眾假期的夜間/凌晨時段上貨，司機只收取夜間/凌晨附加費，不再另外收取星期日及公眾假期附加費。例：貨Van星期日21:30上貨，特別時段附加費為$30；星期日03:00上貨，特別時段附加費為$80。","pricing_tunnels_header":"隧道費及橋費","pricing_tunnels_content":"（以每次計，實報實銷）","pricing_tunnels_head_items":["項目","貨Van/5.5噸貨車","9噸貨車"],"pricing_tunnels_head_items_mobile":["項目","車種及收費"],"pricing_tunnels_cross_harbour_title":"紅磡隧道","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"東區隧道","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"西區隧道","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"青馬隧道／青嶼幹線","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"大欖隧道","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"將軍澳隧道","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"城門隧道","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"尖山隧道／沙田嶺隧道","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"獅子山隧道","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"珀麗灣專區橋費（10:00 - 16:00）","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"愉景灣隧道（09:00-18:00）","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"愉景灣入閘登記費","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"停車場費","pricing_carpark_content":"（以每次計，實報實銷）","pricing_carpark_discovery_bay_title":"愉景灣停車場","pricing_carpark_discovery_bay_price":["首2小時：免費<br />第3小或以內：$100<br />第3小時之後每小時：$200"],"pricing_carpark_hkia_3_title":"機場三號停車場","pricing_carpark_hkia_3_price":["每小時$16"],"pricing_carpark_hkia_1_2_title":"機場一號及二號停車場／落貨區","pricing_carpark_hkia_1_2_price":["首30分鐘：$40<br />次30分鐘：$60<br />其後每30分鐘：$80"],"meta":{"description":"查詢GoGoVan基本路程收費及附加服務費。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 收費表","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查詢GoGoVan基本路程收費及附加服務費。","og:type":"website","og:site_name":"GoGoVan 香港"},"pricing_header_headline":"司機收取總金額＝車費＋雜項收費（如適用）","pricing_header_surcharges":"雜項收費:","pricing_header_additional_charges":"附加服務費","pricing_header_tunnel_tolls_and_bridge_tolls":"隧道費及橋費","pricing_header_parking_fees":"停車場費","pricing_header_dangerous_goods":"危險品收費","pricing_header_refer":"有關雜項收費請參閱以下價目表, 並與司機確認總金額。","pricing_header_enquiry":"如有任何疑問, 歡迎致電GoGoVan 查詢。","pricing_header_tel_no":"","pricing_dangerous_goods_dangerous_goods":"危險品","pricing_dangerous_goods_title":["種類","限制數量","收費方法"],"pricing_dangerous_goods_fire_extinguishers":["滅火筒","無限","免加收費"],"pricing_dangerous_goods_acetylene_cylinder":["風煤樽","2樽","超額收$10/樽"],"pricing_dangerous_goods_refrigerant":["雪種","1樽","超額收$10/樽"],"pricing_dangerous_goods_nitrogen":["氮氣","1樽","超額收$10/樽"],"pricing_dangerous_goods_journey_fare_table":"路程收費表","pricing_dangerous_goods_hk_hk":"香港-香港","pricing_dangerous_goods_hk_kln":"香港-九龍","pricing_dangerous_goods_hk_nt":"香港-新界","pricing_dangerous_goods_kln_kln":"九龍-九龍","pricing_dangerous_goods_kln_nt":"九龍-新界","pricing_dangerous_goods_nt_nt":"新界-新界","pricing_vehicle_dropdown_van":"貨Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5噸貨車","pricing_vehicle_dropdown_ton_truck_9":"9噸貨車"}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"title":"更改密碼 | GoGoVan 香港","password_headline":"更改密碼","password_email":"電郵地址","password_password":"新密碼","password_confirm_password":"確認密碼","password_button_request_reset":"要求重設密碼","password_button_submit":"更改密碼","password_respond":"已更改密碼，請檢查電郵確認。","password_email_not_found":"你的電郵沒有被登記。請先<a href=\"#register\" class=\"global-text-blue dialog\">註冊</a>。","password_error_password_length":"您的密碼不足8位","password_error_password_equal":"對不起，兩次輸入的密碼並不相同。","password_error_token_expired":"此更改密碼連結已過時。"}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台收費表 | GoGoVan 香港","pricing_hero_quoting_headline":"想報價？","pricing_hero_quoting_content":"試試我們的網上報價功能！只需輸入起點及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"收費透明，使用安心","pricing_headline_content":"GoGoVan 的收費通指基本路程費用。不同情況下可能會產生附加服務費、隧道費或停車場費等。現在就對照價目表，查看報價吧。","pricing_quoting_header":"網上報價","pricing_pricing_table_header":"下載價目表","pricing_pricing_table_quoting_header":"網上報價","pricing_pricing_table_van":"貨Van","pricing_pricing_table_5.5ton_truck":"5.5噸貨車","pricing_pricing_table_9ton_truck":"9噸貨車","pricing_pricing_table_item":"項目","pricing_pricing_table_vehicles_and_pricing":"車種及收費","pricing_pricing_table_pricing_header":"下載價目表","pricing_pricing_table_pricing_button_download":"下載價目表","pricing_additionals_header":"附加服務費","pricing_additionals_content":"（以每單計）","pricing_additionals_head_items":["項目","貨Van","5.5噸貨車","9噸貨車"],"pricing_additionals_head_items_mobile":["項目","車種及收費"],"pricing_additionals_need_english_title":"英語司機","pricing_additionals_need_over_6ft_title":"貨物長度超過6呎","pricing_additionals_need_over_6ft_half_net_title":"貨物長度超過6呎，而且高度超過2呎","pricing_additionals_need_cart_title":"租用手推車／板車","pricing_additionals_need_cart_price":["每部$10（無限次使用）","每部$10（無限次使用）","每部$10（無限次使用）"],"pricing_additionals_need_tailgate_title":"租用唧車","pricing_additionals_need_tailgate_price":["每部$20（無限次使用）","每部$20（無限次使用）","每部$20（無限次使用）"],"pricing_additionals_need_carry_title":"幫搬","pricing_additionals_need_carry_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_need_pet_title":"接載寵物","pricing_additionals_need_pet_price":["$10（不論隻數）","$10（不論隻數）","$10（不論隻數）"],"pricing_additionals_need_waste_title":"運載泥頭／建築廢料","pricing_additionals_need_waste_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_enter_landfills_title":"進入堆填區","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"進入建築地盤","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多層停車場或貨倉","pricing_additionals_carpark_price":["第三層起每層 $3<br />（例: 第四層$6，第六層$12）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）"],"pricing_additionals_overtime_title":"超時等候","pricing_additionals_overtime_price":["首15分鐘: 免費;<br />超時每5分鐘: 10元;<br />如有中途點，每點首5分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費"],"pricing_additionals_passenger_count_title":"跟車人數","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免費；3個或以上+$20","最多5人；首2人免費；3個或以上+$20"],"pricing_additionals_night_title":"夜間（21:00 - 23:59）附加費","pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加費","pricing_additionals_sunday_title":"星期日及公眾假期（07:00 - 20:59）附加費*","pricing_additionals_remark":"*如在星期日及公眾假期的夜間/凌晨時段上貨，司機只收取夜間/凌晨附加費，不再另外收取星期日及公眾假期附加費。例：貨Van星期日21:30上貨，特別時段附加費為$30；星期日03:00上貨，特別時段附加費為$80。","pricing_tunnels_header":"隧道費及橋費","pricing_tunnels_content":"（以每次計，實報實銷）","pricing_tunnels_head_items":["項目","貨Van/5.5噸貨車","9噸貨車"],"pricing_tunnels_head_items_mobile":["項目","車種及收費"],"pricing_tunnels_cross_harbour_title":"紅磡隧道","pricing_tunnels_eastern_title":"東區隧道","pricing_tunnels_western_title":"西區隧道","pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tsing_ma_title":"青馬隧道／青嶼幹線","pricing_tunnels_tai_lam_title":"大欖隧道","pricing_tunnels_tseung_kwan_o_title":"將軍澳隧道","pricing_tunnels_shing_mun_title":"城門隧道","pricing_tunnels_eagle_nest_title":"尖山隧道／沙田嶺隧道","pricing_tunnels_lion_rock_title":"獅子山隧道","pricing_tunnels_park_island_daytime_title":"珀麗灣專區橋費（10:00 - 16:00）","pricing_tunnels_discovery_bay_daytime_title":"愉景灣隧道（09:00-18:00）","pricing_tunnels_discovery_bay_road_title":"愉景灣入閘登記費","pricing_carpark_header":"停車場費","pricing_carpark_content":"（以每次計，實報實銷）","pricing_carpark_discovery_bay_title":"愉景灣停車場","pricing_carpark_discovery_bay_price":["首2小時：免費<br />第3小或以內：$100<br />第3小時之後每小時：$200"],"pricing_carpark_hkia_3_title":"機場三號停車場","pricing_carpark_hkia_3_price":["每小時$16"],"pricing_carpark_hkia_1_2_title":"機場一號及二號停車場／落貨區","pricing_carpark_hkia_1_2_price":["首30分鐘：$40<br />次30分鐘：$60<br />其後每30分鐘：$80"],"meta":{"keywords":"價錢,收費,電召,電話,gogovan 電話,gogovan電話,平,最平,至抵, 抵,gogovan 收費,go go van 價錢,gogo van 貨車收費表,收費表,報價,電召客貨車收費表,gogovan 夜間收費,送貨報價,搬運,報價物流報價,包鐘,包月","description":"查詢GoGoVan Call Van服務基本路程收費及附加服務費。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台收費表 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查詢GoGoVan Call Van服務基本路程收費及附加服務費。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = {"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}}}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"title":"隱私條款 | GoGoVan 香港","privacy_headline":"Privacy Policy"}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/en_hk_content"}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 個人資料","section_profile_title":"個人資料","section_profile_photo":"頭像","section_profile_set_picture":"變更","section_profile_password":"密碼:","section_profile_password_change":"變更","section_profile_info":"基本資料","section_profile_address":"地址","section_profile_logout":"登出","section_profile_update":"儲存"}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 報價 | GoGoVan 香港","dollar_code":"$","quoting_first_input":"起點","quoting_last_input":"目的地","quoting_get_btn":"查詢報價","quoting_clear_btn":"清除","quoting_service_title":"選擇車種","quoting_price_prefix":"","quoting_price_postfix":" 起","quoting_service_select_btn":"選擇","quoting_place_order_btn":"即刻落單","quoting_download_app_title":"下載 GoGoVan","quoting_service_van_title":"貨VAN","quoting_service_van_body":"最多可載5人 (不包括司機)；載重約700公斤；內籠尺寸約為長5.5呎、高4呎、闊4呎。","quoting_service_5ton_title":"5.5噸貨車","quoting_service_5ton_body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","quoting_service_9ton_title":"9噸貨車","quoting_service_9ton_body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","order_restricted_area_warning":"<h2>禁區提示</h2><br />下列地點僅限持有有效許可證人士進出","order_restricted_area_ps":"如您沒有有效許可證，車費需與司機另議。GOGOVAN 會有專員提供協助，詳情請致電 <span>35903399</span>  查詢。","order_restricted_area_error_message":"地點僅限持有有效許可證⼈⼠進出","order_restricted_area_error_message_no_services":"您所選擇的地點不在服務範圍中","order_restricted_area_have_lincense":"我持有有效許可證","order_restricted_area_question":"沒有許可證","order_restricted_area_question_title":"沒有許可證?","order_restricted_area_confirm":"我知道了","order_restricted_area_out_ps":"您所選擇的地點不在服務範圍內，GOGOVAN 會有專員提供協助，詳情請致電 <span>35903399</span> 查詢。","meta":{"description":"查詢港島-九龍-新界送貨Call Van 報價","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 報價 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"查詢港島-九龍-新界送貨Call Van 報價","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 服務 | GoGoVan 香港","service_content_headline":"服務說明","service_content_contents":["GoGoVan 提供不同車種和多項附加服務*。叫車時加選附加服務，在確保服務質素的同時，亦能提高運輸效率。","*部分服務有附加收費。"],"service_content_photos_title_0":"跟車送運","service_content_photos_title_1":"貨物運載","service_content_photos_title_2":"寵物接送","service_content_photos_title_3":"家居搬運","service_content_photos_title_4":"倉庫提存","service_content_photos_title_5":"建材運送","service_content_photos_body_0":"私家車容不下的大量行李或貨物，我們幫您連人帶貨送到目的地。","service_content_photos_body_1":"根據您的貨物規格，選派最匹配的車款。","service_content_photos_body_2":"一路上，我們將給予您的寵物最貼心的照料。不論隻數，每程的價錢都一樣。","service_content_photos_body_3":"根據您的傢俬尺寸和數量選擇最合適的車種，可另選司機幫搬服務。","service_content_photos_body_4":"只需您的一個遠程遙控，我們便可到不同的倉庫為您提存貨物。","service_content_photos_body_5":"不同建材有不同的運輸方式，我們為您設計專業運送方案。","service_content_fleets_header":"車種","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"貨Van","service_content_icon_ser_van_body":"最多可載5人 (不包括司機)；載重約700公斤；內籠尺寸約為長5.5呎、高4呎、闊4呎。","service_content_icon_ser_10ftlorry_title":"5.5噸貨車","service_content_icon_ser_10ftlorry_body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","service_content_icon_ser_14ftlorry_title":"9噸貨車","service_content_icon_ser_14ftlorry_body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","service_content_additional_header":"附加服務","service_content_english_speaking_driver_title":"英語司機","service_content_english_speaking_driver_body":"要求司機可使用英語對話。","service_content_goodsg_longer_than_6ft_title":"貨物超過6呎長","service_content_goodsg_longer_than_6ft_body":"如貨物長度超過6呎，但重量不足700公斤，建議選擇車種為「貨Van」，再選擇該項附加服務。貨Van內籠經調節後可加長至8呎。如您的貨物長度超過6呎、而且高度超過2呎，建議在選單中選擇「超過半網高度」。","service_content_borrow_carts_title":"租用手推車／板車","service_content_borrow_carts_body":"手推車／板車為輔助搬貨、運貨的工具。手推車通常為鐵質材料，有手柄，適用於運送體積較小、件數較多的貨物，如紙皮箱等。板車為木板材質，適用於運送單件、體積較大的貨物，如大型衣櫃等。","service_content_forklift_rental_title":"租用唧車","service_content_forklift_rental_body":"唧車為輔助搬貨、運貨的工具，可手動升降貨物高度，適用於使用5.5噸貨車或9噸貨車運送的貨物。","service_content_mover_title":"幫搬","service_content_mover_body":"如您需要司機幫您搬貨，請在上貨前列明貨物種類及數量，並與司機議價。","service_content_pets_title":"接載寵物","service_content_pets_body":"可接送您的寵物。不限隻數。","service_content_new_vehicle_title":"新車","service_content_new_vehicle_body":"為您優先安排較新的貨Van或貨車。","service_content_dumper_construction_waste_title":"運載泥頭／建築廢料","service_content_dumper_construction_waste_body":"如您需要運載工業建築廢料，而且廢料的體積、重量在車輛載重範圍之內，請選擇該項附加服務。","service_content_hourly_header":"包鐘","service_content_hourly_rental_body":"若用戶租用貨Van或貨車超過三小時，建議使用包鐘服務， 車費以每半小時為單位計算。包鐘較適用於同一個柯打中有多個中途點，或路程中需要較長等候時間的情況。","meta":{"keywords":"物流O2O,物流,貨運,運輸,速遞,速遞公司,物流公司,物流方案,搬運,搬貨,送貨,提貨,運貨,即日送貨,派貨服務,月結收費,收件送件,貨物交收,入倉,派貨,包鐘貨運,包月貨運,物流訂製,物流合作,運輸合作,建材運送,五金建材,裝修,五金,建材,音響器材搬運,裝修工具運送,器材搬運,入展,會展,大學搬Hall,大學入宿,大學退宿,退宿,入宿","description":"GoGoVan Call Van 服務包括搬屋、寵物接送、搬貨、建材運送、倉庫提存等貨van物流服務。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 服務 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/service","og:description":"GoGoVan Call Van 服務包括搬屋、寵物接送、搬貨、建材運送、倉庫提存等貨van物流服務。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"en-hk-full":"en-hk","zh-hk-full":"zh-hk"}}}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 新的柯打 | GoGoVan 香港","meta":{"keywords":"客貨車,貨van,van仔,貨車,5.5噸貨車,5.5噸,5噸半,尾板車,尾板貨車,街斗,9噸貨車,16噸貨車,密斗車,密斗尾板車,預約貨車,call尾板貨車,尾板貨車租賃,楂5.5噸貨車,貨車尺寸,貨車容量,貨Van容量,貨Van尺寸,貨Van載重,貨van內籠,貨車升降台,貨van高度,貨車高度","description":"新的柯打","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 新的柯打 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/order","og:description":"新的柯打","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 新的柯打 | GoGoVan 香港","meta":{"keywords":"客貨車,貨van,van仔,貨車,5.5噸貨車,5.5噸,5噸半,尾板車,尾板貨車,街斗,9噸貨車,16噸貨車,密斗車,密斗尾板車,預約貨車,call尾板貨車,尾板貨車租賃,楂5.5噸貨車,貨車尺寸,貨車容量,貨Van容量,貨Van尺寸,貨Van載重,貨van內籠,貨車升降台,貨van高度,貨車高度","description":"新的柯打","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 新的柯打 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/order","og:description":"新的柯打","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = {"title":"Instant Delivery","about_gogovan_sub_headline":"Redefining the everyday logistic experience","about_help_help_headline":"Help us redefine the world of logistics","about_help_help_desc":["GoGoVan is growing rapidly, and we are always looking for investors to support our global expansion. If you would like to invest in a revolutionary logistic service, please get in touch!","<a href='info@gogovan.co.in' class='blue'>info@gogovan.co.in</a>"],"about_gogovan_body":["Established in 2013, GoGoVan is the first app-based platform for transporting goods in Asia. The app GoGoVan was created to connect drivers and customers, and we aim to redefine the everyday logistics experience by providing a convenient and efficient service.","Since its successful July 2013 launch in Hong Kong, GoGoVan has expanded to Singapore, South Korea, China, India, and Taiwan. The GoGoVan network currently comprises of over 20,000 commercial vehicles and 70,000 registered drivers. It continues to grow rapidly, and our presence will soon encompass additional cities on a global scale."],"meta":{"description":"We are an app based, on demand logistics service, operating in Singapore since 2014 with a fleet of over 4000 drivers","og:image":"/img/aboutus-banner.jpg","og:title":"Instant Delivery","og:url":"{{SITE_HTTP_URL}}/about","og:description":"We are an app based, on demand logistics service, operating in Singapore since 2014 with a fleet of over 4000 drivers","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_hire","prefix":"about_hire"}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = {"title":"Customised Solutions for your business","contact_us":"CONTACT US","business_headline_content_headline":"Business Corporation Package","business_headline_content_sub_headline":"Take your business further with GoGoVan","business_headline_contents":["From point to point deliveries and store distributions to van rental services, GoGoVan provides a wide range of logistics services that are designed to help your business grow.","We have both short term and long term options that will help make your work more efficient."],"business_customized_header":"Customized Plan","business_customized_content":["If our hourly rental or monthly plan still doesn’t fit your needs, we are more than happy to tailor-make a service just for you."],"business_partnership_header":"Business Partnership","business_partnership_content":["From small businesses to large multinational companies, we have the flexibility and strength to help you grow your business!","eCommerce API: Is your business online? We have a fully integrateable API that offers a reliable and affordable “plug and play” same day delivery option.","Fleet Management: Logistics companies can integrate their own fleets on our platform to increase their fulfilment rates, fully utilizing their resources and increase their customer base."],"business_investor_header":"Investor","business_investor_content":["Be a part of the logistics revolution!","GoGoVan provides an opportunity for you to invest in a global logistics company. We are rapidly expanding to all parts of the world including Hong Kong, Singapore, South Korea, China, India and Taiwan. If you like GoGoVan and would like to help fund our global expansion, get in touch!"],"meta":{"description":"We provide customised packages, detailed invoicing and continuous support to your business, no matter if you are an MNC, a SME or for one time events","og:image":"/img/aboutus-banner.jpg","og:title":"Customised Solutions for your business","og:url":"{{SITE_HTTP_URL}}/business","og:description":"We provide customised packages, detailed invoicing and continuous support to your business, no matter if you are an MNC, a SME or for one time events","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"customized","offset":"-114"},{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_customized"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_customized":{"id":"customized","buttons":[{"link":"contact","title":"contact_us"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {"title":"Get in touch or Contact us","contact_hotline":"044-45534533","contact_hotline_link":"04445534533","meta":{"description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:image":"/img/aboutus-banner.jpg","og:title":"Get in touch or Contact us","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Cr8v0RlYwMlj-noWOidOcetI4O77r30fkMNIp-zCgwA","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"}}}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"title":"Frequently asked questions","faq_headline":"FAQ / Help Center","faq_other_questions":"Please call GoGoVan at <a href='tel:04445534533'>044-45534533</a> to inquire about any questions you may have that are not mentioned above.","faq_questions":[{"question":"How many types of vehicles does GoGoVan provide?","answer":"Our vehicle fleet includes Tata ace vans, Tata Super Ace, Ashok Leyland - Dost, Mahindra Bolero Pickup, Tata 407 (10 feett) and Eicher (14 feet). If you'd like a 16 ton truck or other vehicle types, please call GoGoVan and we will arrange everything accordingly."},{"question":"What if my location does not appear on the given list?","answer":"If your location is not listed, please choose the location nearest to you. For an updated quote, confirm your location with your designated driver once he or she responds. Alternatively, contact us to inquire about the fee for a particular route."},{"question":"What is included in the price shown in the GoGoVan app?","answer":"The price displayed in the app is the basic route fee. It does not include tolls, parking fees, or other additional charges. For more information, please refer to the price list in the app."},{"question":"Why does the app show “Searching driver, the information of driver will be updated in a new page” after I have confirmed my order?","answer":"After you confirm an order, the app displays this message as the GoGoVan system automatically notifies drivers in your area. Once a driver responds to your order, you will be taken to a new page with contact information for your driver."},{"question":"What should I do after I’m given my driver’s contact information?","answer":"If you are given the contact information for a driver, it means he or she has already responded to your order and will call you for confirmation on the details."},{"question":"For how long will my order be saved in the GoGoVan system?","answer":"All order records are saved and will not be deleted even after an order has been completed."},{"question":"How can I get a receipt for my order?","answer":"You can screenshot your order in the app and email it as an attachment to <a href='mailto:info@gogovan.co.in'>info@gogovan.co.in</a>"},{"question":"How can I contact GOGOVAN?","answer":"If you have any inquiries, please feel free to contact us at <a href='tel:04445534533'>044-45534533</a> or <a href='mailto:info@gogovan.co.in'>info@gogovan.co.in</a>"},{"question":"What are GOGOVAN’s business hours?","answer":"Our app works 24 hours a day and you can place an order at any time. If you would like to place an order by phone, please call us at <a href='tel:04445534533'>044-45534533</a> from 9am to 9pm everyday."}],"meta":{"description":"A comprehensive list of answers to any questions you might have about working with us! / Ask us anything!","og:image":"/img/aboutus-banner.jpg","og:title":"Frequently asked questions","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"A comprehensive list of answers to any questions you might have about working with us! / Ask us anything!","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"src":"dl_appstore.png","src_2x":"dl_appstore@2x.png","alt":"Appstore","height":"60"},"playstore":{"src":"dl_android_client_app_outline.png","src_2x":"dl_android_client_app_outline@2x.png","alt":"GoGoVan","height":"60"},"playstore_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined":{"src":"dl_android_client_app_outline.png","src_2x":"dl_android_client_app_outline@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"GoGoVan","height":"60"},"playstore_driver":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"GoGoVan Driver","height":"60"}}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = {"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":72,"height":69},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47,"alt":"Courier Service"},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":39,"alt":"Moving Service"},"icon_passengerservice":{"src":"icon_passengerservice.png","src_2x":"icon_passengerservice@2x.png","height":44,"alt":"Passenger Service"},"icon_deliveryservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":48,"alt":"Delivery Service"},"howitwork_step1":{"src":"step1.jpg","src_2x":"step1@2x.jpg","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"steps2.png","src_2x":"steps2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"steps3.png","src_2x":"steps3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"channel_newsasia":{"src":"media_channelnewsasia.png","src_2x":"media_channelnewsasia@2x.png","height":"50"},"e27":{"src":"media_e27.png","src_2x":"media_e27@2x.png","height":"30"},"ibt":{"src":"media_ibt.png","src_2x":"media_ibt@2x.png","height":"30"},"the_straits_times":{"src":"media_thestraitstimes.png","src_2x":"media_thestraitstimes@2x.png","height":"30"},"weekender":{"src":"media_weekender.png","src_2x":"media_weekender@2x.png","height":"30"},"tech_crunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":"30"},"wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":"30"}}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/kr/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_media":{"items":["channel_newsasia","e27","ibt","the_straits_times","weekender","tech_crunch","wsj"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Cr8v0RlYwMlj-noWOidOcetI4O77r30fkMNIp-zCgwA","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"background":"form_bg2.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms of Service and Usage (“Terms of use”)","legal_headline":"Terms of Service and Usage (“Terms of use”)","meta":{}}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/in_content"}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = {"title":"Make an order"}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_sg_ordering.html","blocks":[{"type":"sections/sg/order","prefix":"order"}],"body_class":"order-page","include_locales":["dashboard","service"],"ordering_header":{"left_menu":["dashboard","order"],"right_menu":["dashboard","sign_out"]},"order":{"button_apply":"APPLY","button_cancel":"CANCEL","button_add_image":"ADD IMAGE","button_goods_image":"IMAGES OF DELIVERY ITEMS","pick_up_time":"PICK UP TIME","total_amount":"Total","promo_code":"PROMO CODE?","order_confirm_button":"REVIEW ORDER","order_location_warning":"Please fill in all the missing information in red.","image_max_size":"MAX. 2MB","image_too_large_warning":"The image too large","hourly":{"title":"Hourly","desc":"包鐘係以時間作為單位之落單方式。","minimum":"每次最少3個鐘","detail_btn":"DETAIL","hours_for_select":[{"title":"3 hrs","value":"3"},{"title":"3.5 hrs","value":"3.5"},{"title":"4 hrs","value":"4"},{"title":"4.5 hrs","value":"4.5"},{"title":"5 hrs","value":"5"},{"title":"5.5 hrs","value":"5.5"},{"title":"6 hrs","value":"6"},{"title":"6.5 hrs","value":"6.5"},{"title":"7 hrs","value":"7"},{"title":"7.5 hrs","value":"7.5"},{"title":"8 hrs","value":"8"}]},"order_option":{"passenger":{"title":"PASSENGER","body":"Passenger"},"tunnel":{"title":"TUNNEL","tunnels":[{"title":"Any","tunnel_code":"any"},{"title":"Cross-Harbour Tunnel","tunnel_code":"hung"},{"title":"Western Harbour Crossing","tunnel_code":"western"},{"title":"Eastern Harbour Crossing","tunnel_code":"eastern"},{"title":"Lion Rock Tunnel","tunnel_code":"lion_rock"},{"title":"Tate's Cairn Tunnel","tunnel_code":"tates_cairn"},{"title":"Eagle's Nest Tunnel","tunnel_code":"eagles_nest"},{"title":"Tai Lam Tunnel","tunnel_code":"tai_lam"},{"title":"Aberdeen Tunnel","tunnel_code":"aberdeen"},{"title":"Tseung Kwan O Tunnel","tunnel_code":"tko"},{"title":"Tsing Ma Bridge","tunnel_code":"tm_bridge"},{"title":"Discovery Bay Tunnel","tunnel_code":"discovery"},{"title":"Shing Mun Tunnel","tunnel_code":"shing_mun"}]}},"route":{"title":"ROUTE","location_1_address_input":"Enter a Pickup Point","location_2_address_input":"Enter a Destination","view_on_map_button":"VIEW MAP","add_address_button":"Add a Location"},"passenger":{"title":"PASSENGERS","body":"PASSENGER"},"car_type":{"title":"VEHICLE TYPE","van":{"title":"VAN","body":"最多可載5人；載重約1噸／2200磅；內籠尺寸約為長6尺、高4尺、闊4尺。","price":"$20 起"},"5.5_ton_truck":{"title":"5.5 TON TRUCK","body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","price":"$45 起"},"9_ton_truck":{"title":"9 TON TRUCK","body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","price":"$25 起"}},"promo":{"promo_code_input":"Coupon Code / no #","warning_message":"請輸入有效的優惠卷編號"},"additional_service":{"title":"EXTRA SERVICES (OPTIONAL)","button_service_detail":"DETAIL","van":[{"title":"Goods longer than 6ft","service_code":"need_over_6ft","options":[{"title":"Half net ($10)","option_name":"remove_net","option_code":"half"},{"title":"Longer than half net ($20)","option_name":"remove_net","option_code":"full"}]},{"title":"Borrow cart(s) ($10)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]},{"title":"Pets ($10 unlimited)","service_code":"need_pet","options":[]},{"title":"New car","service_code":"need_new_car","options":[]},{"title":"Dumper ($ Quote by driver)","service_code":"need_waste","options":[]}],"5.5_ton_truck":[{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]}],"9_ton_truck":[{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]}]},"contact":{"title":"CONTACT INFO","name_input":"Name","phone_input":"Phone #","email_input":"Email","order_contact_warning":"Please fill in all the missing information in red.","order_contact_phone_warning":"Please input a valid phone number.","order_contact_email_warning":"Please fill in a valid email address"},"remark":{"title":"REMARKS (optional)","body":"Pickup Location’s landmark, number of luggages etc."},"order_summary":{"title":"Order summary","button_confirm_order":"FIND DRIVER","button_edit_order":"EDIT","button_price_table":"Tap here for fee details","button_show_order_detail":"VIEW ORDER DETAIL","button_hide_order_detail":"CLOSE ORDER DETAIL","button_cancel_order":"CANCEL ORDER","driver":{"title":"DRIVER INFO","body":"ASSIGNING DRIVER...","rate_driver_btn":"RATE DRIVER","block_driver_btn":"BLOCK"},"route":{"title":"ROUTE","view_on_map_button":"VIEW MAP"},"contact":{"title":"CONTACT INFO"},"pickup_time":{"title":"PICKUP TIME"},"vehicle":{"title":"VEHICLE TYPE"},"remark":{"title":"REMARKS"},"charge":{"title":"FEE BREAKDOWN","tips":"Bonus","total_amount":"TOTAL","button_why_tips":"(Optional)","coupon":"Coupon Discount"},"tips":{"title":"Why Give Bonus?"},"payment":{"title":"PAYMENT METHOD","message":"The above fees are calculated based on the closest pricing regions to your pickup / delivery points. They do not include ERP charges, car park fees and all other misc. fees. Please confirm with driver the total price on boarding.","button_price_table":"Tap here for fee details","method":"By Cash (to driver)"}},"popup_dialog":{"tips":{"title":"Why Give Bonus?","body":"Bonus can help attract more drivers to your booking, increasing the speed to your response. This can be useful if you want to make a booking during peak hours."}}}}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = {"title":"Price Information","pricing_headline_content":"","pricing_tata_ace_header":"Vehicle Type: TATA ACE","pricing_tata_ace_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_ace_item_prices":["Rs 200","Rs 25/Km","Rs 15/Km","Free for 60 Mins","Rs 2/min","Rs 400 for 1 person *","Rs 1000"],"pricing_tata_ace_time_based":"TIME BASED PRICING:","pricing_tata_ace_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_ace_time_based_hours":["2","4","6","8","10"],"pricing_tata_ace_time_based_km":["20","40","60","80","100"],"pricing_tata_ace_time_based_price":["500","900","1400","1800","2200"],"pricing_tata_ace_lists":["Extra Time: Rs 2/min","Extra Km: Rs 15/Km"],"pricing_tata_ace_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_tata_super_ace_header":"Vehicle Type: TATA SUPER ACE / ASHOK LEYLAND - DOST / MAHINDRA BOLERO PICKUP","pricing_tata_super_ace_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_super_ace_item_prices":["Rs 300","Rs 25/Km","Rs 18/Km","Free for 60 Mins","Rs 2/min","Rs 400 for 1 person *","Rs 1000"],"pricing_tata_super_ace_time_based":"TIME BASED PRICING:","pricing_tata_super_ace_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_super_ace_time_based_hours":["2","4","6","8","10"],"pricing_tata_super_ace_time_based_km":["20","40","60","80","100"],"pricing_tata_super_ace_time_based_price":["650","1050","1550","1900","2350"],"pricing_tata_super_ace_lists":["Extra Time: Rs 2/min","Extra Km: Rs 18/Km"],"pricing_tata_super_ace_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_tata_407_header":"Vehicle Type: TATA 407","pricing_tata_407_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_407_item_prices":["Rs 1200","Rs 30/Km","Rs 20/Km","Free for 120 Mins","Rs 4/min","Rs 500 for 1 person *","Rs 1600"],"pricing_tata_407_time_based":"TIME BASED PRICING:","pricing_tata_407_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_407_time_based_hours":["6","8","10"],"pricing_tata_407_time_based_km":["60","80","100"],"pricing_tata_407_time_based_price":["1800","2400","2800"],"pricing_tata_407_lists":["Extra Time: Rs 4/min","Extra Km: Rs 20/Km"],"pricing_tata_407_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_14_header":"Vehicle Type: EICHER 14 FEET","pricing_eicher_14_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_14_item_prices":["Rs 1500","Rs 30/Km","Rs 22/Km","Free for 120 Mins","Rs 4/min","Rs 500 for 1 person *","Rs 2000"],"pricing_eicher_14_time_based":"TIME BASED PRICING:","pricing_eicher_14_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_14_time_based_hours":["6","8","10"],"pricing_eicher_14_time_based_km":["60","80","100"],"pricing_eicher_14_time_based_price":["2000","2600","3000"],"pricing_eicher_14_lists":["Extra Time: Rs 4/min","Extra Km: Rs 22/Km"],"pricing_eicher_14_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_17_header":"Vehicle Type: EICHER 17 FEET","pricing_eicher_17_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_17_item_prices":["Rs 1800","Rs 35/Km","Rs 25/Km","Free for 180 Mins","Rs 6/min","Rs 500 for 1 person *","Rs 3000"],"pricing_eicher_17_time_based":"TIME BASED PRICING:","pricing_eicher_17_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_17_time_based_hours":["6","8","10"],"pricing_eicher_17_time_based_km":["60","80","100"],"pricing_eicher_17_time_based_price":["2500","3000","3500"],"pricing_eicher_17_lists":["Extra Time: Rs 6/min","Extra Km: Rs 25/Km"],"pricing_eicher_17_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_19_header":"Vehicle Type: EICHER 19 FEET","pricing_eicher_19_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_19_item_prices":["Rs 2200","Rs 40/Km","Rs 30/Km","Free for 180 Mins","Rs 6/min","Rs 500 for 1 person *","Rs 3000"],"pricing_eicher_19_time_based":"TIME BASED PRICING:","pricing_eicher_19_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_19_time_based_hours":["6","8","10"],"pricing_eicher_19_time_based_km":["60","80","100"],"pricing_eicher_19_time_based_price":["3000","3500","4000"],"pricing_eicher_19_lists":["Extra Time: Rs 6/min","Extra Km: Rs 30/Km"],"pricing_eicher_19_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_footer_content":"* Please contact our customer service directly at 044-45534533 for house shifting price quote."}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"400","items":[{"target":"tata_ace","offset":"-114"},{"target":"tata_super_ace","offset":"-114"},{"target":"tata_407","offset":"-114"},{"target":"eicher_14","offset":"-114"},{"target":"eicher_17","offset":"-114"},{"target":"eicher_19","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"vehicle_specific","vehicle_type":"tata_ace","prefix":"pricing_tata_ace"},{"type":"vehicle_specific","vehicle_type":"tata_super_ace","prefix":"pricing_tata_super_ace"},{"type":"vehicle_specific","vehicle_type":"tata_407","prefix":"pricing_tata_407"},{"type":"vehicle_specific","vehicle_type":"eicher_14","prefix":"pricing_eicher_14"},{"type":"vehicle_specific","vehicle_type":"eicher_17","prefix":"pricing_eicher_17"},{"type":"vehicle_specific","vehicle_type":"eicher_19","prefix":"pricing_eicher_19"},{"type":"pricing_footer","prefix":"pricing_footer"}]},"hero":"background-image: url(/img/pricing_banner_bg.jpg);","vehicle_types":{"tata_ace":{"name":"tata_ace"},"tata_super_ace":{"name":"tata_super_ace"},"tata_407":{"name":"tata_407"},"eicher_14":{"name":"eicher_14"},"eicher_17":{"name":"eicher_17"},"eicher_19":{"name":"eicher_19"}}}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy","privacy_headline":"Privacy Policy","meta":{}}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/in_content"}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = {"title":"Instant price quote","dollar_code":"₹","quoting_service_tata_ace_title":"TATA ACE","quoting_service_tata_ace_body":"Capacity: Up to 1 ton, Length: 6 feet","quoting_service_tata_super_ace_title":"TATA SUPER ACE","quoting_service_tata_super_ace_body":"Capacity: Up to 2 tons, Length: 7 feet","quoting_service_tata_407_title":"TATA 407","quoting_service_tata_407_body":"Capacity: Up to 3 tons, Length: 8-10 feet","quoting_service_eicher_14_title":"EICHER 14 FEET","quoting_service_eicher_14_body":"Capacity: Up to 4 tons, Length: 14 feet","quoting_service_eicher_17_title":"EICHER 17 FEET","quoting_service_eicher_17_body":"Capacity: Up to 5 tons, Length: 17 feet","quoting_service_eicher_19_title":"EICHER 19 FEET","quoting_service_eicher_19_body":"Capacity: Up to 6 tons, Length: 19 feet","quoting_remark":"For time based packages contact us at Hotline <a href=\"tel:044-45534533\" class=\"blue\">044-45534533</a> | <a href=\"tel:8939893968/04\" class=\"blue\">8939893968/04</a>"}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = {"icon_tata_ace_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"TATA ACE"},"icon_tata_ace_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"TATA ACE"},"icon_tata_super_ace_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"TATA SUPER ACE"},"icon_tata_super_ace_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"TATA SUPER ACE"},"icon_tata_407_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"TATA 407"},"icon_tata_407_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"TATA 407"},"icon_eicher_14_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 14 FEET"},"icon_eicher_14_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 14 FEET"},"icon_eicher_17_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 17 FEET"},"icon_eicher_17_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 17 FEET"},"icon_eicher_19_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 19 FEET"},"icon_eicher_19_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 19 FEET"}}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12 center","services":[{"type":"tata_ace","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton1"}},{"type":"tata_super_ace","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton2"}},{"type":"tata_407","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton3"}},{"type":"eicher_14","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton4"}},{"type":"eicher_17","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton5"}},{"type":"eicher_19","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton6"}}]}}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = {"title":"Our Services","service_content_headline":"Move Anything, Anywhere, Anytime.","service_content_content_subheadline":"Rely on us.","service_content_contents":["Request a driver online or through our mobile app and receive an instant quote. We place one of the largest fleets in India at your fingertips, ready for dispatch. Our drivers are punctual, professional, and flat-out awesome."],"service_content_fleets_header":"Our Fleet","service_content_fleets_subheader":"Our fleet of over 250 vehicles (and counting...) includes:","service_content_fleets_footer":"If you'd like a 10 tons truck or other vehicle types, please call our hotline and we will arrange everything accordingly.","service_content_tata_ace_title":"Tata Ace:","service_content_tata_ace_body":"Capacity: Up to 1 ton, Length: 6 feet","service_content_tata_super_ace_title":"Tata Super Ace / Ashok Leyland - Dost / Mahindra Bolera Pickup:","service_content_tata_super_ace_body":"Capacity: Up to 2 tons, Length: 7 feet","service_content_tata_407_title":"Tata 407:","service_content_tata_407_body":"Capacity: Up to 3 tons, Length: 8-10 feet","service_content_eicher_14_title":"Eicher 14 feet:","service_content_eicher_14_body":"Capacity: Up to 4 tons, Length: 14 Feet ","service_content_eicher_17_title":"Eicher 17 feet:","service_content_eicher_17_body":"Capacity: Up to 5 tons, Length: 17 Feet ","service_content_eicher_19_title":"Eicher 19 feet:","service_content_eicher_19_body":"Capacity: Up to 6 tons, Length: 19 Feet ","index_service_service_title":"We can help you with","index_service_services_0":"RELOCATION","index_service_services_1":"CONSTRUCTION SUPPLIES","index_service_services_2":"E-COMMERCE SUPPLIES","index_service_services_3":"DELIVERY SERVICES","index_service_services_4":"SUPPLIES MOVING","index_service_services_5":"WAREHOUSE IN AND OUT","meta":{"description":"Our portfolio includes Courier, transport, passenger and moving services, matching your every need","og:image":"/img/aboutus-banner.jpg","og:title":"Our Services","og:url":"{{SITE_HTTP_URL}}/service","og:description":"Our portfolio includes Courier, transport, passenger and moving services, matching your every need","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = {"moving":{"title":"Moving","src":"icon-courier.png","src_2x":"icon-courier@2x.png","width":69,"height":70,"style":"top:70px"},"supplies_moving":{"title":"Supplies Transport","src":"icon-supplies-moving.png","src_2x":"icon-supplies-moving.png","width":51,"height":51,"style":"top:70px"},"delivery_service":{"title":"Delivery services","src":"icon-delivery.png","src_2x":"icon-delivery@2x.png","width":61,"height":52},"warehouse":{"title":"Warehouse In & Out","src":"icon-warehouse-transport.png","src_2x":"icon-warehouse-transport@2x.png","width":57,"height":56},"eicher_14":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"eicher_17":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"eicher_19":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"tata_407":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"tata_ace":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":44},"tata_super_ace":{"src":"icon_ser_14ftlorry.png","src_2x":"icon_ser_14ftlorry@2x.png","width":44}}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_map"}],"index_service":{"parent_width_style":"grid-12 grid-tablet-12 centered","width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","disable_learn_more":true,"items":[{"img":"moving"},{"img":"supplies"},{"img":"oversized"},{"img":"delivery_service"},{"img":"supplies_moving"},{"img":"warehouse"}]},"service_contents":[{"type":"service_headline"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["tata_ace","tata_super_ace","tata_407","eicher_14","eicher_17","eicher_19"],"footer":"fleets_footer"}}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal","faq"],"languages":{"en_sg":"en_sg"}}}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Terms and Conditions","tc_consumer_headline":"Terms and Conditions"}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/sg_content"}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","quoting","faq","sitemap","privacy","template_for_angular","template_for_angular_no_header","tc_location","tc_consumer"]

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 404","404_title":"","404_body":["요청하신 페이지를 찾을 수 없습니다."],"404_sub":"","404_links_title":"유용한 다른 링크:","404_links_button_link_title":"고고밴 홈"}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 서비스 개요","about_gogovan_headline":"고고밴은 한국내 당일배송 서비스를 제공합니다","about_gogovan_body":["고고밴은 2013년 홍콩에서 시작한 스마트 물류 서비스입니다.","안정적인 시스템 구축을 통해 홍콩 뿐만 아니라 싱가폴 등 각 나라에서 놀라운 수익률을 자랑하는 기업으로 성장하였습니다. 고고밴은 끊임없는 서비스 개선과 시스템 유지를 통해 모든 이에게 편리하고 손쉬운 서비스를 제공하며, 전 세계적 사업 확장을 목표로 삼고 그 실현을 위해 매진할 것입니다."],"about_map_map_headline":"가까운 고고밴을 찾아보세요","about_map_map_stat_name_countries":"국가","about_map_map_stat_name_cities":"도시","about_map_map_stat_name_registered":"등록 차량","about_help_help_headline":"전세계 유통을 재설계","about_help_help_desc":["빠르게 성장하고 있는 고고밴은, 세계로 더욱 뻗어나가기 위한 투자자들과 협력사를 모집하고 있습니다. 혁신적인 유통 서비스의 개선에 참여하고 싶다면 연락해 주시기 바랍니다.","<a href='info@gogovan.co.kr' class='blue'>info@gogovan.co.kr</a>"],"about_hire_hire_headline":"고고밴에서 함께 일할 가족을 모집합니다.","about_hire_job_opportunity":"커리어","meta":{"keywords":"물류, 화물, 퀵서비스, 다마스, 라보, 밴, 1톤, 대형화물차, 당일배송, 스마트배송, 용달, 고고밴","description":"고고밴은 온라인 물류중개 회사로 플랫폼을 활용하여 기사님과 소비자를 연결하여 당일배송 서비스를 제공합니다. 오토바이부터, 다마스, 라보, 밴, 및 1톤트럭부터 대형 화물차까지 다양한 형태의 차량을 여러분께 제공합니다"}}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_map":{},"about_help":{},"about_hire":{}}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 고객센터","business_headline_content_headline":"프리미엄 사업 패키지","business_headline_contents":[],"contact_us":"연락하기","business_partnership_header":"파트너쉽","business_partnership_content":["고고밴은 배송 및 물류 유통, 승합차 렌트 등 다양한 물류 서비스를 제공합니다.","또한, 개인의 필요에 따라 맞춤형 물류 서비스도 제공하고 있습니다."],"business_investor_header":"투자문의","business_investor_content":["저희 고고밴의 물류 서비스는 빠른 속도로 전 세계에 확장되고 있습니다.","고고밴의 비전이 마음에 드신다면 저희 글로벌 사업 확장에 참여해주시기 바랍니다.","자세한 정보는 <a class='blue' href='mailto:info@gogovan.co.kr'>info@gogovan.co.kr</a> 로 연락주시기 바랍니다."],"meta":{"keywords":"파트너쉽, 투자, 제휴, 콜라보레이션, 스타트업, 고고밴 투자","description":"고고밴은 고객의 다양한 배송요구사항에 맞는 맞춤형 솔루션도 제공합니다. 고고밴은 전세계에 빠른 속도로 확장중이며 저희 사업 투자에 관심이 있으시면 언제든 문의주시기 바랍니다"}}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 고객센터","contact_section_title":"고객센터","contact_content":"궁금하시거나 문의사항이 있으시면 우측 양식을 작성해 보내주시거나, 고고밴코리아 고객센터로 연락주시기 바랍니다. 서비스 이용에 도움이 되도록 최선을 다해 노력하겠습니다.","contact_label_email":"이메일 주소","contact_email":"info@gogovan.co.kr","contact_label_hotline":"","contact_hotline":"","contact_hotline_link":"","contact_input_name":"이름 (필수기재)","contact_input_email":"이메일 주소 (필수기재)","contact_input_title":"제목","contact_input_message":"내용 (필수기재)","contact_button_send":"보내기","contact_thankyou_message":"접수 되었습니다. 감사합니다!","meta":{"keywords":"고객센터, CS, 콜센터, 고고밴 고객센터","description":"고고밴은 여러분의 의견을 기다립니다. 고고밴 서비스에 대해 궁금하시거나 문의사항이 있으시면 대구를 제외한 지역 1588-3047, 대구 053-254-3047로 전화주시거나 info@gogovan.co.kr로 메일 보내주세요"}}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Uyw4SP8XW6ZQz9FVPxcC1jMM5e-X3xUp_D0rcT3YSRA","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 자주 묻는 질문","faq_headline":"자주 묻는 질문","faq_other_questions":"필요하신 질문에 대한 답변이 없거나 다른 궁금하신 점이 있으시면 <a href='tel:1588-3047'>1588-3047</a>로 문의해주세요","faq_questions":[{"question":"지금 당장 서비스가 필요하지만 기사님을 찾을 수가 없습니다. 어떻게 하는게 좋을까요?","answer":"피크 시간대에는 기사님 배정에 평상시보다 많은 시간이 필요할 수 있습니다. 주문 하실때 \"보너스\"를 추가하시면 기사님이 우선적으로 주문을 받을 확률이 높아집니다."},{"question":"유료도로 통행료가 앱상의 요금에 포함되어 있나요?","answer":"고객님의 주문을 위해 앱상에 표기된 요금은 유료도로 통행료를 포함하고 있지 않습니다."},{"question":"기사님의 번호판이 앱에 표시된 번호판과 왜 다른가요?","answer":"높은 서비스 수준을 유지하기 위해 고고밴 기사님이 접수한 주문을 다른 분에게(고고밴 미등록 기사) 대행하도록 허용하지 않습니다. 만약 차량의 번호판이 표시된 등록판과 다른 경우에는 고객센터로 즉시 연락 주시길 부탁 드립니다."},{"question":"배정된 기사님이 많이 늦거나 연락도 없이 나타나질 않습니다. 어떻게 할까요?","answer":"전화를 통해 고고밴에게 연락주시면 곧바로 새로운 차량을 배정해 드리겠습니다."},{"question":"주문을 제출한 이후에 출발지 및 도착지 변경, 차량 종류 변경 혹은 주문 취소를 하고 싶은 경우에는 어떻게 하면 되나요?","answer":"주문을 변경하시거나 취소하고 싶으실 때에는 기사님께 직접 연락해주세요."},{"question":"보내고 싶은 물품이 중량제한이나 규격제한을 초과하는지 확실히 모르겠어요","answer":"다양한 무게와 규격의 물품을 운반할 수 있도록 다양한 차종이 제공됩니다. 차량 선택에 어려움을 겪으신다면 본 링크를 참조해주세요.<br/><a href='service.html'>참조 링크</a><br/>혹은 고고밴에 직접 문의하세요 ."},{"question":"주문 기록을 새로 받고 싶으면 어떻게 할까요?","answer":"주문 기록은 배송 경로, 시간, 가격 및 기타 연관 정보를 포함하고 있습니다. 주문 기록을 재발급 받고 싶으시다면 앱 왼쪽 상단의 메뉴를 통해 주문 기록을 선택하셔서 원하는 기록을 선택하신 후 우측 상단에 <img class='icon-email' srcset='/img/icon_email.png 1x, /img/icon_email@2x.png 2x'> / <img class='icon-sendto' srcset='/img/icon_send_to.png 1x, /img/icon_send_to@2x.png 2x'>를 클릭해주세요. 이메일 주소를 입력하시면 해당 기록을 이메일로 받아보실 수 있습니다."},{"question":"주문 접수가 완료되어 기사님의 정보가 표시되었습니다. 무엇을 하면 되나요?","answer":"기사님의 정보가 보이신다면 해당 기사님께서 주문을 접수하셨다는 뜻과 동일합니다. 기사님이 정확한 물품 픽업 장소와 도착지를 확인하기위해 곧 전화하실겁니다."},{"question":"제 주문을 위한 적합한 차종이 없다면 어떻게 해야할까요?","answer":"물품의 크기, 특징으로 인해 차량이 적합하지 않다고 생각되시거나 배송 상에 특별한 사유가 있으실 경우 고객센터로 연락해주세요. 고객님의 요청에 맞게 준비하겠습니다."},{"question":"고고밴의 영업시간은 어떻게 되나요?","answer":"앱으로 하시는 주문의 경우 주 7일, 24시간 휴일 없이 진행됩니다. 고객센터를 통한 주문 예약은 주 7일 오전 9시부터 오후 9시까지 운영됩니다."},{"question":"거래 기록이 얼마나 오래 저장되나요??","answer":"고고밴 앱을 삭제하시지 않으신다면 거래 기록은 고객님의 핸드폰에 항상 저장됩니다."}],"meta":{"keywords":"질문, 문의, 고고밴","description":"고고밴 당일배송 서비스의 자주 묻는 질문입니다. 자주 묻는 질문을 먼저 확인해 보세요"}}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = {"playstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_outlined_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"고객용","height":"56"},"playstore_driver_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"고객용","height":"56"},"playstore_driver_outlined":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver_outlined_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"고객용","width":"180","height":"60"}}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = {"hero_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":88,"height":51,"alt":"Video"},"hero_nexus":{"src":"hero_nexus_en.png","src_2x":"hero_nexus_en@2x.png","width":217,"height":401,"alt":"GoGoVan"},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47},"icon_transportservice":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":44},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":44},"icon_passengerservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":44},"icon_deliveryservice":{"src":"icon_smallfreight.png","src_2x":"icon_smallfreight@2x.png","height":44},"feature_lightbox_1":{"src":"feature_lightbox1.png","src_2x":"feature_lightbox1@2x.png","height":"100%"},"feature_lightbox_2":{"src":"feature_lightbox2.png","src_2x":"feature_lightbox2@2x.png","height":235},"feature_lightbox_3":{"src":"feature_lightbox3.png","src_2x":"feature_lightbox3@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4.png","src_2x":"feature_lightbox4@2x.png","height":"100%"},"feature_lightbox_5":{"src":"feature_lightbox5.png","src_2x":"feature_lightbox5@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6.png","src_2x":"feature_lightbox6@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1.png","src_2x":"icon-how-it-work-step1@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"icon-how-it-work-step2.png","src_2x":"icon-how-it-work-step2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"icon-how-it-work-step3.png","src_2x":"icon-how-it-work-step3@2x.png","width":"492","class":"section-howitwork-content-img-middle"},"howitwork_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":183,"height":102,"alt":"Video"}}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/kr/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"}],"index_hero":{"show_phone":true},"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"icon_transportservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"transport"},{"img":"icon_deliveryservice","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"delivery"},{"img":"icon_movingservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"moving"},{"img":"icon_passengerservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"cargo","disable":true}]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Uyw4SP8XW6ZQz9FVPxcC1jMM5e-X3xUp_D0rcT3YSRA","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"},"background":"home_hero_bg_back.jpg","comment_class":"grid-5 grid-tablet-4 grid-mobile-4 centered"}}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 개인정보 정책","legal_headline":"고고밴코리아 개인정보취급방침","meta":{"keywords":"고고밴, 개인정보, 정보보호정책","description":"고고밴 개인정보 취급방침"}}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/kr_content"}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = {"title":"새 주문","body_class":"order-page","include_locales":["pages/service.json"],"blocks":[],"order":{"button_apply":"신청","button_cancel":"취소","button_add_image":"사진 올리기","pick_up_time":"픽업 시간","total_amount":"총 요금","promo_code":"쿠폰이 있으세요?","order_confirm_button":"주문 다시보기","order_location_warning":"빨간색으로 표기된 미입력란을 채워주세요.","hourly":{"title":"렌탈","desc":"包鐘係以時間作為單位之落單方式。","minimum":"每次最少3個鐘","detail_btn":"세부사항","hours_for_select":[{"title":"3시간","value":"3"},{"title":"3.5시간","value":"3.5"},{"title":"4시간","value":"4"},{"title":"4.5시간","value":"4.5"},{"title":"5시간","value":"5"},{"title":"5.5시간","value":"5.5"},{"title":"6시간","value":"6"},{"title":"6.5시간","value":"6.5"},{"title":"7시간","value":"7"},{"title":"7.5시간","value":"7.5"},{"title":"8시간","value":"8"}]},"order_option":{"passenger":{"title":"승객","body":"승객"},"tunnel":{"title":"터널","tunnels":[{"title":"Any","tunnel_code":"any"},{"title":"Cross-Harbour Tunnel","tunnel_code":"hung"},{"title":"Western Harbour Crossing","tunnel_code":"western"},{"title":"Eastern Harbour Crossing","tunnel_code":"eastern"},{"title":"Lion Rock Tunnel","tunnel_code":"lion_rock"},{"title":"Tate's Cairn Tunnel","tunnel_code":"tates_cairn"},{"title":"Eagle's Nest Tunnel","tunnel_code":"eagles_nest"},{"title":"Tai Lam Tunnel","tunnel_code":"tai_lam"},{"title":"Aberdeen Tunnel","tunnel_code":"aberdeen"},{"title":"Tseung Kwan O Tunnel","tunnel_code":"tko"},{"title":"Tsing Ma Bridge","tunnel_code":"tm_bridge"},{"title":"Discovery Bay Tunnel","tunnel_code":"discovery"},{"title":"Shing Mun Tunnel","tunnel_code":"shing_mun"}]}},"route":{"title":"경로","location_1_address_input":"출발지 입력","location_2_address_input":"도착지 입력","view_on_map_button":"지도 보기","add_address_button":"경유지 추가"},"passenger":{"title":"승객","body":"승객"},"car_type":{"title":"차종","van":{"title":"VAN","body":"最多可載5人；載重約1噸／2200磅；內籠尺寸約為長6尺、高4尺、闊4尺。","price":"$20 起"},"5.5_ton_truck":{"title":"5.5 TON TRUCK","body":"最多可載5人；載重1.5噸3300磅；貨櫃尺寸約為長13尺、高6尺8寸、闊6尺8寸。","price":"$45 起"},"9_ton_truck":{"title":"9 TON TRUCK","body":"最多可載5人；載重4噸／8800磅；貨櫃尺寸約為長13尺、高6尺8寸、闊6尺8寸。","price":"$25 起"}},"promo":{"promo_code_input":"쿠폰번호를 입력하세요","warning_message":"請輸入有效的優惠卷編號"},"additional_service":{"title":"부가 서비스(선택사항)","button_service_detail":"세부사항","van":[{"title":"貨物超過6呎長","service_code":"need_over_6ft","options":[{"title":"貨物超過6呎長 ($10)","option_name":"remove_net","option_code":"half"},{"title":"貨物超過半網高度 ($20)","option_name":"remove_net","option_code":"full"}]},{"title":"租借車仔／板車 (每部$10)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]},{"title":"接載寵物 ($10 隻數不限)","service_code":"need_pet","options":[]},{"title":"新車","service_code":"need_new_car","options":[]},{"title":"建築廢料 ($ 請與司機議價)","service_code":"need_waste","options":[]}],"5.5_ton_truck":[{"title":"借唧車 (每部 $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]}],"9_ton_truck":[{"title":"借唧車 (每部 $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]}]},"contact":{"title":"연락처","name_input":"성함","phone_input":"전화번호","email_input":"이메일","order_contact_warning":"빨간색으로 표시된 칸을 채워주세요.","order_contact_phone_warning":"올바른 전화번호를 입력해주세요."},"remark":{"title":"남길 말 (선택사항)","body":"출발지 근처의 주요 빌딩, 짐 개수 등."},"order_summary":{"title":"주문 요약","button_confirm_order":"기사 검색","button_edit_order":"수정","button_price_table":"요금 세부사항 확인","button_show_order_detail":"주문 세부사항 보기","button_hide_order_detail":"주문 세부사항 닫기","button_cancel_order":"주문 취소","driver":{"title":"기사 정보","body":"기사님 배정중","rate_driver_btn":"기사 평가하기","block_driver_btn":"차단하기"},"route":{"title":"경로","view_on_map_button":"지도 보기"},"contact":{"title":"연락처"},"pickup_time":{"title":"픽업 시간"},"vehicle":{"title":"차량 종류"},"remark":{"title":"남길 말"},"charge":{"title":"요금 상세내역","tips":"보너스","total_amount":"합계","button_why_tips":"(선택사항)","coupon":"쿠폰 할인"},"tips":{"title":"보너스는 왜 있는건가요?"},"payment":{"title":"지급 방법","message":"상기 요금은 출발지와 도착지간의 거리를 기반으로 계산되었으며 주차비, 톨게이트 비와 같은 기타 요금은 포함되지 않았습니다. 이용 전에 기사님과 확인해주세요.","button_price_table":"요금 상세사항 확인","method":"현금 지급하기"}},"popup_dialog":{"tips":{"title":"보너스는 왜 있는건가요?","body":"보너스는 더 많은 기사님이 고객님의 주문에 관심을 갖도록하여 서비스의 질을 향상시킬 수 있습니다. 특히 피크시간대에 빠른 주문 접수를 하기에 용이합니다."}}}}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = {"title":"비밀번호 변경 - 고고밴","password_headline":"비밀번호 변경","password_email":"등록되어 있는 이메일 주소","password_password":"신규 비밀번호","password_confirm_password":"비밀번호 확인","password_button_request_reset":"비밀번호 변경 신청","password_button_submit":"확인","password_respond":"신청이 완료되었습니다. 이메일을 확인해주세요","password_email_not_found":"등록되지 않은 이메일입니다, <a href=\"#register\" class=\"global-text-blue dialog\">가입 후</a> 진행해주세요.","password_error_password_length":"최소 8자리 이상의 비밀번호를 입력해주세요.","password_error_password_equal":"비밀번호가 일치하지 않습니다.","password_error_token_expired":"만료된 링크입니다."}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 가격","pricing_hero_quoting_headline":"","pricing_hero_quoting_content":"","pricing_headline_headline":"투명한 가격 정책","pricing_headline_content":"고고밴 배송운임은 실제운송거리를 기준으로 산정됩니다.","pricing_terms_header":"정책 <small>(필수동의사항)</small>","pricing_terms_items":["할인 쿠폰 적용은 차량 비용에서만 가능합니다. (인력 관련 비용은 제외)","기사방문 후 대기시간이 길 경우 배송이 어려울 수 있습니다.","파손 가능한 위험 품목은 이용이 어렵습니다.","오토바이 퀵을 이용할 수 있는 물품 최대 무게는 30kg입니다."],"pricing_charge_header":"추가 운임","pricing_charge_items":["퀵서비스는 서울/경기/대구, 용달 및 원룸, 소/대형화물 운송의 경우 제주도를 제외한전국에 고고밴 서비스 사용이 가능합니다.","기사방문 후 취소시 오토바이는 3,000원, 다마스와 라보는 5,000원의 취소요금이 부과됩니다.","상하차시 2시간 이상의 시간이 필요할 경우 이후부터 시간당 20,000원이 추가됩니다","배송에 하루 이상이 필요할 경우 50,000원이 추가됩니다."],"meta":{"keywords":"당일배송, 가격, 가격정보, 물류가격정보, 운임","description":"고고밴의 당일배송 가격은 실제 운송거리를 기준으로 산정됩니다"}}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"terms","offset":"-114"},{"target":"charge","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"pricing_list","table_name":"terms","prefix":"pricing_terms"},{"type":"pricing_list","table_name":"charge","prefix":"pricing_charge"}]},"pricing_terms":{"name":"terms","list_style":"list-dotted","hr":true},"pricing_charge":{"name":"charge","list_style":"list-numbered","hr":true}}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 - Get Quote","dollar_code":"원","quoting_first_input":"출발지","quoting_last_input":"도착지","quoting_get_btn":"신청","quoting_clear_btn":"경로재설정","quoting_service_title":"퀵서비스","quoting_price_prefix":"","quoting_price_postfix":" 원","quoting_service_select_btn":"선택","quoting_place_order_btn":"주문하기","quoting_download_app_title":"앱을 다운받으세요","quoting_service_delivery_title":"소형 용달 화물","quoting_service_delivery_body":"당일 배송을 원하시는 소량/중량화물의 경우","quoting_service_moving_title":"원룸/소사무실 이사","quoting_service_moving_body":"원룸이사나 작은 사무실의 이사가 필요한 경우","quoting_service_transport_title":"퀵서비스","quoting_service_transport_body":"수도권 내에서 빠른 시간의 당일 배송을 원하시는 소형화물의 경우","quoting_service_cargo_title":"대형 화물 / 기업 물류","quoting_service_cargo_body":"기업화물 / 대형화물의 용달배송이 필요한 경우","quoting_service_not_available_headline":"대형화물 / 기업화물","quoting_service_not_available_content":"대형화물 및 기업화물의 배송을 원하시는 경우 고고밴코리아 고객센터 1588-3047으로 연락주시기 바랍니다."}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = {"icon_delivery_white":{"src":"icon_smallfreight_w.png","src_2x":"icon_smallfreight_w@2x.png","width":"56","alt":"delivery"},"icon_delivery_blue":{"src":"icon_smallfreight.png","src_2x":"icon_smallfreight@2x.png","width":"56","alt":"delivery"},"icon_moving_white":{"src":"icon_movingservice_w.png","src_2x":"icon_movingservice_w@2x.png","width":"63","alt":"moving"},"icon_moving_blue":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","width":"63","alt":"moving"},"icon_transport_white":{"src":"icon_courier_w.png","src_2x":"icon_courier_w@2x.png","width":"64","alt":"transport"},"icon_transport_blue":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","width":"64","alt":"transport"},"icon_cargo_white":{"src":"icon_ridewithgood_w.png","src_2x":"icon_ridewithgood_w@2x.png","width":"64","alt":"cargo"},"icon_cargo_blue":{"src":"icon_ridewithgood.png","src_2x":"icon_ridewithgood@2x.png","width":"64","alt":"cargo"}}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"transport","width_class":"grid-3 grid-mobile-3","data":{"service":"transport","service-type":"transport","vehicle-type":""}},{"type":"delivery","width_class":"grid-3 grid-mobile-3","data":{"service":"delivery","service-type":"delivery","vehicle-type":"damas"}},{"type":"moving","width_class":"grid-3 grid-mobile-3","data":{"service":"moving","service-type":"moving","vehicle-type":"ton1"}},{"type":"cargo","width_class":"grid-3 grid-mobile-3","data":{"service":"cargo","service-type":"cargo","vehicle-type":""},"disable":true}]}}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 서비스 안내","service_content_headline":"당일배송 물류 서비스 고고밴","service_content_content_subheadline":"","service_content_contents":["모바일로 또는 온라인으로 배송을 쉽고 간편하게 맡기세요. 지금 예약하시면 즉시 배송기사와 연결시켜드립니다. 몇 번의 터치로 완성되는 배송 서비스는 24시간 여러분께 열려있습니다. 고고밴으로 인해 세상은 더욱 작고 빠르고 편리해질 것입니다."],"service_content_sg_delivery_title":"퀵서비스","service_content_sg_delivery_content":["소형 물품을 가장 빠르게 보내는 방법","지역 내 배송에 특화","서류, 음식, 소형 물품 배송 시 이용 가능"],"service_content_sg_delivery_button":"선택","service_content_sg_transport_title":"소형용달화물","service_content_sg_transport_content":["단일 가구/소수 물품 배송을 저렴하게 이용","운반에 필요한 인력 추가 설정 가능"],"service_content_sg_transport_button":"선택","service_content_sg_moving_service_title":"소형 이사","service_content_sg_moving_service_content":["소수의 가구로 구성된 원룸/오피스텔 이사, 사무실 이사, 혹은 학생 이사에 적합","추가 운반 인원 설정 가능"],"service_content_sg_moving_service_button":"선택","service_content_sg_big_cargo_title":"화물 배송","service_content_sg_big_cargo_content":["부피와 무게가 큰 다수의 화물 운송에 적합","기본 5톤 트럭 이용","거리단위 요금 측정"],"service_content_sg_big_cargo_button":"선택","service_content_sg_extra_title":"기타 운송","service_content_sg_extra_content":["위 항목외에 다른 이유로 고고밴이 필요하신가요? 맞춤형 서비스는 고객센터로 직접 문의하세요. 저희가 친절히 안내해 드리겠습니다."],"service_content_sg_extra_button":"LEARN MORE","service_content_fleets_header":"등록 차량","service_content_fleets_subheader":"고고밴은 아래 차종의 운전기사와 함께합니다.","service_content_icon_ser_motorcycle_title":"오토바이","service_content_icon_ser_motorcycle_body":"소형 물품 배송용, 빠르고 교통 상황에 대한 제약이 적음","service_content_icon_ser_van_title":"다마스 / 라보 / 밴","service_content_icon_ser_van_body":"소형 물품 배송용, 박스나 소형 가전/가구 운송","service_content_icon_ser_10ftlorry_title":"1톤, 1.2톤 & 1.4톤","service_content_icon_ser_10ftlorry_body":"최대 1,000kg 적재가능, 원룸이사 / 대량박스나 가전/가구 운송","service_content_icon_ser_14ftlorry_title":"2.5 – 3.5톤","service_content_icon_ser_14ftlorry_body":"2,500kg – 3,500kg 적재가능, 원룸 이상의 이사 / 대형가구 및 대량 운송","service_content_icon_ser_24ftlorry_title":"5톤","service_content_icon_ser_24ftlorry_body":"최대 5,000kg 적재가능, 일반이사, 대형화물","meta":{"keywords":"소형용달화물, 퀵서비스, 소형이사, 원룸이사, 오피스텔이사, 화물배송, 기업화물, 기타물품운송, 물품운송 ","description":"고고밴은 쉽고 빠르게 사용할수 있으며 다양한 형태의 물건에 적합한 차종으로 고객 배송요구사항에 맞는 최적화된 당일배송 서비스를 제공합니다"}}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"transport":{"src":"icon_ser_courier.png","src_2x":"icon_ser_courier@2x.png","width":32.5},"delivery":{"src":"icon_ser_smallfreight.png","src_2x":"icon_ser_smallfreight@2x.png","width":32.5},"big_cargo":{"src":"icon_ser_delivery.png","src_2x":"icon_ser_delivery@2x.png","width":90},"icon_ser_motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"icon_ser_10ftlorry":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":38,"height":25},"icon_ser_14ftlorry":{"src":"icon_ser_14ftlorry.png","src_2x":"icon_ser_14ftlorry@2x.png","width":42,"height":27},"icon_ser_24ftlorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_map"}],"service_contents":[{"type":"service_headline"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_sg":{"items":["transport","delivery","moving_service","big_cargo","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_motorcycle","icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry","icon_ser_24ftlorry"]}}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 이용약관 (고객 버전)","tc_consumer_headline":"이용약관 (고객 버전)","meta":{"keywords":"이용약관, 고고밴","description":"고고밴 이용약관 (고객 버전)"}}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/kr_content"}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 위치정보 이용약관","tc_location_headline":"위치정보 이용약관","meta":{"keywords":"위치정보, 이용약관","description":"고고밴 - 위치정보 이용약관"}}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_location"}],"content_block":"tc_location/kr_content"}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","sitemap","template_for_angular","tc_consumer","template_for_angular_no_header"]

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = {"title":"About Us Same Day Delivery | Courier Singapore","about_help_help_headline":"About GoGoVan","about_help_help_desc":"GoGoVan is growing rapidly, and we are always looking for investors to support our global expansion. If you would like to invest in a revolutionary logistic service, please get in touch!","about_gogovan_body":["GoGoVan is Asia’s pioneer app platform that connects users with a network of drivers for same day on-demand delivery and transportation needs. We aim to redefine the everyday logistics experience by providing convenient and efficient service.","Established in Hong Kong since 2013, GoGoVan has successfully expanded to 13 cities in Hong Kong, Singapore, China, Taiwan, South Korea and India. With over 1.3 million app downloads and a driver network of 150,000, GoGoVan has completed more than 7.5 million orders with an aggregate transaction value in excess of US$200 million in 2016.","Leading the market in response time, fleet coverage and service satisfaction, GoGoVan is rapidly expanding its global presence to bring better and faster logistics services to everyone."],"about_map_map_headline":"Explore services near you","about_map_map_stat_name_countries_number":"6","about_map_map_stat_name_countries":"Countries","about_map_map_stat_name_cities_number":"13","about_map_map_stat_name_cities":"Cities","about_map_map_stat_name_registered_number":"150,000+","about_map_map_stat_name_registered":"Registered Vehicles","about_hire_job_opportunity":"CAREERS","meta":{"description":"GOGOVAN is Asia’s pioneer Same Day Delivery and Courier App platform that connects users with commercial drivers for their logistics needs.","og:image":"/img/aboutus-banner.jpg","og:title":"About Same Day Delivery | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/about","og:description":"GOGOVAN is Asia’s pioneer Same Day Delivery and Courier App platform that connects users with commercial drivers for their logistics needs.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_hire","prefix":"about_hire"}]}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery for Business | Courier Singapore","get_in_touch":"GET IN TOUCH","make_an_enquiry":"MAKE AN ENQUIRY","business_headline_content_headline":"Customised Logistic Solutions for Business","business_headline_content_sub_headline":"Take your business further with GoGoVan","business_headline_contents":["From point to point deliveries, store distributions to van rental service, <a class='blue' href='http://www.gogovanbusiness.com'>GoGoVan for Business</a> provides a wide range of logistic services which are devoted to helping your business grow.","From short term to long term commitment, we have the following options to help your business become more efficient:"],"business_delivery_header":"Same Day Delivery","business_grow_header":"Grow Your Business","business_customized_header":"Customised Plan","business_contact_header":"Contact Us","business_delivery_content":["<h4> Impress customers, meet demands</h4>","With the largest driver network of over 10,000 commercial vehicles, GoGoVan is able to help deliver your business needs. Whether your delivery is same day, next day or scheduled, we have customised business solutions catered for you.","Vehicles available to serve you (based on order volume):"],"business_delivery_vehicles":[{"icon":"motorcycle","vehicle":"Motorcycles","content":"<strong>Courier service:</strong> Low volume of documents and small parcel delivery"},{"icon":"van","vehicle":"Van","content":"<strong>Delivery service:</strong> Medium volume of big and bulky parcels to be delivered door-to-door"},{"icon":"lorry","vehicle":"Lorry - 10ft, 14ft, 24ft","content":"<strong>Delivery service:</strong> High volume of parcels to be delivered in a single trip. <br>Moving service and office relocation service are also available."}],"business_delivery_footer":["Corporate pricing is available. Visit our <a class='blue' href='http://www.gogovanbusiness.com'>GoGoVan for Business</a> page for more details."],"business_grow_content":[{"content":"GoGoVan for Business is a delivery management service designed to help you outsource deliveries. We promise quality standards in corporate delivery."},{"content":"Benefits of delivering with GoGoVan:"},{"icon":"enterprise","content":"Access to GOGO Business, a delivery management system created for batch orders"},{"icon":"mobile_and_app","content":" Mobile and web app available"},{"icon":"pay_per_use","content":"Pay per use with no overheads"},{"icon":"real_time_tracking","content":"Real-time tracking of parcels"},{"icon":"kiosk","content":"In-store kiosk allows self-booking of same day delivery, powered by the GoGoVan app"},{"icon":"api","content":"API integration"},{"icon":"insurance","content":"Insurance coverage of up to $250,000 per claim"},{"content":"Get in touch with us and start growing your business."}],"business_customized_content":["Let us work together to help make logistics more efficient. Here are some ways businesses can use GoGoVan:","E-commerce with same day delivery API integration: <ul><li>Furniture shops</li> <li>Fashion/Blogshops</li> <li>Electronics</li></ul>","Courier Documents and Small Goods: <ul><li>Important documents</li><li>Corporate gifting</li><li>Print and publishing</li><li>Food and flowers</li></ul>","Transport Bulky Items and Moving Service: <ul><li>Relocation of home or office</li><li>Scheduled weekly transportation of goods</li></ul>","For customised business solutions, get in touch with us and we’ll get back to you within 2-3 working days."],"business_contact_content":["GoGoVan takes pride in delivering quality service at a reasonable price for your business.","Fill in the contact form below to receive an instant price quotation under no obligation."],"meta":{"description":"Customised Logistic Solutions and Corporate Rates with our Same Day Delivery and Courier Services catered for every business needs.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery for Business | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/business","og:description":"Customised Logistic Solutions and Corporate Rates with our Same Day Delivery and Courier Services catered for every business needs.","og:type":"website","og:site_name":"GoGoVan"},"index_contact_comment_title":"Contact Us","index_contact_comment_bodys":["Thank you! Your message has been received. We will get in touch with you within 1 to 2 working days."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email address*","index_contact_comment_input_company_name":"Company name*","index_contact_comment_input_designation":"Designation","index_contact_comment_input_contact":"Contact number*","index_contact_comment_input_message":"Delivery Specifications & Needs","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":""}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = {"enterprise":{"src":"enterprise.png","width":90},"api":{"src":"api.png","width":90},"pay_per_use":{"src":"pay_per_use.png","width":90},"insurance":{"src":"insurance.png","width":90},"real_time_tracking":{"src":"real_time_tracking.png","width":90},"kiosk":{"src":"kiosk.png","width":90},"mobile_and_app":{"src":"mobile_and_app.png","width":90},"motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"van":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":44},"lorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"delivery","offset":"-114"},{"target":"grow","offset":"-114"},{"target":"customized","offset":"-114"},{"target":"contact","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_contact"},{"type":"index_contact","prefix":"index_contact"},{"type":"business_aside_content_delivery_sg","prefix":"business_delivery"},{"type":"business_aside_content_sg","prefix":"business_grow"},{"type":"business_aside_content","prefix":"business_customized"}]},"business_delivery":{"id":"delivery","buttons":[{"target":"contact","title":"make_an_enquiry"}]},"business_grow":{"id":"grow","buttons":[{"link":"http://www.gogovanbusiness.com","title":"get_in_touch"}]},"business_customized":{"id":"customized","buttons":[{"link":"http://www.gogovanbusiness.com","title":"get_in_touch"}]},"business_contact":{"id":"contact","buttons":[{}]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSdcxt0fvVIy-yezVDvZuo68nDtjNm_b9YYy0cVguv1CtQLVaQ","name_name":"entry.1931335200","name_company_name":"entry.1158028810","name_designation":"entry.1730218061","name_email":"entry.1650232790","name_contact":"entry.695424097","name_message":"entry.1065765231"},"comment_class":"grid-6 grid-tablet-4 grid-mobile-4 left"}}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = {"title":"Contact Us | Same Day Delivery | Courier Singapore","contact_section_title":"Contact Us","contact_content":"Please complete the form and we will get in touch with you.","contact_hotline":"(+65) 6836 1110","contact_hotline_link":"68361110","contact_hotline_availability":"(Available daily, 0900 to 1800)","contact_label_corporate_sales":"Corporate Sales","contact_corporate_sales_text":"Get in touch","contact_label_email":"Email","contact_email":"info@gogovan.sg","contact_input_name":"Name*","contact_input_email":"Email Address*","contact_input_title":"Subject","contact_input_message":"Message*","contact_button_send":"SUBMIT","contact_thankyou_message":"Thank you! Your message has been received. We will get in touch with you within 1 to 2 working days.","meta":{"description":"Contact our Customer Service hotline 6836 1110 or email info@gogovan.sg for general enquiries.","og:image":"/img/aboutus-banner.jpg","og:title":"Contact Us | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"Contact our Customer Service hotline 6836 1110 or email info@gogovan.sg for general enquiries.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/sg/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1VJ0VDNm2CgDowAWCmi7Y37MJSpE7OstCF1XW9h-lFhE","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"dropdown":["General Enquiries & Feedback","Corporate Sales","Marketing & Partnerships","Media Enquiries","Others"]}}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery FAQ | GoGoVan Singapore","faq_headline":"Frequently Asked Questions","faq_other_questions":"Have another question we didn’t answer here? Feel free to email us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> and we’ll get back to you as soon as possible.","faq_questions":[{"question":"What is GoGoVan?","answer":"GoGoVan offers convenient and flexible same-day delivery service island wide - with the use of a mobile or web app.  Within seconds, the app connects you with thousands of riders and drivers in Singapore.<br><br>To try GoGoVan for yourself, download the app from the <a href='https://play.google.com/store/apps/details?id=hk.gogovan.GoGoVanClient2'>Google Play Store</a> or <a href='https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4'>Apple Store</a>. Alternatively, you may place an order on our <a href='/'>Website</a>."},{"question":"Which service do I need for my goods?","answer":"Deliver Small Goods: For small goods likes documents and parcel<ul class='list-dotted'><li>For goods under 3kg, within one parcel unit (30x20x20cm*), a motorcycle will be assigned</li><li>Any goods ranging from 3kg - 60kg, a van will be assigned</li></ul><p class='global-font-light'>Transport Large and Bulky Items: For large goods without movers. This service entitles you to up to 1 hour of loading and unloading time. This excludes the traveling time from pickup point to drop-off point.<ul class='list-dotted'><li>Van:  Suitable for large quantity of parcels and boxes, flower bouquets, plants, pets and furniture like single-size and queen-size mattress, dismantled bed frame, sofa.</li><li>10 ft lorry: Suitable to transport large furniture and household items like king-size mattress, washing machine, fridge etc.</li><li>14 ft lorry/24ft lorry : Suitable for moving house/office.</li></ul><p class='global-font-light'>Book a Moving Service: For moving of big spaces which require help from driver and/or movers to move the goods.  This service entitles you to up to 2 hours of loading and unloading time. This excludes the traveling time from pickup point to drop-off point.</p>"},{"question":"How do I know which vehicle I need? ","answer":"The GoGoVan fleet consists of motorcycles, vans, and lorries (10ft, 14ft and 24ft).<br><br>To help us serve you better, we would encourage you to support us with more details of the items (e.g. dimensions, weight, description of item) and take an image using our camera option when placing an order.<br><br>Our driver and customer service team will assist your order accordingly."},{"question":"Where do you deliver?","answer":"We deliver to every part of Singapore.<br><br>Please take note that there will be additional charges for our vehicles to enter or exit restricted areas (e.g. Airport Cargo Complex, Army Camps, Police Base, Shipyards). Please see <a href='pricing'>Pricing page</a> for more details."},{"question":"What are your operating hours?","answer":"Our mobile and web app can service your needs 24/7 including weekends and public holiday. Do take note that our customer service hotline (<a href='tel:68361110'>6836 1110</a>) operates daily from 9am to 6pm.<br><br>Feel free to send your enquiries to <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> and we’ll get back to you as soon as possible."},{"question":"How much does delivery, transport and moving services cost?","answer":"You may use our mobile or web app to get an instant quote by typing in the pick-up and drop-off locations. For a more detailed breakdown, please refer to our <a href='pricing'>Pricing page</a>. The final fee is subjected to Electronic Road Pricing (ERP), parking and other additional charges for custom requirements that you require."},{"question":"I’m a business, can I get a corporate package?","answer":"Yes, it is available. Please refer to our <a href='business'>Business page</a> for more details or email us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>. "},{"question":"How do I place an order?","answer":"Please download the GoGoVan mobile app from the <a href='https://play.google.com/store/apps/details?id=hk.gogovan.GoGoVanClient2'>Google Play Store</a> or <a href='https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4'>Apple Store</a> to place an order. Alternatively, you may place an order on our <a href='/'>Website</a>."},{"question":"How do I know if my item is one parcel size?","answer":"For easy reference, one parcel size (30x20x20cm) is roughly the size of a shoebox."},{"question":"How do I know if my goods can fit into the vehicle?","answer":"If you are transporting large and bulky goods, you can choose from our fleet of vans and lorries.<ul class='list-dotted'><li>Van: Max length of goods: 2.4m (8 feet)</li><li>10ft lorry:  Max length of goods: 3.0m</li><li>14ft lorry: Max length of goods: 4.2m</li><li>24ft lorry:  Max length of goods: 7.0m</li></ul>"},{"question":"Can I transport pets?","answer":"Yes.<br><br>Step 1: Select on \"New Booking\" on the GoGoVan app.<br>Step 2: Select \"Transport Heavy and Bulky Goods\" service<br>Step 3: Select \"Van\"<br>Step 4: Click on “Transport Pets” option under Extra Requirements."},{"question":"What if my location does not appear on the given list of addresses?","answer":"If your location is not listed, please choose the location nearest to you. For an updated quote, confirm your location with your designated driver once he or she responds. Alternatively, check <a href='/'>https://www.gogovan.sg/</a> to get the quote for a particular route."},{"question":"Do I need to enter my full address?","answer":"Yes, please enter the correct full address, especially when you need door-to-door service."},{"question":"How long does it take to find a driver?","answer":"Our usual response time to find a driver is within 60 seconds."},{"question":"I have placed an order but no driver assigned yet. Is my order confirmed?","answer":"Yes, your order is confirmed. There is an order number assigned to you while the GoGoVan system automatically notifies drivers in your area. Once a driver responds to your order, you will be taken to a new page with the contact information for your driver.<br><br>If you still have not found a driver after 20 minutes, please feel free to contact us at <a href='tel:68361110'>6836 1110</a> or <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>."},{"question":"Can I modify my order after placing it?","answer":"You cannot modify or cancel your order. Please contact us at <a href='tel:68361110'>6836 1110</a> or <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>."},{"question":"What happens after a driver is assigned to me?","answer":"The driver will give you a call to confirm your order details."},{"question":"Will the driver come to my house or office to deliver the goods?","answer":"This only applies to delivery of small goods and moving services."},{"question":"Can I ride with my goods?","answer":"Yes, only one person can accompany the goods at the front seat of a van or lorry."},{"question":"How can I check the status of my order?","answer":"You can always review the status of your order by visiting your Order History."},{"question":"What types of payment do you accept?","answer":"GoGoVan currently accepts only CASH payments."},{"question":"What if I am placing the order for someone else, how do I negotiate on payment options?","answer":"Please let the driver know that he can collect payment from receiver."},{"question":"Do I need to tip my driver?","answer":"There is no need to tip the driver. The best way to thank your driver is by giving him or her a 5-star rating."},{"question":"How do I redeem a coupon on my order?","answer":"Click on the “Use coupon code” button when placing an order through the mobile or web app ordering system. "},{"question":"How do I view my receipt?","answer":"You may view your receipts one of two ways:<ul class='list-numbered'><li>View receipts from your phone. Access Order History from the side menu on the GoGoVan app. You can view all your orders that are completed.</li><li>After completion of order via email. Once your order has been completed, you can email the order details to your preferred email address. You can view all completed orders under Order History, where you can email your order details, rate your driver and leave feedback.</li></ul>"},{"question":"How do I use a coupon code on my order?","answer":"Click on the “Use coupon code” button when placing an order through the mobile or web app ordering system."},{"question":"How do I get a coupon code?","answer":"Follow the GoGoVan <a href='https://www.facebook.com/gogovansg'>Facebook Page</a> and <a href='http://blog.gogovan.sg/'>Blog</a> to receive updates of our campaigns."}],"meta":{"description":"Learn more about Same Day Delivery and Courier in Singapore via this Frequently Asked Questions section.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery FAQ | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"Learn more about Same Day Delivery and Courier in Singapore via this Frequently Asked Questions section.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/sg/faq","prefix":"faq"}]}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = {"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":72,"height":69},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47,"alt":"Courier Service"},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":39,"alt":"Moving Service"},"icon_passengerservice":{"src":"icon_passengerservice.png","src_2x":"icon_passengerservice@2x.png","height":44,"alt":"Passenger Service"},"icon_deliveryservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":48,"alt":"Delivery Service"},"feature_lightbox_1":{"src":"feature_lightbox1.png","src_2x":"feature_lightbox1@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4.png","src_2x":"feature_lightbox4@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6.png","src_2x":"feature_lightbox6@2x.png","height":"100%"},"howitwork_step1":{"src":"step1.jpg","src_2x":"step1@2x.jpg","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"steps2.png","src_2x":"steps2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"steps3.png","src_2x":"steps3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"channel_newsasia":{"src":"media_channelnewsasia.png","src_2x":"media_channelnewsasia@2x.png","height":"50"},"e27":{"src":"media_e27.png","src_2x":"media_e27@2x.png","height":"30"},"ibt":{"src":"media_ibt.png","src_2x":"media_ibt@2x.png","height":"30"},"the_straits_times":{"src":"media_thestraitstimes.png","src_2x":"media_thestraitstimes@2x.png","height":"30"},"weekender":{"src":"media_weekender.png","src_2x":"media_weekender@2x.png","height":"30"},"tech_crunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":"30"},"wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":"30"}}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/sg/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"icon_courier","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"delivery"},{"img":"icon_deliveryservice","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"transport"},{"img":"icon_movingservice","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"moving"}]},"index_media":{"items":["channel_newsasia","e27","ibt","the_straits_times","weekender","tech_crunch","wsj","media_techinasia","media_reuters","media_forbes"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1VJ0VDNm2CgDowAWCmi7Y37MJSpE7OstCF1XW9h-lFhE","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"background":"form_bg2.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered","dropdown":["General Enquiries & Feedback","Corporate Sales","Marketing & Partnerships","Media Enquiries","Others"]}}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms and Conditions | Same Day Delivery | Courier Singapore","legal_headline":"Terms and Conditions","meta":{"description":"Terms and Conditions"}}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/sg_content"}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Services | Courier Singapore","pricing_headline_headline":"Transparent pricing and instant quote to save your time and money.","pricing_delivery_header":"Deliver and Courier Small Goods","pricing_delivery_content":"","pricing_delivery_head_items":["","Documents / parcel less than 3kg","2 Parcels / max 20kg","3 Parcels / max 30kg","4 Parcels / max 40kg","5 Parcels / max 50kg"],"pricing_delivery_head_items_mobile":["Price Range (based on delivery route)"],"pricing_delivery_pricing_range_title":"Price Range (based on delivery route)","pricing_delivery_pricing_range_price":["<?= price.delivery_range[0] ?>","<?= price.delivery_range[1] ?>","<?= price.delivery_range[2] ?>","<?= price.delivery_range[3] ?>","<?= price.delivery_range[4] ?>"],"pricing_delivery_remark_under_table":["Dimensions of each parcel must be no more than 30x20x20cm and under 3kg.","There is a grace period for the first 10 mins before waiting time charges apply. After 10mins from pick-up time: Waiting charge for Motorcycle/Sedan: $3, Van: $5."],"pricing_moving_header":"Book a Moving Service","pricing_moving_content":"","pricing_moving_head_items":["","Van","10 Ft Lorry","14 Ft Lorry","24 Ft Lorry"],"pricing_moving_head_items_mobile":["","Vehicles & Pricing"],"pricing_moving_base_price_title":"Base Price (Includes cost of 1 Mover)*","pricing_moving_base_price_price":["<?= price.moving_base_price[0] ?>","<?= price.moving_base_price[1] ?>","<?= price.moving_base_price[2] ?>","<?= price.moving_base_price[3] ?>"],"pricing_moving_additional_mover_title":"Each additional mover (max 5)","pricing_moving_additional_mover_price":["<?= price.moving_additional_mover_price[0] ?>","<?= price.moving_additional_mover_price[1] ?>","<?= price.moving_additional_mover_price[2] ?>","<?= price.moving_additional_mover_price[3] ?>"],"pricing_moving_limitation_title":"Loading and Unloading Time*","pricing_moving_limitation_price":["2 hrs max<br><br>Extra charge: $5/10 mins","2 hrs max<br><br>Extra charge: $8/10 mins","2 hrs max<br><br>Extra charge: $13/10 mins","2 hrs max<br><br>Extra charge: $21/10 mins"],"pricing_moving_limitation_price_mobile":["2 hrs max<br>Extra charge:<br>$5/10 mins","2 hrs max<br>Extra charge:<br>$8/10 mins","2 hrs max<br>Extra charge:<br>$13/10 mins","2 hrs max<br>Extra charge:<br>$21/10 mins"],"pricing_moving_remark_under_table":["Loading/Unloading Time excludes the travel time from pick-up point to drop-off point.","Price stated is inclusive of one manpower (driver)."],"pricing_transport_header":"Transport Large and Bulky Goods","pricing_transport_content":"","pricing_transport_head_items":["","Van","10 Ft Lorry","14 Ft Lorry","24 Ft Lorry"],"pricing_transport_head_items_mobile":["","Vehicles & Pricing"],"pricing_transport_price_range_title":"Price Range (based on delivery route)","pricing_transport_price_range_price":["<?= price.transport_price_range_price[0] ?>","<?= price.transport_price_range_price[1] ?>","<?= price.transport_price_range_price[2] ?>","<?= price.transport_price_range_price[3] ?>"],"pricing_transport_limitation_title":"Loading and Unloading Time*","pricing_transport_limitation_price":["1 hr max<br><br>Extra charge: $5/10 mins","1 hr max<br><br>Extra charge:  $8/10 mins","2 hrs max<br><br>Extra Charge: $13/10 mins","2 hrs max<br><br>Extra Charge: $21/10 mins"],"pricing_transport_limitation_price_mobile":["1 hr max<br>Extra charge:<br>$5/10 mins","1 hr max<br>Extra charge:<br>$8/10 mins","2 hrs max<br>Extra Charge:<br>$13/10 mins","2 hrs max<br>Extra Charge:<br>$21/10 mins"],"pricing_transport_remark_under_table":["Loading/Unloading Time excludes the travel time from pick-up point to drop-off point."],"pricing_additional_header":"Additional Charges","pricing_additional_items":["Depending on the vehicle used, additional charges will be added if the pick-up or drop-off locations are in one of the following areas: Airport Zone, Changi Cargo and Sea Ports, Military bases, Construction Sites and Jurong Island. [Motorcycle/Sedan: $10, Van: $15]. <a class='blue' href='http://blog.gogovan.sg/restrictedzones'>Complete List of Restricted Zones</a>","Additional charges may be incurred for special deliveries (e.g. oversize cargo, no lift service, need for special equipment). Please discuss with your driver."],"pricing_terms_header":"Other Information","pricing_terms_items":["All services include a driver and exclude CBD and other miscellaneous charges.","Promotional and coupon discounts apply to the transport price only (not inclusive of additional labour cost).","Dangerous and explosive products will not be accepted."],"meta":{"description":"Transparent pricing and instant quote on Same Day Delivery service starting from as low as $7. Email us at sales@gogovansg for corporate business rates.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery Pricing | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"Transparent pricing and instant quote on Same Day Delivery service starting from as low as $7. Email us at sales@gogovansg for corporate business rates.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"delivery","offset":"-114"},{"target":"transport","offset":"-114"},{"target":"moving","offset":"-114"},{"target":"additional","offset":"-114"},{"target":"terms","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"sg/pricing_table_2","prefix":"pricing_delivery"},{"type":"sg/pricing_table_2","prefix":"pricing_transport"},{"type":"sg/pricing_table_2","prefix":"pricing_moving"},{"type":"pricing_list","table_name":"additional","prefix":"pricing_additional"},{"type":"pricing_list","table_name":"terms","prefix":"pricing_terms"}]},"pricing_delivery":{"name":"delivery","col":"6","fields":["pricing_range"],"veritcalCellAtTheLastRow":false},"pricing_transport":{"name":"transport","col":"5","fields":["price_range","limitation"],"veritcalCellAtTheLastRow":true},"pricing_moving":{"name":"moving","col":"5","fields":["base_price","additional_mover","limitation"],"veritcalCellAtTheLastRow":true},"hero":"background-image: url(/img/pricing_banner_bg.jpg);","pricing_terms":{"name":"terms","list_style":"list-dotted","hr":true},"pricing_additional":{"name":"additional","list_style":"list-numbered","br":true}}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy | Same Day Delivery","privacy_headline":"Privacy Policy","meta":{"description":"Privacy Policy"}}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/sg_content"}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Instant Quote | GoGoVan Singapore","dollar_code":"S$ ","quoting_first_input":"Enter a Pick-up point","quoting_last_input":"Enter a Drop-off point","quoting_get_btn":"GET A QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_delivery_title":"DELIVER AND COURIER SMALL GOODS","quoting_service_delivery_body":"Door-to-door delivery/courier service for documents and parcels under 50 kg within 2 hours","quoting_service_transport_title":"TRANSPORT LARGE AND BULKY ITEMS","quoting_service_transport_body":"For goods that exceed 30x20x20cm or weigh over 30kg, additional charge for door-to-door service","quoting_service_moving_title":"BOOK A MOVING SERVICE","quoting_service_moving_body":"Relocation for homes and offices, includes labour cost of one mover","meta":{"description":"Get an Instant Quote for our Reliable Same Day Delivery, Courier, Delivery or Moving Services. For corporate deliveries, email sales@gogovan.sg.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery Instant Quote | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"Get an Instant Quote for our Reliable Same Day Delivery, Courier, Delivery or Moving Services. For corporate deliveries, email sales@gogovan.sg.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_tick":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_delivery_white":{"src":"icon_courier_w.png","src_2x":"icon_courier_w@2x.png","width":"56","alt":"VAN"},"icon_delivery_blue":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","width":"56","alt":"VAN"},"icon_moving_white":{"src":"icon_movingservice_w.png","src_2x":"icon_movingservice_w@2x.png","width":"63","alt":"5.5 TON TRUCK"},"icon_moving_blue":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","width":"63","alt":"5.5 TON TRUCK"},"icon_passenger_white":{"src":"icon_passengervan_w.png","src_2x":"icon_passengervan_w@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_passenger_blue":{"src":"icon_passengervan.png","src_2x":"icon_passengervan@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_transport_white":{"src":"icon_ridewithgoodsicon_w.png","src_2x":"icon_ridewithgoodsicon_w@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_transport_blue":{"src":"icon_ridewithgoodsicon.png","src_2x":"icon_ridewithgoodsicon@2x.png","width":"64","alt":"9 TON TRUCK"}}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"delivery","width_class":"grid-4 grid-mobile-4","data":{"service":"delivery","service-type":"delivery","vehicle-type":"motorcycle"}},{"type":"transport","width_class":"grid-4 grid-mobile-4","data":{"service":"transport","service-type":"transport","vehicle-type":"van"}},{"type":"moving","width_class":"grid-4 grid-mobile-4","data":{"service":"moving","service-type":"moving","vehicle-type":"van"}}]}}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Services | Courier Singapore","service_content_headline":"Book a Logistics Service Instantly","service_content_subheadline":"Rely on us.","service_content_contents":["Receive an instant quote and book a driver online or through our mobile app. We place one of the largest fleets in Singapore at your fingertips, ready for dispatch."],"service_content_fleets_subheader":"Our fleet of over 10,000 vehicles includes:","service_content_icon_ser_motorcycle_title":"Motorcycle:","service_content_icon_ser_motorcycle_body":"Good for small parcels and documents. Max weight: 3kg, Max dimensions: 30x20x20cm (1 parcel size)","service_content_icon_ser_sedan_title":"Sedan:","service_content_icon_ser_sedan_body":"Good for small quantity of parcels and boxes. Max dimensions: 30x20x20cm (1 parcel size)","service_content_icon_ser_van_title":"Van:","service_content_icon_ser_van_body":"Good for large quantity of small parcels, boxes, small furniture and pets. Max length of goods: 2.4m","service_content_icon_ser_10ftlorry_title":"10 ft lorry:","service_content_icon_ser_10ftlorry_body":"Good for 1 bedroom which includes 1 mattress and 3 seater sofa. Max length of goods: 3m","service_content_icon_ser_14ftlorry_title":"14 ft lorry:","service_content_icon_ser_14ftlorry_body":"Good for 2 bedrooms or multiple sofas, dining table and chairs. Max length of goods: 4.2m","service_content_icon_ser_24ftlorry_title":"24 ft lorry:","service_content_icon_ser_24ftlorry_body":"Good for 3 bedrooms, office furniture, and/or boats. Max length of goods: 7.0m","meta":{"description":"Our Same Day Delivery Services include Courier Service for Documents, Parcel Delivery and Relocation of Homes or Offices that match your every logistics need.","og:image":"/img/aboutus-banner.jpg","og:title":"Our Services | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/service","og:description":"Our Same Day Delivery Services include Courier Service for Documents, Parcel Delivery and Relocation of Homes or Offices that match your every logistics need.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = {"icon_ser_motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"icon_ser_24ftlorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_map"}],"service_contents":[{"type":"service_headline"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_sg":{"items":["delivery","transport","moving_service","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_motorcycle","icon_ser_sedan","icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry","icon_ser_24ftlorry"]}}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal","faq"],"languages":{"en_sg":"en_sg"}}}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Terms and Conditions","tc_consumer_headline":"Terms and Conditions"}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/sg_content"}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Order | GoGoVan Singapore","description":"Place a Same Day Delivery order with GoGoVan and get your items moving."}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular_sg.html"}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Order | GoGoVan Singapore","description":"Place a Same Day Delivery order with GoGoVan and get your items moving."}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","quoting","faq","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = {"title":"404 | GoGoVan 台灣","404_title":"","404_body":["ᒥ你會出現在這裡，一定有原因的。","要活得有價值，就請好好把握自己的存在。ᒧ"],"404_sub":"五月天 - 阿信","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"回首頁"}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 關於GoGoVan，首創世界領先的O2O快遞平台 | GoGoVan 台灣","about_gogovan_headline":"關於GoGoVan","about_gogovan_body":["<span class=\"about-gogovan-desc-subtitle\">公司起源及宗旨</span>","GoGoVan於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案，至今已成為香港最多人使用的快遞服務之一。","2014年10月GoGoVan正式進駐台灣，是台灣第一個快遞APP，下載量已超過3萬次，註冊司機超過萬名，為台灣傳統快遞模式帶來新的衝擊。","GoGoVan透過手機APP即時提供客戶與數萬名快遞司機作媒合，完成便利、迅速的點對點快遞服務，提供客戶有更快捷的貨運方式，提高配送及工作效率，無論是個人或企業，皆是您長期配合的最佳選擇。","<span class=\"about-gogovan-desc-subtitle\">GoGoVan引領台灣物流改變現況</span>","<a href=\"/img/關於GoGoVan.jpg\" target=\"_blank\"><img src=\"/img/關於GoGoVan.jpg\" alt=\"關於GoGoVan\" width=\"100%\"/></a>"],"about_map_map_headline":"穿梭城市 改變生活","about_map_map_stat_name_countries":"國家","about_map_map_stat_name_cities":"城市","about_map_map_stat_name_registered":"貨車","about_hire_hire_headline":"想成為GoGoVan的一員？","about_hire_job_opportunity":"加入我們","about_hire_job_opportunity_headline":"司機招募","about_hire_job_opportunity_body":["【順路就有財路—GoGoVan持續招募全台司機】","GoGoVan是台灣第一個快遞O2O平台，客戶透過手機APP完成便利、迅速的快遞下單服務。司機同時也透過APP自由承接訂單，即時、彈性最方便。","請立即下載GoGoVan司機版APP註冊，成為GoGoVan的司機，就是現在！","＊成為正式GoGoVan機車快遞司機須通過驗證，以確保障司機服務品質。"],"about_hire_job_opportunity_register":"立即註冊","meta":{"description":"GoGoVan快遞App於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 關於GoGoVan，首創世界領先的O2O快遞平台 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/about","og:description":"GoGoVan快遞App於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_gogovan","prefix":"about_hire_job_opportunity"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_hire_job_opportunity":{"headline_style":true,"show_button":true},"about_map":{},"about_help":{}}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 為您客製化企業方案，依企業量身打造的物流方案，快速當日配 | GoGoVan 台灣","business_headline_content_headline":"為您客製化企業方案","business_headline_contents":["GoGoVan透過手機APP即時提供客戶與數萬名快遞司機作媒合，完成便利、迅速的點對點快遞服務，提供客戶有更快捷的貨運方式，提高配送及工作效率，是企業長期配合的最佳選擇。"],"contact_us":"聯繫我們","business_partnership_header":"企業合作","business_partnership_content":["省成本．增形象．多保障","1.節省營運成本: 無論是在時間或是人力成本上，GoGoVan皆幫您做到省時省力省錢的概念，再也不用等到固定時間才能寄件，更無須Call車叫配送，用電話語音查詢貨件進度，或是讓員工花時間找貨運單查詢單號，替企業大大省下營運成本。","2.增加企業形象: GoGoVan為響應全球環保節能的概念，應用GPS技術，即時配對距離最近的司機，不僅省時間，也減少車輛排放廢氣量，替企業提升環保節能減碳之形象。","3.多加一層保障: GoGoVan為了令客戶配送貨件安心，機車快遞貨件的理賠額度做到高於業界水準，免費讓客戶的商品多一重保障，送得更放心。","企業方案，更快更划算，立即撥打專線 0800-868-222 或 (02) 2502-1000"],"business_investor_header":"投資GoGoVan","business_investor_content":["GoGoVan提供了一個物流服務的平台。2013年成立至今，我們已涉足香港、新加坡、韓國、中國内地、印度及台灣的物流市場，除亞洲區之外，亦正迅速向全球擴展。","如果您喜歡 GoGoVan並希望投資我們的全球擴展計劃，歡迎聯絡GoGoVan。","讓我們一起改變物流的未來。"],"meta":{"description":"GoGoVan了解企業降低物流成本的需求，我們提供依企業量身打造的物流方案，快速當日配，請立即撥打專線與我們聯繫。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 為您客製化企業方案，依企業量身打造的物流方案，快速當日配 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/business","og:description":"GoGoVan了解企業降低物流成本的需求，我們提供依企業量身打造的物流方案，快速當日配，請立即撥打專線與我們聯繫。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 歡迎與我們聯繫 | GoGoVan 台灣","contact_section_title":"聯絡資訊","contact_content":"如果您有關於GoGoVan的任何疑問或建議，歡迎與我們聯系。我們將盡快回覆您。","contact_email":"info@gogovan.hk","contact_label_hotline_business":"企業合作","contact_hotline_business":"0800 868 222","contact_hotline_business_link":"0800868222","contact_label_hotline_cs":"客服專線","contact_hotline_cs":"02 2502 1000","contact_hotline_cs_link":"0225021000","contact_label_hotline_line":"LINE客服專區ID","contact_hotline_line":"@gogovan.tw","contact_label_hotline_line_driver":"LINE司機專區ID","contact_hotline_line_driver":"@gogovandriver","contact_label_address":"公司地址","contact_address":"台北市中山區松江路9號2樓","contact_input_name":"姓名","contact_input_email":"您的E-mail","contact_input_phone_number":"電話號碼","contact_input_title":"標題","contact_input_message":"您的留言……","contact_button_send":"發送","contact_thankyou_message":"多謝您的留言，我們將會儘快與您聯繫。","meta":{"description":"GoGoVan全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊。專人專送，請致電02-2502-1000, email至info@gogovan.tw或加入GoGoVan的LINE客服，ID：gogovan.tw。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 歡迎與我們聯繫 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"GoGoVan全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊。專人專送，請致電02-2502-1000, email至info@gogovan.tw或加入GoGoVan的LINE客服，ID：gogovan.tw。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/tw/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Z5CO70AHJzB6NeH1s23YF-xEWw5aAPsc9WAV1u4llHQ","name_name":"entry.513304797","name_email":"entry.724799615","name_phone_number":"entry.2144922500","name_title":"entry.1661687659","name_message":"entry.210873863"}}}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = {"title":"常見問題 | GoGoVan 台灣","faq_headline":"常見問題","faq_body":"以下為GOGOVAN 客戶版 APP常見問題，企業方案會因此有所不同，如您想詢問企業方案，敬請聯繫業務單位<a href=\"tel:02-2502-1000\">02-2502-1000</a>#223 ; 247 ; 253 或email : <a href=\"mailto:sales@gogovan.tw\">sales@gogovan.tw</a> 洽詢。","faq_other_questions":"<a href=\"http://www.gogovan.tw/blog/%E3%80%90%E5%85%AC%E5%91%8A%E3%80%91gogovan-app%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C-%E5%AE%A2%E6%88%B6%E7%89%88part-2/\">更多 Q&A 請點此處觀看</a>","faq_questions":[{"question":"請問GOGOVAN 有提供什麼車型？","answer":"GOGOVAN 提供機車快遞與一般貨車的配送服務。"},{"question":"當我確認叫件後，有看到司機資料是代表接件成功嗎？","answer":"是的，當您看到司機資料時，表示該名司機已接受叫件，您只需耐心等待司機10分鐘內來電，並向司機確認收／送件地點即可。若您看不到司機資料時，請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作洽詢。"},{"question":"為什麼我按了「找司機」後，只看到 「正在指派司機，司機資料將更新到頁面中」？","answer":"當您按了「找司機」確認叫件後，您看到「正在指派司機, 司機資料將更新到頁面中」這個訊息，代表系統正將您的訂單資料顯示於附近司機的APP。當司機成功承接訂單後，您將會收到司機的資料以便聯繫。"},{"question":"請問司機多久後會來收件？","answer":"由於收送件路線視情況而定，司機接單後10分鐘內會與您聯繫，您可以直接向司機確認他的位置訊息以及到達寄件地點的時間。"},{"question":"如果我想在司機接單後，想更換車型／更改地點／更正訂單時間或取消訂單該怎麼辦？","answer":"如果您打算取消或更改訂單服務內容，於上班時間內，請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明，我們會立即提供您最佳的處理方法；若是非上班時間，請先聯繫司機告知需要取消訂單。"},{"question":"如果沒有我想選擇的地點應該怎麼辦？","answer":"如果沒有您想選擇的地點，比如偏遠地區，請您致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>查詢運費價格。"},{"question":"我急需叫件，但找不到司機怎麼辦？","answer":"繁忙時段可能沒有司機接單。我們建議您在尋找司機時，選擇支付「小費」，提高接單的吸引力，將更有機會迅速找到司機。"},{"question":"訂單記錄會儲存多久？","answer":"訂單記錄會一直儲存在您的 GOGOVAN APP中，若您卸載手機APP，記錄就會因此消失。"},{"question":"如果我聯繫不到司機，且司機嚴重遲到或沒有出現該怎麼辦？","answer":"請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明，我們將為您重新安排車輛。"},{"question":"為何司機車牌跟 APP 上顯示的司機資料不一樣？","answer":"GOGOVAN 為確保服務品質，嚴禁司機「私自派單」行為。如司機車牌與 APP 上顯示的司機資料不一致時，請您致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明 ，我們將為您重新安排車輛，以確保您的權益。"},{"question":"請問運費的付費方式是？可以接受匯款嗎？","answer":"GOGOVAN APP 訂單皆以現金方式付費〈企業客戶除外〉，您可以在下單時選擇寄件人∕收件人付運費；為避免爭議，運費恕不接受匯款方式。"},{"question":"為什麼我收到的發票金額和當初付的運費金額不一樣？","answer":"GOGOVAN 在此提醒您，當司機跟您說明您的貨件可能有超大、超重或有其它附加費用產生，請您務必致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作訂單更改，切勿私下給予司機現金而未通知GOGOVAN ，導致發票金額和當初付的運費金額有所不同的情形發生。"}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = {"feature_7":{"src":"icon_feature7.png","src_2x":"icon_feature7@2x.png","width":57,"height":50},"feature_8":{"src":"icon_feature8.png","src_2x":"icon_feature8@2x.png","width":57,"height":50},"featrue_inner_7":{"src":"icon_feature7.png","src_2x":"icon_feature7@2x.png","width":37,"height":32},"featrue_inner_8":{"src":"icon_feature8.png","src_2x":"icon_feature8@2x.png","width":38,"height":32},"feature_lightbox_7":{"src":"feature_lightbox7.png","src_2x":"feature_lightbox7@2x.png","height":"100%"},"feature_lightbox_8":{"src":"feature_lightbox8.png","src_2x":"feature_lightbox8@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1.png","src_2x":"icon-how-it-work-step1@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"media_techinasia":{"src":"media_techinasia.png","src_2x":"media_techinasia@2x.png","height":30},"media_reuters":{"src":"media_reuters.png","src_2x":"media_reuters@2x.png","height":30},"media_jkos":{"src":"media_jkos.png","src_2x":"media_jkos@2x.png","height":30},"media_bnext":{"src":"media_bnext.png","src_2x":"media_bnext@2x.png","height":30},"media_mi":{"src":"media_mi.png","src_2x":"media_mi@2x.png","height":30},"media_inside":{"src":"media_inside.png","src_2x":"media_inside@2x.png","height":30},"media_ikea":{"src":"media_ikea.png","src_2x":"media_ikea@2x.png","height":30},"media_ifit":{"src":"media_ifit.png","src_2x":"media_ifit@2x.png","height":30},"media_honestbee":{"src":"media_honestbee.png","src_2x":"media_honestbee@2x.png","height":30},"media_business_weekly":{"src":"media_business_weekly.png","src_2x":"media_business_weekly@2x.png","height":30},"media_alibaba_entrepreneurs_fund":{"src":"media_alibaba_entrepreneurs_fund.png","src_2x":"media_alibaba_entrepreneurs_fund@2x.png","height":30}}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/tw/index/index_service","prefix":"index_service"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_hero":{"show_phone":true},"index_service":{"parent_width_style":"grid-10 grid-tablet-10 push-1 centered","width_style":"grid-4 grid-mobile-4 centered-mobile","disable_learn_more":false,"items":[{"img":"moving"},{"img":"shuttle"},{"img":"supplies"}]},"index_feature":{"class":"grid-3 grid-tablet-2 grid-mobile-2","items":[{"img":"feature_1","img_inner":"featrue_inner_1","img_lightbox":"feature_lightbox_1"},{"img":"feature_2","img_inner":"featrue_inner_2","img_lightbox":"feature_lightbox_2"},{"img":"feature_3","img_inner":"featrue_inner_3","img_lightbox":"feature_lightbox_3"},{"img":"feature_4","img_inner":"featrue_inner_4","img_lightbox":"feature_lightbox_4"},{"img":"feature_5","img_inner":"featrue_inner_5","img_lightbox":"feature_lightbox_5"},{"img":"feature_6","img_inner":"featrue_inner_6","img_lightbox":"feature_lightbox_6"},{"img":"feature_7","img_inner":"featrue_inner_7","img_lightbox":"feature_lightbox_7"},{"img":"feature_8","img_inner":"featrue_inner_8","img_lightbox":"feature_lightbox_8"}]},"index_howitwork":{"how_it_works":[{"image":"howitwork_step1","icon_active":"howitwork_icon_active_step1","icon_inactive":"howitwork_icon_inactive_step1"},{"image":"howitwork_step2","icon_active":"howitwork_icon_active_step2","icon_inactive":"howitwork_icon_inactive_step2"},{"image":"howitwork_step3","icon_active":"howitwork_icon_active_step3","icon_inactive":"howitwork_icon_inactive_step3"}]},"index_media":{"items":["media_reuters","media_bnext","media_techinasia","media_business_weekly","media_36kr","media_inside","media_alibaba_entrepreneurs_fund","media_wsj","media_honestbee","media_ifit","media_jkos","media_mi","media_ikea"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Z5CO70AHJzB6NeH1s23YF-xEWw5aAPsc9WAV1u4llHQ","name_name":"entry.513304797","name_email":"entry.724799615","name_phone_number":"entry.2144922500","name_title":"entry.1661687659","name_message":"entry.210873863"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","legal_headline":"使用者條款與隱私權政策-客戶版","meta":{"description":"GoGoVan快遞App在台灣使用者條款。","og:title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","og:description":"GoGoVan快遞App在台灣使用者條款。"}}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/tw_content"}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 feet","pricing_additionals_need_over_6ft_price":["$10","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Height Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$20","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","$10/pc (unlimited use)","$10/pc (unlimited use)"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["$10/pc (unlimited use)","$10/pc (unlimited use)","$10/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Toll Fee","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Tuck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel(09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"],"pricing_header_headline":"Total Fee = Fare + Surcharges (if applicable)","pricing_header_surcharges":"Surcharges","pricing_header_additional_charges":"Additional Charges","pricing_header_tunnel_tolls_and_bridge_tolls":"Toll Fee","pricing_header_parking_fees":"Parking Fee","pricing_header_dangerous_goods":"Dangerous Goods","pricing_header_refer":"Please refer the surcharges listed below and confirm the total fee with driver in advance.","pricing_header_enquiry":"If you have any enquiries, please contact us at ","pricing_header_tel_no":"35903399","pricing_dangerous_goods_dangerous_goods":"Dangerous Goods","pricing_dangerous_goods_title":["Type","Allowed Number","Charge"],"pricing_dangerous_goods_fire_extinguishers":["Fire Extinguishers","Unlimited","No surcharge"],"pricing_dangerous_goods_acetylene_cylinder":["Acetylene Cylinder","2 bottles","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_refrigerant":["Refrigerant","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_nitrogen":["Nitrogen","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_journey_fare_table":"Journey Fare Table for Van","pricing_dangerous_goods_hk_hk":"Hong Kong - Hong Kong","pricing_dangerous_goods_hk_kln":"Hong Kong - Kowloon","pricing_dangerous_goods_hk_nt":"Hong Kong - New Territories","pricing_dangerous_goods_kln_kln":"Kowloon - Kowloon","pricing_dangerous_goods_kln_nt":"Kowloon -  New Territories","pricing_dangerous_goods_nt_nt":"New Territories - New Territories","pricing_vehicle_dropdown_van":"Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5 Ton Truck","pricing_vehicle_dropdown_ton_truck_9":"9 Ton Truck"}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = {"title":"更改密碼 | GoGoVan 台灣","password_headline":"更改密碼","password_email":"電郵地址","password_password":"新密碼","password_confirm_password":"確認密碼","password_button_request_reset":"要求重設密碼","password_button_submit":"更改密碼","password_respond":"已更改密碼，請檢查電郵確認。","password_email_not_found":"你的電郵沒有被登記。請先<a href=\"#register\" class=\"global-text-blue dialog\">註冊</a>。","password_error_password_length":"您的密碼不足8位","password_error_password_equal":"對不起，兩次輸入的密碼並不相同。","password_error_token_expired":"此更改密碼連結已過時。"}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = {"pricing_image":{"href":"/img/機貨車價目表.jpg","target":"_blank"}}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","pricing_hero_quoting_headline":"想查報價？","pricing_hero_quoting_content":"試試我們的線上報價功能！只需輸入出發地及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"費用說明","pricing_headline_content":"GoGoVan運費計價方式採用里程數計費，下單時APP會自動計算出運費。您還可以使用附加服務，讓您生活更方便，物超所值。","pricing_quoting_header":"線上報價查詢","pricing_headline_header":"費用說明","pricing_pricing_table_header":"附加服務","meta":{"description":"試試我們的線上報價功能，只需輸入起點及目的地，價格一目了然！GoGoVan快遞App的收費是以里程數計費，不同情況下可能會產生代付、代購費及排隊等費用。","keywords":"價格、報價、即時報價、運費試算","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"試試我們的線上報價功能，只需輸入起點及目的地，價格一目了然！GoGoVan快遞App的收費是以里程數計費，不同情況下可能會產生代付、代購費及排隊等費用。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = {"pricing_image":{"title":"機貨車價目表","src":"機貨車價目表.jpg","width":"100%","alt":"機貨車價目表"}}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/pricing/pricing_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"}],"aside":{"prefix":"pricing","bottom":"300","items":[{"target":"quoting","offset":"-114"},{"target":"headline","offset":"-114"},{"target":"pricing_table","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"pricing_image","prefix":"pricing_table"}]}}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 隱私權政策","privacy_headline":"隱私權政策","meta":{}}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/tw_content"}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用試算 | GoGoVan 台灣","dollar_code":"NT$","quoting_first_input":"出發地","quoting_last_input":"目的地","quoting_get_btn":"查詢報價","quoting_clear_btn":"清除","quoting_service_title":"選擇車種","quoting_price_prefix":"","quoting_price_postfix":" 起","quoting_service_select_btn":"選擇","quoting_place_order_btn":"即刻落單","quoting_service_motorcycle_title":"機車","quoting_service_motorcycle_body":"參考載重: 20公斤<br />體積限制(公分): 60(長) x 40(寬) x 30(高)","quoting_service_struck_title":"廂型貨車","quoting_service_struck_body":"參考載重: 600公斤<br />體積限制(公分): 150(長) x 100(寬) x 100(高)","quoting_service_mtruck_title":"貨車(1.75噸)","quoting_service_mtruck_body":"參考載重: 1000公斤<br />體積限制(公分): 300(長) x 150(寬) x 150(高)","meta":{"description":"試試我們的線上報價功能，只需輸入出發地及目的地，價格一目了然！無論機車快遞、貨車宅配通通當日配送完成。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 費用試算 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"試試我們的線上報價功能，只需輸入出發地及目的地，價格一目了然！無論機車快遞、貨車宅配通通當日配送完成。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_done":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_motorcycle_white":{"src":"icon_motorcycle_white.png","src_2x":"icon_motorcycle_white@2x.png","width":"72","alt":"機車"},"icon_motorcycle_blue":{"src":"icon_motorcycle_blue.png","src_2x":"icon_motorcycle_blue@2x.png","width":"72","alt":"機車"},"icon_struck_white":{"src":"icon_van_white.png","src_2x":"icon_van_white@2x.png","width":"72","alt":"廂型貨車"},"icon_struck_blue":{"src":"icon_van_blue.png","src_2x":"icon_van_blue@2x.png","width":"72","alt":"廂型貨車"},"icon_mtruck_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"貨車(1.75噸)"},"icon_mtruck_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"貨車(1.75噸)"}}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"motorcycle","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"motorcycle"}},{"type":"struck","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"struck"}},{"type":"mtruck","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mtruck"}}]}}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = {"title":"服務說明，全方位快遞APP服務，與你一拍即合 | GoGoVan 台灣","service_content_headline":"全方位服務，與你一拍即合","service_content_contents":["使用APP叫件，您可以根據不同配送需求，選擇附加服務。"],"service_content_photos_headline":"運送/附加服務","service_content_photos_title_0":"文件","service_content_photos_title_1":"貨品","service_content_photos_title_2":"商品","service_content_photos_title_3":"食品","service_content_photos_body_0":"限時件最快1.5小時內送達。還可以附加服務幫您代辦文件，省去等待時間。","service_content_photos_body_1":"專人專車派送，一般件也當日到貨。還可以附加服務幫您到不同倉庫提存貨品。","service_content_photos_body_2":"不破壞商品精緻包裝，免除對商品壓毀的損傷。還可以附加服務代付／代購，省時最方便。","service_content_photos_body_3":"無論是精緻糕點、熱銷便當小吃，賞味期內送達。還可以附加服務代排隊，熱銷食／飲品免等待。","service_content_future":"GoGoVan目前提供機車快遞以及3.5頓貨車當日快遞服務!","meta":{"description":"GoGoVan全方位快遞App服務，與你一拍即合。使用APP叫件，您可以根據不同配送需求，選擇附加服務。","keywords":"服務、服務內容、運送服務物、附加服務","og:image":"/img/aboutus-banner.jpg","og:title":"服務說明，全方位快遞APP服務，與你一拍即合 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/service","og:description":"GoGoVan全方位快遞App服務，與你一拍即合。使用APP叫件，您可以根據不同配送需求，選擇附加服務。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {"goods":{"src":"service_image_goods.jpg","src_2x":"service_image_goods@2x.jpg"},"documents":{"src":"service_image_documents.jpg","src_2x":"service_image_documents@2x.jpg"},"food":{"src":"service_image_food.jpg","src_2x":"service_image_food@2x.jpg"},"valuables":{"src":"service_image_valuables.jpg","src_2x":"service_image_valuables@2x.jpg"},"step_1":{"src":"service_comic_1.jpg","src_2x":"service_comic_1@2x.png","width":"33%"},"step_2":{"src":"service_comic_2.jpg","src_2x":"service_comic_2@2x.png","width":"33%"},"step_3":{"src":"service_comic_3.jpg","src_2x":"service_comic_3@2x.png","width":"33%"}}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"partials/download_app"}],"service_contents":[{"type":"service_headline2","content":"service_content"},{"type":"service_photos"},{"type":"service_comic"}],"service_content_photos":{"photo_grid":["documents","goods","valuables","food"]},"service_content_comic":{"photo_grid":["step_1","step_2","step_3"]}}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"zh-tw":"zh-tw"}}}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 網頁下單 | GoGoVan 台灣","meta":{"description":"GoGoVan快遞APP - 網頁下單, 全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊，當日配送沒問題。"}}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 網頁下單 | GoGoVan 台灣","meta":{"description":"GoGoVan快遞APP - 網頁下單, 全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊，當日配送沒問題。"}}

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var LoginFacebook =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginFacebook, _React$Component);

  function LoginFacebook(props) {
    var _this;

    _classCallCheck(this, LoginFacebook);

    _this = _possibleConstructorReturn(this, (LoginFacebook.__proto__ || Object.getPrototypeOf(LoginFacebook)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      isClickLogin: false,
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json"))
    };
    _this.login = _this.login.bind(_assertThisInitialized(_this));
    _this.onClickFacebookLogin = _this.onClickFacebookLogin.bind(_assertThisInitialized(_this));
    _this.responseFacebook = _this.responseFacebook.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginFacebook, [{
    key: "onClickFacebookLogin",
    value: function onClickFacebookLogin() {
      this.facebookLogin.click();
    }
  }, {
    key: "responseFacebook",
    value: function responseFacebook(callback) {
      var _this2 = this;

      if (this.state.isClickLogin) {
        var json = {
          access_token: callback.accessToken
        };
        Object(__WEBPACK_IMPORTED_MODULE_6__api_user__["a" /* facebookLogin */])(json, this.props.currentLocale).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (result.user.phone_number === null) {
            _this2.props.setUserEmail(result.user.email);

            _this2.props.setUserPassword(result.user.session_token);

            _this2.props.setUserName(result.user.name); // close login modal


            if (_this2.props.isShowLoginModal) {
              _this2.props.setIsShowLoginModal();
            } // close register modal


            if (_this2.props.isShowRegisterModal) {
              _this2.props.setIsShowRegisterModal();
            } // open update modal


            if (!_this2.props.isShowUpdateUserModal) {
              _this2.props.setIsShowUpdateUserModal();
            }
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);

            _this2.props.setUserInfo(result.user);

            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      }
    }
  }, {
    key: "login",
    value: function login() {
      var _this3 = this;

      var jsonDev = {
        user: {
          email: this.props.email,
          password: this.props.password
        }
      };

      if (this.props.password.length < 8) {
        return this.props.setErrorCode(1);
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__api_user__["d" /* login */])(jsonDev, this.props.currentLocale).then(function (response) {
        if (response.status !== 200) {
          return response;
        }

        return response.json();
      }).then(function (result) {
        if (result.status === 401) {
          _this3.props.setErrorCode(result.status);
        } else {
          _this3.props.setUserInfo(result.user);

          _this3.props.toggle();
        }
      }).catch(function (error) {
        console.warn('Request failed', error);
      });

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _jsx(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props___default.a, {
        appId: "772024769585869",
        version: "6.0",
        fields: "name,email,picture",
        scope: "public_profile,email",
        disableMobileRedirect: true,
        render: function render(renderProps) {
          return _jsx("button", {
            type: "submit",
            className: "".concat(__WEBPACK_IMPORTED_MODULE_8__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_8__login_sass___default.a.facebook),
            onClick: function onClick() {
              _this4.setState({
                isClickLogin: true
              });

              renderProps.onClick();
            }
          }, void 0, _this4.props.text);
        },
        callback: this.responseFacebook
      });
    }
  }]);

  return LoginFacebook;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal,
    isShowRegisterModal: state.user.isShowRegisterModal,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_10__actions_user__["h" /* setUserInfo */],
  setUserName: __WEBPACK_IMPORTED_MODULE_10__actions_user__["i" /* setUserName */],
  setUserEmail: __WEBPACK_IMPORTED_MODULE_10__actions_user__["g" /* setUserEmail */],
  setIsShowLoginModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["d" /* setIsShowLoginModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["f" /* setIsShowUpdateUserModal */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["e" /* setIsShowRegisterModal */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_10__actions_user__["j" /* setUserPassword */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_8__login_sass___default.a)(LoginFacebook)));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



 // import { FormattedMessage } from 'react-intl';



 // import LoginRegisterMessagesRef from './LoginRegisterMessageRef';

 // const messagesRef = LoginRegisterMessagesRef;

var LoginModuleRedirectText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginModuleRedirectText, _React$Component);

  function LoginModuleRedirectText(props) {
    var _this;

    _classCallCheck(this, LoginModuleRedirectText);

    _this = _possibleConstructorReturn(this, (LoginModuleRedirectText.__proto__ || Object.getPrototypeOf(LoginModuleRedirectText)).call(this, props));
    _this.state = {
      normalText: props.normalText,
      btnText: props.btnText
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginModuleRedirectText, [{
    key: "toggle",
    value: function toggle() {
      if (this.props.isShowRegisterModal) {
        this.props.setIsShowRegisterModal();
      }

      if (this.props.isShowUpdateUserModal) {
        this.props.setIsShowUpdateUserModal();
      }

      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_5__login_sass___default.a.redireactText)
      }, void 0, typeof this.props.currentLocale !== 'undefined' && this.props.currentLocale === 'ko-KR' ? _jsx("span", {}, void 0, this.state.normalText, _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalTextBlue, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.cursorPointer, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.dialog, " dialog-change"),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText)) : _jsx("span", {}, void 0, _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalTextBlue, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.cursorPointer, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.dialog, " dialog-change"),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText), this.state.normalText));
    }
  }]);

  return LoginModuleRedirectText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal,
    isShowRegisterModal: state.user.isShowRegisterModal,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  setIsShowLoginModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["d" /* setIsShowLoginModal */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["e" /* setIsShowRegisterModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_5__login_sass___default.a)(LoginModuleRedirectText)));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



 // import { FormattedMessage } from 'react-intl';




 // import LoginRegisterMessagesRef from '../LoginRegisterMessageRef';






var RegisterButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RegisterButton, _React$Component);

  function RegisterButton(props) {
    var _this;

    _classCallCheck(this, RegisterButton);

    _this = _possibleConstructorReturn(this, (RegisterButton.__proto__ || Object.getPrototypeOf(RegisterButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      setting: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json")),
      lang: lang
    };
    _this.onClickRegister = _this.onClickRegister.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RegisterButton, [{
    key: "onClickRegister",
    value: function onClickRegister() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          currentLocale = _props.currentLocale;
      var json = {
        user: {
          email: this.props.user.email,
          password: this.props.password_1,
          phone_number: ['sg'].includes(this.state.lang) ? this.props.user.phone.toString() : parseInt(this.props.user.phone, 10),
          name: this.props.user.name,
          has_agreed_to_receive_gogovan_updates: this.props.user.has_agreed_to_receive_gogovan_updates,
          has_agreed_to_receive_third_parties_updates: this.props.user.has_agreed_to_receive_third_parties_updates
        }
      }; // if is normal register, not fb register

      if (!this.props.isFromUpdateUserInfoModal) {
        this.props.setUserPassword(this.props.password_1); // check whether register is valid

        var isPassCheck = true;
        Object.entries(json.user).forEach(function (item) {
          if (item[1] === '') {
            isPassCheck = false;
          }
        });

        if (this.props.password_1 === '') {
          isPassCheck = false;
        }

        if (!isPassCheck) return false;
      } // check phone pattern


      var patt = new RegExp(this.state.setting.PHONE_REGEX);

      if (!patt.test(user.phone) && user.phone !== '') {
        return this.props.setErrorCode(4);
      } // check email pattern


      var emailPatt = new RegExp(this.state.setting.EMAIL_REGEX);

      if (!emailPatt.test(user.email) && user.email !== '') {
        return this.props.setErrorCode(0);
      }

      if (this.props.isFromUpdateUserInfoModal) {
        this.props.setErrorCode(0);
        json = {
          phone_number: parseInt(this.props.user.phone, 10)
        };
        var fbAuth = {
          user: {
            email: this.props.email,
            password: this.props.password
          }
        };
        Object(__WEBPACK_IMPORTED_MODULE_7__api_user__["b" /* fbuserProfileUpdate */])(fbAuth, json, this.props.currentLocale, null).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (typeof result.error !== 'undefined') {
            return _this2.props.setErrorCode(7);
          }

          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.id, result.name, result.email, result.session_token, result.phone_number, result.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.meta, result.gender, result.industry, result.date_of_birth, result.profile_photo);

          _this2.props.setUserInfo(result.user);

          setTimeout(function () {
            Object(__WEBPACK_IMPORTED_MODULE_8__actions_user__["f" /* setIsShowUpdateUserModal */])();
            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }, 500);
          return '';
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      } else {
        if (this.props.password_1.length < 8) {
          return this.props.setErrorCode(1);
        }

        if (this.props.password_1 !== this.props.password_2) {
          return this.props.setErrorCode(2);
        }

        this.props.setUserPassword(this.props.password_1);

        if (user.name.length < 1) {
          return console.warn('Name cannot be empty');
        }

        Object(__WEBPACK_IMPORTED_MODULE_7__api_user__["f" /* register */])(json, this.props.currentLocale).then(function (response) {
          return response.json();
        }).then(function (result) {
          var errorCode = 0;

          if (typeof result.errors !== 'undefined') {
            for (var i = 0; i < Object.keys(result.errors).length; i += 1) {
              if (Object.keys(result.errors)[i] === 'email') {
                errorCode += 6;
              } else if (Object.keys(result.errors)[i] === 'phone_number') {
                errorCode += 7;
              }
            }
          }

          if (errorCode !== 0) {
            return _this2.props.setErrorCode(errorCode);
          }

          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);

          _this2.props.setUserInfo(result.user);

          _this2.props.setIsShowRegisterModal();

          window.location.href = Object(__WEBPACK_IMPORTED_MODULE_10__service_asset_json__["a" /* getLink */])('order', currentLocale);
          return '';
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("button", {
        type: "submit",
        onClick: function onClick() {
          _this3.props.onClickisClickButton();

          _this3.onClickRegister();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_6__login_sass___default.a.register),
        block: true
      }, void 0, this.props.text);
    }
  }]);

  return RegisterButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(RegisterButton, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    isFromUpdateUserInfoModal: false,
    password_1: '',
    password_2: '',
    email: '',
    password: '',
    onClickisClickButton: function onClickisClickButton() {},
    className: ''
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    user: state.user,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_8__actions_user__["h" /* setUserInfo */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_8__actions_user__["j" /* setUserPassword */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_8__actions_user__["e" /* setIsShowRegisterModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_8__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_6__login_sass___default.a)(RegisterButton)));

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && process.env.SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(155), __webpack_require__(884)(module)))

/***/ }),
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "382435b5.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b3df5d0f.png";

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FooterLinkStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SignUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NeedHelpMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(759);
var _templateObject = /*#__PURE__*/ _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 100vh;\n  padding: 50px 0;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  min-height: 100vh;\n  padding: 50px 0;\n  align-items: center;\n  justify-content: center;\n"]),
    _templateObject2 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  text-align: center;\n  width: 404px;\n  padding: 0 10px;\n"], ["\n  text-align: center;\n  width: 404px;\n  padding: 0 10px;\n"]),
    _templateObject3 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  margin-bottom: 32px;\n"], ["\n  margin-bottom: 32px;\n"]),
    _templateObject4 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }


var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject);
var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2);
var Logo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].img(_templateObject3);
var FooterLinkStyles = "\n  margin-bottom: 16px;\n  font-family: \"Lato\",\"Lucida Grande\",\"Helvetica Neue\",Helvetica,Arial,Verdana,sans-serif;\n  font-size: 14px;\n";
var SignUp = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);
var BusinessAccount = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);
var NeedHelpMessage = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LoginButton_RegisterButton__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoginModuleRedirectText__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }






















var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_10__LoginButton_LoginButton__["a" /* default */], {});

var _ref2 = _jsx("hr", {});

var UpdateUserInfoModule =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UpdateUserInfoModule, _React$Component);

  function UpdateUserInfoModule(props) {
    var _this;

    _classCallCheck(this, UpdateUserInfoModule);

    _this = _possibleConstructorReturn(this, (UpdateUserInfoModule.__proto__ || Object.getPrototypeOf(UpdateUserInfoModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      user: {
        phone: ''
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UpdateUserInfoModule, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var phone = document.getElementById('phone');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale]; // const phonePatt = new RegExp(this.state.errorMessageLocale.PHONE_REGEX);

        if (phone.value === '') {
          phone.setCustomValidity(errorMessage.blank_field);
          this.setErrorCode(0);
        } else {
          phone.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setPhone",
    value: function setPhone(e) {
      // if (Number.isNaN(e.target.value)) {
      this.props.setUserPhone(e.target.value); // }
      // console.warn(e.target.value);

      this.updateStateItem('phone', e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "updateStateItem",
    value: function updateStateItem(item, value) {
      this.setState({
        user: __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default()(this.state.user, _defineProperty({}, item, {
          $set: value
        }))
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowUpdateUserModal();
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("span", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Modal */], {
        isOpen: this.props.isShowUpdateUserModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.resizeModal, " text-center"),
        contentClassName: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.resizeModalContent2,
        style: {
          backgroundColor: '#f7f7f7 !important'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: function onClick() {
          return _this2.toggle();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.infoCloseRightButton)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* ModalBody */], {}, void 0, _jsx("div", {
        className: "".concat(this.state.errorCode !== 0 ? __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.dialogErrorMessage : '', " col-11")
      }, void 0, _jsx("p", {}, void 0, this.state.errorCode === 401 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_login_info_incorrect, this.state.modelDataDefaultLocale.error_message_login_info_incorrect)) : '', this.state.errorCode === 1 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_password_length_not_enough, this.state.modelDataDefaultLocale.error_message_password_length_not_enough)) : '', this.state.errorCode === 2 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_password_not_match, this.state.modelDataDefaultLocale.error_message_password_not_match)) : '', this.state.errorCode === 4 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_please_enter_telephone_number, this.state.modelDataDefaultLocale.error_message_please_enter_telephone_number)) : '', this.state.errorCode === 7 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_telephone_number_in_use, this.state.modelDataDefaultLocale.error_message_telephone_number_in_use)) : '')), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.update_profile_modal_title, this.state.modelDataDefaultLocale.update_profile_modal_title)), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: "Email",
        id: "email",
        name: "email",
        value: this.props.email,
        onChange: this.setEmail,
        disabled: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        type: "text",
        id: "name",
        name: "name",
        placeholder: "Name",
        value: this.props.name,
        onChange: this.setName,
        disabled: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        type: "text",
        id: "phone",
        name: "phone",
        placeholder: "Phone",
        value: this.state.user.phone,
        onChange: function onChange(e) {
          _this2.setPhone(e);
        },
        required: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__LoginButton_RegisterButton__["a" /* default */], {
        user: this.state.user,
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.toggle,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        isFromUpdateUserInfoModal: true,
        text: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_register_btn, this.state.modelDataDefaultLocale.register_modal_register_btn)
      })) : _ref, _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.orLine
      }, void 0, _ref2, _jsx("span", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.or,
        style: {
          backgroundColor: '#f7f7f7'
        }
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_or, this.state.modelDataDefaultLocale.register_modal_or))))), _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.registerIfNotYet)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__LoginModuleRedirectText__["a" /* default */], {
        target: "#register",
        normalText: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_normal_message, this.state.modelDataDefaultLocale.register_modal_normal_message),
        btnText: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_redirect_to_login_btn, this.state.modelDataDefaultLocale.register_modal_redirect_to_login_btn)
      })))));
    }
  }]);

  return UpdateUserInfoModule;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(UpdateUserInfoModule, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    email: ''
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    name: state.user.name,
    currentLocale: state.intl.locale,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_12__actions_user__["a" /* login */],
  setUserPhone: __WEBPACK_IMPORTED_MODULE_12__actions_user__["k" /* setUserPhone */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_12__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a)(UpdateUserInfoModule)));

/***/ }),
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(528);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(533);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(582);
var ITERATOR = __webpack_require__(454)('iterator');
var Iterators = __webpack_require__(469);
module.exports = __webpack_require__(446).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(801), __esModule: true };

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "96a350a4.png";

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedLoginForm; });
/* unused harmony export LoginForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_LoginFacebook__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */














var LoginForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _classCallCheck(this, LoginForm);

    _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      email: '',
      password: '',
      tooltipOpen: false,
      errorCode: 0,
      isClickButton: false,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.getEmail = _this.getEmail.bind(_assertThisInitialized(_this));
    _this.getPassword = _this.getPassword.bind(_assertThisInitialized(_this));
    _this.setEmail = _this.setEmail.bind(_assertThisInitialized(_this));
    _this.setPassword = _this.setPassword.bind(_assertThisInitialized(_this));
    _this.tooltipToggle = _this.tooltipToggle.bind(_assertThisInitialized(_this));
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  } // Add custom Validation String


  _createClass(LoginForm, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var email = document.getElementById('email');
        var password = document.getElementById('password');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale];
        var emailPatt = new RegExp(this.state.errorMessageLocale.EMAIL_REGEX);

        if (email.value === '' || email.value === null || !emailPatt.test(email.value)) {
          this.setErrorCode(0);
          email.setCustomValidity(errorMessage.incorrect_email);
        } else {
          email.setCustomValidity('');
        }

        if (password.value === '') {
          this.setErrorCode(0);
          password.setCustomValidity(errorMessage.blank_field);
        } else {
          password.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setEmail",
    value: function setEmail(e) {
      this.setState({
        email: e.target.value
      });
      this.props.login(e.target.value, this.props.password);
    }
  }, {
    key: "setPassword",
    value: function setPassword(e) {
      this.setState({
        password: e.target.value
      });
      this.props.login(this.props.email, e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      return this.state.email;
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.state.password;
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var currentLocale = this.props.currentLocale;
      var errorMessage;

      switch (this.state.errorCode) {
        case 1:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_message_password_length_not_enough', currentLocale);
          break;

        case 401:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_message_login_info_incorrect', currentLocale);
          break;

        default:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_wrong_modal_title', currentLocale);
      }

      return _jsx("div", {}, void 0, this.state.errorCode !== 0 && _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.error
      }, void 0, errorMessage), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.page_login, this.state.modelDataDefaultLocale.page_login)), _jsx(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        },
        method: "post"
      }, void 0, _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_email_input, this.state.modelDataDefaultLocale.login_modal_email_input),
        id: "email",
        name: "email",
        value: this.state.email,
        onChange: this.setEmail,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_password_input, this.state.modelDataDefaultLocale.register_modal_password_input),
        id: "password",
        name: "password",
        type: "password",
        value: this.state.password,
        onChange: this.setPassword,
        required: true
      })), _jsx("div", {}, void 0, _jsx("a", {
        href: "/password",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.forgetPassword)
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_forgot_password_btn, this.state.modelDataDefaultLocale.login_modal_forgot_password_btn))), _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_btn, this.state.modelDataDefaultLocale.login_modal_login_btn)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_LoginFacebook__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_with_fb_btn, this.state.modelDataDefaultLocale.login_modal_login_with_fb_btn)
      })) : _jsx(__WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_btn, this.state.modelDataDefaultLocale.login_modal_login_btn)
      }))));
    }
  }]);

  return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(LoginForm, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    email: '',
    onLogin: function onLogin() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_10__actions_user__["a" /* login */]
};
var ConnectedLoginForm = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a)(LoginForm));


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedSignupForm; });
/* unused harmony export SignupForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_RegisterButton__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login_LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Login_LoginButton_LoginFacebook__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__signup_signup_component_styles__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__service_asset_json__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }


















var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_10__components_Login_LoginButton_LoginButton__["a" /* default */], {});

var SignupForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignupForm, _React$Component);

  function SignupForm(props) {
    var _this;

    _classCallCheck(this, SignupForm);

    _this = _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      user: {
        email: '',
        phone: '',
        name: '',
        password_1: '',
        password_2: ''
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.getEmail = _this.getEmail.bind(_assertThisInitialized(_this));
    _this.getPassword = _this.getPassword.bind(_assertThisInitialized(_this));
    _this.setEmail = _this.setEmail.bind(_assertThisInitialized(_this));
    _this.setPassword = _this.setPassword.bind(_assertThisInitialized(_this));
    _this.setPhone = _this.setPhone.bind(_assertThisInitialized(_this));
    _this.setName = _this.setName.bind(_assertThisInitialized(_this));
    _this.tooltipToggle = _this.tooltipToggle.bind(_assertThisInitialized(_this));
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.updateStateItem = _this.updateStateItem.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SignupForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.currentLocale === 'en-SG') {
        this.props.setHaveAgreedToReceiveGogovanUpdates();
        this.props.setHaveAgreedToReceiveThirdPartiesUpdates();
      }
    } // Add custome Validation String

  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var email = document.getElementById('email');
        var phone = document.getElementById('phone');
        var name = document.getElementById('name');
        var password1 = document.getElementById('password_1');
        var password2 = document.getElementById('password_2');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale];
        var emailPatt = new RegExp(this.state.errorMessageLocale.EMAIL_REGEX);

        if (email.value === '' || email.value === null || !emailPatt.test(email.value)) {
          email.setCustomValidity(errorMessage.incorrect_email);
          this.setErrorCode(0);
        } else {
          email.setCustomValidity('');
        }

        if (phone.value === '') {
          this.setErrorCode(0);
          phone.setCustomValidity(errorMessage.blank_field);
        } else {
          phone.setCustomValidity('');
        }

        if (name.value === '') {
          this.setErrorCode(0);
          name.setCustomValidity(errorMessage.blank_field);
        } else {
          name.setCustomValidity('');
        }

        if (password1.value === '') {
          this.setErrorCode(0);
          password1.setCustomValidity(errorMessage.blank_field);
        } else {
          password1.setCustomValidity('');
        }

        if (password2.value === '') {
          this.setErrorCode(0);
          password2.setCustomValidity(errorMessage.blank_field);
        } else {
          password2.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setPassword",
    value: function setPassword(e) {
      this.updateStateItem(e.target.id, e.target.value);
    }
  }, {
    key: "setPhone",
    value: function setPhone(e) {
      this.updateStateItem('phone', e.target.value);
      this.props.setUserPhone(e.target.value);
    }
  }, {
    key: "setName",
    value: function setName(e) {
      this.updateStateItem('name', e.target.value);
      this.props.setUserName(e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      return this.state.email;
    }
  }, {
    key: "setEmail",
    value: function setEmail(e) {
      this.updateStateItem('email', e.target.value);
      this.props.setUserEmail(e.target.value);
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.state.password;
    }
  }, {
    key: "updateStateItem",
    value: function updateStateItem(item, value) {
      this.setState({
        user: __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default()(this.state.user, _defineProperty({}, item, {
          $set: value
        }))
      });
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentLocale = this.props.currentLocale;
      var errorMessage;

      switch (this.state.errorCode) {
        case 1:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_password_length_not_enough', currentLocale);
          break;

        case 2:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_password_not_match', currentLocale);
          break;

        case 4:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_please_enter_telephone_number', currentLocale);
          break;

        case 6:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t', currentLocale);
          break;

        case 7:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_telephone_number_in_use', currentLocale);
          break;

        case 13:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t', currentLocale);
          break;

        case 401:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_login_info_incorrect', currentLocale);
          break;

        default:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_wrong_modal_title', currentLocale);
      }

      var showLoginLink = this.state.errorCode === 6 || this.state.errorCode === 13;
      return _jsx("div", {}, void 0, this.state.errorCode !== 0 && _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.error
      }, void 0, errorMessage, showLoginLink && _jsx("div", {}, void 0, Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t_2', currentLocale), _jsx(__WEBPACK_IMPORTED_MODULE_13__signup_signup_component_styles__["a" /* ErrorLink */], {
        href: "/login",
        tabIndex: 0
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('login_modal_login_btn', currentLocale)))), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_title, this.state.modelDataDefaultLocale.register_modal_title)), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        },
        method: "post"
      }, void 0, _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_email_input, this.state.modelDataDefaultLocale.register_modal_email_input),
        id: "email",
        name: "email",
        value: this.state.user.email,
        onChange: this.setEmail,
        ref: function ref(i) {
          _this2.emailInput = i;
        },
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        type: "text",
        id: "name",
        name: "name",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_username_input, this.state.modelDataDefaultLocale.register_modal_username_input),
        value: this.state.user.name,
        onChange: this.setName,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        type: "text",
        id: "phone",
        name: "phone",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_phone_input, this.state.modelDataDefaultLocale.register_modal_phone_input),
        value: this.state.user.phone,
        onChange: this.setPhone,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_password_input, this.state.modelDataDefaultLocale.register_modal_password_input),
        id: "password_1",
        name: "password",
        type: "password",
        value: this.state.user.password,
        onChange: this.setPassword,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_confirm_password_input, this.state.modelDataDefaultLocale.register_modal_confirm_password_input),
        id: "password_2",
        name: "password",
        type: "password",
        value: this.state.password,
        onChange: this.setPassword,
        required: true
      })), this.props.currentLocale === 'en-SG' ? [_jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding)
      }, "0", _jsx("p", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Input */], {
        type: "checkbox",
        onChange: function onChange() {
          _this2.props.setHaveAgreedToReceiveGogovanUpdates();
        },
        checked: this.props.has_agreed_to_receive_gogovan_updates
      }), Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('register_checkbox_gogovan_updates', currentLocale))), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding
      }, "1", _jsx("p", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Input */], {
        type: "checkbox",
        onChange: function onChange() {
          _this2.props.setHaveAgreedToReceiveThirdPartiesUpdates();
        },
        checked: this.props.has_agreed_to_receive_third_parties_updates
      }), Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('register_checkbox_third_parties_updates', currentLocale))), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding
      }, "2", _jsx("span", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa,
        dangerouslySetInnerHTML: {
          __html: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_info_gogovan_tos, this.state.modelDataDefaultLocale.register_info_gogovan_tos)
        }
      }))] : '', _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_RegisterButton__["a" /* default */], {
        className: "button register",
        user: this.state.user,
        onClickisClickButton: this.onClickisClickButton,
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onSignup,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        password_1: this.state.user.password_1,
        password_2: this.state.user.password_2,
        text: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_register_btn, this.state.modelDataDefaultLocale.register_modal_register_btn)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11__components_Login_LoginButton_LoginFacebook__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onSignup,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        text: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_with_fb_btn, this.state.modelDataDefaultLocale.login_modal_login_with_fb_btn)
      })) : _ref)));
    }
  }]);

  return SignupForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(SignupForm, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onSignup: function onSignup() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    has_agreed_to_receive_gogovan_updates: state.user.has_agreed_to_receive_gogovan_updates,
    has_agreed_to_receive_third_parties_updates: state.user.has_agreed_to_receive_third_parties_updates,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_15__actions_user__["a" /* login */],
  setUserName: __WEBPACK_IMPORTED_MODULE_15__actions_user__["i" /* setUserName */],
  setUserEmail: __WEBPACK_IMPORTED_MODULE_15__actions_user__["g" /* setUserEmail */],
  setUserPhone: __WEBPACK_IMPORTED_MODULE_15__actions_user__["k" /* setUserPhone */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_15__actions_user__["j" /* setUserPassword */],
  setHaveAgreedToReceiveGogovanUpdates: __WEBPACK_IMPORTED_MODULE_15__actions_user__["b" /* setHaveAgreedToReceiveGogovanUpdates */],
  setHaveAgreedToReceiveThirdPartiesUpdates: __WEBPACK_IMPORTED_MODULE_15__actions_user__["c" /* setHaveAgreedToReceiveThirdPartiesUpdates */]
};
var ConnectedSignupForm = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a)(SignupForm));


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_login_component_styles__ = __webpack_require__(766);
var _templateObject = /*#__PURE__*/ _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]),
    _templateObject2 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  color: #fff;\n"], ["\n  color: #fff;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



var Login = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject, __WEBPACK_IMPORTED_MODULE_1__login_login_component_styles__["c" /* FooterLinkStyles */]); // BET-337
// ErrorLink should be in signup-form.component.styles.js but importing that file would cause styles loss on browser refresh
// We might want to take a look at https://www.styled-components.com/docs/advanced#server-side-rendering

var ErrorLink = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].a(_templateObject2);


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:16px;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus{outline:0!important}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:8px;margin-bottom:.5rem}p{margin-top:0;margin-bottom:16px;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:16px;margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:8px;margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 16px;margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:16px;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 16px;margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}[role=button],a,area,button,input:not([type=range]),label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:12px;padding-top:.75rem;padding-bottom:12px;padding-bottom:.75rem;color:#868e96;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:8px;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:8px;margin-bottom:.5rem;font-size:24px;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:8px;margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.h1,h1{font-size:40px;font-size:2.5rem}.h2,h2{font-size:32px;font-size:2rem}.h3,h3{font-size:28px;font-size:1.75rem}.h4,h4{font-size:24px;font-size:1.5rem}.h5,h5{font-size:20px;font-size:1.25rem}.h6,h6{font-size:16px;font-size:1rem}.lead{font-size:20px;font-size:1.25rem;font-weight:300}.display-1{font-size:96px;font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:88px;font-size:5.5rem}.display-3{font-size:72px;font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:56px;font-size:3.5rem}hr{margin-top:16px;margin-top:1rem;margin-bottom:16px;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:8px;margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:16px;margin-bottom:1rem;font-size:20px;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#868e96}.blockquote-footer:before{content:\"\\2014   \\A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:4px;padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem}.figure{display:inline-block}.figure-img{margin-bottom:8px;margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#868e96}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:3.2px 6.4px;padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;max-width:100%;margin-bottom:16px;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:12px;padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:4.8px;padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#dddfe2}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#cfd2d6}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.05)}.table-dark.table-hover tbody tr:hover{background-color:hsla(0,0%,100%,.075)}@media (max-width:575.99px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.99px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.99px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.99px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;padding:6px 12px;padding:.375rem .75rem;font-size:16px;font-size:1rem;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#868e96;opacity:1}.form-control:-ms-input-placeholder,.form-control::-ms-input-placeholder{color:#868e96;opacity:1}.form-control::placeholder{color:#868e96;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:20px;font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:14px;font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:6px;padding-top:.375rem;padding-bottom:6px;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:8px 16px;padding:.5rem 1rem;font-size:20px;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:16px;margin-bottom:1rem}.form-text{display:block;margin-top:4px;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:20px;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:4.8px;margin-top:.3rem;margin-left:-20px;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#868e96}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:12px;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:5px;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:4px;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:8px;padding:.5rem;margin-top:1.6px;margin-top:.1rem;font-size:14px;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.form-check-input.is-valid~.form-check-label,.was-validated .custom-control-input:valid~.custom-control-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label:before,.was-validated .custom-control-input:valid~.custom-control-label:before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label:before,.was-validated .custom-control-input:valid:checked~.custom-control-label:before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label:before,.was-validated .custom-control-input:valid:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label:before,.was-validated .custom-file-input:valid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:4px;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:8px;padding:.5rem;margin-top:1.6px;margin-top:.1rem;font-size:14px;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.form-check-input.is-invalid~.form-check-label,.was-validated .custom-control-input:invalid~.custom-control-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label:before,.was-validated .custom-control-input:invalid~.custom-control-label:before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label:before,.was-validated .custom-control-input:invalid:checked~.custom-control-label:before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label:before,.was-validated .custom-control-input:invalid:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label:before,.was-validated .custom-file-input:invalid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{-ms-flex-align:center;-ms-flex-pack:center;justify-content:center}.form-inline .form-group,.form-inline label{display:-ms-flexbox;display:flex;align-items:center;margin-bottom:0}.form-inline .form-group{-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:6px 12px;padding:.375rem .75rem;font-size:16px;font-size:1rem;line-height:1.5;border-radius:.25rem;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not([disabled]):not(.disabled){cursor:pointer}.btn:not([disabled]):not(.disabled).active,.btn:not([disabled]):not(.disabled):active{background-image:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-primary.disabled,.btn-primary:disabled{background-color:#007bff;border-color:#007bff}.btn-primary:not([disabled]):not(.disabled).active,.btn-primary:not([disabled]):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not([disabled]):not(.disabled).active:focus,.btn-primary:not([disabled]):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-secondary{color:#fff;background-color:#868e96;border-color:#868e96}.btn-secondary:hover{color:#fff;background-color:#727b84;border-color:#6c757d}.btn-secondary.focus,.btn-secondary:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-secondary.disabled,.btn-secondary:disabled{background-color:#868e96;border-color:#868e96}.btn-secondary:not([disabled]):not(.disabled).active,.btn-secondary:not([disabled]):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#666e76}.btn-secondary:not([disabled]):not(.disabled).active:focus,.btn-secondary:not([disabled]):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-success.disabled,.btn-success:disabled{background-color:#28a745;border-color:#28a745}.btn-success:not([disabled]):not(.disabled).active,.btn-success:not([disabled]):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not([disabled]):not(.disabled).active:focus,.btn-success:not([disabled]):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-info.disabled,.btn-info:disabled{background-color:#17a2b8;border-color:#17a2b8}.btn-info:not([disabled]):not(.disabled).active,.btn-info:not([disabled]):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not([disabled]):not(.disabled).active:focus,.btn-info:not([disabled]):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-warning.disabled,.btn-warning:disabled{background-color:#ffc107;border-color:#ffc107}.btn-warning:not([disabled]):not(.disabled).active,.btn-warning:not([disabled]):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not([disabled]):not(.disabled).active:focus,.btn-warning:not([disabled]):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-danger.disabled,.btn-danger:disabled{background-color:#dc3545;border-color:#dc3545}.btn-danger:not([disabled]):not(.disabled).active,.btn-danger:not([disabled]):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not([disabled]):not(.disabled).active:focus,.btn-danger:not([disabled]):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-light.disabled,.btn-light:disabled{background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not([disabled]):not(.disabled).active,.btn-light:not([disabled]):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not([disabled]):not(.disabled).active:focus,.btn-light:not([disabled]):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{background-color:#343a40;border-color:#343a40}.btn-dark:not([disabled]):not(.disabled).active,.btn-dark:not([disabled]):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not([disabled]):not(.disabled).active:focus,.btn-dark:not([disabled]):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#007bff;background-color:transparent;background-image:none;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not([disabled]):not(.disabled).active,.btn-outline-primary:not([disabled]):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#212529;background-color:#007bff;border-color:#007bff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#868e96;background-color:transparent;background-image:none;border-color:#868e96}.btn-outline-secondary:hover{color:#fff;background-color:#868e96;border-color:#868e96}.btn-outline-secondary.focus,.btn-outline-secondary:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#868e96;background-color:transparent}.btn-outline-secondary:not([disabled]):not(.disabled).active,.btn-outline-secondary:not([disabled]):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#212529;background-color:#868e96;border-color:#868e96;-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-outline-success{color:#28a745;background-color:transparent;background-image:none;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not([disabled]):not(.disabled).active,.btn-outline-success:not([disabled]):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#212529;background-color:#28a745;border-color:#28a745;-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;background-color:transparent;background-image:none;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not([disabled]):not(.disabled).active,.btn-outline-info:not([disabled]):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#212529;background-color:#17a2b8;border-color:#17a2b8;-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;background-color:transparent;background-image:none;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not([disabled]):not(.disabled).active,.btn-outline-warning:not([disabled]):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107;-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;background-color:transparent;background-image:none;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not([disabled]):not(.disabled).active,.btn-outline-danger:not([disabled]):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#212529;background-color:#dc3545;border-color:#dc3545;-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;background-color:transparent;background-image:none;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not([disabled]):not(.disabled).active,.btn-outline-light:not([disabled]):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#fff;background-color:#f8f9fa;border-color:#f8f9fa;-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not([disabled]):not(.disabled).active,.btn-outline-dark:not([disabled]):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#212529;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;background-color:transparent}.btn-link:hover{color:#0056b3;background-color:transparent}.btn-link.focus,.btn-link:focus,.btn-link:hover{text-decoration:underline;border-color:transparent}.btn-link.focus,.btn-link:focus{-webkit-box-shadow:none;box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#868e96}.btn-group-lg>.btn,.btn-lg{padding:8px 16px;padding:.5rem 1rem;font-size:20px;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:8px;margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{height:0;overflow:hidden;-webkit-transition:height .35s ease;-o-transition:height .35s ease;transition:height .35s ease}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty:after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;min-width:10rem;padding:8px 0;padding:.5rem 0;margin:2px 0 0;margin:.125rem 0 0;font-size:16px;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropup .dropdown-menu{margin-top:0;margin-bottom:2px;margin-bottom:.125rem}.dropup .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:2px;margin-left:.125rem}.dropright .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-toggle:after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:2px;margin-right:.125rem}.dropleft .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle:before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty:after{margin-left:0}.dropleft .dropdown-toggle:before{vertical-align:0}.dropdown-divider{height:0;margin:8px 0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:4px 24px;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#868e96;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:8px 24px;padding:.5rem 1.5rem;margin-bottom:0;font-size:14px;font-size:.875rem;color:#868e96;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:0 1 auto;flex:0 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group,.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:9px;padding-right:.5625rem;padding-left:9px;padding-left:.5625rem}.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:6px;padding-right:.375rem;padding-left:6px;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:12px;padding-right:.75rem;padding-left:12px;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio],.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group .custom-file,.input-group .custom-select,.input-group .form-control{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;margin-bottom:0}.input-group .custom-file:focus,.input-group .custom-select:focus,.input-group .form-control:focus{z-index:3}.input-group .custom-file+.form-control,.input-group .custom-select+.form-control,.input-group .form-control+.form-control{margin-left:-1px}.input-group .custom-select:not(:last-child),.input-group .form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-select:not(:first-child),.input-group .form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group .custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group .custom-file:not(:last-child) .custom-file-control,.input-group .custom-file:not(:last-child) .custom-file-control:before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-file:not(:first-child) .custom-file-control,.input-group .custom-file:not(:first-child) .custom-file-control:before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{padding:6px 12px;padding:.375rem .75rem;margin-bottom:0;font-size:16px;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:24px;min-height:1.5rem;padding-left:24px;padding-left:1.5rem}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:16px;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label:before{color:#fff;background-color:#007bff}.custom-control-input:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label:before{color:#fff;background-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label{color:#868e96}.custom-control-input:disabled~.custom-control-label:before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label:before{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#dee2e6}.custom-control-label:after,.custom-control-label:before{position:absolute;top:4px;top:.25rem;left:0;display:block;width:16px;width:1rem;height:16px;height:1rem;content:\"\"}.custom-control-label:after{background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-label:before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-radio .custom-control-label:before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:6px 28px 6px 12px;padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 12px center;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25);box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:12px;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#868e96;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);font-size:75%}.custom-select-lg,.custom-select-sm{padding-top:6px;padding-top:.375rem;padding-bottom:6px;padding-bottom:.375rem}.custom-select-lg{height:calc(2.875rem + 2px);font-size:125%}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(2.25rem + 2px)}.custom-file-input{z-index:2;margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control:before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-label{left:0;z-index:1;height:calc(2.25rem + 2px);background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label,.custom-file-label:after{position:absolute;top:0;right:0;padding:6px 12px;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label:after{bottom:0;z-index:3;display:block;height:36px;height:2.25rem;content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:8px 16px;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#868e96}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#868e96;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:8px 16px;padding:.5rem 1rem}.navbar,.navbar>.container,.navbar>.container-fluid{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:5px;padding-top:.3125rem;padding-bottom:5px;padding-bottom:.3125rem;margin-right:16px;margin-right:1rem;font-size:20px;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:8px;padding-top:.5rem;padding-bottom:8px;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:4px 12px;padding:.25rem .75rem;font-size:20px;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not([disabled]):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat 50%;background-size:100% 100%}@media (max-width:575.99px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.99px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.99px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.99px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:8px;padding-right:.5rem;padding-left:8px;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:hsla(0,0%,100%,.5);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:20px;padding:1.25rem}.card-title{margin-bottom:12px;margin-bottom:.75rem}.card-subtitle{margin-top:-6px;margin-top:-.375rem}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:20px;margin-left:1.25rem}.card-header{padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:12px 20px;padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-bottom:-12px;margin-bottom:-.75rem;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-10px;margin-right:-.625rem;margin-left:-10px;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:20px;padding:1.25rem}.card-img{width:100%;border-radius:calc(.25rem - 1px)}.card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:.25rem}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-group>.card:not(:first-child):not(:last-child):not(:only-child),.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:12px;margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;column-count:3;-webkit-column-gap:1.25rem;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:12px 16px;padding:.75rem 1rem;margin-bottom:16px;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:8px;padding-right:.5rem;padding-left:8px;padding-left:.5rem;color:#868e96;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#868e96}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:8px 12px;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:focus,.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:not([disabled]):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:4px;border-top-left-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:4px;border-top-right-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#868e96;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:12px 24px;padding:.75rem 1.5rem;font-size:20px;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-bottom-left-radius:4.8px;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:4.8px;border-top-right-radius:.3rem;border-bottom-right-radius:4.8px;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:3.2px;border-top-left-radius:.2rem;border-bottom-left-radius:3.2px;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:3.2px;border-top-right-radius:.2rem;border-bottom-right-radius:3.2px;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#0062cc}.badge-secondary{color:#fff;background-color:#868e96}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#6c757d}.badge-success{color:#fff;background-color:#28a745}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#1e7e34}.badge-info{color:#fff;background-color:#17a2b8}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#117a8b}.badge-warning{color:#212529;background-color:#ffc107}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#d39e00}.badge-danger{color:#fff;background-color:#dc3545}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#bd2130}.badge-light{color:#212529;background-color:#f8f9fa}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#dae0e5}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:32px 16px;padding:2rem 1rem;margin-bottom:32px;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:16px;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:64px;padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:12px 20px;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#464a4e;background-color:#e7e8ea;border-color:#dddfe2}.alert-secondary hr{border-top-color:#cfd2d6}.alert-secondary .alert-link{color:#2e3133}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress{height:16px;height:1rem;overflow:hidden;font-size:12px;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress,.progress-bar{display:-ms-flexbox;display:flex}.progress-bar{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;background-color:#007bff;-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1 1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#868e96;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#004085;background-color:#b8daff}a.list-group-item-primary,button.list-group-item-primary{color:#004085}a.list-group-item-primary:focus,a.list-group-item-primary:hover,button.list-group-item-primary:focus,button.list-group-item-primary:hover{color:#004085;background-color:#9fcdff}a.list-group-item-primary.active,button.list-group-item-primary.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#464a4e;background-color:#dddfe2}a.list-group-item-secondary,button.list-group-item-secondary{color:#464a4e}a.list-group-item-secondary:focus,a.list-group-item-secondary:hover,button.list-group-item-secondary:focus,button.list-group-item-secondary:hover{color:#464a4e;background-color:#cfd2d6}a.list-group-item-secondary.active,button.list-group-item-secondary.active{color:#fff;background-color:#464a4e;border-color:#464a4e}.list-group-item-success{color:#155724;background-color:#c3e6cb}a.list-group-item-success,button.list-group-item-success{color:#155724}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#155724;background-color:#b1dfbb}a.list-group-item-success.active,button.list-group-item-success.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}a.list-group-item-info,button.list-group-item-info{color:#0c5460}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#0c5460;background-color:#abdde5}a.list-group-item-info.active,button.list-group-item-info.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}a.list-group-item-warning,button.list-group-item-warning{color:#856404}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#856404;background-color:#ffe8a1}a.list-group-item-warning.active,button.list-group-item-warning.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}a.list-group-item-danger,button.list-group-item-danger{color:#721c24}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#721c24;background-color:#f1b0b7}a.list-group-item-danger.active,button.list-group-item-danger.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}a.list-group-item-light,button.list-group-item-light{color:#818182}a.list-group-item-light:focus,a.list-group-item-light:hover,button.list-group-item-light:focus,button.list-group-item-light:hover{color:#818182;background-color:#ececf6}a.list-group-item-light.active,button.list-group-item-light.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}a.list-group-item-dark,button.list-group-item-dark{color:#1b1e21}a.list-group-item-dark:focus,a.list-group-item-dark:hover,button.list-group-item-dark:focus,button.list-group-item-dark:hover{color:#1b1e21;background-color:#b9bbbe}a.list-group-item-dark.active,button.list-group-item-dark.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:24px;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not([disabled]):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:8px;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;-webkit-transition:-webkit-transform .3s ease-out;-o-transition:transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);transform:translateY(-25%)}.modal.show .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:16px;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem}.modal-header .close{padding:16px;padding:1rem;margin:-16px -16px -16px auto;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:16px;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:16px;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:4px;margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:4px;margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:14px;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:12.8px;width:.8rem;height:6.4px;height:.4rem}.tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:6.4px 0;padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow:before,.bs-tooltip-top .arrow:before{top:0;border-width:6.4px 6.4px 0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 6.4px;padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:6.4px;width:.4rem;height:12.8px;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow:before,.bs-tooltip-right .arrow:before{right:0;border-width:6.4px 6.4px 6.4px 0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:6.4px 0;padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow:before,.bs-tooltip-bottom .arrow:before{bottom:0;border-width:0 6.4px 6.4px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 6.4px;padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:6.4px;width:.4rem;height:12.8px;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow:before,.bs-tooltip-left .arrow:before{left:0;border-width:6.4px 0 6.4px 6.4px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:4px 8px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:14px;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:16px;width:1rem;height:8px;height:.5rem;margin:0 4.8px;margin:0 .3rem}.popover .arrow:after,.popover .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:8px;margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc(-.5rem + -1px)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:after,.bs-popover-top .arrow:before{border-width:8px 8px 0;border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-top .arrow:after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:8px;margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc(-.5rem + -1px);width:8px;width:.5rem;height:16px;height:1rem;margin:4.8px 0;margin:.3rem 0}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:after,.bs-popover-right .arrow:before{border-width:8px 8px 8px 0;border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-right .arrow:after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:8px;margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc(-.5rem + -1px)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:after,.bs-popover-bottom .arrow:before{border-width:0 8px 8px;border-width:0 .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-bottom .arrow:after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header:before,.bs-popover-bottom .popover-header:before{position:absolute;top:0;left:50%;display:block;width:16px;width:1rem;margin-left:-8px;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:8px;margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc(-.5rem + -1px);width:8px;width:.5rem;height:16px;height:1rem;margin:4.8px 0;margin:.3rem 0}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:after,.bs-popover-left .arrow:before{border-width:8px 0 8px 8px;border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-left .arrow:after{right:1px;border-left-color:#fff}.popover-header{padding:8px 12px;padding:.5rem .75rem;margin-bottom:0;font-size:16px;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:8px 12px;padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;-ms-flex-align:center;align-items:center;width:100%;transition:-webkit-transform .6s ease;-webkit-transition:-webkit-transform .6s ease;-o-transition:transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateZ(0);transform:translateZ(0)}}.active.carousel-item-right,.carousel-item-next{-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-right,.carousel-item-next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translateX(-100%);-ms-transform:translateX(-100%);transform:translateX(-100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat 50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:hsla(0,0%,100%,.5)}.carousel-indicators li:before{top:-10px}.carousel-indicators li:after,.carousel-indicators li:before{position:absolute;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li:after{bottom:-10px}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#868e96!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#6c757d!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #e9ecef!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#868e96!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:4px!important;border-top-left-radius:.25rem!important}.rounded-right,.rounded-top{border-top-right-radius:4px!important;border-top-right-radius:.25rem!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:4px!important;border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:4px!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:4px!important;border-top-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix:after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.d-print-block{display:none!important}@media print{.d-print-block{display:block!important}}.d-print-inline{display:none!important}@media print{.d-print-inline{display:inline!important}}.d-print-inline-block{display:none!important}@media print{.d-print-inline-block{display:inline-block!important}}@media print{.d-print-none{display:none!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive:before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9:before{padding-top:42.857143%}.embed-responsive-16by9:before{padding-top:56.25%}.embed-responsive-4by3:before{padding-top:75%}.embed-responsive-1by1:before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;-webkit-clip-path:none;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:4px!important;margin:.25rem!important}.mt-1,.my-1{margin-top:4px!important;margin-top:.25rem!important}.mr-1,.mx-1{margin-right:4px!important;margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:4px!important;margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:4px!important;margin-left:.25rem!important}.m-2{margin:8px!important;margin:.5rem!important}.mt-2,.my-2{margin-top:8px!important;margin-top:.5rem!important}.mr-2,.mx-2{margin-right:8px!important;margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:8px!important;margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:8px!important;margin-left:.5rem!important}.m-3{margin:16px!important;margin:1rem!important}.mt-3,.my-3{margin-top:16px!important;margin-top:1rem!important}.mr-3,.mx-3{margin-right:16px!important;margin-right:1rem!important}.mb-3,.my-3{margin-bottom:16px!important;margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:16px!important;margin-left:1rem!important}.m-4{margin:24px!important;margin:1.5rem!important}.mt-4,.my-4{margin-top:24px!important;margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:24px!important;margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:24px!important;margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:24px!important;margin-left:1.5rem!important}.m-5{margin:48px!important;margin:3rem!important}.mt-5,.my-5{margin-top:48px!important;margin-top:3rem!important}.mr-5,.mx-5{margin-right:48px!important;margin-right:3rem!important}.mb-5,.my-5{margin-bottom:48px!important;margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:48px!important;margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:4px!important;padding:.25rem!important}.pt-1,.py-1{padding-top:4px!important;padding-top:.25rem!important}.pr-1,.px-1{padding-right:4px!important;padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:4px!important;padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:4px!important;padding-left:.25rem!important}.p-2{padding:8px!important;padding:.5rem!important}.pt-2,.py-2{padding-top:8px!important;padding-top:.5rem!important}.pr-2,.px-2{padding-right:8px!important;padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:8px!important;padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:8px!important;padding-left:.5rem!important}.p-3{padding:16px!important;padding:1rem!important}.pt-3,.py-3{padding-top:16px!important;padding-top:1rem!important}.pr-3,.px-3{padding-right:16px!important;padding-right:1rem!important}.pb-3,.py-3{padding-bottom:16px!important;padding-bottom:1rem!important}.pl-3,.px-3{padding-left:16px!important;padding-left:1rem!important}.p-4{padding:24px!important;padding:1.5rem!important}.pt-4,.py-4{padding-top:24px!important;padding-top:1.5rem!important}.pr-4,.px-4{padding-right:24px!important;padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:24px!important;padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:24px!important;padding-left:1.5rem!important}.p-5{padding:48px!important;padding:3rem!important}.pt-5,.py-5{padding-top:48px!important;padding-top:3rem!important}.pr-5,.px-5{padding-right:48px!important;padding-right:3rem!important}.pb-5,.py-5{padding-bottom:48px!important;padding-bottom:3rem!important}.pl-5,.px-5{padding-left:48px!important;padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0062cc!important}.text-secondary{color:#868e96!important}a.text-secondary:focus,a.text-secondary:hover{color:#6c757d!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#1e7e34!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#117a8b!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#d39e00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#bd2130!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#dae0e5!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#868e96!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,:after,:before{text-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(779), __esModule: true };

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(446);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(781);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(794);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(782), __esModule: true };

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
__webpack_require__(525);
module.exports = __webpack_require__(793);


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(784);
var step = __webpack_require__(785);
var Iterators = __webpack_require__(469);
var toIObject = __webpack_require__(463);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(576)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(532);
var descriptor = __webpack_require__(474);
var setToStringTag = __webpack_require__(537);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(464)(IteratorPrototype, __webpack_require__(454)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(457);
var anObject = __webpack_require__(462);
var getKeys = __webpack_require__(524);

module.exports = __webpack_require__(458) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(463);
var toLength = __webpack_require__(770);
var toAbsoluteIndex = __webpack_require__(790);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(533);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(456).document;
module.exports = document && document.documentElement;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(533);
var defined = __webpack_require__(529);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(582);
var ITERATOR = __webpack_require__(454)('iterator');
var Iterators = __webpack_require__(469);
module.exports = __webpack_require__(446).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(795), __esModule: true };

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
__webpack_require__(525);
module.exports = __webpack_require__(796);


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(462);
var get = __webpack_require__(771);
module.exports = __webpack_require__(446).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(959);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./slidedown.css", function() {
        content = require("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./slidedown.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(799);
module.exports = __webpack_require__(446).Object.getPrototypeOf;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(570);
var $getPrototypeOf = __webpack_require__(581);

__webpack_require__(800)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(460);
var core = __webpack_require__(446);
var fails = __webpack_require__(470);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(802);
var $Object = __webpack_require__(446).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(460);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(458), 'Object', { defineProperty: __webpack_require__(457).f });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(804), __esModule: true };

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(525);
__webpack_require__(527);
module.exports = __webpack_require__(538).f('iterator');


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(807);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
module.exports = __webpack_require__(446).Symbol;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(456);
var has = __webpack_require__(459);
var DESCRIPTORS = __webpack_require__(458);
var $export = __webpack_require__(460);
var redefine = __webpack_require__(579);
var META = __webpack_require__(808).KEY;
var $fails = __webpack_require__(470);
var shared = __webpack_require__(535);
var setToStringTag = __webpack_require__(537);
var uid = __webpack_require__(475);
var wks = __webpack_require__(454);
var wksExt = __webpack_require__(538);
var wksDefine = __webpack_require__(539);
var enumKeys = __webpack_require__(809);
var isArray = __webpack_require__(810);
var anObject = __webpack_require__(462);
var isObject = __webpack_require__(465);
var toIObject = __webpack_require__(463);
var toPrimitive = __webpack_require__(531);
var createDesc = __webpack_require__(474);
var _create = __webpack_require__(532);
var gOPNExt = __webpack_require__(811);
var $GOPD = __webpack_require__(585);
var $DP = __webpack_require__(457);
var $keys = __webpack_require__(524);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(584).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(526).f = $propertyIsEnumerable;
  __webpack_require__(574).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(530)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(464)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(475)('meta');
var isObject = __webpack_require__(465);
var has = __webpack_require__(459);
var setDesc = __webpack_require__(457).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(470)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(524);
var gOPS = __webpack_require__(574);
var pIE = __webpack_require__(526);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(528);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(463);
var gOPN = __webpack_require__(584).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 812 */
/***/ (function(module, exports) {



/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(539)('asyncIterator');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(539)('observable');


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(816), __esModule: true };

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(817);
module.exports = __webpack_require__(446).Object.setPrototypeOf;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(460);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(818).set });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(465);
var anObject = __webpack_require__(462);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(573)(Function.call, __webpack_require__(585).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(820), __esModule: true };

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(821);
var $Object = __webpack_require__(446).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(460);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(532) });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(823);
exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "#_1Gd_L ._2yLrr ._3HE75:after,#_2kmH_ ._1QOLn .k6qzo:after,#_3oau8 .lABY4 .qIrle:after,#_3xh-V ._2OmcH ._2kaTV:after,#_11M3G ._1XsRi .Btnkp:after,#wMNXO ._5XuBu ._1Ml1n:after,._1Lwc- ._22NuY:after,._1TWTo ._1gkzN p:after,._1wki5:after,._1zQ7v._386WH ._2sfRO ._3bWfi:after,._2jed3:after,._2XHv1:after,._3Keih ._2MutF:after,._38_3g .lHXtK ._20uOO:after,.Ao7v8 .XjKHd ._14X1X:after,.Bg45n:after,.UREhu ._2oI8d ._29rc-:after,.UREhu .CRTaF .Uk3Qe ._3j1sT:after,header ._2ppU5 ul:after,header ._2ppU5:after,header .AJMcR:after,header .AJMcR ul:after{content:\"\";display:table;clear:both}._3rDZu{display:inline-block;background-color:#f6f6f6;font-weight:700;border-radius:4px;border:none;outline:none;font-size:.875em;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;text-decoration:none;vertical-align:middle;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:background-color .5s;-o-transition:background-color .5s;transition:background-color .5s;padding:.75em}._3rDZu:hover{background-color:#e4e4e4}._3rDZu:active,._3rDZu:hover{text-decoration:none}._3rDZu._1S8UQ{width:100%}._3rDZu img{vertical-align:middle;margin-right:6px}._3rDZu a{color:inherit;text-decoration:none}._3rDZu._3RfxN{background-color:#fec930;color:#4a4a4a}._3rDZu._3RfxN:hover{background-color:#ffd805;color:inherit}._3rDZu._1MotY{background-color:#0088bf;color:#fff}._3rDZu._1MotY:hover{background-color:#00a9ee;color:#fff}._3rDZu._2H8fJ{background:none;border:1px solid #f6f6f6;font-weight:400}._3rDZu._2H8fJ:hover{border-width:1px;background-color:#f6f6f6;color:#fff}._3rDZu._2H8fJ._3RfxN{border:1px solid #fec930;color:#fec930}._3rDZu._2H8fJ._3RfxN:hover{background-color:#fec930;color:#fff}._3rDZu._2H8fJ._1MotY{border:1px solid #0088bf;color:#0088bf}._3rDZu._2H8fJ._1MotY:hover{background-color:#0088bf;color:#fff}._1wWOW ._3rDZu._2H8fJ{border-right-width:0;border-radius:0}._1wWOW ._3rDZu._2H8fJ:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}._1wWOW ._3rDZu._2H8fJ:last-child{border-right-width:1px;border-top-right-radius:4px;border-bottom-right-radius:4px}._3rDZu._1eJAQ{padding:.35em .85em}._3rDZu.MmuP2,._3rDZu.MmuP2:hover{color:#fec930}._3rDZu.L1z0u,._3rDZu.L1z0u:hover{color:#0088bf}._3rDZu._2H8fJ[disabled],._3rDZu._2H8fJ[disabled]:hover,._3rDZu[disabled],._3rDZu[disabled]:hover{background-color:#f6f6f6;color:#cacaca;cursor:default}._3rDZu._2H8fJ[disabled],._3rDZu._2H8fJ[disabled]:hover{border-color:#f6f6f6}._1PPDJ{width:100%;margin-bottom:10px;border:1px solid #cacaca;border-radius:4px;outline:none;text-indent:0;padding:9px 1px 9px 15px;-moz-appearance:none;appearance:none;-webkit-appearance:none;-webkit-box-sizing:border-box;box-sizing:border-box}._1PPDJ::-webkit-input-placeholder{color:#9b9b9b}._1PPDJ:-ms-input-placeholder,._1PPDJ::-ms-input-placeholder{color:#9b9b9b}._1PPDJ::placeholder{color:#9b9b9b}._1PPDJ::-webkit-input-placeholder{text-indent:0}._1PPDJ:active,._1PPDJ:focus{-webkit-box-shadow:0 0 8px #c3f8ff;box-shadow:0 0 8px #c3f8ff}@media (max-width:767px){._1PPDJ{font-size:14px;padding-top:6px;padding-bottom:7px}}._1PPDJ._2ZAFP{border-color:#d0021b}._1PPDJ::-ms-clear,._1PPDJ::-ms-expand{display:none}._1PPDJ[disabled]{background-color:#f6f6f6}@media (max-width:767px){textarea._1PPDJ{text-indent:-2px}}._1l3tL{position:relative}._1l3tL ._1rXs9{overflow:hidden}._1l3tL ._3HmWH{position:absolute;background-color:#fff;-webkit-box-shadow:0 3px 8px rgba(0,0,0,.75);box-shadow:0 3px 8px rgba(0,0,0,.75);display:none;z-index:999;top:0;text-align:center;padding:12px 12px 10px}._1l3tL ._3HmWH._3PLKh{right:0;top:43px}._1l3tL ._3HmWH._3PLKh:after{top:-6px;right:24px;-webkit-box-shadow:-1px -1px 1px rgba(0,0,0,.15);box-shadow:-1px -1px 1px rgba(0,0,0,.15)}._1l3tL ._3HmWH.OpJqh{left:0;top:-247px}._1l3tL ._3HmWH.OpJqh:after{bottom:-6px;left:24px;-webkit-box-shadow:1px 1px 1px rgba(0,0,0,.15);box-shadow:1px 1px 1px rgba(0,0,0,.15)}._1l3tL ._3HmWH p{margin-top:0;margin-bottom:.2em;width:160px}._1l3tL ._3HmWH:after{content:\"\";display:block;width:12px;height:12px;position:absolute;background-color:#fff;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);z-index:-1}._1l3tL._3b4Sw ._3HmWH{display:block}.mDTqv li,.mDTqv ol,.mDTqv ul{list-style-type:none;padding:0;margin:0}.mDTqv .g-dV2{color:#4a4a4a;border-bottom:1px solid #e8e8e8;font-weight:lighter;padding-bottom:10px;padding-left:20px;margin-top:57px}.mDTqv ._2QhBc ._1tDmc{padding-left:5px;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}.mDTqv ._2QhBc ._1tDmc a{display:block;padding-top:14px;padding-bottom:14px;padding-left:20px}.mDTqv ._2QhBc ._1tDmc._3b4Sw{background-color:#f6f6f6;border-left:5px solid #fec930;padding-left:0}.mDTqv ._2QhBc ._1tDmc:hover{background-color:#f6f6f6}._3VRFb{padding-bottom:1.5em}._3VRFb li,._3VRFb ol,._3VRFb ul{list-style-type:none;padding:0;margin:0}@media (max-width:767px){._3VRFb{font-size:14px}}._3VRFb ._1r78A{margin-top:1.5em;margin-bottom:1.5em;line-height:28px}._3VRFb ._1r78A .CH8cL{color:#4a4a4a;font-weight:bolder;margin:0}._3VRFb ._1r78A .XrZf9{margin:0;font-weight:lighter}._60kJh{position:relative;display:inline-block;width:18px;height:2px;background:#0088bf;border-radius:2px;vertical-align:middle;margin-right:6px;font-size:0;line-height:0}._60kJh:before{top:-5px}._60kJh:after,._60kJh:before{content:\"\";display:block;position:absolute;width:18px;height:2px;left:0;background:#0088bf;border-radius:2px}._60kJh:after{top:5px}._60kJh.NvNQ6,._60kJh.NvNQ6:after,._60kJh.NvNQ6:before{background-color:#fff}._60kJh._2sUJv,._60kJh._2sUJv:after,._60kJh._2sUJv:before{background-color:#4a4a4a}._2ahKA{font-size:16px;font-weight:lighter;text-align:center;display:inline-block;border:1px solid #fff;border-radius:1em;width:1em;height:1em;line-height:1em;color:#fff}._2ahKA._2sUJv{color:#000;border-color:#000}._3hZvW{font-size:12px;width:1em;height:1em;border-radius:.5em;display:inline-block;margin-left:4px;margin-right:4px;vertical-align:-1px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px solid #9b9b9b;background-color:transparent}._3hZvW._3b4Sw{background-color:#9b9b9b}._3hZvW._3dUjB{border-color:#0088bf}._3hZvW._3dUjB._3b4Sw{background-color:#0088bf}._3hZvW._4CcHU{border-color:#18a493}._3hZvW._4CcHU._3b4Sw{background-color:#18a493}._3hZvW._3dQ2s{border-color:#e75467}._3hZvW._3dQ2s._3b4Sw{background-color:#e75467}._3seDF,._3xcgV{text-align:center;width:100%;font-size:14px}._3seDF td,._3seDF th,._3xcgV td,._3xcgV th{border:1px solid #ddd;padding:20px;text-align:center}._3seDF td._2dXRD,._3seDF th._2dXRD,._3xcgV td._2dXRD,._3xcgV th._2dXRD{text-align:center}._3seDF td._3PLKh,._3seDF th._3PLKh,._3xcgV td._3PLKh,._3xcgV th._3PLKh{text-align:right}._3seDF td.OpJqh,._3seDF th.OpJqh,._3xcgV td.OpJqh,._3xcgV th.OpJqh{text-align:left}@media (max-width:767px){._3seDF td,._3seDF th,._3xcgV td,._3xcgV th{padding-left:10px;padding-right:10px}}._3seDF>thead>tr>th,._3xcgV>thead>tr>th{background-color:#eee;padding-top:14px;padding-bottom:14px;text-align:center}._3seDF .QIjzT,._3xcgV .QIjzT{font-weight:bolder}._3jGkb{width:100%;height:280px}._2io21,.nIJE1{position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.75);z-index:99999;opacity:0;visibility:hidden;-webkit-transition:opacity .5s,visibility .1ms .2s;-o-transition:opacity .5s,visibility .1ms .2s;transition:opacity .5s,visibility .1ms .2s}._1I1QC._2io21,.nIJE1._1I1QC{opacity:1;visibility:visible;-webkit-transition:opacity .2s;-o-transition:opacity .2s;transition:opacity .2s;overflow:auto}._218j1._2io21,.nIJE1._218j1{position:absolute}._3_NBr{width:40px;height:40px;position:fixed;right:20px;top:20px;overflow:hidden;border:none;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=\") no-repeat 50%;background-size:29px 29px;text-indent:200%;color:transparent;outline:none;z-index:100}._2io21{background:rgba(0,136,191,.9)}._2io21 ._2Vjpl{text-align:center;position:relative;font-size:24px;-webkit-transform:translateY(90px);-ms-transform:translateY(90px);transform:translateY(90px);-webkit-perspective:1200px;perspective:1200px}@media (max-width:767px){._2io21 ._2Vjpl{font-size:18px;-webkit-transform:translateY(80px);-ms-transform:translateY(80px);transform:translateY(80px)}}._2io21 ._3hamY{list-style:none;padding:0;margin:0 auto;display:inline-block;height:100%;position:relative;opacity:.4;-webkit-transform:translateY(-25%) rotateX(35deg);transform:translateY(-25%) rotateX(35deg);-webkit-transition:opacity .2s,-webkit-transform .5s;transition:opacity .2s,-webkit-transform .5s;-o-transition:transform .5s,opacity .2s;transition:transform .5s,opacity .2s;transition:transform .5s,opacity .2s,-webkit-transform .5s}._2io21 ._3u_ab{display:block;min-height:80px}@media (max-width:767px){._2io21 ._3u_ab{min-height:60px}}._2io21 ._3u_ab._3b4Sw a{font-weight:bolder}._2io21 ._3u_ab a{font-weight:lighter;display:block;color:#fff;-webkit-transition:color .2s;-o-transition:color .2s;transition:color .2s}._2io21 ._3u_ab a:focus,._2io21 ._3u_ab a:hover{color:hsla(0,0%,100%,.6);text-decoration:none}._2io21._1I1QC ._3hamY{opacity:1;-webkit-transform:rotateX(0deg);transform:rotateX(0deg)}.UREhu{position:relative}.UREhu li,.UREhu ol,.UREhu ul{list-style-type:none;padding:0;margin:0}.UREhu .CRTaF{position:relative}.UREhu .CRTaF .Uk3Qe{position:relative;height:480px;overflow:hidden;z-index:98}.UREhu .CRTaF .Uk3Qe ._3j1sT{width:100%;height:100%;-webkit-transition:left 0ms,opacity 0ms;-o-transition:left 0ms,opacity 0ms;transition:left 0ms,opacity 0ms;position:absolute;opacity:0;left:-100%}.UREhu .CRTaF .Uk3Qe ._3j1sT._3b4Sw{-webkit-transition:left .3s,opacity .5s;-o-transition:left .3s,opacity .5s;transition:left .3s,opacity .5s;opacity:1;left:0}.UREhu ._1mNzl{position:absolute;width:100%;bottom:20px;z-index:99;text-align:center}.UREhu ._1mNzl ._25Lhx{vertical-align:middle;background-color:#fff;display:inline-block;margin:0 15px;width:10px;height:10px;border-radius:20px;-webkit-transition:all .24s ease-in;-o-transition:all .24s ease-in;transition:all .24s ease-in;cursor:pointer}.UREhu ._1mNzl ._25Lhx._3b4Sw{background-color:transparent;border:3px solid #fff;margin:0 11px;width:18px;height:18px}.UREhu ._1mNzl._3JrPv ._25Lhx{background-color:rgba(0,0,0,.5)}.UREhu ._1mNzl._3JrPv ._25Lhx._3b4Sw{background-color:transparent;border-color:rgba(0,0,0,.5)}.UREhu ._3g2an{position:absolute;width:100%;height:50px;top:50%;margin-top:-25px;z-index:100}.UREhu ._3g2an [class^=slider-arrows-]{position:absolute;width:60px;height:60px;border-radius:60px;background-size:18px 35px;background-repeat:no-repeat;background-position:50% 50%;background-color:hsla(0,0%,100%,.1);cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.UREhu ._3g2an [class^=slider-arrows-]:hover{background-color:hsla(0,0%,100%,.3)}.UREhu ._3g2an .wDwHS{left:10px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABGCAYAAACkPDbJAAAAnklEQVR42u3YoQ6DQBBFUVKSVmLI2ib9BhSpRBF0VWX7BzQBDPvny9MjqZgR9yXXH/0qZlZKaVSKgunVrrKavDFPlU23SJhZXaJgNnUHAwYMGDBgwIABAwYMGDBgwJzCdN4YC5q9MRa0GtDL+zj6qGwaPUFJ/UCBAgUKFChQoECBAgUKFChQoP5EDdFQu7pGQi2q9v6mWvVWX/WoIu4AcRMT5C2iuxEAAAAASUVORK5CYII=\")}.UREhu ._3g2an .TTswc{right:10px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABGCAYAAACkPDbJAAAAo0lEQVRo3u3QoQoCURRF0YcgTB8wyKB/YRKDRfEvJlmmGEQ0yPz5ttygMs3wrrA3nL44pWQMaIE2C2YHjLFDBtD9DTQCp9qg8xeoLgpYAFdRokSJEiVKlChRokSJEiVKlKgfUftsqCcwr4k6TrzU1MJsJzAXYJYF8wBWmTBrMWLEiBEjRowYMWLEiBEj5n8wmzSYAN3SYAI0pMEEaAn0sa7YZy+8VhDpNaCcyAAAAABJRU5ErkJggg==\")}.UREhu ._3g2an._3JrPv [class^=slider-arrows-]{background-color:rgba(0,0,0,.2)}.UREhu ._3g2an._3JrPv [class^=slider-arrows-]:hover{background-color:rgba(0,0,0,.3)}.UREhu ._2oI8d{position:relative;background-color:#efefef;border:0 solid #ddd;border-top:8px;margin-bottom:12px;border-top:8px solid #ddd}.UREhu ._2oI8d ._29rc-{text-align:center;margin:0;position:relative;z-index:10}.UREhu ._2oI8d ._29rc- ._1U_U1{position:relative;float:left;border-top:8px solid #ddd;margin:0;margin-top:-8px;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}.UREhu ._2oI8d ._29rc- ._1U_U1._3b4Sw{border-top-color:#0088bf;background-color:#dcdcdc}.UREhu ._2oI8d ._29rc- ._1U_U1._3b4Sw:before{opacity:1}.UREhu ._2oI8d ._29rc- ._1U_U1:before{content:\"\";position:absolute;top:0;left:50%;width:0;height:0;display:block;margin-left:-8px;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #0088bf;opacity:0;-webkit-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.UREhu ._2oI8d ._29rc- ._1U_U1._2K78B{width:50%}.UREhu ._2oI8d ._29rc- ._1U_U1._3-AAL{width:33.3%}.UREhu ._2oI8d ._29rc- ._1U_U1.e6VLZ{width:25%}.UREhu ._2oI8d ._29rc- ._1U_U1._6lTyE{width:20%}.UREhu ._2oI8d ._29rc- ._1U_U1 ._1tq2d{display:block;padding:25px;text-decoration:none;cursor:pointer}.UREhu ._2oI8d ._29rc- ._1U_U1 ._1tq2d:hover{background-color:#ccc}._1sc2k{width:178px;display:inline-block;text-align:left;position:relative}._1sc2k._1I1QC .aqzh5{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.0470588) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.0470588);background-color:#fff}._1sc2k._1I1QC ._35Fnc{opacity:1;height:152px}._1sc2k .aqzh5{padding:12px;width:100%;cursor:pointer;border-radius:3px;background-color:#f5f5f5;-webkit-transition:all .25s;-o-transition:all .25s;transition:all .25s}._1sc2k .aqzh5:hover{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.0470588) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.0470588);background-color:#fff}._1sc2k .aqzh5:after{content:\"\";width:9px;height:5px;position:absolute;top:50%;right:12px;margin-top:-3px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAAUVJREFUKBWVkSFIxVAUhnfvLQ5BzNZtyWgWluY2EQST8KKYDJY9BIPJ8pLBJAaDWVR0842FwSsWRawbRsPaCzKZXOd/5F55ylN8p5xz/vP/H5eNhWH4YBhGGsdxF33iQr6HkMfbtr3AEAVBsD8pRWUiYoiyLHPbtmcZYxH6G/bBf4CA7CKzB8hBkiQ7gkII9wGZw6GLPsR++xcMkG14e4AcAbJF3k8QDQjHjuNYCvaM/Z70nwXIJjyH0E8B2UBvyfMFIqEoiku8aB7GyLKsJ8AeyaTL9/0O5/wYLzkDpAP9Xd+4HlSXVVWtw3iDwAn+yJq+00wa3cgDXeobdTa66Nl13SnTNK+xLyK4SjpeeY42qOt6Oc/zV9JGayyIDJ7nTQsh+hgXVOBOSrmUpumL2r+1X0HkwoedwUuuaG6aZiXLsiHN4+oD3VaHIQDXD1sAAAAASUVORK5CYII=\");background-size:9px 5px}._1sc2k ._35Fnc{position:absolute;left:0;right:0;top:44px;width:100%;height:0;overflow:auto;background-color:#fff;border-radius:2.4px;-webkit-box-shadow:0 0 8px rgba(0,0,0,.5);box-shadow:0 0 8px rgba(0,0,0,.5);padding:0;opacity:0;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;z-index:101}._1sc2k ._35Fnc,._1sc2k ._35Fnc ._2Dvi6{list-style-type:none;margin:0}._1sc2k ._35Fnc ._2Dvi6._3b4Sw{display:none}._1sc2k ._35Fnc ._2Dvi6 ._1KWp9{display:block;padding:12px;cursor:pointer;text-decoration:none}._1sc2k ._35Fnc ._2Dvi6 ._1KWp9:hover{background-color:#0088bf;color:#fff}._1sc2k._3b4Sw ._2CW5w{background-color:#ebebeb}._1sc2k._3b4Sw ._1H1dK{opacity:1;display:block}.jGoAn{-webkit-box-shadow:0 5px 15px -5px rgba(0,0,0,.506);box-shadow:0 5px 15px -5px rgba(0,0,0,.506);background:#fff;border-bottom:1px solid #bbb;border-left:1px solid #ccc;border-right:1px solid #ccc;border-top:1px solid #ccc;color:#333;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px;padding-left:0;padding-top:2px;position:absolute;z-index:9999;-webkit-box-sizing:border-box;box-sizing:border-box;display:none}.jGoAn iframe{position:absolute;left:0;top:0;width:75px;height:210px;background:transparent;border:none}.jGoAn button{border:none!important}._12366{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}._12366::selection{background:transparent}._12366::-moz-selection{background:transparent}.jGoAn._7ROQa{display:inline-block;position:static;-webkit-box-shadow:none;box-shadow:none}.jGoAn *{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0;margin:0}.jGoAn ._2XeMU,.jGoAn ._3LKHR{display:none}.jGoAn ._2XeMU._3b4Sw,.jGoAn ._3LKHR._3b4Sw{display:block}.jGoAn ._3LKHR{width:224px;float:left;margin-left:8px}.jGoAn.IGbUh ._3LKHR{width:256px}.jGoAn ._2XeMU{width:58px;float:left;text-align:center;margin-left:8px;margin-top:0}.jGoAn ._3LKHR._3b4Sw+._2XeMU{margin-top:8px;margin-bottom:3px}.jGoAn .I2tIA{position:relative;text-align:center}.jGoAn ._1l0Mx,.jGoAn ._1x9b6,.jGoAn ._3dxxn,.jGoAn .mDgNv i{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0NBRjI1NjM0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0NBRjI1NjQ0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQ0FGMjU2MTQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQ0FGMjU2MjQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoNEP54AAAIOSURBVHja7Jq9TsMwEMcxrZD4WpBYeKUCe+kTMCACHZh4BFfHO/AAIHZGFhYkBBsSEqxsLCAgXKhbXYOTxh9pfJVP+qutnZ5s/5Lz2Y5I03QhWji2GIcgAokWgfCxNvcOCCGKqiSqhUp0laHOne05vdEyGMfkdxJDVjgwDlEQgYQBgx+ULJaWSXXS6r/ER5FBVR8VfGftTKcITNs+a1XpcFoExREIDF14AVIFxgQUS+h520cdud6wNkC0UBw6BCO/HoCYwBhD8QCkQ/x1mwDyD4plh4D6DDV0TAGyo4HcawLIBBSLDkHeH0Mg2yVP3l4TQMZQDDsEOl/MgHQqhMNuE0D+oBh0CIr8MAKyazBH9WyBuKxDWgbXfjNf32TZ1KWm/Ap1oSk/R53UtQ5xTh3LUlMmT8gt6g51Q9p+SobxgJQ/qmsfZhWywGFSl0yBjCLJCMgXail3b7+rumdVJ2YRss4cN+r6qAHDkPWjPjdJCF4n9RmAD/V9A/Wp4NQassDjwlB6XBiCxcJQWmZZb8THFilfy/lfrTvLghq2TqTHrRMTKNJ0sIhdo15RT+RpyWwFdY96UZ/LdQKBGjcXpcc1AlSFEfLmouD+1knuxBDUVrvOBmoOC/rEcN7OQxKVeJTCiAdUzUJhA2Oez9QTkp72OTVcxDcXY8iKNkxGAJXmJCOQwOa6dhyXsOa6XwEGAKdeb5ET3rQdAAAAAElFTkSuQmCC)}.jGoAn .mDgNv i{opacity:.5;background-position:-92px -19px;display:inline-block;width:9px;height:20px;vertical-align:middle}.jGoAn ._1x9b6{float:left;background-position:-20px 0}.jGoAn ._1l0Mx{float:left;background-position:-70px 0;margin-left:5px}.jGoAn ._3dxxn{float:right;background-position:0 0}.jGoAn ._1l0Mx,.jGoAn ._1x9b6,.jGoAn ._3dxxn{background-color:transparent;background-repeat:no-repeat;border:0 none currentColor;cursor:pointer;display:block;height:30px;opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";outline:medium none currentColor;overflow:hidden;padding:0;position:relative;text-indent:100%;white-space:nowrap;width:20px}.jGoAn ._2XeMU ._1x9b6,.jGoAn ._2XeMU ._3dxxn{float:none;background-position:-40px -15px;height:15px;width:30px;display:block;margin-left:14px;margin-top:7px}.jGoAn ._2XeMU ._1x9b6{background-position:-40px 0;margin-bottom:7px;margin-top:0}.jGoAn ._2XeMU ._2aHdp{height:151px;overflow:hidden;border-bottom:1px solid #ddd}.jGoAn ._2XeMU ._2aHdp>div>div{background:#f5f5f5;border-top:1px solid #ddd;color:#666;font-size:12px;text-align:center;border-collapse:collapse;cursor:pointer;border-bottom-width:0;height:25px;line-height:25px}.jGoAn ._2XeMU ._2aHdp>div>div:first-child{border-top-width:0}.jGoAn ._1l0Mx:hover,.jGoAn ._1x9b6:hover,.jGoAn ._3dxxn:hover{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"}.jGoAn .mDgNv{display:inline;position:relative;z-index:9999;margin:0;padding:5px 3px;font-size:14px;line-height:20px;font-weight:700;background-color:#fff;float:left;width:182px;text-align:center;cursor:pointer}.jGoAn .mDgNv:hover>span{text-decoration:underline}.jGoAn .mDgNv:hover i{opacity:1}.jGoAn .mDgNv>.S2Zz6{border:1px solid #ccc;position:absolute;right:0;top:30px;z-index:101;display:none;background:#fff;max-height:160px;overflow-y:hidden}.jGoAn .mDgNv>.S2Zz6._1LhSp{right:-7px}.jGoAn .mDgNv>.S2Zz6._2TT0n{right:2px}.jGoAn .mDgNv>.S2Zz6>div>._12gx2:hover{color:#fff;background:#ff8000}.jGoAn .mDgNv>.S2Zz6>div>._12gx2{padding:2px 10px 2px 5px;text-decoration:none!important}.jGoAn .mDgNv>.S2Zz6>div>._12gx2._1oZGu{background:#3af;-webkit-box-shadow:#178fe5 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #178fe5;color:#fff;font-weight:700}.jGoAn ._3i15b{width:100px;text-align:right}.jGoAn ._2hU6N{clear:both}.jGoAn ._3dBzb{width:48px;margin-left:5px}.jGoAn ._2hU6N table{border-collapse:collapse;width:100%}.jGoAn ._2hU6N td>div{padding-right:5px}.jGoAn ._2hU6N th{height:25px}.jGoAn ._2hU6N td,.jGoAn ._2hU6N th{width:14.2857142%;background:#f5f5f5;border:1px solid #ddd;color:#666;font-size:12px;text-align:right;vertical-align:middle;padding:0;border-collapse:collapse;cursor:pointer;height:25px}.jGoAn.IGbUh ._2hU6N td,.jGoAn.IGbUh ._2hU6N th{width:12.5%}.jGoAn ._2hU6N th{background:#f1f1f1}.jGoAn ._2hU6N td._2DTLR{color:#3af}.jGoAn ._2hU6N td._1oyRE,.jGoAn ._2hU6N td._1oZGu,.jGoAn ._2XeMU ._2aHdp>div>div._1oZGu{background:#3af;-webkit-box-shadow:#178fe5 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #178fe5;color:#fff;font-weight:700}.jGoAn ._2aHdp>div>div._3qOXB,.jGoAn ._2hU6N td._3NiGk,.jGoAn ._2hU6N td._3qOXB{opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\"}.jGoAn ._2hU6N td._3NiGk._3qOXB{opacity:.2;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\"}.jGoAn ._2hU6N td:hover,.jGoAn ._2XeMU ._2aHdp>div>div:hover{color:#fff!important;background:#ff8000!important;-webkit-box-shadow:none!important;box-shadow:none!important}.jGoAn ._2hU6N td._3qOXB:hover,.jGoAn ._2XeMU ._2aHdp>div>div._3qOXB:hover{color:inherit!important;background:inherit!important;-webkit-box-shadow:inherit!important;box-shadow:inherit!important}.jGoAn ._2hU6N th{font-weight:700;text-align:center;color:#999;cursor:default}.jGoAn ._3eXY_{color:#ccc!important;font-size:10px;clear:both;float:none;margin-left:8px}.jGoAn ._3eXY_ a{color:#eee!important}.jGoAn ._3eXY_ a:hover{color:#aaa!important}._2aHdp{position:relative;border:1px solid #ccc}._35pPT>._1BxLV{background:#ccc!important;height:20px;border-radius:3px}._35pPT{position:absolute;width:7px;right:0;top:0;bottom:0;cursor:pointer}._28-AY{position:relative}.jGoAn._3x5hT{-webkit-box-shadow:0 5px 15px -5px hsla(0,0%,100%,.506);box-shadow:0 5px 15px -5px hsla(0,0%,100%,.506);background:#000;border-bottom:1px solid #444;border-left:1px solid #333;border-right:1px solid #333;border-top:1px solid #333;color:#ccc}.jGoAn._3x5hT ._2XeMU ._2aHdp{border-bottom:1px solid #222}.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div{background:#0a0a0a;border-top:1px solid #222;color:#999}.jGoAn._3x5hT .mDgNv{background-color:#000}.jGoAn._3x5hT .mDgNv>.S2Zz6{border:1px solid #333;background:#000}.jGoAn._3x5hT .mDgNv>.S2Zz6>div>._12gx2:hover{color:#000;background:#007fff}.jGoAn._3x5hT .mDgNv>.S2Zz6>div>._12gx2._1oZGu{background:#c50;-webkit-box-shadow:#b03e00 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #b03e00;color:#000}.jGoAn._3x5hT ._1l0Mx,.jGoAn._3x5hT ._1x9b6,.jGoAn._3x5hT ._3dxxn,.jGoAn._3x5hT .mDgNv i{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUExQUUzOTA0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUExQUUzOTE0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQTFBRTM4RTQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQTFBRTM4RjQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp0VxGEAAAIASURBVHja7JrNSgMxEMebtgh+3MSLr1T1Xn2CHoSKB08+QmR8Bx9A8e7RixdB9CKCoNdexIugxFlJa7rNZneTbLIpM/CnNLsdMvNjM8l0mRCiQ9Ye61IKCAgZAUnH+mU3MMZaHYChBnJUDzWOFZdVfc5+ZFLbrWDeXPwbxIqrLLfaeS0hEBVGIRQCEiZoHQwtlGSByCCdYBl8g8egTTAWoKQMRBRBcZxYlhzhKegqMOageErsCHVkk3hXIFooDgHB1KkHIHVgzKB4ADJQ/A1jAFmAYhkQqA5TOBtocrKrgXwQA8gcFIuAIO8sQSA7hidvPwaQGZSaAYHOUWJABhWWw2EMIH9QagQERU4SArJXo0ZZL18uvaxejXt/Em8xjVBXmvFr1KVm/AJ10tRe2XnraNqaJvKE3KHuUbfK1E+VHB0q40/y3sdQSxY4FHWeKJCunP8UyDdqJZenT3ntVV5jIYCAh20vT7ioP8tpf6E2lfEMwERe+whV1MHjwZB7PBiCxcGQWwKZKD62lfGNnP/1poFAA60T7rF1UgcKd2id3KDeUS+oLWV8DfWAepOfq00CgQabi9zjcgJVYVD7PVzQUAUGAQkbNJTBICDhgwYTjDYD6XeW08ZKh+A4pYkzenOxXUbvZcWz7E8ykRMnIHGX1XPl+1m2vPYpL+2qdb8CDAARlKFEz/ZVkAAAAABJRU5ErkJggg==)}.jGoAn._3x5hT ._2hU6N td,.jGoAn._3x5hT ._2hU6N th{background:#0a0a0a;border:1px solid #222;color:#999}.jGoAn._3x5hT ._2hU6N th{background:#0e0e0e}.jGoAn._3x5hT ._2hU6N td._2DTLR{color:#c50}.jGoAn._3x5hT ._2hU6N td._1oyRE,.jGoAn._3x5hT ._2hU6N td._1oZGu,.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div._1oZGu{background:#c50;-webkit-box-shadow:#b03e00 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #b03e00;color:#000}.jGoAn._3x5hT ._2hU6N td:hover,.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div:hover{color:#000!important;background:#007fff!important}.jGoAn._3x5hT ._2hU6N th{color:#666}.jGoAn._3x5hT ._3eXY_{color:#333!important}.jGoAn._3x5hT ._3eXY_ a{color:#111!important}.jGoAn._3x5hT ._3eXY_ a:hover{color:#555!important}._3x5hT ._2aHdp{border:1px solid #333}._3x5hT ._35pPT>._1BxLV{background:#333!important}.Bg45n{display:inline-block;margin-bottom:1em}.Bg45n ._1lbmd{width:25px;height:25px;float:right;margin-left:4px;margin-right:4px;background-size:100% 100%;background-repeat:no-repeat;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAAAXNSR0IArs4c6QAAArBJREFUSA2tVjuLE1EYnUkmUbYTi4CI0c3uqrhWFnmQ0sbGF4jaLKiVtSCKWmkngn9AhAVZNoKvFDaWeRZWVu6uCiJCChEb3cwkE88ZZobJde6d3FkH7tx7v+9859zvvmYMI+XTbrdLLCnDDSttYC6Xu+PHXk3DYaYJ6vf7hxC34cculcvlL7o8Gd0A4ieTyW3TNC0WttNwaGfcarUO5PP5LYjlfEHHtu2Fer3+VWcA2hljbZlhIEotmDybjq6hlXGv19ufyWQ+QSEvqNiu65Yqlco3wS7tamUM0VsxoiTP+z6pkOiYOWOs7T6s7WcQ7BJJ/P4Qaz2Ptf4u8U+ZY4VxXPYCtYSyiF27iGxYn8AuXpiKFjrAbAHzHtO+iXoTbpYNHLcfAtQwm83mXKFQuIGgwwB7Qqj3iMCd9MH9kwNBzQF9HAwGj7yMkeEKDE9BrrXmKQbjQvwKZmA1nGqIXwbRKgaQ+hpVDQSCI/hXILpGXJghDXBegs2h4z8/DrkDUXKHGQdC3W73dDabfY6+eFYDiG5tj8fjC9Vq9U008B9hOiF+Cjv5BaZ9dxSs20aW29jh5yH6VoyNFSYI4ieR+Ws058SgGfu/kekZiL6Lw0uFCcaGO4usX8YFJtmQ7Tms6SsZLtxcEsBONpoyNkl4WTKgWczKWKUwplkZrFJPilUKg/iYijzBp4yVCjcajSw2yFEF+S/4WGIfxpIj1gmjVLhYLJbizjEI/6A8HI1G8yxs0yYKMJYcoj3oS+9lHPxlnOMAx5rX3hPHce4L39yb+FY/xu/PPYhdAy78LSIH+sHfKDnCR5pxZHPwi/JsOBwewbm8Loh6RLTRRwyxMLp0RDg8XPQlvUBweaxzujCdd2u12odoUFK70+kctyzrAQaxjQFdTMJP+XFlHpwypOioOP4C6FoDBzvJSk4AAAAASUVORK5CYII=\")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.Bg45n ._1lbmd{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA4CAMAAACWs2tWAAABMlBMVEUAAAAAAAC/v7+ZmZmqqqq2tra/v7/Gxsa5ubm/v7/ExMTIyMi/v7/GxsbJycnCwsLIyMjCwsLExMTGxsbBwcHHx8fFxcXGxsbExMTGxsbIyMjIyMjKysrHx8fFxcXHx8fGxsbHx8fKysrHx8fHx8fIyMjIyMjHx8fKysrIyMjJycnJycnJycnJycnIyMjJycnKysrJycnIyMjKysrJycnIyMjJycnJycnIyMjJycnKysrKysrKysrJycnJycnJycnKysrJycnKysrKysrJycnKysrJycnKysrKysrKysrJycnJycnJycnJycnJycnKysrKysrJycnJycnKysrKysrJycnJycnKysrKysrJycnJycnJycnKysrJycnJycnKysrKysrJycnJycnJycnKysrKysp6G+wjAAAAZXRSTlMAAQQFBgcICQsMDQ4QEhMVFxkaGx0gIyQnKCouMDI1Nzo7PkBESlRXW1xfY2Rnam1ucXR4e36AhIeIi4+ZpaaprLO6u8PKz9PX2Nnb3t/g4eLj5OXm5+jq6+zt7u/x8/T19/v8/u1X1AcAAAHDSURBVBgZrcEJPyJxHAbwxzGI3LcQOWoN7YZyn0vuo0SLcva8/7ewU5KZtv/P/Oez3y9Efj+8i8fhWdvjYxu8WiaX4ZHvnrz3wZslWpbgSUuWlmwLvFhkySI8aL5jyV0z9MVYFoO2pgzLMk3Q9YsVP6HJSLMibUBPlDZRaGm8ps11I3Qs0GEBGhou6XDZAPdMVjHhTnfIXLthlZs1M9QNQefE3MpO8olKT8mdlbmJTjj4xyOJrcMcXcodbiUi434UDafoSWoYlukXevAyjZKpZ2p7nkLZZJ6a8pOoCOaoJReEzdgDNTyMwSGQpWvZAKqM3NKl2xH8YyhNV9JDqGHgii5cDaCm/nN+67wfCn1n/MZZH5R6jik67oGg64iCoy6IwhSEIUtQkIBsl4JdyE4oOIHIeKfg3YBklKJRSH5QFIFklaJVSPYo2oPkgqILCHwFOhwc0KHgg1qQdskZYCZJuyDUTH45DdfBUhc+5RcTahv8lJqvR1n9fIqfNqD2mx+yMQM2RuwPP+xDLcOifLwVVVrjeRZloNROy+t6B2roWH+lpR0qIfJtsxcKvZtvZAgq0cL2IASD24UoVGYD+EZgFv/LX4jOCpeMg6dUAAAAAElFTkSuQmCC\")}}.Bg45n ._1lbmd._2Kjii{cursor:pointer}.Bg45n ._1lbmd._2Kjii:hover,.Bg45n ._1lbmd._2Kjii:hover~._3u6mR,.Bg45n ._1lbmd._3b4Sw,.Bg45n ._1lbmd._3b4Sw~._3u6mR{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAAAXNSR0IArs4c6QAAAoFJREFUSA2lV02LE0EQfZXMoCxelwVBUDSCRBAE87FRlnXxJN49efMH+Af0r4g3z8JeRHNx87WX9eBls6IQWFj2KmFhJlNWt+n5iD0z25OGpqur6r3X1V1JCFBx8MDbUbMiHF5VIOp4u8TuVeZwBfLQ6/HEZz3FdsWr/FoVkFT7Lsal7dhZblB5SjaDR35HjjvMeCN0qROMMr6SjXvFxEm1hrzG5r2Np3R1qpgP/EfwMbGyBmhRLzi0xixOt4q9gsqKYhbhS1fMA78lH76xhSNxhWjTdmC/kSRLWxlh/oQNbOIOUG8AdBc1aoBZbDRAtLWCtW+ZzyQwlfwpIp4CfAwspjjHCb3A3IBIi215H8DogHBdBDOHMYnrr8yicSoaI5yFr7QIj/EA5H0W0c31BYoY+BwcPqM2vsfV8QRNsPfl0ldaxG+LqSegcI9a+KHCcVdrRxDKlz6f2nDr+YRTuI2o4oorNsR8gNvw/b7sbxjfmusMQbBLPfxM8/wnrII8xE3U/K9yrFvpZGeb8QtR8JS6+L2Kja86HdCJF8GOdOFJ2u9kK6xw2EQVj7ViI8BjryvNNjB7p5V5m9ph9sckRWCtOI4TV3/nEmyxcET340O4GiXYYmFCdeESbLEwqOlaaJJfjM1tLu7jKja8P9Jc9YQsZTF/0zuixylvYjIvMA+v0S4uEmdi5Vd8BfesoowjRNFz6dgnaipbPnZHCeXSUgdWHDkjX7hWz74v4xiL6CXawUPqLPYNn7bFp2MqJz1WOVKxfGGKO3oGjl5jHjSpu/gob8MpvDaVT8VUjs4FZv8CMccqJH/PY/+9zDe8LxfmOBRGY4XDESol9Nf4l7FUK+L4C1TpzkBUsOKvAAAAAElFTkSuQmCC\")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.Bg45n ._1lbmd._2Kjii:hover,.Bg45n ._1lbmd._2Kjii:hover~._3u6mR,.Bg45n ._1lbmd._3b4Sw,.Bg45n ._1lbmd._3b4Sw~._3u6mR{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA4CAMAAACWs2tWAAABGlBMVEUAAAD/AAD/gAD/qgD/vwD/mQD/qgD/tgD/vwD/swD/vwD/yAD/xAD/xQD/xwD/yQD/yAD/xAD/xgD/xwD/yAD/xQD/yQD/xwD/xQX/yAX/yAT/xgT/ygT/yAT/yAP/ygP/yAP/yQP/yAP/yAP/yAX/yAX/yAX/yQX/yAT/yQT/ygT/yAT/yQT/ygT/yQT/yAT/yQT/yQT/yQT/ygT/yQP/ygP/ygP/yQP/ygX/yAX/yQX/yAX/yQX/yQX/yQX/ygX/yQX/yQT/ygT/ygT/yQT/yQT/yQT/yQT/ygT/yQT/yQT/ygT/yQX/yQX/yQX/yQX/yQX/yQT/yQT/yQT/yQT/yQT/ygT/ygT/ygT/yQT/yQT/ygT/ygT/ygVy/jJ5AAAAXXRSTlMAAQIDBAUGBwgKEBcaHyAhJScoKSosLzI1ODw/Q0ZKTU9QVF1qa29xdHV4eXt8f4KFiI6QkpSVlpmanZ+gpaanqausrbCztbe6vsLJ0NTb3t/j5+3u8/T4+fv8/f6jNhC6AAABq0lEQVQYGa3Bh1LqUBQF0B0QFexi7w3svTdsiCD2rsn+/994mUwmkyj3JPfOWwui0VGYq9VgbIQcgakqWYWhYbqGYeaGrhsYGaJnCCau6bmGgUH6BqGvTF8Z2gYc+pwB6Lpi4Aqa+h0GnH7oOWfIObT02Qyx+6CjxIgSNPTYjLB7kFj2jL+cZRGrJT+1cFB7dviH81w7WJjKt6CBpu6J4l71yWYM+6m6V5zoboKvs7Bdefimlu+HynahE0BrhUYqrXA1l2mg3AxP5oLaLjLwpUvUVEojkDqhlpMUQqxDaji0EGHtMrFdC79tMaEtNLDJRDbR0DoTWIfCCmOtQGmRMRYhKFJUhGiVglXI5iiYg2yfgn3Ibim4heyVgleI2ilqh2SconFI5imah+SIoiNI6hTVIbDeKXq3oNbFiPrYWJ0RXVCbZMj9NFzT9wyZhNoyA4+zKXhSs48MLEPtlL6XQgaBTOGFvlOo3dHztpRFRHbpjZ47KKU/6frYyOGP3MYHXZ9pqPSS/NppQ0NtO18ke6Eyw5/jDih1HP9wBiprl3mI8pdrUMkhVg7/yz+IJOGgAW17pAAAAABJRU5ErkJggg==\")}}._1Es7Q{letter-spacing:1px;font-size:12px;width:140px;height:40px;margin-right:20px;color:#9b9b9b;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._1Es7Q,._1Es7Q:active,._1Es7Q:hover{background-color:transparent}._1Es7Q._3b4Sw{color:#4a4a4a}._1Es7Q._3b4Sw._21K8-{border:2px solid #0088bf;border-radius:40px}._1Es7Q._3b4Sw._3VKxx{border:2px solid #18a493;border-radius:40px}._1Es7Q._3b4Sw._3DOkU{border:2px solid #e75467;border-radius:40px}._2TEdR{margin-bottom:3px}._2TEdR>*{line-height:40px;padding-left:24px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAADSCAMAAABuMVBiAAABL1BMVEUAAAAAAAAAVaoAgL8AZpkAgL8AcaoAgLMAdLkAgL8AgL8AgLgAhrYAhbwAgLoAgL8AiLsAg7kAhrwAgr4Ah7sAh74Ahr4AhL8Ahr4Ahr4Ah78Ah70Ahb4AhbwAh70Ah78Ahb0Ahr4AiL0Ahr8Ah74Ahr8Ah8AAh78Ah74Ah74Ah78Ah78Ah8AAiL4AiL8Ah78AhsAAh74AhsAAiL8AiL8Ah8AAhr4Ah8AAiL4AiL8Ah8AAh8AAh74AiMAAiMAAiMAAiMAAh78AiMAAiL8Ah78AiL8Ah78Ah8AAiL8AiL8AiMAAh78AiL8Ah8AAh8AAiMAAiL8Ah78AiMAAh8AAiL8Ah78AiL8Ah78AiL8AiL8AiMAAh78AiL8Ah8AAiMAAiL8AiMAAh78Ah8ABiMABiMB6kfTKAAAAZHRSTlMAAQMEBQgJCgsMEBIVFxocHiEmKzEzNzg7P0BCQ0VGSElKTVBTVFlbYmpsc3l6fH+BgoWHj5GSlZqcnaGmqa26vsDFx8jLzM7P1NbX2Nnd3uPk5ebn6Ovs7/Dy8/T19vj6+/3+PZrW0wAAAglJREFUWMPtlms7AkEUx1euRRRZEoncLxWFXGIrlEtEkWxIzff/DHJmZmev4+GNx2POq3POb3c6c/ZM85ckaoGEUlLVkpIISGZbvEaaXS8akD+PDJb3MxasIZPVghprIos1CfXXkI3V8Mp5ZGt5qBM52GfN2h7aadntltNtbUedvVO/EsIlhCo0E5AS9L0QLT5E301ICvHSbNtpklKkEvFkBmWSKkkq8dwMuklK5cFn/rLcgrhb4TaB2z5+47mfjP+xuWPCHzD+aPKH+ovj8ActUi5HHGEZobIj/GzPzyB3WW5Boreit//LxAyJ3v6STcSzt43GbTY+YUHRM3ZFnkUNyJMxXq4ZD2NDV+Zr+XKIsr6i9UIv9hGY1FJvb5qbxMz3TsjWWHf32Bbh7z6AmziqjuJnR6s43oDoHPyWJnmmW5DIQfAE/ikr/hQS9+C/gp9iMIUFCPhYe+wxuAeJR/CxtigwWMA7Bf9Yp410snUfgnUc1Ccxm6zjeAmikRbRYAdhrzd8QDSY2o+fPbFTUofkR5bt4AyBvXdWVuii9a1Y4ay2MdeFmWV1YzJnYm1ZP0RHRrhjmLDBqp7dDBhHc16/6JR5cHcZ3LZMdU+OMsVlPQ7DD5jde+0Oiwwj8TJuf5QWOh+kFXU6aGsIrTofw1hM/GuKG0n0VpiYIdFboRiFYhSKUSjGbyjGD04cVC5bkID+AAAAAElFTkSuQmCC\");background-repeat:no-repeat;background-position-y:-32px;background-size:14px;-o-text-overflow:ellipsis;text-overflow:ellipsis}._2TEdR>:first-child{background-position-y:12px}._2TEdR>:last-child{background-position-y:-77px}.ZdsF7{max-width:1024px;margin:0 auto}body{min-width:300px}._27EhB{background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-position:50% 15%;margin-bottom:190px}._27EhB .mT3jc{text-align:center}._27EhB .ZdsF7{background-color:#0088bf;position:relative;top:140px;padding-top:20px;padding-bottom:20px;border-radius:8px}@media (min-width:768px) and (max-width:1023px){._27EhB .ZdsF7{margin-left:20px;margin-right:20px}}@media (max-width:767px){._27EhB .ZdsF7{margin-left:10px;margin-right:10px;padding:30px 20px}._27EhB .ZdsF7 h2{margin-top:0}}._27EhB .ZdsF7 ._1bbCM{padding:0;margin-top:36px}._27EhB .ZdsF7 ._1bbCM ._3rDZu{width:100%;text-align:center}@media (max-width:767px){._27EhB .ZdsF7 ._1bbCM{margin-top:auto}._27EhB .ZdsF7 ._1bbCM ._3rDZu{width:auto}}._27EhB .ZdsF7 h2{color:#fff;margin-bottom:0;font-weight:700}._27EhB .ZdsF7 p{color:#fff}._1u6oN ._3seDF>tbody>tr:nth-child(2n){background-color:#f9f9f9}._1u6oN hr{border:0;height:1px;color:#e8e8e8;background-color:#e8e8e8}._1u6oN ._3seDF{font-weight:lighter}._1u6oN ._3seDF._2tw_N tr:nth-child(2n){background-color:#fff}._1u6oN ._3seDF._2tw_N td{border:0;color:#9b9b9b;padding:10px 6px;line-height:28px;vertical-align:center}._1u6oN ._3seDF._2tw_N td.QIjzT{color:#4a4a4a}._1u6oN ._3seDF._2tw_N td ._3rDZu{line-height:normal}@media (max-width:767px){._1u6oN ._3seDF._2UvPP{display:table}}._1u6oN ._3seDF th{padding:18px 12px}@media (max-width:767px){._1u6oN ._3seDF th{padding:10px 6px}}._1u6oN ._3seDF td{padding:18px 12px;vertical-align:top}@media (max-width:767px){._1u6oN ._3seDF td{padding:10px 6px}}._1u6oN ._3seDF p{margin-top:0}._1u6oN ._3seDF ._1kzDm td,._1u6oN ._3seDF ._1kzDm th{padding:0;border:none;margin-bottom:4px}._1u6oN ._3seDF ._1kzDm td:first-child{padding-right:10px}._1u6oN ._2qhfp{list-style-type:decimal}._1u6oN ._1yuwc,._1u6oN ._2qhfp{padding-left:20px;font-size:1.125em}._1u6oN ._1yuwc{list-style-type:disc}._1u6oN ._1sc9s{margin-top:76px;font-weight:400}._1u6oN ._2-qYX h1{font-size:36px}@media (max-width:767px){._1u6oN ._2-qYX h1{font-size:28px}}._1u6oN ._2-qYX h4{font-weight:400;margin-top:40px;margin-bottom:58px}._1u6oN ._1kTze{line-height:1.5;margin-bottom:50px}._1u6oN ._1kTze h2{letter-spacing:1px;margin-bottom:0}@media (max-width:767px){._1u6oN ._1kTze h2{font-size:24px;margin-bottom:10px}}._1u6oN ._1kTze ul{font-weight:400;padding-bottom:50px}._1u6oN ._2nMaW ._1kzDm td:first-child{width:70px}.RdJxU{background-image:url(" + escape(__webpack_require__(824)) + ");background-repeat:no-repeat;background-position:50% 50%;background-size:cover;-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.RdJxU h2{font-size:1.5em;font-weight:lighter;letter-spacing:1px;display:inline-block}.RdJxU h2.bI7pj{border-top:3px solid #fec930;padding-top:12px;margin-top:0}@media (max-width:767px){.RdJxU h2{margin-bottom:50px}}.RdJxU ._2syPd{margin-top:10px}@media (max-width:767px){.RdJxU ._2syPd{margin-top:0}.RdJxU ._2syPd img{height:50px;width:auto}}.RdJxU._1r9_5{margin:0}._1NiHL{opacity:.4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._3_NBr._2cxpJ{position:absolute;top:-30px;right:0}._1esll{color:#fff;background-color:#ea5365;border-radius:0 0 4px 4px;padding-top:5px;padding-bottom:5px;vertical-align:top;top:-16px;margin:auto;float:none}._1esll p{margin:0}._3ksoC{position:relative}._3ksoC ._3o1W6{left:10px}._3ksoC ._3vfIx{position:absolute;top:13px}._3ksoC ._3vfIx._3pb9I{top:7px;width:24px}@media (max-width:767px){._3ksoC ._3vfIx._3pb9I{top:4px;left:4px}}._1FTCK{height:498px;position:relative;margin-top:70px}@media (max-width:767px){._1FTCK{height:360px}}._1FTCK #_1Yit_{height:inherit}._1FTCK .ZdsF7{position:relative}._2HefH{position:absolute;bottom:20px;left:0;right:0;color:#4a4a4a;text-align:center;width:950px;margin:auto}@media (min-width:768px) and (max-width:1023px){._2HefH{width:800px}}@media (max-width:767px){._2HefH{margin-top:-80px;margin:auto;width:100%}}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._2HefH .fCIYr{height:auto}}._2HefH .fCIYr ._3ksoC{display:inline-block;width:40%}@media (max-width:767px){._2HefH .fCIYr ._3ksoC{display:block;max-width:100%;width:420px;margin:auto}}._2HefH .fCIYr ._3ksoC ._28zLC{position:absolute;top:12px;right:12px;cursor:pointer}._2HefH .fCIYr ._3ksoC ._1f4Rw{padding:.75em 40px;font-size:.875em;border-radius:0;margin:0;vertical-align:middle;height:39px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw{border-bottom-width:0}}._2HefH .fCIYr ._3ksoC ._1f4Rw._1TbJI{border-right-width:0;border-top-left-radius:4px;border-bottom-left-radius:4px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw._1TbJI{border-right-width:1px;border-bottom-left-radius:0;border-top-right-radius:4px}}._2HefH .fCIYr ._3ksoC ._1f4Rw._2y8KP{border-left-width:0;border-top-right-radius:4px;border-bottom-right-radius:4px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw._2y8KP{border-left-width:1px;border-bottom-left-radius:4px;border-top-right-radius:0;border-bottom-width:1px}}._2HefH .fCIYr ._3ksoC._3Xa1c ._2atma{border-left-width:2px;border-bottom-width:2px}._2HefH .fCIYr ._1FzLI{height:39px;width:18%;margin-left:4px;vertical-align:middle}@media (max-width:767px){._2HefH .fCIYr ._1FzLI{max-width:100%;width:420px;margin-top:10px;margin-left:0;bottom:500px}}._2HefH .fCIYr ._1FzLI ._2eBOE{display:none}._2HefH .fCIYr ._1FzLI._1t3XB ._2M3HP{color:#fff}._2HefH .fCIYr ._1FzLI._1t3XB ._3Hpxn{display:inherit;color:#0088bf}._2HefH .fCIYr>img{vertical-align:middle;background-color:#fff;height:39px;border-top:1px solid #cacaca;border-bottom:1px solid #cacaca;-webkit-box-sizing:border-box;box-sizing:border-box}._2uCng{text-align:center;background-color:#006a96;padding-top:20px;padding-bottom:77px;color:#fff}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._2uCng{background-color:transparent;color:#000}}@media (max-width:767px){._2uCng{padding-bottom:0}}._2uCng h2{margin:0;letter-spacing:1px}._1ZD6b{background-color:#fff;text-align:center;position:relative}._1ZD6b ._146f6{position:relative;top:-77px}@media (max-width:767px){._1ZD6b ._146f6{top:auto;margin:0 auto 20px}}._1ZD6b ._146f6._3b4Sw ._2vMk_{border-top:4px solid #fec930}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6._3b4Sw ._2vMk_{border-top:4px solid transparent}}._1ZD6b ._146f6._3b4Sw ._36-Be{background-color:#0088bf}._1ZD6b ._146f6._3b4Sw ._36-Be [data-select=false]{display:none}._1ZD6b ._146f6._3b4Sw ._36-Be img{margin-right:0;vertical-align:top;line-height:28px}._1ZD6b ._146f6 ._1EQDm{height:77px;overflow:hidden;position:relative}._1ZD6b ._146f6 ._1EQDm img{position:absolute;bottom:0;left:0;right:0;margin:auto}._1ZD6b ._146f6 ._1EQDm img.g5v9M{display:block}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._1EQDm img.g5v9M{display:none}}._1ZD6b ._146f6 ._1EQDm img._283qC{display:none}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._1EQDm img._283qC{display:block}}._1ZD6b ._146f6 ._36-Be{padding-left:22px;padding-right:22px}._1ZD6b ._146f6 ._1U8eZ{background-color:#0088bf}._1ZD6b ._146f6 ._2vMk_{padding-top:8px;border-top:4px solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s;min-height:130px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._2vMk_{min-height:60px}}._1ZD6b ._146f6 ._2vMk_ .uOEIZ{margin-top:0;margin-bottom:4px;height:40px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._2vMk_ .uOEIZ{height:inherit;margin-bottom:0}}._1ZD6b ._146f6 ._2vMk_ ._242w8{padding-top:8px;border-top:4px solid transparent;line-height:18px}._1ZD6b ._146f6 ._27cuJ{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;color:#00a493;margin-top:18px;margin-bottom:8px}@media (max-width:767px){._1ZD6b ._146f6 ._27cuJ{margin-bottom:5px;margin-top:5px}}._1ZD6b ._146f6 ._27cuJ ._1XNLe{font-size:10px;vertical-align:4px;margin-right:2px}._1ZD6b ._146f6 ._27cuJ ._2mhin{font-size:18px}._1ZD6b ._3nwGW{position:relative;top:-40px;display:none}@media (max-width:767px){._1ZD6b ._3nwGW{top:auto;margin-top:20px;margin-bottom:20px}}._1ZD6b ._3nwGW ._3rDZu{letter-spacing:1px}._1QLAD{background-color:#f7f7f7;margin-top:17vh;padding-bottom:20px;border-radius:4px;text-align:center;position:relative}._1QLAD .lQsGN{width:300px;margin:auto}._1QLAD .lQsGN input._1PPDJ{padding-left:36px}._1QLAD .lQsGN ._2JeFL{margin:0 -50px}._1QLAD .lQsGN ._2JeFL p{font-size:13px}._1QLAD .lQsGN ._2JeFL input{margin-right:4px}._1QLAD ._25PWf{width:300px;margin:auto;padding-top:25px}._1QLAD ._25PWf span{top:-18px;padding-left:6px;padding-right:6px}._1QLAD ._25PWf span,._2sfDo{position:relative;background-color:#f7f7f7}._2sfDo{margin-top:17vh;padding-top:1px;padding-bottom:20px;border-radius:4px;text-align:center}._2sfDo ._16t1Z{width:300px;margin:auto}._3O-Rc{background-color:#f7f7f7;margin-top:17vh;padding-top:1px;padding-bottom:20px;border-radius:4px;text-align:center;position:relative}._3O-Rc ._1rxXL{width:300px;margin:auto}._3O-Rc ._1rxXL ._3rDZu{width:150px}._3O-Rc ._1rxXL ._2JeFL{margin:0 -50px}._3O-Rc ._1rxXL ._2JeFL p{font-size:13px}._22J50{height:210px;background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%;margin-bottom:50px}@media (max-width:767px){._22J50{height:160px}}._3NkcO{margin-top:50px;margin-bottom:200px}._3NkcO h1{font-size:36px}._3NkcO h2{margin-bottom:0}._3NkcO h4{line-height:24px;margin-bottom:20px}._3NkcO h4._2Z6-Q{margin-bottom:10px}._3NkcO ._3Vnc2{font-weight:lighter;margin-top:68px}._3NkcO ._3J8_A{position:relative;padding-bottom:30px;border-top:1px solid #e8e8e8}._3NkcO ._3J8_A .gIM7Z{position:absolute;top:30px;right:0;z-index:-1}._3NkcO ._3J8_A:last-child{border-bottom:1px solid #e8e8e8}._3NkcO ._3J8_A a{text-align:center}._3NkcO ._3J8_A ul{list-style-type:inherit;padding-left:24px}._3NkcO ._3J8_A ul li{margin-bottom:10px}._3NkcO ._3J8_A ul li:last-child{margin-bottom:20px}._3NkcO ._3J8_A table._17bhS tr td{padding-left:4px;padding-right:4px}._3NkcO ._3J8_A table._17bhS tr td._36au2{text-align:center}._3qMxW{padding-top:100px}._3qMxW ._2OfJz{position:relative;bottom:0}@media (max-width:767px){#_2kmH_ .ZdsF7>div{padding-left:0;padding-right:0}}#_2kmH_ ._1QOLn{background-color:#fff;margin-top:100px;margin-bottom:100px;position:relative}@media (max-width:767px){#_2kmH_ ._1QOLn{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_2kmH_ ._1QOLn ._1CDHc{position:absolute;top:-50px;right:0}@media (max-width:767px){#_2kmH_ ._1QOLn ._1CDHc{position:fixed;top:15px}}#_2kmH_ ._1QOLn .F1GZI{margin-bottom:60px}#_2kmH_ ._1QOLn .Xzwqa td{width:50%}#_2kmH_ ._1QOLn ._1jThf{margin:0}#_2kmH_ ._1QOLn ._1bb5l{margin-bottom:15px}#_2kmH_ ._1QOLn .EnnC9{background-color:#006a96;color:#fff}#_2kmH_ ._1QOLn .EnnC9 h2{margin:54px 40px 30px}@media (max-width:767px){#_2kmH_ ._1QOLn .EnnC9{position:fixed;width:100%;margin-top:-60px}#_2kmH_ ._1QOLn .EnnC9 h2{margin:20px}}#_2kmH_ ._1QOLn .k6qzo{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:767px){#_2kmH_ ._1QOLn .k6qzo{margin-top:60px;padding-left:10px;padding-right:10px}}#_2kmH_ ._1QOLn .k6qzo hr{margin-left:10px}#_2kmH_ ._1QOLn .k6qzo p{margin:0;line-height:24px}#_2kmH_ ._1QOLn .k6qzo ._1R9Td{margin-bottom:0}#_2kmH_ ._1QOLn .k6qzo ._1X9gQ{float:right;width:220px;margin-top:60px}._2GfRi{height:210px;background-image:url(" + escape(__webpack_require__(586)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._2GfRi{height:160px}}._3QB01{margin-top:60px;margin-bottom:84px}@media (max-width:767px){._3QB01{margin-bottom:40px}}._3QB01 ._3751L{margin-bottom:10px}._3QB01 ._3751L ._2hPCm{color:#fec930;font-weight:400;font-size:1.5em;margin-top:0;margin-bottom:32px;display:block}@media (max-width:767px){._3QB01 ._3751L ._2hPCm{margin-bottom:20px}}._3QB01 ._3751L ._27Jfd{line-height:24px;margin-top:32px;margin-bottom:38px}@media (max-width:767px){._3QB01 ._3751L ._27Jfd{margin-top:20px;margin-bottom:0}}._3QB01 ._3751L .D9XIN{margin-bottom:10px;line-height:24px}._3QB01 ._3751L .D9XIN a{font-weight:lighter}._3QB01 ._3751L ._2Ra-l{color:#fec930}._3QB01 ._68Fnu{text-align:center}._3QB01 ._68Fnu .d29dH{margin-top:0;font-weight:lighter;display:none}@media (max-width:767px){._3QB01 ._68Fnu ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._3QB01 ._68Fnu ._3rDZu{width:100%}@media (max-width:767px){._3QB01 ._68Fnu ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._2-Vh2,._2GqDO{margin-top:31px}._2i8fX ._2Kh2v,._2iGa0 ._22Joy,._3KUIw ._1o8n6{margin-bottom:41px;font-weight:400;font-size:36px}@media (max-width:767px){._2i8fX ._2Kh2v,._2iGa0 ._22Joy,._3KUIw ._1o8n6{font-size:28px}}._2eBQb{height:400px;background-image:url(" + escape(__webpack_require__(825)) + ");background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat}._2i8fX{margin-top:28px;margin-bottom:72px;text-align:center}._2i8fX ._2iB-y{line-height:24px;letter-spacing:.5px;color:#8c8c8c}@media (max-width:767px){._2i8fX ._2iB-y{font-size:14px}}._3Keih{padding-top:226px;padding-bottom:226px;background-color:#006a96;background-image:url(" + escape(__webpack_require__(826)) + ");background-repeat:no-repeat;background-position:50%;background-size:100%;color:#fff;text-align:center}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){._3Keih{background-image:url(" + escape(__webpack_require__(827)) + ")}}@media (max-width:767px){._3Keih{padding-top:36px;padding-bottom:45px}}@media (max-width:767px){._3Keih ._2Heaf{font-size:28px}}._3Keih ._2MutF ._2B-Rb{display:inline-block;margin:0 20px;text-align:center}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb{margin:0 10px}}._3Keih ._2MutF ._2B-Rb *{margin:0}._3Keih ._2MutF ._2B-Rb ._15Si0{color:#fec930;font-size:40px;font-weight:bolder}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb ._15Si0{font-size:28px}}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb .VXYAK{font-size:14px}}._3KUIw{margin-top:52px;margin-bottom:64px;text-align:center}@media (max-width:767px){._3KUIw ._1o8n6{font-size:28px}}._3KUIw ._1gEeL{line-height:24px;color:#8c8c8c}@media (max-width:767px){._3KUIw ._1gEeL{font-size:14px}}._3KUIw ._2-Vh2{margin-top:31px}._31vm2{background-image:url(" + escape(__webpack_require__(828)) + ");background-size:cover;background-repeat:no-repeat;background-position:50% 100%;height:400px;color:#fff;text-align:center;margin-top:52px}@media (min-width:1024px) and (max-width:1439px){._31vm2{height:33.7vw}}@media (max-width:767px){._31vm2{height:310px}}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){._31vm2{background-image:url(" + escape(__webpack_require__(829)) + ")}}._31vm2 .EcXB-{padding-top:40px}._31vm2 ._1kDLQ{padding:12px 26px;font-size:12px;height:auto}@media (max-width:767px){._31vm2 ._1kDLQ{padding:12px 26px}}._31vm2 ._1kDLQ a{color:#fff;letter-spacing:.86px}._2iGa0 .ZdsF7{text-align:center}._2iGa0 .ZdsF7 ._3vc2d{color:#8c8c8c}@media (max-width:767px){._2iGa0 .ZdsF7 ._3vc2d{font-size:14px}}._2xoGR{margin-top:52px;margin-bottom:64px}._2xoGR .ZdsF7{width:100%;max-width:100%;margin:0;background-color:#f6f6f6;padding:1px 1px 20px}._2xoGR ._1YDAv{text-align:center}._2xoGR .NSUQt{display:inline-block;padding:5px 20px}._2xoGR .NSUQt ._1zdNP{display:inline-block;vertical-align:middle}._2xoGR ._3MFv5{text-align:center;color:#8c8c8c}._3Q4aW{height:210px;background-image:url(" + escape(__webpack_require__(830)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._3Q4aW{height:160px}}.Vn63I{margin-top:50px;margin-bottom:50px}.Vn63I ._3sbvY{font-size:36px;font-weight:400}.Vn63I li,.Vn63I p,.Vn63I ul{font-weight:lighter;font-size:14px;line-height:22px}.Vn63I ._2qhfp{list-style-type:decimal;padding-left:20px}.Vn63I ._2qhfp>li{margin-top:14px;margin-bottom:14px}.Vn63I ._1yuwc{list-style-type:disc}.Vn63I .iNheQ{margin-left:1em}._1pe1D{height:200px;background-image:url(" + escape(__webpack_require__(831)) + ");background-size:100%;background-position:50% 50%;margin-bottom:50px}@media (max-width:767px){._1pe1D{height:140px;margin-bottom:30px}}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1pe1D{background-image:none;height:60px}}.vMg3P{margin-bottom:80px}@media (max-width:767px){.vMg3P{margin-bottom:40px}}.vMg3P hr{border:0;height:1px;color:#cacaca;background-color:#cacaca}.vMg3P ._17X15{margin-bottom:70px}.vMg3P ._17X15 h1{font-size:30px;margin-bottom:10px}@media (max-width:767px){.vMg3P ._17X15 h1{font-size:28px}}.vMg3P ._17X15 h2{margin-top:10px;display:block}.vMg3P ._17X15 h4{font-weight:100;margin-top:40px;margin-bottom:58px;line-height:24px;max-width:620px}@media (max-width:767px){.vMg3P ._2U-6U img{width:100%}}.vMg3P .QIsRI{margin:0}.vMg3P .QIsRI ._1p6TH{position:relative;padding-left:0;padding-right:0;height:400px;overflow:hidden}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH{height:200px}}.vMg3P .QIsRI ._1p6TH img{min-height:100%;min-width:100%}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH img{min-height:200px;height:auto;width:100%}}.vMg3P .QIsRI ._1p6TH ._18735{position:absolute;bottom:0;left:0;right:0;background:#0088bf;height:8px;-webkit-transition:height .25s ease-in-out;-o-transition:height .25s ease-in-out;transition:height .25s ease-in-out}.vMg3P .QIsRI ._1p6TH ._2Slqz{position:absolute;left:0;right:0;bottom:0;color:#fff;padding:21px}.vMg3P .QIsRI ._1p6TH ._2Slqz h2{margin:0;font-size:20px}.vMg3P .QIsRI ._1p6TH ._2Slqz p{font-size:14px;margin-top:14px;margin-bottom:16px;min-height:44px}@media (min-width:768px) and (max-width:1023px){.vMg3P .QIsRI ._1p6TH ._2Slqz p{margin-bottom:0;min-height:66px}}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH ._2Slqz{padding-top:10px;padding-bottom:10px}.vMg3P .QIsRI ._1p6TH ._2Slqz h2{font-size:18px}.vMg3P .QIsRI ._1p6TH ._2Slqz p{font-size:14px;margin-bottom:0}}.vMg3P .QIsRI ._1p6TH ._1E2le{display:block;position:absolute;top:0;left:0;bottom:0;right:0;opacity:0;background:#0088bf;-webkit-transition:opacity .3s linear;-o-transition:opacity .3s linear;transition:opacity .3s linear}.vMg3P .QIsRI ._1p6TH:hover img{background-color:#0088bf}.vMg3P .QIsRI ._1p6TH:hover ._1E2le{opacity:.5}.vMg3P .QIsRI ._1p6TH:hover ._18735{height:150px}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH:hover ._18735{height:110px}}.vMg3P .VJHSb{margin-top:80px}.vMg3P .VJHSb h2{margin:0}.vMg3P .VJHSb hr{margin-top:15px;margin-bottom:39px}.vMg3P ._3zJh3:last-child hr,.vMg3P ._11Llk:last-child hr,.vMg3P .TGBhW:last-child hr{display:none}.vMg3P ._3zJh3 ._1Wt-q,.vMg3P ._3zJh3 ._3Fe9f,.vMg3P ._3zJh3 ._229Cf,.vMg3P ._11Llk ._1Wt-q,.vMg3P ._11Llk ._3Fe9f,.vMg3P ._11Llk ._229Cf,.vMg3P .TGBhW ._1Wt-q,.vMg3P .TGBhW ._3Fe9f,.vMg3P .TGBhW ._229Cf{text-align:center}@media (max-width:767px){.vMg3P ._3zJh3 ._1Wt-q,.vMg3P ._3zJh3 ._3Fe9f,.vMg3P ._3zJh3 ._229Cf,.vMg3P ._11Llk ._1Wt-q,.vMg3P ._11Llk ._3Fe9f,.vMg3P ._11Llk ._229Cf,.vMg3P .TGBhW ._1Wt-q,.vMg3P .TGBhW ._3Fe9f,.vMg3P .TGBhW ._229Cf{width:80px;padding-left:10px}}.vMg3P ._3zJh3 ._1Wt-q img,.vMg3P ._3zJh3 ._3Fe9f img,.vMg3P ._3zJh3 ._229Cf img,.vMg3P ._11Llk ._1Wt-q img,.vMg3P ._11Llk ._3Fe9f img,.vMg3P ._11Llk ._229Cf img,.vMg3P .TGBhW ._1Wt-q img,.vMg3P .TGBhW ._3Fe9f img,.vMg3P .TGBhW ._229Cf img{vertical-align:-20px}.vMg3P ._3zJh3 ._2L6Px,.vMg3P ._3zJh3 ._3Be5L,.vMg3P ._3zJh3 .IiM8M,.vMg3P ._11Llk ._2L6Px,.vMg3P ._11Llk ._3Be5L,.vMg3P ._11Llk .IiM8M,.vMg3P .TGBhW ._2L6Px,.vMg3P .TGBhW ._3Be5L,.vMg3P .TGBhW .IiM8M{min-height:4em}.vMg3P ._3zJh3 ._2L6Px ._1_t-n,.vMg3P ._3zJh3 ._2L6Px ._1MFOl,.vMg3P ._3zJh3 ._3Be5L ._1_t-n,.vMg3P ._3zJh3 ._3Be5L ._1MFOl,.vMg3P ._3zJh3 .IiM8M ._1_t-n,.vMg3P ._3zJh3 .IiM8M ._1MFOl,.vMg3P ._11Llk ._2L6Px ._1_t-n,.vMg3P ._11Llk ._2L6Px ._1MFOl,.vMg3P ._11Llk ._3Be5L ._1_t-n,.vMg3P ._11Llk ._3Be5L ._1MFOl,.vMg3P ._11Llk .IiM8M ._1_t-n,.vMg3P ._11Llk .IiM8M ._1MFOl,.vMg3P .TGBhW ._2L6Px ._1_t-n,.vMg3P .TGBhW ._2L6Px ._1MFOl,.vMg3P .TGBhW ._3Be5L ._1_t-n,.vMg3P .TGBhW ._3Be5L ._1MFOl,.vMg3P .TGBhW .IiM8M ._1_t-n,.vMg3P .TGBhW .IiM8M ._1MFOl{color:#0088bf}.vMg3P ._3zJh3 ._2L6Px hr,.vMg3P ._3zJh3 ._3Be5L hr,.vMg3P ._3zJh3 .IiM8M hr,.vMg3P ._11Llk ._2L6Px hr,.vMg3P ._11Llk ._3Be5L hr,.vMg3P ._11Llk .IiM8M hr,.vMg3P .TGBhW ._2L6Px hr,.vMg3P .TGBhW ._3Be5L hr,.vMg3P .TGBhW .IiM8M hr{margin-top:16px;margin-bottom:19px}.vMg3P ._3zJh3 ._2L6Px p,.vMg3P ._3zJh3 ._3Be5L p,.vMg3P ._3zJh3 .IiM8M p,.vMg3P ._11Llk ._2L6Px p,.vMg3P ._11Llk ._3Be5L p,.vMg3P ._11Llk .IiM8M p,.vMg3P .TGBhW ._2L6Px p,.vMg3P .TGBhW ._3Be5L p,.vMg3P .TGBhW .IiM8M p{margin:0;line-height:1.375}.vMg3P ._3zJh3 ._2L6Px ._3rDZu,.vMg3P ._3zJh3 ._3Be5L ._3rDZu,.vMg3P ._3zJh3 .IiM8M ._3rDZu,.vMg3P ._11Llk ._2L6Px ._3rDZu,.vMg3P ._11Llk ._3Be5L ._3rDZu,.vMg3P ._11Llk .IiM8M ._3rDZu,.vMg3P .TGBhW ._2L6Px ._3rDZu,.vMg3P .TGBhW ._3Be5L ._3rDZu,.vMg3P .TGBhW .IiM8M ._3rDZu{margin-top:20px}.vMg3P ._3pveH{font-weight:lighter;font-size:14px;padding-top:20px;padding-bottom:30px}.vMg3P ._3pveH h3{margin-top:0;font-size:14px;font-weight:400;line-height:24px}.vMg3P ._3pveH ._1yuwc{list-style-type:disc;padding-left:20px;line-height:22px}.vMg3P ._3pveH ._22EK6{width:120px}@media (max-width:767px){.vMg3P ._3pveH ._22EK6{width:80px}}.vMg3P ._3pveH ._22EK6 img{width:90px;height:90px}@media (max-width:767px){.vMg3P ._3pveH ._22EK6 img{width:60px;height:60px}}.vMg3P ._3pveH ._2fMr_{min-height:63px}.vMg3P ._3pveH ._33Mai{padding-top:40px}.vMg3P ._3pveH ._33Mai ._3rDZu{font-size:12px;letter-spacing:1px;text-align:center;width:130px}@media (max-width:767px){.vMg3P ._3pveH ._33Mai{padding-top:10px;padding-left:80px}}html[lang=zh-HK] ._1_t-n,html[lang=zh-HK] ._17X15 h2,html[lang=zh-HK] ._25wMv{font-weight:700}html[lang=zh-HK] ._2oDed h2{font-size:24px}html[lang=zh-HK] ._2oDed p{font-size:16px}._5ZbER{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}label{font-size:16px;font-size:1rem;font-weight:400;color:#4a4a4a;margin:10px 0}._2jlB3{color:#cacaca!important;cursor:not-allowed!important}._1W6ld{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._1W6ld._3BJvv{background-color:#fff}#_1u6J0{direction:rtl;width:90px;min-width:80px;padding-right:4px}._37sX1{background-color:#f6f6f6;padding-top:130px}@media (max-width:767px){._37sX1{padding-top:50px}}._37sX1 ui-image-upload .g5l-M ._1KCds .yLIZg{height:19px}._37sX1 ._1qUtG{padding-bottom:124px}._37sX1 ._3WoPP ._3cCsr{margin-top:40px;margin-bottom:0}._37sX1 ._1zQ7v._1bkYo._1CXyI ._2camJ{width:inherit;background-color:transparent}._37sX1 ._2_oWL .Hm2tb{display:none}._37sX1 ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._37sX1 ._1PPDJ._3sJzq{background-color:#f6f6f6;border:0}._37sX1 ._1PPDJ._3sJzq.J2hUy{-moz-appearance:none;background-image:url(" + escape(__webpack_require__(832)) + ");background-repeat:no-repeat;background-position:1em 1em;background-size:9px 5px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._37sX1 ._1PPDJ._3sJzq.J2hUy:active,._37sX1 ._1PPDJ._3sJzq.J2hUy:hover{background-color:#fff;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.3);box-shadow:0 1px 4px rgba(0,0,0,.3)}._37sX1 ._1PPDJ._3sJzq.J2hUy option{background-color:#fff}._37sX1 ._3AbwP{position:absolute;top:8px;right:12px;cursor:pointer}@media (max-width:767px){._37sX1 ._3AbwP{top:4px}}._37sX1 ._3_0Xz img{margin-top:20px}._37sX1 ._3_0Xz h2{font-size:1.5em;margin-top:20px;margin-bottom:20px;display:block}._37sX1 ._3_0Xz ._2cFBo,._37sX1 ._3_0Xz .GwQrN{margin-top:0;display:inline}._37sX1 ._3g_0b ._30n-g{padding-top:8px}._37sX1 ._3g_0b ._132cm{padding-left:20px}._37sX1 ._2OOFq ._3sGbs{display:-ms-flexbox;display:flex}._37sX1 ._2OOFq ._3sGbs .byV1i{width:8em;height:2.9em}._37sX1 .HcfKz ._2camJ{margin-top:150px!important;margin-bottom:150px!important}._37sX1 .HcfKz #_2kmH_ ._1QOLn{margin-top:0;margin-bottom:0}._22a9P{border-color:#0088bf}._2-6pC,._22a9P{color:#0088bf;font-size:12px}._2-6pC{letter-spacing:1px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._2-6pC:hover{color:#006a96}._2-6pC:hover ._3ltDJ[data-hover=true]{display:inline}._2-6pC:hover ._3ltDJ[data-hover=false]{display:none}._2-6pC ._3ltDJ{vertical-align:-4px;margin-right:.5em}._2-6pC ._3ltDJ[data-hover=true]{display:none}.mYUvl{font-size:12px;font-weight:bolder;letter-spacing:1px;margin-top:40px;margin-bottom:12px}._2wCEe ._3l3Pr,._2wCEe ._7qJOK{font-size:16px;vertical-align:bottom}._2wCEe ._3cqQc,._2wCEe ._3mpDC{font-size:16px;text-align:right;margin-bottom:9px;font-weight:300}._2wCEe ._3bkYF{margin-top:1em;font-size:18px;vertical-align:bottom;color:#00a493;font-weight:600}._2wCEe ._3q8Kf{font-size:40px;text-align:right;margin-bottom:9px;color:#00a493;font-weight:600}._2s6IY>div{display:none}._2s6IY>div .ij0TS{margin-top:0}._2s6IY>div._1mf5x img{cursor:pointer}._3utK6{padding-bottom:124px}._3utK6 ._12H4d{margin-top:15px}._3utK6 ._12H4d label{cursor:pointer}._3utK6 ._12H4d [type=radio],._3utK6 ._12H4d [type=text],._3utK6 ._12H4d p{margin-left:25px}._3utK6 .dnQW5{margin-top:0}._3utK6 .dnQW5 ._132cm{margin-top:25px}._3utK6 ._3mdnf{background-color:#fff;color:#6a4a4a}@media (max-width:767px){._3utK6 ._3mdnf._1YzL_{padding:0}}._3OKTV{cursor:not-allowed}._3bJl2{background-color:#fff;height:180px;margin:auto;color:#0088bf;text-align:center;padding-top:86px;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d5d5d5;border-radius:4px;position:relative}@media (max-width:767px){._3bJl2{height:115px;padding-top:47px;padding-left:150px;text-align:left}}._3bJl2:hover{border-color:#0088bf}._3bJl2._3b4Sw{border-width:4px;border-color:#fec930;background-image:url(" + escape(__webpack_require__(833)) + ");background-size:51px 51px;background-repeat:no-repeat;background-position:100% 0;background-origin:border-box}@media (max-width:767px){._3bJl2._3b4Sw{padding-top:44px;padding-left:147px}}._3bJl2._3b4Sw img{bottom:87px}@media (max-width:767px){._3bJl2._3b4Sw img{bottom:37px;left:37px}}._3bJl2 img{position:absolute;bottom:90px;left:0;right:0;margin:auto}@media (max-width:767px){._3bJl2 img{bottom:40px;left:40px;right:auto}}._3QXL5{display:none}._1Ed0C{line-height:40px}.Ao7v8 .XjKHd ._1CDHc{position:absolute;top:-50px;right:0}.Ao7v8 .XjKHd ._1xxxB{background-color:#006a96;color:#fff}.Ao7v8 .XjKHd ._1xxxB h2{margin:54px 40px 30px}.Ao7v8 .XjKHd ._14X1X{color:#4a4a4a;padding:30px 60px 60px 40px}.Ao7v8 .XjKHd ._14X1X._2Zov_{text-align:center}.Ao7v8 .XjKHd ._14X1X._2Zov_ ._3zs6Z{font-size:12px;letter-spacing:1px}.Ao7v8 .XjKHd ._14X1X._2Zov_ ._3RB8R{color:#0088bf}.Ao7v8 .XjKHd ._14X1X p{margin:0;line-height:24px}.Ao7v8 .XjKHd ._14X1X ._28qyD{float:right;width:220px;margin-top:60px}@media (max-width:767px){.Ao7v8 .XjKHd ._14X1X ._28qyD{width:auto}}@media (max-width:767px){#_1Gd_L .ZdsF7>div{padding-left:0;padding-right:0}}#_1Gd_L ._2yLrr{background-color:#fff;position:relative}@media (max-width:767px){#_1Gd_L ._2yLrr{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_1Gd_L ._2yLrr ._1CDHc{position:absolute;top:-50px;right:0}@media (max-width:767px){#_1Gd_L ._2yLrr ._1CDHc{position:fixed;top:20px}}#_1Gd_L ._2yLrr ._1bb5l{margin-bottom:15px}#_1Gd_L ._2yLrr ._18QxU{background-color:#006a96;color:#fff}#_1Gd_L ._2yLrr ._18QxU h2{margin:54px 40px 30px}@media (max-width:767px){#_1Gd_L ._2yLrr ._18QxU{position:fixed;width:100%;margin-top:-60px}#_1Gd_L ._2yLrr ._18QxU h2{margin:20px}}#_1Gd_L ._2yLrr ._3HE75{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:767px){#_1Gd_L ._2yLrr ._3HE75{margin-top:60px;padding-left:10px;padding-right:10px}}#_1Gd_L ._2yLrr ._3HE75 hr{margin-left:10px}#_1Gd_L ._2yLrr ._3HE75 p{margin:0;line-height:24px}#_1Gd_L ._2yLrr ._3HE75 ._3vanm{margin-bottom:0}#_1Gd_L ._2yLrr ._3HE75 ._1rDDr{float:right;width:220px;margin-top:60px}#_3oau8 .lABY4{background-color:#fff;position:relative}#_3oau8 .lABY4 ._1CDHc{position:absolute;top:-50px;right:0}#_3oau8 .lABY4 .V9fXg{background-color:#006a96;color:#fff}#_3oau8 .lABY4 .V9fXg h2{font-size:24px;margin:54px 40px 30px}#_3oau8 .lABY4 .qIrle{color:#4a4a4a;padding:30px 60px 60px 40px}#_3oau8 .lABY4 .qIrle p{margin:0;font-size:16px;line-height:24px}#fJHca ._2gzBZ{margin-top:200px;position:relative}#fJHca ._2gzBZ ._1CDHc{position:absolute;top:-50px;right:0}#_1F0MN{display:none;padding-bottom:20px}.IRd_G hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:4px}.IRd_G .yabym>div{margin-top:.5em;margin-bottom:.5em;line-height:24px}.IRd_G ._2Da3K{margin:0 8px;margin-left:4px;vertical-align:middle}.IRd_G ._13tGj{margin-bottom:2px}.IRd_G ._13tGj>div{line-height:24px;margin-bottom:.75em}.IRd_G ._3PLKh{float:right}.IRd_G ._1Xd5d img{width:100%}#_1TiJI ._po4e{border-color:#e75467;color:#e75467}#_1TiJI ._po4e:hover{background-color:#e75467;color:#fff}._1Lwc-{display:block}._1Lwc- ._22NuY{display:inline-block;margin:10px}._2jed3,._2XHv1{margin-top:10px;display:inline-block}.jROZJ{width:100px;height:100px;position:relative;float:left;margin-right:20px;cursor:pointer;background-size:cover;background-position:50%;background-repeat:no-repeat;background-image:url(" + escape(__webpack_require__(834)) + ")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.jROZJ{background-image:url(" + escape(__webpack_require__(835)) + ")}}.jROZJ .AJ8fj{position:absolute;right:-6px;top:-6px;width:24px;height:24px;cursor:pointer;display:none}._35LlM{padding-left:2em;padding-right:3em}._3Ieq3 ._2oCU2{height:100%;bottom:0}._1b5vx{max-height:400px;overflow-y:scroll}._3Xa1c{position:relative;height:56px}._3Xa1c input{border-color:#e75467;border-width:2px}._3Xa1c img.ASGAs{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.393 0.769 0.189 0 0 0.349 0.686 0.168 0 0 0.272 0.534 0.131 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"1.01\" /><feFuncG type=\"linear\" slope=\"1.01\" /><feFuncB type=\"linear\" slope=\"1.01\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncG type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncB type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"311\" /></filter></svg>#filter');filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg);-webkit-filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg)}._3Xa1c img._3AbwP{-webkit-filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.5144 0.6152000000000001 0.1512 0 0 0.2792 0.7488 0.13440000000000002 0 0 0.21760000000000002 0.4272 0.30479999999999996 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.56\" /><feFuncG type=\"linear\" slope=\"0.56\" /><feFuncB type=\"linear\" slope=\"0.56\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncG type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncB type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"300\" /></filter></svg>#filter');filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg)}._3Xa1c ._1kKj1{height:52px}._3Xa1c ._3zs6Z{color:#e75467;font-size:12px;margin-left:50px;position:absolute;left:0;bottom:0}#_2EybY ._1EBUY{margin-top:20px}#_2EybY ._1EBUY ._2-6pC{text-align:center;font-size:14px;color:#cacaca}#_2EybY ._1EBUY ._2-6pC img{-webkit-filter:brightness(-35%) contrast(0);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncG type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncB type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /></feComponentTransfer></filter></svg>#filter');filter:brightness(-35%) contrast(0)}#_2EybY ._1EBUY ._2-6pC:hover{color:#0088bf}#_2EybY ._1EBUY ._2-6pC:hover img{-webkit-filter:none;filter:none}._3zR94{padding-top:110px;padding-bottom:54px}._3zR94 .ZdsF7{background-image:url(" + escape(__webpack_require__(836)) + ");background-position:50% 0;background-repeat:no-repeat}._3zR94 .eobbf{margin-top:35px;margin-bottom:60px}._3zR94 .eobbf ._3UJNW{text-align:center;margin-bottom:0}._3zR94 .eobbf ._3l--v{margin-top:15px;text-align:center}._3zR94 .eobbf ._2kkxF{margin:0}._3zR94 ._2FDDs{width:200px;height:43px;font-size:1em;text-align:center}._3zR94 .RsP0H{margin-top:20px;margin-bottom:28px}._3zR94 ._2mj47 ._2fE1W{margin:0 20px;white-space:nowrap;line-height:28px}html[lang=zh-HK] ._2mj47{width:100%}.x4oQq{height:200px;background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-position:50% 15%;margin-bottom:50px}@media (max-width:767px){.x4oQq{height:140px;margin-bottom:30px}}._3R0g-{margin-bottom:100px}@media (max-width:767px){._3R0g- ._1umwt h1{font-size:22px}}._3R0g- .ZjmqP{margin-top:40px;border-top:1px solid #e8e8e8}._3R0g- .ZjmqP:nth-child(2){border:none;margin-top:60px}._3R0g- .ZjmqP .pHKvt{position:relative;top:3px;height:16px}._3R0g- .ZjmqP .RLABw{position:relative;top:3px;height:18px}._3R0g- .ZjmqP .ykM2L{line-height:22px;letter-spacing:.8px}._3R0g- .ZjmqP .-GXcZ{line-height:20px}._3R0g- ._2uZNB{margin-top:60px}._3R0g- a{color:#0088bf}._3R0g- a:hover{color:#00a9ee}html[lang=zh-HK] .ZjmqP ._3R0g-._2JV0n h4{font-weight:700}html[lang=zh-HK] ._2MreE ._3R0g-._3ZmKf p{font-weight:400}._1dImH{font-weight:lighter;margin-top:68px}._31Hea{height:374px;width:100%;margin-top:70px}._31Hea .qgHS8{bottom:200px}._2eOoj{background-color:#f6f6f6;padding-bottom:38px}@media (max-width:767px){._2eOoj h1{font-size:2em}}._2eOoj hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:6px}._2eOoj ._2FFT2{display:none}._2eOoj ._2apV8{margin-top:60px}._2eOoj ._2oZsN{line-height:68px}._2eOoj ._26gkz hr{margin-bottom:18px}._2eOoj ._26gkz ._2FYoy{text-align:center;font-size:20px;margin-top:42px;margin-bottom:49px;letter-spacing:.67px}._2eOoj ._26gkz ._2FYoy img._3BrF-{position:absolute;margin-left:40px}@media (max-width:767px){._2eOoj ._26gkz ._2FYoy img._3BrF-{margin-left:0}}._2eOoj ._26gkz ._2FYoy ._2nB13{font-size:10px}._2eOoj ._26gkz ._29Dnm{line-height:24px}._2eOoj ._26gkz ._29Dnm p{margin-top:0;margin-bottom:6px}._2eOoj ._26gkz ._29Dnm .OpJqh{float:left;margin-right:17px}._2eOoj ._3PLKh{float:right}._2eOoj ._39HV9>div{margin-top:.75em;margin-bottom:1em}._2eOoj .mcD3q>div{margin-top:19px;margin-bottom:19px}._2eOoj ._1d8UR{padding-left:4px;padding-right:8px;vertical-align:middle}._2eOoj ._1LQoz{margin-top:.75em;margin-bottom:1em}._2eOoj ._1LQoz img{padding-left:4px;padding-right:8px}._2eOoj ._1LQoz dd{display:inline}._2eOoj ._1LQoz a{position:relative;z-index:100}._2BG14{border-radius:40px}._3rDZu._2H8fJ._po4e{letter-spacing:.86px;margin-top:10px;width:100%;color:#ea5365;border-color:#ea5365}._3rDZu._2H8fJ._po4e:hover{background-color:#ea5365;color:#fff}#_1JYtN ._32DUx{background-color:#fff;text-align:center;border-radius:2px}#_1JYtN ._32DUx ._1uy56{padding-top:180px;background-color:#0088bf}#_1JYtN ._32DUx ._1uy56 .Ro7ve{position:relative;top:-180px;background-color:#0088bf;text-align:left}#_1JYtN ._32DUx ._1uy56 .Ro7ve p{padding:14px 20px;color:#fff;margin:0}#_1JYtN ._32DUx ._1pbKI{position:relative;top:-38px}#_1JYtN ._32DUx ._1pbKI ._2cOrO{width:300px}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._2cOrO{width:auto}}#_1JYtN ._32DUx ._1pbKI ._7qdaN{width:300px}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._7qdaN{width:150px;text-align:center;white-space:nowrap}}#_1JYtN ._32DUx ._1pbKI ._65koF{width:300px;padding:12.55px 0}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._65koF{width:150px;text-align:center;white-space:nowrap}}._38_3g ._1G40n{position:relative;background-color:#fff}._38_3g ._1G40n ._3_NBr{position:absolute;top:-50px;right:-4px}._38_3g ._4cLqW{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px;height:123px}._38_3g ._4cLqW h2{margin-top:0;padding-top:61px}._38_3g .lHXtK{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){._38_3g .lHXtK{padding-right:40px}}._38_3g .lHXtK ._20uOO{display:inline-block;margin-bottom:1em}._38_3g .lHXtK ._20uOO ._1lbmd{float:right;height:30px;padding-right:8px;cursor:pointer}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw .n2T0F,._38_3g .lHXtK ._20uOO ._1lbmd:hover .n2T0F{display:block}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw .IHHed,._38_3g .lHXtK ._20uOO ._1lbmd:hover .IHHed{display:none}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw~._1lbmd .n2T0F,._38_3g .lHXtK ._20uOO ._1lbmd:hover~._1lbmd .n2T0F{display:block}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw~._1lbmd .IHHed,._38_3g .lHXtK ._20uOO ._1lbmd:hover~._1lbmd .IHHed,._38_3g .lHXtK ._20uOO .n2T0F{display:none}._38_3g .lHXtK ._1YKa_ label{display:block}._38_3g .lHXtK ._3rDZu{padding-top:1em;padding-bottom:1em}._38_3g .lHXtK ._2geVD{background-color:transparent;border:none;color:#cacaca}#_1IyNo ._8CBG1{position:relative;background-color:#fff}#_1IyNo ._8CBG1 ._3_NBr{position:absolute;top:-50px;right:-4px}#_1IyNo ._3Knrq{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px}#_1IyNo ._3Knrq h2{margin-top:61px;margin-bottom:34px}#_1IyNo ._1qFsQ{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){#_1IyNo ._1qFsQ{padding-right:40px}}#_1IyNo ._1qFsQ ._1YKa_{display:none}#_1IyNo ._1qFsQ ._1YKa_ label{display:block}#_1IyNo ._1qFsQ ._3rDZu{padding-top:1em;padding-bottom:1em}#_1IyNo ._1qFsQ ._2geVD{background-color:transparent;border:none;color:#cacaca}._1wki5{margin-bottom:26px}._1wki5 ._3gMYW{text-transform:uppercase;font-size:12px;font-weight:bloder;height:2.5em;line-height:2.5em;letter-spacing:1px;padding-left:2em;padding-right:2em;float:left;color:#fff}._1wki5 ._3gMYW._7Mq2g{background-color:#0088bf}._1wki5 ._3gMYW.U6xL2{background-color:#006a96}._1wki5 ._3gMYW._3SHHr{background-color:#00a493}._1wki5 ._3gMYW.Kz54i{background-color:#e75467}._1aoWb{background-color:#0088bf;padding-left:80px;color:#fff;font-size:1em;height:2em;line-height:2em}._1aoWb ._1CDHc{top:6px;position:absolute;width:18px;height:18px}#_12899 ._3rDZu{padding-top:1em;padding-bottom:1em}#_12899 ._3zzB2{background-color:transparent;border:none;color:#cacaca}#_2cDcK ._14X1X,#_3YZKd ._14X1X{padding-bottom:30px}._3BrF-{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-name:n36uq;animation-name:n36uq;-webkit-animation-duration:2s;animation-duration:2s}#_11M3G ._1XsRi{background-color:#fff;position:relative}#_11M3G ._1XsRi ._3_NBr{position:absolute;top:-50px;right:0}#_11M3G ._1XsRi ._29QOQ{background-color:#006a96;color:#fff}#_11M3G ._1XsRi ._29QOQ h2{margin:54px 40px 30px}#_11M3G ._1XsRi .Btnkp{color:#4a4a4a;padding:30px 60px 30px 40px}#_11M3G ._1XsRi .Btnkp p{margin:0;line-height:24px}#_11M3G ._1XsRi .Btnkp ._2YEOb{background-color:transparent;border:none;color:#cacaca}#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{float:right;margin-top:60px;width:220px}@media (min-width:768px) and (max-width:1023px){#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{width:auto;padding-left:20px;padding-right:20px}}@media (max-width:767px){#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{width:100%;margin-top:20px}}#_3xh-V ._2OmcH{background-color:#fff;position:relative}#_3xh-V ._2OmcH ._1CDHc{position:absolute;top:-50px;right:0}#_3xh-V ._2OmcH ._3licn{background-color:#006a96;color:#fff}#_3xh-V ._2OmcH ._3licn h2{margin:54px 40px 30px}#_3xh-V ._2OmcH ._2kaTV{color:#4a4a4a;padding:30px 60px 30px 40px}#_3xh-V ._2OmcH ._2kaTV p{margin:0;line-height:24px}#_3xh-V ._2OmcH ._2kaTV ._1elNQ{float:right;width:220px;margin-top:60px}#wMNXO ._5XuBu{background-color:#fff;position:relative}#wMNXO ._5XuBu ._1CDHc{position:absolute;top:-50px;right:0}#wMNXO ._5XuBu ._1wA7j{background-color:#006a96;color:#fff}#wMNXO ._5XuBu ._1wA7j h2{margin:54px 40px 30px}#wMNXO ._5XuBu ._1Ml1n{color:#4a4a4a;padding:30px 60px 30px 40px}#wMNXO ._5XuBu ._1Ml1n p{margin:0;line-height:24px}@-webkit-keyframes n36uq{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes n36uq{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}body._5FYG4{background-color:#f8f8f8}._1qQ29{background-image:url(" + escape(__webpack_require__(476)) + ")}._1qQ29,._3dK92{min-width:0;height:400px;background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat}._3dK92{background-image:url(" + escape(__webpack_require__(837)) + ")}._1TWTo{margin-top:-350px;padding-bottom:50px}._1TWTo ._1HDHb{color:#fff}._1TWTo ._3A7_2{height:300px;background-image:url(" + escape(__webpack_require__(838)) + ");background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat;border-radius:8px;position:relative}._1TWTo ._3A7_2 ._2OOXg{position:absolute;top:60px;right:2em}._1TWTo ._3A7_2 ._2OOXg h2{color:#fff;display:block}._1TWTo ._3A7_2 ._2OOXg ._3rDZu{width:200px;font-size:12px}._1TWTo ._3bNn4{background-image:url(" + escape(__webpack_require__(839)) + ")}._1TWTo ._2U9s0{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;border:1px solid #ddd;border-radius:8px;background-color:#fff;padding-bottom:50px}._1TWTo ._2U9s0 .-LSPU{padding:20px}._1TWTo ._2U9s0 .-LSPU,._1TWTo ._2U9s0 ._3xcgV{font-size:12px;font-weight:bolder}._1TWTo ._2U9s0 ._3xcgV thead tr{border-bottom:2px solid #006a96}._1TWTo ._2U9s0 ._3xcgV thead tr th{background-color:#0088bf;color:#fff;border:none;text-align:left;letter-spacing:1px}._1TWTo ._2U9s0 ._3xcgV thead tr th:first-child{width:20%}._1TWTo ._2U9s0 ._3xcgV thead tr th:nth-child(2){width:40%}._1TWTo ._2U9s0 ._3xcgV thead tr th:nth-child(3){width:20%}._1TWTo ._2U9s0 ._3xcgV thead tr th:last-child{text-align:right;width:20%}._1TWTo ._2U9s0 ._3xcgV tbody{font-size:16px;font-weight:400}._1TWTo ._2U9s0 ._3xcgV tbody tr{border-bottom:1px solid #ddd;cursor:pointer}._1TWTo ._2U9s0 ._3xcgV tbody tr:hover{background-color:#f6f6f6}._1TWTo ._2U9s0 ._3xcgV tbody tr td{border:none;text-align:left;vertical-align:baseline;padding-bottom:0;padding-top:0}._1TWTo ._2U9s0 ._3xcgV tbody tr td:last-child{text-align:right}._1TWTo ._2U9s0 ._3xcgV tbody tr td .AsVCb{margin-top:20px;margin-bottom:10px}._1TWTo ._2U9s0 ._3xcgV tbody ul._2TEdR li{width:420px;-o-text-overflow:ellipsis;text-overflow:ellipsis}._1TWTo ._2U9s0 .FvuHK{font-size:12px;color:#9b9b9b;font-weight:400;letter-spacing:1px;margin-top:20px}._1TWTo ._2U9s0 .FvuHK ._3oHgT{text-transform:uppercase;font-weight:bolder}._1TWTo ._2U9s0 .FvuHK ._22arr{text-transform:uppercase}@media (max-width:767px){._1TWTo ._2U9s0{overflow:scroll}._1TWTo ._2U9s0 table{min-width:760px}}._1TWTo ._1gkzN{text-align:center;font-size:12px;font-weight:400}._1TWTo ._1gkzN hr{border:none;border-top:1px solid #cacaca}._1TWTo ._1gkzN p{margin-top:0;margin-bottom:6px;line-height:normal}._1TWTo ._1gkzN p._2PyYK{background-color:#0088bf;color:#fff;padding:8px;text-transform:uppercase;letter-spacing:1px}._1TWTo ._1gkzN p._3mMF4{color:#999;letter-spacing:1px}._1TWTo ._1gkzN p._1LSj4{text-align:left;font-size:16px;color:#18a493;line-height:1.5em;margin-top:.75em;margin-bottom:.75em;letter-spacing:1px}._1TWTo ._1gkzN p._1LSj4 span{float:right;font-size:1.5em}._1TWTo ._1gkzN p.k9_AQ{font-size:16px;font-weight:bolder}._1TWTo ._1gkzN p.Y1Xbb{margin-bottom:10px;letter-spacing:1px}._1TWTo ._1gkzN p._1taS2{letter-spacing:1px;font-weight:700;margin-top:10px;color:#cacaca}._1TWTo ._1gkzN p._1taS2 .AsVCb:first-child{border-right:1px solid #cacaca;text-align:right}._1TWTo ._1gkzN p._1taS2 .AsVCb:last-child{text-align:left}._1TWTo ._1gkzN p._1taS2 a{color:#0088bf}._1TWTo ._1gkzN ._1xHqb{margin-top:10px;margin-bottom:10px}._1TWTo ._1gkzN ._1xHqb img{margin:0;border-radius:70px}._1TWTo ._1gkzN ._3rDZu{font-size:12px;padding-top:12px;padding-bottom:12px;height:38px;letter-spacing:1px}._1TWTo ._1gkzN ._2DRWh{height:200px}._1TWTo ._1gkzN ._1_jBF ._1H3cs,._1TWTo ._1gkzN ._3zldW ._1H3cs{font-size:20px;color:#0088bf;margin-top:88px;margin-bottom:76px;line-height:50px;letter-spacing:.67px}._2NwyD{padding-top:140px;padding-bottom:300px}._2NwyD ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._2NwyD ._3rDZu{font-size:12px;letter-spacing:.8px}._2NwyD ._1Nyfl{width:300px}._2NwyD ._2wdIg{font-size:18px;font-weight:lighter;line-height:28px;display:none}._2NwyD ._1rswt{display:none}._2NwyD hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:16px}body.-ZuDw{background-color:#f6f6f6}._3z6wN{background-color:#fff;padding-bottom:93px}._3z6wN ._1oArF{border-bottom:2px solid #cacaca}._3z6wN .QzzAF ._3RrB4{width:80px;width:5rem;height:80px;height:5rem;border-radius:5rem;display:inline-block;background-position:50%;background-size:cover;background-repeat:no-repeat}._3z6wN .QzzAF label._3rDZu{vertical-align:2.3em;margin-left:1em}._3z6wN ._2Dq8t ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._3z6wN ._2Dq8t .T4Jkb{height:48px;height:3rem;line-height:40px;line-height:2.5rem;vertical-align:middle}._3z6wN ._1Xvvs a{margin-top:10px;margin-bottom:10px}._3z6wN ._1Xvvs .ZYvEl{margin-left:35px;color:#bbb}._3z6wN ._1Xvvs ._3N7rs input{margin-bottom:0;margin-top:5px}._3z6wN ._1Xvvs ._3N7rs .ASGAs{display:none}._3z6wN ._1Xvvs ._3N7rs ._3AbwP{position:absolute;top:13px;right:10px}@media (max-width:767px){._3z6wN ._1Xvvs ._3N7rs ._3AbwP{top:9px}}._3z6wN ._1Xvvs ._3tV3Z{padding:8px}._3z6wN ._1Xvvs ._3tV3Z ._2esNT{padding:12px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k{width:40px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k._1sk-6 ._35Fnc{height:122px;top:40px;overflow:hidden}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6{width:40px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 ._1KWp9{padding:10px;margin:0}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 ._2esNT,._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 img{height:17px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5{width:20px;height:20px;padding:10px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5 img{width:20px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5:after{width:0}._3z6wN ._42uj6{float:left;margin:6px}._3z6wN button{margin:10px auto}._3z6wN ._2nF7I input{margin-left:4px}.qDzZ6{text-align:center}.qDzZ6 p{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}._1zQ7v._2hLM6 ._2camJ{width:640px;padding:0;background-color:transparent}.Sy11b{position:absolute;top:-8px;left:0;right:0;margin:auto;width:80%}.Sy11b p{padding-top:4px;padding-top:.25rem;padding-bottom:4px;padding-bottom:.25rem;font-size:12px;font-size:.75rem;font-weight:700;line-height:1.3em;letter-spacing:.85px;background:#ea5365;color:#fff;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}._1zQ7v._386WH{text-align:center}._1zQ7v._386WH ._2camJ{position:relative}._1zQ7v._386WH ._3H9aN{padding-left:60px;padding-right:60px}._1zQ7v._386WH ._3H9aN p{margin-bottom:30px;margin-bottom:1.875rem}._1zQ7v._386WH ._2sfRO ._1WO9m{width:75%;margin:auto;margin-bottom:30px}._1zQ7v._386WH ._2sfRO ._3bWfi{font-size:12px;font-size:.75rem;width:60%;margin:auto}._1zQ7v._386WH ._2sfRO ._3bWfi:after{width:57%;height:2px;background-color:#0088bf;margin:auto;position:relative;top:-1em}@media (max-width:767px){._1zQ7v._386WH ._2sfRO ._3bWfi{width:100%}}._1zQ7v._386WH ._2sfRO ._3bWfi ._2Fdfz{color:#737373;float:left;width:90px}._1zQ7v._386WH ._2sfRO ._3bWfi ._2Fdfz:after{content:\"\";display:block;border:1px solid #0088bf;background-color:#0088bf;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}._1zQ7v._386WH ._2sfRO ._3bWfi ._3Do1m{color:#afafaf;float:right;width:90px}._1zQ7v._386WH ._2sfRO ._3bWfi ._3Do1m:after{content:\"\";display:block;border:1px solid #d8d8d8;background-color:#d8d8d8;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}._1zQ7v._386WH p.kMSeD{letter-spacing:.67px}._1zQ7v._386WH p.kMSeD img{vertical-align:-8px;vertical-align:-.5rem}._1zQ7v._386WH h2{font-size:30px;font-size:1.875rem;letter-spacing:1px;margin-top:32px;margin-top:2rem;margin-bottom:16px;margin-bottom:1rem}._1zQ7v._386WH p{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}._1zQ7v._386WH ._1PPDJ{font-size:16px;font-size:1rem}._1zQ7v._386WH ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._1zQ7v._386WH ._1PPDJ._3cHA3{text-align:center;padding-right:15px;width:22%}._1zQ7v._386WH ._3rDZu{font-size:12px;font-size:.75rem}._1zQ7v._386WH ._3rDZu._1lycB{width:45%}._1zQ7v._386WH ._3rDZu._2jlB3{background-color:#e7e7e7;color:#9b9b9b}._1zQ7v._386WH ._3rDZu._22S6x{line-height:13.6px;line-height:.85rem}._1zQ7v._386WH ._3rDZu._22S6x span{font-size:10px;font-size:.625rem;color:#b1b1b1}._1zQ7v._386WH ._3BNo3{position:absolute;top:-8px;left:0;right:0;margin:auto;width:80%}._1zQ7v._386WH ._3BNo3 p{padding-top:4px;padding-top:.25rem;padding-bottom:4px;padding-bottom:.25rem;font-size:12px;font-size:.75rem;font-weight:700;line-height:1.3em;letter-spacing:.85px;background:#ea5365;color:#fff;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}._1TY8_{height:210px;background-image:url(" + escape(__webpack_require__(586)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._1TY8_{height:160px}}._1Yln6{margin-top:60px;margin-bottom:84px}@media (max-width:767px){._1Yln6{margin-bottom:40px;margin-left:10px}}._1Yln6 .UiJRG{margin-bottom:10px}._1Yln6 .UiJRG ._1hiGV{color:#fec930;font-weight:400;margin-top:0;margin-bottom:32px;display:block}@media (max-width:767px){._1Yln6 .UiJRG ._1hiGV{margin-bottom:20px}}._1Yln6 .UiJRG ._2474X{line-height:24px;margin-top:32px;margin-bottom:38px}@media (max-width:767px){._1Yln6 .UiJRG ._2474X{margin-top:20px;margin-bottom:0}}._1Yln6 .UiJRG .GRDTp{margin-bottom:10px;line-height:24px}._1Yln6 .UiJRG .GRDTp a{font-weight:lighter}._1Yln6 ._1kP80{text-align:center}._1Yln6 ._1kP80 ._1dOZk,._1Yln6 ._1kP80 ._3TQd7,._1Yln6 ._1kP80 h4{text-align:left;margin:0 0 10px}@media (max-width:767px){._1Yln6 ._1kP80 ._1dOZk,._1Yln6 ._1kP80 ._3TQd7,._1Yln6 ._1kP80 h4{max-width:320px;margin-left:auto;margin-right:auto}}._1Yln6 ._1kP80 .d29dH{margin-top:0;font-weight:lighter;display:none}@media (max-width:767px){._1Yln6 ._1kP80 ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._1Yln6 ._1kP80 ._3rDZu{width:100%}@media (max-width:767px){._1Yln6 ._1kP80 ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}.-Kvaq.eQqDs .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}.-Kvaq.eQqDs .zKju_{width:100%;max-width:100%;padding:0}.-Kvaq.eQqDs .Jqkjw{padding:15px 0;bottom:0}.-Kvaq.eQqDs .tsov8{text-align:center}.-Kvaq.eQqDs ._1KLue{margin-left:4px}.-Kvaq._3xKxN{background-image:url(" + escape(__webpack_require__(840)) + ");background-repeat:no-repeat;background-position:50% 100%;background-size:cover}.-Kvaq._3xKxN ._2b3cR{margin-top:5vh}.-Kvaq._3xKxN ._2OtEe{padding-top:6vh;padding-bottom:90px;text-align:left}@media (max-width:767px){.-Kvaq._3xKxN ._2OtEe{padding-top:70px;padding-bottom:70px;text-align:center}}.-Kvaq._3xKxN ._2OtEe ._3rDZu{margin:1em 0;background-color:#fff;color:#0088bf}.-Kvaq._3xKxN ._3p6_y{text-align:right}.-Kvaq._3xKxN ._3p6_y img{width:550px}.-Kvaq._3xKxN ._3VZtN{height:3em}@font-face{font-family:Interstate;font-style:normal;font-weight:300;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Light.ttf)}@font-face{font-family:Interstate;font-style:normal;font-weight:400;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Regular.ttf)}@font-face{font-family:Interstate;font-style:normal;font-weight:700;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Bold.ttf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:100;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Light.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:400;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Light.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:700;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Regular.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:900;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Bold.otf)}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:400;src:local(\"FZLTXHB--B51-0\")}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:700;src:local(\"FZLTZHB--B51-0\")}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:900;src:local(\"FZLTTHB--B51-0\")}._1zQ7v._1bkYo ._2Fm8Y:before{font-size:16px;font-size:1rem;font-family:symbols;content:\"\\EA05\";font-size:1.5em;right:0;top:-1.4em;color:#fff}._1zQ7v._1bkYo ._2Fm8Y:before:hover{color:#fff}*{-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:grayscale}body{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;font-size:16px;color:#4a4a4a;font-weight:400}button:focus,Button:focus,span:focus{outline:0}a{color:inherit;text-decoration:none!important}a:hover{text-decoration:none}a:focus{outline:0}h1{font-size:3em;margin:0}h1,h2{font-weight:lighter}h2{font-size:1.5em;letter-spacing:1px;display:inline-block;display:block;-webkit-margin-before:.83em;-webkit-margin-after:.83em;-webkit-margin-start:0;-webkit-margin-end:0}h2._zhea{border-top:3px solid #fec930;padding-top:12px;margin-top:0}@media (max-width:767px){h2._zhea{font-size:1.5em}}h3{font-size:1.5em}h4{font-size:1em}small{font-size:.875em}small._3-WO4{font-size:.6875em}dl,ol,ul{list-style-type:none}dl,dl dd,dl dt,ol,ul{margin:0;padding:0}p{line-height:1.5em}p._2bDBi{margin:0}._3TtA5{font-weight:lighter}.Dd1pC{font-weight:400}.cEmAd{font-weight:700!important}.t1VbU{color:#fec930}._1Yhod{color:#0088bf!important}._1DFdj,._1DFdj:hover{color:#ea5365}._1Gas-.pR2tb{position:fixed;width:inherit;top:0}.QB_qr{border-radius:0;border:0;width:650px;right:15%}@media (max-width:767px){.QB_qr{width:auto;right:auto}}.CYPW6{width:40px;height:40px;margin-left:610px;margin-top:-50px;margin-bottom:10px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}.CYPW6:hover .CYPW6:active .CYPW6:link .CYPW6:visited{background-color:transparent;border-color:transparent;border:0}@media (max-width:767px){.CYPW6{margin-left:auto}}.Ao7v8 .XjKHd{background-color:#fff;position:relative}.Ao7v8 .XjKHd ._3_NBr{position:absolute;top:-50px;left:0}header{position:fixed;width:100%;height:70px;border-top:4px solid #0088bf;background-color:hsla(0,0%,100%,.95);z-index:1000;font-size:14px;letter-spacing:1px;text-align:center}header ._8jILl{text-align:center;margin-top:-4px}header ._8jILl img{width:86px}@media (max-width:767px){header ._8jILl img{width:66px}}@media (max-width:767px){header{height:50px}}header ul{margin:0;height:100%}header ._2ppU5{position:absolute!important;left:0;top:-4px}header ._2ppU5 ul{margin:0}header ._2ppU5 ._2i8L_:lang(zh){font-size:14px}header ._2ppU5 .o2vx1{margin:0;margin-left:30px;float:left;font-weight:700;height:70px;line-height:70px;color:#999;border:0;border-top:4px;border-style:solid;border-color:transparent;font-size:12px}header ._2ppU5 .o2vx1:first-child{margin-left:30px}@media (min-width:768px) and (max-width:1023px){header ._2ppU5 .o2vx1{margin-left:20px}}@media (max-width:767px){header ._2ppU5 .o2vx1{margin-left:12px;height:50px;line-height:50px}}header ._2ppU5 .o2vx1._3b4Sw,header ._2ppU5 .o2vx1:hover{border-color:#fec930}header ._2ppU5 .o2vx1>*{display:block}header ._2ppU5 .o2vx1 ._2T3_D{color:#999;cursor:pointer}header ._2ppU5 .o2vx1 ._3geOS{position:relative;display:inline-block;margin-right:12px;height:2px;width:20px;vertical-align:4px;background-color:#999;font-size:0;line-height:0}header ._2ppU5 .o2vx1 ._3geOS:before{top:-6px}header ._2ppU5 .o2vx1 ._3geOS:after,header ._2ppU5 .o2vx1 ._3geOS:before{content:\"\";background-color:#999;width:20px;height:2px;position:relative;display:inline-block}header ._2ppU5 .o2vx1 ._3geOS:after{top:5px}header .AJMcR{position:absolute;right:0;top:-4px}header .AJMcR ._3rDZu._2H8fJ{color:#999;border-color:#999;letter-spacing:1px;display:inline}header .AJMcR ._3rDZu._2H8fJ:hover{color:#fff;background-color:#999}@media (max-width:767px){header .AJMcR ._3rDZu._2H8fJ{font-size:10px;letter-spacing:normal}}header .AJMcR ._3rDZu._2H8fJ._1MotY{border-color:#0088bf}header .AJMcR ._3rDZu._2H8fJ._1MotY:hover{color:#fff;background-color:#0088bf}header .AJMcR ._1Sp85{margin:0 15px;float:right;height:70px;line-height:70px;color:#999;border-top:4px solid transparent;text-align:right;cursor:pointer}@media (max-width:767px),(min-width:768px) and (max-width:1023px){header .AJMcR ._1Sp85{margin:0 10px}}@media (max-width:767px){header .AJMcR ._1Sp85{height:50px;line-height:50px}}header .AJMcR ._1Sp85 ._3rDZu{padding:7px;font-size:12px}header .AJMcR ._1Sp85._2jKU1{text-align:center}@media (max-width:767px){header .AJMcR ._1Sp85._2jKU1 span:first-child Button{border-top-right-radius:4px;border-bottom-right-radius:4px}header .AJMcR ._1Sp85._2jKU1 span:last-child{display:none}}header .AJMcR ._1Sp85._2jKU1 .GFGd5{width:90px;height:30px;line-height:1em;display:inline-block}header .AJMcR ._1Sp85._2jKU1 .SnmEN{border-top-right-radius:0;border-bottom-right-radius:0}header .AJMcR ._1Sp85._2jKU1 ._1yEpp{border-top-left-radius:0;border-bottom-left-radius:0;border-left:0}@media (max-width:767px){header .AJMcR ._1Sp85._2jKU1 ._1yEpp{width:70px;height:24px;line-height:.75em}}header .AJMcR ul{margin:0}@media (max-width:767px){header .AJMcR{right:5px}}header dd:after{clear:both}header._3k_0- .ZdsF7{position:relative}header._3k_0- ._8jILl{text-align:left}header._3k_0- ._8jILl img{width:90px}@media (max-width:767px){header._3k_0- ._8jILl img{width:66px}}header._3k_0- ._2ppU5{top:0;left:100px}header._3k_0- .AJMcR{top:0}header._3k_0- .AJMcR ._1Sp85{cursor:pointer}#OY5GE{color:#0088bf;position:relative}#OY5GE ._3bWfR{text-transform:uppercase}@media (max-width:767px){#OY5GE ._3bWfR{display:none}}#OY5GE ._2O6he{display:none;text-transform:uppercase}@media (max-width:767px){#OY5GE ._2O6he{display:inline}}#OY5GE img{vertical-align:middle;margin:0 4px;border:0 solid;border-radius:20px}#OY5GE dl{background-color:#fff;padding:10px 0;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.3);box-shadow:0 2px 4px rgba(0,0,0,.3);border-radius:2px;position:absolute;top:70px;right:-10px;width:220px;display:none}@media (max-width:767px){#OY5GE dl{top:50px}}#OY5GE dl dd{height:40px;line-height:40px;font-size:16px;text-align:left;hover-background-color:#e8e8e8}#OY5GE dl dd>a{color:#4a4a4a;display:block;padding-left:40px}.-Kvaq{background-image:url(" + escape(__webpack_require__(841)) + ");background-repeat:no-repeat;background-position:50% 0;background-size:cover;color:#fff;padding-top:73px}.-Kvaq .wY3pw{margin-top:32px}.-Kvaq ._2OtEe ._1H9h2{font-size:2.5em}.-Kvaq ._2OfJz{position:relative;bottom:0}._3LcIB{background-color:transparent}._3LcIB .NRFON a{color:#fff!important}._3LcIB ._1jWQk a._2H8fJ{color:#fff!important;border-color:#fff!important}._3LcIB ._3geOS,._3LcIB ._3geOS:after,._3LcIB ._3geOS:before{background-color:#fff!important}._3LcIB a{color:#fff}._1Giov ._1jWQk a._2H8fJ{color:#0088bf}._1Giov ._1jWQk a._2H8fJ:hover{color:#fff}.h2dVE ._2b3cR{width:100%;max-width:100%;margin-top:7vh}@media (min-width:1440px){.h2dVE ._2b3cR{margin-top:12vh}}.h2dVE .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}.h2dVE .zKju_{width:100%;max-width:100%;padding:0}.h2dVE ._2OtEe{padding-bottom:2vh;text-align:center}@media (min-width:768px) and (max-width:1023px){.h2dVE ._2OtEe{padding-top:100px;padding-bottom:100px}}@media (max-width:767px){.h2dVE ._2OtEe{padding-top:70px;padding-bottom:70px}}.h2dVE ._1mNbz{height:297px;text-align:center}.h2dVE .Jqkjw{padding:35px 0;bottom:0}.h2dVE ._2OfJz{background-color:#006a96}.h2dVE ._2OfJz .fCIYr ._1Nyfl ._2atma._2y8KP{border-left-width:2px}.h2dVE ._1FzLI{margin-left:4px}.h2dVE .tsov8{text-align:center}.R4up1 ._2b3cR{padding-top:15vh;padding-bottom:0}@media (min-width:1440px){.R4up1 ._2b3cR{padding-top:24vh}}@media (min-width:768px) and (max-width:1023px){.R4up1 ._2b3cR{padding-top:0;padding-bottom:100px}}@media (max-width:767px){.R4up1 ._2b3cR{padding-top:0}}.R4up1 ._2OtEe{padding-top:135px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){.R4up1 ._2OtEe{text-align:center}}@media (max-width:767px){.R4up1 ._2OtEe{padding-top:50px;padding-bottom:50px}}.R4up1 ._2OfJz ._1TbJI{border-right:1px solid #cacaca!important;border-top-left-radius:4px!important;border-top-right-radius:4px!important;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.R4up1 ._2OfJz ._2y8KP{border-left:1px solid #cacaca!important;border-top-left-radius:0!important;border-top-right-radius:0!important;border-bottom-left-radius:4px!important;border-bottom-right-radius:4px!important}.R4up1 ._2OfJz .fCIYr ._1Nyfl{display:block;max-width:100%;width:420px;margin:auto}.R4up1 ._1mNbz{position:relative;bottom:-39px;right:0;text-align:center}.R4up1 .zH59r{display:none}.R4up1 ._2OfJz{padding-top:150px}.R4up1 ._2OfJz ._1FzLI{max-width:100%;margin-top:10px;margin-left:0;height:40px;width:420px}@media (max-width:767px){.R4up1 ._2OfJz{padding-top:50px;padding-bottom:50px}}._3qMxW ._2b3cR{margin-top:9vh}@media (min-width:1440px){._3qMxW ._2b3cR{margin-top:15vh}}._3qMxW .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}._3qMxW .zKju_{width:100%;max-width:100%;padding:0}._3qMxW ._2OtEe{padding-top:220px;padding-bottom:90px;text-align:left}@media (max-width:767px){._3qMxW ._2OtEe{padding-top:70px;padding-bottom:70px;text-align:center}}._3qMxW ._1mNbz{text-align:right}._3qMxW .Jqkjw{padding:15px 0;bottom:0}._3qMxW .tsov8{text-align:center}._3qMxW ._1FzLI{margin-left:4px}._1r9_5{margin-top:40px;margin-bottom:40px;text-align:center}._1r9_5 ._1herx{line-height:1.5;color:#8c8c8c}._1r9_5 ._3cnlI{margin:30px 10px 0;display:inline-block}@media (max-width:767px){._1r9_5 ._3cnlI{margin:10px 10px 0}}._1r9_5 ._3cnlI [data-hover=true]{display:none}._1r9_5 ._3cnlI:hover [data-hover=true],._1r9_5 ._3cnlI [data-hover=false]{display:inline}._1r9_5 ._3cnlI:hover [data-hover=false]{display:none}._1r9_5 ._2wIYV{line-height:1.5;color:#0089c0}._15hCe{height:250px}@media (max-width:767px){._15hCe{height:180px}}._3SFmo{text-align:center;padding-top:20px;padding-bottom:70px}._3SFmo ._2tau2{line-height:1.5;color:#8c8c8c}._3SFmo .E5nK4{padding-top:70px;height:50px;position:relative}._3SFmo .E5nK4 img{position:absolute;bottom:0;left:0;right:0;margin:auto}@media (max-width:767px){._3SFmo .E5nK4{padding-top:35px}}._3SFmo .R2n1V{border-top:1px solid #cacaca;min-height:110px}._3SFmo .R2n1V p{margin-top:7px;margin-bottom:26px}._3SFmo ._3rDZu._2H8fJ{letter-spacing:1px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._3SFmo .AzeNc{left:0}}@media (max-width:767px){._3SFmo .AzeNc{margin-bottom:40px}}._3ltbW{text-align:center;padding-top:20px;padding-bottom:50px;background-color:#0088bf;color:#fff;position:relative}._3ltbW ._2Oh5F{margin-top:73px;margin-bottom:31px}._3ltbW ._2Oh5F ._2jdPn{height:191px}._3ltbW ._2Oh5F ._2jdPn:hover{color:#fec930}._3ltbW ._2Oh5F ._2jdPn a{cursor:pointer}._3ltbW ._2Oh5F ._2jdPn ._1zdNP{height:86px}._3ltbW ._2Oh5F ._2jdPn .DVzGW{width:100%;height:40px;margin:auto}._3ltbW ._2Oh5F ._2jdPn ._2HdKi{margin-top:10px}@media (max-width:767px){._3ltbW ._2Oh5F{margin-top:46px}}._3ltbW.UREhu .kFtTa{position:absolute;background-color:rgba(0,0,0,.5);top:0;bottom:0;width:100%;z-index:999}._3ltbW.UREhu .kFtTa .ZdsF7{position:relative}._3ltbW.UREhu .kFtTa ._3ijdR{background-color:#0088bf;margin-top:90px}@media (min-width:768px) and (max-width:1023px){._3ltbW.UREhu .kFtTa ._3ijdR{margin-top:165px}}._3ltbW.UREhu .kFtTa ._3ijdR .Uk3Qe{height:280px}@media (min-width:768px) and (max-width:1023px){._3ltbW.UREhu .kFtTa ._3ijdR .Uk3Qe{height:310px}}._3ltbW.UREhu .kFtTa ._3ijdR ._3vcNQ{width:8px;height:8px;border-radius:16px;margin-left:6px;margin-right:6px}._3ltbW.UREhu .kFtTa ._3ijdR ._3vcNQ._3b4Sw{width:12px;height:12px;border-width:2px}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd,._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._38TMS{height:inherit}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu{text-align:left;margin-top:70px}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu p:first-child{display:inline}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu img{vertical-align:middle}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT{display:table-row}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dd,._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dt{vertical-align:middle;display:table-cell}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dt{width:50px}._3ltbW.UREhu .kFtTa ._3ijdR ._2u8W1{line-height:26px}._3ltbW.UREhu .kFtTa ._2mTqO{position:absolute;top:-46px;right:8px}._3Gtxx{padding-top:20px;text-align:center}._3Gtxx .ZdsF7{position:relative}._3Gtxx .CRTaF{z-index:-1}._3Gtxx .CRTaF .Uk3Qe{height:400px}._3Gtxx ._2oI8d{border-top-width:4px}@media (max-width:767px){._3Gtxx ._2oI8d{background-color:transparent;border:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1{border-top-width:4px;margin-top:-4px}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1{background-color:transparent;border-top-width:0}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3-AAL{width:100%}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw{background-color:#fec930}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw{background-color:transparent}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=inactive]{display:none}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=inactive]{display:inline}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=active]{display:inline}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=active]{display:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw ._1tq2d:hover{background-color:transparent}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw ._1tq2d:hover{background-color:#f8f8f8}}._3Gtxx ._2oI8d ._29rc- ._1U_U1:before{top:-20px;left:47%;border-width:20px;border-top-width:0;border-bottom:20px solid transparent;background:url(" + escape(__webpack_require__(842)) + ");background-position:16px -2px;background-size:34px 22px}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1:before{display:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-left:65px;padding-right:65px;padding-top:52px;height:240px;-webkit-box-sizing:border-box;box-sizing:border-box}._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d:hover{background-color:#f8f8f8}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-left:20px;padding-right:20px}}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-top:40px;padding-bottom:0;height:220px}}._3Gtxx ._2oI8d ._29rc- ._1U_U1 [data-status=inactive]{display:inline}._3Gtxx ._2oI8d ._29rc- ._1U_U1 [data-status=active]{display:none}._3Gtxx ._1UZ2y ._1es2l{font-size:0;width:100%;height:100%;float:left;position:relative}._3Gtxx ._1UZ2y ._1es2l ._1LIHx,._3Gtxx ._1UZ2y ._1es2l ._1Y7Ka{position:absolute;bottom:0;left:0;right:0;margin:auto}._3Gtxx ._1UZ2y ._1es2l ._1Y7Ka{top:0}._3Gtxx ._2o6B4{height:100%;position:absolute;top:0;bottom:0;right:60px}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2o6B4{right:30px}}@media (max-width:767px){._3Gtxx ._2o6B4{position:static}}._3Gtxx ._2o6B4 ._1I7an{margin-top:60px;margin-bottom:30px}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2o6B4 ._1I7an{margin-top:60px}}@media (max-width:767px){._3Gtxx ._2o6B4 ._1I7an{margin-top:42px;margin-bottom:42px}}._3Gtxx ._2o6B4 ._1I7an iframe{width:100%}._3Gtxx ._2o6B4 ._3Wt7w{border:1px solid #0088bf;border-radius:4px;margin-bottom:20px;max-width:320px;margin-left:auto;margin-right:auto}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu{display:inline-block;background-color:transparent;border-right:1px solid #0088bf;border-radius:0;color:#0088bf;width:50%;letter-spacing:.86px;font-size:13px}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu:last-child{border-right:none}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu:hover{color:#fec930}._3Gtxx ._2o6B4 ._3Wt7w img{vertical-align:-2px}._3Gtxx .-Gsfk{margin-bottom:0}._3Gtxx .-Gsfk ._24ngD{height:65px;padding-bottom:8px}._3Gtxx .-Gsfk ._24ngD img{position:relative}._3Gtxx .-Gsfk ._3HvUg{margin-top:10px;margin-bottom:10px;display:inline;font-weight:400}._3Gtxx .-Gsfk ._1l4Pm{font-weight:lighter;line-height:1.25em;display:inline}._3mdnf{background-color:#006a96;color:#fff;text-align:center;padding-bottom:62px}@media (max-width:767px){._3mdnf h2{font-size:1.5em}}._3mdnf ._3BCWw{height:260px;margin-bottom:20px}@media (max-width:767px){._3mdnf ._3BCWw{height:180px}}._3mdnf .mC2-h ._1PPDJ{color:#4a4a4a}@media (max-width:767px){._3mdnf .mC2-h ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._3mdnf .mC2-h ._3rDZu{width:100%}@media (max-width:767px){._3mdnf .mC2-h ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._3mdnf .d29dH,._14R3_ .d29dH{display:none}._6K4Jd{background-color:#006a96;color:#fff;text-align:center;padding-bottom:62px}@media (max-width:767px){._6K4Jd h2{font-size:1.5em}}._6K4Jd ._169Kc{height:260px;margin-bottom:20px}@media (max-width:767px){._6K4Jd ._169Kc{height:180px}}._6K4Jd ._2Oiad ._1PPDJ{color:#4a4a4a}@media (max-width:767px){._6K4Jd ._2Oiad ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._6K4Jd ._2Oiad ._3rDZu{width:100%}@media (max-width:767px){._6K4Jd ._2Oiad ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._6K4Jd ._2Oiad ._1bjPS{margin-top:20px}._6K4Jd ._2Oiad ._1bjPS ._nPCD{display:inline;color:#ffca05}._6K4Jd .d29dH{display:none}.TiqAf{text-align:center;margin:40px auto}.TiqAf .T3EE1{padding:auto;display:inline-block;margin:30px 20px}.TiqAf .T3EE1 img{vertical-align:middle}@media (max-width:767px){.TiqAf .T3EE1{margin:10px 20px}.TiqAf .T3EE1 img{height:20px}}footer{text-align:center;padding-top:50px;padding-bottom:75px;background-color:#f8f8f8}footer._3k_0- ._1pBHM{margin-bottom:20px;font-size:18px;font-weight:lighter;color:#cacaca}footer._3k_0- ._1pBHM a{margin:0 10px;color:#4a4a4a}footer._3k_0- .bCttm{text-align:center;font-weight:bolder}footer._3k_0- .bCttm a{color:#666;margin:0 15px}footer .bCttm{text-align:left;line-height:28px;font-size:.875em}footer .bCttm li:first-child{border-top:3px solid #fec930;padding-top:7px}footer .bCttm a{color:#666}footer .bCttm a:hover{color:#0088bf}footer ._23tsA{margin-bottom:34px}@media (max-width:767px){footer ._23tsA{margin-bottom:0}}footer ._23tsA li{margin:2px 0}footer ._23tsA small{color:#4a4a4a}footer ._23tsA ._3xUeT{font-size:1.75em;letter-spacing:1px;line-height:33px}footer ._23tsA ._3-WO4{color:#666}footer ._1OCOQ{text-align:left;margin:34px 22px 28px 0}@media (max-width:767px){footer ._1OCOQ{text-align:center;margin-right:0}}footer ._1OCOQ ._34oFX{display:-ms-inline-flexbox;display:inline-flex}footer ._1OCOQ ._34oFX a{margin:0 10px}@media (max-width:767px){footer ._1OCOQ ._34oFX{margin-bottom:50px;display:block}footer ._1OCOQ ._34oFX a{display:block;margin:10px 0}}footer ._1OCOQ ._34oFX ._3lbPI [data-hover=true]{display:none}footer ._1OCOQ ._34oFX ._3lbPI:hover [data-hover=true],footer ._1OCOQ ._34oFX ._3lbPI [data-hover=false]{display:inline}footer ._1OCOQ ._34oFX ._3lbPI:hover [data-hover=false]{display:none}footer .gP_1u{text-align:left;margin:20px auto}@media (max-width:767px){footer .gP_1u{text-align:center}}footer .gP_1u a{margin:0 10px}footer ._1sc2k{float:right;width:200px}@media (max-width:767px){footer ._1sc2k{float:none}}footer ._1sc2k img{vertical-align:-5px}footer ._1sc2k._1I1QC ._1C33D{top:0;height:175px}footer ._1sc2k .aqzh5{padding:12px;border:1px solid #d5d5d5;-webkit-box-sizing:border-box;box-sizing:border-box}@media screen and (max-width:800px){footer .bCttm{text-align:center;margin-bottom:20px}}footer ._1Zf0i{border-right:1px solid #ccc;height:180px;margin-bottom:28px}@media screen and (max-width:768px){footer ._1Zf0i{border-right:0;margin-bottom:0;height:180px;margin-bottom:28px}}footer ._1Zf0i ._1bSfM{width:10em;text-align:left;margin:0 auto;line-height:28px}footer ._1Zf0i ._1bSfM a:hover{color:#0088bf}footer ._1Zf0i ._1bSfM ._3kND8{margin-top:0;margin-bottom:1em;font-weight:bolder;color:#5c5c5c}footer ._1Zf0i ._1bSfM ._23tsA{display:block;color:#4a4a4a;margin-bottom:0}@media screen and (max-width:800px){footer ._1Zf0i ._1bSfM{width:100%;text-align:center;margin-bottom:20px}}html[lang=zh-HK] .Dd1pC{font-weight:600}html[lang=zh-HK] .cEmAd{font-weight:800!important}html[lang=zh-HK] body{font-family:Lato,Lucida Grande,Helvetica Neue,MyNormalFont,STHeitiTC,Microsoft JhengHei,Microsoft YaHei New,Microsoft YaHei,Helvetica,Arial,Verdana,sans-serif}html[lang=zh-HK] h2{font-size:1.875em}html[lang=zh-HK] header{font-size:14px}html[lang=zh-HK] ._3rDZu{font-weight:700}html[lang=zh-HK] ._2OtEe ._1H9h2{font-size:2.75em}html[lang=zh-HK] .DVzGW small{font-size:1em}html[lang=zh-HK] ._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{height:270px}html[lang=zh-HK] ._3Gtxx .-Gsfk ._3HvUg{display:inherit;font-weight:700}html[lang=zh-HK] ._3Gtxx .-Gsfk ._1l4Pm{display:block;font-size:16px;line-height:1.5em}html[lang=zh-HK] ._3QB01 ._2hPCm{font-size:1.875em}._3M6c6 ._1MrQ4{display:inline-block;color:#ffca05}._3M6c6 ._3jqTo{position:relative;top:4px}._1tDmc:hover{color:#0088bf}._2io21 ._2Vjpl{-webkit-transform:translateY(80px);-ms-transform:translateY(80px);transform:translateY(80px)}@media (max-height:645px),(max-width:767px){._2io21 ._2Vjpl{-webkit-transform:translateY(40px);-ms-transform:translateY(40px);transform:translateY(40px)}}._2io21 ._2Vjpl ._3u_ab{min-height:74px}@media (max-height:700px){._2io21 ._2Vjpl ._3u_ab{font-size:18px;min-height:60px}}@media (max-width:767px){._2io21 ._2Vjpl ._3u_ab{min-height:40px}}a._3RB8R{color:#0088bf}a._3RB8R:hover{color:#00a9ee}a._3DY3x{color:#0088bf}a._3DY3x,a._3DY3x:hover{text-decoration:underline}a._3DY3x:hover{color:#00a9ee}._3rDZu._3mUoB{min-width:120px;text-align:center}#_1mQos ._1eAtq,#_1mQos ._2D_x1,#_2LFnb ._1eAtq,#_2LFnb ._2D_x1,#_2v8lt ._1eAtq,#_2v8lt ._2D_x1,._39juq ._1eAtq,._39juq ._2D_x1{margin-top:200px}.Jqkjw ._1ZfZi ._2L6Uk,.Jqkjw ._2IV17 ._3o3fv{display:block}.Jqkjw ._1ZfZi input,.Jqkjw ._2IV17 input{border-color:#e75467;border-width:2px}.Jqkjw ._1ZfZi img._3vfIx,.Jqkjw ._2IV17 img._3vfIx{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.393 0.769 0.189 0 0 0.349 0.686 0.168 0 0 0.272 0.534 0.131 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.92\" /><feFuncG type=\"linear\" slope=\"0.92\" /><feFuncB type=\"linear\" slope=\"0.92\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncG type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncB type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"311\" /></filter></svg>#filter');filter:sepia(1) saturate(1) brightness(92%) contrast(281%) hue-rotate(311deg);-webkit-filter:sepia(1) saturate(1) brightness(92%) contrast(281%) hue-rotate(311deg)}.Jqkjw ._1ZfZi img._28zLC,.Jqkjw ._2IV17 img._28zLC{-webkit-filter:sepia(.8) saturate(1) brightness(71%) contrast(290%) hue-rotate(300deg);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.5144 0.6152000000000001 0.1512 0 0 0.2792 0.7488 0.13440000000000002 0 0 0.21760000000000002 0.4272 0.30479999999999996 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.71\" /><feFuncG type=\"linear\" slope=\"0.71\" /><feFuncB type=\"linear\" slope=\"0.71\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncG type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncB type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"300\" /></filter></svg>#filter');filter:sepia(.8) saturate(1) brightness(71%) contrast(290%) hue-rotate(300deg)}.Jqkjw ._1ZfZi._1Nyfl,.Jqkjw ._2IV17._1Nyfl{height:56px}.Jqkjw ._2L6Uk,.Jqkjw ._3o3fv,.Jqkjw ._3zs6Z{display:none;color:#e75467;background-color:#fff;width:99.1%;margin:0;text-align:left;font-size:12px;letter-spacing:1px;position:absolute;left:0;border:2px solid #e75467}._11-QW ._3vl9D{text-align:center}#_1nQw9 ._2oCU2{position:relative;top:200px}#_1nQw9 ._38PI-{height:inherit}._1zQ7v._1bkYo._1IjRd,._1zQ7v._1bkYo._1O6iE,._1zQ7v._1bkYo._1QP_H,._1zQ7v._1bkYo._1uQEH,._1zQ7v._1bkYo._2yniJ,._1zQ7v._1bkYo._3kmhK,._1zQ7v._1bkYo._3OVyf,._1zQ7v._1bkYo._3p6Sy,._1zQ7v._1bkYo._3wAbS,._1zQ7v._1bkYo._3wP29,._1zQ7v._1bkYo._17G5p,._1zQ7v._1bkYo._32QA7,._1zQ7v._1bkYo._3280R,._1zQ7v._1bkYo.dUmLp,._1zQ7v._1bkYo.HcfKz{padding:0}._1zQ7v._1bkYo._1IjRd ._18xTg,._1zQ7v._1bkYo._1O6iE ._18xTg,._1zQ7v._1bkYo._1QP_H ._18xTg,._1zQ7v._1bkYo._1uQEH ._18xTg,._1zQ7v._1bkYo._2yniJ ._18xTg,._1zQ7v._1bkYo._3kmhK ._18xTg,._1zQ7v._1bkYo._3OVyf ._18xTg,._1zQ7v._1bkYo._3p6Sy ._18xTg,._1zQ7v._1bkYo._3wAbS ._18xTg,._1zQ7v._1bkYo._3wP29 ._18xTg,._1zQ7v._1bkYo._17G5p ._18xTg,._1zQ7v._1bkYo._32QA7 ._18xTg,._1zQ7v._1bkYo._3280R ._18xTg,._1zQ7v._1bkYo.dUmLp ._18xTg,._1zQ7v._1bkYo.HcfKz ._18xTg{text-align:right}._1zQ7v._1bkYo._1IjRd ._18xTg ._1CDHc,._1zQ7v._1bkYo._1O6iE ._18xTg ._1CDHc,._1zQ7v._1bkYo._1QP_H ._18xTg ._1CDHc,._1zQ7v._1bkYo._1uQEH ._18xTg ._1CDHc,._1zQ7v._1bkYo._2yniJ ._18xTg ._1CDHc,._1zQ7v._1bkYo._3kmhK ._18xTg ._1CDHc,._1zQ7v._1bkYo._3OVyf ._18xTg ._1CDHc,._1zQ7v._1bkYo._3p6Sy ._18xTg ._1CDHc,._1zQ7v._1bkYo._3wAbS ._18xTg ._1CDHc,._1zQ7v._1bkYo._3wP29 ._18xTg ._1CDHc,._1zQ7v._1bkYo._17G5p ._18xTg ._1CDHc,._1zQ7v._1bkYo._32QA7 ._18xTg ._1CDHc,._1zQ7v._1bkYo._3280R ._18xTg ._1CDHc,._1zQ7v._1bkYo.dUmLp ._18xTg ._1CDHc,._1zQ7v._1bkYo.HcfKz ._18xTg ._1CDHc{position:relative;top:0;right:0}._1zQ7v._1bkYo._1IjRd ._2camJ,._1zQ7v._1bkYo._1O6iE ._2camJ,._1zQ7v._1bkYo._1QP_H ._2camJ,._1zQ7v._1bkYo._1uQEH ._2camJ,._1zQ7v._1bkYo._2yniJ ._2camJ,._1zQ7v._1bkYo._3kmhK ._2camJ,._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo._3p6Sy ._2camJ,._1zQ7v._1bkYo._3wAbS ._2camJ,._1zQ7v._1bkYo._3wP29 ._2camJ,._1zQ7v._1bkYo._17G5p ._2camJ,._1zQ7v._1bkYo._32QA7 ._2camJ,._1zQ7v._1bkYo._3280R ._2camJ,._1zQ7v._1bkYo.dUmLp ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:200px;margin-bottom:200px;width:100%;background-color:transparent}@media (max-width:767px){._1zQ7v._1bkYo._1IjRd ._2camJ,._1zQ7v._1bkYo._1O6iE ._2camJ,._1zQ7v._1bkYo._1QP_H ._2camJ,._1zQ7v._1bkYo._1uQEH ._2camJ,._1zQ7v._1bkYo._2yniJ ._2camJ,._1zQ7v._1bkYo._3kmhK ._2camJ,._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo._3p6Sy ._2camJ,._1zQ7v._1bkYo._3wAbS ._2camJ,._1zQ7v._1bkYo._3wP29 ._2camJ,._1zQ7v._1bkYo._17G5p ._2camJ,._1zQ7v._1bkYo._32QA7 ._2camJ,._1zQ7v._1bkYo._3280R ._2camJ,._1zQ7v._1bkYo.dUmLp ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:80px}}@media (max-width:767px){._1zQ7v._1bkYo._3OVyf ._18xTg ._1CDHc,._1zQ7v._1bkYo.HcfKz ._18xTg ._1CDHc{position:fixed;top:15px}._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:0;margin-bottom:0;padding:0}}._1zQ7v._1bkYo.HcfKz #_2kmH_ ._1QOLn{margin-top:auto}.Ew0Lx{position:relative}@media only screen and (max-width:1024px){.NhaPQ{width:100%;max-width:100%}._2CMtn{display:none!important}}@media only screen and (min-width:1024px){.NhaPQ{width:100%;max-width:100%}._3V_Cy{display:none!important}}._1yPGZ{margin-right:4px}.Ao7v8{top:200px}._2ps_I{cursor:pointer}._3tbrB:hover{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.04706) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.04706);background-color:#fff}", ""]);

// exports
exports.locals = {
	"slider": "UREhu",
	"slider-content": "CRTaF",
	"slider-detail": "Uk3Qe",
	"slider-detail-item": "_3j1sT",
	"slider-control": "_2oI8d",
	"slider-option": "_29rc-",
	"rateStar": "Bg45n",
	"hourly-price": "_2kmH_",
	"hourly-price-container": "_1QOLn",
	"hourly-price-content-container": "k6qzo",
	"about-map": "_3Keih",
	"about-map-stats": "_2MutF",
	"infoPopup": "Ao7v8",
	"infoContainer": "XjKHd",
	"info-content": "_14X1X",
	"service-detail": "_1Gd_L",
	"service-detail-container": "_2yLrr",
	"service-detail-content-container": "_3HE75",
	"item-fit": "_3oau8",
	"item-fit-container": "lABY4",
	"item-fit-content-container": "qIrle",
	"summary-goods-images": "_1Lwc-",
	"summary-goods-image": "_22NuY",
	"add-image-items": "_2jed3",
	"order-add-image-items": "_2XHv1",
	"driverRate": "_38_3g",
	"driverRateContent": "lHXtK",
	"driverRateStar": "_20uOO",
	"showOrderProgress": "_1wki5",
	"orderCancel": "_11M3G",
	"orderCancelContainer": "_1XsRi",
	"orderCancelContent": "Btnkp",
	"order-cancelled": "_3xh-V",
	"order-cancelled-container": "_2OmcH",
	"order-cancelled-content": "_2kaTV",
	"order-released": "wMNXO",
	"order-released-container": "_5XuBu",
	"order-released-content": "_1Ml1n",
	"sectionDashboard": "_1TWTo",
	"dashboradOrderDetail": "_1gkzN",
	"ngdialog": "_1zQ7v",
	"ngdialog-sms": "_386WH",
	"step-two": "_2sfRO",
	"step-two-progress": "_3bWfi",
	"headerMenuLeft": "_2ppU5",
	"headerMenuRight": "AJMcR",
	"button": "_3rDZu",
	"buttonFull": "_1S8UQ",
	"primary": "_3RfxN",
	"secondary": "_1MotY",
	"outlined": "_2H8fJ",
	"twin-button": "_1wWOW",
	"small": "_1eJAQ",
	"text-yellow": "MmuP2",
	"text-blue": "L1z0u",
	"input": "_1PPDJ",
	"input-alert": "_2ZAFP",
	"tooltips": "_1l3tL",
	"tooltips-body": "_1rXs9",
	"tooltips-content": "_3HmWH",
	"right": "_3PLKh",
	"left": "OpJqh",
	"active": "_3b4Sw",
	"aside": "mDTqv",
	"aside-title": "g-dV2",
	"aside-items": "_2QhBc",
	"aside-item": "_1tDmc",
	"lists": "_3VRFb",
	"list": "_1r78A",
	"list-headline": "CH8cL",
	"list-desc": "XrZf9",
	"icon-stack": "_60kJh",
	"white": "NvNQ6",
	"black": "_2sUJv",
	"icon-plus": "_2ahKA",
	"iconDots": "_3hZvW",
	"dotBlue": "_3dUjB",
	"dotGreen": "_4CcHU",
	"dotRed": "_3dQ2s",
	"table": "_3xcgV",
	"ggv-table": "_3seDF",
	"center": "_2dXRD",
	"table-headline": "QIjzT",
	"parallax-window": "_3jGkb",
	"dialogOverlay": "nIJE1",
	"nav": "_2io21",
	"open": "_1I1QC",
	"dialogOverlayContain": "_218j1",
	"dialogOverlayClose": "_3_NBr",
	"navMenu": "_2Vjpl",
	"navGroup": "_3hamY",
	"navItem": "_3u_ab",
	"slider-dots": "_1mNzl",
	"slider-dot": "_25Lhx",
	"dark": "_3JrPv",
	"slider-arrows": "_3g2an",
	"slider-arrows-left": "wDwHS",
	"slider-arrows-right": "TTswc",
	"slider-option-item": "_1U_U1",
	"span-50": "_2K78B",
	"span-33": "_3-AAL",
	"span-25": "e6VLZ",
	"span-20": "_6lTyE",
	"slider-option-item-trigger": "_1tq2d",
	"dropdown": "_1sc2k",
	"dropdown-cover": "aqzh5",
	"dropdown-list": "_35Fnc",
	"dropdown-list-item": "_2Dvi6",
	"dropdown-list-item-trigger": "_1KWp9",
	"dropdown-body": "_2CW5w",
	"dropdown-lists": "_1H1dK",
	"xdsoft_datetimepicker": "jGoAn",
	"xdsoft_noselect": "_12366",
	"xdsoft_inline": "_7ROQa",
	"xdsoft_datepicker": "_3LKHR",
	"xdsoft_timepicker": "_2XeMU",
	"xdsoft_showweeks": "IGbUh",
	"xdsoft_mounthpicker": "I2tIA",
	"xdsoft_label": "mDgNv",
	"xdsoft_prev": "_1x9b6",
	"xdsoft_next": "_3dxxn",
	"xdsoft_today_button": "_1l0Mx",
	"xdsoft_time_box": "_2aHdp",
	"xdsoft_select": "S2Zz6",
	"xdsoft_monthselect": "_1LhSp",
	"xdsoft_yearselect": "_2TT0n",
	"xdsoft_option": "_12gx2",
	"xdsoft_current": "_1oZGu",
	"xdsoft_month": "_3i15b",
	"xdsoft_calendar": "_2hU6N",
	"xdsoft_year": "_3dBzb",
	"xdsoft_today": "_2DTLR",
	"xdsoft_default": "_1oyRE",
	"xdsoft_other_month": "_3NiGk",
	"xdsoft_disabled": "_3qOXB",
	"xdsoft_copyright": "_3eXY_",
	"xdsoft_scrollbar": "_35pPT",
	"xdsoft_scroller": "_1BxLV",
	"xdsoft_scroller_box": "_28-AY",
	"xdsoft_dark": "_3x5hT",
	"starGroup": "_1lbmd",
	"toggle": "_2Kjii",
	"star-group": "_3u6mR",
	"buttonControl": "_1Es7Q",
	"buttonControlBlue": "_21K8-",
	"buttonControlGreen": "_3VKxx",
	"buttonControlRed": "_3DOkU",
	"address": "_2TEdR",
	"container": "ZdsF7",
	"pricing-hero": "_27EhB",
	"pricing-hero-icon": "mT3jc",
	"pricing-hero-button-div": "_1bbCM",
	"pricing-content": "_1u6oN",
	"special": "_2tw_N",
	"show-mobile": "_2UvPP",
	"ggv-table-nested": "_1kzDm",
	"list-numbered": "_2qhfp",
	"list-dotted": "_1yuwc",
	"pricing-content-menu": "_1sc9s",
	"pricing-content-headline": "_2-qYX",
	"pricing-content-detail": "_1kTze",
	"pricing-content-detail-additionals": "_2nMaW",
	"pricingDownload": "RdJxU",
	"borderTop": "bI7pj",
	"pricingDownloadIcon": "_2syPd",
	"section-about": "_1r9_5",
	"transparent": "_1NiHL",
	"absolute": "_2cxpJ",
	"dialogErrorMessage": "_1esll",
	"formGroup": "_3ksoC",
	"inputIconLeft": "_3o1W6",
	"inputIcon": "_3vfIx",
	"inputIcon24": "_3pb9I",
	"quotingHero": "_1FTCK",
	"mapCanvas": "_1Yit_",
	"quotingHeroForm": "_2HefH",
	"form": "fCIYr",
	"inputClear": "_28zLC",
	"quotingHeroFormInput": "_1f4Rw",
	"first": "_1TbJI",
	"last": "_2y8KP",
	"error": "_3Xa1c",
	"quoting-hero-form-input": "_2atma",
	"quotingHeroFormButton": "_1FzLI",
	"getGuoteText": "_2eBOE",
	"getQuote": "_1t3XB",
	"clearRouteText": "_2M3HP",
	"getQuoteText": "_3Hpxn",
	"quotingService": "_2uCng",
	"quotingOption": "_1ZD6b",
	"quotingOptionItem": "_146f6",
	"quotingOptionItemContext": "_2vMk_",
	"quotingOptionItemButton": "_36-Be",
	"quotingServiceIcon": "_1EQDm",
	"quotingServiceIconWhite": "g5v9M",
	"quotingServiceIconBlue": "_283qC",
	"quotingOptionItemButtonSelected": "_1U8eZ",
	"quotingOptionItemTitle": "uOEIZ",
	"quotingOptionItemContent": "_242w8",
	"quotingOptionItemPrice": "_27cuJ",
	"quotingW": "_1XNLe",
	"quotingN": "_2mhin",
	"quoting-option-confirm": "_3nwGW",
	"loginContainer": "_1QLAD",
	"loginForm": "lQsGN",
	"pdpa": "_2JeFL",
	"orLine": "_25PWf",
	"track-container": "_2sfDo",
	"track-form": "_16t1Z",
	"pdpa-container": "_3O-Rc",
	"pdpa-form": "_1rxXL",
	"business-hero": "_22J50",
	"business-content": "_3NkcO",
	"advatanges": "_2Z6-Q",
	"business-content-menu": "_3Vnc2",
	"business-content-item": "_3J8_A",
	"business-content-item-background": "gIM7Z",
	"business-content-delivery": "_17bhS",
	"vehicle-description": "_36au2",
	"section-hero-theme-3": "_3qMxW",
	"hero-desc-container": "zECOk",
	"quoting-hero-container": "zKju_",
	"section-hero-content": "_2OtEe",
	"quoting": "Jqkjw",
	"quoting-hero-form": "_2OfJz",
	"hero-phone-container": "tsov8",
	"dialog-overlay-close": "_1CDHc",
	"ot-price-table": "F1GZI",
	"hourly-price-table": "Xzwqa",
	"headline-vehicle-type": "_1jThf",
	"service-vehicle-type": "_1bb5l",
	"hourly-price-headline": "EnnC9",
	"hourly-price-desc-headline": "_1R9Td",
	"hourly-price-close-button": "_1X9gQ",
	"contact-hero": "_2GfRi",
	"contact-content": "_3QB01",
	"contact-content-info": "_3751L",
	"contact-content-info-title": "_2hPCm",
	"contact-content-info-content": "_27Jfd",
	"contact-content-info-details": "D9XIN",
	"contact-content-info-business-title": "_2Ra-l",
	"contact-content-form": "_68Fnu",
	"show-after-submit": "d29dH",
	"about-investment-link": "_2GqDO",
	"about-help-link": "_2-Vh2",
	"about-gogovan": "_2i8fX",
	"about-gogovan-headline": "_2Kh2v",
	"about-help": "_3KUIw",
	"about-help-headline": "_1o8n6",
	"about-investment": "_2iGa0",
	"about-investment-headline": "_22Joy",
	"about-hero": "_2eBQb",
	"about-gogovan-desc": "_2iB-y",
	"about-map-headline": "_2Heaf",
	"about-map-stat": "_2B-Rb",
	"about-map-stat-num": "_15Si0",
	"about-map-stat-name": "VXYAK",
	"about-help-desc": "_1gEeL",
	"about-hire": "_31vm2",
	"about-hire-headline": "EcXB-",
	"about-hire-join-us": "_1kDLQ",
	"about-investment-desc": "_3vc2d",
	"about-business-cooperation": "_2xoGR",
	"about-business-cooperation-items": "_1YDAv",
	"about-business-cooperation-item": "NSUQt",
	"section-feature-icon": "_1zdNP",
	"about-business-cooperation-headline": "_3MFv5",
	"legal-hero": "_3Q4aW",
	"legal-content": "Vn63I",
	"legal-content-headline": "_3sbvY",
	"list-with-tab": "iNheQ",
	"service-hero": "_1pe1D",
	"service-content": "vMg3P",
	"service-content-headline": "_17X15",
	"service-content-comic-grid": "_2U-6U",
	"service-content-photos": "QIsRI",
	"service-content-photos-grid": "_1p6TH",
	"service-content-photos-grid-overlay-background": "_18735",
	"service-content-photos-grid-overlay": "_2Slqz",
	"tint": "_1E2le",
	"service-content-section-headline": "VJHSb",
	"service-content-hourly": "_3zJh3",
	"service-content-fleet": "_11Llk",
	"service-content-additional": "TGBhW",
	"service-content-hourly-icon": "_3Fe9f",
	"service-content-fleet-icon": "_1Wt-q",
	"service-content-additional-icon": "_229Cf",
	"service-content-hourly-desc": "IiM8M",
	"service-content-fleet-desc": "_3Be5L",
	"service-content-additional-desc": "_2L6Px",
	"service-content-hourly-desc-header": "_1MFOl",
	"service-content-additional-desc-header": "_1_t-n",
	"service-content-detail-sg": "_3pveH",
	"service-content-detail-icon": "_22EK6",
	"service-content-detail-desc": "_2fMr_",
	"service-content-detail-button": "_33Mai",
	"service-content-fleet-desc-header": "_25wMv",
	"service-content-phtoso-grid-overlay": "_2oDed",
	"noselect": "_5ZbER",
	"disabled": "_2jlB3",
	"fixedContainer": "_1W6ld",
	"backgroundWhite": "_3BJvv",
	"orderBonus": "_1u6J0",
	"orderPage": "_37sX1",
	"image-upload": "g5l-M",
	"add-image-button": "_1KCds",
	"function-icon": "yLIZg",
	"fixed-container": "_1qUtG",
	"section-headline": "_3WoPP",
	"headline": "_3cCsr",
	"ngdialog-theme-default": "_1bkYo",
	"ngdialog-no-bg": "_1CXyI",
	"ngdialog-content": "_2camJ",
	"picker": "_2_oWL",
	"picker__button--clear": "Hm2tb",
	"icon": "mUp1L",
	"background-dark": "_3sJzq",
	"select-dropdown": "J2hUy",
	"input-clear": "_3AbwP",
	"section-hourly": "_3_0Xz",
	"desc": "_2cFBo",
	"desc-minimum": "GwQrN",
	"section-hourly-selection": "_3g_0b",
	"hour-detail": "_30n-g",
	"order-small-title": "_132cm",
	"section-coupon-input": "_2OOFq",
	"coupon-input": "_3sGbs",
	"ui-button": "byV1i",
	"hourly-detail-dialog": "HcfKz",
	"icon-plus-blue": "_22a9P",
	"order-function-text": "_2-6pC",
	"order-function-icon": "_3ltDJ",
	"orderSmallTitle": "mYUvl",
	"orderPricingRow": "_2wCEe",
	"orderPricingBonus": "_3l3Pr",
	"orderPricingCoupon": "_7qJOK",
	"orderPricingBonusPrice": "_3cqQc",
	"orderPricingCouponPrice": "_3mpDC",
	"orderPricingTotal": "_3bkYF",
	"orderPricingTotalPrice": "_3q8Kf",
	"orderPromoCode": "_2s6IY",
	"orderPromoCodeWarning": "ij0TS",
	"orderPromoCodeConfirm": "_1mf5x",
	"orderForm": "_3utK6",
	"orderAdditionalService": "_12H4d",
	"section-order-options": "dnQW5",
	"section-contact": "_3mdnf",
	"order-sender-recipient": "_1YzL_",
	"feature-disabled": "_3OKTV",
	"order-vehicle-grid": "_3bJl2",
	"order-delivery-item-option": "_3QXL5",
	"order-location-cell-view-map": "_1Ed0C",
	"info-headline": "_1xxxB",
	"restricted-info": "_2Zov_",
	"reminder": "_3zs6Z",
	"blue": "_3RB8R",
	"info-close-button": "_28qyD",
	"service-detail-headline": "_18QxU",
	"service-detail-desc-headline": "_3vanm",
	"service-detail-close-button": "_1rDDr",
	"item-fit-headline": "V9fXg",
	"static-map": "fJHca",
	"static-map-container": "_2gzBZ",
	"order-form-summary": "_1F0MN",
	"order-summary": "IRd_G",
	"summary-location": "yabym",
	"order-summary-icon": "_2Da3K",
	"summary-breakdown": "_13tGj",
	"order-remark": "_1Xd5d",
	"show-order-cancel-order": "_1TiJI",
	"red": "_po4e",
	"order-add-image-item": "jROZJ",
	"order-add-image-cancel": "AJ8fj",
	"mod-icon": "_35LlM",
	"picker--opened": "_3Ieq3",
	"picker__frame": "_2oCU2",
	"picker__box": "_1b5vx",
	"input-icon": "ASGAs",
	"routeInputFormGroup": "_1kKj1",
	"order-submit-form": "_2EybY",
	"bottom-reminder": "_1EBUY",
	"section-404": "_3zR94",
	"section-404-desc": "eobbf",
	"section-404-desc-title": "_3UJNW",
	"section-404-desc-body": "_3l--v",
	"section-404-desc-sub": "_2kkxF",
	"btn-back-to-home": "_2FDDs",
	"section-gogovan": "RsP0H",
	"section-redirect-links": "_2mj47",
	"redirect-link": "_2fE1W",
	"faq-hero": "x4oQq",
	"faq-content": "_3R0g-",
	"faq-content-headline": "_1umwt",
	"faq-content-desc": "ZjmqP",
	"icon-email": "pHKvt",
	"icon-sendto": "RLABw",
	"faq-content-question": "ykM2L",
	"faq-content-answer": "-GXcZ",
	"faq-other-questions": "_2uZNB",
	"question": "_2JV0n",
	"faq-contnet-desc": "_2MreE",
	"answer": "_3ZmKf",
	"faq-content-menu": "_1dImH",
	"showOrderMap": "_31Hea",
	"ollehmapCornerContainer": "qgHS8",
	"showOrderInfo": "_2eOoj",
	"showOrderHiddenItem": "_2FFT2",
	"operationButtons": "_2apV8",
	"showOrderFunction": "_2oZsN",
	"showStatus": "_26gkz",
	"showOrderAssigningDriver": "_2FYoy",
	"graphsRotate": "_3BrF-",
	"subtext": "_2nB13",
	"showOrderDriverInfo": "_29Dnm",
	"showOrderLocationAddress": "_39HV9",
	"showOrderBreakdown": "mcD3q",
	"showOrderIcon": "_1d8UR",
	"showOrderRoute": "_1LQoz",
	"driverIcon": "_2BG14",
	"driver-info": "_1JYtN",
	"driver-info-container": "_32DUx",
	"driver-info-background": "_1uy56",
	"order-info": "Ro7ve",
	"driver-info-detail": "_1pbKI",
	"driver-info-dialog-body": "_2cOrO",
	"driver-info-dialog-okay-button": "_7qdaN",
	"driver-info-dialog-review-order-button": "_65koF",
	"driverRateContainer": "_1G40n",
	"driverRateHeadline": "_4cLqW",
	"starActive": "n2T0F",
	"starInactive": "IHHed",
	"rateReasonList": "_1YKa_",
	"driverRateSkip": "_2geVD",
	"reportOrderIssue": "_1IyNo",
	"reportOrderIssueContainer": "_8CBG1",
	"reportOrderIssueHeadline": "_3Knrq",
	"reportOrderIssueContent": "_1qFsQ",
	"showOrderProgressBar": "_3gMYW",
	"inProgress": "_7Mq2g",
	"data": "U6xL2",
	"completed": "_3SHHr",
	"cancelled": "Kz54i",
	"completed-alert": "_1aoWb",
	"order-cancel": "_12899",
	"order-cancel-no": "_3zzB2",
	"driver-block": "_2cDcK",
	"order-release": "_3YZKd",
	"orbit": "n36uq",
	"orderCancelHeadline": "_29QOQ",
	"infoCloseButton": "_2YEOb",
	"orderCancelButton": "_3vB9-",
	"order-cancelled-headline": "_3licn",
	"order-cancelled-close-button": "_1elNQ",
	"order-released-headline": "_1wA7j",
	"dashboard": "_5FYG4",
	"sectionDashboardHeader": "_1qQ29",
	"sectionDashboardHeaderTW": "_3dK92",
	"sectionDashboardHeadline": "_1HDHb",
	"sectionDashboardBanner": "_3A7_2",
	"sectionDashboardBannerContent": "_2OOXg",
	"sectionDashboardBannerIN": "_3bNn4",
	"sectionDashboardTable": "_2U9s0",
	"sectionDashboardControls": "-LSPU",
	"grid6": "AsVCb",
	"sectionDashboardOrder": "FvuHK",
	"sectionDashboardOrderStatus": "_3oHgT",
	"sectionDashboardOrderDate": "_22arr",
	"dashboardOrderDetailStatus": "_2PyYK",
	"dashboardOrderDetailLocation": "_3mMF4",
	"dashboardOrderDetailPrice": "_1LSj4",
	"dashboardOrderDetailDriver": "k9_AQ",
	"dashboardOrderDetailLicense": "Y1Xbb",
	"dashboardOrderDetailFunction": "_1taS2",
	"dashboardOrderDetailImage": "_1xHqb",
	"dashboardOrderDetailStatus1": "_2DRWh",
	"dashboardOrderDetailStatus2": "_1_jBF",
	"dashboardOrderDetailStatusBar": "_1H3cs",
	"dashboardOrderDetailStatus3": "_3zldW",
	"section-reset-password": "_2NwyD",
	"form-group": "_1Nyfl",
	"section-reset-password-respond": "_2wdIg",
	"section-reset-password-reset": "_1rswt",
	"profile": "-ZuDw",
	"section-profile": "_3z6wN",
	"border-bottom": "_1oArF",
	"section-profile-photo": "QzzAF",
	"profile-photo": "_3RrB4",
	"section-profile-info": "_2Dq8t",
	"change-password": "T4Jkb",
	"section-profile-address": "_1Xvvs",
	"address-empty": "ZYvEl",
	"route-input-form-group": "_3N7rs",
	"address-type-image-div": "_3tV3Z",
	"image-empty": "_2esNT",
	"address-type": "_2S3sZ",
	"mod-open": "_1sk-6",
	"profile-icon": "_42uj6",
	"section-profile-pdpa": "_2nF7I",
	"ngdialog-password": "qDzZ6",
	"ngdialog-address": "_2hLM6",
	"profile-password-error": "Sy11b",
	"step-one": "_3H9aN",
	"sms-confirm-field": "_1WO9m",
	"done": "_2Fdfz",
	"doing": "_3Do1m",
	"sms-status": "kMSeD",
	"quartar": "_3cHA3",
	"half": "_1lycB",
	"button-two-line": "_22S6x",
	"sms-error": "_3BNo3",
	"business-services-registration-hero": "_1TY8_",
	"business-services-registration-content": "_1Yln6",
	"business-services-registration-content-info": "UiJRG",
	"business-services-registration-content-info-title": "_1hiGV",
	"business-services-registration-content-info-content": "_2474X",
	"business-services-registration-content-info-details": "GRDTp",
	"business-services-registration-content-form": "_1kP80",
	"radio-item": "_3TQd7",
	"checkbox-item": "_1dOZk",
	"section-hero": "-Kvaq",
	"campaign-base": "eQqDs",
	"quoting-hero-form-button": "_1KLue",
	"campaign-gogobusiness": "_3xKxN",
	"section-hero-container": "_2b3cR",
	"section-hero-imac": "_3p6_y",
	"index-hero-logo": "_3VZtN",
	"ngdialog-close": "_2Fm8Y",
	"border-top": "_zhea",
	"extra-small": "_3-WO4",
	"no-margin": "_2bDBi",
	"globalFontLight": "_3TtA5",
	"globalFontNormal": "Dd1pC",
	"globalFontBold": "cEmAd",
	"globalTextYellow": "t1VbU",
	"globalTextBlue": "_1Yhod",
	"globalTextRed": "_1DFdj",
	"sticky": "_1Gas-",
	"stuck": "pR2tb",
	"infoNoRadiusAndResize": "QB_qr",
	"infoCloseRightButton": "CYPW6",
	"headerLogo": "_8jILl",
	"resetFontsize": "_2i8L_",
	"headerMenuLeftItem": "o2vx1",
	"headerMenuLeftBar": "_2T3_D",
	"iconStack": "_3geOS",
	"headerMenuRightItem": "_1Sp85",
	"twinButton": "_2jKU1",
	"headerMenuButton": "GFGd5",
	"leftRadius": "SnmEN",
	"rightRadius": "_1yEpp",
	"order": "_3k_0-",
	"headerMenuUser": "OY5GE",
	"nameLong": "_3bWfR",
	"nameShort": "_2O6he",
	"section-hero-video": "wY3pw",
	"section-hero-headline": "_1H9h2",
	"section-hero-navbar-theme-1": "_3LcIB",
	"header-menu-left": "NRFON",
	"header-menu-right": "_1jWQk",
	"section-hero-navbar-theme-2": "_1Giov",
	"section-hero-theme-1": "h2dVE",
	"section-hero-phone": "_1mNbz",
	"section-hero-theme-2": "R4up1",
	"arrow-left-icon": "zH59r",
	"section-about-body": "_1herx",
	"sectionAboutDownload": "_3cnlI",
	"section-about-coming-soon": "_2wIYV",
	"section-map": "_15hCe",
	"section-service": "_3SFmo",
	"section-service-body": "_2tau2",
	"section-service-icon": "E5nK4",
	"section-service-border": "R2n1V",
	"services": "AzeNc",
	"section-feature": "_3ltbW",
	"section-feature-items": "_2Oh5F",
	"section-feature-item": "_2jdPn",
	"section-feature-desc": "DVzGW",
	"section-feature-plus": "_2HdKi",
	"section-feature-overlay": "kFtTa",
	"section-feature-overlay-container": "_3ijdR",
	"section-feature-dot": "_3vcNQ",
	"section-feature-overlay-content": "_1qbBd",
	"section-feature-overlay-content-img": "_38TMS",
	"section-feature-overlay-content-desc": "_1sFgu",
	"section-feature-headline": "_24ITT",
	"section-feature-content": "_2u8W1",
	"section-feature-close": "_2mTqO",
	"section-howitwork": "_3Gtxx",
	"section-howitwork-content": "_1UZ2y",
	"section-howitwork-content-img": "_1es2l",
	"section-howitwork-content-img-bottom": "_1LIHx",
	"section-howitwork-content-img-middle": "_1Y7Ka",
	"section-howitwork-desc": "_2o6B4",
	"section-howitwork-desc-video": "_1I7an",
	"section-howitwork-desc-buttons": "_3Wt7w",
	"section-howitwork-control": "-Gsfk",
	"section-howitwork-control-icon": "_24ngD",
	"section-howitwork-control-title": "_3HvUg",
	"section-howitwork-control-desc": "_1l4Pm",
	"section-contact-background": "_3BCWw",
	"section-contact-form": "mC2-h",
	"business-contact": "_14R3_",
	"section-newsletter-subscriptions": "_6K4Jd",
	"section-newsletter-subscriptions-background": "_169Kc",
	"section-newsletter-subscriptions-form": "_2Oiad",
	"section-newsletter-subscriptions-receive-news": "_1bjPS",
	"section-newsletter-subscriptions-receive-news-desc": "_nPCD",
	"section-media": "TiqAf",
	"section-media-item": "T3EE1",
	"footerFunction": "_1pBHM",
	"footerNav": "bCttm",
	"footerContent": "_23tsA",
	"footerTel": "_3xUeT",
	"footerDownload": "_1OCOQ",
	"footerDownloadButtons": "_34oFX",
	"footerDownloadButtonsWithHover": "_3lbPI",
	"footerLinks": "gP_1u",
	"dropdownList": "_1C33D",
	"footerLists": "_1Zf0i",
	"footerList": "_1bSfM",
	"footerTitle": "_3kND8",
	"section-join-gogovan-team": "_3M6c6",
	"section-join-gogovan-team-desc": "_1MrQ4",
	"section-join-gogovan-team-btn": "_3jqTo",
	"blue-underline": "_3DY3x",
	"fixed": "_3mUoB",
	"restricted-popup": "_39juq",
	"errorWrongPopupContainer": "_1eAtq",
	"error-wrong-popup": "_2v8lt",
	"error-popup": "_1mQos",
	"service-not-available-popup": "_2LFnb",
	"error-popup-container": "_2D_x1",
	"errorRestricted": "_2IV17",
	"reminderPermit": "_3o3fv",
	"errorNoService": "_1ZfZi",
	"reminderNoService": "_2L6Uk",
	"restrictedPopup": "_11-QW",
	"centered": "_3vl9D",
	"order-value-pickup-time-date_root": "_1nQw9",
	"picker__wrap": "_38PI-",
	"static-map-dialog": "_1uQEH",
	"info-bonus-dialog": "_3wAbS",
	"service-detail-dialog": "_3OVyf",
	"item-fit-dialog": "_3p6Sy",
	"rate-driver-dialog": "_2yniJ",
	"report-order-issue-dialog": "_1IjRd",
	"blacklist-dialog": "_3280R",
	"driver-info-dialog": "dUmLp",
	"order-released-dialog": "_32QA7",
	"order-cancelled-dialog": "_3kmhK",
	"share-order-dialog": "_1QP_H",
	"order-extra-message-dialog": "_1O6iE",
	"service-not-available-dialog": "_3wP29",
	"order-cancel-dialog": "_17G5p",
	"info-popup-header": "_18xTg",
	"index-hero-form": "Ew0Lx",
	"col3": "NhaPQ",
	"hideMobile": "_2CMtn",
	"showMobile": "_3V_Cy",
	"dropdownListStyle": "_1yPGZ",
	"cursorPointer": "_2ps_I",
	"orderSelectHover": "_3tbrB"
};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "259b0d05.jpg";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa81e17e.jpg";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "228b0f5e.png";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6796c98c.png";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab216425.png";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c20c158b.png";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a52091c.jpg";

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "41b57149.jpg";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAu0lEQVR4AZ2OMQrCQBREP4ogCHqYXCBFWHZ/a2urdWqtUtjYpE5ta2tpIzmAtxFE0Rn4NkGXbAaGLDNvPhFVvcEHGShueUNCCBUeb3z3kihubFt9g9qCbcKRnW3qbtFYUfY4Uhrb/OpHKI8GrCNHNmTIcvOPGwM8AXp571fdkhk7MmQlpizLJgDPGDzhpZj4ZsaOjPRRnudTDC7wA3+hNN/M2EmKnHMzDFv4bm6ZyRBhPFfVK10UxSLGfgB+eFcD197eMgAAAABJRU5ErkJggg=="

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABlVBMVEUAAAAAiL0AiL8Ah78Ah74Ah70AiLsAh74AiL4AgKoAiL8Ah74AhbkAhr8blMWm1ejp9Pnk8vil1egelsYvncrr9fn///8glsfm8/gUkcTY7PUKjMHI5fEEicC03Oyd0ebx+PuExeD5/P1Cps9qudn+/v5YsdVSrtP9/v5wvNs9pM73+/yKyOEsnMrv9/qj1OcBiL9Lq9GPyuIdlca53u0FisADib+v2eqs2OoJjMERj8PV6/TM5/IMjcJ6wN2y2+sIi8HE4/Dc7vYWksSb0OUjmMfw+PuCxN+YzuXz+fszn8vH5PBouNl+wt76/P1GqNBJqtH8/f5QrdNktthds9aMyeI8pM5Nq9J1vtzu9/oqm8k5os32+vyQy+O73+3i8fdEp9Dt9vqo1ukNjsLO6PK94O4GisAXksTd7/bQ6fMOjsIlmcjq9fnf8PYZk8U1oMz0+fzs9vonmsj7/f31+vw3ocxftNZ4wN1itdeSzON7wd0CiL+q1+mVzeQHi8C/4e6t2OoPj8LR6fPC4u8alMW13OwQj8Mcb4sgAAAADnRSTlMAfP/z1ZAt/ZYGvpUsg7djC/UAAAIuSURBVHgBvM3FAcMAEASxMTMz9N9m+Bv2rRoQV45rw/ODEDA9rqI4sT6u0sT6uMoEhxvlFK65AMHiI1g8FAuKBcWCYkGxoFhQLCgWFAuKhYOXsqqbtnuV/L/0w3gxlC+Sv5dpHm+qF8m/y7KOd/WL5M9l28eH5sz6XCg1DERRGJ45L4Aziru7W3GHFnd3h+LF7bVxDu1NkE3ujmXt/7K/IO6UuPgvIzZSIHpKAo3EKIloKUk0klMgESUllUZaOiSipGRkEsmCBdFRsnNo5MKKqCh5+TQKCm0QU6Uot7hIrpVE0Cgtgwliq5RXvJUqq0IWq2to1NbBDLFT6j9aDeVBa55GGk3NMEVslK9/bgl+HI3wVpgjVqXtq9fOpQ4anV0wROyVbhZ7Pld6udLXD2eIVLxM+gbeFwa5kDYEp4hUhhnNGQEw6uN8DI4RqRRGsjo+gckpzqbhApFK2Qy7s3Pz/F4odIVIZXEp1jqWV+AOkcrqmsVY34BbRCqbW8LY3oECIpTdvRBj/wAaiFS8/iDj8Ag6iFSOvw1/EbQQqZwQOYUiIpSzT+McmohQAhfvxiV0EaFcXb8aNwFtRCi3d7H3HqgjQnl4fII+QsVwvPQ2BwIAwEAUhTqA7687ir0EUiyKRbEoFsWiWBSLYlEsikWxKBbFolgUi2JRLIpFsSgWxaJYFItiUSyKRbEoFsWiWBSLYlEsikWxKBbFolgUi2JRLIpFsJyfS3Cw4GDBwQ4ezwRx3B6sQ1EAAAAASUVORK5CYII="

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAgMAAAANjH3HAAAADFBMVEUAAADHx8fJycnKysqfrdWaAAAAA3RSTlMAQIDntwj7AAAAVElEQVRIx2P4/4EBO2I4wIAdMOOUYcAjM9CAGY/MgQGWGQ230XCjtYwIznDTwOnSgZBhxiNzgN4y/P9B4MNouJEuIzKaT0fLt9FwG2rhxv+fASsCAG3JSU1ZVIZ5AAAAAElFTkSuQmCC"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEUAAADKyspz+74zAAAAAXRSTlMAQObYZgAAAGRJREFUWMPt1rENwDAIBdEvMYDb7D8JI3kDovTQJKQxh+iufRIotvJVXVz52Iui5jJlrLn4kII3vOENbzO8XZ+LhhRrLn5qWfHMTuzUBW94ayrcU+4p/xve8IY3vP3sbYXSrcsNNdGPuYO9ORsAAAAASUVORK5CYII="

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "24e445e8.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a7a2dc7.jpg";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "841c0257.jpg";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13e8abbf.jpg";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e145d4f0.jpg";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94a8ac2f.jpg";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAsCAYAAADctB6FAAACfElEQVR4AezZhYpbYRDF8ZWrq3F3d/c8eR2tv0m9uFTOhQGGuveQ+w38V6M/opMjM2bMmDFjxoyZkM6x6kQlfwvPaIRTZH3SaZhgNISNHOQiT3Llb7aGCQuGh87QBbqULuRvnsBYCuUgMSzkIF+u/DWKorgUQxHB8T9FOWSMS4FIogzKSVmUEpgrubW4GuXQMM7kisZQGhVQGVWlivwtg+Lomh/l9zHicoVLqDZrO6NJ057g5w5qobogZVGCH+X3MbKC0Rg37OnrO4NHQf2qvcLfhqiLmoKS+30Ufowyaowa9iyAeP9o8iHoxa3Bk07Z2uF/Y9SXW0vl91H4MZqfYmiUdsna4zCTv4jCj6F7fnPwlACFAIMAhQCDAIUBgwCFB4MAhQeDAIUHgwCFB4MAhQeDBYUCgw2FAIMPhQCDD4UAgw+FAIMPhRSDH+UYnSJbLYRjKKM3XSwYX9mnjFFPbd6yKI6u1Db/VFB++NbhonMUQSlUQNVpyx4zYnyyedvKOrKD6qiI0iiKLpCHbEE5/pFbh4P8T/egi64zeHN3+JARQvfq9uCx7Gh7X9/P6s98vj6f3jqu5URy+5Hbfntv+IAZQhfcioO7toBUUB4l5Rb/cdzElCWMuALExZRD6etB3aMgi4YSBkWguTabFrTsk0IOEFi2ITpAYLVLqBOn9PfDeodBFgxFDIpIJ2N2ZVAZAp/8QqQQwgGCXIbkhvKI/jqqdxBk8FDGoAgNcuCUgaYOHhLmjRFVbn+BgMDvY3oHQAYOBwyKWFAEQwODnZRahmn/VFGeP8f194MMGk4YFMEzywX5SVp/8myzFNe/E/r7QAYMRwyKaFCEYwsMANFdnqH0aeoSAAAAAElFTkSuQmCC"

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 844 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(847);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(848);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(849);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(851);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(850);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;

      // If Popper isn't instantiated, hide the popperElement
      // to avoid flash of unstyled content

      if (!data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      var _data$offsets$popper = data.offsets.popper,
          top = _data$offsets$popper.top,
          left = _data$offsets$popper.left,
          position = _data$offsets$popper.position;


      return _extends({
        position: position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }

      if (lastProps.children !== this.props.children) {
        this._popper.scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });

      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }

      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // schedule an update to make sure everything gets positioned correctly
      // after being instantiated
      this._popper.scheduleUpdate();
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperRef = function popperRef(node) {
        _this2._node = node;
        if (node) {
          _this2._createPopper();
        } else {
          _this2._destroyPopper();
        }
        if (typeof innerRef === 'function') {
          innerRef(node);
        }
      };
      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var _popperProps;

        var popperProps = (_popperProps = {
          ref: popperRef,
          style: popperStyle
        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);

        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: function scheduleUpdate() {
            // _createPopper will scheduleUpdate,
            // so calling this before this._popper exists
            // can be a noop.
            _this2._popper && _this2._popper.scheduleUpdate();
          }
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = popperRef;
      } else {
        componentProps.innerRef = popperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._3nSiC .F6-GS ._2PFVy:after,.cSf14 .E2EKj:after{content:\"\";display:table;clear:both}._3HRy1{font-family:Helvetica,sans-serif;font-size:1.1em;line-height:1.5em}.cSf14{background-color:#fff;position:relative}.cSf14 .zqpwJ{position:absolute;top:-50px;right:0}.cSf14 ._10aZ0{background-color:#006a96;color:#fff}.cSf14 ._10aZ0 h2{margin:54px 40px 30px;display:inline-block}.cSf14 .E2EKj{color:#4a4a4a;padding:30px 60px 30px 40px}.cSf14 .E2EKj p{margin:0;line-height:24px}.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._1of4s:hover{background-color:transparent;border:none;color:#cacaca}.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{float:right;margin-top:60px;width:220px}@media (min-width:768px) and (max-width:1023px){.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{width:auto;padding-left:20px;padding-right:20px}}@media (max-width:767px){.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{width:100%;margin-top:20px}}._3WfFn{margin-left:758px}@media (min-width:768px) and (max-width:1023px){._3WfFn{margin-left:auto}}@media (max-width:767px){._3WfFn{margin-left:auto}}._3fqdU{margin-left:auto}@media (min-width:768px) and (max-width:1023px){._3fqdU{margin-left:auto}}@media (max-width:767px){._3fqdU{margin-left:auto}}._1qt6p{padding-bottom:20px}._3nSiC{margin-top:200px}._3nSiC .F6-GS{background-color:#fff;position:relative}._3nSiC .F6-GS ._37zdH{position:absolute;top:-50px;right:0}._3nSiC .F6-GS ._2VXDF{background-color:#006a96;color:#fff}._3nSiC .F6-GS ._2VXDF h2{margin:54px 40px 30px;display:inline-block}._3nSiC .F6-GS ._2PFVy{color:#4a4a4a;padding:30px 60px 60px 40px}._3nSiC .F6-GS ._2PFVy._2GAR7{text-align:center}._3nSiC .F6-GS ._2PFVy._2GAR7 ._3pDKK{font-size:12px;letter-spacing:1px}._3nSiC .F6-GS ._2PFVy._2GAR7 ._2rWBv{color:#0088bf}._3nSiC .F6-GS ._2PFVy p{margin:0;line-height:24px}._3nSiC .F6-GS ._2PFVy ._1of4s{float:right;width:220px;margin-top:60px}@media (max-width:767px){._3nSiC .F6-GS ._2PFVy ._1of4s{width:auto}}._2pLsB{margin-bottom:10px!important}.pDc_2{width:220px;margin-top:60px}#_3HSSR .SgjZv{position:relative;background-color:#fff}#_3HSSR .SgjZv .zqpwJ{position:absolute;top:-50px;right:-4px}#_3HSSR ._3H4ME{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px}#_3HSSR ._3H4ME h2{margin-top:61px;margin-bottom:34px;display:inline-block}#_3HSSR ._134hj{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){#_3HSSR ._134hj{padding-right:40px}}#_3HSSR ._134hj ._23vab{display:none}#_3HSSR ._134hj ._23vab label{display:block}#_3HSSR ._134hj ._2M9yb{padding-top:1em;padding-bottom:1em}#_3HSSR ._134hj ._3IhNO{background-color:transparent;border:none;color:#cacaca}._10abN{color:#fff;background-color:#ea5365;border-radius:0 0 4px 4px;padding-top:5px;padding-bottom:5px;vertical-align:top;top:-16px;margin:auto;float:none}._10abN p{margin:0}._2jqtO{color:#000;background-color:#f0f0f0!important;text-align:center;border-radius:4px;padding-top:0}._31xWd{position:relative;margin-bottom:10px!important}._31xWd ._21Wn7{padding-left:38px;padding-right:3em}._31xWd ._1_Bp5{margin-top:-30px;margin-left:10px;float:left}._3S1Bf{margin-left:458px}@media (min-width:768px) and (max-width:1023px){._3S1Bf{margin-left:auto}}@media (max-width:767px){._3S1Bf{margin-left:auto}}._2v9nl{font-size:10px;font-size:.625rem;color:#b1b1b1}.y-fie{font-size:12px;font-size:.75rem;font-weight:700;border-color:#e7e7e7}.y-fie ._3x99N{color:#b1b1b1}.RJiCf{background-color:#e7e7e7!important;cursor:not-allowed!important;font-size:12px;letter-spacing:1px}.RJiCf,.RJiCf:hover .RJiCf:focus{outline:0;border:transparent}._2Cj9l{font-size:30px;font-size:1.875rem;letter-spacing:1px;margin-top:32px;margin-top:2rem;margin-bottom:16px;margin-bottom:1rem}._2jfG-{font-size:13px}._36G22>a{color:#0074c2!important}._3dmJI{width:150px}", ""]);

// exports
exports.locals = {
	"orderCancelContainer": "cSf14",
	"orderCancelContent": "E2EKj",
	"infoPopup": "_3nSiC",
	"infoContainer": "F6-GS",
	"infoContent": "_2PFVy",
	"dialog": "_3HRy1",
	"dialogOverlayClose": "zqpwJ",
	"orderCancelHeadline": "_10aZ0",
	"infoCloseButton": "_1of4s",
	"orderCancelButton": "_163J3",
	"orderCancelcloseRightButton": "_3WfFn",
	"agreeCancelcloseRightButton": "_3fqdU",
	"infoContainerReportIssue": "_1qt6p",
	"dialog-overlay-close": "_37zdH",
	"infoHeadline": "_2VXDF",
	"restrictedInfo": "_2GAR7",
	"reminder": "_3pDKK",
	"blue": "_2rWBv",
	"shareOrderUrl": "_2pLsB",
	"shareOrderCloseButton": "pDc_2",
	"reportOrderIssue": "_3HSSR",
	"reportOrderIssueContainer": "SgjZv",
	"reportOrderIssueHeadline": "_3H4ME",
	"reportOrderIssueContent": "_134hj",
	"rateReasonList": "_23vab",
	"button": "_2M9yb",
	"driverRateSkip": "_3IhNO",
	"dialogErrorMessage": "_10abN",
	"smsContainer": "_2jqtO",
	"smsPhone": "_31xWd",
	"smsDialog": "_21Wn7",
	"smsImg": "_1_Bp5",
	"smallcloseRightButton": "_3S1Bf",
	"buttonTwoLine": "_2v9nl",
	"buttonDisableBG": "y-fie",
	"disableText": "_3x99N",
	"disabled": "RJiCf",
	"smsH2": "_2Cj9l",
	"pdpa": "_2jfG-",
	"agreeSpan": "_36G22",
	"agreeSumbitButton": "_3dmJI"
};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"zh_HK","mapCenter":{"lat":"22.278731","lng":"114.176109"},"geocomplete_country":"hk","PHONE_REGEX":"^\\d{8}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-HK":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"},"zh-HK":{"blank_field":"請填寫這個欄位。","incorrect_email":"請填寫正確電郵。","error_message_signup_email_used":"電郵 已登記","error_message_signup_phone_taken":"電話號碼 已登記"}}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"en_IN","mapCenter":{"lat":"13.0475226","lng":"80.0685804"},"geocomplete_country":"in","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-IN":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"ko_KR","mapCenter":{"lat":"37.5650172","lng":"126.8494663"},"geocomplete_country":"kr","PHONE_REGEX":"^\\d{9,11}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","ko-KR":{"blank_field":"해당 항목을 입력해주세요","incorrect_email":"해당 항목을 입력해주세요","error_message_signup_email_used":"이미 등록된 이메일입니다.","error_message_signup_phone_taken":"이미 등록된 번호입니다."}}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"en_US","mapCenter":{"lat":"1.352083","lng":"103.819836"},"geocomplete_country":"sg","PHONE_REGEX":"^([36]\\d{7}|[78][1-9]\\d{6}|[9][0-8]\\d{6})$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-SG":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"zh_TW","mapCenter":{"lat":"25.0172264","lng":"121.506378"},"geocomplete_country":"tw","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","zh-TW":{"blank_field":"請填寫這個欄位。","incorrect_email":"請填寫正確電郵。","error_message_signup_email_used":"電郵 已登記","error_message_signup_phone_taken":"電話號碼 已登記"}}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(30);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(54);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(439);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(148);

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(860);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(871);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/components/Layout/Layout.css
var Layout_Layout = __webpack_require__(873);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout_Layout);

// EXTERNAL MODULE: ./src/components/Layout/Layout.sass
var components_Layout_Layout = __webpack_require__(875);
var Layout_Layout_default = /*#__PURE__*/__webpack_require__.n(components_Layout_Layout);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__(441);
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./src/assets/styles/style.sass
var style = __webpack_require__(440);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/components/Header/Header.sass
var Header = __webpack_require__(588);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header);

// EXTERNAL MODULE: ./src/components/Header/OrderingHeaderStyle.sass
var OrderingHeaderStyle = __webpack_require__(878);
var OrderingHeaderStyle_default = /*#__PURE__*/__webpack_require__.n(OrderingHeaderStyle);

// EXTERNAL MODULE: ./src/service/util.js + 1 modules
var util = __webpack_require__(453);

// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.es.js
var reactstrap_es = __webpack_require__(443);

// EXTERNAL MODULE: ./src/components/Login/login.sass
var login = __webpack_require__(451);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/actions/user.js
var actions_user = __webpack_require__(444);

// CONCATENATED MODULE: ./src/components/Login/RegisterModuleRedirectText.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }









var RegisterModuleRedirectText_RegisterModuleRedirectText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RegisterModuleRedirectText, _React$Component);

  function RegisterModuleRedirectText(props) {
    var _this;

    _classCallCheck(this, RegisterModuleRedirectText);

    _this = _possibleConstructorReturn(this, (RegisterModuleRedirectText.__proto__ || Object.getPrototypeOf(RegisterModuleRedirectText)).call(this, props));
    _this.state = {
      normalText: props.normalText,
      btnText: props.btnText
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RegisterModuleRedirectText, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        className: "".concat(style_default.a.globalFontLight, " ").concat(login_default.a.redireactText)
      }, void 0, typeof this.props.currentLocale !== 'undefined' && this.props.currentLocale === 'ko-KR' ? _jsx("span", {}, void 0, this.state.normalText, _jsx("span", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(style_default.a.dialog, " ").concat(style_default.a.cursorPointer),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText)) : _jsx("span", {}, void 0, _jsx("span", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(style_default.a.dialog, " ").concat(style_default.a.cursorPointer),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText), this.state.normalText));
    }
  }]);

  return RegisterModuleRedirectText;
}(react_default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */],
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Login_RegisterModuleRedirectText = (Object(es["b" /* connect */])(mapState, mapDispatch)(withStyles_default()(style_default.a, login_default.a)(RegisterModuleRedirectText_RegisterModuleRedirectText)));
// EXTERNAL MODULE: ./src/login-form/login-form.component.js
var login_form_component = __webpack_require__(774);

// CONCATENATED MODULE: ./src/components/Login/LoginModule.js
function LoginModule__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LoginModule__typeof = function _typeof(obj) { return typeof obj; }; } else { LoginModule__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LoginModule__typeof(obj); }

var LoginModule_REACT_ELEMENT_TYPE;

function LoginModule__jsx(type, props, key, children) { if (!LoginModule_REACT_ELEMENT_TYPE) { LoginModule_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LoginModule_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LoginModule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginModule__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LoginModule__createClass(Constructor, protoProps, staticProps) { if (protoProps) LoginModule__defineProperties(Constructor.prototype, protoProps); if (staticProps) LoginModule__defineProperties(Constructor, staticProps); return Constructor; }

function LoginModule__possibleConstructorReturn(self, call) { if (call && (LoginModule__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LoginModule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function LoginModule__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */












var _ref = LoginModule__jsx("hr", {});

var LoginModule_LoginModule =
/*#__PURE__*/
function (_React$Component) {
  LoginModule__inherits(LoginModule, _React$Component);

  function LoginModule(props) {
    var _this;

    LoginModule__classCallCheck(this, LoginModule);

    _this = LoginModule__possibleConstructorReturn(this, (LoginModule.__proto__ || Object.getPrototypeOf(LoginModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(LoginModule__assertThisInitialized(_this));
    return _this;
  }

  LoginModule__createClass(LoginModule, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return LoginModule__jsx("span", {}, void 0, LoginModule__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.props.isShowLoginModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        style: {
          marginTop: '200px'
        },
        className: "".concat(login_default.a.resizeModal, " text-center"),
        contentClassName: login_default.a.resizeModalContent
      }, void 0, LoginModule__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: this.toggle,
        className: "".concat(login_default.a.infoCloseRightButton)
      }), LoginModule__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          backgroundColor: '#f7f7f7',
          borderRadius: '4px'
        }
      }, void 0, LoginModule__jsx(login_form_component["a" /* ConnectedLoginForm */], {
        onLogin: this.toggle
      }), LoginModule__jsx("div", {
        className: login_default.a.orLine
      }, void 0, _ref, LoginModule__jsx("span", {
        className: login_default.a.or
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_or, this.state.modelDataDefaultLocale.login_modal_or))), LoginModule__jsx("span", {
        className: "".concat(style_default.a.globalFontLight, " ").concat(login_default.a.registerIfNotYet)
      }, void 0, LoginModule__jsx(Login_RegisterModuleRedirectText, {
        lang: this.props.currentLocale,
        target: "#register",
        toggle: this.toggle,
        normalText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_normal_message, this.state.modelDataDefaultLocale.login_modal_normal_message),
        btnText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_redirect_to_register_btn, this.state.modelDataDefaultLocale.login_modal_redirect_to_register_btn)
      })))));
    }
  }]);

  return LoginModule;
}(react_default.a.Component);

var LoginModule_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal
  };
};

var LoginModule_mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Login_LoginModule = (Object(es["b" /* connect */])(LoginModule_mapState, LoginModule_mapDispatch)(withStyles_default()(style_default.a, login_default.a)(LoginModule_LoginModule)));
// EXTERNAL MODULE: ./node_modules/react-addons-update/index.js
var react_addons_update = __webpack_require__(107);
var react_addons_update_default = /*#__PURE__*/__webpack_require__.n(react_addons_update);

// EXTERNAL MODULE: ./src/components/Login/LoginModuleRedirectText.js
var LoginModuleRedirectText = __webpack_require__(757);

// EXTERNAL MODULE: ./src/signup-form/signup-form.component.js
var signup_form_component = __webpack_require__(775);

// CONCATENATED MODULE: ./src/components/Login/RegisterModule.js
function RegisterModule__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RegisterModule__typeof = function _typeof(obj) { return typeof obj; }; } else { RegisterModule__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RegisterModule__typeof(obj); }

var RegisterModule_REACT_ELEMENT_TYPE;

function RegisterModule__jsx(type, props, key, children) { if (!RegisterModule_REACT_ELEMENT_TYPE) { RegisterModule_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: RegisterModule_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function RegisterModule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegisterModule__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RegisterModule__createClass(Constructor, protoProps, staticProps) { if (protoProps) RegisterModule__defineProperties(Constructor.prototype, protoProps); if (staticProps) RegisterModule__defineProperties(Constructor, staticProps); return Constructor; }

function RegisterModule__possibleConstructorReturn(self, call) { if (call && (RegisterModule__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RegisterModule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function RegisterModule__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }














var RegisterModule_RegisterModule =
/*#__PURE__*/
function (_React$Component) {
  RegisterModule__inherits(RegisterModule, _React$Component);

  function RegisterModule(props) {
    var _this;

    RegisterModule__classCallCheck(this, RegisterModule);

    _this = RegisterModule__possibleConstructorReturn(this, (RegisterModule.__proto__ || Object.getPrototypeOf(RegisterModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(RegisterModule__assertThisInitialized(_this));
    return _this;
  }

  RegisterModule__createClass(RegisterModule, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return RegisterModule__jsx("span", {}, void 0, RegisterModule__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.props.isShowRegisterModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        style: {
          marginTop: '200px'
        },
        className: "".concat(login_default.a.resizeModal, " text-center"),
        contentClassName: login_default.a.resizeModalContent
      }, void 0, RegisterModule__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: function onClick() {
          return _this2.toggle();
        },
        className: "".concat(login_default.a.infoCloseRightButton)
      }), RegisterModule__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          backgroundColor: '#f7f7f7',
          borderRadius: '4px'
        }
      }, void 0, RegisterModule__jsx(signup_form_component["a" /* ConnectedSignupForm */], {
        onSignup: this.toggle
      }), RegisterModule__jsx("span", {
        className: "".concat(login_default.a.registerIfNotYet)
      }, void 0, RegisterModule__jsx(LoginModuleRedirectText["a" /* default */], {
        target: "#login",
        normalText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_normal_message, this.state.modelDataDefaultLocale.register_modal_normal_message),
        btnText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_redirect_to_login_btn, this.state.modelDataDefaultLocale.register_modal_redirect_to_login_btn)
      })))));
    }
  }]);

  return RegisterModule;
}(react_default.a.Component);

var RegisterModule_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowRegisterModal: state.user.isShowRegisterModal
  };
};

var RegisterModule_mapDispatch = {
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Login_RegisterModule = (Object(es["b" /* connect */])(RegisterModule_mapState, RegisterModule_mapDispatch)(withStyles_default()(style_default.a, login_default.a)(RegisterModule_RegisterModule)));
// EXTERNAL MODULE: ./src/components/Login/UpdateUserInfoModule.js
var UpdateUserInfoModule = __webpack_require__(767);

// EXTERNAL MODULE: ./src/components/Dialog/dialog.sass
var dialog = __webpack_require__(523);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./src/api/user.js
var api_user = __webpack_require__(468);

// CONCATENATED MODULE: ./src/components/Dialog/expiredLoginDialog.js
function expiredLoginDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { expiredLoginDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { expiredLoginDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return expiredLoginDialog__typeof(obj); }

var expiredLoginDialog_REACT_ELEMENT_TYPE;

function expiredLoginDialog__jsx(type, props, key, children) { if (!expiredLoginDialog_REACT_ELEMENT_TYPE) { expiredLoginDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: expiredLoginDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function expiredLoginDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function expiredLoginDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function expiredLoginDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) expiredLoginDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) expiredLoginDialog__defineProperties(Constructor, staticProps); return Constructor; }

function expiredLoginDialog__possibleConstructorReturn(self, call) { if (call && (expiredLoginDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function expiredLoginDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var expiredLoginDialog__ref = expiredLoginDialog__jsx("br", {});

var expiredLoginDialog_expiredLoginDialog =
/*#__PURE__*/
function (_React$Component) {
  expiredLoginDialog__inherits(expiredLoginDialog, _React$Component);

  function expiredLoginDialog(props) {
    var _this;

    expiredLoginDialog__classCallCheck(this, expiredLoginDialog);

    _this = expiredLoginDialog__possibleConstructorReturn(this, (expiredLoginDialog.__proto__ || Object.getPrototypeOf(expiredLoginDialog)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      modelDataDefaultLocale: __webpack_require__(445)
    };
    return _this;
  }

  expiredLoginDialog__createClass(expiredLoginDialog, [{
    key: "onYes",
    value: function onYes() {
      this.props.setisNotExpiredLogin();
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var href = typeof this.state.modelDataLink['home'] === 'undefined' ? this.state.modelDataDefaultLink['home'] : this.state.modelDataLink['home'];
      return expiredLoginDialog__jsx("div", {
        id: "expiredLogin"
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["k" /* Modal */], {
        size: "lg",
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this2.props.setisNotExpiredLogin();

          Object(api_user["e" /* logout */])();
          window.location.href = href;
        }
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.orderCancelcloseRightButton),
        onClick: function onClick() {
          _this2.props.setisNotExpiredLogin();

          Object(api_user["e" /* logout */])();
          window.location.href = href;
        }
      }), expiredLoginDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.infoContainer, " ").concat(dialog_default.a.orderCancelContainer),
        style: {
          padding: 0
        }
      }, void 0, expiredLoginDialog__jsx("div", {
        className: dialog_default.a.infoHeadline
      }, void 0, expiredLoginDialog__jsx("h2", {
        className: style_default.a.globalFontLight
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_error_modal_title, this.state.modelDataDefaultLocale.login_error_modal_title))), expiredLoginDialog__jsx("div", {
        className: dialog_default.a.infoContent
      }, void 0, expiredLoginDialog__jsx("p", {}, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_error_modal_body, this.state.modelDataDefaultLocale.login_error_modal_body)), expiredLoginDialog__ref, expiredLoginDialog__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: 'auto',
          offset: '8'
        },
        xs: {
          size: '5',
          offset: '7'
        }
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " "),
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          _this2.onYes();
        }
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_title, this.state.modelDataDefaultLocale.login_modal_title)))))));
    }
  }]);

  return expiredLoginDialog;
}(react_default.a.Component);

var expiredLoginDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.user.isShowExpiredLoginModal
  };
};

var expiredLoginDialog_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Dialog_expiredLoginDialog = (Object(es["b" /* connect */])(expiredLoginDialog_mapState, expiredLoginDialog_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(expiredLoginDialog_expiredLoginDialog)));
// CONCATENATED MODULE: ./src/components/Header/Button/RegisterButton.js
function RegisterButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RegisterButton__typeof = function _typeof(obj) { return typeof obj; }; } else { RegisterButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RegisterButton__typeof(obj); }

var RegisterButton_REACT_ELEMENT_TYPE;

function RegisterButton__jsx(type, props, key, children) { if (!RegisterButton_REACT_ELEMENT_TYPE) { RegisterButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: RegisterButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function RegisterButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegisterButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RegisterButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) RegisterButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) RegisterButton__defineProperties(Constructor, staticProps); return Constructor; }

function RegisterButton__possibleConstructorReturn(self, call) { if (call && (RegisterButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RegisterButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function RegisterButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






 // const messagesRef = LoginRegisterMessagesRef;

var RegisterButton_RegisterButton =
/*#__PURE__*/
function (_React$Component) {
  RegisterButton__inherits(RegisterButton, _React$Component);

  function RegisterButton(props) {
    var _this;

    RegisterButton__classCallCheck(this, RegisterButton);

    _this = RegisterButton__possibleConstructorReturn(this, (RegisterButton.__proto__ || Object.getPrototypeOf(RegisterButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(RegisterButton__assertThisInitialized(_this));
    return _this;
  }

  RegisterButton__createClass(RegisterButton, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return RegisterButton__jsx("span", {}, void 0, RegisterButton__jsx(reactstrap_es["a" /* Button */], {
        onClick: function onClick() {
          _this2.toggle();
        },
        className: "".concat(style_default.a.headerMenuButton, " ").concat(style_default.a.rightRadius, " ").concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " dialog")
      }, void 0, typeof this.state.modelDataLocale.page_register === 'undefined' ? this.state.modelDataDefaultLocale.page_register : this.state.modelDataLocale.page_register));
    }
  }]);

  return RegisterButton;
}(react_default.a.Component);

var RegisterButton_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowRegisterModal: state.user.isShowRegisterModal
  };
};

var RegisterButton_mapDispatch = {
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Button_RegisterButton = (Object(es["b" /* connect */])(RegisterButton_mapState, RegisterButton_mapDispatch)(withStyles_default()(style_default.a)(RegisterButton_RegisterButton)));
// CONCATENATED MODULE: ./src/components/Header/Button/LoginButton.js
function LoginButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LoginButton__typeof = function _typeof(obj) { return typeof obj; }; } else { LoginButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LoginButton__typeof(obj); }

var LoginButton_REACT_ELEMENT_TYPE;

function LoginButton__jsx(type, props, key, children) { if (!LoginButton_REACT_ELEMENT_TYPE) { LoginButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LoginButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LoginButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LoginButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) LoginButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) LoginButton__defineProperties(Constructor, staticProps); return Constructor; }

function LoginButton__possibleConstructorReturn(self, call) { if (call && (LoginButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LoginButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function LoginButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






 // const messagesRef = LoginRegisterMessagesRef;

var LoginButton_LoginButton =
/*#__PURE__*/
function (_React$Component) {
  LoginButton__inherits(LoginButton, _React$Component);

  function LoginButton(props) {
    var _this;

    LoginButton__classCallCheck(this, LoginButton);

    _this = LoginButton__possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(LoginButton__assertThisInitialized(_this));
    return _this;
  }

  LoginButton__createClass(LoginButton, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return LoginButton__jsx("span", {}, void 0, LoginButton__jsx(reactstrap_es["a" /* Button */], {
        onClick: function onClick() {
          _this2.toggle();
        },
        className: "".concat(style_default.a.headerMenuButton, " ").concat(style_default.a.leftRadius, " ").concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " dialog")
      }, void 0, typeof this.state.modelDataLocale.page_login === 'undefined' ? this.state.modelDataDefaultLocale.page_login : this.state.modelDataLocale.page_login));
    }
  }]);

  return LoginButton;
}(react_default.a.Component);

var LoginButton_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal
  };
};

var LoginButton_mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Button_LoginButton = (Object(es["b" /* connect */])(LoginButton_mapState, LoginButton_mapDispatch)(withStyles_default()(style_default.a)(LoginButton_LoginButton)));
// EXTERNAL MODULE: ./src/service/asset-json.js
var asset_json = __webpack_require__(461);

// EXTERNAL MODULE: ./src/assets/img/icon_dropdownarrow_grey.png
var icon_dropdownarrow_grey = __webpack_require__(773);
var icon_dropdownarrow_grey_default = /*#__PURE__*/__webpack_require__.n(icon_dropdownarrow_grey);

// EXTERNAL MODULE: ./src/assets/img/icon_avator40x40.png
var icon_avator40x40 = __webpack_require__(765);
var icon_avator40x40_default = /*#__PURE__*/__webpack_require__.n(icon_avator40x40);

// EXTERNAL MODULE: ./src/assets/img/icon_avator40x40@2x.png
var icon_avator40x40_2x = __webpack_require__(764);
var icon_avator40x40_2x_default = /*#__PURE__*/__webpack_require__.n(icon_avator40x40_2x);

// EXTERNAL MODULE: ./src/service/localStorage.js
var localStorage = __webpack_require__(150);

// CONCATENATED MODULE: ./src/components/Header/Header/MenuRight.js
function MenuRight__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MenuRight__typeof = function _typeof(obj) { return typeof obj; }; } else { MenuRight__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MenuRight__typeof(obj); }

var MenuRight_REACT_ELEMENT_TYPE;

function MenuRight__jsx(type, props, key, children) { if (!MenuRight_REACT_ELEMENT_TYPE) { MenuRight_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: MenuRight_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function MenuRight__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MenuRight__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MenuRight__createClass(Constructor, protoProps, staticProps) { if (protoProps) MenuRight__defineProperties(Constructor.prototype, protoProps); if (staticProps) MenuRight__defineProperties(Constructor, staticProps); return Constructor; }

function MenuRight__possibleConstructorReturn(self, call) { if (call && (MenuRight__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MenuRight__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function MenuRight__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






















var MenuRight__ref = MenuRight__jsx(Button_LoginButton, {});

var _ref2 = MenuRight__jsx(Button_RegisterButton, {});

var _ref3 = MenuRight__jsx(Login_LoginModule, {});

var _ref4 = MenuRight__jsx(Login_RegisterModule, {});

var _ref5 = MenuRight__jsx(UpdateUserInfoModule["a" /* default */], {});

var _ref6 = MenuRight__jsx(Dialog_expiredLoginDialog, {});

var MenuRight_MenuRight =
/*#__PURE__*/
function (_React$Component) {
  MenuRight__inherits(MenuRight, _React$Component);

  function MenuRight(props) {
    var _this;

    MenuRight__classCallCheck(this, MenuRight);

    _this = MenuRight__possibleConstructorReturn(this, (MenuRight.__proto__ || Object.getPrototypeOf(MenuRight)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      dropdownOpen: false,
      // ensure fetched data from localStorage
      isShowMenu: false,
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      modelDataSetting: __webpack_require__(895)("./".concat(lang === 'hk' ? 'default' : lang, "/setting/general/setting.json")),
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(MenuRight__assertThisInitialized(_this)); // this.setUserInfo = this.setUserInfo.bind(this);

    return _this;
  }

  MenuRight__createClass(MenuRight, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(localStorage["b" /* localStorageGet */])('auth.id', false) !== null) {
        var email = Object(localStorage["b" /* localStorageGet */])('auth.email', false);
        var password = Object(localStorage["b" /* localStorageGet */])('auth.password', false);
        var phone = Object(localStorage["b" /* localStorageGet */])('auth.phone', false);

        if (!((email || phone) && password)) {
          return false;
        }

        var id = Object(localStorage["b" /* localStorageGet */])('auth.id', false);
        var username = Object(localStorage["b" /* localStorageGet */])('auth.username', false);
        var verified = Object(localStorage["b" /* localStorageGet */])('auth.verified', false);
        var addresses = Object(localStorage["b" /* localStorageGet */])('auth.addresses', false);
        var gender = Object(localStorage["b" /* localStorageGet */])('auth.gender', false);
        var industry = Object(localStorage["b" /* localStorageGet */])('auth.industry', false);
        var dateOfBirth = Object(localStorage["b" /* localStorageGet */])('auth.date_of_birth', false);
        var receiveGogovanUpdates = Object(localStorage["b" /* localStorageGet */])('auth.has_agreed_to_receive_gogovan_updates', false);
        var receiveThirdPartiesUpdates = Object(localStorage["b" /* localStorageGet */])('auth.has_agreed_to_receive_third_parties_updates', false);
        var profilePhoto = Object(localStorage["b" /* localStorageGet */])('auth.profile_photo', false);
        var user = {
          id: id,
          email: email,
          password: password,
          name: username,
          phone: phone,
          verified: verified,
          addresses: addresses,
          profilePhoto: profilePhoto,
          receiveGogovanUpdates: receiveGogovanUpdates,
          receiveThirdPartiesUpdates: receiveThirdPartiesUpdates,
          gender: gender,
          industry: industry,
          dateOfBirth: dateOfBirth
        };
        this.props.setUserInfo(user);
      }

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIsShowMenu();
    }
  }, {
    key: "setIsShowMenu",
    value: function setIsShowMenu() {
      this.setState({
        isShowMenu: true
      });
    }
  }, {
    key: "setUserInfo",
    value: function setUserInfo() {
      Object(api_user["e" /* logout */])();
      this.props.setUserInfo(null);
      var href = Object(asset_json["a" /* getLink */])('sign_in', this.props.currentLocale);
      window.location.href = href;
    }
  }, {
    key: "getPage",
    value: function getPage(page) {
      if (page === 'dashboard') {
        var href = typeof this.state.modelDataLink[page] === 'undefined' ? this.state.modelDataDefaultLink[page] : this.state.modelDataLink[page];
        window.location.href = href;
      } else if (page === 'sign_out') {
        this.setUserInfo();
      } else {
        var _href = typeof this.state.modelDataLink[page] === 'undefined' ? this.state.modelDataDefaultLink[page] : this.state.modelDataLink[page];

        window.location.href = _href;
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = this.props.user;
      return MenuRight__jsx("nav", {
        className: style_default.a.headerMenuRight
      }, void 0, this.state.modelDataSetting.enable_ordering && this.state.isShowMenu ? MenuRight__jsx("span", {}, void 0, user === null ? MenuRight__jsx("span", {
        className: "".concat(style_default.a.headerMenuRightItem, " ").concat(style_default.a.twinButton)
      }, void 0, MenuRight__ref, _ref2) : MenuRight__jsx("ul", {}, void 0, MenuRight__jsx("li", {
        className: style_default.a.headerMenuRightItem,
        id: "headerMenuUser"
      }, void 0, MenuRight__jsx(reactstrap_es["d" /* Dropdown */], {
        isOpen: this.state.dropdownOpen,
        toggle: this.toggle,
        className: Header_default.a.dropdownMenuRight
      }, void 0, MenuRight__jsx(reactstrap_es["f" /* DropdownToggle */], {
        tag: "span",
        onClick: this.toggle,
        "aria-expanded": this.state.dropdownOpen
      }, void 0, MenuRight__jsx("span", {
        className: Header_default.a.nameLong
      }, void 0, user.name), MenuRight__jsx("span", {
        className: Header_default.a.nameShort
      }, void 0, user.name.split(' ').map(function (x) {
        return x[0];
      }).join('')), MenuRight__jsx("img", {
        className: "".concat(style_default.a.userImage),
        srcSet: "".concat(icon_avator40x40_default.a, " 1x, ").concat(icon_avator40x40_2x_default.a, " 2x"),
        width: "40",
        alt: "user icon"
      }), MenuRight__jsx("img", {
        alt: "arrow",
        className: Header_default.a.dropdownMenuRight__arrow,
        src: icon_dropdownarrow_grey_default.a,
        width: "9"
      })), MenuRight__jsx(reactstrap_es["e" /* DropdownMenu */], {
        className: "".concat(Header_default.a.dropdownmenu, " ").concat(this.props.fromNormalHeader ? Header_default.a.dropHeading : Header_default.a.dropOrderHeading) // onMouseLeave={() => {
        //   this.toggle();
        // }}
        ,
        onBlur: function onBlur() {}
      }, void 0, this.state.modelDataSetting.header.options.map(function (i) {
        return MenuRight__jsx("div", {
          tabIndex: "0",
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.getPage(i);
          },
          onKeyPress: function onKeyPress() {},
          role: "button"
        }, i, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]));
      })))))) : MenuRight__jsx("ul", {}), _ref3, _ref4, _ref5, _ref6);
    }
  }]);

  return MenuRight;
}(react_default.a.Component);

Object.defineProperty(MenuRight_MenuRight, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    fromNormalHeader: false
  }
});
Object.defineProperty(MenuRight_MenuRight, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    user: null
  }
});

var MenuRight_mapState = function mapState(state) {
  return {
    user: state.user.user,
    currentLocale: state.intl.locale
  };
};

var MenuRight_mapDispatch = {
  setUserInfo: actions_user["h" /* setUserInfo */],
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */],
  setIsShowUpdateUserModal: actions_user["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ var Header_MenuRight = (Object(es["b" /* connect */])(MenuRight_mapState, MenuRight_mapDispatch)(withStyles_default()(style_default.a, Header_default.a)(MenuRight_MenuRight)));
// EXTERNAL MODULE: ./src/assets/img/nav_logo.png
var nav_logo = __webpack_require__(896);
var nav_logo_default = /*#__PURE__*/__webpack_require__.n(nav_logo);

// EXTERNAL MODULE: ./src/assets/img/nav_logo@2x.png
var nav_logo_2x = __webpack_require__(897);
var nav_logo_2x_default = /*#__PURE__*/__webpack_require__.n(nav_logo_2x);

// CONCATENATED MODULE: ./src/components/Header/OrderingHeader.js
function OrderingHeader__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderingHeader__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderingHeader__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderingHeader__typeof(obj); }

var OrderingHeader_REACT_ELEMENT_TYPE;

function OrderingHeader__jsx(type, props, key, children) { if (!OrderingHeader_REACT_ELEMENT_TYPE) { OrderingHeader_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderingHeader_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderingHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderingHeader__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderingHeader__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderingHeader__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderingHeader__defineProperties(Constructor, staticProps); return Constructor; }

function OrderingHeader__possibleConstructorReturn(self, call) { if (call && (OrderingHeader__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderingHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





 // general setting.json









var OrderingHeader__ref = OrderingHeader__jsx(Header_MenuRight, {});

var OrderingHeader_OrderingHeader =
/*#__PURE__*/
function (_React$Component) {
  OrderingHeader__inherits(OrderingHeader, _React$Component);

  function OrderingHeader(props) {
    var _this;

    OrderingHeader__classCallCheck(this, OrderingHeader);

    _this = OrderingHeader__possibleConstructorReturn(this, (OrderingHeader.__proto__ || Object.getPrototypeOf(OrderingHeader)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      // delay to show header
      isShowheader: false,
      modelDataSetting: __webpack_require__(466),
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    return _this;
  }

  OrderingHeader__createClass(OrderingHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIsShowHeader();
    }
  }, {
    key: "setIsShowHeader",
    value: function setIsShowHeader() {
      this.setState({
        isShowheader: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return OrderingHeader__jsx("header", {
        className: "".concat(style_default.a.order, " ").concat(Header_default.a.headerFontFamily),
        style: this.state.isShowheader ? {} : {
          visibility: 'hidden'
        }
      }, void 0, OrderingHeader__jsx("div", {
        className: "".concat(style_default.a.container)
      }, void 0, OrderingHeader__jsx("div", {
        className: "".concat(style_default.a.headerLogo)
      }, void 0, OrderingHeader__jsx("a", {
        href: "/"
      }, void 0, OrderingHeader__jsx("img", {
        alt: "GoGoVan",
        srcSet: "".concat(nav_logo_default.a, " 1x, ").concat(nav_logo_2x_default.a, " 2x")
      }))), OrderingHeader__jsx("nav", {
        className: "".concat(OrderingHeaderStyle_default.a.headerLeft, " ").concat(style_default.a.headerMenuLeft, " ")
      }, void 0, OrderingHeader__jsx("ul", {}, void 0, this.state.modelDataSetting.ordering_header.left_menu.map(function (i) {
        var page = i.replace('ordering_', '');

        if (_this2.props.filename.toUpperCase() === page.toUpperCase()) {
          return OrderingHeader__jsx("a", {
            href: page,
            className: "".concat(style_default.a.headerMenuLeftItem, " ").concat(style_default.a.headerMenuLeftBar, " ").concat(style_default.a.active, " ").concat(style_default.a.resetFontsize)
          }, page, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]).toUpperCase());
        }

        return OrderingHeader__jsx("a", {
          href: page,
          className: "".concat(style_default.a.headerMenuLeftItem, " ").concat(style_default.a.headerMenuLeftBar, " ").concat(style_default.a.resetFontsize)
        }, page, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]).toUpperCase());
      }))), OrderingHeader__ref));
    }
  }]);

  return OrderingHeader;
}(react_default.a.Component);

var OrderingHeader_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

/* harmony default export */ var Header_OrderingHeader = (Object(es["b" /* connect */])(OrderingHeader_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, OrderingHeaderStyle_default.a)(OrderingHeader_OrderingHeader)));
// EXTERNAL MODULE: ./src/components/Footer/footer.sass
var footer = __webpack_require__(898);
var footer_default = /*#__PURE__*/__webpack_require__.n(footer);

// CONCATENATED MODULE: ./src/components/Footer/OrderingFooter.js
function OrderingFooter__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderingFooter__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderingFooter__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderingFooter__typeof(obj); }

var OrderingFooter_REACT_ELEMENT_TYPE;

function OrderingFooter__jsx(type, props, key, children) { if (!OrderingFooter_REACT_ELEMENT_TYPE) { OrderingFooter_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderingFooter_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderingFooter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderingFooter__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderingFooter__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderingFooter__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderingFooter__defineProperties(Constructor, staticProps); return Constructor; }

function OrderingFooter__possibleConstructorReturn(self, call) { if (call && (OrderingFooter__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderingFooter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OrderingFooter_OrderingFooter =
/*#__PURE__*/
function (_React$Component) {
  OrderingFooter__inherits(OrderingFooter, _React$Component);

  function OrderingFooter() {
    OrderingFooter__classCallCheck(this, OrderingFooter);

    return OrderingFooter__possibleConstructorReturn(this, (OrderingFooter.__proto__ || Object.getPrototypeOf(OrderingFooter)).apply(this, arguments));
  }

  OrderingFooter__createClass(OrderingFooter, [{
    key: "render",
    value: function render() {
      var currentLocale = this.props.currentLocale;
      return OrderingFooter__jsx("footer", {
        className: "".concat(style_default.a.order)
      }, void 0, OrderingFooter__jsx("div", {
        className: "".concat(footer_default.a.fixedContainer)
      }, void 0, OrderingFooter__jsx("div", {
        className: "".concat(style_default.a.footerFunction)
      }, void 0, OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('home', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_home', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('help_center', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_help_center', currentLocale)), "|"), OrderingFooter__jsx("div", {
        className: "".concat(style_default.a.footerNav)
      }, void 0, OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('about', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_about_us', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('service', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_service', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('pricing', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_pricing', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('business', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_business', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('privacy', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_privacy', currentLocale)))));
    }
  }]);

  return OrderingFooter;
}(react_default.a.Component);

var OrderingFooter_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

/* harmony default export */ var Footer_OrderingFooter = (Object(es["b" /* connect */])(OrderingFooter_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, footer_default.a)(OrderingFooter_OrderingFooter)));
// EXTERNAL MODULE: ./src/actions/intl.js
var intl = __webpack_require__(156);

// CONCATENATED MODULE: ./src/components/Layout/Layout.js
function Layout__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Layout__typeof = function _typeof(obj) { return typeof obj; }; } else { Layout__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Layout__typeof(obj); }

var Layout_REACT_ELEMENT_TYPE;

function Layout__jsx(type, props, key, children) { if (!Layout_REACT_ELEMENT_TYPE) { Layout_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Layout_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Layout__createClass(Constructor, protoProps, staticProps) { if (protoProps) Layout__defineProperties(Constructor.prototype, protoProps); if (staticProps) Layout__defineProperties(Constructor, staticProps); return Constructor; }

function Layout__possibleConstructorReturn(self, call) { if (call && (Layout__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */













var Layout__ref = Layout__jsx("link", {
  rel: "icon",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-32x32.png",
  sizes: "32x32"
});

var Layout__ref2 = Layout__jsx("link", {
  rel: "icon",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-192x192.png",
  sizes: "192x192"
});

var Layout__ref3 = Layout__jsx("link", {
  rel: "apple-touch-icon-precomposed",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-180x180.png"
});

var Layout__ref4 = Layout__jsx("meta", {
  name: "msapplication-TileImage",
  content: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-270x270.png"
});

var Layout__ref5 = Layout__jsx("meta", {
  name: "application-name",
  content: "GOGOX"
});

var Layout__ref6 = Layout__jsx("meta", {
  name: "msapplication-TileColor",
  content: "#0088bf"
});

var _ref7 = Layout__jsx(Footer_OrderingFooter, {});

var Layout_Layout_Layout =
/*#__PURE__*/
function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout(props) {
    var _this;

    Layout__classCallCheck(this, Layout);

    _this = Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props)); // ensure lang is not zh-CN

    _this.state = {
      pathname: '',
      isValidEnter: false,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      modelDataText: null,
      needToRedirect: false,
      locale: props.defaultLocale,
      fileLang: "".concat(props.currentLocale.split('-')[0], "_").concat(props.currentLocale.split('-')[1].toLowerCase(), "/")
    };
    return _this;
  }

  Layout__createClass(Layout, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // ensure current lang equals to default lang

      /*
      Due to using react-intl plugin (base on the requirement), this may need switch twice to change languages.
      The plugin store the using languages to cookie. To ensure the using language is correct, it will reload the page to do it.
      */
      if (this.props.currentLocale.split('-')[1] !== this.props.defaultLocale.split('-')[1]) {
        var locale = this.state.locale;
        this.props.setLocale({
          locale: locale
        });
        this.setState({
          needToRedirect: true
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (new Date('2022-07-06T00:00:00+08:00') <= new Date() && this.state.locale === 'zh-TW') {
        // TW service is going to shutdown on 06Jul2022.
        window.location.href = 'https://www.gogox.com/tw/';
      }

      if (this.state.needToRedirect) {
        var locale = this.state.locale;
        this.props.setLocale({
          locale: locale
        });
        setTimeout(function () {
          window.location.reload();
        }, 300);
      } else {
        this.props.setIsdefaultLang(true);
      } // ensure not in zh-CN


      if (this.props.currentLocale === 'zh-CN') {
        this.props.setLocale({
          locale: this.props.defaultLocale
        });
        setTimeout(function () {
          window.location.reload();
        }, 300);
      } else {
        this.setCurrentLocate();
      }

      document.body.classList.add("".concat(Layout_Layout_default.a.adjustPaddingRight));
    }
  }, {
    key: "setCurrentLocate",
    value: function setCurrentLocate() {
      var _state = this.state,
          lang = _state.lang,
          fileLang = _state.fileLang;
      this.setState({
        modelDataText: __webpack_require__(900)("./".concat(lang, "/").concat(lang === 'hk' ? fileLang : '', "setting/index/locale.json"))
      });
      this.setState({
        isValidEnter: true
      });
      this.setState({
        pathname: src_history["a" /* default */].location.pathname.replace('/', '').toLowerCase()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          showHeader = _props.showHeader,
          showFooter = _props.showFooter;

      if (this.state.isValidEnter && this.props.isDefaultLang) {
        return Layout__jsx("div", {}, void 0, Layout__jsx(Helmet["Helmet"], {}, void 0, Layout__jsx("title", {}, void 0, this.state.modelDataText.title), Layout__ref, Layout__ref2, Layout__ref3, Layout__ref4, Layout__ref5, Layout__ref6), Layout__jsx("div", {}, void 0, showHeader && Layout__jsx(Header_OrderingHeader, {
          filename: this.state.pathname
        }), Layout__jsx("div", {
          className: Layout_Layout_default.a.child
        }, void 0, this.props.children), showFooter && _ref7));
      }

      return null;
    }
  }]);

  return Layout;
}(react_default.a.Component);

Object.defineProperty(Layout_Layout_Layout, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    showHeader: true,
    showFooter: true
  }
});

var Layout_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    defaultLocale: state.intl.defaultLocale,
    isDefaultLang: state.intl.isDefaultLang
  };
};

var Layout_mapDispatch = {
  setLocale: intl["c" /* setLocale */],
  setIsdefaultLang: intl["b" /* setIsdefaultLang */]
};
/* harmony default export */ var src_components_Layout_Layout = __webpack_exports__["a"] = (Object(es["b" /* connect */])(Layout_mapState, Layout_mapDispatch)(withStyles_default()(normalize_default.a, Layout_default.a, Layout_Layout_default.a)(Layout_Layout_Layout)));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(861);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(864);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(867);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(870);

var _HelmetConstants = __webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(862)();
}


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(151);
var invariant = __webpack_require__(108);
var ReactPropTypesSecret = __webpack_require__(863);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(30);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(865));
var shallowEqual = _interopDefault(__webpack_require__(866));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(868);
var isArguments = __webpack_require__(869);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 868 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 869 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(36);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(872);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(874);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "html{color:#222;font-weight:100;font-size:1em;font-family:Segoe UI,HelveticaNeue-Light,sans-serif;line-height:1.375}body{margin:0}a{color:#0074c2}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(876);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Layout.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Layout.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, ".OJcJY{padding-right:0!important}.OWNPr{overflow-y:auto!important}", ""]);

// exports
exports.locals = {
	"adjustPaddingRight": "OJcJY",
	"child": "OWNPr"
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._1_kj0{opacity:.4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._2qnhs{text-transform:uppercase;left:-5px;position:relative;color:#0088bf}@media (max-width:767px){._2qnhs{display:none}}._2gKor{display:none;text-transform:uppercase;left:-5px;position:relative;color:#0088bf}@media (max-width:767px){._2gKor{display:inline}}.yiov7{padding-right:20px}._20KZV{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);right:0}._3ss0d{line-height:25px!important;background-color:#fff;padding:10px 0;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.3);box-shadow:0 2px 4px rgba(0,0,0,.3);border-radius:2px;width:220px;float:none;border:0;position:absolute!important;top:65px!important;right:-10px!important;-webkit-transform:none!important;-ms-transform:none!important;transform:none!important;left:auto!important}@media (max-width:767px){._3ss0d{top:45px!important}}._3ss0d div{height:40px;line-height:40px;font-size:16px;text-align:left;color:#4a4a4a;display:block;padding-left:40px}._3ss0d div:hover{background-color:#e8e8e8}._1ahyg{border:unset!important}@media (max-width:767px){._1ahyg{border:unset!important}}._3CRwj,.qzR4l{max-height:0!important;overflow-y:hidden!important;-webkit-transition:max-height 3s ease-in-out!important;-o-transition:max-height 3s ease-in-out!important;transition:max-height 3s ease-in-out!important}._3CRwj{max-height:200px!important}._1usdi{overflow-y:hidden;max-height:200px;-webkit-transition-property:all;-o-transition-property:all;transition-property:all;-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s;transition-duration-transition-timing-function:ease-in-out}.WGqnJ{max-height:0}._3s_Nn,._3YkZ6{overflow:hidden}._3s_Nn>div,._3YkZ6>div{-webkit-transform:translateY(-100%);-ms-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:.4s ease-in-out;-o-transition:.4s ease-in-out;transition:.4s ease-in-out}._3YkZ6>div{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.k7veS{max-height:0}._1ySUO,.k7veS{overflow:hidden;-webkit-transition:max-height .2s ease-in-out!important;-o-transition:max-height .2s ease-in-out!important;transition:max-height .2s ease-in-out!important}._1ySUO{max-height:200px}", ""]);

// exports
exports.locals = {
	"transparent": "_1_kj0",
	"nameLong": "_2qnhs",
	"nameShort": "_2gKor",
	"dropdownMenuRight": "yiov7",
	"dropdownMenuRight__arrow": "_20KZV",
	"dropdownmenu": "_3ss0d",
	"dropHeading": "_1ahyg",
	"slideup": "qzR4l",
	"slidedown": "_3CRwj",
	"slider": "_1usdi",
	"sliderClosed": "WGqnJ",
	"slideUp": "_3s_Nn",
	"slideDown": "_3YkZ6",
	"submenu": "k7veS",
	"submenuhover": "_1ySUO"
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(879);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./OrderingHeaderStyle.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./OrderingHeaderStyle.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._3yq5m{border-color:#fec930}", ""]);

// exports
exports.locals = {
	"headerLeftBoarder": "_3yq5m"
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "hr{border-top:1px solid rgba(0,0,0,.35)}.HhDS9{display:block;-webkit-margin-before:1.33em;-webkit-margin-after:1.33em;-webkit-margin-start:0;-webkit-margin-end:0}._1pD35{padding-left:2.2em!important;padding-right:3em!important}._3E9Eo{margin-top:-30px;margin-left:10px;float:left}._2FI7K{margin-top:17vh!important;border-radius:4px}@media (max-width:767px){._2FI7K{margin-left:0!important;margin-right:0!important;max-width:100%!important}}._3HozT{background-color:#f7f7f7!important}._2gByW{width:40px;height:40px;position:absolute;top:-40px;right:0;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}._2gByW:hover ._2gByW:active ._2gByW:link ._2gByW:visited{background-color:transparent;border-color:transparent;border:0}._1Q5kA{padding-bottom:10px}._3pS7u{padding-right:0;padding-left:0;width:100%;margin:auto;padding-top:10px}._3pS7u ._10wiI{margin-top:-25px;position:absolute;margin-left:auto;margin-right:auto;background-color:#f7f7f7;padding:0 10px;margin-left:-15px}.MDnJS{margin:20px 0}._2Ypa4{display:none}._2k4nM{font-size:.875em!important;color:#0088bf!important;outline:0!important;border:0!important}._2k4nM:active ._2k4nM:hover{background-color:\"red\"}.EefiA input._2kOoi{padding-left:36px}.IZiYH{font-size:13px}.IKszL{padding-left:2.2em;padding-right:0;background-color:#f7f7f7}._2EfXz{margin-top:5px;margin-bottom:10px;background-color:#0088bf}._2EfXz:hover{background-color:#00a9ee;color:#fff;border-color:#00a9ee}._1geF2{font-weight:700!important}._2k4nM{margin-top:5px;margin-bottom:10px;outline:0;border:0}._2uUK2{display:none;color:#0074c2}._2YfWy{margin-bottom:0}._62960{margin-bottom:25px;font-weight:100!important}._2hYgp{border-radius:40px;font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;font-style:normal;font-weight:700;font-size:16px;padding:16px 32px;cursor:pointer;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;width:266px}._2hYgp._1WilD{border:1.5px solid #0088bf;color:#0088bf;background-color:#fff;margin-bottom:24px}._2hYgp.-mvnM,._2hYgp._1WilD:hover,._2hYgp._69YCb{color:#fff;background-color:#0088bf}._2hYgp.-mvnM,._2hYgp._69YCb{border:1.5px solid #0088bf;margin:24px 0 12px}._2hYgp.-mvnM:hover,._2hYgp._69YCb:hover{background-color:#006e9b}._2kOoi{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;border:1px solid #e5e7e8;border-radius:4px;width:100%;background-color:#fff;font-size:16px;padding:12px 24px;margin-bottom:10px}._2kOoi::-webkit-input-placeholder{color:#7f888c}._2kOoi:-ms-input-placeholder,._2kOoi::-ms-input-placeholder{color:#7f888c}._2kOoi::placeholder{color:#7f888c}._20tOH{position:absolute;background:#ea5265;border-radius:0 0 3px 3px;top:0;width:404px;padding:12px;color:#fff;font-size:14px}", ""]);

// exports
exports.locals = {
	"redireactText": "HhDS9",
	"iconLeft": "_1pD35",
	"imgIconLeft": "_3E9Eo",
	"resizeModal": "_2FI7K",
	"resizeModalContent2": "_3HozT",
	"infoCloseRightButton": "_2gByW",
	"inputPadding": "_1Q5kA",
	"orLine": "_3pS7u",
	"or": "_10wiI",
	"registerIfNotYet": "MDnJS",
	"visible": "_2Ypa4",
	"registerButton": "_2k4nM",
	"sgloginForm": "EefiA",
	"input": "_2kOoi",
	"pdpa": "IZiYH",
	"updateInfoModuleInput": "IKszL",
	"loginRegisterbutton": "_2EfXz",
	"fbloginButton": "_1geF2",
	"forgetPassword": "_2uUK2",
	"resetformgroup": "_2YfWy",
	"registerTitle": "_62960",
	"button": "_2hYgp",
	"facebook": "_1WilD",
	"register": "_69YCb",
	"login": "-mvnM",
	"error": "_20tOH"
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404/locale": 477,
	"./404/locale.json": 477,
	"./404/media": 478,
	"./404/media.json": 478,
	"./404/setting": 479,
	"./404/setting.json": 479,
	"./about/locale": 480,
	"./about/locale.json": 480,
	"./about/media": 481,
	"./about/media.json": 481,
	"./about/setting": 482,
	"./about/setting.json": 482,
	"./business/link": 483,
	"./business/link.json": 483,
	"./business/locale": 484,
	"./business/locale.json": 484,
	"./business/media": 485,
	"./business/media.json": 485,
	"./business/setting": 486,
	"./business/setting.json": 486,
	"./business_services_registration/locale": 487,
	"./business_services_registration/locale.json": 487,
	"./business_services_registration/setting": 488,
	"./business_services_registration/setting.json": 488,
	"./contact/locale": 489,
	"./contact/locale.json": 489,
	"./contact/setting": 490,
	"./contact/setting.json": 490,
	"./faq/locale": 491,
	"./faq/locale.json": 491,
	"./faq/setting": 492,
	"./faq/setting.json": 492,
	"./general/link": 452,
	"./general/link.json": 452,
	"./general/locale": 445,
	"./general/locale.json": 445,
	"./general/media": 493,
	"./general/media.json": 493,
	"./general/setting": 466,
	"./general/setting.json": 466,
	"./index/locale": 471,
	"./index/locale.json": 471,
	"./index/media": 494,
	"./index/media.json": 494,
	"./index/setting": 495,
	"./index/setting.json": 495,
	"./legal/locale": 496,
	"./legal/locale.json": 496,
	"./legal/setting": 497,
	"./legal/setting.json": 497,
	"./mobile/pricing/locale": 498,
	"./mobile/pricing/locale.json": 498,
	"./mobile/pricing/media": 499,
	"./mobile/pricing/media.json": 499,
	"./mobile/pricing/setting": 500,
	"./mobile/pricing/setting.json": 500,
	"./password/locale": 501,
	"./password/locale.json": 501,
	"./password/setting": 502,
	"./password/setting.json": 502,
	"./pricing/locale": 503,
	"./pricing/locale.json": 503,
	"./pricing/media": 504,
	"./pricing/media.json": 504,
	"./pricing/setting": 505,
	"./pricing/setting.json": 505,
	"./quoting/locale": 506,
	"./quoting/locale.json": 506,
	"./quoting/media": 507,
	"./quoting/media.json": 507,
	"./quoting/setting": 508,
	"./quoting/setting.json": 508,
	"./service/link": 509,
	"./service/link.json": 509,
	"./service/locale": 510,
	"./service/locale.json": 510,
	"./service/media": 511,
	"./service/media.json": 511,
	"./service/setting": 512,
	"./service/setting.json": 512,
	"./sitemap/setting": 513,
	"./sitemap/setting.json": 513,
	"./template_for_angular/locale": 514,
	"./template_for_angular/locale.json": 514,
	"./template_for_angular/setting": 515,
	"./template_for_angular/setting.json": 515,
	"./template_for_angular_no_header/locale": 516,
	"./template_for_angular_no_header/locale.json": 516,
	"./template_for_angular_no_header/setting": 517,
	"./template_for_angular_no_header/setting.json": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/pages": 589,
	"./default/pages.json": 589,
	"./default/setting/404/locale": 477,
	"./default/setting/404/locale.json": 477,
	"./default/setting/404/media": 478,
	"./default/setting/404/media.json": 478,
	"./default/setting/404/setting": 479,
	"./default/setting/404/setting.json": 479,
	"./default/setting/about/locale": 480,
	"./default/setting/about/locale.json": 480,
	"./default/setting/about/media": 481,
	"./default/setting/about/media.json": 481,
	"./default/setting/about/setting": 482,
	"./default/setting/about/setting.json": 482,
	"./default/setting/business/link": 483,
	"./default/setting/business/link.json": 483,
	"./default/setting/business/locale": 484,
	"./default/setting/business/locale.json": 484,
	"./default/setting/business/media": 485,
	"./default/setting/business/media.json": 485,
	"./default/setting/business/setting": 486,
	"./default/setting/business/setting.json": 486,
	"./default/setting/business_services_registration/locale": 487,
	"./default/setting/business_services_registration/locale.json": 487,
	"./default/setting/business_services_registration/setting": 488,
	"./default/setting/business_services_registration/setting.json": 488,
	"./default/setting/contact/locale": 489,
	"./default/setting/contact/locale.json": 489,
	"./default/setting/contact/setting": 490,
	"./default/setting/contact/setting.json": 490,
	"./default/setting/faq/locale": 491,
	"./default/setting/faq/locale.json": 491,
	"./default/setting/faq/setting": 492,
	"./default/setting/faq/setting.json": 492,
	"./default/setting/general/link": 452,
	"./default/setting/general/link.json": 452,
	"./default/setting/general/locale": 445,
	"./default/setting/general/locale.json": 445,
	"./default/setting/general/media": 493,
	"./default/setting/general/media.json": 493,
	"./default/setting/general/setting": 466,
	"./default/setting/general/setting.json": 466,
	"./default/setting/index/locale": 471,
	"./default/setting/index/locale.json": 471,
	"./default/setting/index/media": 494,
	"./default/setting/index/media.json": 494,
	"./default/setting/index/setting": 495,
	"./default/setting/index/setting.json": 495,
	"./default/setting/legal/locale": 496,
	"./default/setting/legal/locale.json": 496,
	"./default/setting/legal/setting": 497,
	"./default/setting/legal/setting.json": 497,
	"./default/setting/mobile/pricing/locale": 498,
	"./default/setting/mobile/pricing/locale.json": 498,
	"./default/setting/mobile/pricing/media": 499,
	"./default/setting/mobile/pricing/media.json": 499,
	"./default/setting/mobile/pricing/setting": 500,
	"./default/setting/mobile/pricing/setting.json": 500,
	"./default/setting/password/locale": 501,
	"./default/setting/password/locale.json": 501,
	"./default/setting/password/setting": 502,
	"./default/setting/password/setting.json": 502,
	"./default/setting/pricing/locale": 503,
	"./default/setting/pricing/locale.json": 503,
	"./default/setting/pricing/media": 504,
	"./default/setting/pricing/media.json": 504,
	"./default/setting/pricing/setting": 505,
	"./default/setting/pricing/setting.json": 505,
	"./default/setting/quoting/locale": 506,
	"./default/setting/quoting/locale.json": 506,
	"./default/setting/quoting/media": 507,
	"./default/setting/quoting/media.json": 507,
	"./default/setting/quoting/setting": 508,
	"./default/setting/quoting/setting.json": 508,
	"./default/setting/service/link": 509,
	"./default/setting/service/link.json": 509,
	"./default/setting/service/locale": 510,
	"./default/setting/service/locale.json": 510,
	"./default/setting/service/media": 511,
	"./default/setting/service/media.json": 511,
	"./default/setting/service/setting": 512,
	"./default/setting/service/setting.json": 512,
	"./default/setting/sitemap/setting": 513,
	"./default/setting/sitemap/setting.json": 513,
	"./default/setting/template_for_angular/locale": 514,
	"./default/setting/template_for_angular/locale.json": 514,
	"./default/setting/template_for_angular/setting": 515,
	"./default/setting/template_for_angular/setting.json": 515,
	"./default/setting/template_for_angular_no_header/locale": 516,
	"./default/setting/template_for_angular_no_header/locale.json": 516,
	"./default/setting/template_for_angular_no_header/setting": 517,
	"./default/setting/template_for_angular_no_header/setting.json": 517,
	"./hk/en_hk/pages": 590,
	"./hk/en_hk/pages.json": 590,
	"./hk/en_hk/setting/about/locale": 591,
	"./hk/en_hk/setting/about/locale.json": 591,
	"./hk/en_hk/setting/business/locale": 592,
	"./hk/en_hk/setting/business/locale.json": 592,
	"./hk/en_hk/setting/contact/locale": 593,
	"./hk/en_hk/setting/contact/locale.json": 593,
	"./hk/en_hk/setting/contact/setting": 594,
	"./hk/en_hk/setting/contact/setting.json": 594,
	"./hk/en_hk/setting/dashboard/locale": 595,
	"./hk/en_hk/setting/dashboard/locale.json": 595,
	"./hk/en_hk/setting/dashboard/setting": 596,
	"./hk/en_hk/setting/dashboard/setting.json": 596,
	"./hk/en_hk/setting/faq/locale": 597,
	"./hk/en_hk/setting/faq/locale.json": 597,
	"./hk/en_hk/setting/general/link": 549,
	"./hk/en_hk/setting/general/link.json": 549,
	"./hk/en_hk/setting/general/locale": 541,
	"./hk/en_hk/setting/general/locale.json": 541,
	"./hk/en_hk/setting/general/media": 598,
	"./hk/en_hk/setting/general/media.json": 598,
	"./hk/en_hk/setting/general/setting": 550,
	"./hk/en_hk/setting/general/setting.json": 550,
	"./hk/en_hk/setting/index/locale": 551,
	"./hk/en_hk/setting/index/locale.json": 551,
	"./hk/en_hk/setting/index/setting": 599,
	"./hk/en_hk/setting/index/setting.json": 599,
	"./hk/en_hk/setting/legal/locale": 600,
	"./hk/en_hk/setting/legal/locale.json": 600,
	"./hk/en_hk/setting/legal/setting": 601,
	"./hk/en_hk/setting/legal/setting.json": 601,
	"./hk/en_hk/setting/pricing/locale": 602,
	"./hk/en_hk/setting/pricing/locale.json": 602,
	"./hk/en_hk/setting/privacy/locale": 603,
	"./hk/en_hk/setting/privacy/locale.json": 603,
	"./hk/en_hk/setting/privacy/setting": 604,
	"./hk/en_hk/setting/privacy/setting.json": 604,
	"./hk/en_hk/setting/quoting/locale": 605,
	"./hk/en_hk/setting/quoting/locale.json": 605,
	"./hk/en_hk/setting/service/locale": 606,
	"./hk/en_hk/setting/service/locale.json": 606,
	"./hk/en_hk/setting/service/setting": 607,
	"./hk/en_hk/setting/service/setting.json": 607,
	"./hk/en_hk/setting/template_for_angular/locale": 608,
	"./hk/en_hk/setting/template_for_angular/locale.json": 608,
	"./hk/en_hk/setting/template_for_angular_no_header/locale": 609,
	"./hk/en_hk/setting/template_for_angular_no_header/locale.json": 609,
	"./hk/zh_cn/pages": 610,
	"./hk/zh_cn/pages.json": 610,
	"./hk/zh_cn/setting/mobile/pricing/locale": 611,
	"./hk/zh_cn/setting/mobile/pricing/locale.json": 611,
	"./hk/zh_cn/setting/mobile/pricing/setting": 612,
	"./hk/zh_cn/setting/mobile/pricing/setting.json": 612,
	"./hk/zh_hk/pages": 613,
	"./hk/zh_hk/pages.json": 613,
	"./hk/zh_hk/setting/404/locale": 614,
	"./hk/zh_hk/setting/404/locale.json": 614,
	"./hk/zh_hk/setting/about/locale": 615,
	"./hk/zh_hk/setting/about/locale.json": 615,
	"./hk/zh_hk/setting/business/locale": 616,
	"./hk/zh_hk/setting/business/locale.json": 616,
	"./hk/zh_hk/setting/business_services_registration/locale": 617,
	"./hk/zh_hk/setting/business_services_registration/locale.json": 617,
	"./hk/zh_hk/setting/contact/locale": 618,
	"./hk/zh_hk/setting/contact/locale.json": 618,
	"./hk/zh_hk/setting/faq/locale": 619,
	"./hk/zh_hk/setting/faq/locale.json": 619,
	"./hk/zh_hk/setting/general/link": 552,
	"./hk/zh_hk/setting/general/link.json": 552,
	"./hk/zh_hk/setting/general/locale": 542,
	"./hk/zh_hk/setting/general/locale.json": 542,
	"./hk/zh_hk/setting/general/setting": 553,
	"./hk/zh_hk/setting/general/setting.json": 553,
	"./hk/zh_hk/setting/index/locale": 554,
	"./hk/zh_hk/setting/index/locale.json": 554,
	"./hk/zh_hk/setting/index/setting": 620,
	"./hk/zh_hk/setting/index/setting.json": 620,
	"./hk/zh_hk/setting/legal/locale": 621,
	"./hk/zh_hk/setting/legal/locale.json": 621,
	"./hk/zh_hk/setting/legal/setting": 622,
	"./hk/zh_hk/setting/legal/setting.json": 622,
	"./hk/zh_hk/setting/mobile/pricing/locale": 623,
	"./hk/zh_hk/setting/mobile/pricing/locale.json": 623,
	"./hk/zh_hk/setting/mobile/pricing/setting": 624,
	"./hk/zh_hk/setting/mobile/pricing/setting.json": 624,
	"./hk/zh_hk/setting/password/locale": 625,
	"./hk/zh_hk/setting/password/locale.json": 625,
	"./hk/zh_hk/setting/pricing/locale": 626,
	"./hk/zh_hk/setting/pricing/locale.json": 626,
	"./hk/zh_hk/setting/pricing/setting": 627,
	"./hk/zh_hk/setting/pricing/setting.json": 627,
	"./hk/zh_hk/setting/privacy/locale": 628,
	"./hk/zh_hk/setting/privacy/locale.json": 628,
	"./hk/zh_hk/setting/privacy/setting": 629,
	"./hk/zh_hk/setting/privacy/setting.json": 629,
	"./hk/zh_hk/setting/profile/locale": 630,
	"./hk/zh_hk/setting/profile/locale.json": 630,
	"./hk/zh_hk/setting/quoting/locale": 631,
	"./hk/zh_hk/setting/quoting/locale.json": 631,
	"./hk/zh_hk/setting/service/locale": 632,
	"./hk/zh_hk/setting/service/locale.json": 632,
	"./hk/zh_hk/setting/sitemap/setting": 633,
	"./hk/zh_hk/setting/sitemap/setting.json": 633,
	"./hk/zh_hk/setting/template_for_angular/locale": 634,
	"./hk/zh_hk/setting/template_for_angular/locale.json": 634,
	"./hk/zh_hk/setting/template_for_angular_no_header/locale": 635,
	"./hk/zh_hk/setting/template_for_angular_no_header/locale.json": 635,
	"./in/pages": 636,
	"./in/pages.json": 636,
	"./in/setting/about/locale": 637,
	"./in/setting/about/locale.json": 637,
	"./in/setting/about/setting": 638,
	"./in/setting/about/setting.json": 638,
	"./in/setting/business/locale": 639,
	"./in/setting/business/locale.json": 639,
	"./in/setting/business/setting": 640,
	"./in/setting/business/setting.json": 640,
	"./in/setting/contact/locale": 641,
	"./in/setting/contact/locale.json": 641,
	"./in/setting/contact/setting": 642,
	"./in/setting/contact/setting.json": 642,
	"./in/setting/faq/locale": 643,
	"./in/setting/faq/locale.json": 643,
	"./in/setting/general/link": 555,
	"./in/setting/general/link.json": 555,
	"./in/setting/general/locale": 543,
	"./in/setting/general/locale.json": 543,
	"./in/setting/general/media": 644,
	"./in/setting/general/media.json": 644,
	"./in/setting/general/setting": 556,
	"./in/setting/general/setting.json": 556,
	"./in/setting/index/locale": 557,
	"./in/setting/index/locale.json": 557,
	"./in/setting/index/media": 645,
	"./in/setting/index/media.json": 645,
	"./in/setting/index/setting": 646,
	"./in/setting/index/setting.json": 646,
	"./in/setting/legal/locale": 647,
	"./in/setting/legal/locale.json": 647,
	"./in/setting/legal/setting": 648,
	"./in/setting/legal/setting.json": 648,
	"./in/setting/order/locale": 649,
	"./in/setting/order/locale.json": 649,
	"./in/setting/order/setting": 650,
	"./in/setting/order/setting.json": 650,
	"./in/setting/pricing/locale": 651,
	"./in/setting/pricing/locale.json": 651,
	"./in/setting/pricing/media": 652,
	"./in/setting/pricing/media.json": 652,
	"./in/setting/pricing/setting": 653,
	"./in/setting/pricing/setting.json": 653,
	"./in/setting/privacy/locale": 654,
	"./in/setting/privacy/locale.json": 654,
	"./in/setting/privacy/setting": 655,
	"./in/setting/privacy/setting.json": 655,
	"./in/setting/quoting/locale": 656,
	"./in/setting/quoting/locale.json": 656,
	"./in/setting/quoting/media": 657,
	"./in/setting/quoting/media.json": 657,
	"./in/setting/quoting/setting": 658,
	"./in/setting/quoting/setting.json": 658,
	"./in/setting/service/locale": 659,
	"./in/setting/service/locale.json": 659,
	"./in/setting/service/media": 660,
	"./in/setting/service/media.json": 660,
	"./in/setting/service/setting": 661,
	"./in/setting/service/setting.json": 661,
	"./in/setting/sitemap/setting": 662,
	"./in/setting/sitemap/setting.json": 662,
	"./in/setting/tc_consumer/locale": 663,
	"./in/setting/tc_consumer/locale.json": 663,
	"./in/setting/tc_consumer/setting": 664,
	"./in/setting/tc_consumer/setting.json": 664,
	"./kr/pages": 665,
	"./kr/pages.json": 665,
	"./kr/setting/404/locale": 666,
	"./kr/setting/404/locale.json": 666,
	"./kr/setting/about/locale": 667,
	"./kr/setting/about/locale.json": 667,
	"./kr/setting/about/setting": 668,
	"./kr/setting/about/setting.json": 668,
	"./kr/setting/business/locale": 669,
	"./kr/setting/business/locale.json": 669,
	"./kr/setting/business/setting": 670,
	"./kr/setting/business/setting.json": 670,
	"./kr/setting/contact/locale": 671,
	"./kr/setting/contact/locale.json": 671,
	"./kr/setting/contact/setting": 672,
	"./kr/setting/contact/setting.json": 672,
	"./kr/setting/faq/locale": 673,
	"./kr/setting/faq/locale.json": 673,
	"./kr/setting/general/link": 558,
	"./kr/setting/general/link.json": 558,
	"./kr/setting/general/locale": 544,
	"./kr/setting/general/locale.json": 544,
	"./kr/setting/general/media": 674,
	"./kr/setting/general/media.json": 674,
	"./kr/setting/general/setting": 559,
	"./kr/setting/general/setting.json": 559,
	"./kr/setting/index/locale": 560,
	"./kr/setting/index/locale.json": 560,
	"./kr/setting/index/media": 675,
	"./kr/setting/index/media.json": 675,
	"./kr/setting/index/setting": 676,
	"./kr/setting/index/setting.json": 676,
	"./kr/setting/legal/locale": 677,
	"./kr/setting/legal/locale.json": 677,
	"./kr/setting/legal/setting": 678,
	"./kr/setting/legal/setting.json": 678,
	"./kr/setting/order/locale": 679,
	"./kr/setting/order/locale.json": 679,
	"./kr/setting/password/locale": 680,
	"./kr/setting/password/locale.json": 680,
	"./kr/setting/pricing/locale": 681,
	"./kr/setting/pricing/locale.json": 681,
	"./kr/setting/pricing/setting": 682,
	"./kr/setting/pricing/setting.json": 682,
	"./kr/setting/quoting/locale": 683,
	"./kr/setting/quoting/locale.json": 683,
	"./kr/setting/quoting/media": 684,
	"./kr/setting/quoting/media.json": 684,
	"./kr/setting/quoting/setting": 685,
	"./kr/setting/quoting/setting.json": 685,
	"./kr/setting/service/locale": 686,
	"./kr/setting/service/locale.json": 686,
	"./kr/setting/service/media": 687,
	"./kr/setting/service/media.json": 687,
	"./kr/setting/service/setting": 688,
	"./kr/setting/service/setting.json": 688,
	"./kr/setting/tc_consumer/locale": 689,
	"./kr/setting/tc_consumer/locale.json": 689,
	"./kr/setting/tc_consumer/setting": 690,
	"./kr/setting/tc_consumer/setting.json": 690,
	"./kr/setting/tc_location/locale": 691,
	"./kr/setting/tc_location/locale.json": 691,
	"./kr/setting/tc_location/setting": 692,
	"./kr/setting/tc_location/setting.json": 692,
	"./sg/pages": 693,
	"./sg/pages.json": 693,
	"./sg/setting/about/locale": 694,
	"./sg/setting/about/locale.json": 694,
	"./sg/setting/about/setting": 695,
	"./sg/setting/about/setting.json": 695,
	"./sg/setting/business/locale": 696,
	"./sg/setting/business/locale.json": 696,
	"./sg/setting/business/media": 697,
	"./sg/setting/business/media.json": 697,
	"./sg/setting/business/setting": 698,
	"./sg/setting/business/setting.json": 698,
	"./sg/setting/contact/locale": 699,
	"./sg/setting/contact/locale.json": 699,
	"./sg/setting/contact/setting": 700,
	"./sg/setting/contact/setting.json": 700,
	"./sg/setting/faq/locale": 701,
	"./sg/setting/faq/locale.json": 701,
	"./sg/setting/faq/setting": 702,
	"./sg/setting/faq/setting.json": 702,
	"./sg/setting/general/link": 561,
	"./sg/setting/general/link.json": 561,
	"./sg/setting/general/locale": 545,
	"./sg/setting/general/locale.json": 545,
	"./sg/setting/general/media": 703,
	"./sg/setting/general/media.json": 703,
	"./sg/setting/general/setting": 562,
	"./sg/setting/general/setting.json": 562,
	"./sg/setting/index/locale": 563,
	"./sg/setting/index/locale.json": 563,
	"./sg/setting/index/media": 704,
	"./sg/setting/index/media.json": 704,
	"./sg/setting/index/setting": 705,
	"./sg/setting/index/setting.json": 705,
	"./sg/setting/legal/locale": 706,
	"./sg/setting/legal/locale.json": 706,
	"./sg/setting/legal/setting": 707,
	"./sg/setting/legal/setting.json": 707,
	"./sg/setting/pricing/locale": 708,
	"./sg/setting/pricing/locale.json": 708,
	"./sg/setting/pricing/media": 709,
	"./sg/setting/pricing/media.json": 709,
	"./sg/setting/pricing/setting": 710,
	"./sg/setting/pricing/setting.json": 710,
	"./sg/setting/privacy/locale": 711,
	"./sg/setting/privacy/locale.json": 711,
	"./sg/setting/privacy/setting": 712,
	"./sg/setting/privacy/setting.json": 712,
	"./sg/setting/quoting/locale": 713,
	"./sg/setting/quoting/locale.json": 713,
	"./sg/setting/quoting/media": 714,
	"./sg/setting/quoting/media.json": 714,
	"./sg/setting/quoting/setting": 715,
	"./sg/setting/quoting/setting.json": 715,
	"./sg/setting/service/locale": 716,
	"./sg/setting/service/locale.json": 716,
	"./sg/setting/service/media": 717,
	"./sg/setting/service/media.json": 717,
	"./sg/setting/service/setting": 718,
	"./sg/setting/service/setting.json": 718,
	"./sg/setting/sitemap/setting": 719,
	"./sg/setting/sitemap/setting.json": 719,
	"./sg/setting/tc_consumer/locale": 720,
	"./sg/setting/tc_consumer/locale.json": 720,
	"./sg/setting/tc_consumer/setting": 721,
	"./sg/setting/tc_consumer/setting.json": 721,
	"./sg/setting/template_for_angular/locale": 722,
	"./sg/setting/template_for_angular/locale.json": 722,
	"./sg/setting/template_for_angular/setting": 723,
	"./sg/setting/template_for_angular/setting.json": 723,
	"./sg/setting/template_for_angular_no_header/locale": 724,
	"./sg/setting/template_for_angular_no_header/locale.json": 724,
	"./tw/pages": 725,
	"./tw/pages.json": 725,
	"./tw/setting/404/locale": 726,
	"./tw/setting/404/locale.json": 726,
	"./tw/setting/about/locale": 727,
	"./tw/setting/about/locale.json": 727,
	"./tw/setting/about/setting": 728,
	"./tw/setting/about/setting.json": 728,
	"./tw/setting/business/locale": 729,
	"./tw/setting/business/locale.json": 729,
	"./tw/setting/business/setting": 730,
	"./tw/setting/business/setting.json": 730,
	"./tw/setting/contact/locale": 731,
	"./tw/setting/contact/locale.json": 731,
	"./tw/setting/contact/setting": 732,
	"./tw/setting/contact/setting.json": 732,
	"./tw/setting/faq/locale": 733,
	"./tw/setting/faq/locale.json": 733,
	"./tw/setting/general/link": 564,
	"./tw/setting/general/link.json": 564,
	"./tw/setting/general/locale": 546,
	"./tw/setting/general/locale.json": 546,
	"./tw/setting/general/media": 734,
	"./tw/setting/general/media.json": 734,
	"./tw/setting/general/setting": 565,
	"./tw/setting/general/setting.json": 565,
	"./tw/setting/index/locale": 566,
	"./tw/setting/index/locale.json": 566,
	"./tw/setting/index/media": 735,
	"./tw/setting/index/media.json": 735,
	"./tw/setting/index/setting": 736,
	"./tw/setting/index/setting.json": 736,
	"./tw/setting/legal/locale": 737,
	"./tw/setting/legal/locale.json": 737,
	"./tw/setting/legal/setting": 738,
	"./tw/setting/legal/setting.json": 738,
	"./tw/setting/mobile/pricing/locale": 739,
	"./tw/setting/mobile/pricing/locale.json": 739,
	"./tw/setting/password/locale": 740,
	"./tw/setting/password/locale.json": 740,
	"./tw/setting/pricing/link": 741,
	"./tw/setting/pricing/link.json": 741,
	"./tw/setting/pricing/locale": 742,
	"./tw/setting/pricing/locale.json": 742,
	"./tw/setting/pricing/media": 743,
	"./tw/setting/pricing/media.json": 743,
	"./tw/setting/pricing/setting": 744,
	"./tw/setting/pricing/setting.json": 744,
	"./tw/setting/privacy/locale": 745,
	"./tw/setting/privacy/locale.json": 745,
	"./tw/setting/privacy/setting": 746,
	"./tw/setting/privacy/setting.json": 746,
	"./tw/setting/quoting/locale": 747,
	"./tw/setting/quoting/locale.json": 747,
	"./tw/setting/quoting/media": 748,
	"./tw/setting/quoting/media.json": 748,
	"./tw/setting/quoting/setting": 749,
	"./tw/setting/quoting/setting.json": 749,
	"./tw/setting/service/locale": 750,
	"./tw/setting/service/locale.json": 750,
	"./tw/setting/service/media": 751,
	"./tw/setting/service/media.json": 751,
	"./tw/setting/service/setting": 752,
	"./tw/setting/service/setting.json": 752,
	"./tw/setting/sitemap/setting": 753,
	"./tw/setting/sitemap/setting.json": 753,
	"./tw/setting/template_for_angular/locale": 754,
	"./tw/setting/template_for_angular/locale.json": 754,
	"./tw/setting/template_for_angular_no_header/locale": 755,
	"./tw/setting/template_for_angular_no_header/locale.json": 755
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(30)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FacebookLogin=t(require("react")):e.FacebookLogin=t(e.react)}(this,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(4)},function(e,t,o){e.exports=o(6)()},function(t,o){t.exports=e},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e,t){return decodeURIComponent(e.replace(new RegExp("^(?:.*[&\\?]"+encodeURIComponent(t).replace(/[\.\+\*]/g,"\\$&")+"(?:\\=([^&]*))?)?.*$","i"),"$1"))}},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(2),d=n(u),l=o(1),p=n(l),f=o(5),b=n(f),y=o(3),h=n(y),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i))}catch(t){}return e},k=function(e){function t(){var e,o,n,s;r(this,t);for(var c=arguments.length,u=Array(c),d=0;d<c;d++)u[d]=arguments[d];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){a(t,e),n.props.callback(t)})},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status})},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0)},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,s=t.returnScopes,a=t.responseType,c=t.redirectUri,u=t.disableMobileRedirect,d=t.authType,l=t.state;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var p={client_id:r,redirect_uri:c,state:l,return_scopes:s,scope:o,response_type:a,auth_type:d};if(n.props.isMobile&&!u)window.location.href="https://www.facebook.com/dialog/oauth"+(0,b["default"])(p);else{if(!window.FB)return void(n.props.onFailure&&n.props.onFailure({status:"facebookNotLoaded"}));window.FB.login(n.checkLoginState,{scope:o,return_scopes:s,auth_type:p.auth_type})}}}},s=o,i(n,s)}return s(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e))}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh)}},{key:"componentWillUnmount",value:function(){this._isMounted=!1}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e)}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,s=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(s||e.isRedirectedFromFb())&&window.FB.getLoginStatus(e.checkLoginAfterRefresh)}}},{key:"isRedirectedFromFb",value:function(){var e=window.location.search;return(0,h["default"])(e,"code")||(0,h["default"])(e,"granted_scopes")}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0})}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,s=r;t.getElementById(n)||(s=t.createElement(o),s.id=n,s.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(s,i))}(document,"script","facebook-jssdk")}},{key:"render",value:function o(){var o=this.props.render;if(!o)throw new Error("ReactFacebookLogin requires a render prop to render");var e={onClick:this.click,isDisabled:!!this.props.isDisabled,isProcessing:this.state.isProcessing,isSdkLoaded:this.state.isSdkLoaded};return this.props.render(e)}}]),t}(d["default"].Component);k.propTypes={isDisabled:p["default"].bool,callback:p["default"].func.isRequired,appId:p["default"].string.isRequired,xfbml:p["default"].bool,cookie:p["default"].bool,authType:p["default"].string,scope:p["default"].string,state:p["default"].string,responseType:p["default"].string,returnScopes:p["default"].bool,redirectUri:p["default"].string,autoLoad:p["default"].bool,disableMobileRedirect:p["default"].bool,isMobile:p["default"].bool,fields:p["default"].string,version:p["default"].string,language:p["default"].string,onClick:p["default"].func,onFailure:p["default"].func,render:p["default"].func.isRequired},k.defaultProps={redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,authType:"",fields:"name",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),onFailure:null,state:"facebookdirect",responseType:"code"},t["default"]=k},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return"?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")}},function(e,t,o){"use strict";function n(){}var r=o(7);e.exports=function(){function e(e,t,o,n,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o}},function(e,t){"use strict";var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o}])});

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(886);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(890)();
}


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(151);
var invariant = __webpack_require__(108);
var ReactPropTypesSecret = __webpack_require__(891);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(894);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/setting.json": 466,
	"./hk/en_hk/setting/general/setting.json": 550,
	"./hk/zh_hk/setting/general/setting.json": 553,
	"./in/setting/general/setting.json": 556,
	"./kr/setting/general/setting.json": 559,
	"./sg/setting/general/setting.json": 562,
	"./tw/setting/general/setting.json": 565
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a812038b.png";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba1673a6.png";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(899);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./footer.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./footer.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._31BJH{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._1w3UC>span>a{cursor:unset;color:#0088bf!important}._1w3UC>span>a:hover{color:#0088bf;-webkit-filter:brightness(110%)}._3FMyZ{color:#4a4a4a}._3PgcV>*{text-align:left}@media only screen and (max-width:768px){._2TNHs{width:100%;max-width:100%}._3Nop6{display:none!important}}@media only screen and (min-width:768px){._2TNHs{width:100%;max-width:100%}._1dgJ_{display:none!important}}", ""]);

// exports
exports.locals = {
	"fixedContainer": "_31BJH",
	"childLink": "_1w3UC",
	"footerCopyright": "_3FMyZ",
	"childRight": "_3PgcV",
	"col3": "_2TNHs",
	"hideMobile": "_3Nop6",
	"showMobile": "_1dgJ_"
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/index/locale.json": 471,
	"./hk/en_hk/setting/index/locale.json": 551,
	"./hk/zh_hk/setting/index/locale.json": 554,
	"./in/setting/index/locale.json": 557,
	"./kr/setting/index/locale.json": 560,
	"./sg/setting/index/locale.json": 563,
	"./tw/setting/index/locale.json": 566
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;

/***/ }),
/* 901 */,
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(963);
var react_1 = tslib_1.__importDefault(__webpack_require__(30));
var TransitionGroup_1 = tslib_1.__importDefault(__webpack_require__(964));
var SlideDownContent = (function (_super) {
    tslib_1.__extends(SlideDownContent, _super);
    function SlideDownContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRef = function (element) {
            _this.element = element;
            _this.callbacks = [];
        };
        _this.handleTransitionEnd = function (evt) {
            if ((evt.target === _this.element) && (evt.propertyName === 'height')) {
                var callback = _this.callbacks.shift();
                callback && callback();
                if (_this.callbacks.length === 0) {
                    _this.element.classList.remove('transitioning');
                    _this.element.style.transitionProperty = 'none';
                    _this.element.style.height = _this.props.closed ? '0px' : 'auto';
                    if (_this.props.closed)
                        _this.element.classList.add('closed');
                }
            }
        };
        return _this;
    }
    SlideDownContent.prototype.componentDidMount = function () {
        if (this.props.closed)
            this.element.classList.add('closed');
    };
    SlideDownContent.prototype.componentWillAppear = function (callback) {
        if (this.props.transitionOnAppear) {
            this.callbacks.push(callback);
            this.startTransition('0px');
        }
        else {
            this.element.style.height = this.props.closed ? '0px' : 'auto';
            callback();
        }
    };
    SlideDownContent.prototype.componentWillEnter = function (callback) {
        this.callbacks.push(callback);
        var prevHeight = this.element.getBoundingClientRect().height + 'px';
        this.startTransition(prevHeight);
    };
    SlideDownContent.prototype.componentWillLeave = function (callback) {
        this.callbacks.push(callback);
        this.element.classList.add('transitioning');
        this.element.style.height = getComputedStyle(this.element).height;
        this.element.offsetHeight;
        this.element.style.transitionProperty = 'height';
        this.element.style.height = '0px';
    };
    SlideDownContent.prototype.componentWillUpdate = function () {
        if (this.callbacks.length === 0) {
            this.element.style.height = this.element.getBoundingClientRect().height + 'px';
        }
    };
    SlideDownContent.prototype.componentDidUpdate = function () {
        var callback = this.callbacks.shift();
        callback && callback();
        if (this.callbacks.length === 0) {
            var prevHeight = getComputedStyle(this.element).height;
            this.startTransition(prevHeight);
        }
    };
    SlideDownContent.prototype.startTransition = function (prevHeight) {
        var endHeight = '0px';
        if (!this.props.closed) {
            this.element.classList.remove('closed');
            this.element.style.height = 'auto';
            endHeight = getComputedStyle(this.element).height;
        }
        if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
            this.element.classList.add('transitioning');
            this.element.style.height = prevHeight;
            this.element.offsetHeight;
            this.element.style.transitionProperty = 'height';
            this.element.style.height = endHeight;
        }
    };
    SlideDownContent.prototype.render = function () {
        var className = this.props.className ?
            'react-slidedown ' + this.props.className : 'react-slidedown';
        return (react_1.default.createElement("div", { className: className, ref: this.handleRef, onTransitionEnd: this.handleTransitionEnd }, this.props.children));
    };
    SlideDownContent.defaultProps = {
        transitionOnAppear: true,
        closed: false
    };
    return SlideDownContent;
}(react_1.default.Component));
function SlideDownWrapper(props) {
    var childrenArray = react_1.default.Children.toArray(props.children);
    return childrenArray[0] || null;
}
function SlideDown(props) {
    var children = props.children, attrs = tslib_1.__rest(props, ["children"]);
    var hasContent = (children && react_1.default.Children.count(children) !== 0);
    return (react_1.default.createElement(TransitionGroup_1.default, { component: SlideDownWrapper }, hasContent && react_1.default.createElement(SlideDownContent, tslib_1.__assign({ key: 'content' }, attrs), children)));
}
exports.SlideDown = SlideDown;
//# sourceMappingURL=slidedown.js.map

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocationPrice */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocationSuggestion;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLocationSuggestionDetail;
/* harmony export (immutable) */ __webpack_exports__["c"] = getStaticMapUrl;
/* unused harmony export UTMKToLatlng */
/* harmony export (immutable) */ __webpack_exports__["d"] = latlngToUTMK;
/* unused harmony export geocodeCallback */
/* unused harmony export getAddrByParseGeocodewithFetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFetch__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(453);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable import/prefer-default-export */


var staticGoogleMapKey = "AIzaSyDv9PDY8W1vG_4SNlyiD2fMTLCHK1tEUoY";
/**
 * Get price by location
 * @param  {Object} data
 * @param  {String} data.nickname
 * @param  {String} data.phone_number
 * @param  {Object} data.order_request_detail_attributes
 * @param  {String} data.service_type
 * @param  {String} data.vehicle
 * @param  {String} data.address1
 * @param  {String} data.address2
 */

function getLocationPrice(_x, _x2) {
  return _getLocationPrice.apply(this, arguments);
}
/**
 * Get suggestion by location
 * @param  {String} data
 */

function _getLocationPrice() {
  _getLocationPrice = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(data, locale) {
    var url, json, Options, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/api/w1/utils/price_breakdown.json';
            json = {
              order: {
                nickname: data.nickname,
                phone_number: data.phone_number,
                order_request_detail_attributes: data.order_request_detail_attributes,
                pickup_time: Object(__WEBPACK_IMPORTED_MODULE_1__service_util__["b" /* dateToISO8601String */])(data.pickup_time),
                service_type: data.service_type,
                vehicle: data.vehicle,
                waypoints_attributes: [data.address1, data.address2],
                goods: data.goods
              }
            };
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context.prev = 4;
            _context.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 7:
            return _context.abrupt("return", _context.sent);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", console.warn(_context.t0));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 10]]);
  }));
  return _getLocationPrice.apply(this, arguments);
}

function getLocationSuggestion(_x3, _x4, _x5) {
  return _getLocationSuggestion.apply(this, arguments);
}
/**
 * Get suggestion detail by location
 * e.g. lat, lng, address, placeid
 * @param  {String} data
 */

function _getLocationSuggestion() {
  _getLocationSuggestion = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(data, locale, sessionToken) {
    var json, url, Options, options;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            json = "?input=".concat(data, "&sessiontoken=").concat(sessionToken);
            url = "/api/v1/places/autocomplete.json".concat(json);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context2.prev = 4;
            _context2.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            return _context2.abrupt("return", console.warn(_context2.t0));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[4, 10]]);
  }));
  return _getLocationSuggestion.apply(this, arguments);
}

function getLocationSuggestionDetail(_x6, _x7, _x8) {
  return _getLocationSuggestionDetail.apply(this, arguments);
}
/**
 * Get Static Map Url
 * @param  {Object} locations
 * @param  {number} zoom
 * @param  {Object} size
 * @return {String}
 */

function _getLocationSuggestionDetail() {
  _getLocationSuggestionDetail = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(data, locale, sessionToken) {
    var json, url, Options, options;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            json = "?placeid=".concat(data, "&sessiontoken=").concat(sessionToken);
            url = "/api/v1/places/details.json".concat(json);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context3.prev = 4;
            _context3.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](4);
            return _context3.abrupt("return", console.warn(_context3.t0));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[4, 10]]);
  }));
  return _getLocationSuggestionDetail.apply(this, arguments);
}

function getStaticMapUrl(locations, zoom, size) {
  var nSize = {};

  if (size === null) {
    nSize = {
      width: 620,
      height: 380
    };
  } else {
    nSize = size;
  }

  var url = "https://maps.googleapis.com/maps/api/staticmap?size=".concat(nSize.width, "x").concat(nSize.height, "&sensor=true&zoom=").concat(zoom);

  for (var i = 0; i < locations.length; i += 1) {
    // prevent page to break when there is no location object
    if (!locations[i].location) return '';
    url = url.concat("&markers=icon:http://www.gogovan.com.hk/img/map_marker_".concat(i + 1, ".png%7C").concat(locations[i].location.lat, ",").concat(locations[i].location.lon));
  }

  url = url.concat("&scale=1.100000023841858&key=".concat(staticGoogleMapKey));
  return url;
} // olleh map

/** convert UTMK to Lat Lng
 * @param {Object} data
 * @param {Number} data.x
 * @param {Number} data.y
 */

function UTMKToLatlng(data) {
  return new window.olleh.maps.LatLng.valueOf(new window.olleh.maps.UTMK(data));
}
/** convert lat lng to UTMK
 * @param {Object} data
 * @param {Number} data.lat
 * @param {Number} data.lng
 */

function latlngToUTMK(data) {
  if (Object.prototype.hasOwnProperty.call(data, 'lat') && Object.prototype.hasOwnProperty.call(data, 'lon')) {
    var d = new window.olleh.maps.LatLng(data.lat, data.lon);
    return window.olleh.maps.UTMK.valueOf(d);
  }

  return window.olleh.maps.UTMK.valueOf(new window.olleh.maps.LatLng(data));
} // References
// http://14.63.244.28/DevSiteHtmlRenewal/innerDevelopment/download/javascript_v3_spatial/references.html#olleh.maps.Geocoder

function geocodeCallback(data) {
  var geocoder = new window.olleh.maps.Geocoder();
  var geocoderResult = geocoder.parseGeocode(data); // const str_result = '';

  if (geocoderResult.count !== '0') {
    var infoArr = geocoderResult.infoarr;
    console.warn(infoArr);

    for (var i = 0; i < infoArr.length; i += 1) {
      console.warn(infoArr[i]);
    }
  }
}
function getAddrByParseGeocodewithFetch(_x9) {
  return _getAddrByParseGeocodewithFetch.apply(this, arguments);
}

function _getAddrByParseGeocodewithFetch() {
  _getAddrByParseGeocodewithFetch = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(position) {
    var baseUrl, geoOptions, options;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            baseUrl = 'https://api.ollehmap.com:10083/giop/rest/geocode/Rgeocode.json?';
            geoOptions = {
              key: "",
              x: position.x,
              y: position.y,
              type: 1,
              addrcdtype: 1,
              isJibun: 1,
              reqtype: 1,
              newAddr: 0,
              isMPoi: 0
            };
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            Object.keys(geoOptions).forEach(function (k) {
              baseUrl = baseUrl.concat("".concat(k, "=").concat(geoOptions[k], "&"));
            });
            _context4.prev = 4;
            _context4.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])({})(baseUrl, options);

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](4);
            return _context4.abrupt("return", console.warn(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[4, 10]]);
  }));
  return _getAddrByParseGeocodewithFetch.apply(this, arguments);
}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b458d439.png";

/***/ }),
/* 905 */,
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ccee92e.png";

/***/ }),
/* 907 */,
/* 908 */,
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_5ton_blue.png": 1720,
	"./icon_5ton_blue@2x.png": 1222,
	"./icon_5ton_white.png": 1721,
	"./icon_5ton_white@2x.png": 1223,
	"./icon_9ton_blue.png": 1722,
	"./icon_9ton_blue@2x.png": 1224,
	"./icon_9ton_white.png": 1723,
	"./icon_9ton_white@2x.png": 1225,
	"./icon_add.png": 1226,
	"./icon_add@2x.png": 976,
	"./icon_add_disabled.png": 1724,
	"./icon_add_disabled@2x.png": 1227,
	"./icon_add_hover.png": 1228,
	"./icon_add_hover@2x.png": 977,
	"./icon_avatar.png": 569,
	"./icon_avatar@2x.png": 568,
	"./icon_avator40x40.png": 765,
	"./icon_avator40x40@2x.png": 764,
	"./icon_avator70x70.png": 1725,
	"./icon_avator70x70@2x.png": 1229,
	"./icon_birthday.png": 1726,
	"./icon_birthday@2x.png": 1230,
	"./icon_borrowcart_inactive.png": 1727,
	"./icon_borrowcart_inactive@2x.png": 1231,
	"./icon_calendar.png": 927,
	"./icon_calendar@2x.png": 918,
	"./icon_calendar_solidblue.png": 1728,
	"./icon_calendar_solidblue@2x.png": 1232,
	"./icon_camera.png": 1729,
	"./icon_camera@2x.png": 1233,
	"./icon_camera_disabled.png": 1730,
	"./icon_camera_disabled@2x.png": 1234,
	"./icon_camera_hover.png": 1731,
	"./icon_camera_hover@2x.png": 1235,
	"./icon_clear_2.png": 926,
	"./icon_clear_2@2x.png": 917,
	"./icon_clear_b.png": 1732,
	"./icon_clear_b@2x.png": 1236,
	"./icon_clock.png": 1733,
	"./icon_clock@2x.png": 1237,
	"./icon_clock_small.png": 1734,
	"./icon_clock_small@2x.png": 1238,
	"./icon_constructionwaste_inactive.png": 1735,
	"./icon_constructionwaste_inactive@2x.png": 1239,
	"./icon_courier.png": 1736,
	"./icon_courier@2x.png": 1240,
	"./icon_courier_w.png": 1737,
	"./icon_courier_w@2x.png": 1241,
	"./icon_cross_r.png": 1242,
	"./icon_cross_r@2x.png": 978,
	"./icon_deliveryservice.png": 1738,
	"./icon_deliveryservice@2x.png": 1243,
	"./icon_destination_pin_1.png": 1739,
	"./icon_destination_pin_2.png": 1740,
	"./icon_destination_pin_3.png": 1741,
	"./icon_destination_pin_4.png": 1742,
	"./icon_destination_pin_5.png": 1743,
	"./icon_destination_pin_6.png": 1744,
	"./icon_destination_pin_7.png": 1745,
	"./icon_destination_pin_8.png": 1746,
	"./icon_destination_pin_9.png": 1747,
	"./icon_done.png": 1748,
	"./icon_done@2x.png": 1244,
	"./icon_dropdownarrow_grey.png": 773,
	"./icon_email.png": 1749,
	"./icon_email@2x.png": 1245,
	"./icon_english_inactive.png": 1750,
	"./icon_english_inactive@2x.png": 1246,
	"./icon_facebook.png": 1751,
	"./icon_facebook@2x.png": 1247,
	"./icon_feature1.png": 1752,
	"./icon_feature1@2x.png": 1248,
	"./icon_feature2.png": 1753,
	"./icon_feature2@2x.png": 1249,
	"./icon_feature3.png": 1754,
	"./icon_feature3@2x.png": 1250,
	"./icon_feature4.png": 1755,
	"./icon_feature4@2x.png": 1251,
	"./icon_feature5.png": 1756,
	"./icon_feature5@2x.png": 1252,
	"./icon_feature6.png": 1757,
	"./icon_feature6@2x.png": 1253,
	"./icon_from.png": 1219,
	"./icon_from@2x.png": 973,
	"./icon_gender.png": 1758,
	"./icon_gender@2x.png": 1254,
	"./icon_googleplus.png": 1759,
	"./icon_googleplus@2x.png": 1255,
	"./icon_home_address.png": 1256,
	"./icon_home_address@2x.png": 979,
	"./icon_hourlyrental_inactive.png": 1760,
	"./icon_hourlyrental_inactive@2x.png": 1257,
	"./icon_industry.png": 1761,
	"./icon_industry@2x.png": 1258,
	"./icon_instagram.png": 1762,
	"./icon_instagram@2x.png": 1259,
	"./icon_linkedin.png": 1763,
	"./icon_linkedin@2x.png": 1260,
	"./icon_loading_complete.png": 1019,
	"./icon_loading_complete@2x.png": 962,
	"./icon_loading_small.png": 906,
	"./icon_loading_small@2x.png": 904,
	"./icon_location_1.png": 1764,
	"./icon_location_1@2x.png": 1261,
	"./icon_location_2.png": 1765,
	"./icon_location_2@2x.png": 1262,
	"./icon_location_red.png": 1766,
	"./icon_location_red@2x.png": 1263,
	"./icon_locations_full.png": 1767,
	"./icon_locations_full@2x.png": 1264,
	"./icon_longergood_inactive.png": 1768,
	"./icon_longergood_inactive@2x.png": 1265,
	"./icon_mail.png": 575,
	"./icon_mail@2x.png": 572,
	"./icon_mid.png": 1220,
	"./icon_mid@2x.png": 974,
	"./icon_moving.png": 1769,
	"./icon_moving@2x.png": 1266,
	"./icon_moving_w.png": 1770,
	"./icon_moving_w@2x.png": 1267,
	"./icon_movingservice.png": 1771,
	"./icon_movingservice@2x.png": 1268,
	"./icon_movingservice_w.png": 1772,
	"./icon_movingservice_w@2x.png": 1269,
	"./icon_naver.png": 1773,
	"./icon_naver@2x.png": 1270,
	"./icon_newcar_inactive.png": 1774,
	"./icon_newcar_inactive@2x.png": 1271,
	"./icon_notification.png": 1775,
	"./icon_notification@2x.png": 1272,
	"./icon_ordering_hourly_clock.png": 1776,
	"./icon_ordering_hourly_clock@2x.png": 1273,
	"./icon_passengerservice.png": 1777,
	"./icon_passengerservice@2x.png": 1274,
	"./icon_passengervan.png": 1778,
	"./icon_passengervan@2x.png": 1275,
	"./icon_passengervan_w.png": 1779,
	"./icon_passengervan_w@2x.png": 1276,
	"./icon_password.png": 1780,
	"./icon_password@2x.png": 1277,
	"./icon_pets_inactive.png": 1781,
	"./icon_pets_inactive@2x.png": 1278,
	"./icon_phone.png": 567,
	"./icon_phone@2x.png": 540,
	"./icon_phone_white.png": 1782,
	"./icon_phone_white@2x.png": 1279,
	"./icon_phone_white_big.png": 1783,
	"./icon_phone_white_big@2x.png": 1280,
	"./icon_porterage_inactive.png": 1784,
	"./icon_porterage_inactive@2x.png": 1281,
	"./icon_question.png": 1282,
	"./icon_question@2x.png": 980,
	"./icon_question_hover.png": 1785,
	"./icon_question_hover@2x.png": 1283,
	"./icon_rate.png": 1786,
	"./icon_rate@2x.png": 1284,
	"./icon_rate_y.png": 1787,
	"./icon_rate_y@2x.png": 1285,
	"./icon_ridewithgood.png": 1788,
	"./icon_ridewithgood@2x.png": 1286,
	"./icon_ridewithgood_w.png": 1789,
	"./icon_ridewithgood_w@2x.png": 1287,
	"./icon_ridewithgoodsicon.png": 1790,
	"./icon_ridewithgoodsicon@2x.png": 1288,
	"./icon_ridewithgoodsicon_w.png": 1791,
	"./icon_selected.png": 1792,
	"./icon_selected@2x.png": 1289,
	"./icon_send_to.png": 1793,
	"./icon_send_to@2x.png": 1290,
	"./icon_ser_10ftlorry.png": 1794,
	"./icon_ser_10ftlorry@2x.png": 1291,
	"./icon_ser_14ftlorry.png": 1795,
	"./icon_ser_14ftlorry@2x.png": 1292,
	"./icon_ser_24ftlorry.png": 1796,
	"./icon_ser_24ftlorry@2x.png": 1293,
	"./icon_ser_bike.png": 1797,
	"./icon_ser_bike@2x.png": 1294,
	"./icon_ser_courier.png": 1798,
	"./icon_ser_courier@2x.png": 1295,
	"./icon_ser_delivery.png": 1799,
	"./icon_ser_delivery@2x.png": 1296,
	"./icon_ser_everythingelse.png": 1800,
	"./icon_ser_everythingelse@2x.png": 1297,
	"./icon_ser_moving.png": 1801,
	"./icon_ser_moving@2x.png": 1298,
	"./icon_ser_passenger.png": 1802,
	"./icon_ser_passenger@2x.png": 1299,
	"./icon_ser_smallfreight.png": 1803,
	"./icon_ser_smallfreight@2x.png": 1300,
	"./icon_ser_van.png": 1804,
	"./icon_ser_van@2x.png": 1301,
	"./icon_smallfreight.png": 1805,
	"./icon_smallfreight@2x.png": 1302,
	"./icon_smallfreight_w.png": 1806,
	"./icon_smallfreight_w@2x.png": 1303,
	"./icon_steps1.png": 1807,
	"./icon_steps1@2x.png": 1304,
	"./icon_steps1_activated.png": 1808,
	"./icon_steps1_activated@2x.png": 1305,
	"./icon_steps2.png": 1809,
	"./icon_steps2@2x.png": 1306,
	"./icon_steps2_activated.png": 1810,
	"./icon_steps2_activated@2x.png": 1307,
	"./icon_steps3.png": 1811,
	"./icon_steps3@2x.png": 1308,
	"./icon_steps3_activated.png": 1812,
	"./icon_steps3_activated@2x.png": 1309,
	"./icon_to.png": 1221,
	"./icon_to@2x.png": 975,
	"./icon_twitter.png": 1813,
	"./icon_twitter@2x.png": 1310,
	"./icon_van.png": 1814,
	"./icon_van@2x.png": 1311,
	"./icon_van_blue.png": 1815,
	"./icon_van_blue@2x.png": 1312,
	"./icon_van_white.png": 1816,
	"./icon_van_white@2x.png": 1313,
	"./icon_work_address.png": 1314,
	"./icon_work_address@2x.png": 981,
	"./icon_youtube.png": 1817,
	"./icon_youtube@2x.png": 1315
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_5ton_blue@2x.png": 1222,
	"./icon_5ton_white@2x.png": 1223,
	"./icon_9ton_blue@2x.png": 1224,
	"./icon_9ton_white@2x.png": 1225,
	"./icon_add@2x.png": 976,
	"./icon_add_disabled@2x.png": 1227,
	"./icon_add_hover@2x.png": 977,
	"./icon_avatar@2x.png": 568,
	"./icon_avator40x40@2x.png": 764,
	"./icon_avator70x70@2x.png": 1229,
	"./icon_birthday@2x.png": 1230,
	"./icon_borrowcart_inactive@2x.png": 1231,
	"./icon_calendar@2x.png": 918,
	"./icon_calendar_solidblue@2x.png": 1232,
	"./icon_camera@2x.png": 1233,
	"./icon_camera_disabled@2x.png": 1234,
	"./icon_camera_hover@2x.png": 1235,
	"./icon_clear_2@2x.png": 917,
	"./icon_clear_b@2x.png": 1236,
	"./icon_clock@2x.png": 1237,
	"./icon_clock_small@2x.png": 1238,
	"./icon_constructionwaste_inactive@2x.png": 1239,
	"./icon_courier@2x.png": 1240,
	"./icon_courier_w@2x.png": 1241,
	"./icon_cross_r@2x.png": 978,
	"./icon_deliveryservice@2x.png": 1243,
	"./icon_done@2x.png": 1244,
	"./icon_email@2x.png": 1245,
	"./icon_english_inactive@2x.png": 1246,
	"./icon_facebook@2x.png": 1247,
	"./icon_feature1@2x.png": 1248,
	"./icon_feature2@2x.png": 1249,
	"./icon_feature3@2x.png": 1250,
	"./icon_feature4@2x.png": 1251,
	"./icon_feature5@2x.png": 1252,
	"./icon_feature6@2x.png": 1253,
	"./icon_from@2x.png": 973,
	"./icon_gender@2x.png": 1254,
	"./icon_googleplus@2x.png": 1255,
	"./icon_home_address@2x.png": 979,
	"./icon_hourlyrental_inactive@2x.png": 1257,
	"./icon_industry@2x.png": 1258,
	"./icon_instagram@2x.png": 1259,
	"./icon_linkedin@2x.png": 1260,
	"./icon_loading_complete@2x.png": 962,
	"./icon_loading_small@2x.png": 904,
	"./icon_location_1@2x.png": 1261,
	"./icon_location_2@2x.png": 1262,
	"./icon_location_red@2x.png": 1263,
	"./icon_locations_full@2x.png": 1264,
	"./icon_longergood_inactive@2x.png": 1265,
	"./icon_mail@2x.png": 572,
	"./icon_mid@2x.png": 974,
	"./icon_moving@2x.png": 1266,
	"./icon_moving_w@2x.png": 1267,
	"./icon_movingservice@2x.png": 1268,
	"./icon_movingservice_w@2x.png": 1269,
	"./icon_naver@2x.png": 1270,
	"./icon_newcar_inactive@2x.png": 1271,
	"./icon_notification@2x.png": 1272,
	"./icon_ordering_hourly_clock@2x.png": 1273,
	"./icon_passengerservice@2x.png": 1274,
	"./icon_passengervan@2x.png": 1275,
	"./icon_passengervan_w@2x.png": 1276,
	"./icon_password@2x.png": 1277,
	"./icon_pets_inactive@2x.png": 1278,
	"./icon_phone@2x.png": 540,
	"./icon_phone_white@2x.png": 1279,
	"./icon_phone_white_big@2x.png": 1280,
	"./icon_porterage_inactive@2x.png": 1281,
	"./icon_question@2x.png": 980,
	"./icon_question_hover@2x.png": 1283,
	"./icon_rate@2x.png": 1284,
	"./icon_rate_y@2x.png": 1285,
	"./icon_ridewithgood@2x.png": 1286,
	"./icon_ridewithgood_w@2x.png": 1287,
	"./icon_ridewithgoodsicon@2x.png": 1288,
	"./icon_selected@2x.png": 1289,
	"./icon_send_to@2x.png": 1290,
	"./icon_ser_10ftlorry@2x.png": 1291,
	"./icon_ser_14ftlorry@2x.png": 1292,
	"./icon_ser_24ftlorry@2x.png": 1293,
	"./icon_ser_bike@2x.png": 1294,
	"./icon_ser_courier@2x.png": 1295,
	"./icon_ser_delivery@2x.png": 1296,
	"./icon_ser_everythingelse@2x.png": 1297,
	"./icon_ser_moving@2x.png": 1298,
	"./icon_ser_passenger@2x.png": 1299,
	"./icon_ser_smallfreight@2x.png": 1300,
	"./icon_ser_van@2x.png": 1301,
	"./icon_smallfreight@2x.png": 1302,
	"./icon_smallfreight_w@2x.png": 1303,
	"./icon_steps1@2x.png": 1304,
	"./icon_steps1_activated@2x.png": 1305,
	"./icon_steps2@2x.png": 1306,
	"./icon_steps2_activated@2x.png": 1307,
	"./icon_steps3@2x.png": 1308,
	"./icon_steps3_activated@2x.png": 1309,
	"./icon_to@2x.png": 975,
	"./icon_twitter@2x.png": 1310,
	"./icon_van@2x.png": 1311,
	"./icon_van_blue@2x.png": 1312,
	"./icon_van_white@2x.png": 1313,
	"./icon_work_address@2x.png": 981,
	"./icon_youtube@2x.png": 1315
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(30);
var factory = __webpack_require__(1826);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_order__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_map__ = __webpack_require__(903);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import







var StaticMapDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StaticMapDialog, _React$Component);

  function StaticMapDialog(props) {
    var _this;

    _classCallCheck(this, StaticMapDialog);

    _this = _possibleConstructorReturn(this, (StaticMapDialog.__proto__ || Object.getPrototypeOf(StaticMapDialog)).call(this, props));
    var locations = {
      locations: {
        location: props.location
      }
    };
    _this.state = {
      staticMapUrl: Object(__WEBPACK_IMPORTED_MODULE_9__api_map__["c" /* getStaticMapUrl */])(locations, 16, null)
    };
    return _this;
  }

  _createClass(StaticMapDialog, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location !== this.location) {
        var locations = [];
        locations.push({
          location: nextProps.location
        });
        this.setState({
          staticMapUrl: Object(__WEBPACK_IMPORTED_MODULE_9__api_map__["c" /* getStaticMapUrl */])(locations, 16, null)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Modal */], {
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this2.props.onClickShow();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.infoPopup, " ").concat(__WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass___default.a.staticMapInfo)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: function onClick() {
          _this2.props.onClickShow();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass___default.a.infoCloseRightButton)
      }), _jsx("img", {
        className: __WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass___default.a.staticMap,
        src: this.state.staticMapUrl,
        alt: "staticMap"
      }));
    }
  }]);

  return StaticMapDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    address: state.order.address
  };
};

var mapDispatch = {
  addOrderAddress: __WEBPACK_IMPORTED_MODULE_8__actions_order__["a" /* addOrderAddress */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__routes_order_Order_sass___default.a)(StaticMapDialog)));

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_sass__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dialog_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_dialog__ = __webpack_require__(467);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var _ref = _jsx("br", {});

var bonusPriceDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(bonusPriceDialog, _React$Component);

  function bonusPriceDialog(props) {
    var _this;

    _classCallCheck(this, bonusPriceDialog);

    _this = _possibleConstructorReturn(this, (bonusPriceDialog.__proto__ || Object.getPrototypeOf(bonusPriceDialog)).call(this, props));
    var langType = props.currentLocale.split('-')[0]; // en-SG

    var lang = props.currentLocale.split('-')[1].toLowerCase();

    if (lang === 'hk') {
      langType = "".concat(langType, "-").concat(lang);
    } else {
      langType = lang;
    }

    _this.state = {
      modelDataText: __webpack_require__(920)("./".concat(lang, "/").concat(langType, ".json"))
    };
    return _this;
  }

  _createClass(bonusPriceDialog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        id: "blacklist"
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["k" /* Modal */], {
        size: "lg",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.dialog, " ").concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.infoPopup) // isOpen={this.props.modal}
        ,
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this2.props.setIsShowBonusPriceDialog();
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.infoCloseRightButton, " ").concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.dialogOverlayClose, " ").concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.orderCancelcloseRightButton),
        onClick: function onClick() {
          _this2.props.setIsShowBonusPriceDialog();
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* ModalBody */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.infoContainer, " ").concat(__WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.orderCancelContainer),
        style: {
          padding: 0
        }
      }, void 0, _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.infoHeadline
      }, void 0, _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.globalFontLight
      }, void 0, this.state.modelDataText.order.order_dialog_info_bonus_title)), _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a.infoContent
      }, void 0, _jsx("p", {}, void 0, this.state.modelDataText.order.order_dialog_info_bonus_body, _ref, this.state.modelDataText.order.order_dialog_info_bonus_body_2)))));
    }
  }]);

  return bonusPriceDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowBonusPriceDialog
  };
};

var mapDispatch = {
  setIsShowBonusPriceDialog: __WEBPACK_IMPORTED_MODULE_8__actions_dialog__["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__dialog_sass___default.a)(bonusPriceDialog)));

/***/ }),
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ffda836b.png";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7da14685.png";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var scroll = __webpack_require__(1818);

function calculateScrollOffset(elem, additionalOffset, alignment) {
  var body = document.body,
      html = document.documentElement;

  var elemRect = elem.getBoundingClientRect();
  var clientHeight = html.clientHeight;
  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
                                 html.clientHeight, html.scrollHeight, html.offsetHeight );

  additionalOffset = additionalOffset || 0;

  var scrollPosition;
  if (alignment === 'bottom') {
    scrollPosition = elemRect.bottom - clientHeight;
  } else if (alignment === 'middle') {
    scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
  } else { // top and default
    scrollPosition = elemRect.top;
  }

  var maxScrollPosition = documentHeight - clientHeight;
  return Math.min(scrollPosition + additionalOffset + window.pageYOffset,
                  maxScrollPosition);
}

module.exports = function (elem, options) {
  options = options || {};
  if (typeof elem === 'string') elem = document.querySelector(elem);
  if (elem) return scroll(0, calculateScrollOffset(elem, options.offset, options.align), options);
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hk/en-hk-modelData.json": 929,
	"./hk/en-hk.json": 921,
	"./hk/zh-hk-modelData.json": 930,
	"./hk/zh-hk.json": 982,
	"./in/in-modelData.json": 931,
	"./in/in.json": 983,
	"./kr/kr-modelData.json": 932,
	"./kr/kr.json": 984,
	"./sg/sg-modelData.json": 933,
	"./sg/sg.json": 985,
	"./tw/tw-modelData.json": 934,
	"./tw/tw.json": 986,
	"./wechat/cn-modelData.json": 935
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-HK","lang_lib":"en","lang_img":"en","lang_text":"English (Hong Kong)","links":{"home":"/en/order"},"order":{"dollar_code":"$","dollar_price":"${{price}}","pick_up_time_title":"PICK UP TIME","contact_info_title":"CONTACT INFO","contact_info_nickname_input":"Name","contact_info_phone_input":"Phone #","contact_info_email_input":"Email","contact_info_nickname_input_warning":"Please fill your name.","contact_info_phone_input_warning":"Please input a valid phone number.","contact_info_email_input_warning":"Please fill in a valid email address.","input_empty_warning":"Please fill in all the missing information in red.","price_total_amount":"TOTAL","pickup_datetime_input_warning":"Booking must be made in the future.","order_title":"Order GoGoVan - HK","order_headline":"New Order","order_add_image_button":"ADD IMAGE","order_add_image_max_size_desc":"MAX. 2MB","order_goods_image_desc":"IMAGES OF DELIVERY ITEMS","order_hourly_title":"Hourly Rental","order_hourly_body":"This option calculates fees based on every half-hour. ","order_hourly_minimum":"We recommend this option if you would like to rent GoGoVan for 3 hours or more due to many mid-points/stops in the trip, or if you expect a long waiting time during the trip.","order_hourly_detail_button":"DETAIL","order_hourly_hour":"  hrs","order_route_input_warning":"Please fill in the address","order_option_passenger_title":"PASSENGERS","order_option_passenger_body":"Passenger","order_option_passenger_body_plural":"Passengers","order_option_tunnel_title":"TUNNEL","order_option_tunnel_any":"Any","order_option_tunnel_hung":"Cross-Harbour Tunnel","order_option_tunnel_western":"Western Harbour Crossing","order_option_tunnel_eastern":"Eastern Harbour Crossing","order_option_tunnel_lion_rock":"Lion Rock Tunnel","order_option_tunnel_tates_cairn":"Tate's Cairn Tunnel","order_option_tunnel_eagles_nest":"Eagle's Nest Tunnel","order_option_tunnel_tai_lam":"Tai Lam Tunnel","order_option_tunnel_aberdeen":"Aberdeen Tunnel","order_option_tunnel_tko":"Tseung Kwan O Tunne","order_option_tunnel_tm_bridge":"Tsing Ma Bridge","order_option_tunnel_discovery":"Discovery Bay Tunnel","order_option_tunnel_shing_mun":"Shing Mun Tunnel","order_option_route_title":"ROUTE","order_option_route_location_1_address_input":"Enter a Pickup Point","order_option_route_location_2_address_input":"Enter a Destination","order_option_route_view_on_map_button":"VIEW MAP","order_option_route_view_on_map_button_mobile":"MAP","order_option_route_add_address_button":"Add a Location","order_vehicle_title":"VEHICLE TYPE","order_vehicle_type_sedan":"Sedan","order_vehicle_type_motorcycle":"motorcycle","order_vehicle_type_lorry10":"10 ft. Lorry","order_vehicle_type_lorry14":"14 ft. Lorry","order_vehicle_type_lorry24":"24 ft. Lorry","order_vehicle_type_van12":"Passenger Van","order_vehicle_type_van":"VAN","order_vehicle_type_mudou":"5.5 TON TRUCK","order_vehicle_type_mudou9":"9 TON TRUCK","order_promo_code_title":"COUPON CODE","order_promo_code_if_any_title":"COUPON CODE?","order_summary_service_title":"SERVICE","order_promo_code_input":"Coupon Code / no #","order_promo_input_warning":"Please fill in a valid coupon code.","order_promo_code_confirm_button":"APPLY","order_promo_code_cancel_button":"CANCEL","order_additional_service_title":"EXTRA SERVICES (OPTIONAL)","order_additional_service_detail_button":"DETAIL","order_additional_service_need_over_6ft":"Goods longer than 6 feet","order_additional_service_remove_net_half":"Goods longer than 6 feet ($20)","order_additional_service_remove_net_full":"Goods longer than 6 feet and height taller than 2 feet ($40)","order_additional_service_need_cart":"Borrow cart(s) ($10)","order_additional_service_cart":"PC","order_additional_service_need_carry":"Mover (Quote by driver)","order_additional_service_need_pet":"Pets ($10 unlimited)","order_additional_service_need_new_car":"New car","order_additional_service_need_waste":"Dumper (Quote by driver)","order_additional_service_mudou_need_cart":"Borrow forklift(s) ($20)","order_remark_title":"REMARKS (OPTIONAL)","order_remark_body":"Pickup Location’s landmark, number of luggages etc.","order_review_order_button":"REVIEW ORDER","order_restricted_area_warning":"<h2>Restricted Area</h2><br />The following address is restricted to closed road permit holders only.","order_restricted_area_ps":"If you don't have the permit, the fare will be quoted by the driver.  Please contact GOGOVAN specialist for further assistance (Tel: <span class='blue'>35903399</span>).","order_restricted_area_error_message":"Address is restricted to closed road permit holders only","order_restricted_area_have_permit":"I have permit","order_restricted_area_no_permit":"I don't have the permit","order_restricted_area_question":"Have no permit","order_restricted_area_question_title":"Have no permit?","order_restricted_area_confirm":"I Understand","order_restricted_area_out_error_msg":"GOGOVAN may not have services in the address","order_restricted_area_out_ps":"GOGOVAN may not have services at the following address. Please contact GOGOVAN specialist for further assistance (Tel: <span class='blue'>35903399</span>).","order_restricted_area_both_ps":"GOGOVAN specialist is here to help you to find a right driver. Please contact us for further assistance (Tel: <span class='blue'>35903399</span>)","order_restricted_area_both_find_driver":"Search for Driver","order_summary_title":"Order summary","order_summary_passenger_title":"PASSENGERS","order_summary_tunnel_title":"TUNNEL","order_summary_order_confirm_button":"FIND A DRIVER","order_summary_order_edit_button":"EDIT","order_summary_bonus_dialog_button":"Bonus","order_summary_route_title":"ROUTE","order_summary_route_view_on_map_button":"VIEW MAP","order_summary_route_view_on_map_button_mobile":"MAP","order_summary_show_order_detail_button":"VIEW ORDER DETAIL","order_summary_hide_order_detail_button":"CLOSE ORDER DETAIL","order_summary_order_cancel_button":"CANCEL ORDER","order_summary_driver_title":"DRIVER INFO","order_summary_driver_body":"ASSIGNING DRIVER...","order_summary_driver_rate_driver_button":"RATE DRIVER","order_summary_block_driver_button":"BLOCK","order_summary_pickup_time":"PICKUP TIME","order_summary_vehicle_title":"VEHICLE TYPE","order_summary_remark_title":"REMARKS","order_summary_charge_title":"FEE BREAKDOWN","order_summary_charge_tips":"Bonus","order_summary_charge_why_tips_button":"(Optional)","order_summary_charge_coupon":"Coupon","order_summary_tips_title":"Why Give Bonus?","order_summary_payment_title":"PAYMENT METHOD","order_summary_payment_message":"The above fees are calculated based on the closest pricing regions to your pickup / delivery points. They do not include car park fees and all other misc. fees. Please confirm with driver the total price on boarding.","order_summary_payment_price_table_button":"Tap here for fee details","order_summary_payment_method":"By Cash (to driver)","order_dialog_info_bonus_title":"Why Give Bonus?","order_dialog_info_bonus_body":"Bonus can help attract more drivers to your booking, increasing the speed to your response. This can be useful if you want to make a booking during peak hours.","order_dialog_info_bonus_body_2":"","service_content_headline":"Service Detail","service_content_content":"No matter if you are moving furnitures, supplies, goods or even pets, our wide range of vehicle types from van to 9 ton trucks can help.","service_content_fleets_header":"Vehicle Types","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"Van","service_content_icon_ser_van_body":"Carries max. 5 passengers (not including the driver); max. load 700kg; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","service_content_icon_ser_10ftlorry_title":"5.5 Ton Truck","service_content_icon_ser_10ftlorry_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","service_content_icon_ser_14ftlorry_title":"9 Ton Truck","service_content_icon_ser_14ftlorry_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width.","service_content_additional_header":"Additional Services","service_content_english_speaking_driver_title":"English-speaking Driver","service_content_english_speaking_driver_body":"Yes! We have English-speaking drivers working around the clock to help our non-Chinese speaking users.","service_content_goodsg_longer_than_6ft_title":"Goods Longer Than 6ft","service_content_goodsg_longer_than_6ft_body":"We recommend that you select this option and choose the “Van” vehicle type if your goods exceed 6’ in length, but do not exceed 700kg in weight. Our vans can then be modified to accommodate goods of up to 8’. If your goods exceed 6’ in length and 2’ in height, we recommend you to select the “taller than half net” option in the sub-menu.","service_content_borrow_carts_title":"Borrow Carts (Trolley/Pallet rental)","service_content_borrow_carts_body":"Trolleys and pallets help you move and deliver your goods. Trolleys are made of steel and equipped with a handle. They are more suited for transporting small goods in large quantities, like cardboard boxes. Pallets are made of wood and are more suited for transporting large, single items, like wardrobes.","service_content_forklift_rental_title":"Forklift Rental","service_content_forklift_rental_body":"Forklifts help you move and deliver your goods, and also allow you to manually adjust your goods’ height with the hand-pump. They are more applicable for goods delivered on a 5.5/9 ton truck.","service_content_mover_title":"Mover (Need extra hand)","service_content_mover_body":"Please contact and negotiate with your driver personally if you would like the driver to assist you in manually carrying and moving your goods.","service_content_pets_title":"Pets (Transporting pets)","service_content_pets_body":"We will safely transport your pets and count only one fixed price.","service_content_new_vehicle_title":"New Vehicle","service_content_new_vehicle_body":"We will get you a newer vehicle for your goods.","service_content_dumper_construction_waste_title":"Dumper / Construction Waste","service_content_dumper_construction_waste_body":"Select this option if you would like to move construction/industrial waste. Please make sure that it’s within our given dimensions and weight limits for a good.","service_content_hourly_header":"Hourly Rental","service_content_hourly_rental_body":"This option calculates fees based on every half-hour. We recommend this option if you would like to rent GoGoVan for 3 hours or more due to many mid-points/stops in the trip, or if you expect a long waiting time during the trip.","order_hourly_price_dialog_title":"Hourly Plan Price List","order_hourly_price_dialog_hourly_title":"Hourly Rental","order_hourly_price_dialog_overtime_title":"Overtime Charges","order_hourly_price_dialog_normal_time":"Monday to Saturday  07:00 - 20:59","order_hourly_price_dialog_normal_overtime":"Monday to Saturday  21:00 - 06:59","order_hourly_price_dialog_holiday_normal_time":"Sundays and Public Holidays  07:00 - 20:59","order_hourly_price_dialog_holiday_overtime":"Sundays and Public Holidays  21:00 - 06:59","order_hourly_price_dialog_van_type":"Van","order_hourly_price_dialog_van_normal_hourly_price":"$110/hour","order_hourly_price_dialog_van_other_hourly_price":"$135/hour","order_hourly_price_dialog_van_normal_overtime_price":"$10/5 mins or part thereof","order_hourly_price_dialog_van_other_overtime_price":"$12/5 mins or part thereof","order_hourly_price_dialog_5_ton_truck_type":"5.5 Ton Truck","order_hourly_price_dialog_5_ton_truck_normal_hourly_price":"$180/hour","order_hourly_price_dialog_5_ton_truck_other_hourly_price":"$220/hour","order_hourly_price_dialog_5_ton_truck_normal_overtime_price":"$15/5 mins or part thereof","order_hourly_price_dialog_5_ton_truck_other_overtime_price":"$18/5 mins or part thereof","order_hourly_price_dialog_9_ton_truck_type":"9 Ton Truck","order_hourly_price_dialog_9_ton_truck_normal_hourly_price":"$250/hour","order_hourly_price_dialog_9_ton_truck_other_hourly_price":"$320/hour","order_hourly_price_dialog_9_ton_truck_normal_overtime_price":"$18/5 mins or part thereof","order_hourly_price_dialog_9_ton_truck_other_overtime_price":"$21/5 mins or part thereof"}}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

(function(global) {
  'use strict';

  var dateFormat = (function() {
      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;
  
      // Regexes and supporting functions are cached through closure
      return function (date, mask, utc, gmt) {
  
        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
          mask = date;
          date = undefined;
        }
  
        date = date || new Date;
  
        if(!(date instanceof Date)) {
          date = new Date(date);
        }
  
        if (isNaN(date)) {
          throw TypeError('Invalid date');
        }
  
        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
  
        // Allow setting the utc/gmt argument via the mask
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
          mask = mask.slice(4);
          utc = true;
          if (maskSlice === 'GMT:') {
            gmt = true;
          }
        }
  
        var _ = utc ? 'getUTC' : 'get';
        var d = date[_ + 'Date']();
        var D = date[_ + 'Day']();
        var m = date[_ + 'Month']();
        var y = date[_ + 'FullYear']();
        var H = date[_ + 'Hours']();
        var M = date[_ + 'Minutes']();
        var s = date[_ + 'Seconds']();
        var L = date[_ + 'Milliseconds']();
        var o = utc ? 0 : date.getTimezoneOffset();
        var W = getWeek(date);
        var N = getDayOfWeek(date);
        var flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dateFormat.i18n.dayNames[D],
          dddd: dateFormat.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dateFormat.i18n.monthNames[m],
          mmmm: dateFormat.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(Math.round(L / 10)),
          t:    H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
          tt:   H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
          T:    H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
          TT:   H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
          W:    W,
          N:    N
        };
  
        return mask.replace(token, function (match) {
          if (match in flags) {
            return flags[match];
          }
          return match.slice(1, match.length - 1);
        });
      };
    })();

  dateFormat.masks = {
    'default':               'ddd mmm dd yyyy HH:MM:ss',
    'shortDate':             'm/d/yy',
    'mediumDate':            'mmm d, yyyy',
    'longDate':              'mmmm d, yyyy',
    'fullDate':              'dddd, mmmm d, yyyy',
    'shortTime':             'h:MM TT',
    'mediumTime':            'h:MM:ss TT',
    'longTime':              'h:MM:ss TT Z',
    'isoDate':               'yyyy-mm-dd',
    'isoTime':               'HH:MM:ss',
    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ],
    timeNames: [
      'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
    ]
  };

function pad(val, len) {
  val = String(val);
  len = len || 2;
  while (val.length < len) {
    val = '0' + val;
  }
  return val;
}

/**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */
function getWeek(date) {
  // Remove time components of date
  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // Change date to Thursday same week
  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);

  // Take January 4th as it is always in week 1 (see ISO 8601)
  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);

  // Change date to Thursday same week
  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);

  // Check if daylight-saving-time-switch occurred and correct for it
  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  targetThursday.setHours(targetThursday.getHours() - ds);

  // Number of weeks between target Thursday and first Thursday
  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
  return 1 + Math.floor(weekDiff);
}

/**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */
function getDayOfWeek(date) {
  var dow = date.getDay();
  if(dow === 0) {
    dow = 7;
  }
  return dow;
}

/**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */
function kindOf(val) {
  if (val === null) {
    return 'null';
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (typeof val !== 'object') {
    return typeof val;
  }

  if (Array.isArray(val)) {
    return 'array';
  }

  return {}.toString.call(val)
    .slice(8, -1).toLowerCase();
};



  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return dateFormat;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = dateFormat;
  } else {
    global.dateFormat = dateFormat;
  }
})(this);


/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = {"show":{"mins":"분","km":"KM","dist":"거리","reuse_this_route_button":"주문하기","okay_button":"확인","back_to_home_button":"홈","dollar_code":"원","driver_info_dialog_order":"주문 번호","driver_info_dialog_body":"주문이 접수되었습니다. 기사님이 곧 연락 드릴 예정입니다.","driver_info_dialog_okay_button":"확인","driver_info_dialog_notified_button":"확인","driver_info_dialog_view_order_button":"주문 확인","order_summary_service_title":"서비스 유형","order_status_order_active":"배송 중...","order_status_order_data":"예상 시간","order_status_order_completed":"배송 완료","order_status_order_cancelled":"취소","order_payment_method":"현금 결제","order_payment_method_cash":"현금","order_payment_method_cash_credit":"신용카드 결제","order_completed_dialog_title":"배송 완료","order_completed_dialog_body":"기사님이 배송을 완료했습니다. 서비스는 마음에 드셨나요?","order_completed_dialog_comment_input":"여기에 내용을 입력하세요","order_completed_dialog_skip_button":"넘기기","order_completed_dialog_submit_button":"확인","report_order_issue_dialog_title":"배송에 문제가 있습니다","report_order_issue_dialog_body":"주문번호 {{order}}에 대한 의견/내용을 남겨주세요.","report_order_issue_dialog_body_1":"주문번호 ","report_order_issue_dialog_body_2":"에 대한 의견/내용을 남겨주세요.","report_order_issue_name_input":"이름","report_order_issue_contact_input":"이메일/연락처","report_order_issue_feedback_input":"내용을 입력해주세요","order_cancel_dialog_title":"주문 취소","order_cancel_dialog_body":"정말 주문을 취소하시겠습니까?","order_cancel_dialog_continue_button":"아니오, 취소하지 않겠습니다","order_cancel_dialog_confirm_button":"네, 취소하겠습니다","order_cancel_dialog_okay_button":"확인","order_released_dialog_title":"주문 상태가 변경되었습니다.","order_released_dialog_body":"곧 다른 기사님이 주문을 수행할 예정입니다.","order_released_dialog_okay_button":"확인","driver_block_dialog_block_title":"차단","driver_block_dialog_block_body":"기사님에 대한 차단이 해제되었습니다, 향 후 신규 주문에 대한 기사님 배정이 가능합니다.","driver_block_dialog_unblock_title":"차단 해제","driver_block_dialog_unblock_body":"기사님 차단이 설정되었습니다, 향 후 신규 주문에 대한 기사님 배정이 이루어지지 않습니다.","driver_block_dialog_unblock_confirm_button":"차단 해제","driver_block_dialog_okay_button":"확인","share_order_dialog_title":"여행 상태 공유","share_order_dialog_body":"링크가있는 모든 사용자가 볼 수 있습니다.","order_summary_charge_tips_title":"보너스란?","order_summary_charge_tips_body":"B추가 보너스는 기사님이 주문에 대해 조금 더 빠른 시간 내에 응답 할 수 있도록 도와드립니다. 보너스 추가를 통해 피크 시간대의 예약을 조금 더 수월하게 진행 하실 수 있습니다.","order_summary_title":"주문 번호","order_summary_title_feedback_button":"문제 보고","order_summary_title_share_button":"공유","order_summary_order_confirm_button":"기사님 검색","order_summary_order_edit_button":"변경","order_summary_bonus_button":"보너스","order_summary_route_title":"경로","order_summary_route_view_on_map_button":"지도 보기","order_summary_show_order_detail_button":"주문 상세 보기","order_summary_hide_order_detail_button":"주문 상세 닫기","order_summary_order_cancel_button":"주문 취소","order_summary_driver_title":"기사 정보","order_summary_driver_body":"기사님을 검색 중입니다.","order_summary_driver_rate_driver_button":"기사 평가하기","order_summary_block_driver_button":"차단","order_summary_unblock_driver_button":"차단 해제","order_summary_contact_info_title":"연락처","order_summary_receiver_info_title":"수취인 정보","order_summary_pickup_time":"픽업 시간","order_summary_vehicle_title":"차량","order_summary_remark_title":"기타 요청 사항","order_summary_charge_title":"상세 운임","order_summary_charge_tips":"보너스","order_summary_charge_why_tips_button":"(선택)","order_summary_charge_coupon":"Coupon","order_summary_tips_title":"보너스","order_summary_payment_title":"결제 방법","order_summary_payment_message":"본 주문 기록에 표기된 금액은 경로에 따른 표준 요금과 시스템 상에 기록된 고객님이 신청하신 부가 서비스 이용 요금만을 포함하고 있습니다. 본 요금은 주차료, 통행료(터널, 다리)와 같은 기타 비용 및 오프라인상으로 고객님과 기사님 사이에 동의하신 기타 금액을 포함하지 않습니다.","order_summary_payment_price_table_button":"추가 비용에 대한 자세한 설명은 여기를 클릭하세요","order_summary_payment_method":"현금 결제","order_summary_charge_total_amount":"최종 요금 합계","order_vehicle_type_motorcycle":"오토바이","order_vehicle_type_damas":"다마스","order_vehicle_type_labo":"라보","order_vehicle_type_van":"밴","order_vehicle_type_ton1":"1톤","order_vehicle_type_ton1_2_and_ton1_4":"1.2톤&1.4톤","order_service_type_transport":"퀵서비스","order_service_type_moving":"원룸/소사무실 이사","order_service_type_delivery":"소형 용달 화물","order_cancelled_dialog_title":"주문이 취소되었습니다.","order_cancelled_dialog_body":"만약 취소하신게 아니라면 알려주세요","order_completed_alert_1":"배송이 완료되었습니다 (","order_completed_alert_2":") - 주문 번호 : ","order_completed_alert_3":".","order_cancelled_dialog_with_reason_title":"이유 : ","order_cancelled_dialog_with_reason_body_1":"만약 불편사항이 있다면","order_cancelled_dialog_with_reason_body_2":"고고밴에 알려주세요"}}

/***/ }),
/* 924 */,
/* 925 */,
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "45d9c71d.png";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02317171.png";

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"vehicle_type":{"title":"VEHICLE TYPE","types":[{"title":"VAN","type":"van","price":"$20 起","icon":"/img/icon_van_blue.png 1x, /img/icon_van_blue@2x.png 2x"},{"title":"5.5 TON TRUCK","type":"mudou","price":"$45 起","icon":"/img/icon_5ton_blue.png 1x, /img/icon_5ton_blue@2x.png 2x"},{"title":"9 TON TRUCK","type":"mudou9","price":"$25 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"}]},"additional_service":{"title":"EXTRA SERVICES (OPTIONAL)","button_service_detail":"DETAIL","van":[{"title":"Speak English ($5)","service_code":"need_english","options":[]},{"title":"Goods longer than 6 feet","service_code":"need_over_6ft","options":[{"title":"Goods longer than 6 feet ($20)","option_name":"remove_net","option_code":"half"},{"title":"Goods longer than 6 feet and height taller than 2 feet ($40)","option_name":"remove_net","option_code":"full"}]},{"title":"Borrow cart(s) ($10)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover (Quote by driver)","service_code":"need_carry","options":[]},{"title":"Pets ($10 unlimited)","service_code":"need_pet","options":[]},{"title":"New car","service_code":"need_new_car","options":[]},{"title":"Dumper (Quote by driver)","service_code":"need_waste","options":[]},{"title":"Pay by receiver","service_code":"pay_by_receiver","options":[]}],"mudou":[{"title":"Speak English ($5)","service_code":"need_english","options":[]},{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover (Quote by driver)","service_code":"need_carry","options":[]},{"title":"Pay by receiver","service_code":"pay_by_receiver","options":[]}],"mudou9":[{"title":"Speak English ($5)","service_code":"need_english","options":[]},{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover (Quote by driver)","service_code":"need_carry","options":[]},{"title":"Pay by receiver","service_code":"pay_by_receiver","options":[]}]},"tunnel":{"title":"TUNNEL","tunnels":[{"title":"Please select tunnel","tunnel_code":"any","placehoder":true},{"title":"Cross-Harbour Tunnel","tunnel_code":"hung"},{"title":"Western Harbour Crossing","tunnel_code":"western"},{"title":"Eastern Harbour Crossing","tunnel_code":"eastern"},{"title":"Lion Rock Tunnel","tunnel_code":"lion_rock"},{"title":"Tate's Cairn Tunnel","tunnel_code":"tates_cairn"},{"title":"Eagle's Nest Tunnel","tunnel_code":"eagles_nest"},{"title":"Tai Lam Tunnel","tunnel_code":"tai_lam"},{"title":"Aberdeen Tunnel","tunnel_code":"aberdeen"},{"title":"Tseung Kwan O Tunnel","tunnel_code":"tko"},{"title":"Tsing Ma Bridge","tunnel_code":"tm_bridge"},{"title":"Discovery Bay Tunnel","tunnel_code":"discovery"},{"title":"Shing Mun Tunnel","tunnel_code":"shing_mun"}]},"hourly":{"hours":["3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8"]},"datepicker":{"date":{"today":"Today","close":"Close"}}}}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"vehicle_type":{"title":"選擇車種","types":[{"title":"貨VAN","type":"van","price":"$20 起","icon":"/img/icon_van_blue.png 1x, /img/icon_van_blue@2x.png 2x"},{"title":"5.5 &nbsp; 噸貨車","type":"mudou","price":"$45 起","icon":"/img/icon_5ton_blue.png 1x, /img/icon_5ton_blue@2x.png 2x"},{"title":"9 &nbsp; 噸貨車","type":"mudou9","price":"$25 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"}]},"additional_service":{"title":"附加服務","button_service_detail":"詳情","van":[{"title":"貨物長度超過6呎","service_code":"need_over_6ft","options":[{"title":"貨物長度超過6呎 &nbsp; ($20)","option_name":"remove_net","option_code":"half"},{"title":"貨物長度超過6呎，而且高度超過2呎 &nbsp; ($40)","option_name":"remove_net","option_code":"full"}]},{"title":"租借車仔／板車 &nbsp; (每部 &nbsp; $10)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 &nbsp; (上樓) &nbsp; ($ &nbsp; 請與司機議價)","service_code":"need_carry","options":[]},{"title":"接載寵物 &nbsp; ($10 &nbsp; 隻數不限)","service_code":"need_pet","options":[]},{"title":"新車","service_code":"need_new_car","options":[]},{"title":"建築廢料 &nbsp; ($ &nbsp; 請與司機議價)","service_code":"need_waste","options":[]},{"title":"收件人付款","service_code":"pay_by_receiver","options":[]}],"mudou":[{"title":"借唧車 &nbsp; (每部 &nbsp; $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 &nbsp; (上樓) &nbsp; ($ &nbsp; 請與司機議價)","service_code":"need_carry","options":[]},{"title":"收件人付款","service_code":"pay_by_receiver","options":[]}],"mudou9":[{"title":"借唧車 &nbsp; (每部 &nbsp; $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 &nbsp; (上樓) &nbsp; ($ &nbsp; 請與司機議價)","service_code":"need_carry","options":[]},{"title":"收件人付款","service_code":"pay_by_receiver","options":[]}]},"tunnel":{"title":"隧道","tunnels":[{"title":"請選擇隧道","tunnel_code":"any","placehoder":true},{"title":"紅磡隧道","tunnel_code":"hung"},{"title":"西區隧道","tunnel_code":"western"},{"title":"東區隧道","tunnel_code":"eastern"},{"title":"獅子山隧道","tunnel_code":"lion_rock"},{"title":"大老山隧道","tunnel_code":"tates_cairn"},{"title":"尖山隧道／沙田嶺隧道","tunnel_code":"eagles_nest"},{"title":"大欖隧道","tunnel_code":"tai_lam"},{"title":"香港仔隧道","tunnel_code":"aberdeen"},{"title":"將軍澳隧道","tunnel_code":"tko"},{"title":"青馬隧道／青嶼幹線","tunnel_code":"tm_bridge"},{"title":"愉景灣隧道","tunnel_code":"discovery"},{"title":"城門隧道","tunnel_code":"shing_mun"}]},"hourly":{"hours":["3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8"]},"datepicker":{"date":{"monthsFull":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],"monthsShort":["一","二","三","四","五","六","七","八","九","十","十一","十二"],"weekdaysFull":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"weekdaysShort":["日","一","二","三","四","五","六"],"today":"今天","clear":"清除","close":"關閉","firstDay":"1"},"time":{"clear":"清除"}}}}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"vehicle_type":{"title":"VEHICLE TYPE","types":[{"title":"Tata Ace","type":"ton1","price":"$20 起","icon":"/img/icon_5ton_blue.png 1x, /img/icon_5ton_blue@2x.png 2x"},{"title":"Tata Super Ace","type":"ton2","price":"$20 起","icon":"/img/icon_5ton_blue.png 1x, /img/icon_5ton_blue@2x.png 2x"},{"title":"Tata 407","type":"ton3","price":"$45 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"},{"title":"Eicher 14 feet","type":"ton4","price":"$20 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"},{"title":"Eicher 17 feet","type":"ton5","price":"$20 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"},{"title":"Eicher 19 feet","type":"ton6","price":"$20 起","icon":"/img/icon_9ton_blue.png 1x, /img/icon_9ton_blue@2x.png 2x"}]},"mover_service":[{"title":"No mover needed","value":""},{"title":"1 Mover","value":"1"},{"title":"2 Movers","value":"2"},{"title":"3 Movers","value":"3"},{"title":"4 Movers","value":"4"},{"title":"5 Movers","value":"5"},{"title":"6 Movers","value":"6"},{"title":"7 Movers","value":"7"},{"title":"8 Movers","value":"8"},{"title":"9 Movers","value":"9"},{"title":"10 Movers","value":"10"}],"additional_service":{"title":"EXTRA REQUIREMENTS (OPTIONAL)","ton1":[{"title":"Labour","service_code":"need_labour","options":[{"title":"No, thanks","option_name":"labour_num","option_code":"0"},{"title":"1 labour","option_name":"labour_num","option_code":"1"},{"title":"2 labours","option_name":"labour_num","option_code":"2"}]}],"ton2":[{"title":"Labour","service_code":"need_labour","options":[{"title":"No, thanks","option_name":"labour_num","option_code":"0"},{"title":"1 labour","option_name":"labour_num","option_code":"1"},{"title":"2 labours","option_name":"labour_num","option_code":"2"}]}]},"datepicker":{"date":{"today":"Today","close":"Close"}}}}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"service_types":[{"title":"퀵서비스","value":"transport","height":"49","icon":"/img/icon_courier.png 1x, /img/icon_courier@2x.png 2x"},{"title":"소형 용달 화물","value":"delivery","height":"45","icon":"/img/icon_smallfreight.png 1x, /img/icon_smallfreight@2x.png 2x"},{"title":"원룸/소사무실 이사","value":"moving","height":"48","icon":"/img/icon_movingservice.png 1x, /img/icon_movingservice@2x.png 2x"},{"title":"대형화물 / 기업화물","value":"big_cargo","height":"45","icon":"/img/icon_deliveryservice.png 1x, /img/icon_deliveryservice@2x.png 2x","disable":true}],"goods_types":[{"title":"서류","value":"documents","vehicle":"van"},{"title":"소형 박스","value":"small_box","vehicle":"motorcycle"},{"title":"대형 박스","value":"big_box","vehicle":"van"},{"title":"식품","value":"food","vehicle":"van"},{"title":"꽃&화분","value":"plants","vehicle":"van"},{"title":"기타","value":"others","vehicle":"van"}],"number_of_items":{"small_box":[{"title":"1개","value":"1"},{"title":"2개","value":"2"},{"title":"3개","value":"3"},{"title":"4개 - 12개","value":"12"},{"title":"13개 - 24개","value":"24"},{"title":"25개 이상","value":"30"}],"big_box":[{"title":"1개","value":"1"},{"title":"2개 - 8개","value":"8"},{"title":"9개 - 16개","value":"16"},{"title":"17개 이상","value":"20"}]},"vehicle_types":{"delivery":[{"title":"다마스","value":"damas"},{"title":"라보","value":"labo"},{"title":"밴","value":"van"},{"title":"1톤","value":"ton1"},{"title":"1.2톤&1.4톤","value":"ton1_2_and_ton1_4"}],"moving":[{"title":"1톤","value":"ton1"},{"title":"1.2톤&1.4톤","value":"ton1_2_and_ton1_4"}]},"num_movers_departure":{"moving":[{"title":"추가 수작업 인원 미포함","value":"0"},{"title":"기사님 + 작업인원 1명 추가","value":"1"},{"title":"기사님 + 작업인원 2명 추가","value":"2"},{"title":"기사님 + 작업인원 3명 추가","value":"3"}]},"num_movers_destination":{"moving":[{"title":"추가 수작업 인원 미포함","value":"0"},{"title":"기사님 + 작업인원 1명 추가","value":"1"},{"title":"기사님 + 작업인원 2명 추가","value":"2"},{"title":"기사님 + 작업인원 3명 추가","value":"3"}]},"additional_service":{"transport":[{"title":"비 오는 날 추가 요금 (3,000원 추가)","service_code":"is_raining","options":[]},{"title":"눈 오는 날 추가 요금 (5,000원 추가)","service_code":"is_snowing","options":[]},{"title":"급송 서비스  (운임 2배)","service_code":"express_service","options":[]},{"title":"착불","service_code":"pay_by_receiver","options":[]}],"delivery":[{"title":"운반 필요 - 기사님과 협의","service_code":"need_carry","options":[]},{"title":"착불","service_code":"pay_by_receiver","options":[]}],"moving":[{"title":"상차지의 층수가 3층 이상입니까?","service_code":"departure_above_3f","options":[{"title":"아니오, 3층 이하입니다.","option_name":"departure_lift","option_code":"less_than_3f"},{"title":"예, 엘리베이터 사용 가능합니다.","option_name":"departure_lift","option_code":"can_use_elevator"},{"title":"예, 하지만 엘리베이터 사용이 불가하며, 사다리차가 필요합니다. (80,000원)","option_name":"departure_lift","option_code":"need_ladder_car"}]},{"title":"하차지의 층수가 3층 이상입니까?","service_code":"destination_above_3f","options":[{"title":"아니오, 3층 이하입니다.","option_name":"destination_lift","option_code":"less_than_3f"},{"title":"예, 엘리베이터 사용 가능합니다.","option_name":"destination_lift","option_code":"can_use_elevator"},{"title":"예, 하지만 엘리베이터 사용이 불가하며, 사다리차가 필요합니다. (80,000원)","option_name":"destination_lift","option_code":"need_ladder_car"}]},{"title":"냉장고는 양문형입니까?  (기사님께 미리 말씀해주세요.)","service_code":"need_to_move_double_door_refrigerator","options":[]},{"title":"벽걸이 TV 해체시 기사님 도움이 필요하세요? (+ 50,000원)","service_code":"need_help_for_disassembling_tv","options":[]},{"title":"벽걸이 에어컨 해체시 기사님 도움이 필요하세요? (+50,000원)","service_code":"need_help_for_disassembling_aircon","options":[]}]},"payment_method":[{"title":"현금결제","option_name":"payment_method","option_code":"cash"},{"title":"신용카드결제","details":"신용카드결제를 위해 고객센터 1588-3047로 전화주시기 바랍니다.","option_name":"payment_method","option_code":"braintree"}],"datepicker":{"date":{"monthsFull":["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],"monthsShort":["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],"weekdaysFull":["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],"weekdaysShort":["일","월","화","수","목","금","토"],"today":"금일","clear":"재설정","close":"닫기","firstDay":"1"},"time":{"clear":"재설정"}}}}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"service_types":[{"title":"Deliver & Courier Small Goods","value":"delivery","goods":"Document","height":"49","icon":"/img/icon_courier.png 1x, /img/icon_courier@2x.png 2x"},{"title":"Transport Large and Bulky Items","value":"transport","height":"45","icon":"/img/icon_deliveryservice.png 1x, /img/icon_deliveryservice@2x.png 2x"},{"title":"Book a Moving Service","value":"moving","height":"48","icon":"/img/icon_movingservice.png 1x, /img/icon_movingservice@2x.png 2x"}],"goods_types":[{"title":"Parcel","value":"Parcel","vehicle":"van"},{"title":"Document","value":"Document","vehicle":"motorcycle"},{"title":"Food","value":"Food","vehicle":"motorcycle"}],"parcel_types":[{"title":"1 unit (max 10 kg)","value":"1"},{"title":"2 units (max 20 kg)","value":"2"}],"vehicle_types":[{"title":"VAN","type":"van"},{"title":"10 ft. Lorry","type":"lorry10"},{"title":"14 ft. Lorry","type":"lorry14"},{"title":"24 ft. Lorry","type":"lorry24"}],"mover_service":{"transport":[{"title":"NO mover needed","value":""},{"title":"1 Mover (Driver)","value":"0"},{"title":"2 Movers (Driver + Assistant)","value":"1"},{"title":"3 Movers (Driver + 2 Assistants)","value":"2"},{"title":"4 Movers (Driver + 3 Assistants)","value":"3"},{"title":"5 Movers (Driver + 4 Assistants)","value":"4"},{"title":"6 Movers (Driver + 5 Assistants)","value":"5"}],"moving":[{"title":"1 Mover (Driver)","value":"0"},{"title":"2 Movers (Driver + Assistant)","value":"1"},{"title":"3 Movers (Driver + 2 Assistants)","value":"2"},{"title":"4 Movers (Driver + 3 Assistants)","value":"3"},{"title":"5 Movers (Driver + 4 Assistants)","value":"4"},{"title":"6 Movers (Driver + 5 Assistants)","value":"5"}]},"additional_service":{"delivery":{"van":[{"title":"Express delivery (within 1 hour +S$5)","service_code":"express_service","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"sedan":[{"title":"Express delivery (within 1 hour +S$3)","service_code":"express_service","options":[]},{"title":"Access restricted area (+S$10)","service_code":"free_trade_zone_delivery","options":[]}],"motorcycle":[{"title":"Express delivery (within 1 hour +S$3)","service_code":"express_service","options":[]},{"title":"Access restricted area (+S$10)","service_code":"free_trade_zone_delivery","options":[]}]},"transport":{"van":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Trolley/Cart Needed","service_code":"trolley_cart","options":[]},{"title":"Transport Pets","service_code":"need_pet","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry10":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Trolley/Cart Needed","service_code":"trolley_cart","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Refrigerated (+S$5)","service_code":"need_refrigeration","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry14":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Trolley/Cart Needed","service_code":"trolley_cart","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Tailgate (+S$5)","service_code":"need_tailgate","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry24":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Trolley/Cart Needed","service_code":"trolley_cart","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Tailgate (+S$5)","service_code":"need_tailgate","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}]},"moving":{"van":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry10":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry14":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Tailgate (+S$5)","service_code":"need_tailgate","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}],"lorry24":[{"title":"Ride with Goods (Front seat passenger only)","service_code":"ride","options":[]},{"title":"Covered Lorry","service_code":"need_covered_truck","options":[]},{"title":"Tailgate (+S$5)","service_code":"need_tailgate","options":[]},{"title":"Access restricted area (+S$15)","service_code":"free_trade_zone_delivery","options":[]}]}},"datepicker":{"date":{"today":"Today","close":"Close"}}}}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"vehicle_type":{"title":"車種","types":[{"title":"機車","type":"motorcycle","price":"$20 起","icon":"/img/icon_motorcycle_blue.png 1x, /img/icon_motorcycle_blue@2x.png 2x"},{"title":"廂型貨車","type":"struck","price":"$20 起","icon":"/img/icon_van_blue.png 1x, /img/icon_van_blue@2x.png 2x"},{"title":"貨車(1.75噸)","type":"mtruck","price":"$20 起","icon":"/img/icon_5ton_blue.png 1x, /img/icon_5ton_blue@2x.png 2x"}]},"additional_service":{"title":"加值服務","button_service_detail":"詳情","motorcycle":[{"ignore":true,"title":"須代購/代付款 (金額需加收＄50)","service_code":"proxy_payment","options_amount_title":"請輸入金額","options":[{"title":"不需要排隊","option_name":"need_queueing","option_code":false},{"title":"需要排隊: 排隊費毎30分鐘100元(不足時以30分鐘計)","option_name":"need_queueing","option_code":true}]},{"title":"收件人付運費","service_code":"pay_by_receiver","options":[]}],"struck":[{"ignore":true,"title":"須代購/代付款 (金額需加收＄50)","service_code":"proxy_payment","options_amount_title":"請輸入金額","options":[{"title":"不需要排隊","option_name":"need_queueing","option_code":false},{"title":"需要排隊: 排隊費毎30分鐘100元(不足時以30分鐘計)","option_name":"need_queueing","option_code":true}]},{"title":"收件人付運費","service_code":"pay_by_receiver","options":[]},{"title":"貨件搬運","service_code":"need_carry","options":[]},{"title":"進撤櫃或參撤展","service_code":"need_booth_deconstruction","options":[]}],"mtruck":[{"ignore":true,"title":"須代購/代付款 (金額需加收＄50)","service_code":"proxy_payment","options_amount_title":"請輸入金額","options":[{"title":"不需要排隊","option_name":"need_queueing","option_code":false},{"title":"需要排隊: 排隊費毎30分鐘100元(不足時以30分鐘計)","option_name":"need_queueing","option_code":true}]},{"title":"收件人付運費","service_code":"pay_by_receiver","options":[]},{"title":"貨件搬運","service_code":"need_carry","options":[]},{"title":"進撤櫃或參撤展","service_code":"need_booth_deconstruction","options":[]}]},"goods_type":{"goods":[{"title":"日用百貨","value":"1"},{"title":"文件","value":"2"},{"title":"食用品","value":"3"},{"title":"易碎品","value":"4"},{"title":"其他","value":"5"}]},"datepicker":{"date":{"monthsFull":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],"monthsShort":["一","二","三","四","五","六","七","八","九","十","十一","十二"],"weekdaysFull":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"weekdaysShort":["日","一","二","三","四","五","六"],"today":"今天","clear":"清除","close":"關閉","firstDay":"1"},"time":{"clear":"清除"}}}}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = {"order_model_data":{"passenger_count_by_vehicle_type":{"tricycle":["没跟车"],"sbread":["没跟车",1,2,3,4,5,6,7],"mbread":["没跟车",1,2,3,4,5,6,7],"lbread":["没跟车",1,2],"struck":["没跟车",1,2,3,4,5],"mtruck":["没跟车",1,2,3,4,5],"ltruck":["没跟车",1,2],"sltruck":["没跟车",1,2]},"vehicle_type":{"vehicles":[{"title":"三轮车","type":"tricycle","payload":"0.4吨","max_width":"1.3米","icon":"/img/tricycle@2x.png 2x, /img/tricycle@2x.png 2x"},{"title":"小型面包车","type":"sbread","payload":"0.6吨","max_width":"1.7米","icon":"/img/sbread@2x.png 2x, /img/sbread@2x.png 2x"},{"title":"中型面包车","type":"mbread","payload":"0.8吨","max_width":"2.0米","icon":"/img/mbread@2x.png 2x, /img/mbread@2x.png 2x"},{"title":"大型面包车","type":"lbread","payload":"1.2吨","max_width":"2.6米","icon":"/img/lbread@2x.png 2x, /img/lbread@2x.png 2x"}]},"additional_service":{"services":[{"title":"需要搬运 (请与司机自行商量价钱)","value":"1"},{"title":"需要回单 (请与司机自行商量价钱)","value":"2"}]},"city":{"cities":[{"title":"北京","value":"beijing"},{"title":"上海","value":"shanghai"},{"title":"深圳","value":"shenzhen"},{"title":"广州","value":"guangzhou"},{"title":"青岛","value":"qingdao"},{"title":"武汉","value":"wuhan"}]},"goods_type":{"goods":[{"title":"日用百货","value":"1"},{"title":"办公用品","value":"2"},{"title":"食用品","value":"3"},{"title":"易碎品","value":"4"},{"title":"建筑材料","value":"5"},{"title":"其他","value":"6"}]}}}

/***/ }),
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, ".react-slidedown{height:0;-webkit-transition-property:none;-o-transition-property:none;transition-property:none;-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s;-webkit-transition-timing-function:ease-in-out;-o-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out}.react-slidedown.transitioning{overflow-y:hidden}.react-slidedown.closed{display:none}", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "#_2-K8B ._1bYsY ._31mEW:after,#YwqOg .Nxbxi ._2umWN:after,._1c-mK ._2NvEa:after,._1FMQT:after,._358Qi ._2XoJG .qELQ3:after,.O3BWk:after{content:\"\";display:table;clear:both}.OKrb5{font-size:16px;font-size:1rem;font-weight:400;color:#4a4a4a;margin:10px 0;cursor:pointer;padding:5px}.OKrb5:focus{outline:0}._2eVrl{margin-top:15px!important}.-sMnr{display:none}._1eR6K{color:#cacaca!important;cursor:not-allowed!important;outline:0;font-size:12px;letter-spacing:1px}._2BMvf{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._2BMvf._2u65M{background-color:#fff}#_3MU46{direction:rtl;width:90px;min-width:80px;padding-right:4px}._1uX9E{background-color:#f6f6f6;padding-top:130px}@media (min-width:768px){._1uX9E ._3BTvt{border:4px solid #fec930;background-image:url(https://gogovan-web-hk.herokuapp.com/img/icon_selected@2x.png);background-size:51px 51px;background-repeat:no-repeat;background-position:100% 0;background-origin:border-box;height:180px;text-align:center;padding-top:35px;border-radius:4px;cursor:pointer}._1uX9E ._3BTvt:focus{outline:0}._1uX9E .MT7IK{border:1px solid #d5d5d5;height:180px;text-align:center;padding-top:35px;border-radius:4px;cursor:pointer}}@media (max-width:767px){._1uX9E{padding-top:50px}._1uX9E ._3BTvt{border:4px solid #fec930;background-image:url(https://gogovan-web-hk.herokuapp.com/img/icon_selected@2x.png);background-size:51px 51px;background-repeat:no-repeat;background-position:100% 0;background-origin:border-box;border-radius:4px}._1uX9E ._3BTvt,._1uX9E .MT7IK{text-align:center;padding-top:35px;cursor:pointer}._1uX9E .MT7IK{border:1px solid #d5d5d5;border-radius:4px}}._1uX9E ._2SN-h{position:absolute;height:19px;width:21px;background-size:21px 18px;background-repeat:no-repeat;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAkCAYAAAD/yagrAAAAAXNSR0IArs4c6QAABT9JREFUWAnNWG2IVFUYfs6dyV0Sl9qFvlilRXO3yCJICTFzZqV+lBgiBUFKBG1CGQjJflUX2p2ZDPuhPyopQiOJ/tmaZezurAZKGQau1ZbGhkihoIVJ7LY79/S8587O3Plqz72CeeDOPef9eM5z3vOejzsKYUrf0DLEnT0KqjWMW7mtBk7Bm96I7tVHy3W12qqWokLuDlyPunljSmF+hS6CQEOfxcTlVrhr/rZxj9sYGZs5c1+YIcmI/AitD/GZsvYXQ6Wu4/MQo3MnZ6VZE5PSbTYYdhHdum8ebmwYV0o1aY1jmNQr4SYmbDqosHGz9ahThznopVrrC/jjUgu2rf2rwq5M4JS1qzcbG17Kk/SAqY7IJAXdDHCqgwP2BBPErt5pqbQY0dRgE1TsRc7PUposAnRwEM0ErSf4HnSt2lgKEbGVHtnNqG5gVGVmzhZRFIOB0+z/GHRuJxfcBdH5RNNDD5Pkh2zcVHQorRFwGtNeG15p/6VUE7H1+tBC7iBcnKrmOuFaOE+yT6Or/UsFN9uMeowyuW+QLknoV9L/iWOQkQWKPoLORF9AcOXVTLaX/SwvBeJMarRyALeLnLvDn5jAEoVM9j2SfNYINbZyat+U+v9e0iMvMzXMjkCy7zMP/REx/767ZkhKlBgww8lETC2PS5j9TPVORo5i/+DNzPHHiLOEA7/Nx9G/EXuUObYfPavPRcMWTs59wjHO8OZXd3lOWkCnBu+CE+tn6qyldXEHMa5sGklc60x2H7xcD1fwDxaoAROfk3AMbkEBA4tqangLSZ4gycdpbSjJ3sjFeM5/MLMY2Q9taAvxiViiEU1ndyrH2U4CMemXBD/VnvcoT6y56ErcYh7WRUbdgNiIrfiAvtIOW2ruYTWBUsObuXXIGc3UwUXkvKfQkzxYYe8fsQcoP6D7hx9BzNnLsDeKr04Nn0J3ckeFz38IwkW07+B8XireEDxG6hL+8VZWJVneoQyEtsZHdIIhWCFKOKKxOpcRqTf4nu7Aq8nvrfsSW/FhMRjEsvaloT1R95M5tF8v4Jzy4+hJfCz1UIU+xtd3Wg8f0wrCnmhd0wou3waD6nkfWaFXM9J6r4gNFjGrmVST2RPVTksBwFHfFOphKwpfF1yCmAVh9Yo9UaWKNysvd746nIU06BvEnMXVnqjWFwtYXqyxUA9bCfoGMWfBCUHUO1PAcnBvoR62EvTVAcxZcOyJTjlf8Wj0v5OUemIW3NpqRz0pSoNFzNqGpRp7om7iMpeqnDSyYpNIDyVLoSxa9OHplDCWgiWYlsWeqADm9Gu8xOYMtnJ2o/+LWy37gbEVHxaDQSxrXxqGI9qTOMk5e0s64CWjGbH6Q5Cr3mxFbGhrfMRWMAQrRAlHVIAnD3cyv/ZLldN4B69vx5EZ2U7Ci0VWUkQmOtoYWyrNbYoYJXYWjfC3J9f18Ny763TL4h08s59nlOrYD++m8S06M3KGVPhIUQtIbkG+bl4c4DsY/3kzdhEjZAlPVDrY1SF/5WzSmWFG1kmTED9BTIRJTOXJicQvPN9HAa8LXcnPZmRh39GIzvTSyY5d93Mdf/ABfqOvgVb3UDWzwH6H0if4X8AAetvlXzvyjV7i9B5nRFqYcAsjwUgqAEfyTySImk55TsKRH/vaXDCYayv4TbOuptPVVpCL4ST9kqNCf/ZuxPBtflEw3/UQVWNUXtFURR4XVyh92/hq51txz51EDveLEEiNPANHv50na0TXwo8h6alN6F71gU/UkM22MU97eT4uo3ARRUXd1WUtU3napKRGH7oTY9L9v5DyyzRcjE33AAAAAElFTkSuQmCC)}._1uX9E ._196-Z{font-size:12px;letter-spacing:1px;color:#00a9ee;margin-left:27px}._1uX9E ._10VN-{background-image:url(data:image/png;base64,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);width:100px;height:100px;position:relative;float:left;cursor:pointer;background-position:50%;background-size:cover}._1uX9E ._3uQoO{max-width:800px;max-height:600px;margin:auto}._1uX9E ._3uQoO .gYIZJ{margin-top:15px}._1uX9E ._3uQoO .gYIZJ ._3mTcI{display:inline-block;margin-right:20px;margin-bottom:20px}._1uX9E ._3uQoO .gYIZJ ._12Ul9{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABRdJREFUaAXVWk1IHEkU7pneMDr+ISIScvDgDzl4EDRuBIVEiOhekix6CCxBWRZy3F1wT7ussIGQCLlmLwtCcglKfmBBmYC7qGASIoQcZCGzF3ER8aCiuP4wzn5fb1dnLLunq9puHQt6qqvr1Xvfe/WqXv1MzAghtbe3F1dUVFyLxWJX8VzMZrP1YFuJ9zKyR3kT2RrKabz/heePjY2NV3Nzc/+y/jgpFrRxR0dHZWlp6XWA4tMNPklNXttQJIXn5dbW1svZ2dk1zfYWubYCLS0tyerq6u/j8fgP4GBZOIhgqc3mwcHBg9XV1Yfz8/PbUl3eoo4CZm9v79fgNgyLn8/LNWAlemOZ/CcmJn5DnlFho6RAV1fXhUQi8QLAW1WYHpcGirzb3d29MTU19Y8fL18Furu7PzdN83lUVvcCyN7IZDI3U6nUGy8afo/nq+zp6fkK4P88afDERJmUTQz5MJpelWyIgfoYjD7zoon6O2Xj+bKuru7vdDr9wU2eqwvZbkPLF7k1OulvcKcduNMVN3c64kIcsLbPFwR4GouGJCZik40nK2Das00k06QsXKcMJc4TG9occvtDCnCeB+GJTJU64AUtsdmxSHz6pA0jbElJyTMQhRVdHSEhv7Ri3fVoeXl5n3ydHuDygN0UsrDQ2REjsQrGlj9xYVZUVDSOjwlRoZr39fUZVVVVxuLiomoTi66zs9Noa2szFhYWtNqRGEpcqqmp+RUyd6w5nqtKfNd2nf7+fmNgYMDAFGeBmJmZsXK/H4IfGhoyMLMQjDE2NubXRK4vszGPWj3Q0NDwMxhdlKnylWn5wcFBiwQBz8CewFhaWvLtiVzwbNzc3Gzs7e0F6gkEt6dxbkYAnut5rbSysuJYng1pTVqVAL2SDJ507D3y0k3ETOxmU1PTFyjc1mVAn6fFaXn2AFO+nvACPzIyYqi6noTxHOLCWxPucwcKXJYqlYqqSkQAXuBbMRsbG79FiXvYQMlPidraWmfACgF0m2NYXrDhBLAeQ2T7iJfACghuXlZmPceHSGGBJz8s8tKcRisF8+Pkwo/F9EheucBZDhM8+SFVxmF97fn//7ZHf6kEXYNA5RQBeLpQmbOUkAWelXIcfsRDp1CS2zgQjFXihKBVzYmdPRDoQEkW4gaebpPrThEoscYxkJbB6Ja9wHM8yGMiTCWI3ayvr2/FS6BARkXzgeeg9osTrA+a4EK/U4EEFLgVhIkfeMEzKiWgwD0Tm4PF4uLi7yDsnBCokquCF7wiUGJ7fX39TpxH3NAkJQSp5thQHApUKvO8W5zgmCAv3UTMxG7FeLgRl9Q3dJhwJ7W/v2+t51XAC95yT4yOjhrj49wM6iUocB/7gffWjozn8+Xl5YwHWlGZOykwstbzYimhAkPQ0vJBwEPGJjFTlnMyh6PEH7Ge/0UFwGnT4C7hp8nJybvE4SwleLkAa/J8vqATMRKrAOkoYN+MDIuKAs6Hc29xHBeyAfMW5jUGdEGezsH673B7w6DrLHedHrAVyPBmpBBdiZiILRc8McsKGLzWwbR4Ew12bKVOPSMWYnK7cjqiANHyHB6Nvjl15DYAYnG7G2D1p82qhJY3IrwZwWceu1jxQiKJvEjL4xnElPnES5g8iI/QFfoln68C1KjrLF+z5nRJQV50e46BHODiNYtxMc/LhWQyuYNxcQkV2sfxgpmU868GdxFhb01PT79GXVaq9ywquZBb6zP7Zw83ZXhKfFp/t/kPu2K722LYDaIAAAAASUVORK5CYII=);position:absolute;width:24px;height:24px;background-size:cover;z-index:10;cursor:pointer;margin-left:90px;margin-top:-8px}._1uX9E ._31auD{opacity:0;width:0;display:none}._1uX9E ui-image-upload ._1-zzd ._2pp4_ .PUcs2{height:19px}._1uX9E ._2BMvf{padding-bottom:124px}._1uX9E ._1p2O- ._35qaU{margin-top:40px;margin-bottom:0}._1uX9E ._34JNl._3LB1E._2GtPp ._2xnoi{width:inherit;background-color:transparent}._1uX9E ._1Sh_a .VnDpr{display:none}._1uX9E ._3GpTA.kvn1f{padding-left:38px;padding-right:3em}._1uX9E ._3GpTA.bT48p{background-color:#f6f6f6;border:0}._1uX9E ._3GpTA.bT48p._30pgi{-moz-appearance:none;background-repeat:no-repeat;background-position:1em 1em;background-size:9px 5px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._1uX9E ._3GpTA.bT48p._30pgi:active,._1uX9E ._3GpTA.bT48p._30pgi:hover{background-color:#fff;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.3);box-shadow:0 1px 4px rgba(0,0,0,.3)}._1uX9E ._3GpTA.bT48p._30pgi option{background-color:#fff}._1uX9E ._2t8EW{position:absolute;top:8px;right:18px;cursor:pointer}@media (max-width:767px){._1uX9E ._2t8EW{top:4px}}._1uX9E ._11-WI img{margin-top:20px}._1uX9E ._11-WI h2{font-size:1.5em;margin-top:20px;margin-bottom:20px;display:block}._1uX9E ._11-WI ._3RdXE,._1uX9E ._11-WI .CplIF{margin-top:0;display:inline}._1uX9E .JJZUV ._2Nq0B{padding-top:8px}._1uX9E .JJZUV .ww73D{padding-left:20px}._1uX9E ._1EZgR ._1Ne82{display:-ms-flexbox;display:flex}._1uX9E ._1EZgR ._1Ne82 .fYPzn{width:8em;height:2.9em}._1uX9E .X7WFb ._2xnoi{margin-top:150px!important;margin-bottom:150px!important}._1uX9E .X7WFb #_Z4C8 ._3l5Ev{margin-top:0;margin-bottom:0}._1yq0H{border-color:#0088bf}._1yq0H,.VgkCC{color:#0088bf;font-size:12px}.VgkCC{letter-spacing:1px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;cursor:pointer;outline:0}.VgkCC:hover{color:#006a96}.VgkCC:hover ._37aHM[data-hover=true]{display:inline}.VgkCC:hover ._37aHM[data-hover=false]{display:none}.VgkCC ._37aHM{vertical-align:-4px;margin-right:.5em}.VgkCC ._37aHM[data-hover=true]{display:none}.ww73D{margin-top:20px;margin-bottom:12px}.-RLg6 ._1WWC5,.-RLg6 ._2tgy6{font-size:16px;vertical-align:bottom;cursor:pointer}.-RLg6 ._2gDQe,.-RLg6 ._3zt57{font-size:16px;text-align:right;margin-bottom:9px;font-weight:300;cursor:pointer}.-RLg6 ._27kbq{margin-top:1em;font-size:18px;vertical-align:bottom;color:#00a493;font-weight:600}.-RLg6 ._2n1HY{font-size:40px;text-align:right;margin-bottom:9px;color:#00a493;font-weight:600}.kxgTS>div{display:none}.kxgTS>div ._2CqaW{margin-top:0}.kxgTS>div._26VUk img{cursor:pointer}._2gf1p{padding-bottom:124px}._2gf1p .bit6D{margin-top:10px;padding:10px}._2gf1p .bit6D label{cursor:pointer}._2gf1p .bit6D [type=radio],._2gf1p .bit6D [type=text],._2gf1p .bit6D p{margin-left:25px}._2gf1p ._25ypr{margin-top:0}._2gf1p ._25ypr ._1-797{margin-top:25px}._2gf1p ._2USoH{background-color:#fff;color:#6a4a4a}@media (max-width:767px){._2gf1p ._2USoH._2Eml5{padding:0}}._2LtOC{cursor:not-allowed}.-TaIw{background-color:#fff;height:180px;margin:auto;color:#0088bf;text-align:center;padding-top:86px;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d5d5d5;border-radius:4px;position:relative}@media (max-width:767px){.-TaIw{height:115px;padding-top:47px;padding-left:150px;text-align:left}}.-TaIw:hover{border-color:#0088bf}.-TaIw._1yUcw{border-width:4px;border-color:#fec930;background-size:51px 51px;background-repeat:no-repeat;background-position:100% 0;background-origin:border-box}@media (max-width:767px){.-TaIw._1yUcw{padding-top:44px;padding-left:147px}}.-TaIw._1yUcw img{bottom:87px}@media (max-width:767px){.-TaIw._1yUcw img{bottom:37px;left:37px}}.-TaIw img{position:absolute;bottom:90px;left:0;right:0;margin:auto}@media (max-width:767px){.-TaIw img{bottom:40px;left:40px;right:auto}}._1ayC5{display:none}._3VKbZ{line-height:40px}._358Qi ._2XoJG{background-color:#fff;position:relative}._358Qi ._2XoJG ._1MIb-{position:absolute;top:-50px;right:0}._358Qi ._2XoJG ._3D3EE{background-color:#006a96;color:#fff}._358Qi ._2XoJG ._3D3EE h2{margin:54px 40px 30px}._358Qi ._2XoJG .qELQ3{color:#4a4a4a;padding:30px 60px 60px 40px}._358Qi ._2XoJG .qELQ3.-dzAv{text-align:center}._358Qi ._2XoJG .qELQ3.-dzAv .Vw1kZ{font-size:12px;letter-spacing:1px}._358Qi ._2XoJG .qELQ3.-dzAv .sQ1_X{color:#0088bf}._358Qi ._2XoJG .qELQ3 p{margin:0;line-height:24px}._358Qi ._2XoJG .qELQ3 ._3qYBL{float:right;width:220px;margin-top:60px}@media (max-width:767px){._358Qi ._2XoJG .qELQ3 ._3qYBL{width:auto}}@media (max-width:767px){#_2-K8B ._3AsFN>div{padding-left:0;padding-right:0}}#_2-K8B ._1bYsY{background-color:#fff;position:relative}@media (max-width:767px){#_2-K8B ._1bYsY{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_2-K8B ._1bYsY ._1MIb-{position:absolute;top:-50px;right:0}@media (max-width:767px){#_2-K8B ._1bYsY ._1MIb-{position:fixed;top:20px}}#_2-K8B ._1bYsY ._1U_25{margin-bottom:15px}#_2-K8B ._1bYsY .Z2yre{background-color:#006a96;color:#fff}#_2-K8B ._1bYsY .Z2yre h2{margin:54px 40px 30px}@media (max-width:767px){#_2-K8B ._1bYsY .Z2yre{position:fixed;width:100%;margin-top:-60px}#_2-K8B ._1bYsY .Z2yre h2{margin:20px}}#_2-K8B ._1bYsY ._31mEW{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:767px){#_2-K8B ._1bYsY ._31mEW{margin-top:60px;padding-left:10px;padding-right:10px}}#_2-K8B ._1bYsY ._31mEW hr{margin-left:10px}#_2-K8B ._1bYsY ._31mEW p{margin:0;line-height:24px}#_2-K8B ._1bYsY ._31mEW ._3wHyf{margin-bottom:0}#_2-K8B ._1bYsY ._31mEW ._13wy6{float:right;width:220px;margin-top:60px}#YwqOg .Nxbxi{background-color:#fff;position:relative}#YwqOg .Nxbxi ._1MIb-{position:absolute;top:-50px;right:0}#YwqOg .Nxbxi ._37Y2D{background-color:#006a96;color:#fff}#YwqOg .Nxbxi ._37Y2D h2{font-size:24px;margin:54px 40px 30px}#YwqOg .Nxbxi ._2umWN{color:#4a4a4a;padding:30px 60px 60px 40px}#YwqOg .Nxbxi ._2umWN p{margin:0;font-size:16px;line-height:24px}#_2QSha .sbwaU{margin-top:200px;position:relative}#_2QSha .sbwaU ._8QdvJ{position:absolute;top:-50px;right:0}#E3ZOj{display:none;padding-bottom:20px}._2uOws hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:4px}._2uOws .Bdg_n>div{margin-top:.5em;margin-bottom:.5em;line-height:24px}._2uOws ._1L86M{margin:0 8px;margin-left:4px;vertical-align:middle}._2uOws .ordLL{margin-bottom:2px}._2uOws .ordLL>div{line-height:24px;margin-bottom:.75em}._2uOws ._1Jco5{float:right}._2uOws .hmFwX img{width:100%}#_2BxTJ .gt2TY{border-color:#e75467;color:#e75467}#_2BxTJ .gt2TY:hover{background-color:#e75467;color:#fff}._1c-mK{display:block}._1c-mK ._2NvEa{display:inline-block;margin:10px}._1FMQT,.O3BWk{margin-top:10px;display:inline-block}._1bevN{width:100px;height:100px;position:relative;float:left;margin-right:20px;cursor:pointer;background-size:cover;background-position:50%;background-repeat:no-repeat}._1bevN ._3yrNr{position:absolute;right:-6px;top:-6px;width:24px;height:24px;cursor:pointer;display:none}._11gVC{padding-left:2em;padding-right:3em}._3aS9p .dLTtL{height:100%;bottom:0}._1YFdb{max-height:400px;overflow-y:scroll}._3jg4P{position:relative;height:56px}._3jg4P input{border-color:#e75467;border-width:2px}._3jg4P img._2RER_{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.393 0.769 0.189 0 0 0.349 0.686 0.168 0 0 0.272 0.534 0.131 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"1.01\" /><feFuncG type=\"linear\" slope=\"1.01\" /><feFuncB type=\"linear\" slope=\"1.01\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncG type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncB type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"311\" /></filter></svg>#filter');filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg);-webkit-filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg)}._3jg4P img._35S3R{-webkit-filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.5144 0.6152000000000001 0.1512 0 0 0.2792 0.7488 0.13440000000000002 0 0 0.21760000000000002 0.4272 0.30479999999999996 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.56\" /><feFuncG type=\"linear\" slope=\"0.56\" /><feFuncB type=\"linear\" slope=\"0.56\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncG type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncB type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"300\" /></filter></svg>#filter');filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg)}._3jg4P ._1kRww{height:52px}._3jg4P .Vw1kZ{color:#e75467;font-size:12px;margin-left:50px;position:absolute;left:0;bottom:0}#_3EpVu ._3xCK5{margin-top:20px}#_3EpVu ._3xCK5 .VgkCC{text-align:center;font-size:14px;color:#cacaca}#_3EpVu ._3xCK5 .VgkCC img{-webkit-filter:brightness(-35%) contrast(0);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncG type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncB type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /></feComponentTransfer></filter></svg>#filter');filter:brightness(-35%) contrast(0)}#_3EpVu ._3xCK5 .VgkCC:hover{color:#0088bf}#_3EpVu ._3xCK5 .VgkCC:hover img{-webkit-filter:none;filter:none}@media only screen and (min-width:768px){._1uX9E{padding-top:130px;font-family:Lato,Lucida Grande,Helvetica Neue,MyNormalFont,STHeitiTC,Microsoft JhengHei,Microsoft YaHei New,Microsoft YaHei,Helvetica,Arial,Verdana,sans-serif;background-color:#f6f6f6}}@media only screen and (max-width:768px){._1uX9E{font-family:Lato,Lucida Grande,Helvetica Neue,MyNormalFont,STHeitiTC,Microsoft JhengHei,Microsoft YaHei New,Microsoft YaHei,Helvetica,Arial,Verdana,sans-serif;background-color:#f6f6f6}}._1lR30{margin:auto;padding-top:20px;background-color:#fff;float:none;border-radius:10px}@media only screen and (min-width:768px){._3Snx1{background-color:#fff;padding:40px 70px 124px}}@media only screen and (max-width:768px){._3Snx1{background-color:#fff;padding:40px 20px 124px}}._35qaU{font-size:30px;margin-top:40px;margin-bottom:0}.ww73D{font-size:12px;font-weight:bolder;letter-spacing:1px;padding-top:20px;padding-bottom:0;color:#4a4a4a}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;-o-text-overflow:\"\";text-overflow:\"\"}._1tbVb{font-size:14px;padding:6px 3em 7px 38px;margin-bottom:10px}._3o1ym{background-image:url(https://gogovan-web-hk.herokuapp.com/img/icon_dropdownarrow_grey.png);background-repeat:no-repeat;background-position:1em 1em;background-size:9px 5px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}.bT48p{background-color:#f6f6f6;border:0}.HI3XA{padding-left:2.2em;padding-right:3em}._2RK4z{margin-top:-70px;margin-left:5px}._3xwp1{margin-top:-30px;margin-left:5px}._2lmV4{width:100%;border:none}._1_jZc{border:1px solid #cacaca;border-radius:4px;padding-left:1.8em;padding-right:3em}.-c8cL{width:100%}._3jB3s{margin-left:25px}@-webkit-keyframes _3DtKn{0%{margin-top:-5rem;opacity:1}to{margin-top:0;opacity:1}}@keyframes _3DtKn{0%{margin-top:-5rem;opacity:1}to{margin-top:0;opacity:1}}@-webkit-keyframes _2yjKy{0%{margin-top:0;opacity:1}to{margin-top:-5rem;opacity:1}}@keyframes _2yjKy{0%{margin-top:0;opacity:1}to{margin-top:-5rem;opacity:1}}.daWQn{width:100%;font-size:1em;opacity:1;-webkit-animation-name:_3DtKn;animation-name:_3DtKn;-webkit-animation-duration:1s;animation-duration:1s}._15UvX{text-align:right}._1P9yo{width:8em;height:2.9em}._2vuoH{display:none}._1qmEK{width:100%;font-size:1em;opacity:1;-webkit-animation-name:_2yjKy;animation-name:_2yjKy;-webkit-animation-duration:1s;animation-duration:1s}._2gBnI{margin-top:-50px}._3vJAC{margin-top:-65px}._1dp2L{margin-top:-75px}._1KV7e{z-Index:100;background-color:#fff;top:40px;left:0;position:absolute;width:inherit;border:1px solid #d3d3d3;-webkit-box-shadow:5px 5px 25px #d3d3d3;box-shadow:5px 5px 25px #d3d3d3}._1KV7e ._1NnML{color:#999;text-align:left;padding-left:10px;border-bottom:1px solid #d3d3d3;cursor:pointer}._1KV7e ._1NnML:hover{background-color:#d3d3d3;cursor:pointer}._1KV7e ._1NnML ._3V40U{display:block;width:auto}.NyvPb{max-width:none}.NyvPb>div{margin:auto;width:620px}._2QSha{width:620px;height:380px;max-width:auto;min-width:auto}._37F1y{width:40px;height:40px;margin-left:580px;margin-top:-40px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}._1mXkX>*{color:#000!important;font-weight:400!important}._3PWjp{float:right;color:#0088bf;font-size:12px;cursor:pointer}.l-pRb{margin-bottom:0}._2PhFh{width:100px;height:100px;position:relative;float:left;cursor:pointer;background-position:50%;background-size:cover}._2AMSJ{position:absolute;right:20px;top:8px;cursor:pointer}._1uF3L{font-size:16px;display:block;-webkit-margin-before:1em;-webkit-margin-after:1em;-webkit-margin-start:0;-webkit-margin-end:0}._2WSOU{font-size:16px;letter-spacing:0;font-weight:600}._WVY7:focus{outline:0}._WVY7:hover{border-color:#0088bf}._1_P2s{float:right;color:#9b9b9b}._3CId-{border-color:transparent;border-top:1px solid #cacaca}._2igrr{border:1px solid #000;margin-top:38px;overflow:unset}._24xZ1{cursor:pointer}._24xZ1:focus{outline:0}.-CJ2J{margin-bottom:15px}.-CJ2J,._3cTko{margin-left:0}._22tVs{line-height:3}", ""]);

// exports
exports.locals = {
	"infoPopup": "_358Qi",
	"infoContainer": "_2XoJG",
	"infoContent": "qELQ3",
	"serviceDetail": "_2-K8B",
	"serviceDetail-container": "_1bYsY",
	"serviceDetailContentContainer": "_31mEW",
	"item-fit": "YwqOg",
	"item-fit-container": "Nxbxi",
	"item-fit-content-container": "_2umWN",
	"summaryGoodsImages": "_1c-mK",
	"summaryGoodsImage": "_2NvEa",
	"add-image-items": "_1FMQT",
	"order-add-image-items": "O3BWk",
	"label": "OKrb5",
	"formGroupMarginTop": "_2eVrl",
	"hideAdditionalService": "-sMnr",
	"disabled": "_1eR6K",
	"fixedContainer": "_2BMvf",
	"backgroundWhite": "_2u65M",
	"orderBonus": "_3MU46",
	"orderPage": "_1uX9E",
	"vehicleGridActive": "_3BTvt",
	"vehicleGrid": "MT7IK",
	"functionIcon": "_2SN-h",
	"functionText": "_196-Z",
	"uploadImage": "_10VN-",
	"uiImageUpload": "_3uQoO",
	"uiImageTopOffset": "gYIZJ",
	"imageItem": "_3mTcI",
	"imageItemCancel": "_12Ul9",
	"uploadFile": "_31auD",
	"image-upload": "_1-zzd",
	"add-image-button": "_2pp4_",
	"function-icon": "PUcs2",
	"sectionHeadline": "_1p2O-",
	"headline": "_35qaU",
	"ngdialog": "_34JNl",
	"ngdialog-theme-default": "_3LB1E",
	"ngdialog-no-bg": "_2GtPp",
	"ngdialog-content": "_2xnoi",
	"picker": "_1Sh_a",
	"picker__button--clear": "VnDpr",
	"input": "_3GpTA",
	"icon": "kvn1f",
	"backgroundDark": "bT48p",
	"selectDropdown": "_30pgi",
	"inputClear": "_2t8EW",
	"sectionHourly": "_11-WI",
	"desc": "CplIF",
	"descMinimum": "_3RdXE",
	"sectionHourlySelection": "JJZUV",
	"hourDetail": "_2Nq0B",
	"orderSmallTitle": "ww73D",
	"sectionCouponInput": "_1EZgR",
	"couponInput": "_1Ne82",
	"uiButton": "fYPzn",
	"hourlyDetailDialog": "X7WFb",
	"hourlyPrice": "_Z4C8",
	"hourly-price-container": "_3l5Ev",
	"iconPlusBlue": "_1yq0H",
	"orderFunctionText": "VgkCC",
	"orderFunctionIcon": "_37aHM",
	"orderPricingRow": "-RLg6",
	"orderPricingBonus": "_2tgy6",
	"orderPricingCoupon": "_1WWC5",
	"orderPricingBonusPrice": "_2gDQe",
	"orderPricingCouponPrice": "_3zt57",
	"orderPricingTotal": "_27kbq",
	"orderPricingTotalPrice": "_2n1HY",
	"orderPromoCode": "kxgTS",
	"orderPromoCodeWarning": "_2CqaW",
	"orderPromoCodeConfirm": "_26VUk",
	"orderForm": "_2gf1p",
	"orderAdditionalService": "bit6D",
	"sectionOrderOptions": "_25ypr",
	"order-small-title": "_1-797",
	"section-contact": "_2USoH",
	"order-sender-recipient": "_2Eml5",
	"feature-disabled": "_2LtOC",
	"orderVehicleGrid": "-TaIw",
	"active": "_1yUcw",
	"order-delivery-item-option": "_1ayC5",
	"orderLocationCellViewMap": "_3VKbZ",
	"dialog-overlay-close": "_1MIb-",
	"infoHeadline": "_3D3EE",
	"restrictedInfo": "-dzAv",
	"reminder": "Vw1kZ",
	"blue": "sQ1_X",
	"infoCloseButton": "_3qYBL",
	"container": "_3AsFN",
	"service-vehicle-type": "_1U_25",
	"serviceDetailHeadline": "Z2yre",
	"serviceDetailDescHeadline": "_3wHyf",
	"serviceDetailCloseButton": "_13wy6",
	"item-fit-headline": "_37Y2D",
	"staticMap": "_2QSha",
	"staticMapContainer": "sbwaU",
	"dialogOverlayClose": "_8QdvJ",
	"orderFormSummary": "E3ZOj",
	"orderSummary": "_2uOws",
	"summaryLocation": "Bdg_n",
	"orderSummaryIcon": "_1L86M",
	"summaryBreakdown": "ordLL",
	"right": "_1Jco5",
	"orderRemark": "hmFwX",
	"show-order-cancel-order": "_2BxTJ",
	"red": "gt2TY",
	"order-add-image-item": "_1bevN",
	"order-add-image-cancel": "_3yrNr",
	"mod-icon": "_11gVC",
	"picker--opened": "_3aS9p",
	"picker__frame": "dLTtL",
	"picker__box": "_1YFdb",
	"error": "_3jg4P",
	"input-icon": "_2RER_",
	"input-clear": "_35S3R",
	"routeInputFormGroup": "_1kRww",
	"order-submit-form": "_3EpVu",
	"bottomReminder": "_3xCK5",
	"whiteCard": "_1lR30",
	"formBox": "_3Snx1",
	"inputSelect": "_1tbVb",
	"simpleSelectDropdown": "_3o1ym",
	"iconLeft": "HI3XA",
	"imgIconLeft": "_2RK4z",
	"imgIconLeftTW": "_3xwp1",
	"inputBox": "_2lmV4",
	"inputRoundDiv": "_1_jZc",
	"noteTextarea": "-c8cL",
	"labelAdditionalOption": "_3jB3s",
	"addCoupon": "daWQn",
	"topFadeIn": "_3DtKn",
	"buttonLeft": "_15UvX",
	"buttonStyle": "_1P9yo",
	"couponHide": "_2vuoH",
	"removeCoupon": "_1qmEK",
	"topFadeOut": "_2yjKy",
	"routeStartImg": "_2gBnI",
	"routeMidImg": "_3vJAC",
	"routeEndImg": "_1dp2L",
	"suggestionContainer": "_1KV7e",
	"suggestionItem": "_1NnML",
	"suggestionSpan": "_3V40U",
	"staticMapInfo": "NyvPb",
	"infoCloseRightButton": "_37F1y",
	"remarkOverride": "_1mXkX",
	"rightText": "_3PWjp",
	"hrBottom": "l-pRb",
	"OrderSummaryImg": "_2PhFh",
	"couponCrossButton": "_2AMSJ",
	"orderWarningText": "_1uF3L",
	"addPathButton": "_2WSOU",
	"selectVehicle": "_WVY7",
	"summaryPaymentOptionDetails": "_1_P2s",
	"hrTitle": "_3CId-",
	"hrTotalPrice": "_2igrr",
	"addPhotoButton": "_24xZ1",
	"contantInfoTop": "-CJ2J",
	"contantInfo": "_3cTko",
	"order13RemarkLineHeight": "_22tVs"
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1486);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./sms.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./sms.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1e16245.png";

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(965);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(966);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(969);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 965 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(967)();
}


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(151);
var invariant = __webpack_require__(108);
var ReactPropTypesSecret = __webpack_require__(968);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(30);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./IMG_2836.png": 1494,
	"./IMG_2836@2x.png": 1021,
	"./add_image.png": 1495,
	"./add_image@2x.png": 1022,
	"./app_download_banner_logo.png": 1496,
	"./arrow_left.png": 1497,
	"./button_arrowdown.png": 1498,
	"./button_arrowdown@2x.png": 1023,
	"./china.png": 1499,
	"./clearbutton.png": 1500,
	"./clearbutton@2x.png": 1024,
	"./dialog_order_finished_en.png": 1501,
	"./dl_andriod_blue.png": 1502,
	"./dl_andriod_blue@2x.png": 1025,
	"./dl_android_outline.png": 1503,
	"./dl_android_outline@2x.png": 1026,
	"./dl_apple_blue.png": 1504,
	"./dl_apple_blue@2x.png": 1027,
	"./dl_appstore.png": 1505,
	"./dl_appstore@2x.png": 1028,
	"./dl_appstore_hover_yl.png": 1506,
	"./dl_appstore_hover_yl@2x.png": 1029,
	"./dl_appstore_outline.png": 1507,
	"./dl_appstore_outline@2x.png": 1030,
	"./dl_appstore_white.png": 1508,
	"./dl_appstore_white@2x.png": 1031,
	"./dl_playstore.png": 1509,
	"./dl_playstore@2x.png": 1032,
	"./dl_playstore_hover_yl.png": 1510,
	"./dl_playstore_hover_yl@2x.png": 1033,
	"./dl_playstore_white.png": 1511,
	"./dl_playstore_white@2x.png": 1034,
	"./favicon-114x114.png": 1512,
	"./favicon-195x195.png": 1513,
	"./favicon-228x228.png": 1514,
	"./favicon-32x32.png": 1515,
	"./favicon-64x64.png": 1516,
	"./favicon-72x72.png": 1517,
	"./favicon-96x96.png": 1518,
	"./feature_lightbox1_en.png": 1519,
	"./feature_lightbox1_en@2x.png": 1035,
	"./feature_lightbox2.png": 1520,
	"./feature_lightbox2@2x.png": 1036,
	"./feature_lightbox3.png": 1521,
	"./feature_lightbox3@2x.png": 1037,
	"./feature_lightbox4_en.png": 1522,
	"./feature_lightbox4_en@2x.png": 1038,
	"./feature_lightbox5_en.png": 1523,
	"./feature_lightbox5_en@2x.png": 1039,
	"./feature_lightbox6_en.png": 1524,
	"./feature_lightbox6_en@2x.png": 1040,
	"./hero_iphone_en.png": 1525,
	"./hero_iphone_en@2x.png": 1041,
	"./hero_nexus_en.png": 1526,
	"./hero_nexus_en@2x.png": 1042,
	"./hero_video.png": 1527,
	"./hero_video@2x.png": 1043,
	"./hero_video_hover.png": 1528,
	"./hero_video_hover@2x.png": 1044,
	"./hongkong.png": 1529,
	"./icon-building-materials-transport.png": 1530,
	"./icon-building-materials-transport@2x.png": 1045,
	"./icon-courier.png": 1531,
	"./icon-courier@2x.png": 1046,
	"./icon-delivery.png": 1532,
	"./icon-delivery@2x.png": 1047,
	"./icon-how-it-work-step1_en.png": 1533,
	"./icon-how-it-work-step1_en@2x.png": 1048,
	"./icon-how-it-work-step2.png": 1534,
	"./icon-how-it-work-step2@2x.png": 1049,
	"./icon-how-it-work-step3.png": 1535,
	"./icon-how-it-work-step3@2x.png": 1050,
	"./icon-pet-shuttle-service.png": 1536,
	"./icon-pet-shuttle-service@2x.png": 1051,
	"./icon-right.png": 1537,
	"./icon-right@2x.png": 1052,
	"./icon-send-document.png": 1538,
	"./icon-send-document@2x.png": 1053,
	"./icon-supplies-moving.png": 1539,
	"./icon-supplies-moving@2x.png": 1054,
	"./icon-warehouse-transport.png": 1540,
	"./icon-warehouse-transport@2x.png": 1055,
	"./icon_5ton_blue.png": 1541,
	"./icon_5ton_blue@2x.png": 1056,
	"./icon_5ton_white.png": 1542,
	"./icon_5ton_white@2x.png": 1057,
	"./icon_9ton_blue.png": 1543,
	"./icon_9ton_blue@2x.png": 1058,
	"./icon_9ton_white.png": 1544,
	"./icon_9ton_white@2x.png": 1059,
	"./icon_add.png": 1545,
	"./icon_add@2x.png": 1060,
	"./icon_add_disabled.png": 1546,
	"./icon_add_disabled@2x.png": 1061,
	"./icon_add_hover.png": 1547,
	"./icon_add_hover@2x.png": 1062,
	"./icon_avatar.png": 1548,
	"./icon_avatar@2x.png": 1063,
	"./icon_avator40x40.png": 1549,
	"./icon_avator40x40@2x.png": 1064,
	"./icon_avator70x70.png": 1550,
	"./icon_avator70x70@2x.png": 1065,
	"./icon_birthday.png": 1551,
	"./icon_birthday@2x.png": 1066,
	"./icon_borrowcart_inactive.png": 1552,
	"./icon_borrowcart_inactive@2x.png": 1067,
	"./icon_calendar.png": 1553,
	"./icon_calendar@2x.png": 1068,
	"./icon_calendar_solidblue.png": 1554,
	"./icon_calendar_solidblue@2x.png": 1069,
	"./icon_camera.png": 1555,
	"./icon_camera@2x.png": 1070,
	"./icon_camera_disabled.png": 1556,
	"./icon_camera_disabled@2x.png": 1071,
	"./icon_camera_hover.png": 1557,
	"./icon_camera_hover@2x.png": 1072,
	"./icon_clear_2.png": 1558,
	"./icon_clear_2@2x.png": 1073,
	"./icon_clear_b.png": 1559,
	"./icon_clear_b@2x.png": 1074,
	"./icon_clock.png": 1560,
	"./icon_clock@2x.png": 1075,
	"./icon_clock_small.png": 1561,
	"./icon_clock_small@2x.png": 1076,
	"./icon_constructionwaste_inactive.png": 1562,
	"./icon_constructionwaste_inactive@2x.png": 1077,
	"./icon_courier.png": 1563,
	"./icon_courier@2x.png": 1078,
	"./icon_courier_blue.png": 1564,
	"./icon_courier_blue@2x.png": 1079,
	"./icon_courier_white.png": 1565,
	"./icon_courier_white@2x.png": 1080,
	"./icon_cross_r.png": 1566,
	"./icon_cross_r@2x.png": 1081,
	"./icon_deliveryservice.png": 1567,
	"./icon_deliveryservice@2x.png": 1082,
	"./icon_deliveryservice_blue.png": 1568,
	"./icon_deliveryservice_blue@2x.png": 1083,
	"./icon_deliveryservice_white.png": 1569,
	"./icon_deliveryservice_white@2x.png": 1084,
	"./icon_destination_pin_1.png": 1570,
	"./icon_destination_pin_2.png": 1571,
	"./icon_destination_pin_3.png": 1572,
	"./icon_destination_pin_4.png": 1573,
	"./icon_destination_pin_5.png": 1574,
	"./icon_destination_pin_6.png": 1575,
	"./icon_destination_pin_7.png": 1576,
	"./icon_destination_pin_8.png": 1577,
	"./icon_destination_pin_9.png": 1578,
	"./icon_done.png": 1579,
	"./icon_done@2x.png": 1085,
	"./icon_dropdownarrow_grey.png": 1580,
	"./icon_email.png": 1581,
	"./icon_email@2x.png": 1086,
	"./icon_english_inactive.png": 1582,
	"./icon_english_inactive@2x.png": 1087,
	"./icon_facebook.png": 1583,
	"./icon_facebook@2x.png": 1088,
	"./icon_feature1.png": 1584,
	"./icon_feature1@2x.png": 1089,
	"./icon_feature2.png": 1585,
	"./icon_feature2@2x.png": 1090,
	"./icon_feature3.png": 1586,
	"./icon_feature3@2x.png": 1091,
	"./icon_feature4.png": 1587,
	"./icon_feature4@2x.png": 1092,
	"./icon_feature5.png": 1588,
	"./icon_feature5@2x.png": 1093,
	"./icon_feature6.png": 1589,
	"./icon_feature6@2x.png": 1094,
	"./icon_from.png": 1590,
	"./icon_from@2x.png": 1095,
	"./icon_gender.png": 1591,
	"./icon_gender@2x.png": 1096,
	"./icon_googleplus.png": 1592,
	"./icon_googleplus@2x.png": 1097,
	"./icon_home_address.png": 1593,
	"./icon_home_address@2x.png": 1098,
	"./icon_hourlyrental_inactive.png": 1594,
	"./icon_hourlyrental_inactive@2x.png": 1099,
	"./icon_industry.png": 1595,
	"./icon_industry@2x.png": 1100,
	"./icon_instagram.png": 1596,
	"./icon_instagram@2x.png": 1101,
	"./icon_linkedin.png": 1597,
	"./icon_linkedin@2x.png": 1102,
	"./icon_loading_complete.png": 1598,
	"./icon_loading_complete@2x.png": 1103,
	"./icon_loading_small.png": 1599,
	"./icon_loading_small@2x.png": 1104,
	"./icon_location_1.png": 1600,
	"./icon_location_1@2x.png": 1105,
	"./icon_location_2.png": 1601,
	"./icon_location_2@2x.png": 1106,
	"./icon_locations_full.png": 1602,
	"./icon_locations_full@2x.png": 1107,
	"./icon_longergood_inactive.png": 1603,
	"./icon_longergood_inactive@2x.png": 1108,
	"./icon_mail.png": 1604,
	"./icon_mail@2x.png": 1109,
	"./icon_mid.png": 1605,
	"./icon_mid@2x.png": 1110,
	"./icon_motorcycle_blue.png": 1606,
	"./icon_motorcycle_blue@2x.png": 1111,
	"./icon_motorcycle_white.png": 1607,
	"./icon_motorcycle_white@2x.png": 1112,
	"./icon_moving.png": 1608,
	"./icon_moving@2x.png": 1113,
	"./icon_moving_w.png": 1609,
	"./icon_moving_w@2x.png": 1114,
	"./icon_movingservice.png": 1610,
	"./icon_movingservice@2x.png": 1115,
	"./icon_movingservice_blue.png": 1611,
	"./icon_movingservice_blue@2x.png": 1116,
	"./icon_movingservice_white.png": 1612,
	"./icon_movingservice_white@2x.png": 1117,
	"./icon_naver.png": 1613,
	"./icon_naver@2x.png": 1118,
	"./icon_newcar_inactive.png": 1614,
	"./icon_newcar_inactive@2x.png": 1119,
	"./icon_notification.png": 1615,
	"./icon_notification@2x.png": 1120,
	"./icon_ordering_hourly_clock.png": 1616,
	"./icon_ordering_hourly_clock@2x.png": 1121,
	"./icon_passengerservice.png": 1617,
	"./icon_passengerservice@2x.png": 1122,
	"./icon_passengervan.png": 1618,
	"./icon_passengervan@2x.png": 1123,
	"./icon_passengervan_w.png": 1619,
	"./icon_passengervan_w@2x.png": 1124,
	"./icon_password.png": 1620,
	"./icon_password@2x.png": 1125,
	"./icon_pets_inactive.png": 1621,
	"./icon_pets_inactive@2x.png": 1126,
	"./icon_phone.png": 1622,
	"./icon_phone@2x.png": 1127,
	"./icon_phone_white.png": 1623,
	"./icon_phone_white@2x.png": 1128,
	"./icon_phone_white_big.png": 1624,
	"./icon_phone_white_big@2x.png": 1129,
	"./icon_porterage_inactive.png": 1625,
	"./icon_porterage_inactive@2x.png": 1130,
	"./icon_question.png": 1626,
	"./icon_question@2x.png": 1131,
	"./icon_question_hover.png": 1627,
	"./icon_question_hover@2x.png": 1132,
	"./icon_rate.png": 1628,
	"./icon_rate@2x.png": 1133,
	"./icon_rate_y.png": 1629,
	"./icon_rate_y@2x.png": 1134,
	"./icon_ridewithgood_blue.png": 1630,
	"./icon_ridewithgood_blue@2x.png": 1135,
	"./icon_ridewithgood_white.png": 1631,
	"./icon_ridewithgood_white@2x.png": 1136,
	"./icon_ridewithgoodsicon.png": 1632,
	"./icon_ridewithgoodsicon@2x.png": 1137,
	"./icon_ridewithgoodsicon_blue.png": 1633,
	"./icon_ridewithgoodsicon_blue@2x.png": 1138,
	"./icon_ridewithgoodsicon_w.png": 1634,
	"./icon_ridewithgoodsicon_white.png": 1635,
	"./icon_ridewithgoodsicon_white@2x.png": 1139,
	"./icon_selected.png": 1636,
	"./icon_selected@2x.png": 1140,
	"./icon_send_to.png": 1637,
	"./icon_send_to@2x.png": 1141,
	"./icon_ser_10ftlorry.png": 1638,
	"./icon_ser_10ftlorry@2x.png": 1142,
	"./icon_ser_14ftlorry.png": 1639,
	"./icon_ser_14ftlorry@2x.png": 1143,
	"./icon_ser_24ftlorry.png": 1640,
	"./icon_ser_24ftlorry@2x.png": 1144,
	"./icon_ser_bike.png": 1641,
	"./icon_ser_bike@2x.png": 1145,
	"./icon_ser_courier.png": 1642,
	"./icon_ser_courier@2x.png": 1146,
	"./icon_ser_delivery.png": 1643,
	"./icon_ser_delivery@2x.png": 1147,
	"./icon_ser_everythingelse.png": 1644,
	"./icon_ser_everythingelse@2x.png": 1148,
	"./icon_ser_moving.png": 1645,
	"./icon_ser_moving@2x.png": 1149,
	"./icon_ser_passenger.png": 1646,
	"./icon_ser_passenger@2x.png": 1150,
	"./icon_ser_smallfreight.png": 1647,
	"./icon_ser_smallfreight@2x.png": 1151,
	"./icon_ser_van.png": 1648,
	"./icon_ser_van@2x.png": 1152,
	"./icon_smallfreight.png": 1649,
	"./icon_smallfreight@2x.png": 1153,
	"./icon_smallfreight_blue.png": 1650,
	"./icon_smallfreight_blue@2x.png": 1154,
	"./icon_smallfreight_white.png": 1651,
	"./icon_smallfreight_white@2x.png": 1155,
	"./icon_steps1.png": 1652,
	"./icon_steps1@2x.png": 1156,
	"./icon_steps1_activated.png": 1653,
	"./icon_steps1_activated@2x.png": 1157,
	"./icon_steps2.png": 1654,
	"./icon_steps2@2x.png": 1158,
	"./icon_steps2_activated.png": 1655,
	"./icon_steps2_activated@2x.png": 1159,
	"./icon_steps3.png": 1656,
	"./icon_steps3@2x.png": 1160,
	"./icon_steps3_activated.png": 1657,
	"./icon_steps3_activated@2x.png": 1161,
	"./icon_to.png": 1658,
	"./icon_to@2x.png": 1162,
	"./icon_twitter.png": 1659,
	"./icon_twitter@2x.png": 1163,
	"./icon_van.png": 1660,
	"./icon_van@2x.png": 1164,
	"./icon_van_blue.png": 1661,
	"./icon_van_blue@2x.png": 1165,
	"./icon_van_white.png": 1662,
	"./icon_van_white@2x.png": 1166,
	"./icon_work_address.png": 1663,
	"./icon_work_address@2x.png": 1167,
	"./icon_youtube.png": 1664,
	"./icon_youtube@2x.png": 1168,
	"./img_404.png": 1665,
	"./img_404@2x.png": 1169,
	"./img_driverprofile_fallback.png": 1666,
	"./img_driverprofile_fallback@2x.png": 1170,
	"./img_step1.png": 1667,
	"./img_step1@2x.png": 1171,
	"./index_hero/gogobusiness/gogovan_logo.png": 1668,
	"./index_hero/gogobusiness/gogovan_logo@2x.png": 1172,
	"./index_hero/gogobusiness/imac.png": 1669,
	"./index_hero/gogobusiness/imac@2x.png": 1173,
	"./india.png": 1670,
	"./india@2x.png": 1174,
	"./map_marker_1.png": 1671,
	"./map_marker_1@2x.png": 1175,
	"./map_marker_2.png": 1672,
	"./map_marker_2@2x.png": 1176,
	"./map_marker_3.png": 1673,
	"./map_marker_3@2x.png": 1177,
	"./map_marker_4.png": 1674,
	"./map_marker_4@2x.png": 1178,
	"./map_marker_5.png": 1675,
	"./map_marker_5@2x.png": 1179,
	"./map_marker_6.png": 1676,
	"./map_marker_6@2x.png": 1180,
	"./map_marker_7.png": 1677,
	"./map_marker_7@2x.png": 1181,
	"./map_marker_8.png": 1678,
	"./map_marker_8@2x.png": 1182,
	"./map_marker_9.png": 1679,
	"./map_marker_9@2x.png": 1183,
	"./map_marker_van.png": 1680,
	"./media_36kr.png": 1681,
	"./media_36kr@2x.png": 1184,
	"./media_appledaily.png": 1682,
	"./media_appledaily@2x.png": 1185,
	"./media_channelnewsasia.png": 1683,
	"./media_channelnewsasia@2x.png": 1186,
	"./media_d100.png": 1684,
	"./media_d100@2x.png": 1187,
	"./media_e27.png": 1685,
	"./media_e27@2x.png": 1188,
	"./media_econtimes.png": 1686,
	"./media_econtimes@2x.png": 1189,
	"./media_ezone.png": 1687,
	"./media_ezone@2x.png": 1190,
	"./media_ibt.png": 1688,
	"./media_ibt@2x.png": 1191,
	"./media_metro_broadcast.png": 1689,
	"./media_metro_broadcast@2x.png": 1192,
	"./media_pcm.png": 1690,
	"./media_pcm@2x.png": 1193,
	"./media_rthk.png": 1691,
	"./media_rthk@2x.png": 1194,
	"./media_singtao.png": 1692,
	"./media_singtao@2x.png": 1195,
	"./media_techcrunch.png": 1693,
	"./media_techcrunch@2x.png": 1196,
	"./media_techinasia.png": 1694,
	"./media_techinasia@2x.png": 1197,
	"./media_thestraitstimes.png": 1695,
	"./media_thestraitstimes@2x.png": 1198,
	"./media_unwire.png": 1696,
	"./media_unwire@2x.png": 1199,
	"./media_weekender.png": 1697,
	"./media_weekender@2x.png": 1200,
	"./media_wsj.png": 1698,
	"./media_wsj@2x.png": 1201,
	"./nav_logo.png": 1699,
	"./nav_logo@2x.png": 1202,
	"./partnerships_ikea.png": 1700,
	"./partnerships_ikea@2x.png": 1203,
	"./partnerships_kfc.png": 1701,
	"./partnerships_kfc@2x.png": 1204,
	"./partnerships_logos_eprint.png": 1702,
	"./partnerships_logos_eprint@2x.png": 1205,
	"./partnerships_logos_spacious.png": 1703,
	"./partnerships_logos_spacious@2x.png": 1206,
	"./partnerships_nike.png": 1704,
	"./partnerships_nike@2x.png": 1207,
	"./partnerships_pizzahut.png": 1705,
	"./partnerships_pizzahut@2x.png": 1208,
	"./partnerships_pricerite.png": 1706,
	"./partnerships_pricerite@2x.png": 1209,
	"./pricing_icon.png": 1707,
	"./pricing_icon@2x.png": 1210,
	"./singapore.png": 1708,
	"./south_korea.png": 1709,
	"./steps_video.png": 1710,
	"./steps_video@2x.png": 1211,
	"./steps_video_hover.png": 1711,
	"./steps_video_hover@2x.png": 1212,
	"./swire.png": 1712,
	"./swire@2x.png": 1213,
	"./taiwan.png": 1713,
	"./verify_sender_phone.png": 1714,
	"./verify_sender_phone@2x.png": 1214,
	"./world_map_dots.png": 1715,
	"./world_map_dots@2x.png": 1215,
	"./yellowtip.png": 1716,
	"./yellowtip@2x.png": 1216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./IMG_2836@2x.png": 1021,
	"./add_image@2x.png": 1022,
	"./button_arrowdown@2x.png": 1023,
	"./clearbutton@2x.png": 1024,
	"./dl_andriod_blue@2x.png": 1025,
	"./dl_android_outline@2x.png": 1026,
	"./dl_apple_blue@2x.png": 1027,
	"./dl_appstore@2x.png": 1028,
	"./dl_appstore_hover_yl@2x.png": 1029,
	"./dl_appstore_outline@2x.png": 1030,
	"./dl_appstore_white@2x.png": 1031,
	"./dl_playstore@2x.png": 1032,
	"./dl_playstore_hover_yl@2x.png": 1033,
	"./dl_playstore_white@2x.png": 1034,
	"./feature_lightbox1_en@2x.png": 1035,
	"./feature_lightbox2@2x.png": 1036,
	"./feature_lightbox3@2x.png": 1037,
	"./feature_lightbox4_en@2x.png": 1038,
	"./feature_lightbox5_en@2x.png": 1039,
	"./feature_lightbox6_en@2x.png": 1040,
	"./hero_iphone_en@2x.png": 1041,
	"./hero_nexus_en@2x.png": 1042,
	"./hero_video@2x.png": 1043,
	"./hero_video_hover@2x.png": 1044,
	"./icon-building-materials-transport@2x.png": 1045,
	"./icon-courier@2x.png": 1046,
	"./icon-delivery@2x.png": 1047,
	"./icon-how-it-work-step1_en@2x.png": 1048,
	"./icon-how-it-work-step2@2x.png": 1049,
	"./icon-how-it-work-step3@2x.png": 1050,
	"./icon-pet-shuttle-service@2x.png": 1051,
	"./icon-right@2x.png": 1052,
	"./icon-send-document@2x.png": 1053,
	"./icon-supplies-moving@2x.png": 1054,
	"./icon-warehouse-transport@2x.png": 1055,
	"./icon_5ton_blue@2x.png": 1056,
	"./icon_5ton_white@2x.png": 1057,
	"./icon_9ton_blue@2x.png": 1058,
	"./icon_9ton_white@2x.png": 1059,
	"./icon_add@2x.png": 1060,
	"./icon_add_disabled@2x.png": 1061,
	"./icon_add_hover@2x.png": 1062,
	"./icon_avatar@2x.png": 1063,
	"./icon_avator40x40@2x.png": 1064,
	"./icon_avator70x70@2x.png": 1065,
	"./icon_birthday@2x.png": 1066,
	"./icon_borrowcart_inactive@2x.png": 1067,
	"./icon_calendar@2x.png": 1068,
	"./icon_calendar_solidblue@2x.png": 1069,
	"./icon_camera@2x.png": 1070,
	"./icon_camera_disabled@2x.png": 1071,
	"./icon_camera_hover@2x.png": 1072,
	"./icon_clear_2@2x.png": 1073,
	"./icon_clear_b@2x.png": 1074,
	"./icon_clock@2x.png": 1075,
	"./icon_clock_small@2x.png": 1076,
	"./icon_constructionwaste_inactive@2x.png": 1077,
	"./icon_courier@2x.png": 1078,
	"./icon_courier_blue@2x.png": 1079,
	"./icon_courier_white@2x.png": 1080,
	"./icon_cross_r@2x.png": 1081,
	"./icon_deliveryservice@2x.png": 1082,
	"./icon_deliveryservice_blue@2x.png": 1083,
	"./icon_deliveryservice_white@2x.png": 1084,
	"./icon_done@2x.png": 1085,
	"./icon_email@2x.png": 1086,
	"./icon_english_inactive@2x.png": 1087,
	"./icon_facebook@2x.png": 1088,
	"./icon_feature1@2x.png": 1089,
	"./icon_feature2@2x.png": 1090,
	"./icon_feature3@2x.png": 1091,
	"./icon_feature4@2x.png": 1092,
	"./icon_feature5@2x.png": 1093,
	"./icon_feature6@2x.png": 1094,
	"./icon_from@2x.png": 1095,
	"./icon_gender@2x.png": 1096,
	"./icon_googleplus@2x.png": 1097,
	"./icon_home_address@2x.png": 1098,
	"./icon_hourlyrental_inactive@2x.png": 1099,
	"./icon_industry@2x.png": 1100,
	"./icon_instagram@2x.png": 1101,
	"./icon_linkedin@2x.png": 1102,
	"./icon_loading_complete@2x.png": 1103,
	"./icon_loading_small@2x.png": 1104,
	"./icon_location_1@2x.png": 1105,
	"./icon_location_2@2x.png": 1106,
	"./icon_locations_full@2x.png": 1107,
	"./icon_longergood_inactive@2x.png": 1108,
	"./icon_mail@2x.png": 1109,
	"./icon_mid@2x.png": 1110,
	"./icon_motorcycle_blue@2x.png": 1111,
	"./icon_motorcycle_white@2x.png": 1112,
	"./icon_moving@2x.png": 1113,
	"./icon_moving_w@2x.png": 1114,
	"./icon_movingservice@2x.png": 1115,
	"./icon_movingservice_blue@2x.png": 1116,
	"./icon_movingservice_white@2x.png": 1117,
	"./icon_naver@2x.png": 1118,
	"./icon_newcar_inactive@2x.png": 1119,
	"./icon_notification@2x.png": 1120,
	"./icon_ordering_hourly_clock@2x.png": 1121,
	"./icon_passengerservice@2x.png": 1122,
	"./icon_passengervan@2x.png": 1123,
	"./icon_passengervan_w@2x.png": 1124,
	"./icon_password@2x.png": 1125,
	"./icon_pets_inactive@2x.png": 1126,
	"./icon_phone@2x.png": 1127,
	"./icon_phone_white@2x.png": 1128,
	"./icon_phone_white_big@2x.png": 1129,
	"./icon_porterage_inactive@2x.png": 1130,
	"./icon_question@2x.png": 1131,
	"./icon_question_hover@2x.png": 1132,
	"./icon_rate@2x.png": 1133,
	"./icon_rate_y@2x.png": 1134,
	"./icon_ridewithgood_blue@2x.png": 1135,
	"./icon_ridewithgood_white@2x.png": 1136,
	"./icon_ridewithgoodsicon@2x.png": 1137,
	"./icon_ridewithgoodsicon_blue@2x.png": 1138,
	"./icon_ridewithgoodsicon_white@2x.png": 1139,
	"./icon_selected@2x.png": 1140,
	"./icon_send_to@2x.png": 1141,
	"./icon_ser_10ftlorry@2x.png": 1142,
	"./icon_ser_14ftlorry@2x.png": 1143,
	"./icon_ser_24ftlorry@2x.png": 1144,
	"./icon_ser_bike@2x.png": 1145,
	"./icon_ser_courier@2x.png": 1146,
	"./icon_ser_delivery@2x.png": 1147,
	"./icon_ser_everythingelse@2x.png": 1148,
	"./icon_ser_moving@2x.png": 1149,
	"./icon_ser_passenger@2x.png": 1150,
	"./icon_ser_smallfreight@2x.png": 1151,
	"./icon_ser_van@2x.png": 1152,
	"./icon_smallfreight@2x.png": 1153,
	"./icon_smallfreight_blue@2x.png": 1154,
	"./icon_smallfreight_white@2x.png": 1155,
	"./icon_steps1@2x.png": 1156,
	"./icon_steps1_activated@2x.png": 1157,
	"./icon_steps2@2x.png": 1158,
	"./icon_steps2_activated@2x.png": 1159,
	"./icon_steps3@2x.png": 1160,
	"./icon_steps3_activated@2x.png": 1161,
	"./icon_to@2x.png": 1162,
	"./icon_twitter@2x.png": 1163,
	"./icon_van@2x.png": 1164,
	"./icon_van_blue@2x.png": 1165,
	"./icon_van_white@2x.png": 1166,
	"./icon_work_address@2x.png": 1167,
	"./icon_youtube@2x.png": 1168,
	"./img_404@2x.png": 1169,
	"./img_driverprofile_fallback@2x.png": 1170,
	"./img_step1@2x.png": 1171,
	"./index_hero/gogobusiness/gogovan_logo@2x.png": 1172,
	"./index_hero/gogobusiness/imac@2x.png": 1173,
	"./india@2x.png": 1174,
	"./map_marker_1@2x.png": 1175,
	"./map_marker_2@2x.png": 1176,
	"./map_marker_3@2x.png": 1177,
	"./map_marker_4@2x.png": 1178,
	"./map_marker_5@2x.png": 1179,
	"./map_marker_6@2x.png": 1180,
	"./map_marker_7@2x.png": 1181,
	"./map_marker_8@2x.png": 1182,
	"./map_marker_9@2x.png": 1183,
	"./media_36kr@2x.png": 1184,
	"./media_appledaily@2x.png": 1185,
	"./media_channelnewsasia@2x.png": 1186,
	"./media_d100@2x.png": 1187,
	"./media_e27@2x.png": 1188,
	"./media_econtimes@2x.png": 1189,
	"./media_ezone@2x.png": 1190,
	"./media_ibt@2x.png": 1191,
	"./media_metro_broadcast@2x.png": 1192,
	"./media_pcm@2x.png": 1193,
	"./media_rthk@2x.png": 1194,
	"./media_singtao@2x.png": 1195,
	"./media_techcrunch@2x.png": 1196,
	"./media_techinasia@2x.png": 1197,
	"./media_thestraitstimes@2x.png": 1198,
	"./media_unwire@2x.png": 1199,
	"./media_weekender@2x.png": 1200,
	"./media_wsj@2x.png": 1201,
	"./nav_logo@2x.png": 1202,
	"./partnerships_ikea@2x.png": 1203,
	"./partnerships_kfc@2x.png": 1204,
	"./partnerships_logos_eprint@2x.png": 1205,
	"./partnerships_logos_spacious@2x.png": 1206,
	"./partnerships_nike@2x.png": 1207,
	"./partnerships_pizzahut@2x.png": 1208,
	"./partnerships_pricerite@2x.png": 1209,
	"./pricing_icon@2x.png": 1210,
	"./steps_video@2x.png": 1211,
	"./steps_video_hover@2x.png": 1212,
	"./swire@2x.png": 1213,
	"./verify_sender_phone@2x.png": 1214,
	"./world_map_dots@2x.png": 1215,
	"./yellowtip@2x.png": 1216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setGoogleMap */
/* harmony export (immutable) */ __webpack_exports__["b"] = setQuotingMapLocation1;
/* harmony export (immutable) */ __webpack_exports__["c"] = setQuotingMapLocation2;
/* unused harmony export setVehiclePrice */
/* unused harmony export setQuotingIsGetQuoting */
/* harmony export (immutable) */ __webpack_exports__["a"] = setIsDraggingMap;
/* unused harmony export setIsNoQuotingService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(35);
/* eslint-disable import/prefer-default-export */

function setGoogleMap(map) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_0" /* QUOTING_GOOGLE_MAP */],
      payload: map
    });
  };
}
function setQuotingMapLocation1(address) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["Y" /* QUOTING_ADDRESS_1 */],
      payload: address
    });
  };
}
function setQuotingMapLocation2(address) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* QUOTING_ADDRESS_2 */],
      payload: address
    });
  };
}
function setVehiclePrice(price, vehicleType) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_3" /* QUOTING_SET_VEHICLE_PRICE */],
      price: price,
      vehicle: vehicleType
    });
  };
}
function setQuotingIsGetQuoting(bool) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_1" /* QUOTING_IS_GET_QUOTE */],
      payload: bool
    });
  };
}
function setIsDraggingMap(bool) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* IS_DRAGGING_MAP */],
      payload: bool
    });
  };
}
function setIsNoQuotingService(bool) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_2" /* QUOTING_IS_NO_SERVICE */],
      payload: bool
    });
  };
}

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2192e7de.png";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10fa2677.png";

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "74d07355.png";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6618e9f6.png";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "52d2c854.png";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e1e4036.png";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d2c5e0e.png";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d7909f4.png";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "902fd619.png";

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = {"lang":"zh-HK","lang_lib":"zh-TW","lang_img":"tc","lang_text":"繁體中文（香港）","links":{"home":"/order"},"order":{"dollar_code":"$","dollar_price":"${{price}}","pick_up_time_title":"上車時間","contact_info_title":"聯絡人資料","contact_info_nickname_input":"名字","contact_info_phone_input":"電話","contact_info_email_input":"電郵地址","contact_info_nickname_input_warning":"請填寫你的名字","contact_info_phone_input_warning":"請填寫正確的電話號碼","contact_info_email_input_warning":"您的電郵無效","input_empty_warning":"請輸入未填寫的資料","price_total_amount":"總數","pickup_datetime_input_warning":"叫車時間一定要在未來","order_title":"Order GoGoVan - HK","order_headline":"新的柯打","order_add_image_button":"添加貨物照片","order_add_image_max_size_desc":"不超過 2MB","order_goods_image_desc":"貨物照片","order_hourly_title":"包鐘","order_hourly_body":"包鐘係以時間作為單位之落單方式。","order_hourly_minimum":"每次最少3個鐘","order_hourly_detail_button":"查看包鐘收費詳情","order_hourly_hour":"  小時","order_route_input_warning":"請填上地址","order_option_passenger_title":"人數","order_option_passenger_body":"人","order_option_passenger_body_plural":"人","order_option_tunnel_title":"隧道","order_option_tunnel_any":"無所謂","order_option_tunnel_hung":"紅磡隧道","order_option_tunnel_western":"西區隧道","order_option_tunnel_eastern":"東區隧道","order_option_tunnel_lion_rock":"獅子山隧道","order_option_tunnel_tates_cairn":"大老山隧道","order_option_tunnel_eagles_nest":"尖山隧道／沙田嶺隧道","order_option_tunnel_tai_lam":"大欖隧道","order_option_tunnel_aberdeen":"香港仔隧道","order_option_tunnel_tko":"將軍澳隧道","order_option_tunnel_tm_bridge":"青馬隧道／青嶼幹線","order_option_tunnel_discovery":"愉景灣隧道","order_option_tunnel_shing_mun":"城門隧道","order_option_route_title":"路線設定","order_option_route_location_1_address_input":"起點","order_option_route_location_2_address_input":"目的地","order_option_route_view_on_map_button":"地圖上顯示","order_option_route_view_on_map_button_mobile":"地圖","order_option_route_add_address_button":"增加中途點","order_vehicle_title":"選擇車種","order_vehicle_type_van":"貨VAN","order_vehicle_type_mudou":"5.5  噸貨車","order_vehicle_type_mudou9":"9  噸貨車","order_promo_code_if_any_title":"優惠券# (如有)","order_promo_code_title":"優惠券#","order_promo_code_input":"請在此輸入優惠卷編號","order_promo_input_warning":"請輸入有效的優惠卷編號","order_promo_code_confirm_button":"提交","order_promo_code_cancel_button":"取消","order_additional_service_title":"附加服務","order_additional_service_detail_button":"詳情","order_additional_service_need_over_6ft":"貨物長度超過6呎","order_additional_service_remove_net_half":"貨物長度超過6呎 &nbsp; ($20)","order_additional_service_remove_net_full":"貨物長度超過6呎，而且高度超過2呎 &nbsp; ($40)","order_additional_service_need_cart":"租借車仔／板車 &nbsp; (每部 &nbsp; $10)","order_additional_service_cart":"部","order_additional_service_need_carry":"搬運 &nbsp; (上樓) &nbsp; ($ &nbsp; 請與司機議價)","order_additional_service_need_pet":"載寵物 &nbsp; ($10 &nbsp; 隻數不限)","order_additional_service_need_new_car":"新車","order_additional_service_need_waste":"建築廢料 &nbsp; ($ &nbsp; 請與司機議價)","order_additional_service_mudou_need_cart":"借唧車 &nbsp; (每部 &nbsp; $20)","order_remark_title":"備註 (可選填)","order_remark_body":"例如：要搬什麼，貨物尺寸等等","order_review_order_button":"確認柯打","order_restricted_area_warning":"<h2>禁區提示</h2><br />下列地點僅限持有有效許可證人士進出","order_restricted_area_ps":"如您沒有有效許可證，車費需與司機另議。GOGOVAN 會有專員提供協助，詳情請致電 <span class='blue'>35903399</span> 查詢。","order_restricted_area_error_message":"地點僅限持有有效許可證⼈⼠進出","order_restricted_area_have_permit":"我持有有效許可證","order_restricted_area_no_permit":"我沒有許可證","order_restricted_area_question":"沒有許可證","order_restricted_area_question_title":"沒有許可證?","order_restricted_area_confirm":"我知道了","order_restricted_area_out_error_msg":"地點不在服務範圍內","order_restricted_area_out_ps":"您所選擇的地點不在服務範圍內，GOGOVAN 會有專員提供協助，詳情請致電 <span class='blue'>35903399</span> 查詢。","order_restricted_area_both_ps":"GOGOVAN 會有專員提供協助,詳情請致電 <span class='blue'>35903399</span> 查詢。","order_restricted_area_both_find_driver":"尋找有許可證司機","order_summary_title":"柯打詳情","order_summary_passenger_title":"人數","order_summary_tunnel_title":"隧道","order_summary_order_confirm_button":"確認柯打","order_summary_order_edit_button":"修改","order_summary_bonus_dialog_button":"小費","order_summary_route_title":"設定路線","order_summary_route_view_on_map_button":"在地圖上顯示","order_summary_route_view_on_map_button_mobile":"地圖","order_summary_show_order_detail_button":"檢視我的柯打","order_summary_hide_order_detail_button":"收起詳細柯打","order_summary_order_cancel_button":"取消柯打","order_summary_driver_title":"司機信息","order_summary_driver_body":"正在指派司機．．．．．","order_summary_driver_rate_driver_button":"給司機評分","order_summary_block_driver_button":"加入黑名單","order_summary_pickup_time":"上車時間","order_summary_vehicle_title":"車種","order_summary_remark_title":"備註","order_summary_charge_title":"收費項目","order_summary_charge_tips":"小費","order_summary_charge_why_tips_button":"(自選)","order_summary_charge_coupon":"優惠卷","order_summary_tips_title":"小費","order_summary_payment_title":"支付方式","order_summary_payment_message":"以上價錢並未包括隧道費，橋費，停車場費及所有雜費，請於上車前與司機確認收費。","order_summary_payment_price_table_button":"按此查閱收費表","order_summary_payment_method":"支付現金予司機","order_dialog_info_bonus_title":"小費說明","order_dialog_info_bonus_body":"小費能吸引更多司機接您的柯打, 加快您的叫車速度, 有助解決您在繁忙時間內叫不到車的煩惱。","order_dialog_info_bonus_body_2":"","service_content_headline":"服務說明","service_content_content":"GoGoVan 提供不同車種和多項附加服務*。叫車時加選附加服務，在確保服務質素的同時，亦能提高運輸效率。 *部分服務有附加收費。","service_content_fleets_header":"車種","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"貨Van","service_content_icon_ser_van_body":"最多可載5人 (不包括司機)；載重約700公斤；內籠尺寸約為長5.5呎、高4呎、闊4呎。","service_content_icon_ser_10ftlorry_title":"5.5噸貨車","service_content_icon_ser_10ftlorry_body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","service_content_icon_ser_14ftlorry_title":"9噸貨車","service_content_icon_ser_14ftlorry_body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","service_content_additional_header":"附加服務","service_content_english_speaking_driver_title":"英語司機","service_content_english_speaking_driver_body":"要求司機可使用英語對話。","service_content_goodsg_longer_than_6ft_title":"貨物超過6呎長","service_content_goodsg_longer_than_6ft_body":"如貨物長度超過6呎，但重量不足700公斤，建議選擇車種為「貨Van」，再選擇該項附加服務。貨Van內籠經調節後可加長至8呎。如您的貨物長度超過6呎、而且高度超過2呎，建議在選單中選擇「超過半網高度」。","service_content_borrow_carts_title":"租用手推車／板車","service_content_borrow_carts_body":"手推車／板車為輔助搬貨、運貨的工具。手推車通常為鐵質材料，有手柄，適用於運送體積較小、件數較多的貨物，如紙皮箱等。板車為木板材質，適用於運送單件、體積較大的貨物，如大型衣櫃等。","service_content_forklift_rental_title":"租用唧車","service_content_forklift_rental_body":"唧車為輔助搬貨、運貨的工具，可手動升降貨物高度，適用於使用5.5噸貨車或9噸貨車運送的貨物。","service_content_mover_title":"幫搬","service_content_mover_body":"如您需要司機幫您搬貨，請在上貨前列明貨物種類及數量，並與司機議價。","service_content_pets_title":"接載寵物","service_content_pets_body":"可接送您的寵物。不限隻數。","service_content_new_vehicle_title":"新車","service_content_new_vehicle_body":"為您優先安排較新的貨車。","service_content_dumper_construction_waste_title":"運載泥頭／建築廢料","service_content_dumper_construction_waste_body":"如您需要運載工業建築廢料，而且廢料的體積、重量在車輛載重範圍之內，請選擇該項附加服務。","service_content_hourly_header":"包鐘","service_content_hourly_rental_body":"若用戶租用貨車超過三小時，建議使用包鐘服務， 車費以每半小時為單位計算。包鐘較適用於同一個柯打中有多個中途點，或路程中需要較長等候時間的情況。","order_hourly_price_dialog_title":"包鐘收費表","order_hourly_price_dialog_hourly_title":"基本包鐘收費","order_hourly_price_dialog_overtime_title":"超時收費","order_hourly_price_dialog_normal_time":"星期一至六 07:00 - 20:59","order_hourly_price_dialog_normal_overtime":"星期一至六 21:00 - 06:59","order_hourly_price_dialog_holiday_normal_time":"星期日及公眾假期 07:00 - 20:59","order_hourly_price_dialog_holiday_overtime":"星期一至六 21:00 - 06:59","order_hourly_price_dialog_van_type":"貨Van","order_hourly_price_dialog_van_normal_hourly_price":"$110/小時","order_hourly_price_dialog_van_other_hourly_price":"$135/小時","order_hourly_price_dialog_van_normal_overtime_price":"$10/5分鐘, 不夠5分鐘當5分鐘計","order_hourly_price_dialog_van_other_overtime_price":"$12/5分鐘, 不夠5分鐘當5分鐘計","order_hourly_price_dialog_5_ton_truck_type":"5.5噸貨車","order_hourly_price_dialog_5_ton_truck_normal_hourly_price":"$180/小時","order_hourly_price_dialog_5_ton_truck_other_hourly_price":"$220/小時","order_hourly_price_dialog_5_ton_truck_normal_overtime_price":"$15/5分鐘, 不夠5分鐘當5分鐘計","order_hourly_price_dialog_5_ton_truck_other_overtime_price":"$18/5分鐘, 不夠5分鐘當5分鐘計","order_hourly_price_dialog_9_ton_truck_type":"9噸貨車","order_hourly_price_dialog_9_ton_truck_normal_hourly_price":"$250/小時","order_hourly_price_dialog_9_ton_truck_other_hourly_price":"$320/小時","order_hourly_price_dialog_9_ton_truck_normal_overtime_price":"$18/5分鐘, 不夠5分鐘當5分鐘計","order_hourly_price_dialog_9_ton_truck_other_overtime_price":"$21/5分鐘, 不夠5分鐘當5分鐘計"}}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-IN","lang_lib":"en","lang_img":"en","lang_text":"English (India)","links":{"home":"/order"},"order":{"dollar_code":"₹","dollar_price":"₹{{price}}","pick_up_time_title":"PICK UP TIME","contact_info_title":"CONTACT INFO","contact_info_nickname_input":"Name","contact_info_phone_input":"Phone #","contact_info_email_input":"Email","contact_info_nickname_input_warning":"Please fill your name.","contact_info_phone_input_warning":"Please input a valid phone number.","contact_info_email_input_warning":"Please fill in a valid email address.","input_empty_warning":"Please fill in all the missing information in red.","price_total_amount":"TOTAL","pickup_datetime_input_warning":"Booking must be made in the future.","order_title":"Order GoGoVan - HK","order_headline":"New Order","order_add_image_button":"ADD IMAGE","order_add_image_max_size_desc":"MAX. 2MB","order_goods_image_desc":"IMAGES OF DELIVERY ITEMS","order_route_input_warning":"Please fill in the address","order_option_passenger_title":"PASSENGERS","order_option_passenger_body":"Passenger","order_option_passenger_body_plural":"Passengers","order_option_route_title":"ROUTE","order_hourly_title":"Hourly Rental","order_hourly_body":"This option calculates fees based on every half-hour. ","order_hourly_minimum":"We recommend this option if you would like to rent GoGoVan for 3 hours or more due to many mid-points/stops in the trip, or if you expect a long waiting time during the trip.","order_hourly_detail_button":"DETAIL","order_hourly_hour":"  hrs","order_hourly_kms":"  kms","order_movers_title":"MOVERS","order_option_route_location_1_address_input":"Enter a Pickup Point","order_option_route_location_2_address_input":"Enter a Destination","order_option_route_view_on_map_button":"VIEW MAP","order_option_route_view_on_map_button_mobile":"MAP","order_option_route_add_address_button":"Add a Location","order_vehicle_title":"VEHICLE TYPE","order_vehicle_type_tata_ace":"Tata Ace","order_vehicle_type_tata_407":"Tata 407","order_vehicle_type_tata_super_ace":"TATA SUPER ACE / ASHOK LEYLAND - DOST / MAHINDRA BOLERO PICKUP","order_vehicle_type_eicher_14":"Eicher 14 Feet","order_vehicle_type_eicher_17":"Eicher 17 Feet","order_vehicle_type_eicher_19":"Eicher 19 Feet","order_promo_code_title":"COUPON CODE","order_promo_code_if_any_title":"COUPON CODE?","order_promo_code_input":"Coupon Code / no #","order_promo_input_warning":"Please fill in a valid coupon code.","order_promo_code_confirm_button":"APPLY","order_promo_code_cancel_button":"CANCEL","order_additional_service_title":"EXTRA SERVICES (OPTIONAL)","order_remark_title":"REMARKS (OPTIONAL)","order_remark_body":"e.g What to move, Dimensions of Goods etc.","order_review_order_button":"REVIEW ORDER","order_summary_title":"Order summary","order_summary_order_confirm_button":"FIND A DRIVER","order_summary_order_edit_button":"EDIT","order_summary_bonus_dialog_button":"Bonus","order_summary_route_title":"ROUTE","order_summary_route_view_on_map_button":"VIEW MAP","order_summary_route_view_on_map_button_mobile":"MAP","order_summary_show_order_detail_button":"VIEW ORDER DETAIL","order_summary_hide_order_detail_button":"CLOSE ORDER DETAIL","order_summary_order_cancel_button":"CANCEL ORDER","order_summary_driver_title":"DRIVER INFO","order_summary_driver_body":"ASSIGNING DRIVER...","order_summary_driver_rate_driver_button":"RATE DRIVER","order_summary_block_driver_button":"BLOCK","order_summary_pickup_time":"PICKUP TIME","order_summary_vehicle_title":"VEHICLE TYPE","order_summary_remark_title":"REMARKS","order_summary_charge_title":"FEE BREAKDOWN","order_summary_charge_tips":"Bonus","order_summary_charge_why_tips_button":"(Optional)","order_summary_charge_coupon":"Coupon","order_summary_tips_title":"Why Give Bonus?","order_summary_payment_title":"PAYMENT METHOD","order_summary_payment_message":"The above fees are calculated based on the closest pricing regions to your pickup / delivery points. They do not include car park fees and all other misc. fees. Please confirm with driver the total price on boarding.","order_summary_payment_price_table_button":"Tap here for fee details","order_summary_payment_method":"By Cash (to driver)","order_dialog_info_bonus_title":"Why Give Bonus?","order_dialog_info_bonus_body":"Bonus can help attract more drivers to your booking, increasing the speed to your response. This can be useful if you want to make a booking during peak hours."}}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = {"lang":"kr","lang_lib":"kr","lang_img":"kr","lang_text":"한국어 (한국)","links":{"home":"/order"},"order":{"order_headline":"주문서 작성","order_service_title":"서비스","order_goods_title":"배송 물품","order_vehicle_title":"차량","dollar_code":"원","dollar_price":"{{price}} 원","pick_up_time_title":"픽업 시간","order_route_floor_unit":"상세 주소","contact_info_title":"보내는 분","contact_info_sender_title":"보내는 분","contact_info_recipient_title":"받으실 분","contact_info_nickname_input":"이름","contact_info_phone_input":"핸드폰 번호","contact_info_email_input":"이메일","contact_info_nickname_input_warning":"이름을 입력해주세요","contact_info_phone_input_warning":"핸드폰 번호를 입력해주세요","contact_info_email_input_warning":"이메일 주소를 입력해주세요","contact_info_recipient_nickname_input":"성함","contact_info_recipient_phone_input":"연락처","input_empty_warning":"누락된 정보를 입력해주세요","price_total_amount":"최종 요금 합계","pickup_datetime_input_warning":"미래 시간에 대한 주문 접수만 가능합니다","order_will_my_item_fit_into_the_vehicle":"배송하실 물품의 크기를 고려하셨나요?","order_add_image_button":"사진 추가","order_add_image_max_size_desc":"파일 최대 크기 : 2MB","order_parcel_title":"30 X 30 X 30, 10KG 이내","order_parcel_big_title":"50 X 50 X 50, 20KG 이내","order_movers_departure_title":"출발지 추가 수작업 인원","order_movers_destination_title":"도착지 추가 수작업 인원","order_route_input_warning":"누락된 주소를 입력해주세요","order_option_route_title":"경로","order_option_route_location_1_address_input":"출발지를 입력해주세요","order_option_route_location_2_address_input":"도착지를 입력해주세요","order_option_route_view_on_map_button":"지도 보기","order_option_route_view_on_map_button_mobile":"지도","order_option_route_add_address_button":"경유지 추가","order_promo_code_title":"쿠폰","order_promo_code_if_any_title":"쿠폰을 사용하시겠습니까?","order_promo_code_input":"여기에 쿠폰 코드를 입력해주세요","order_promo_input_warning":"쿠폰 코드를 입력해주세요","order_promo_code_confirm_button":"적용","order_promo_code_cancel_button":"취소","order_additional_service_title":"기타 서비스 (선택)","order_remark_title":"기타 요청 사항 (선택)","order_remark_body":"무엇을 옮기시나요? 몇 가지의, 얼마나 큰 짐들인가요? ","order_remark_body_2":"기타 요청 사항 (선택)","order_summary_title":"서비스 요약","order_summary_service_title":"서비스 유형","order_summary_transport_item_title":"배송 물품 정보","order_summary_vehicle_title":"차량","order_summary_remark_title":"기타 요청 사항 (선택)","order_summary_remark_title_show":"기타 요청 사항","order_summary_route_title":"경로","order_summary_route_view_on_map_button":"지도 보기","order_summary_route_view_on_map_button_mobile":"지도 보기","order_summary_charge_title":"요금 상세","order_summary_payment_message":"물품의 특이사항 혹은 특별 배송 요청을 원하시면, 기사님께 말씀해주시기 바랍니다. 원룸이나 소 사무실 이전은 기사님과의 상세한 협의가 필요합니다.","order_summary_payment_price_table_button":"추가 비용에 대한 자세한 설명은 여기를 클릭하세요","order_summary_payment_title":"결제 방법","order_summary_payment_method":"현금 결제","order_summary_charge_tips":"보너스","order_summary_charge_why_tips_button":"(선택)","order_summary_order_confirm_button":"기사님 검색","order_summary_order_edit_button":"변경","order_review_order_button":"주문 확인","order_vehicle_type_motorcycle":"오토바이","order_vehicle_type_damas":"다마스","order_vehicle_type_labo":"라보","order_vehicle_type_van":"밴","order_vehicle_type_ton1":"1톤","order_vehicle_type_ton1_2_and_ton1_4":"1.2톤&1.4톤","order_dialog_info_bonus_title":"추가 보너스","order_dialog_info_bonus_body":"추가 보너스는 기사님이 주문에 대해 조금 더 빠른 시간 내에 응답 할 수 있도록 도와드립니다.","order_dialog_info_bonus_body_2":"보너스 추가를 통해 피크 시간대의 예약을 조금 더 수월하게 진행 하실 수 있습니다.","item_fit_headline":"차량별 물품 규격 확인","item_fit_content":"고고밴 코리아는 퀵 서비와 화물 운송 서비스를 모두 제공하고 있습니다.","item_fit_content_2":"배송할 물품의 크기가 너무 크다고 생각되시면 주문 접수 시, 자세한 메모를 남겨주세요.","service_not_available_headline":"대형화물 / 기업화물","service_not_available_content":"대형화물 및 기업화물의 배송을 원하시는 경우 고고밴코리아 고객센터 1588-3047으로 연락주시기 바랍니다.","order_carry_disclaimer_1":"물품 운반 요청 시, 추가 요금이 발생됩니다.","order_carry_disclaimer_2":"주문 접수 이후, 기사님과의 협의를 위해 고고밴 고객센터 1588-3047로 연락주세요."}}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = {"lang":"en","lang_lib":"en","lang_img":"en","lang_text":"English (Singapore)","links":{"home":"/order"},"order":{"order_headline":"New Order","order_service_title":"SERVICE TYPE","order_goods_title":"DELIVERY ITEM","order_vehicle_title":"VEHICLE TYPE","dollar_code":"S$ ","dollar_price":"S${{price}}","pick_up_time_title":"PICK-UP TIME","order_route_floor_unit":"#floor-unit","contact_info_title":"CONTACT INFO","contact_info_sender_title":"SENDER'S CONTACT INFO","contact_info_recipient_title":"RECIPIENT'S CONTACT INFO","contact_info_nickname_input":"Sender's Name","contact_info_phone_input":"Sender's Contact No.*","contact_info_email_input":"Sender's Email","contact_info_nickname_input_warning":"Please fill your name.","contact_info_phone_input_warning":"Please fill in a valid mobile number.","contact_info_email_input_warning":"Please fill in a valid email.","contact_info_recipient_nickname_input":"Recipient's Name","contact_info_recipient_phone_input":"Recipient's Contact No.","input_empty_warning":"Please fill in all the missing information in red.","price_total_amount":"TOTAL","pickup_datetime_input_warning":"Booking must be made in the future.","order_will_my_item_fit_into_the_vehicle":"WILL MY ITEM FIT INTO THE VEHICLE?","order_add_image_button":"ADD IMAGE","order_add_image_max_size_desc":"MAX. 2MB","order_parcel_title":"30 X 20 X 20CM (PER UNIT)","order_movers_title":"MOVERS","order_route_input_warning":"Please fill in the address","order_option_route_title":"ROUTE","order_option_route_location_1_address_input":"Enter a Pick-up point","order_option_route_location_2_address_input":"Enter a Drop-off Point","order_vehicle_type_van":"Van","order_vehicle_type_sedan":"Sedan","order_vehicle_type_motorcycle":"motorcycle","order_vehicle_type_lorry10":"10 ft. Lorry","order_vehicle_type_lorry14":"14 ft. Lorry","order_vehicle_type_lorry24":"24 ft. Lorry","order_vehicle_type_van12":"Passenger Van","order_option_route_view_on_map_button":"VIEW MAP","order_option_route_view_on_map_button_mobile":"MAP","order_option_route_add_address_button":"Add Additional Drop-off Point(s)","order_summary_charge_title":"FEE BREAKDOWN","order_promo_code_title":"PROMO CODE","order_promo_code_if_any_title":"PROMO CODE?","order_promo_code_input":"Enter promo code here","order_promo_input_warning":"Please fill in a valid coupon code.","order_promo_code_confirm_button":"APPLY","order_promo_code_cancel_button":"CANCEL","order_additional_service_title":"ADDITIONAL SERVICES (OPTIONAL)","order_remark_title":"REMARKS (OPTIONAL)","order_remark_body":"Item description (e.g. number of luggage, vehicle required etc.)","order_summary_mover_title":"MOVERS","order_review_order_button":"REVIEW ORDER","item_fit_headline":"Will my items fit into the vehicle?","item_fit_content":"Our delivery service vehicles include motorcycles, sedans, and vans.If you think your items will be too large for our vehicles, please write a note and upload a photo of the items on our app. We will take care of the rest.","item_fit_content_2":"","order_summary_service_title":"SERVICE","meta":{"description":"Place a Same Day Delivery order with GoGoVan and get your items moving.","og:title":"Same Day Delivery Order | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/order","og:description":"Place a Same Day Delivery order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan"}}}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = {"lang":"tw","lang_lib":"tw","lang_img":"tc","lang_text":"正體中文（台灣）","links":{"home":"/order"},"order":{"dollar_code":"NT$","dollar_price":"NT${{price}}","pick_up_time_title":"預約收件時間","contact_info_receiver_title":"收件人資料","contact_info_title":"寄件人資料","contact_info_nickname_input":"姓名","contact_info_phone_input":"電話 ex: 0225021000","contact_info_phone_ext_input":"市話分機","contact_info_email_input":"電郵","contact_info_nickname_input_warning":"請填寫你的名字","contact_info_phone_input_warning":"請填寫正確的電話號碼","contact_info_email_input_warning":"您的電郵無效","input_empty_warning":"請輸入未填寫的資料","price_total_amount":"總金額","pickup_datetime_input_warning":"訂單時間必須是晚於現在的時間","proxy_payment_input_warning":"請填寫代購／代付金額","order_title":"Order GoGoVan - HK","order_headline":"新的訂單","order_add_image_button":"上傳照片","order_add_image_max_size_desc":"不超過 2MB","order_goods_image_desc":"貨物照片","order_goods_title":"貨物類型","order_route_input_warning":"請填上地址","order_option_route_location_1_address_input":"輸入出發地","order_option_route_location_2_address_input":"輸入目的地","order_option_route_view_on_map_button":"在地圖上顯示","order_option_route_view_on_map_button_mobile":"地圖","order_option_route_add_address_button":"增加地點","order_route_floor_unit":"樓層及房屋資訊(選填)","order_vehicle_title":"車種","order_vehicle_type_motorcycle":"機車","order_vehicle_type_struck":"廂型貨車","order_vehicle_type_mtruck":"貨車(1.75噸)","order_promo_code_title":"優惠券#","order_promo_code_if_any_title":"使用優惠券","order_promo_code_input":"請在此輸入優惠卷編號","order_promo_input_warning":"請輸入有效的優惠卷編號","order_promo_code_confirm_button":"提交","order_promo_code_cancel_button":"取消","order_additional_service_title":"加值服務","order_additional_service_detail_button":"詳情","order_additional_service_need_over_6ft":"貨物長度超過6呎","order_additional_service_remove_net_half":"貨物長度超過6呎 &nbsp; ($10)","order_additional_service_remove_net_full":"貨物長度超過6呎，而且高度超過2呎 &nbsp; ($20)","order_additional_service_need_cart":"租借車仔／板車 &nbsp; (每部 &nbsp; $10)","order_additional_service_cart":"部","order_remark_body":"發票相關備註","order_remark_body_type":"備註 (有什麼話要跟司機說?)","order_review_order_button":"確認訂單","order_summary_title":"訂單詳情","order_summary_passenger_title":"人數","order_summary_goods_title":"貨物類型","order_summary_order_confirm_button":"確認訂單","order_summary_order_edit_button":"修改","order_summary_bonus_dialog_button":"小費","order_summary_route_title":"設定路線","order_summary_route_view_on_map_button":"在地圖上顯示","order_summary_route_view_on_map_button_mobile":"地圖","order_summary_show_order_detail_button":"檢視我的訂單","order_summary_hide_order_detail_button":"收起詳細訂單","order_summary_order_cancel_button":"取消訂單","order_summary_driver_title":"司機信息","order_summary_driver_body":"正在指派司機．．．．．","order_summary_driver_rate_driver_button":"給司機評分","order_summary_block_driver_button":"加入黑名單","order_summary_pickup_time":"上車時間","order_summary_vehicle_title":"車種","order_summary_remark_title":"備註","order_summary_charge_title":"收費項目","order_summary_charge_tips":"小費","order_summary_charge_why_tips_button":"(自選)","order_summary_charge_coupon":"優惠卷","order_summary_tips_title":"小費","order_summary_payment_title":"支付方式","order_summary_payment_message":"以上價錢請與司機確認運費，並將運費交給司機。","order_summary_payment_price_table_button":"按此查閱收費表","order_summary_payment_method":"支付現金予司機","order_dialog_info_bonus_title":"小費說明","order_dialog_info_bonus_body":"小費能吸引更多司機接您的訂單, 加快您的叫車速度, 有助解決您在繁忙時間內叫不到車的煩惱。","order_dialog_info_bonus_body_2":"","uniform_invoice_title":"發票相關欄位","uniform_invoice_email_name_input":"姓名 (必填)","uniform_invoice_email_input":"電郵","uniform_invoice_postal_address_input":"發票寄送地址 (如需實體發票)","uniform_invoice_email_company_id_input":"公司統一編號","uniform_invoice_remark_input":"其他備註 (如有)","uniform_invoice_email_name_input_warning":"姓名為必填欄位","uniform_invoice_email_input_warning":"您的電郵無效","uniform_invoice_email_company_id_input_warning":"請輸入8位統一編號","uniform_invoice_email_and_postal_address_input_emapty_warning":"電郵及發票寄送地址必擇一填寫"}}

/***/ }),
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e23b321.png";

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = {"orderDetailInfo":{"hk":{"service_type":"","order_request_detail_attributes":{"cart_count":"1","passenger_count":"0","remove_net":"half"},"order_request_extra_attributes":{"email_address":""},"vehicle":"","pickup_time":"","phone_number":"","nickname":"","routes":[],"tunnel":"any","waypoints_attributes":[]},"tw":{"goods":"1","nickname":"","order_request_detail_attributes":{"passenger_count":"0"},"order_request_extra_attributes":{"email_address":""},"phone_number":"","pickup_time":"","routes":[],"service_type":"","vehicle":"","waypoints_attributes":[]},"in":{"nickname":"","service_type":"","order_request_detail_attributes":{"passenger_count":"0","rent_hours":""},"order_request_extra_attributes":{"email_address":""},"vehicle":"","pickup_time":"","phone_number":"","routes":[],"waypoints_attributes":[]},"kr":{"nickname":"","service_type":"moving","order_request_detail_attributes":{"passenger_count":"1"},"order_request_extra_attributes":{"email_address":""},"payment_method":"cash","vehicle":"","pickup_time":"","phone_number":"","routes":[],"waypoints_attributes":[]},"sg":{"nickname":"","goods":"Parcel","service_type":"delivery","order_request_detail_attributes":{"additional_cartons":"1"},"order_request_extra_attributes":{"email_address":""},"vehicle":"sedan","pickup_time":"","phone_number":"","routes":[],"waypoints_attributes":[]}}}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f8f4d45.png";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd95686a.png";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7324e49a.png";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e07a77d5.png";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba118927.png";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b319563.png";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed6445d6.png";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd579a56.png";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fdbec319.png";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d8e404c.png";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91d7575f.png";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5a19cb8.png";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8212de89.png";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02fac2f1.png";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f480d88d.png";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1b8d211.png";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e611d2f.png";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57b82ae2.png";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6c4da049.png";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e9649ef7.png";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0345b7ca.png";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "55156db3.png";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5603b46d.png";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3df0996c.png";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50be8769.png";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "73f18e0e.png";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c375992c.png";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e7b2ad93.png";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e88ff60.png";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f88f6762.png";

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8329143f.png";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c863dfc5.png";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "acbfb3c3.png";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4be466d5.png";

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f2c153cb.png";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "873f2654.png";

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a96298e1.png";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0234bd14.png";

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03ab41e4.png";

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1915f25.png";

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ecdb4c0.png";

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf9f2e7a.png";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49c91d93.png";

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9906b8ac.png";

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18b853e3.png";

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed1149cf.png";

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5c1aa3f9.png";

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed91b799.png";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "82882016.png";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95e06b1c.png";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c289584.png";

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9aca2e25.png";

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "59235afd.png";

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba3c1d1d.png";

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "716b8e7b.png";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ce07b25.png";

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8b9b95cd.png";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c02aa7a2.png";

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c02aa7a2.png";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "70f04e78.png";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db134604.png";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eefa6089.png";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eefa6089.png";

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ab16ceb.png";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d1a3888e.png";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "66bc4bfa.png";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e6c39167.png";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33129f11.png";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43b8baff.png";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "96eb8fa4.png";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "066d4f47.png";

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4be5219.png";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "104f0605.png";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97248481.png";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ad172d8.png";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ffce525.png";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ff7d997.png";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff92958e.png";

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b66d40e5.png";

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "93ffe788.png";

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75cbabaa.png";

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f609204.png";

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db7a6b27.png";

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50568ee3.png";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a9674300.png";

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "522450d1.png";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49195f4b.png";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b420c3f1.png";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4924b3dd.png";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "efc108d4.png";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6abac02.png";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d31552c.png";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6749d609.png";

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2da99b44.png";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6749d609.png";

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6749d609.png";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0aa9caea.png";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7ff2eeb.png";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3b214fa.png";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9fb53d3d.png";

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc92b1c2.png";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11cf604b.png";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11cf604b.png";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e6f8aff4.png";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3aacb3c3.png";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "273b2e35.png";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14ce91d1.png";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e45fe92.png";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0512ba1f.png";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6072339d.png";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "981efb53.png";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e27b88c1.png";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33b30345.png";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "afe822dc.png";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eefa6089.png";

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ab16ceb.png";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eefa6089.png";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eefa6089.png";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "afca4307.png";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "07b8a418.png";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d0532e55.png";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "759f1387.png";

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "881ba06f.png";

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1681aba6.png";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1404cc87.png";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3f9eff21.png";

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83f40542.png";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57e59bb5.png";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "591c008c.png";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "422e2226.png";

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f808b703.png";

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "274d5151.png";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca96125b.png";

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca96125b.png";

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a62393ba.png";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bc698a19.png";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e36605f.png";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2169ca68.png";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bfe2ba30.png";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bebc176.png";

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f350b9b9.png";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20d780bf.png";

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f191473c.png";

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1169bccd.png";

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0bf02df5.png";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49429e91.png";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9bedd7ed.png";

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "957c9f7d.png";

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7a244b3.png";

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5cbf312.png";

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae54d346.png";

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5749bd41.png";

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37ad2047.png";

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a8aedd82.png";

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6d6d179.png";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "abffac10.png";

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29be029c.png";

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1868af44.png";

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8099f517.png";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da4599e7.png";

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e6d63af6.png";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7c47e3f3.png";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ab765ad.png";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5ab16e1.png";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "21a81555.png";

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3116c333.png";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0110c558.png";

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc91df9d.png";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0dd9b34.png";

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9947c2f6.png";

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "baf9b673.png";

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab28ab9f.png";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75c4dedb.png";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06e5d1ac.png";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47cde550.png";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43d96ef0.png";

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c7e4bb63.png";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4065e03d.png";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "363756fe.png";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "38057ebb.png";

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd7b2d0a.png";

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6dc90063.png";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "055f998d.png";

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "454dcc72.png";

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6fcd36ae.png";

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4d75bc9e.png";

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f1ed8d1.png";

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9de06497.png";

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "367feab2.png";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1fc6465.png";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f37b7eea.png";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bc37cc2.png";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b875a3aa.png";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ca8542b.png";

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e83468aa.png";

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e6cddca4.png";

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd09ec7e.png";

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ba4d01e.png";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "71be282b.png";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2c7dbc4.png";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ebf653b.png";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97e903c4.png";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48ba3000.png";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b8f0f94.png";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ebedf1e.png";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf369e9e.png";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83de083c.png";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3968f931.png";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d11747f9.png";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "676ca731.png";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0b7de01.png";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b9d1e571.png";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce3fc5e5.png";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c574ddb2.png";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "68d6e396.png";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79772d2e.png";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "65d20688.png";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "851a8bdc.png";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b44a769a.png";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "63d081e1.png";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a482b180.png";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dfbed93b.png";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6e72165.png";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de2351fe.png";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5a3ddefe.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f0849a1.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f16cbbb6.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "63d93879.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2e0acbf5.png";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8db6fe95.png";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f07cc1ff.png";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "233a0837.png";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3881a03.png";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "623e4dda.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e74cf00d.png";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47c39fb8.png";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "99b1f3d5.png";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b73b5c7.png";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f6690658.png";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0935d2f.png";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "029ea4b0.png";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "662bc646.png";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3b41f74b.png";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "250679fe.png";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "99ab7455.png";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "250679fe.png";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "758cb268.png";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bab9674.png";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "011a7cec.png";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "510a7f1f.png";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14e95d82.png";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "839d90c0.png";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "839d90c0.png";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e91a17f5.png";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "397e3a8e.png";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7328883.png";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "21537393.png";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7f135711.png";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8abdfb7e.png";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fab3bd5a.png";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce9c61a9.png";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd96de65.png";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be7ec6f3.png";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a482b180.png";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f8a93faa.png";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a482b180.png";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a33aae5e.png";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fe5e5d35.png";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "59f12621.png";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "768eb99f.png";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf707918.png";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "879ee75e.png";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33897d8b.png";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "27061822.png";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49b08f84.png";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19afd98e.png";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c098a124.png";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b9154cc9.png";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6c924c8.png";

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb332b75.png";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bf85fed.png";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "81934279.png";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac22ff63.png";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51f81bed.png";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c0e3c87.png";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c45162ed.png";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6439b716.png";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd00874e.png";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "524acc6e.png";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5a04aa1.png";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20b099da.png";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "749e93a5.png";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a6ad954.png";

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  if (isBuffer(val)) return 'buffer';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val);

  return typeof val;
};

// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
function isBuffer(obj) {
  return !!(obj != null &&
    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
      (obj.constructor &&
      typeof obj.constructor.isBuffer === 'function' &&
      obj.constructor.isBuffer(obj))
    ))
}


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(442)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hk/en-hk-modelData.json": 929,
	"./hk/zh-hk-modelData.json": 930,
	"./in/in-modelData.json": 931,
	"./kr/kr-modelData.json": 932,
	"./sg/sg-modelData.json": 933,
	"./tw/tw-modelData.json": 934,
	"./wechat/cn-modelData.json": 935
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1437;

/***/ }),
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, ".ak5I4 ._3rkS_ .Zewoh:after{content:\"\";display:table;clear:both}.ak5I4{text-align:center}.ak5I4 ._2kaBM{position:relative}.ak5I4 .ttHMM{padding-left:60px;padding-right:60px}.ak5I4 .ttHMM p{margin-bottom:30px;margin-bottom:1.875rem}.ak5I4 ._3rkS_ .zHIqU{width:75%;margin:auto;margin-bottom:30px}.ak5I4 ._3rkS_ .Zewoh{font-size:12px;font-size:.75rem;width:60%;margin:auto}.ak5I4 ._3rkS_ .Zewoh:after{width:57%;height:2px;background-color:#0088bf;margin:auto;position:relative;top:-1em}@media (max-width:767px){.ak5I4 ._3rkS_ .Zewoh{width:100%}}.ak5I4 ._3rkS_ .Zewoh ._3nyVE{color:#737373;float:left;width:90px}.ak5I4 ._3rkS_ .Zewoh ._3nyVE:after{content:\"\";display:block;border:1px solid #0088bf;background-color:#0088bf;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}.ak5I4 ._3rkS_ .Zewoh ._2BZGr{color:#afafaf;float:right;width:90px}.ak5I4 ._3rkS_ .Zewoh ._2BZGr:after{content:\"\";display:block;border:1px solid #d8d8d8;background-color:#d8d8d8;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}.ak5I4 p._4-BOi{letter-spacing:.67px;padding:5px}.ak5I4 p._4-BOi img{vertical-align:-8px;vertical-align:-.5rem}.ak5I4 h2{font-size:30px;font-size:1.875rem;letter-spacing:1px;margin-top:32px;margin-top:2rem;margin-bottom:16px;margin-bottom:1rem}.ak5I4 p{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}.ak5I4 ._2tLg6{font-size:16px;font-size:1rem}.ak5I4 ._2tLg6._2_H4l{padding-left:38px;padding-right:3em}.ak5I4 ._2tLg6._2mkb2{text-align:center;padding-right:15px;width:20%;display:inline-block;margin-right:10px}.ak5I4 .knl5p{font-size:12px;font-size:.75rem}.ak5I4 .knl5p._1VFwp{width:45%}.ak5I4 .knl5p._3GaJ3{background-color:#e7e7e7;color:#9b9b9b}.ak5I4 .knl5p._6dG4D{line-height:13.6px;line-height:.85rem}.ak5I4 .knl5p._6dG4D span{font-size:10px;font-size:.625rem;color:#b1b1b1}.ak5I4 ._29XYW{position:absolute;top:-8px;left:0;right:0;margin:auto;width:80%}.ak5I4 ._29XYW p{padding-top:4px;padding-top:.25rem;padding-bottom:4px;padding-bottom:.25rem;font-size:12px;font-size:.75rem;font-weight:700;line-height:1.3em;letter-spacing:.85px;background:#ea5365;color:#fff;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}.ak5I4 ._29XYW ._25y8x{margin-top:0!important}", ""]);

// exports
exports.locals = {
	"smsContainer": "ak5I4",
	"stepTwo": "_3rkS_",
	"stepTwoProgress": "Zewoh",
	"smsContent": "_2kaBM",
	"stepOne": "ttHMM",
	"smsConfirmField": "zHIqU",
	"done": "_3nyVE",
	"doing": "_2BZGr",
	"smsStatus": "_4-BOi",
	"input": "_2tLg6",
	"icon": "_2_H4l",
	"quartar": "_2mkb2",
	"button": "knl5p",
	"half": "_1VFwp",
	"disabled": "_3GaJ3",
	"buttonTwoLine": "_6dG4D",
	"smsError": "_29XYW",
	"smsErrorTop": "_25y8x"
};

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hk/en-hk.json": 1488,
	"./hk/zh-hk.json": 1489,
	"./in/en.json": 1490,
	"./kr/kr.json": 1491,
	"./sg/en.json": 1492,
	"./tw/tw.json": 1493
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1487;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"Please enter the 8-digit telephone number.","sms_call_cs_to_verify":"For fixed-line number, please contact 35903399 (GOGOVAN) for verification.","sms_tel_no_being_taken":"Telephone number has already been taken.","sms_please_enter_tel_no":"Please enter your mobile number","sms_please_enter_tel_no_hint":"Phone","sms_verification":"VERIFICATION","sms_incorrect_verification_code":"Sorry, incorrect verification code","sms_exceed_the_limit":"You have exceed the limits of changing / requesting. Please redo your registration again.","sms_complete_your_profile":"COMPLETE YOUR PROFILE","sms_register":"REGISTER","sms_sent_to_your_phone":"A SMS verification code will be sent to your mobile number shortly.","sms_enter_your_verify_code":"Please enter the SMS verification code.","sms_submit":"SUBMIT","sms_entered_a_wrong_no":"Entered a wrong number?","sms_use_a_different_no":"Use a different number","sms_verifying":"VERIFYING...","sms_success":"SUCCESS","sms_resend":"RESEND","sms_change":"CHANGE","sms_sending":"SENDING","sms_sec_remaining_prefix":"","sms_sec_remaining_suffix":"sec remaining"}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"請輸入 8 位數字電話號碼","sms_call_cs_to_verify":"固網電話號碼需要驗證，請致電客戶服務熱線：35903399","sms_tel_no_being_taken":"電話號碼已被註冊。","sms_please_enter_tel_no":"請輸入您的電話號碼","sms_please_enter_tel_no_hint":"電話號碼","sms_verification":"驗證","sms_incorrect_verification_code":"抱歉，驗證碼不正確。","sms_exceed_the_limit":"您已經超過更改 / 要求的限制。請重新註冊。","sms_complete_your_profile":"請填寫您的資料","sms_register":"註冊","sms_sent_to_your_phone":"我們已將驗證碼傳送到您的電話號碼","sms_enter_your_verify_code":"請輸入驗證碼","sms_submit":"提交","sms_entered_a_wrong_no":"電話號碼輸入錯誤","sms_use_a_different_no":"請嘗試其他號碼","sms_verifying":"驗證中⋯","sms_success":"成功","sms_resend":"重新傳送","sms_change":"更改","sms_sending":"傳送中","sms_sec_remaining_prefix":"","sms_sec_remaining_suffix":"秒後"}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"Please enter the 8-digit telephone number.","sms_tel_no_being_taken":"Telephone number has already been taken.","sms_please_enter_tel_no":"Please enter your phone number","sms_please_enter_tel_no_hint":"Phone","sms_verification":"VERIFICATION","sms_incorrect_verification_code":"Sorry, incorrect verification code","sms_exceed_the_limit":"You have exceed the limits of changing / requesting. Please redo your registration again.","sms_complete_your_profile":"COMPLETE YOUR PROFILE","sms_register":"REGISTER","sms_sent_to_your_phone":"We've sent a verification code to your phone","sms_enter_your_verify_code":"Please enter your verify code","sms_submit":"SUBMIT","sms_entered_a_wrong_no":"Entered a wrong number?","sms_use_a_different_no":"Use a different number","sms_verifying":"VERIFYING...","sms_success":"SUCCESS","sms_resend":"RESEND","sms_change":"CHANGE","sms_sending":"SENDING","sms_sec_remaining_prefix":"","sms_sec_remaining_suffix":"sec remaining"}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"11 자리의 휴대폰 번호를 입력해주세요.","sms_tel_no_being_taken":"입력하신 번호는 이미 사용중입니다.","sms_please_enter_tel_no":"휴대폰 번호를 입력해주세요.","sms_please_enter_tel_no_hint":"핸드폰 번호","sms_verification":"인증","sms_incorrect_verification_code":"죄송합니다. 인증 코드가 일치하지 않습니다.","sms_exceed_the_limit":"허용된 요청 / 변경 횟수를 초과하였습니다.  등록 절차를 다시 진행해주세요.","sms_complete_your_profile":"프로필을 완성해주세요","sms_register":"등록","sms_sent_to_your_phone":"휴대폰으로 인증 코드가 전송되었습니다.","sms_enter_your_verify_code":"인증 코드를 입력해주세요.","sms_submit":"확인","sms_entered_a_wrong_no":"번호를 잘못 입력하셨나요?","sms_use_a_different_no":"다른 번호로 시도해주세요.","sms_verifying":"인증 중...","sms_success":"성공","sms_resend":"다시 받기","sms_change":"변경","sms_sending":"전송 중","sms_sec_remaining_prefix":"0:","sms_sec_remaining_suffix":""}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"Please enter the 8-digit mobile number.","sms_tel_no_being_taken":"Mobile number has already been taken.","sms_please_enter_tel_no":"Please enter your mobile number","sms_please_enter_tel_no_hint":"Phone","sms_verification":"VERIFICATION","sms_incorrect_verification_code":"Sorry, incorrect verification code","sms_exceed_the_limit":"You have exceed the limits of changing / requesting. Please redo your registration again.","sms_complete_your_profile":"COMPLETE YOUR PROFILE","sms_register":"REGISTER","sms_sent_to_your_phone":"We've sent a verification code to your mobile","sms_enter_your_verify_code":"Please enter your verify code","sms_submit":"SUBMIT","sms_entered_a_wrong_no":"Entered a wrong number?","sms_use_a_different_no":"Use a different number","sms_verifying":"VERIFYING...","sms_success":"SUCCESS","sms_resend":"RESEND","sms_change":"ENTER","sms_sending":"SENDING","sms_sec_remaining_prefix":"","sms_sec_remaining_suffix":"sec remaining"}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports = {"sms_please_enter_correct_digit_no":"請輸入 10 位數字電話號碼","sms_tel_no_being_taken":"電話號碼已被註冊。","sms_please_enter_tel_no":"請輸入您的電話號碼","sms_please_enter_tel_no_hint":"電話號碼","sms_verification":"驗證","sms_incorrect_verification_code":"抱歉，驗證碼錯誤","sms_exceed_the_limit":"您已經超過更改 / 要求的限制。請重新註冊。","sms_complete_your_profile":"請填寫您的資料","sms_register":"註冊","sms_sent_to_your_phone":"我們已經驗證碼傳送到您的手機","sms_enter_your_verify_code":"請輸入驗證碼","sms_submit":"提交","sms_entered_a_wrong_no":"電話號碼輸入錯誤","sms_use_a_different_no":"輸入其他號碼","sms_verifying":"驗證中⋯⋯","sms_success":"成功","sms_resend":"重新傳送","sms_change":"更改","sms_sending":"重送","sms_sec_remaining_prefix":"剩下","sms_sec_remaining_suffix":"秒"}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "99a81517.png";

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7c792422.png";

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ad89f1e.png";

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a8c9a3c.png";

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "09abf14d.png";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e82ac8b3.png";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8819403.png";

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1901cd18.png";

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0a9319cb.png";

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3439034.png";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae513feb.png";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1060f3f0.png";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d759c56c.png";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f71f88c.png";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "932a49d9.png";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3692d530.png";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0f4921bb.png";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b49a30c6.png";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91e8c05a.png";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4af32e65.png";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "771cfb33.png";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "548a4fae.png";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "850dbbe7.png";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d2db634e.png";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cda17e74.png";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0fc4599.png";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2b643309.png";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "678c9293.png";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d488eb80.png";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5044e6b6.png";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11a79298.png";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d1eb8c37.png";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9048f5fe.png";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c296b6a3.png";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "160ecbc3.png";

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9aaa3e0e.png";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b31bcd71.png";

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3b50634.png";

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "30421a84.png";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9cad555b.png";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6ce8b8db.png";

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c1f0d68d.png";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11639af2.png";

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad0df0e3.png";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "87f1e403.png";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b00b5b23.png";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f21ac83.png";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "74558371.png";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e27a9743.png";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f1bc6d26.png";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "036280e2.png";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4737ddd8.png";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53a50b45.png";

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e1c3078.png";

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a834b21e.png";

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c69feaa.png";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "034a2056.png";

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dc5f34e8.png";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "295f588f.png";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba08b8e0.png";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a22de03.png";

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8e2daf2e.png";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c1abd1f9.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b8943314.png";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f2c28ad.png";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "040352a9.png";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b0dd7cbe.png";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3dd6a734.png";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e67241d7.png";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e3d4156.png";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e3d4156.png";

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "68ca9df2.png";

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "62b37f5e.png";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1385c288.png";

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1385c288.png";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e1b3093.png";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b0b7cd28.png";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8fd0ed0b.png";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "84a0cea4.png";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d062da3e.png";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d3aa6ce.png";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "405cdbd9.png";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c251a850.png";

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7939cbea.png";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06f9f136.png";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e60ee854.png";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd6e43cb.png";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae21cb8b.png";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "343cc6c7.png";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b26b2a9b.png";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "496063cb.png";

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f435e113.png";

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50c7a71c.png";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ff530cc.png";

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57bf7ef2.png";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ac42c85.png";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2e130201.png";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97299824.png";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3d4dc26.png";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53baf20d.png";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ae32a19.png";

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53f3eb9a.png";

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9381584e.png";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c661e78e.png";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e5f09c7b.png";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f002e69.png";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "59fcdb0e.png";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d7d8e048.png";

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3cfd5d4c.png";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "44a14acb.png";

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7261d4ba.png";

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6f666f7e.png";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "44e55e83.png";

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c438f15.png";

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "67525a74.png";

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7d143ca.png";

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "67525a74.png";

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "67525a74.png";

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9fb0a135.png";

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91d933d9.png";

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19e6937c.png";

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c755c2af.png";

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48b8f019.png";

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "026b2b80.png";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "026b2b80.png";

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43e97752.png";

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f881cb4.png";

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "07727a93.png";

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1d83e464.png";

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc614b8c.png";

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d46d93a5.png";

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49345a68.png";

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "25c0f7da.png";

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1469826.png";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "921ebffb.png";

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37cf13a2.png";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1385c288.png";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "322b63ea.png";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1385c288.png";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1385c288.png";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f6a2963f.png";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "05b3c312.png";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d8e287e.png";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c52b66d5.png";

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "05fd786e.png";

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47d6141a.png";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "96fc96b5.png";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "107dad73.png";

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14e56f2c.png";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "476fec50.png";

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d82bfbd4.png";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4755aaae.png";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be4fb7db.png";

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5e44c833.png";

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f207f010.png";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f463abe6.png";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f463abe6.png";

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "417065c7.png";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b93daab4.png";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1a6de034.png";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "784c4044.png";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8130eecb.png";

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79fd576f.png";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c2b73d4.png";

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a493c9c9.png";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad2c5104.png";

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91011dfe.png";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "55dfd753.png";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "877ffe8f.png";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "118d371a.png";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "976eec9a.png";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4bbcdf90.png";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba3383e9.png";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa2f6a71.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8bf1ff3.png";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0112acf5.png";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83dfcc3c.png";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9d29aa4e.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4cb8b7c3.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1495c9d8.png";

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "906d42e4.png";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cb925de6.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "813c89fe.png";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ddc44f23.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed7e6a6b.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1389501c.png";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9cc0f53e.png";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "abdaac98.png";

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3aef7cd5.png";

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0203368e.png";

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a6e2fb74.png";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd5c1863.png";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d204a3fe.png";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e22af9c1.png";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20db67c0.png";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b066ebd7.png";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "606a19f6.png";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "248db217.png";

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bff62657.png";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bcc54d3f.png";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f068f25f.png";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75bd9246.png";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0c23abd.png";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89ea7d0f.png";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff6a98d7.png";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ac29fe6.png";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d54f4594.png";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "26ba4682.png";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9574c7ab.png";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37ba972e.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36b7924f.png";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7daa03be.png";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5be9e032.png";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "541223b8.png";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed01b66f.png";

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1552da0c.png";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b30c776.png";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c2f785da.png";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff258d7d.png";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8d4276b6.png";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbf661ef.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d4fa587b.png";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50940f6a.png";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1718);
var v4 = __webpack_require__(1719);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1217);
var bytesToUuid = __webpack_require__(1218);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1217);
var bytesToUuid = __webpack_require__(1218);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c40339b.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "45b48717.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b36b1323.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "011ed1b4.png";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f8b6033.png";

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bc9ffe70.png";

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f63c412.png";

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1aa851d7.png";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80025821.png";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9625d0fa.png";

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a010c6cc.png";

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3d73c67.png";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1314733d.png";

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a3c50390.png";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b45950ae.png";

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3d82ed4.png";

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7da90969.png";

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "319dfc5a.png";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4df36732.png";

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c77c7583.png";

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8eb20d92.png";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8813f730.png";

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "948f5e58.png";

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb85828d.png";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3830d6bc.png";

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6ec82b5.png";

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "379783a9.png";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6be66d54.png";

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "12fd07fa.png";

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e7ceb1b0.png";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e03bea6.png";

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "711eba86.png";

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "614c645c.png";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d3984a0e.png";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7cd6cf81.png";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33d70f9b.png";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cefde225.png";

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85548007.png";

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e99ed816.png";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5a32b699.png";

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "70ecc996.png";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b74a900e.png";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0a8a7970.png";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50177204.png";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92cbd7a9.png";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf2545f7.png";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "87ad2959.png";

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03ecdb05.png";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3952d1be.png";

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ecd6cda6.png";

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "013f2f63.png";

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ecd6cda6.png";

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "45383f40.png";

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d1d1e087.png";

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "82e58d04.png";

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1dd8f712.png";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "616ae909.png";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f306364.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f306364.png";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0dba6988.png";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02c3ced2.png";

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3bd49ceb.png";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fb39bc2e.png";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b492a9ad.png";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e2f522ab.png";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "845baa64.png";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ce1c4b9.png";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "468c480d.png";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4df36732.png";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c468ba78.png";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4df36732.png";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6d7c39a.png";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2a520ea.png";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47f54ef4.png";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fda0e5a9.png";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6124a71e.png";

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f1b3a54c.png";

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5c24c730.png";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37eb4669.png";

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0d2559d.png";

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "858aab46.png";

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8d22748b.png";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1bd2b491.png";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b802da21.png";

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "86f18537.png";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3d50e3c.png";

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "54f5870d.png";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f345685c.png";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cce79c10.png";

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6a57527.png";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b439379.png";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0ba3128.png";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb498ed1.png";

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee3cf4a7.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4da71ca7.png";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f88725ec.png";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f5a2291.png";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "12464b76.png";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Tween = __webpack_require__(1819);
var raf = __webpack_require__(1824);

/**
 * Expose `scrollTo`.
 */

module.exports = scrollTo;

/**
 * Scroll to `(x, y)`.
 *
 * @param {Number} x
 * @param {Number} y
 * @api public
 */

function scrollTo(x, y, options) {
  options = options || {};

  // start position
  var start = scroll();

  // setup tween
  var tween = Tween(start)
    .ease(options.ease || 'out-circ')
    .to({ top: y, left: x })
    .duration(options.duration || 1000);

  // scroll
  tween.update(function(o){
    window.scrollTo(o.left | 0, o.top | 0);
  });

  // handle end
  tween.on('end', function(){
    animate = function(){};
  });

  // animate
  function animate() {
    raf(animate);
    tween.update();
  }

  animate();
  
  return tween;
}

/**
 * Return scroll position.
 *
 * @return {Object}
 * @api private
 */

function scroll() {
  var y = window.pageYOffset || document.documentElement.scrollTop;
  var x = window.pageXOffset || document.documentElement.scrollLeft;
  return { top: y, left: x };
}


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(1820);
var clone = __webpack_require__(1821);
var type = __webpack_require__(1822);
var ease = __webpack_require__(1823);

/**
 * Expose `Tween`.
 */

module.exports = Tween;

/**
 * Initialize a new `Tween` with `obj`.
 *
 * @param {Object|Array} obj
 * @api public
 */

function Tween(obj) {
  if (!(this instanceof Tween)) return new Tween(obj);
  this._from = obj;
  this.ease('linear');
  this.duration(500);
}

/**
 * Mixin emitter.
 */

Emitter(Tween.prototype);

/**
 * Reset the tween.
 *
 * @api public
 */

Tween.prototype.reset = function(){
  this.isArray = 'array' === type(this._from);
  this._curr = clone(this._from);
  this._done = false;
  this._start = Date.now();
  return this;
};

/**
 * Tween to `obj` and reset internal state.
 *
 *    tween.to({ x: 50, y: 100 })
 *
 * @param {Object|Array} obj
 * @return {Tween} self
 * @api public
 */

Tween.prototype.to = function(obj){
  this.reset();
  this._to = obj;
  return this;
};

/**
 * Set duration to `ms` [500].
 *
 * @param {Number} ms
 * @return {Tween} self
 * @api public
 */

Tween.prototype.duration = function(ms){
  this._duration = ms;
  return this;
};

/**
 * Set easing function to `fn`.
 *
 *    tween.ease('in-out-sine')
 *
 * @param {String|Function} fn
 * @return {Tween}
 * @api public
 */

Tween.prototype.ease = function(fn){
  fn = 'function' == typeof fn ? fn : ease[fn];
  if (!fn) throw new TypeError('invalid easing function');
  this._ease = fn;
  return this;
};

/**
 * Stop the tween and immediately emit "stop" and "end".
 *
 * @return {Tween}
 * @api public
 */

Tween.prototype.stop = function(){
  this.stopped = true;
  this._done = true;
  this.emit('stop');
  this.emit('end');
  return this;
};

/**
 * Perform a step.
 *
 * @return {Tween} self
 * @api private
 */

Tween.prototype.step = function(){
  if (this._done) return;

  // duration
  var duration = this._duration;
  var now = Date.now();
  var delta = now - this._start;
  var done = delta >= duration;

  // complete
  if (done) {
    this._from = this._to;
    this._update(this._to);
    this._done = true;
    this.emit('end');
    return this;
  }

  // tween
  var from = this._from;
  var to = this._to;
  var curr = this._curr;
  var fn = this._ease;
  var p = (now - this._start) / duration;
  var n = fn(p);

  // array
  if (this.isArray) {
    for (var i = 0; i < from.length; ++i) {
      curr[i] = from[i] + (to[i] - from[i]) * n;
    }

    this._update(curr);
    return this;
  }

  // objech
  for (var k in from) {
    curr[k] = from[k] + (to[k] - from[k]) * n;
  }

  this._update(curr);
  return this;
};

/**
 * Set update function to `fn` or
 * when no argument is given this performs
 * a "step".
 *
 * @param {Function} fn
 * @return {Tween} self
 * @api public
 */

Tween.prototype.update = function(fn){
  if (0 == arguments.length) return this.step();
  this._update = fn;
  return this;
};

/***/ }),
/* 1820 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var type;
try {
  type = __webpack_require__(1316);
} catch (_) {
  type = __webpack_require__(1316);
}

/**
 * Module exports.
 */

module.exports = clone;

/**
 * Clones objects.
 *
 * @param {Mixed} any object
 * @api public
 */

function clone(obj){
  switch (type(obj)) {
    case 'object':
      var copy = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = clone(obj[key]);
        }
      }
      return copy;

    case 'array':
      var copy = new Array(obj.length);
      for (var i = 0, l = obj.length; i < l; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;

    case 'regexp':
      // from millermedeiros/amd-utils - MIT
      var flags = '';
      flags += obj.multiline ? 'm' : '';
      flags += obj.global ? 'g' : '';
      flags += obj.ignoreCase ? 'i' : '';
      return new RegExp(obj.source, flags);

    case 'date':
      return new Date(obj.getTime());

    default: // string, number, boolean, …
      return obj;
  }
}


/***/ }),
/* 1822 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val)

  return typeof val;
};


/***/ }),
/* 1823 */
/***/ (function(module, exports) {


// easing functions from "Tween.js"

exports.linear = function(n){
  return n;
};

exports.inQuad = function(n){
  return n * n;
};

exports.outQuad = function(n){
  return n * (2 - n);
};

exports.inOutQuad = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n;
  return - 0.5 * (--n * (n - 2) - 1);
};

exports.inCube = function(n){
  return n * n * n;
};

exports.outCube = function(n){
  return --n * n * n + 1;
};

exports.inOutCube = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n;
  return 0.5 * ((n -= 2 ) * n * n + 2);
};

exports.inQuart = function(n){
  return n * n * n * n;
};

exports.outQuart = function(n){
  return 1 - (--n * n * n * n);
};

exports.inOutQuart = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n;
  return -0.5 * ((n -= 2) * n * n * n - 2);
};

exports.inQuint = function(n){
  return n * n * n * n * n;
}

exports.outQuint = function(n){
  return --n * n * n * n * n + 1;
}

exports.inOutQuint = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n * n;
  return 0.5 * ((n -= 2) * n * n * n * n + 2);
};

exports.inSine = function(n){
  return 1 - Math.cos(n * Math.PI / 2 );
};

exports.outSine = function(n){
  return Math.sin(n * Math.PI / 2);
};

exports.inOutSine = function(n){
  return .5 * (1 - Math.cos(Math.PI * n));
};

exports.inExpo = function(n){
  return 0 == n ? 0 : Math.pow(1024, n - 1);
};

exports.outExpo = function(n){
  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};

exports.inOutExpo = function(n){
  if (0 == n) return 0;
  if (1 == n) return 1;
  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};

exports.inCirc = function(n){
  return 1 - Math.sqrt(1 - n * n);
};

exports.outCirc = function(n){
  return Math.sqrt(1 - (--n * n));
};

exports.inOutCirc = function(n){
  n *= 2
  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};

exports.inBack = function(n){
  var s = 1.70158;
  return n * n * (( s + 1 ) * n - s);
};

exports.outBack = function(n){
  var s = 1.70158;
  return --n * n * ((s + 1) * n + s) + 1;
};

exports.inOutBack = function(n){
  var s = 1.70158 * 1.525;
  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
};

exports.inBounce = function(n){
  return 1 - exports.outBounce(1 - n);
};

exports.outBounce = function(n){
  if ( n < ( 1 / 2.75 ) ) {
    return 7.5625 * n * n;
  } else if ( n < ( 2 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
  } else if ( n < ( 2.5 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
  } else {
    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
  }
};

exports.inOutBounce = function(n){
  if (n < .5) return exports.inBounce(n * 2) * .5;
  return exports.outBounce(n * 2 - 1) * .5 + .5;
};

// aliases

exports['in-quad'] = exports.inQuad;
exports['out-quad'] = exports.outQuad;
exports['in-out-quad'] = exports.inOutQuad;
exports['in-cube'] = exports.inCube;
exports['out-cube'] = exports.outCube;
exports['in-out-cube'] = exports.inOutCube;
exports['in-quart'] = exports.inQuart;
exports['out-quart'] = exports.outQuart;
exports['in-out-quart'] = exports.inOutQuart;
exports['in-quint'] = exports.inQuint;
exports['out-quint'] = exports.outQuint;
exports['in-out-quint'] = exports.inOutQuint;
exports['in-sine'] = exports.inSine;
exports['out-sine'] = exports.outSine;
exports['in-out-sine'] = exports.inOutSine;
exports['in-expo'] = exports.inExpo;
exports['out-expo'] = exports.outExpo;
exports['in-out-expo'] = exports.inOutExpo;
exports['in-circ'] = exports.inCirc;
exports['out-circ'] = exports.outCirc;
exports['in-out-circ'] = exports.inOutCirc;
exports['in-back'] = exports.inBack;
exports['out-back'] = exports.outBack;
exports['in-out-back'] = exports.inOutBack;
exports['in-bounce'] = exports.inBounce;
exports['out-bounce'] = exports.outBounce;
exports['in-out-bounce'] = exports.inOutBounce;


/***/ }),
/* 1824 */
/***/ (function(module, exports) {

/**
 * Expose `requestAnimationFrame()`.
 */

exports = module.exports = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || fallback;

/**
 * Fallback implementation.
 */

var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime();
  var ms = Math.max(0, 16 - (curr - prev));
  var req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

/**
 * Cancel.
 */

var cancel = window.cancelAnimationFrame
  || window.webkitCancelAnimationFrame
  || window.mozCancelAnimationFrame
  || window.clearTimeout;

exports.cancel = function(id){
  cancel.call(window, id);
};


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(1317),
	PropTypes = __webpack_require__(54),
	createClass = __webpack_require__(911),
	moment = __webpack_require__(442),
	React = __webpack_require__(30),
	CalendarContainer = __webpack_require__(1829)
	;

var TYPES = PropTypes;
var Datetime = createClass({
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf(['years', 'months', 'days', 'time']),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getDefaultProps: function() {
		var nof = function() {};
		return {
			className: '',
			defaultValue: '',
			inputProps: {},
			input: true,
			onFocus: nof,
			onBlur: nof,
			onChange: nof,
			onViewModeChange: nof,
			timeFormat: true,
			timeConstraints: {},
			dateFormat: true,
			strictParsing: true,
			closeOnSelect: false,
			closeOnTab: true,
			utc: false
		};
	},

	getInitialState: function() {
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ? (this.props.viewMode || state.updateOn || 'days') : 'time';

		return state;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		if ( date && typeof date === 'string' )
			selectedDate = this.localMoment( date, formats.datetime );
		else if ( date )
			selectedDate = this.localMoment( date );

		if ( selectedDate && !selectedDate.isValid() )
			selectedDate = null;

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			this.localMoment().startOf('month')
		;

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return 'days';
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return 'months';
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return 'years';
		}

		return 'days';
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== 'days' ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== 'time' ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}
		//we should only show a valid date if we are provided a isValidDate function. Removed in 2.10.3
		/*if (this.props.isValidDate) {
			updatedState.viewDate = updatedState.viewDate || this.state.viewDate;
			while (!this.props.isValidDate(updatedState.viewDate)) {
				updatedState.viewDate = updatedState.viewDate.add(1, 'day');
			}
		}*/
		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: 'days',
				year: 'months'
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	addTime: function( amount, type, toSelected ) {
		return this.updateTime( 'add', amount, type, toSelected );
	},

	subtractTime: function( amount, type, toSelected ) {
		return this.updateTime( 'subtract', amount, type, toSelected );
	},

	updateTime: function( op, amount, type, toSelected ) {
		var me = this;

		return function() {
			var update = {},
				date = toSelected ? 'selectedDate' : 'viewDate'
			;

			update[ date ] = me.state[ date ].clone()[ op ]( amount, type );

			me.setState( update );
		};
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.target,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && !this.props.open ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var momentFn = props.utc ? moment.utc : moment;
		var m = momentFn( date, format, props.strictParsing );
		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
                  ( Array.isArray( this.props.className ) ?
                  ' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign({
				type: 'text',
				className: 'form-control',
				onClick: this.openCalendar,
				onFocus: this.openCalendar,
				onChange: this.onInputChange,
				onKeyDown: this.onInputKey,
				value: this.state.inputValue,
			}, this.props.inputProps);
			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.state.open )
			className += ' rdtOpen';

		return React.createElement( 'div', { className: className }, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps(), onClickOutside: this.handleClickOutside })
			)
		));
	}
});

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var emptyObject = __webpack_require__(1827);
var _invariant = __webpack_require__(108);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 1318,
	"./af.js": 1318,
	"./ar": 1319,
	"./ar-dz": 1320,
	"./ar-dz.js": 1320,
	"./ar-kw": 1321,
	"./ar-kw.js": 1321,
	"./ar-ly": 1322,
	"./ar-ly.js": 1322,
	"./ar-ma": 1323,
	"./ar-ma.js": 1323,
	"./ar-sa": 1324,
	"./ar-sa.js": 1324,
	"./ar-tn": 1325,
	"./ar-tn.js": 1325,
	"./ar.js": 1319,
	"./az": 1326,
	"./az.js": 1326,
	"./be": 1327,
	"./be.js": 1327,
	"./bg": 1328,
	"./bg.js": 1328,
	"./bm": 1329,
	"./bm.js": 1329,
	"./bn": 1330,
	"./bn.js": 1330,
	"./bo": 1331,
	"./bo.js": 1331,
	"./br": 1332,
	"./br.js": 1332,
	"./bs": 1333,
	"./bs.js": 1333,
	"./ca": 1334,
	"./ca.js": 1334,
	"./cs": 1335,
	"./cs.js": 1335,
	"./cv": 1336,
	"./cv.js": 1336,
	"./cy": 1337,
	"./cy.js": 1337,
	"./da": 1338,
	"./da.js": 1338,
	"./de": 1339,
	"./de-at": 1340,
	"./de-at.js": 1340,
	"./de-ch": 1341,
	"./de-ch.js": 1341,
	"./de.js": 1339,
	"./dv": 1342,
	"./dv.js": 1342,
	"./el": 1343,
	"./el.js": 1343,
	"./en-au": 1344,
	"./en-au.js": 1344,
	"./en-ca": 1345,
	"./en-ca.js": 1345,
	"./en-gb": 1346,
	"./en-gb.js": 1346,
	"./en-ie": 1347,
	"./en-ie.js": 1347,
	"./en-nz": 1348,
	"./en-nz.js": 1348,
	"./eo": 1349,
	"./eo.js": 1349,
	"./es": 1350,
	"./es-do": 1351,
	"./es-do.js": 1351,
	"./es-us": 1352,
	"./es-us.js": 1352,
	"./es.js": 1350,
	"./et": 1353,
	"./et.js": 1353,
	"./eu": 1354,
	"./eu.js": 1354,
	"./fa": 1355,
	"./fa.js": 1355,
	"./fi": 1356,
	"./fi.js": 1356,
	"./fo": 1357,
	"./fo.js": 1357,
	"./fr": 1358,
	"./fr-ca": 1359,
	"./fr-ca.js": 1359,
	"./fr-ch": 1360,
	"./fr-ch.js": 1360,
	"./fr.js": 1358,
	"./fy": 1361,
	"./fy.js": 1361,
	"./gd": 1362,
	"./gd.js": 1362,
	"./gl": 1363,
	"./gl.js": 1363,
	"./gom-latn": 1364,
	"./gom-latn.js": 1364,
	"./gu": 1365,
	"./gu.js": 1365,
	"./he": 1366,
	"./he.js": 1366,
	"./hi": 1367,
	"./hi.js": 1367,
	"./hr": 1368,
	"./hr.js": 1368,
	"./hu": 1369,
	"./hu.js": 1369,
	"./hy-am": 1370,
	"./hy-am.js": 1370,
	"./id": 1371,
	"./id.js": 1371,
	"./is": 1372,
	"./is.js": 1372,
	"./it": 1373,
	"./it.js": 1373,
	"./ja": 1374,
	"./ja.js": 1374,
	"./jv": 1375,
	"./jv.js": 1375,
	"./ka": 1376,
	"./ka.js": 1376,
	"./kk": 1377,
	"./kk.js": 1377,
	"./km": 1378,
	"./km.js": 1378,
	"./kn": 1379,
	"./kn.js": 1379,
	"./ko": 1380,
	"./ko.js": 1380,
	"./ky": 1381,
	"./ky.js": 1381,
	"./lb": 1382,
	"./lb.js": 1382,
	"./lo": 1383,
	"./lo.js": 1383,
	"./lt": 1384,
	"./lt.js": 1384,
	"./lv": 1385,
	"./lv.js": 1385,
	"./me": 1386,
	"./me.js": 1386,
	"./mi": 1387,
	"./mi.js": 1387,
	"./mk": 1388,
	"./mk.js": 1388,
	"./ml": 1389,
	"./ml.js": 1389,
	"./mr": 1390,
	"./mr.js": 1390,
	"./ms": 1391,
	"./ms-my": 1392,
	"./ms-my.js": 1392,
	"./ms.js": 1391,
	"./mt": 1393,
	"./mt.js": 1393,
	"./my": 1394,
	"./my.js": 1394,
	"./nb": 1395,
	"./nb.js": 1395,
	"./ne": 1396,
	"./ne.js": 1396,
	"./nl": 1397,
	"./nl-be": 1398,
	"./nl-be.js": 1398,
	"./nl.js": 1397,
	"./nn": 1399,
	"./nn.js": 1399,
	"./pa-in": 1400,
	"./pa-in.js": 1400,
	"./pl": 1401,
	"./pl.js": 1401,
	"./pt": 1402,
	"./pt-br": 1403,
	"./pt-br.js": 1403,
	"./pt.js": 1402,
	"./ro": 1404,
	"./ro.js": 1404,
	"./ru": 1405,
	"./ru.js": 1405,
	"./sd": 1406,
	"./sd.js": 1406,
	"./se": 1407,
	"./se.js": 1407,
	"./si": 1408,
	"./si.js": 1408,
	"./sk": 1409,
	"./sk.js": 1409,
	"./sl": 1410,
	"./sl.js": 1410,
	"./sq": 1411,
	"./sq.js": 1411,
	"./sr": 1412,
	"./sr-cyrl": 1413,
	"./sr-cyrl.js": 1413,
	"./sr.js": 1412,
	"./ss": 1414,
	"./ss.js": 1414,
	"./sv": 1415,
	"./sv.js": 1415,
	"./sw": 1416,
	"./sw.js": 1416,
	"./ta": 1417,
	"./ta.js": 1417,
	"./te": 1418,
	"./te.js": 1418,
	"./tet": 1419,
	"./tet.js": 1419,
	"./th": 1420,
	"./th.js": 1420,
	"./tl-ph": 1421,
	"./tl-ph.js": 1421,
	"./tlh": 1422,
	"./tlh.js": 1422,
	"./tr": 1423,
	"./tr.js": 1423,
	"./tzl": 1424,
	"./tzl.js": 1424,
	"./tzm": 1425,
	"./tzm-latn": 1426,
	"./tzm-latn.js": 1426,
	"./tzm.js": 1425,
	"./uk": 1427,
	"./uk.js": 1427,
	"./ur": 1428,
	"./ur.js": 1428,
	"./uz": 1429,
	"./uz-latn": 1430,
	"./uz-latn.js": 1430,
	"./uz.js": 1429,
	"./vi": 1431,
	"./vi.js": 1431,
	"./x-pseudo": 1432,
	"./x-pseudo.js": 1432,
	"./yo": 1433,
	"./yo.js": 1433,
	"./zh-cn": 1434,
	"./zh-cn.js": 1434,
	"./zh-hk": 1435,
	"./zh-hk.js": 1435,
	"./zh-tw": 1436,
	"./zh-tw.js": 1436
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1828;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(30),
	createClass = __webpack_require__(911),
	DaysView = __webpack_require__(1830),
	MonthsView = __webpack_require__(1831),
	YearsView = __webpack_require__(1832),
	TimeView = __webpack_require__(1833)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(30),
	createClass = __webpack_require__(911),
	moment = __webpack_require__(442),
	onClickOutside = __webpack_require__(928).default
	;

var DateTimePickerDays = onClickOutside( createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerDays;


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(30),
	createClass = __webpack_require__(911),
	onClickOutside = __webpack_require__(928).default
	;

var DateTimePickerMonths = onClickOutside( createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(30),
	createClass = __webpack_require__(911),
	onClickOutside = __webpack_require__(928).default
	;

var DateTimePickerYears = onClickOutside( createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerYears;


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(30),
	createClass = __webpack_require__(911),
	assign = __webpack_require__(1317),
	onClickOutside = __webpack_require__(928).default
	;

var DateTimePickerTime = onClickOutside( createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );
		
		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerTime;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1835);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./Order10PickupTime.sass", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./Order10PickupTime.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._23Jwd{min-width:256px;max-height:400px;overflow-y:scroll}._2sRZU{-webkit-box-shadow:0 12px 36px 16px rgba(0,0,0,.24);box-shadow:0 12px 36px 16px rgba(0,0,0,.24)}._6pzbk{padding:5px;border-bottom:1px solid #ddd;border-top:1px solid #ddd;margin-bottom:-1px;position:relative;background:#fff;display:block}._6pzbk:hover{cursor:pointer;color:#000;background:#b1dcfb;border-color:#0089ec;z-index:9000}._2yx0X{top:200px}._3Wr2O{display:none}._1G6Gy>div>div>table{width:100%!important;text-align:center!important;height:300px}._1G6Gy>div>div>table>thead>tr:first-of-type>th{margin-bottom:10px}._1G6Gy>div>div>table>thead>tr:first-of-type>th:first-of-type{visibility:hidden}._1G6Gy>div>div>table>thead>tr:first-of-type>th:first-of-type:hover{cursor:pointer;color:#000;background:#b1dcfb}._1G6Gy>div>div>table>thead>tr:first-of-type>th:first-of-type:before{margin-top:5px!important;content:\" \";visibility:visible;border-top:.5em solid transparent;border-bottom:.5em solid transparent;border-right:.75em solid #000;width:0;height:0;display:block;margin:0 auto}._1G6Gy>div>div>table>thead>tr:first-of-type>th:last-of-type{visibility:hidden}._1G6Gy>div>div>table>thead>tr:first-of-type>th:last-of-type:hover{cursor:pointer;color:#000;background:#b1dcfb}._1G6Gy>div>div>table>thead>tr:first-of-type>th:last-of-type:before{margin-top:5px!important;content:\" \";visibility:visible;border-top:.5em solid transparent;border-bottom:.5em solid transparent;border-left:.75em solid #000;width:0;height:0;display:block;margin:0 auto}._1G6Gy>div>div>table>tbody>tr>td:hover{cursor:pointer;color:#000;background:#b1dcfb}._1S4sf{border-color:#0089ec;background:#b1dcfb;border:1px solid transparent}._3jU4z{border-radius:0;color:#000;border:1px solid #fff;background:#fff;font-size:19px;padding:.66em 0;font-weight:700;width:33%;display:inline-block;vertical-align:bottom;text-decoration:none}._3jU4z:before{content:\"\";margin-right:.45em;top:-.05em;width:0;border-top:.66em solid #0059bc;border-left:.66em solid transparent;position:relative;display:inline-block;height:0}._3jU4z:hover{background:#b1dcfb;outline:0}._3jU4z:active,._3jU4z:hover,._3jU4z:visited,.Go1bN{text-decoration:none}.Go1bN{border-radius:0;color:#000;border:1px solid #fff;background:#fff;font-size:19px;padding:.66em 0;font-weight:700;width:33%;display:inline-block;vertical-align:bottom}.Go1bN:before{content:\"\\D7\";top:-.1em;vertical-align:top;font-size:1.1em;margin-right:.35em;color:#777;position:relative;display:inline-block;height:0}.Go1bN:hover{background:#b1dcfb;outline:0}.Go1bN:active,.Go1bN:hover,.Go1bN:visited{text-decoration:none}._204Yw{width:15%}._204Yw:before{content:\"\";position:relative;top:2px;left:30px;width:0;height:0;border-top:.5em solid #0059bc;border-left:.5em solid transparent}._2nYqy:hover{cursor:pointer;color:#000;background:#b1dcfb}", ""]);

// exports
exports.locals = {
	"picker__frame": "_23Jwd",
	"picker__wrap": "_2sRZU",
	"picker__listItem": "_6pzbk",
	"infoPopup": "_2yx0X",
	"optionHidden": "_3Wr2O",
	"picker__dateTime": "_1G6Gy",
	"pickerToday": "_1S4sf",
	"pickerTodayButton": "_3jU4z",
	"pickerClosedButton": "Go1bN",
	"calenderToday": "_204Yw",
	"calenderHover": "_2nYqy"
};

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1837);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./serviceDetailDialog.sass", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./serviceDetailDialog.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "#_3-xXn ._2H5iD .Z49Fb:after{content:\"\";display:table;clear:both}.VzoK7{border-radius:0;border:0}@media (max-width:830px){.VzoK7{top:0;margin:0}}.VzoK7 ._2gvim{width:40px;height:40px;margin-left:960px;margin-top:-40px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}.VzoK7 ._2gvim:hover .VzoK7 ._2gvim:active .VzoK7 ._2gvim:link .VzoK7 ._2gvim:visited{background-color:transparent;border-color:transparent;border:0}@media (max-width:1050px){.VzoK7 ._2gvim{margin-left:auto;position:fixed;right:0}}@media (max-width:830px){.VzoK7 ._2gvim{margin-left:auto;position:fixed;right:0;top:60px}}.PPs4i{max-width:1000px;margin-left:auto;margin-right:auto;display:block}@media (max-width:1050px){.PPs4i{margin-left:2%;margin-right:2%}}@media (max-width:1050px) and (max-width:830px){.PPs4i{margin-left:0;margin-right:0}}._12L1T{font-size:1.1em}._19U6t{font-size:12px;font-weight:bolder;letter-spacing:1px;line-height:24px}@media (max-width:830px){#_3-xXn{padding-left:0;padding-right:0}}#_3-xXn ._2H5iD{background-color:#fff;position:relative}@media (max-width:830px){#_3-xXn ._2H5iD{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_3-xXn ._2H5iD .Z49Fb{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:830px){#_3-xXn ._2H5iD .Z49Fb{margin-top:60px;padding-left:10px;padding-right:10px}}._3DJaa{background-color:#006a96;color:#fff}._3DJaa h2{margin:54px 40px 30px}@media (max-width:830px){._3DJaa{position:fixed;width:100%;margin-top:-60px}}._1-z9T{margin-bottom:15px}._1DTar{margin-top:20px}hr{margin-bottom:0;margin-top:0;display:block;unicode-bidi:-webkit-isolate;unicode-bidi:isolate;-webkit-margin-before:.5em;-webkit-margin-after:.5em;-webkit-margin-start:auto;-webkit-margin-end:auto;overflow:hidden;border-style:inset;border-width:1px}p{margin:0;line-height:24px}._2xT2x{margin-bottom:0}._2UcV0{margin-bottom:-15px}._1NLsN{float:right;width:220px;margin-top:60px}", ""]);

// exports
exports.locals = {
	"serviceDetail": "_3-xXn",
	"serviceDetailContainer": "_2H5iD",
	"serviceDetailContentContainer": "Z49Fb",
	"infoNoRadiusAndResize": "VzoK7",
	"infoCloseRightButton": "_2gvim",
	"resizeModalPosition": "PPs4i",
	"detailServicefontSize": "_12L1T",
	"orderSmallTitle": "_19U6t",
	"serviceDetailHeadline": "_3DJaa",
	"serviceVehicleType": "_1-z9T",
	"serviceAddtionalType": "_1DTar",
	"h2MarginBottom": "_2xT2x",
	"serviceDetailDescHeadline": "_2UcV0",
	"serviceDetailCloseButton": "_1NLsN"
};

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1839);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./Order21Confirm.sass", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../../node_modules/sass-loader/lib/loader.js!./Order21Confirm.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1841);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./orderSummary.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./orderSummary.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._2uByW{width:100%}", ""]);

// exports
exports.locals = {
	"buttonFull": "_2uByW"
};

/***/ }),
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(30);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__(441);
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(54);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(148);

// EXTERNAL MODULE: ./node_modules/react-slidedown/lib/slidedown.css
var slidedown = __webpack_require__(797);
var slidedown_default = /*#__PURE__*/__webpack_require__.n(slidedown);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(439);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./src/assets/styles/style.sass
var style = __webpack_require__(440);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/routes/order/Order.sass
var order_Order = __webpack_require__(449);
var Order_default = /*#__PURE__*/__webpack_require__.n(order_Order);

// EXTERNAL MODULE: ./src/actions/user.js
var actions_user = __webpack_require__(444);

// EXTERNAL MODULE: ./src/api/order.js + 1 modules
var api_order = __webpack_require__(571);

// EXTERNAL MODULE: ./src/service/util.js + 1 modules
var util = __webpack_require__(453);

// EXTERNAL MODULE: ./src/service/auth.js
var auth = __webpack_require__(149);

// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.es.js
var reactstrap_es = __webpack_require__(443);

// EXTERNAL MODULE: ./src/components/Dialog/dialog.sass
var dialog = __webpack_require__(523);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./src/actions/dialog.js
var actions_dialog = __webpack_require__(467);

// EXTERNAL MODULE: ./src/service/localStorage.js
var localStorage = __webpack_require__(150);

// EXTERNAL MODULE: ./src/api/user.js
var api_user = __webpack_require__(468);

// EXTERNAL MODULE: ./src/assets/img/icon_phone.png
var icon_phone = __webpack_require__(567);
var icon_phone_default = /*#__PURE__*/__webpack_require__.n(icon_phone);

// EXTERNAL MODULE: ./src/assets/img/icon_phone@2x.png
var icon_phone_2x = __webpack_require__(540);
var icon_phone_2x_default = /*#__PURE__*/__webpack_require__.n(icon_phone_2x);

// CONCATENATED MODULE: ./src/components/Dialog/smsChangePhoneDialog.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
















var _ref = _jsx("br", {});

var _ref2 = _jsx("br", {});

var _ref3 = _jsx("br", {});

var smsChangePhoneDialog_smsChangePhoneDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(smsChangePhoneDialog, _React$Component);

  function smsChangePhoneDialog(props) {
    var _this;

    _classCallCheck(this, smsChangePhoneDialog);

    _this = _possibleConstructorReturn(this, (smsChangePhoneDialog.__proto__ || Object.getPrototypeOf(smsChangePhoneDialog)).call(this, props));
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    _this.state = {
      setting: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json")),
      errorPhone: false,
      errorPhoneTaken: false,
      phone: Object(localStorage["b" /* localStorageGet */])('auth.phone', false),
      isClickButton: false,
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.onYes = _this.onYes.bind(_assertThisInitialized(_this));
    _this.changePhoneNumber = _this.changePhoneNumber.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(smsChangePhoneDialog, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var phone = document.getElementById('phone');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale];

        if (phone.value === '' || phone.value === null) {
          phone.setCustomValidity(errorMessage.blank_field);
        } else {
          phone.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "onYes",
    value: function onYes() {
      var patt = new RegExp(this.state.setting.PHONE_REGEX);

      if (patt.test(this.state.phone)) {
        this.changePhoneNumber(); // shouldComponentUpdate
      } else {
        this.setState({
          errorPhone: true
        });
        this.setState({
          errorPhoneTaken: false
        });
      }
    }
  }, {
    key: "changePhoneNumber",
    value: function changePhoneNumber() {
      var _this2 = this;

      if (['2', '3'].includes(this.state.phone.replace('825', '')[0]) && this.props.currentLocale.split('-')[1].toLowerCase() === 'hk') {
        this.props.onSetIsMobilePhone(false);
      } else {
        this.props.onSetIsMobilePhone(true);
      }

      var user = {
        phone_number: this.state.phone
      };
      Object(api_user["h" /* userProfileUpdate */])(Object(auth["b" /* getAuth */])().id, user, this.props.currentLocale).then(function (result) {
        if (result.status === 200 || result.status === 204) {
          result.json().then(function (res) {
            if (typeof res.name !== 'undefined') {
              Object(localStorage["d" /* localStorageSet */])('auth.username', res.name);
            }

            if (typeof res.phone_number !== 'undefined') {
              Object(localStorage["d" /* localStorageSet */])('auth.phone', res.phone_number);
            }

            Object(localStorage["d" /* localStorageSet */])('auth.has_agreed_to_receive_gogovan_updates', res.meta.has_agreed_to_receive_gogovan_updates);
            Object(localStorage["d" /* localStorageSet */])('auth.has_agreed_to_receive_third_parties_updates', res.meta.has_agreed_to_receive_third_parties_updates); // open / close dialog

            if (['4', '5'].includes(result.status.toString().split('')[0])) {
              // status error
              _this2.setState({
                errorPhone: false
              });

              _this2.setState({
                errorPhoneTaken: true
              });
            } else {
              Object(api_user["g" /* sendSMS */])(_this2.props.currentLocale, _this2.props.setIsSendingSMS);

              _this2.setState({
                errorPhone: false
              });

              _this2.setState({
                errorPhoneTaken: false
              });

              _this2.props.setIsShowSMSPhoneDialog();

              _this2.props.setIsShowSMSVerfiyDialog();
            }
          });
        } else {
          console.warn(result.status);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("div", {
        id: "smsChangePhoneDialog"
      }, void 0, _jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this3.props.setIsShowSMSPhoneDialog();
        }
      }, void 0, _jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.smallcloseRightButton),
        onClick: function onClick() {
          _this3.props.setIsShowSMSPhoneDialog();
        }
      }), _jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.infoContainer, " ").concat(dialog_default.a.orderCancelContainer, " ").concat(dialog_default.a.smsContainer)
      }, void 0, this.state.errorPhone ? _jsx("p", {
        className: dialog_default.a.dialogErrorMessage
      }, void 0, this.props.modelDataText.sms_please_enter_correct_digit_no) : '', this.state.errorPhoneTaken ? _jsx("p", {
        className: dialog_default.a.dialogErrorMessage
      }, void 0, this.props.modelDataText.sms_tel_no_being_taken) : '', _jsx("div", {
        className: dialog_default.a.infoContent,
        style: {
          paddingBottom: '20px'
        }
      }, void 0, _jsx(reactstrap_es["g" /* Form */], {}, void 0, _jsx("h2", {
        style: {
          marginBottom: '0px'
        }
      }, void 0, this.props.modelDataText.sms_verification), _ref, _jsx("p", {}, void 0, this.props.modelDataText.sms_please_enter_tel_no), _ref2, _jsx("div", {
        className: dialog_default.a.smsPhone
      }, void 0, _jsx(reactstrap_es["i" /* Input */], {
        type: "text",
        className: dialog_default.a.smsDialog,
        id: "phone",
        name: "phone",
        placeholder: "Phone",
        value: this.state.phone,
        onChange: function onChange(e) {
          _this3.setState({
            phone: e.target.value
          });
        },
        disabled: this.props.isSendingSMS
      }), _jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        className: "".concat(dialog_default.a.smsImg),
        alt: "phone"
      })), !this.props.isSendingSMS ? _jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.primary, " ").concat(style_default.a.globalTextBlue),
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          _this3.onClickisClickButton();

          _this3.onYes();
        }
      }, void 0, this.props.modelDataText.sms_change) : _jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(dialog_default.a.buttonTwoLine, " ").concat(dialog_default.a.disabled, " ").concat(dialog_default.a.buttonDisableBG),
        style: {
          width: '100%'
        },
        onClick: function onClick() {}
      }, void 0, _jsx("span", {
        className: dialog_default.a.disableText
      }, void 0, this.props.modelDataText.sms_verification), _ref3, _jsx("span", {
        className: dialog_default.a.disableText
      }, void 0, "(", this.props.modelDataText.sms_sec_remaining_prefix, this.props.second, this.props.modelDataText.sms_sec_remaining_suffix, ")")))))));
    }
  }]);

  return smsChangePhoneDialog;
}(react_default.a.Component);

var mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowSMSPhoneDialog,
    isSendingSMS: state.dialog.isSendingSMS
  };
};

var mapDispatch = {
  setIsShowSMSPhoneDialog: actions_dialog["g" /* setIsShowSMSPhoneDialog */],
  setIsShowSMSVerfiyDialog: actions_dialog["h" /* setIsShowSMSVerfiyDialog */],
  setIsSendingSMS: actions_dialog["b" /* setIsSendingSMS */]
};
/* harmony default export */ var Dialog_smsChangePhoneDialog = (Object(es["b" /* connect */])(mapState, mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(smsChangePhoneDialog_smsChangePhoneDialog)));
// EXTERNAL MODULE: ./src/components/Dialog/sms.sass
var sms = __webpack_require__(961);
var sms_default = /*#__PURE__*/__webpack_require__.n(sms);

// CONCATENATED MODULE: ./src/components/Dialog/smsVerifyDialog.js
function smsVerifyDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { smsVerifyDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { smsVerifyDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return smsVerifyDialog__typeof(obj); }

var smsVerifyDialog_REACT_ELEMENT_TYPE;

function smsVerifyDialog__jsx(type, props, key, children) { if (!smsVerifyDialog_REACT_ELEMENT_TYPE) { smsVerifyDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: smsVerifyDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function smsVerifyDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function smsVerifyDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function smsVerifyDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) smsVerifyDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) smsVerifyDialog__defineProperties(Constructor, staticProps); return Constructor; }

function smsVerifyDialog__possibleConstructorReturn(self, call) { if (call && (smsVerifyDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function smsVerifyDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function smsVerifyDialog__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var verifyCodeInputLenght = [0, 1, 2, 3];

var smsVerifyDialog__ref = smsVerifyDialog__jsx("br", {});

var smsVerifyDialog__ref2 = smsVerifyDialog__jsx("br", {});

var smsVerifyDialog__ref3 = smsVerifyDialog__jsx("br", {});

var smsVerifyDialog_smsVerifyDialog =
/*#__PURE__*/
function (_React$Component) {
  smsVerifyDialog__inherits(smsVerifyDialog, _React$Component);

  function smsVerifyDialog(props) {
    var _this;

    smsVerifyDialog__classCallCheck(this, smsVerifyDialog);

    _this = smsVerifyDialog__possibleConstructorReturn(this, (smsVerifyDialog.__proto__ || Object.getPrototypeOf(smsVerifyDialog)).call(this, props));
    _this.state = {
      errorVerificationCode: false,
      exceedRetryLimit: false,
      verifyCode: [],
      phone: Object(localStorage["b" /* localStorageGet */])('auth.phone', false)
    };
    _this.onYes = _this.onYes.bind(smsVerifyDialog__assertThisInitialized(_this));
    _this.onClickRendSMS = _this.onClickRendSMS.bind(smsVerifyDialog__assertThisInitialized(_this));
    return _this;
  }

  smsVerifyDialog__createClass(smsVerifyDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (['2', '3'].includes(this.state.phone.replace('825', '')[0]) && this.props.currentLocale.split('-')[1].toLowerCase() === 'hk') {
        this.props.onSetIsMobilePhone(false);
      }
    }
  }, {
    key: "onYes",
    value: function onYes() {
      var _this2 = this;

      Object(api_user["i" /* verificationSMS */])(this.state.verifyCode.toString().replace(/,/g, ''), this.props.currentLocale).then(function (result) {
        switch (result.status) {
          case 503:
            _this2.setState({
              exceedRetryLimit: true
            });

            break;

          case 500:
          case 401:
          case 404:
          case 403:
            _this2.setState({
              errorVerificationCode: true
            });

            break;

          default:
            _this2.props.setIsShowSMSVerfiyDialog();

            _this2.props.setIsShowSMSVerfiyLoadingDialog();

            setTimeout(function () {
              _this2.props.setIsShowSMSVerfiyLoadingDialog();

              _this2.props.setIsShowSMSVerfiySuccessDialog();

              Object(api_user["c" /* getUser */])(null, _this2.props.currentLocale);
              setTimeout(function () {
                _this2.props.setIsShowSMSVerfiySuccessDialog();
              }, 500);
            }, 500);
            break;
        }
      });
    }
  }, {
    key: "onClickRendSMS",
    value: function onClickRendSMS() {
      Object(api_user["g" /* sendSMS */])(this.props.currentLocale, this.props.setIsSendingSMS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return smsVerifyDialog__jsx("div", {
        id: "smsVerifyDialog"
      }, void 0, smsVerifyDialog__jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal // isOpen
        ,
        toggle: function toggle() {
          _this3.props.setIsShowSMSVerfiyDialog();
        }
      }, void 0, smsVerifyDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.smallcloseRightButton),
        onClick: function onClick() {
          _this3.props.setIsShowSMSVerfiyDialog();
        }
      }), smsVerifyDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.smsContainer, " ").concat(sms_default.a.smsContainer, " ").concat(sms_default.a.smsError)
      }, void 0, smsVerifyDialog__jsx("div", {}, void 0, this.state.errorVerificationCode ? smsVerifyDialog__jsx("p", {
        className: "".concat(sms_default.a.smsErrorTop, " ").concat(dialog_default.a.dialogErrorMessage),
        style: {
          marginTop: '0px'
        }
      }, void 0, this.props.modelDataText.sms_incorrect_verification_code) : '', this.state.exceedRetryLimit ? smsVerifyDialog__jsx("p", {
        className: "".concat(sms_default.a.smsErrorTop, " ").concat(dialog_default.a.dialogErrorMessage)
      }, void 0, this.props.modelDataText.sms_exceed_the_limit) : ''), smsVerifyDialog__jsx("div", {
        className: sms_default.a.stepTwo
      }, void 0, smsVerifyDialog__jsx("h2", {}, void 0, this.props.modelDataText.sms_complete_your_profile), smsVerifyDialog__jsx("div", {
        className: sms_default.a.stepTwoProgress
      }, void 0, smsVerifyDialog__jsx("p", {
        className: sms_default.a.done
      }, void 0, this.props.modelDataText.sms_register), smsVerifyDialog__jsx("p", {
        className: sms_default.a.doing
      }, void 0, this.props.modelDataText.sms_verification)), this.props.isMobilePhone ? smsVerifyDialog__jsx("p", {}, void 0, this.props.modelDataText.sms_sent_to_your_phone) : smsVerifyDialog__jsx("p", {}, void 0, this.props.modelDataText.sms_call_cs_to_verify), smsVerifyDialog__jsx("p", {
        className: "".concat(style_default.a.globalFontLight, " ").concat(style_default.a.globalTextBlue)
      }, void 0, Object(localStorage["b" /* localStorageGet */])('auth.phone', false)), smsVerifyDialog__jsx("p", {
        className: style_default.a.globalFontLight
      }, void 0, this.props.modelDataText.sms_enter_your_verify_code), smsVerifyDialog__jsx("div", {
        className: sms_default.a.smsConfirmField
      }, void 0, verifyCodeInputLenght.map(function (i) {
        return smsVerifyDialog__jsx(reactstrap_es["i" /* Input */], {
          maxLength: "1",
          className: "".concat(sms_default.a.input, " ").concat(sms_default.a.quartar),
          onKeyUp: function onKeyUp(e) {
            if (e.target.value !== '') {
              _this3.state.verifyCode[i] = e.target.value;
              e.target.nextSibling.focus();
            }
          }
        }, i);
      }), smsVerifyDialog__ref, smsVerifyDialog__ref2, smsVerifyDialog__jsx(reactstrap_es["n" /* Row */], {}, void 0, smsVerifyDialog__jsx(reactstrap_es["b" /* Col */], {}, void 0, smsVerifyDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.primary, " ").concat(style_default.a.globalTextBlue),
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          _this3.onYes();
        }
      }, void 0, this.props.modelDataText.sms_submit)), smsVerifyDialog__jsx(reactstrap_es["b" /* Col */], {}, void 0, !this.props.isSendingSMS ? smsVerifyDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " "),
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          _this3.onClickRendSMS();
        }
      }, void 0, this.props.modelDataText.sms_resend) : smsVerifyDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(dialog_default.a.buttonTwoLine, " ").concat(dialog_default.a.disabled, " ").concat(dialog_default.a.buttonDisableBG),
        style: {
          width: '100%'
        },
        onClick: function onClick() {}
      }, void 0, smsVerifyDialog__jsx("span", {
        className: dialog_default.a.disableText
      }, void 0, this.props.modelDataText.sms_sending), smsVerifyDialog__ref3, smsVerifyDialog__jsx("span", {
        className: dialog_default.a.disableText
      }, void 0, "(", this.props.modelDataText.sms_sec_remaining_prefix, this.props.second, this.props.modelDataText.sms_sec_remaining_suffix, ")"))))), smsVerifyDialog__jsx("p", {}, void 0, this.props.modelDataText.sms_entered_a_wrong_no, "\xA0", smsVerifyDialog__jsx("span", {
        className: style_default.a.globalTextBlue,
        role: "button",
        style: {
          cursor: 'pointer'
        },
        tabIndex: 0,
        onClick: function onClick() {
          _this3.props.setIsShowSMSVerfiyDialog();

          _this3.props.setIsShowSMSPhoneDialog();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.props.modelDataText.sms_use_a_different_no))))));
    }
  }]);

  return smsVerifyDialog;
}(react_default.a.Component);

var smsVerifyDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowSMSVerifyDialog,
    isSendingSMS: state.dialog.isSendingSMS
  };
};

var smsVerifyDialog_mapDispatch = {
  setIsShowSMSVerfiyDialog: actions_dialog["h" /* setIsShowSMSVerfiyDialog */],
  setIsShowSMSPhoneDialog: actions_dialog["g" /* setIsShowSMSPhoneDialog */],
  setIsSendingSMS: actions_dialog["b" /* setIsSendingSMS */],
  setIsShowSMSVerfiyLoadingDialog: actions_dialog["i" /* setIsShowSMSVerfiyLoadingDialog */],
  setIsShowSMSVerfiySuccessDialog: actions_dialog["j" /* setIsShowSMSVerfiySuccessDialog */]
};
/* harmony default export */ var Dialog_smsVerifyDialog = (Object(es["b" /* connect */])(smsVerifyDialog_mapState, smsVerifyDialog_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a, sms_default.a)(smsVerifyDialog_smsVerifyDialog)));
// EXTERNAL MODULE: ./src/assets/img/icon_loading_small.png
var icon_loading_small = __webpack_require__(906);
var icon_loading_small_default = /*#__PURE__*/__webpack_require__.n(icon_loading_small);

// EXTERNAL MODULE: ./src/assets/img/icon_loading_small@2x.png
var icon_loading_small_2x = __webpack_require__(904);
var icon_loading_small_2x_default = /*#__PURE__*/__webpack_require__.n(icon_loading_small_2x);

// CONCATENATED MODULE: ./src/components/Dialog/smsVerifyLoadingDialog.js
function smsVerifyLoadingDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { smsVerifyLoadingDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { smsVerifyLoadingDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return smsVerifyLoadingDialog__typeof(obj); }

var smsVerifyLoadingDialog_REACT_ELEMENT_TYPE;

function smsVerifyLoadingDialog__jsx(type, props, key, children) { if (!smsVerifyLoadingDialog_REACT_ELEMENT_TYPE) { smsVerifyLoadingDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: smsVerifyLoadingDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function smsVerifyLoadingDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function smsVerifyLoadingDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function smsVerifyLoadingDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) smsVerifyLoadingDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) smsVerifyLoadingDialog__defineProperties(Constructor, staticProps); return Constructor; }

function smsVerifyLoadingDialog__possibleConstructorReturn(self, call) { if (call && (smsVerifyLoadingDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function smsVerifyLoadingDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var smsVerifyLoadingDialog_smsVerifyLoadingDialog =
/*#__PURE__*/
function (_React$Component) {
  smsVerifyLoadingDialog__inherits(smsVerifyLoadingDialog, _React$Component);

  function smsVerifyLoadingDialog() {
    smsVerifyLoadingDialog__classCallCheck(this, smsVerifyLoadingDialog);

    return smsVerifyLoadingDialog__possibleConstructorReturn(this, (smsVerifyLoadingDialog.__proto__ || Object.getPrototypeOf(smsVerifyLoadingDialog)).apply(this, arguments));
  }

  smsVerifyLoadingDialog__createClass(smsVerifyLoadingDialog, [{
    key: "render",
    value: function render() {
      return smsVerifyLoadingDialog__jsx("div", {
        id: "blacklist"
      }, void 0, smsVerifyLoadingDialog__jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal // isOpen

      }, void 0, smsVerifyLoadingDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.smsContainer, " ").concat(sms_default.a.smsContainer, " ").concat(sms_default.a.smsError),
        style: {
          padding: 0
        }
      }, void 0, smsVerifyLoadingDialog__jsx("p", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(sms_default.a.smsStatus)
      }, void 0, this.props.modelDataText.sms_verifying, "\xA0", smsVerifyLoadingDialog__jsx("img", {
        className: style_default.a.graphsRotate,
        srcSet: "".concat(icon_loading_small_default.a, " 1x, ").concat(icon_loading_small_2x_default.a, " 2x"),
        width: "30",
        height: "30",
        alt: "loading"
      })))));
    }
  }]);

  return smsVerifyLoadingDialog;
}(react_default.a.Component);

var smsVerifyLoadingDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowSMSVerifyLoadingDialog
  };
};

/* harmony default export */ var Dialog_smsVerifyLoadingDialog = (Object(es["b" /* connect */])(smsVerifyLoadingDialog_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(smsVerifyLoadingDialog_smsVerifyLoadingDialog)));
// EXTERNAL MODULE: ./src/assets/img/icon_loading_complete.png
var icon_loading_complete = __webpack_require__(1019);
var icon_loading_complete_default = /*#__PURE__*/__webpack_require__.n(icon_loading_complete);

// EXTERNAL MODULE: ./src/assets/img/icon_loading_complete@2x.png
var icon_loading_complete_2x = __webpack_require__(962);
var icon_loading_complete_2x_default = /*#__PURE__*/__webpack_require__.n(icon_loading_complete_2x);

// CONCATENATED MODULE: ./src/components/Dialog/smsVerifySuccessDialog.js
function smsVerifySuccessDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { smsVerifySuccessDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { smsVerifySuccessDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return smsVerifySuccessDialog__typeof(obj); }

var smsVerifySuccessDialog_REACT_ELEMENT_TYPE;

function smsVerifySuccessDialog__jsx(type, props, key, children) { if (!smsVerifySuccessDialog_REACT_ELEMENT_TYPE) { smsVerifySuccessDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: smsVerifySuccessDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function smsVerifySuccessDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function smsVerifySuccessDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function smsVerifySuccessDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) smsVerifySuccessDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) smsVerifySuccessDialog__defineProperties(Constructor, staticProps); return Constructor; }

function smsVerifySuccessDialog__possibleConstructorReturn(self, call) { if (call && (smsVerifySuccessDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function smsVerifySuccessDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var smsVerifySuccessDialog_smsVerifySuccessDialog =
/*#__PURE__*/
function (_React$Component) {
  smsVerifySuccessDialog__inherits(smsVerifySuccessDialog, _React$Component);

  function smsVerifySuccessDialog() {
    smsVerifySuccessDialog__classCallCheck(this, smsVerifySuccessDialog);

    return smsVerifySuccessDialog__possibleConstructorReturn(this, (smsVerifySuccessDialog.__proto__ || Object.getPrototypeOf(smsVerifySuccessDialog)).apply(this, arguments));
  }

  smsVerifySuccessDialog__createClass(smsVerifySuccessDialog, [{
    key: "render",
    value: function render() {
      return smsVerifySuccessDialog__jsx("div", {
        id: "blacklist"
      }, void 0, smsVerifySuccessDialog__jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal
      }, void 0, smsVerifySuccessDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.smsContainer, " ").concat(sms_default.a.smsContainer, " ").concat(sms_default.a.smsError),
        style: {
          padding: 0
        }
      }, void 0, smsVerifySuccessDialog__jsx("p", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(sms_default.a.smsStatus)
      }, void 0, this.props.modelDataText.sms_success, "\xA0", smsVerifySuccessDialog__jsx("img", {
        srcSet: "".concat(icon_loading_complete_default.a, " 1x, ").concat(icon_loading_complete_2x_default.a, " 2x"),
        width: "30",
        height: "30",
        alt: "complete"
      })))));
    }
  }]);

  return smsVerifySuccessDialog;
}(react_default.a.Component);

var smsVerifySuccessDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowSMSVerifySuccessDialog
  };
};

/* harmony default export */ var Dialog_smsVerifySuccessDialog = (Object(es["b" /* connect */])(smsVerifySuccessDialog_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(smsVerifySuccessDialog_smsVerifySuccessDialog)));
// CONCATENATED MODULE: ./src/ctrl/smsCtrl.js
function smsCtrl__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { smsCtrl__typeof = function _typeof(obj) { return typeof obj; }; } else { smsCtrl__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return smsCtrl__typeof(obj); }

var smsCtrl_REACT_ELEMENT_TYPE;

function smsCtrl__jsx(type, props, key, children) { if (!smsCtrl_REACT_ELEMENT_TYPE) { smsCtrl_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: smsCtrl_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function smsCtrl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function smsCtrl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function smsCtrl__createClass(Constructor, protoProps, staticProps) { if (protoProps) smsCtrl__defineProperties(Constructor.prototype, protoProps); if (staticProps) smsCtrl__defineProperties(Constructor, staticProps); return Constructor; }

function smsCtrl__possibleConstructorReturn(self, call) { if (call && (smsCtrl__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function smsCtrl__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function smsCtrl__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }












var sendingTime = 60;

var smsCtrl_smsCtrl =
/*#__PURE__*/
function (_React$Component) {
  smsCtrl__inherits(smsCtrl, _React$Component);

  function smsCtrl(props) {
    var _this;

    smsCtrl__classCallCheck(this, smsCtrl);

    _this = smsCtrl__possibleConstructorReturn(this, (smsCtrl.__proto__ || Object.getPrototypeOf(smsCtrl)).call(this, props));
    var langType = props.currentLocale.split('-')[0]; // en-SG

    var lang = props.currentLocale.split('-')[1].toLowerCase();

    if (lang === 'hk') {
      langType = "".concat(langType, "-").concat(lang);
    } else if (['sg', 'in'].includes(lang)) {
      langType = 'en';
    } else {
      langType = lang;
    }

    _this.state = {
      isChangeable: true,
      isMobilePhone: true,
      second: sendingTime,
      modelDataText: __webpack_require__(1487)("./".concat(lang, "/").concat(langType, ".json"))
    };
    _this.timeChange = _this.timeChange.bind(smsCtrl__assertThisInitialized(_this));
    _this.onSetIsMobilePhone = _this.onSetIsMobilePhone.bind(smsCtrl__assertThisInitialized(_this));
    return _this;
  }

  smsCtrl__createClass(smsCtrl, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isSendingSMS) {
        this.timeChange();
      }
    }
  }, {
    key: "onClickIsChangeable",
    value: function onClickIsChangeable() {
      this.setState({
        isChangeable: !this.state.isChangeable
      });
    }
  }, {
    key: "onSetIsMobilePhone",
    value: function onSetIsMobilePhone(bool) {
      var _this2 = this;

      this.setState({
        isMobilePhone: bool
      }, function () {
        _this2.forceUpdate();
      });
    }
  }, {
    key: "timeChange",
    value: function timeChange() {
      var _this3 = this;

      var countdown = setInterval(function () {
        _this3.setState({
          second: _this3.state.second -= 1
        });

        if (_this3.state.second === 0) {
          clearInterval(countdown);

          _this3.props.setIsSendingSMS(false);

          _this3.setState({
            second: sendingTime
          });
        }
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      return smsCtrl__jsx("div", {}, void 0, smsCtrl__jsx("div", {
        id: "step-one"
      }, void 0, smsCtrl__jsx(Dialog_smsChangePhoneDialog, {
        second: this.state.second,
        onSetIsMobilePhone: this.onSetIsMobilePhone,
        modelDataText: this.state.modelDataText
      })), smsCtrl__jsx("div", {
        id: "step-two"
      }, void 0, smsCtrl__jsx(Dialog_smsVerifyDialog, {
        second: this.state.second,
        isMobilePhone: this.state.isMobilePhone,
        onSetIsMobilePhone: this.onSetIsMobilePhone,
        modelDataText: this.state.modelDataText
      })), smsCtrl__jsx("div", {
        id: "sms-verifiying"
      }, void 0, smsCtrl__jsx(Dialog_smsVerifyLoadingDialog, {
        modelDataText: this.state.modelDataText
      })), smsCtrl__jsx("div", {
        id: "sms-verified"
      }, void 0, smsCtrl__jsx(Dialog_smsVerifySuccessDialog, {
        modelDataText: this.state.modelDataText
      })));
    }
  }]);

  return smsCtrl;
}(react_default.a.Component);

var smsCtrl_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isSendingSMS: state.dialog.isSendingSMS
  };
};

var smsCtrl_mapDispatch = {
  setIsSendingSMS: actions_dialog["b" /* setIsSendingSMS */]
};
/* harmony default export */ var ctrl_smsCtrl = (Object(es["b" /* connect */])(smsCtrl_mapState, smsCtrl_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a)(smsCtrl_smsCtrl)));
// EXTERNAL MODULE: ./src/actions/order.js
var actions_order = __webpack_require__(455);

// EXTERNAL MODULE: ./node_modules/react-slidedown/lib/slidedown.js
var lib_slidedown = __webpack_require__(902);
var lib_slidedown_default = /*#__PURE__*/__webpack_require__.n(lib_slidedown);

// EXTERNAL MODULE: ./src/ctrl/orderInti.json
var orderInti = __webpack_require__(1020);
var orderInti_default = /*#__PURE__*/__webpack_require__.n(orderInti);

// CONCATENATED MODULE: ./src/routes/order/Order01SelectVehicle/Order01SelectVehicle.js
function Order01SelectVehicle__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order01SelectVehicle__typeof = function _typeof(obj) { return typeof obj; }; } else { Order01SelectVehicle__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order01SelectVehicle__typeof(obj); }

var Order01SelectVehicle_REACT_ELEMENT_TYPE;

function Order01SelectVehicle__jsx(type, props, key, children) { if (!Order01SelectVehicle_REACT_ELEMENT_TYPE) { Order01SelectVehicle_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order01SelectVehicle_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order01SelectVehicle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order01SelectVehicle__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order01SelectVehicle__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order01SelectVehicle__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order01SelectVehicle__defineProperties(Constructor, staticProps); return Constructor; }

function Order01SelectVehicle__possibleConstructorReturn(self, call) { if (call && (Order01SelectVehicle__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order01SelectVehicle__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order01SelectVehicle__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import








var Order01SelectVehicle__ref = Order01SelectVehicle__jsx("br", {});

var Order01SelectVehicle__ref2 = Order01SelectVehicle__jsx("br", {});

var Order01SelectVehicle_Order01SelectVehicle =
/*#__PURE__*/
function (_React$Component) {
  Order01SelectVehicle__inherits(Order01SelectVehicle, _React$Component);

  function Order01SelectVehicle(props) {
    var _this;

    Order01SelectVehicle__classCallCheck(this, Order01SelectVehicle);

    _this = Order01SelectVehicle__possibleConstructorReturn(this, (Order01SelectVehicle.__proto__ || Object.getPrototypeOf(Order01SelectVehicle)).call(this, props));
    _this.state = {
      selectedVehicle: '',
      lang: props.currentLocale.split('-')[1].toLowerCase()
    };
    _this.onClickSelectVehicle = _this.onClickSelectVehicle.bind(Order01SelectVehicle__assertThisInitialized(_this));
    return _this;
  }

  Order01SelectVehicle__createClass(Order01SelectVehicle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // get selectedVehicle, then remove this in localStorage
      if (Object(localStorage["b" /* localStorageGet */])('selectedVehicle', false) !== null) {
        this.onClickSelectVehicle(Object(localStorage["b" /* localStorageGet */])('selectedVehicle', false));
      } else {
        this.onClickSelectVehicle(this.props.modelData.vehicle_type.types[0].type);
      }
    } // ensure remove selectVehicle in localStorage

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object(localStorage["c" /* localStorageRemove */])('selectedVehicle');
    }
  }, {
    key: "onClickSelectVehicle",
    value: function onClickSelectVehicle(type) {
      this.props.setOrderVehicleType(type);
      this.setState({
        selectedVehicle: type
      });
      this.props.updateOrderDetailInfoAction('vehicle', null, type);

      if (this.state.lang === 'hk') {
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, orderInti_default.a.orderDetailInfo[this.state.lang].order_request_detail_attributes);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order01SelectVehicle__jsx("div", {}, void 0, Order01SelectVehicle__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_vehicle_title), Order01SelectVehicle__jsx(reactstrap_es["n" /* Row */], {}, void 0, this.props.modelData.vehicle_type.types.map(function (obj, index) {
        var img = obj.icon.toString();
        var img1 = img.split(',')[0].split(' ')[0];
        img1 = img1.split('/').reverse()[0].split('.')[0];

        var imgBlueVehicle = __webpack_require__(970)("./".concat(img1, ".png"));

        var imgBlueVehicle2 = __webpack_require__(971)("./".concat(img1, "@2x.png"));

        return Order01SelectVehicle__jsx(reactstrap_es["b" /* Col */], {
          xs: "12",
          sm: "12",
          md: "4"
        }, index.toString(), Order01SelectVehicle__jsx("div", {
          className: "".concat(_this2.state.selectedVehicle === obj.type ? Order_default.a.vehicleGridActive : [Order_default.a.vehicleGrid, Order_default.a.selectVehicle].join(' ')),
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            _this2.onClickSelectVehicle(obj.type);
          },
          onKeyPress: function onKeyPress() {}
        }, void 0, Order01SelectVehicle__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order01SelectVehicle__jsx(reactstrap_es["b" /* Col */], {
          md: "12",
          xs: "3"
        }, void 0, Order01SelectVehicle__jsx("img", {
          width: "72",
          height: "72",
          alt: obj.title,
          srcSet: "".concat(imgBlueVehicle, " 1x, ").concat(imgBlueVehicle2, " 2x")
        }), Order01SelectVehicle__ref, Order01SelectVehicle__ref2), Order01SelectVehicle__jsx(reactstrap_es["b" /* Col */], {
          md: "12"
        }, void 0, Order01SelectVehicle__jsx("span", {
          dangerouslySetInnerHTML: {
            __html: obj.title
          },
          style: {
            color: '#0088bf'
          }
        })))));
      })));
    }
  }]);

  return Order01SelectVehicle;
}(react_default.a.Component);

var Order01SelectVehicle_mapState = function mapState(state) {
  return {
    isToggleOn: state.order.isToggleOn,
    currentLocale: state.intl.locale
  };
};

var Order01SelectVehicle_mapDispatch = {
  setOrderVehicleType: actions_order["q" /* setOrderVehicleType */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order01SelectVehicle_Order01SelectVehicle = (Object(es["b" /* connect */])(Order01SelectVehicle_mapState, Order01SelectVehicle_mapDispatch)(withStyles_default()(bootstrap_default.a, Order_default.a)(Order01SelectVehicle_Order01SelectVehicle)));
// CONCATENATED MODULE: ./src/routes/order/Order03Pessenger/Order03Pessenger.js
function Order03Pessenger__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order03Pessenger__typeof = function _typeof(obj) { return typeof obj; }; } else { Order03Pessenger__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order03Pessenger__typeof(obj); }

var Order03Pessenger_REACT_ELEMENT_TYPE;

function Order03Pessenger__jsx(type, props, key, children) { if (!Order03Pessenger_REACT_ELEMENT_TYPE) { Order03Pessenger_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order03Pessenger_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order03Pessenger__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order03Pessenger__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order03Pessenger__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order03Pessenger__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order03Pessenger__defineProperties(Constructor, staticProps); return Constructor; }

function Order03Pessenger__possibleConstructorReturn(self, call) { if (call && (Order03Pessenger__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order03Pessenger__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import


 // Relative import








var Order03Pessenger_Order03Pessenger =
/*#__PURE__*/
function (_React$Component) {
  Order03Pessenger__inherits(Order03Pessenger, _React$Component);

  function Order03Pessenger() {
    Order03Pessenger__classCallCheck(this, Order03Pessenger);

    return Order03Pessenger__possibleConstructorReturn(this, (Order03Pessenger.__proto__ || Object.getPrototypeOf(Order03Pessenger)).apply(this, arguments));
  }

  Order03Pessenger__createClass(Order03Pessenger, [{
    key: "render",
    value: function render() {
      var _this = this;

      var passengerNumber = [0, 1, 2, 3, 4, 5];
      return Order03Pessenger__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "6"
      }, void 0, Order03Pessenger__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_option_passenger_title), Order03Pessenger__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          e.preventDefault();

          _this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'passenger_count', parseInt(e.target.value, 10));
        }
      }, void 0, passengerNumber.map(function (i) {
        return Order03Pessenger__jsx("option", {
          value: i
        }, i, i, " \xA0", i < 2 ? _this.props.modelDataText.order.order_option_passenger_body : _this.props.modelDataText.order.order_option_passenger_body_plural);
      })));
    }
  }]);

  return Order03Pessenger;
}(react_default.a.Component);

var Order03Pessenger_mapState = function mapState(state) {
  return {
    vehiclePrice: state.quoting.vehiclePrice
  };
};

var Order03Pessenger_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order03Pessenger_Order03Pessenger = (Object(es["b" /* connect */])(Order03Pessenger_mapState, Order03Pessenger_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order03Pessenger_Order03Pessenger)));
// CONCATENATED MODULE: ./src/routes/order/Order04Tunnel/Order04Tunnel.js
function Order04Tunnel__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order04Tunnel__typeof = function _typeof(obj) { return typeof obj; }; } else { Order04Tunnel__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order04Tunnel__typeof(obj); }

var Order04Tunnel_REACT_ELEMENT_TYPE;

function Order04Tunnel__jsx(type, props, key, children) { if (!Order04Tunnel_REACT_ELEMENT_TYPE) { Order04Tunnel_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order04Tunnel_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order04Tunnel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order04Tunnel__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order04Tunnel__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order04Tunnel__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order04Tunnel__defineProperties(Constructor, staticProps); return Constructor; }

function Order04Tunnel__possibleConstructorReturn(self, call) { if (call && (Order04Tunnel__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order04Tunnel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import







var Order04Tunnel_Order04Tunnel =
/*#__PURE__*/
function (_React$Component) {
  Order04Tunnel__inherits(Order04Tunnel, _React$Component);

  function Order04Tunnel() {
    Order04Tunnel__classCallCheck(this, Order04Tunnel);

    return Order04Tunnel__possibleConstructorReturn(this, (Order04Tunnel.__proto__ || Object.getPrototypeOf(Order04Tunnel)).apply(this, arguments));
  }

  Order04Tunnel__createClass(Order04Tunnel, [{
    key: "render",
    value: function render() {
      var _this = this;

      var indents2 = [];

      for (var i = 0; i < this.props.modelData.tunnel.tunnels.length; i += 1) {
        indents2.push(Order04Tunnel__jsx("option", {
          value: i
        }, void 0, this.props.modelData.tunnel.tunnels[i].title));
      }

      return Order04Tunnel__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "6"
      }, void 0, Order04Tunnel__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelData.tunnel.title), Order04Tunnel__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          e.preventDefault();

          _this.props.updateOrderDetailInfoAction('tunnel', null, e.target.value);
        }
      }, void 0, this.props.modelData.tunnel.tunnels.map(function (i) {
        return Order04Tunnel__jsx("option", {
          value: "".concat(i.tunnel_code)
        }, "".concat(i.tunnel_code), i.title);
      })));
    }
  }]);

  return Order04Tunnel;
}(react_default.a.Component);

var Order04Tunnel_mapState = function mapState(state) {
  return {
    tunnel: state.quoting.tunnel
  };
};

var Order04Tunnel_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order04Tunnel_Order04Tunnel = (Object(es["b" /* connect */])(Order04Tunnel_mapState, Order04Tunnel_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order04Tunnel_Order04Tunnel)));
// EXTERNAL MODULE: ./src/actions/quoting.js
var quoting = __webpack_require__(972);

// CONCATENATED MODULE: ./src/routes/order/autoComplete.js
function autoComplete__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { autoComplete__typeof = function _typeof(obj) { return typeof obj; }; } else { autoComplete__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return autoComplete__typeof(obj); }

var autoComplete_REACT_ELEMENT_TYPE;

function autoComplete__jsx(type, props, key, children) { if (!autoComplete_REACT_ELEMENT_TYPE) { autoComplete_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: autoComplete_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function autoComplete__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function autoComplete__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function autoComplete__createClass(Constructor, protoProps, staticProps) { if (protoProps) autoComplete__defineProperties(Constructor.prototype, protoProps); if (staticProps) autoComplete__defineProperties(Constructor, staticProps); return Constructor; }

function autoComplete__possibleConstructorReturn(self, call) { if (call && (autoComplete__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function autoComplete__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function autoComplete__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }








var autoComplete_autoComplete =
/*#__PURE__*/
function (_React$Component) {
  autoComplete__inherits(autoComplete, _React$Component);

  function autoComplete(props) {
    var _this;

    autoComplete__classCallCheck(this, autoComplete);

    _this = autoComplete__possibleConstructorReturn(this, (autoComplete.__proto__ || Object.getPrototypeOf(autoComplete)).call(this, props));
    _this.onClickLocationName = _this.onClickLocationName.bind(autoComplete__assertThisInitialized(_this));
    return _this;
  }

  autoComplete__createClass(autoComplete, [{
    key: "onClickLocationName",
    value: function onClickLocationName(location) {
      this.props.onClickSelectSuggestion({
        description: location.description,
        place_id: location.place_id
      }, this.props.index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.suggestion.length <= 0) {
        return '';
      }

      return autoComplete__jsx("ul", {
        role: "menu",
        className: "".concat(Order_default.a.suggestionContainer)
      }, void 0, this.props.suggestion.map(function (i, index) {
        return autoComplete__jsx("li", {
          className: "".concat(Order_default.a.suggestionItem)
        }, index.toString(), autoComplete__jsx("span", {
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            _this2.onClickLocationName(i);
          },
          onKeyPress: function onKeyPress() {},
          className: "".concat(Order_default.a.suggestionSpan)
        }, void 0, i.description));
      }));
    }
  }]);

  return autoComplete;
}(react_default.a.Component);

Object.defineProperty(autoComplete_autoComplete, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    suggestion: []
  }
});

var autoComplete_mapState = function mapState(state) {
  return {
    address1: state.quoting.address1,
    address2: state.quoting.address2
  };
};

var autoComplete_mapDispatch = {
  setQuotingMapLocation1: quoting["b" /* setQuotingMapLocation1 */],
  setQuotingMapLocation2: quoting["c" /* setQuotingMapLocation2 */]
};
/* harmony default export */ var order_autoComplete = (Object(es["b" /* connect */])(autoComplete_mapState, autoComplete_mapDispatch)(withStyles_default()(Order_default.a)(autoComplete_autoComplete)));
// EXTERNAL MODULE: ./src/api/map.js
var map = __webpack_require__(903);

// CONCATENATED MODULE: ./src/routes/order/order09Path/Order09PathStaticMap.js
function Order09PathStaticMap__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order09PathStaticMap__typeof = function _typeof(obj) { return typeof obj; }; } else { Order09PathStaticMap__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order09PathStaticMap__typeof(obj); }

var Order09PathStaticMap_REACT_ELEMENT_TYPE;

function Order09PathStaticMap__jsx(type, props, key, children) { if (!Order09PathStaticMap_REACT_ELEMENT_TYPE) { Order09PathStaticMap_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order09PathStaticMap_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order09PathStaticMap__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order09PathStaticMap__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order09PathStaticMap__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order09PathStaticMap__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order09PathStaticMap__defineProperties(Constructor, staticProps); return Constructor; }

function Order09PathStaticMap__possibleConstructorReturn(self, call) { if (call && (Order09PathStaticMap__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order09PathStaticMap__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order09PathStaticMap__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import





var staticGoogleMapKey = "AIzaSyDv9PDY8W1vG_4SNlyiD2fMTLCHK1tEUoY";

var Order09PathStaticMap_Order09PathStaticMap =
/*#__PURE__*/
function (_React$Component) {
  Order09PathStaticMap__inherits(Order09PathStaticMap, _React$Component);

  function Order09PathStaticMap(props) {
    var _this;

    Order09PathStaticMap__classCallCheck(this, Order09PathStaticMap);

    _this = Order09PathStaticMap__possibleConstructorReturn(this, (Order09PathStaticMap.__proto__ || Object.getPrototypeOf(Order09PathStaticMap)).call(this, props));
    _this.state = {
      modal: props.openModal,
      staticMapUrl: ''
    };
    _this.toggle = _this.toggle.bind(Order09PathStaticMap__assertThisInitialized(_this));
    return _this;
  } // Need Gogovan Key and signature


  Order09PathStaticMap__createClass(Order09PathStaticMap, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.openModal !== this.props.openModal) {
        this.setState({
          modal: nextProps.openModal
        });
        var url = "https://maps.googleapis.com/maps/api/staticmap?center=".concat(nextProps.activeSuggestion.geometry.location.lat, ",").concat(nextProps.activeSuggestion.geometry.location.lng, "&size=620x380&sensor=true&zoom=16&scale=1&markers=icon:http://www.gogovan.com.hk/img/map_marker_1.png%7C").concat(nextProps.activeSuggestion.geometry.location.lat, ",").concat(nextProps.activeSuggestion.geometry.location.lng, "&scale=1.100000023841858&key=").concat(staticGoogleMapKey);
        this.setState({
          staticMapUrl: url
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        modal: !this.state.modal
      });
      this.props.onClickToggleStaticMap(false);
      this.setState({
        staticMapUrl: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      return Order09PathStaticMap__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.state.modal,
        toggle: this.toggle,
        className: "".concat(style_default.a.infoPopup, " ").concat(Order_default.a.staticMapInfo)
      }, void 0, Order09PathStaticMap__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: this.toggle,
        className: "".concat(Order_default.a.infoCloseRightButton)
      }), Order09PathStaticMap__jsx("img", {
        className: Order_default.a.staticMap,
        src: this.state.staticMapUrl,
        alt: "staticMap"
      }));
    }
  }]);

  return Order09PathStaticMap;
}(react_default.a.Component);

var Order09PathStaticMap_mapState = function mapState(state) {
  return {
    address: state.order.address
  };
};

var Order09PathStaticMap_mapDispatch = {
  addOrderAddress: actions_order["a" /* addOrderAddress */]
};
/* harmony default export */ var order09Path_Order09PathStaticMap = (Object(es["b" /* connect */])(Order09PathStaticMap_mapState, Order09PathStaticMap_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order09PathStaticMap_Order09PathStaticMap)));
// EXTERNAL MODULE: ./node_modules/uuid/index.js
var uuid = __webpack_require__(1717);
var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid);

// EXTERNAL MODULE: ./src/assets/img/icon_clear_2.png
var icon_clear_2 = __webpack_require__(926);
var icon_clear_2_default = /*#__PURE__*/__webpack_require__.n(icon_clear_2);

// EXTERNAL MODULE: ./src/assets/img/icon_clear_2@2x.png
var icon_clear_2_2x = __webpack_require__(917);
var icon_clear_2_2x_default = /*#__PURE__*/__webpack_require__.n(icon_clear_2_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_from.png
var icon_from = __webpack_require__(1219);
var icon_from_default = /*#__PURE__*/__webpack_require__.n(icon_from);

// EXTERNAL MODULE: ./src/assets/img/icon_from@2x.png
var icon_from_2x = __webpack_require__(973);
var icon_from_2x_default = /*#__PURE__*/__webpack_require__.n(icon_from_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_mid.png
var icon_mid = __webpack_require__(1220);
var icon_mid_default = /*#__PURE__*/__webpack_require__.n(icon_mid);

// EXTERNAL MODULE: ./src/assets/img/icon_mid@2x.png
var icon_mid_2x = __webpack_require__(974);
var icon_mid_2x_default = /*#__PURE__*/__webpack_require__.n(icon_mid_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_to.png
var icon_to = __webpack_require__(1221);
var icon_to_default = /*#__PURE__*/__webpack_require__.n(icon_to);

// EXTERNAL MODULE: ./src/assets/img/icon_to@2x.png
var icon_to_2x = __webpack_require__(975);
var icon_to_2x_default = /*#__PURE__*/__webpack_require__.n(icon_to_2x);

// CONCATENATED MODULE: ./src/routes/order/order09Path/Order09PathComponent.js
function Order09PathComponent__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order09PathComponent__typeof = function _typeof(obj) { return typeof obj; }; } else { Order09PathComponent__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order09PathComponent__typeof(obj); }

var Order09PathComponent_REACT_ELEMENT_TYPE;

function Order09PathComponent__jsx(type, props, key, children) { if (!Order09PathComponent_REACT_ELEMENT_TYPE) { Order09PathComponent_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order09PathComponent_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order09PathComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order09PathComponent__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order09PathComponent__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order09PathComponent__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order09PathComponent__defineProperties(Constructor, staticProps); return Constructor; }

function Order09PathComponent__possibleConstructorReturn(self, call) { if (call && (Order09PathComponent__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order09PathComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order09PathComponent__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import


















var Order09PathComponent_address = {
  address: '',
  lat: 0,
  lon: 0
};

var Order09PathComponent_Order09PathComponent =
/*#__PURE__*/
function (_React$Component) {
  Order09PathComponent__inherits(Order09PathComponent, _React$Component);

  function Order09PathComponent(props) {
    var _this;

    Order09PathComponent__classCallCheck(this, Order09PathComponent);

    _this = Order09PathComponent__possibleConstructorReturn(this, (Order09PathComponent.__proto__ || Object.getPrototypeOf(Order09PathComponent)).call(this, props));
    _this.state = {
      address: '',
      autoCompleteSuggestion: [],
      openModal: false,
      activeSuggestion: {},
      addresses: Object(localStorage["b" /* localStorageGet */])('addresses', false),
      googleMapSessionToken: null
    };
    _this.onhandleLocationChange = _this.onhandleLocationChange.bind(Order09PathComponent__assertThisInitialized(_this));
    _this.onClickSelectSuggestion = _this.onClickSelectSuggestion.bind(Order09PathComponent__assertThisInitialized(_this));
    _this.onGetLocationSuggestionDetail = _this.onGetLocationSuggestionDetail.bind(Order09PathComponent__assertThisInitialized(_this));
    _this.onClickToggleStaticMap = _this.onClickToggleStaticMap.bind(Order09PathComponent__assertThisInitialized(_this));
    _this.checkOrderAddressItem = _this.checkOrderAddressItem.bind(Order09PathComponent__assertThisInitialized(_this));
    _this.onClickClearAddress = _this.onClickClearAddress.bind(Order09PathComponent__assertThisInitialized(_this));
    return _this;
  }

  Order09PathComponent__createClass(Order09PathComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(localStorage["b" /* localStorageGet */])('addresses', false) !== null && this.state.addresses.waypoints.length > this.props.index) {
        // this.props.updateOrderAddress(
        //   addresses[`address${this.props.index + 1}`],
        //   this.props.index,
        // );
        this.setState({
          address: this.state.addresses.waypoints[this.props.index].address
        }); // in

        this.setState({
          activeSuggestion: {
            geometry: {
              location: {
                lat: this.state.addresses.waypoints[this.props.index].location.lat,
                lng: this.state.addresses.waypoints[this.props.index].location.lon
              }
            }
          }
        });
      }
    }
  }, {
    key: "onClickClearAddress",
    value: function onClickClearAddress(index) {
      this.setState({
        address: ''
      });
      this.props.updateOrderAddress({
        address: '',
        lat: 0,
        lon: 0
      }, index);
    }
  }, {
    key: "onClickSelectSuggestion",
    value: function onClickSelectSuggestion(suggestion, index) {
      this.setState({
        address: suggestion.description
      });
      this.setState({
        autoCompleteSuggestion: []
      });
      this.onGetLocationSuggestionDetail(suggestion.place_id, index);
    }
  }, {
    key: "onGetLocationSuggestionDetail",
    value: function onGetLocationSuggestionDetail(placeID, index) {
      var _this2 = this;

      Object(map["b" /* getLocationSuggestionDetail */])(placeID, this.props.currentLocale, this.state.googleMapSessionToken).then(function (response) {
        return response.json();
      }).then(function (result) {
        _this2.setState({
          activeSuggestion: result.result
        });

        Order09PathComponent_address = {
          address: result.result.formatted_address,
          lat: result.result.geometry.location.lat,
          lon: result.result.geometry.location.lng
        };

        _this2.checkOrderAddressItem(Order09PathComponent_address, index);
      }).catch(function (error) {
        console.warn('Request failed', error);
      }).finally(function () {
        _this2.setState({
          googleMapSessionToken: null
        });
      });
    }
  }, {
    key: "onhandleLocationChange",
    value: function onhandleLocationChange(e) {
      var _this3 = this;

      var sessionToken = this.state.googleMapSessionToken === null ? Object(uuid["v4"])() : this.state.googleMapSessionToken;
      this.setState({
        address: e.target.value,
        googleMapSessionToken: sessionToken
      });
      Object(map["a" /* getLocationSuggestion */])(e.target.value, this.props.currentLocale, sessionToken).then(function (response) {
        return response.json();
      }).then(function (result) {
        _this3.setState({
          autoCompleteSuggestion: result.predictions
        });
      }).catch(function (error) {
        console.warn('Request failed', error);
      });
      this.forceUpdate();
    }
  }, {
    key: "onClickToggleStaticMap",
    value: function onClickToggleStaticMap(bool) {
      this.setState({
        openModal: bool
      });
    } // Check if add address or update address

  }, {
    key: "checkOrderAddressItem",
    value: function checkOrderAddressItem(addresses, index) {
      if (this.props.address.length < index) {
        this.props.addOrderAddress(addresses);
      } else {
        this.props.updateOrderAddress(addresses, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var index = this.props.index;
      var imgTag = '';
      var imgTag2 = '';
      var imgClass = '';
      var imgPlaceholder = this.props.modelDataText.order_option_route_location_2_address_input;

      if (index === 0) {
        imgTag = icon_from_default.a;
        imgTag2 = icon_from_2x_default.a;
        imgClass = Order_default.a.routeStartImg;
        imgPlaceholder = this.props.modelDataText.order_option_route_location_1_address_input;
      } else if (index < this.props.address.length - 1) {
        imgTag = icon_mid_default.a;
        imgTag2 = icon_mid_2x_default.a;
        imgClass = Order_default.a.routeMidImg;
      } else {
        imgTag = icon_to_default.a;
        imgTag2 = icon_to_2x_default.a;
        imgClass = Order_default.a.routeEndImg;
      }

      return Order09PathComponent__jsx(reactstrap_es["n" /* Row */], {}, index, Order09PathComponent__jsx(reactstrap_es["b" /* Col */], {
        md: "10",
        xs: "10"
      }, void 0, Order09PathComponent__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: imgPlaceholder,
        id: index,
        onChange: this.onhandleLocationChange,
        onBlur: function onBlur() {
          setTimeout(function () {
            _this4.setState({
              autoCompleteSuggestion: []
            });
          }, 200);
        },
        value: this.state.address
      }), Order09PathComponent__jsx(order_autoComplete, {
        suggestion: this.state.autoCompleteSuggestion,
        onClickSelectSuggestion: this.onClickSelectSuggestion,
        index: index
      }), Order09PathComponent__jsx("img", {
        className: "".concat(Order_default.a.imgIconLeft, " ").concat(imgClass),
        srcSet: "".concat(imgTag, " 1x, ").concat(imgTag2, " 2x"),
        width: "13",
        alt: "start"
      }), this.state.address === '' ? '' : Order09PathComponent__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this4.onClickClearAddress(index);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09PathComponent__jsx("img", {
        className: "".concat(Order_default.a.inputClear),
        srcSet: "".concat(icon_clear_2_default.a, " 1x, ").concat(icon_clear_2_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "clear"
      }))), Order09PathComponent__jsx(reactstrap_es["b" /* Col */], {
        md: "2",
        xs: "2",
        className: "".concat(Order_default.a.orderLocationCellViewMap)
      }, void 0, Order09PathComponent__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          if (typeof _this4.props.address[index] !== 'undefined' && _this4.props.address[index].address !== '') {
            _this4.onClickToggleStaticMap(true);

            e.preventDefault();
          }
        },
        onKeyPress: function onKeyPress() {},
        className: "".concat(typeof this.props.address[index] === 'undefined' || this.props.address[index] === '{}' || this.props.address[index].address === '' ? Order_default.a.disabled : [Order_default.a.orderFunctionText, style_default.a.textBlue].join(' '))
      }, void 0, Order09PathComponent__jsx("span", {
        className: style_default.a.hideMobile
      }, void 0, this.props.modelDataText.order_option_route_view_on_map_button), Order09PathComponent__jsx("span", {
        className: style_default.a.showMobile
      }, void 0, this.props.modelDataText.order_option_route_view_on_map_button_mobile)), Order09PathComponent__jsx(order09Path_Order09PathStaticMap, {
        openModal: this.state.openModal,
        onClickToggleStaticMap: this.onClickToggleStaticMap,
        activeSuggestion: this.state.activeSuggestion
      })));
    }
  }]);

  return Order09PathComponent;
}(react_default.a.Component);

var Order09PathComponent_mapState = function mapState(state) {
  return {
    address: state.order.address,
    currentLocale: state.intl.locale
  };
};

var Order09PathComponent_mapDispatch = {
  addOrderAddress: actions_order["a" /* addOrderAddress */],
  updateOrderAddress: actions_order["s" /* updateOrderAddress */]
};
/* harmony default export */ var order09Path_Order09PathComponent = (Object(es["b" /* connect */])(Order09PathComponent_mapState, Order09PathComponent_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a)(Order09PathComponent_Order09PathComponent)));
// CONCATENATED MODULE: ./src/routes/order/order09Path/Order09PathComponentWithMoreInfo.js
function Order09PathComponentWithMoreInfo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order09PathComponentWithMoreInfo__typeof = function _typeof(obj) { return typeof obj; }; } else { Order09PathComponentWithMoreInfo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order09PathComponentWithMoreInfo__typeof(obj); }

var Order09PathComponentWithMoreInfo_REACT_ELEMENT_TYPE;

function Order09PathComponentWithMoreInfo__jsx(type, props, key, children) { if (!Order09PathComponentWithMoreInfo_REACT_ELEMENT_TYPE) { Order09PathComponentWithMoreInfo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order09PathComponentWithMoreInfo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order09PathComponentWithMoreInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order09PathComponentWithMoreInfo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order09PathComponentWithMoreInfo__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order09PathComponentWithMoreInfo__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order09PathComponentWithMoreInfo__defineProperties(Constructor, staticProps); return Constructor; }

function Order09PathComponentWithMoreInfo__possibleConstructorReturn(self, call) { if (call && (Order09PathComponentWithMoreInfo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order09PathComponentWithMoreInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order09PathComponentWithMoreInfo__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import











var Order09PathComponentWithMoreInfo_address = {
  address: '',
  lat: 0,
  lon: 0
};

var Order09PathComponentWithMoreInfo_Order09PathComponentWithMoreInfo =
/*#__PURE__*/
function (_React$Component) {
  Order09PathComponentWithMoreInfo__inherits(Order09PathComponentWithMoreInfo, _React$Component);

  function Order09PathComponentWithMoreInfo(props) {
    var _this;

    Order09PathComponentWithMoreInfo__classCallCheck(this, Order09PathComponentWithMoreInfo);

    _this = Order09PathComponentWithMoreInfo__possibleConstructorReturn(this, (Order09PathComponentWithMoreInfo.__proto__ || Object.getPrototypeOf(Order09PathComponentWithMoreInfo)).call(this, props));
    _this.state = {
      address: '',
      addressDetailInfo: '',
      autoCompleteSuggestion: [],
      openModal: false,
      activeSuggestion: {},
      addresses: Object(localStorage["b" /* localStorageGet */])('addresses', false)
    };
    _this.onhandleLocationChange = _this.onhandleLocationChange.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.onClickSelectSuggestion = _this.onClickSelectSuggestion.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.onGetLocationSuggestionDetail = _this.onGetLocationSuggestionDetail.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.onClickToggleStaticMap = _this.onClickToggleStaticMap.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.checkOrderAddressItem = _this.checkOrderAddressItem.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.onClickClearAddress = _this.onClickClearAddress.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    _this.onClickClearAddressDetailInfo = _this.onClickClearAddressDetailInfo.bind(Order09PathComponentWithMoreInfo__assertThisInitialized(_this));
    return _this;
  }

  Order09PathComponentWithMoreInfo__createClass(Order09PathComponentWithMoreInfo, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(localStorage["b" /* localStorageGet */])('addresses', false) !== null && this.state.addresses.waypoints.length > this.props.index) {
        // this.props.updateOrderAddress(
        //   addresses[`address${this.props.index + 1}`],
        //   this.props.index,
        // );
        this.setState({
          address: this.state.addresses.waypoints[this.props.index].address
        }); // in

        this.setState({
          activeSuggestion: {
            geometry: {
              location: {
                lat: this.state.addresses.waypoints[this.props.index].location.lat,
                lng: this.state.addresses.waypoints[this.props.index].location.lon
              }
            }
          }
        });
      }
    }
  }, {
    key: "onClickClearAddress",
    value: function onClickClearAddress(index) {
      this.setState({
        address: ''
      });
      this.props.updateOrderAddress({
        address: '',
        lat: 0,
        lon: 0
      }, index);
    }
  }, {
    key: "onClickClearAddressDetailInfo",
    value: function onClickClearAddressDetailInfo(index) {
      this.setState({
        addressDetailInfo: ''
      });
      this.props.updateOrderAddress({
        address: this.props.address[index].address,
        lat: this.props.address[index].lat,
        lon: this.props.address[index].lon
      }, index);
    }
  }, {
    key: "onClickSelectSuggestion",
    value: function onClickSelectSuggestion(suggestion, index) {
      this.setState({
        address: suggestion.description
      });
      this.setState({
        autoCompleteSuggestion: []
      });
      this.onGetLocationSuggestionDetail(suggestion.place_id, index);
    }
  }, {
    key: "onGetLocationSuggestionDetail",
    value: function onGetLocationSuggestionDetail(placeID, index) {
      var _this2 = this;

      Object(map["b" /* getLocationSuggestionDetail */])(placeID, this.props.currentLocale).then(function (response) {
        return response.json();
      }).then(function (result) {
        _this2.setState({
          activeSuggestion: result.result
        });

        Order09PathComponentWithMoreInfo_address = {
          address: result.result.formatted_address,
          lat: result.result.geometry.location.lat,
          lon: result.result.geometry.location.lng
        };

        _this2.checkOrderAddressItem(Order09PathComponentWithMoreInfo_address, index);
      }).catch(function (error) {
        console.warn('Request failed', error);
      });
    }
  }, {
    key: "onhandleLocationChange",
    value: function onhandleLocationChange(e) {
      var _this3 = this;

      this.setState({
        address: e.target.value
      });
      Object(map["a" /* getLocationSuggestion */])(e.target.value, this.props.currentLocale).then(function (response) {
        return response.json();
      }).then(function (result) {
        _this3.setState({
          autoCompleteSuggestion: result.predictions
        });
      }).catch(function (error) {
        console.warn('Request failed', error);
      });
      this.forceUpdate();
    }
  }, {
    key: "onChangeAddressDetailInfo",
    value: function onChangeAddressDetailInfo(e, index) {
      this.setState({
        addressDetailInfo: e.target.value
      });
      this.props.updateOrderAddress({
        address: this.props.address[index].address,
        lat: this.props.address[index].lat,
        lon: this.props.address[index].lon,
        detail_address: e.target.value
      }, index);
    }
  }, {
    key: "onClickToggleStaticMap",
    value: function onClickToggleStaticMap(bool) {
      this.setState({
        openModal: bool
      });
    } // Check if add address or update address

  }, {
    key: "checkOrderAddressItem",
    value: function checkOrderAddressItem(addresses, index) {
      if (this.props.address.length < index) {
        this.props.addOrderAddress(addresses);
      } else {
        this.props.updateOrderAddress(addresses, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var index = this.props.index;
      var imgTag = '';
      var img1 = '';
      var img2 = '';
      var imgClass = '';
      var imgPlaceholder = this.props.modelDataText.order_option_route_location_2_address_input;

      if (index === 0) {
        imgTag = 'from';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeStartImg;
        imgPlaceholder = this.props.modelDataText.order_option_route_location_1_address_input;
      } else if (index < this.props.address.length - 1) {
        imgTag = 'mid';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeMidImg;
      } else {
        imgTag = 'to';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeEndImg;
      }

      return Order09PathComponentWithMoreInfo__jsx(reactstrap_es["n" /* Row */], {}, index, Order09PathComponentWithMoreInfo__jsx(reactstrap_es["b" /* Col */], {
        md: "6",
        xs: "6"
      }, void 0, Order09PathComponentWithMoreInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: imgPlaceholder,
        id: index,
        onChange: this.onhandleLocationChange,
        onBlur: function onBlur() {
          setTimeout(function () {
            _this4.setState({
              autoCompleteSuggestion: []
            });
          }, 200);
        },
        value: this.state.address
      }), Order09PathComponentWithMoreInfo__jsx(order_autoComplete, {
        suggestion: this.state.autoCompleteSuggestion,
        onClickSelectSuggestion: this.onClickSelectSuggestion,
        index: index
      }), Order09PathComponentWithMoreInfo__jsx("img", {
        className: "".concat(Order_default.a.imgIconLeft, " ").concat(imgClass),
        srcSet: "".concat(img1, " 1x, ").concat(img2, " 2x"),
        width: "13",
        alt: "start"
      }), this.state.address === '' ? '' : Order09PathComponentWithMoreInfo__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this4.onClickClearAddress(index);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09PathComponentWithMoreInfo__jsx("img", {
        className: "".concat(Order_default.a.inputClear),
        srcSet: "".concat(icon_clear_2_default.a, " 1x, ").concat(icon_clear_2_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "clear"
      }))), Order09PathComponentWithMoreInfo__jsx(reactstrap_es["b" /* Col */], {
        md: "4",
        xs: "4"
      }, void 0, Order09PathComponentWithMoreInfo__jsx(reactstrap_es["i" /* Input */], {
        placeholder: this.props.modelDataText.order_route_floor_unit,
        value: this.state.addressDetailInfo,
        onChange: function onChange(e) {
          _this4.onChangeAddressDetailInfo(e, index);
        }
      }), this.state.addressDetailInfo === '' ? '' : Order09PathComponentWithMoreInfo__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this4.onClickClearAddressDetailInfo(index);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09PathComponentWithMoreInfo__jsx("img", {
        className: "".concat(Order_default.a.inputClear),
        srcSet: "".concat(icon_clear_2_default.a, " 1x, ").concat(icon_clear_2_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "clear"
      }))), Order09PathComponentWithMoreInfo__jsx(reactstrap_es["b" /* Col */], {
        md: "2",
        xs: "2",
        className: "".concat(Order_default.a.orderLocationCellViewMap)
      }, void 0, Order09PathComponentWithMoreInfo__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          if (typeof _this4.props.address[index] !== 'undefined' && _this4.props.address[index].address !== '') {
            _this4.onClickToggleStaticMap(true);

            e.preventDefault();
          }
        },
        onKeyPress: function onKeyPress() {},
        className: "".concat(typeof this.props.address[index] === 'undefined' || this.props.address[index] === '{}' || this.props.address[index].address === '' ? Order_default.a.disabled : [Order_default.a.orderFunctionText, style_default.a.textBlue].join(' '))
      }, void 0, Order09PathComponentWithMoreInfo__jsx("span", {
        className: style_default.a.hideMobile
      }, void 0, this.props.modelDataText.order_option_route_view_on_map_button), Order09PathComponentWithMoreInfo__jsx("span", {
        className: style_default.a.showMobile
      }, void 0, this.props.modelDataText.order_option_route_view_on_map_button_mobile)), Order09PathComponentWithMoreInfo__jsx(order09Path_Order09PathStaticMap, {
        openModal: this.state.openModal,
        onClickToggleStaticMap: this.onClickToggleStaticMap,
        activeSuggestion: this.state.activeSuggestion
      })));
    }
  }]);

  return Order09PathComponentWithMoreInfo;
}(react_default.a.Component);

var Order09PathComponentWithMoreInfo_mapState = function mapState(state) {
  return {
    address: state.order.address,
    currentLocale: state.intl.locale
  };
};

var Order09PathComponentWithMoreInfo_mapDispatch = {
  addOrderAddress: actions_order["a" /* addOrderAddress */],
  updateOrderAddress: actions_order["s" /* updateOrderAddress */]
};
/* harmony default export */ var order09Path_Order09PathComponentWithMoreInfo = (Object(es["b" /* connect */])(Order09PathComponentWithMoreInfo_mapState, Order09PathComponentWithMoreInfo_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a)(Order09PathComponentWithMoreInfo_Order09PathComponentWithMoreInfo)));
// CONCATENATED MODULE: ./src/routes/order/order09Path/Order09PathComponentWithMoreInfoWithoutButton.js
function Order09PathComponentWithMoreInfoWithoutButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order09PathComponentWithMoreInfoWithoutButton__typeof = function _typeof(obj) { return typeof obj; }; } else { Order09PathComponentWithMoreInfoWithoutButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order09PathComponentWithMoreInfoWithoutButton__typeof(obj); }

var Order09PathComponentWithMoreInfoWithoutButton_REACT_ELEMENT_TYPE;

function Order09PathComponentWithMoreInfoWithoutButton__jsx(type, props, key, children) { if (!Order09PathComponentWithMoreInfoWithoutButton_REACT_ELEMENT_TYPE) { Order09PathComponentWithMoreInfoWithoutButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order09PathComponentWithMoreInfoWithoutButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order09PathComponentWithMoreInfoWithoutButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order09PathComponentWithMoreInfoWithoutButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order09PathComponentWithMoreInfoWithoutButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order09PathComponentWithMoreInfoWithoutButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order09PathComponentWithMoreInfoWithoutButton__defineProperties(Constructor, staticProps); return Constructor; }

function Order09PathComponentWithMoreInfoWithoutButton__possibleConstructorReturn(self, call) { if (call && (Order09PathComponentWithMoreInfoWithoutButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order09PathComponentWithMoreInfoWithoutButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import










var Order09PathComponentWithMoreInfoWithoutButton_address = {
  address: '',
  lat: 0,
  lon: 0
}; // Only For Korea

var Order09PathComponentWithMoreInfoWithoutButton_Order09PathComponentWithMoreInfoWithoutButton =
/*#__PURE__*/
function (_React$Component) {
  Order09PathComponentWithMoreInfoWithoutButton__inherits(Order09PathComponentWithMoreInfoWithoutButton, _React$Component);

  function Order09PathComponentWithMoreInfoWithoutButton(props) {
    var _this;

    Order09PathComponentWithMoreInfoWithoutButton__classCallCheck(this, Order09PathComponentWithMoreInfoWithoutButton);

    _this = Order09PathComponentWithMoreInfoWithoutButton__possibleConstructorReturn(this, (Order09PathComponentWithMoreInfoWithoutButton.__proto__ || Object.getPrototypeOf(Order09PathComponentWithMoreInfoWithoutButton)).call(this, props));
    _this.state = {
      address: '',
      addressDetailInfo: '',
      autoCompleteSuggestion: [],
      addresses: Object(localStorage["b" /* localStorageGet */])('addresses', false)
    };
    _this.onClickSelectSuggestion = _this.onClickSelectSuggestion.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.onClickClearAddress = _this.onClickClearAddress.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.onClickClearAddressDetailInfo = _this.onClickClearAddressDetailInfo.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.onGetLocationSuggestionDetail = _this.onGetLocationSuggestionDetail.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.onhandleLocationChange = _this.onhandleLocationChange.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.onChangeAddressDetailInfo = _this.onChangeAddressDetailInfo.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    _this.checkOrderAddressItem = _this.checkOrderAddressItem.bind(Order09PathComponentWithMoreInfoWithoutButton__assertThisInitialized(_this));
    return _this;
  }

  Order09PathComponentWithMoreInfoWithoutButton__createClass(Order09PathComponentWithMoreInfoWithoutButton, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(localStorage["b" /* localStorageGet */])('addresses', false) !== null && this.state.addresses.waypoints.length > this.props.index) {
        // this.props.updateOrderAddress(
        //   addresses[`address${this.props.index + 1}`],
        //   this.props.index,
        // );
        this.setState({
          address: this.state.addresses.waypoints[this.props.index].address
        });
      }
    }
  }, {
    key: "onClickClearAddress",
    value: function onClickClearAddress(index) {
      this.setState({
        address: ''
      });
      this.props.updateOrderAddress({
        address: '',
        lat: 0,
        lon: 0
      }, index);
    }
  }, {
    key: "onClickClearAddressDetailInfo",
    value: function onClickClearAddressDetailInfo(index) {
      this.setState({
        addressDetailInfo: ''
      });
      this.props.updateOrderAddress({
        address: this.props.address[index].address,
        lat: this.props.address[index].lat,
        lon: this.props.address[index].lon
      }, index);
    }
  }, {
    key: "onClickSelectSuggestion",
    value: function onClickSelectSuggestion(suggestion, index) {
      this.setState({
        address: suggestion.description
      });
      this.setState({
        autoCompleteSuggestion: []
      });
      this.onGetLocationSuggestionDetail(suggestion.description, suggestion.place_id, index);
    }
  }, {
    key: "onGetLocationSuggestionDetail",
    value: function onGetLocationSuggestionDetail(description, placeID, index) {
      var _this2 = this;

      Object(map["b" /* getLocationSuggestionDetail */])(placeID, this.props.currentLocale).then(function (response) {
        return response.json();
      }).then(function (result) {
        // this.setState({ activeSuggestion: result.result });
        Order09PathComponentWithMoreInfoWithoutButton_address = {
          address: description,
          lat: result.result.geometry.location.lat,
          lon: result.result.geometry.location.lng
        };

        _this2.checkOrderAddressItem(Order09PathComponentWithMoreInfoWithoutButton_address, index);
      }).catch(function (error) {
        console.warn('Request failed', error);
      });
    }
  }, {
    key: "onhandleLocationChange",
    value: function onhandleLocationChange(e) {
      var _this3 = this;

      this.setState({
        address: e.target.value
      });
      Object(map["a" /* getLocationSuggestion */])(e.target.value, this.props.currentLocale).then(function (response) {
        return response.json();
      }).then(function (result) {
        _this3.setState({
          autoCompleteSuggestion: result.predictions
        });
      }).catch(function (error) {
        console.warn('Request failed', error);
      });
      this.forceUpdate();
    }
  }, {
    key: "onChangeAddressDetailInfo",
    value: function onChangeAddressDetailInfo(e, index) {
      this.setState({
        addressDetailInfo: e.target.value
      });
      this.props.updateOrderAddress({
        address: this.props.address[index].address,
        lat: this.props.address[index].lat,
        lon: this.props.address[index].lon,
        detail_address: e.target.value
      }, index);
    } // Check if add address or update address

  }, {
    key: "checkOrderAddressItem",
    value: function checkOrderAddressItem(addresses, index) {
      if (this.props.address.length < index) {
        this.props.addOrderAddress(addresses);
      } else {
        this.props.updateOrderAddress(addresses, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var index = this.props.index;
      var imgTag = '';
      var img1 = '';
      var img2 = '';
      var imgClass = '';
      var imgPlaceholder = this.props.modelDataText.order_option_route_location_2_address_input;

      if (index === 0) {
        imgTag = 'from';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeStartImg;
        imgPlaceholder = this.props.modelDataText.order_option_route_location_1_address_input;
      } else if (index < this.props.address.length - 1) {
        imgTag = 'mid';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeMidImg;
      } else {
        imgTag = 'to';
        img1 = __webpack_require__(909)("./icon_".concat(imgTag, ".png"));
        img2 = __webpack_require__(910)("./icon_".concat(imgTag, "@2x.png"));
        imgClass = Order_default.a.routeEndImg;
      }

      return Order09PathComponentWithMoreInfoWithoutButton__jsx(reactstrap_es["n" /* Row */], {}, index, Order09PathComponentWithMoreInfoWithoutButton__jsx(reactstrap_es["b" /* Col */], {
        md: "8",
        xs: "8"
      }, void 0, Order09PathComponentWithMoreInfoWithoutButton__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: imgPlaceholder,
        id: index,
        onChange: function onChange(e) {
          _this4.onhandleLocationChange(e);
        },
        onBlur: function onBlur() {
          setTimeout(function () {
            _this4.setState({
              autoCompleteSuggestion: []
            });
          }, 200);
        },
        value: this.state.address
      }), Order09PathComponentWithMoreInfoWithoutButton__jsx(order_autoComplete, {
        suggestion: this.state.autoCompleteSuggestion,
        onClickSelectSuggestion: this.onClickSelectSuggestion,
        index: index
      }), Order09PathComponentWithMoreInfoWithoutButton__jsx("img", {
        className: "".concat(Order_default.a.imgIconLeft, " ").concat(imgClass),
        srcSet: "".concat(img1, " 1x, ").concat(img2, " 2x"),
        width: "13",
        alt: "start"
      }), this.state.address === '' ? '' : Order09PathComponentWithMoreInfoWithoutButton__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this4.onClickClearAddress(index);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09PathComponentWithMoreInfoWithoutButton__jsx("img", {
        className: "".concat(Order_default.a.inputClear),
        srcSet: "".concat(icon_clear_2_default.a, " 1x, ").concat(icon_clear_2_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "clear"
      }))), Order09PathComponentWithMoreInfoWithoutButton__jsx(reactstrap_es["b" /* Col */], {
        md: "4",
        xs: "4"
      }, void 0, Order09PathComponentWithMoreInfoWithoutButton__jsx(reactstrap_es["i" /* Input */], {
        placeholder: this.props.modelDataText.order_route_floor_unit,
        value: this.state.addressDetailInfo,
        onChange: function onChange(e) {
          _this4.onChangeAddressDetailInfo(e, index);
        }
      }), this.state.addressDetailInfo === '' ? '' : Order09PathComponentWithMoreInfoWithoutButton__jsx("span", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this4.onClickClearAddressDetailInfo(index);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09PathComponentWithMoreInfoWithoutButton__jsx("img", {
        className: "".concat(Order_default.a.inputClear),
        srcSet: "".concat(icon_clear_2_default.a, " 1x, ").concat(icon_clear_2_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "clear"
      }))));
    }
  }]);

  return Order09PathComponentWithMoreInfoWithoutButton;
}(react_default.a.Component);

var Order09PathComponentWithMoreInfoWithoutButton_mapState = function mapState(state) {
  return {
    address: state.order.address,
    currentLocale: state.intl.locale
  };
};

var Order09PathComponentWithMoreInfoWithoutButton_mapDispatch = {
  addOrderAddress: actions_order["a" /* addOrderAddress */],
  updateOrderAddress: actions_order["s" /* updateOrderAddress */]
};
/* harmony default export */ var order09Path_Order09PathComponentWithMoreInfoWithoutButton = (Object(es["b" /* connect */])(Order09PathComponentWithMoreInfoWithoutButton_mapState, Order09PathComponentWithMoreInfoWithoutButton_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a)(Order09PathComponentWithMoreInfoWithoutButton_Order09PathComponentWithMoreInfoWithoutButton)));
// EXTERNAL MODULE: ./src/assets/img/icon_add.png
var icon_add = __webpack_require__(1226);
var icon_add_default = /*#__PURE__*/__webpack_require__.n(icon_add);

// EXTERNAL MODULE: ./src/assets/img/icon_add@2x.png
var icon_add_2x = __webpack_require__(976);
var icon_add_2x_default = /*#__PURE__*/__webpack_require__.n(icon_add_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_add_hover.png
var icon_add_hover = __webpack_require__(1228);
var icon_add_hover_default = /*#__PURE__*/__webpack_require__.n(icon_add_hover);

// EXTERNAL MODULE: ./src/assets/img/icon_add_hover@2x.png
var icon_add_hover_2x = __webpack_require__(977);
var icon_add_hover_2x_default = /*#__PURE__*/__webpack_require__.n(icon_add_hover_2x);

// CONCATENATED MODULE: ./src/routes/order/order09Path/Order09Path.js
function Order09Path__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order09Path__typeof = function _typeof(obj) { return typeof obj; }; } else { Order09Path__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order09Path__typeof(obj); }

var Order09Path_REACT_ELEMENT_TYPE;

function Order09Path__jsx(type, props, key, children) { if (!Order09Path_REACT_ELEMENT_TYPE) { Order09Path_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order09Path_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order09Path__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order09Path__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order09Path__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order09Path__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order09Path__defineProperties(Constructor, staticProps); return Constructor; }

function Order09Path__possibleConstructorReturn(self, call) { if (call && (Order09Path__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order09Path__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order09Path__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import














var Order09Path_Order09Path =
/*#__PURE__*/
function (_React$Component) {
  Order09Path__inherits(Order09Path, _React$Component);

  function Order09Path(props) {
    var _this;

    Order09Path__classCallCheck(this, Order09Path);

    _this = Order09Path__possibleConstructorReturn(this, (Order09Path.__proto__ || Object.getPrototypeOf(Order09Path)).call(this, props));
    _this.state = {
      addressComponent: [],
      addresses: Object(localStorage["b" /* localStorageGet */])('addresses', false),
      isValidAddress: true,
      scrollToComponent: null
    }; // this.onAddRoute = this.onAddRoute.bind(this);

    _this.onAddRoute2 = _this.onAddRoute2.bind(Order09Path__assertThisInitialized(_this));
    _this.setScrollToComponent = _this.setScrollToComponent.bind(Order09Path__assertThisInitialized(_this));
    return _this;
  }

  Order09Path__createClass(Order09Path, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollToComponent(); // If no previous address data

      if (this.state.addresses === null) {
        for (var i = 0; i < 2; i += 1) {
          this.onAddRoute2(i);
        } // reuse the route or select places in quoting page

      } else if (this.props.address.length < this.state.addresses.waypoints.length) {
        for (var _i = 0; _i < this.state.addresses.waypoints.length; _i += 1) {
          this.onAddRoute2(_i);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // detect updated address
      if (nextProps.address !== this.props.address) {
        this.props.updateOrderDetailInfoAction('waypoints_attributes', null, nextProps.address);
      }

      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        if (this.props.address.length > 1) {
          // check first 2 address
          if (this.props.address[0].address === '' || this.props.address[1].address === '') {
            this.props.setIsValidOrder(false);
            this.setState({
              isValidAddress: false
            });
            /* eslint-disable global-require */

            this.state.scrollToComponent(this.Order09PathComponent, {
              offset: -100,
              duration: 500
            }); // this.props.setIsClickConfirmOrder(false);
          } else {
            this.setState({
              isValidAddress: true
            }); // this.props.setIsClickConfirmOrder(false);
          }
        }
      }
    }
  }, {
    key: "onAddRoute2",
    value: function onAddRoute2(i) {
      // init the address
      var address = {
        address: '',
        lat: 0,
        lon: 0
      };
      this.props.addOrderAddress(address);

      if (this.state.addresses !== null && typeof this.state.addresses.waypoints[i] !== 'undefined') {
        address = {
          address: this.state.addresses.waypoints[i].address,
          lat: this.state.addresses.waypoints[i].location.lat,
          lon: this.state.addresses.waypoints[i].location.lon
        };
        this.props.updateOrderAddress(address, i);
      }

      var pathComponent = Order09Path__jsx(order09Path_Order09PathComponent, {
        index: i,
        onSetActiveSuggestion: this.onSetActiveSuggestion,
        modelDataText: this.props.modelDataText
      }, i);

      if (['tw', 'sg'].includes(this.props.lang)) {
        pathComponent = Order09Path__jsx(order09Path_Order09PathComponentWithMoreInfo, {
          index: i,
          onSetActiveSuggestion: this.onSetActiveSuggestion,
          modelDataText: this.props.modelDataText
        }, i);
      }

      if (this.props.lang === 'kr') {
        pathComponent = Order09Path__jsx(order09Path_Order09PathComponentWithMoreInfoWithoutButton, {
          index: i,
          onSetActiveSuggestion: this.onSetActiveSuggestion,
          modelDataText: this.props.modelDataText
        }, i);
      }

      this.state.addressComponent.push(pathComponent);
    }
  }, {
    key: "setScrollToComponent",
    value: function setScrollToComponent() {
      this.setState({
        scrollToComponent: __webpack_require__(919)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement("div", {
        ref: function ref(i) {
          _this2.Order09PathComponent = i;
        }
      }, Order09Path__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_route_title), !this.state.isValidAddress ? Order09Path__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText)
      }, void 0, this.props.modelDataText.order_route_input_warning) : '', this.state.addressComponent, Order09Path__jsx("span", {
        className: Order_default.a.orderFunctionText,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          if (_this2.props.address.length < 9) {
            _this2.onAddRoute2(_this2.props.address.length);
          }
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order09Path__jsx("img", {
        className: "".concat(Order_default.a.orderFunctionIcon),
        "data-hover": "false",
        srcSet: "".concat(icon_add_default.a, " 1x, ").concat(icon_add_2x_default.a, " 2x"),
        height: "18",
        alt: ""
      }), Order09Path__jsx("img", {
        className: "".concat(Order_default.a.orderFunctionIcon),
        "data-hover": "true",
        srcSet: "".concat(icon_add_hover_default.a, " 1x, ").concat(icon_add_hover_2x_default.a, " 2x"),
        height: "18",
        alt: ""
      }), Order09Path__jsx("span", {
        className: Order_default.a.addPathButton
      }, void 0, this.props.modelDataText.order_option_route_add_address_button)));
    }
  }]);

  return Order09Path;
}(react_default.a.Component);

var Order09Path_mapState = function mapState(state) {
  return {
    address: state.order.address,
    order: state.order,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order09Path_mapDispatch = {
  addOrderAddress: actions_order["a" /* addOrderAddress */],
  updateOrderAddress: actions_order["s" /* updateOrderAddress */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order09Path_Order09Path = (Object(es["b" /* connect */])(Order09Path_mapState, Order09Path_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order09Path_Order09Path)));
// EXTERNAL MODULE: ./node_modules/react-datetime/DateTime.js
var DateTime = __webpack_require__(1825);
var DateTime_default = /*#__PURE__*/__webpack_require__.n(DateTime);

// EXTERNAL MODULE: ./src/routes/order/Order10PickupTime/Order10PickupTime.sass
var Order10PickupTime_Order10PickupTime = __webpack_require__(1834);
var Order10PickupTime_default = /*#__PURE__*/__webpack_require__.n(Order10PickupTime_Order10PickupTime);

// CONCATENATED MODULE: ./src/routes/order/Order10PickupTime/Order10PickupTime.js
function Order10PickupTime__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order10PickupTime__typeof = function _typeof(obj) { return typeof obj; }; } else { Order10PickupTime__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order10PickupTime__typeof(obj); }

var Order10PickupTime_REACT_ELEMENT_TYPE;

function Order10PickupTime__jsx(type, props, key, children) { if (!Order10PickupTime_REACT_ELEMENT_TYPE) { Order10PickupTime_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order10PickupTime_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order10PickupTime__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order10PickupTime__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order10PickupTime__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order10PickupTime__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order10PickupTime__defineProperties(Constructor, staticProps); return Constructor; }

function Order10PickupTime__possibleConstructorReturn(self, call) { if (call && (Order10PickupTime__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order10PickupTime__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order10PickupTime__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint no-underscore-dangle: ["error", { "allow": ["_d"] }] */

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import









var Order10PickupTime_Order10PickupTime_Order10PickupTime =
/*#__PURE__*/
function (_React$Component) {
  Order10PickupTime__inherits(Order10PickupTime, _React$Component);

  function Order10PickupTime(props) {
    var _this;

    Order10PickupTime__classCallCheck(this, Order10PickupTime);

    _this = Order10PickupTime__possibleConstructorReturn(this, (Order10PickupTime.__proto__ || Object.getPrototypeOf(Order10PickupTime)).call(this, props));
    var langType = props.currentLocale.split('-')[0]; // en-SG

    var langTypeE = props.currentLocale.split('-')[0]; // en-SG

    var lang = props.currentLocale.split('-')[1].toLowerCase();

    if (lang === 'hk') {
      langTypeE = "".concat(langType, "-").concat(lang);
      langType = langTypeE;
    } else if (['sg', 'in'].includes(lang)) {
      langTypeE = 'en';
      langType = lang;
    } else {
      langTypeE = lang;
      langType = lang;
    }

    _this.state = {
      timeModal: false,
      dateModal: false,
      now: new Date(),
      selectedTime: 0,
      selectedDate: 0,
      pickupDate: new Date(),
      // the date user picked
      isValidTime: true,
      isEN: props.currentLocale.split('-')[0].toLowerCase(),
      // for show today in Pickup
      modelData: __webpack_require__(1437)("./".concat(lang, "/").concat(langType, "-modelData.json"))
    };
    _this.timeModal = [];
    _this.timeModalToggle = _this.timeModalToggle.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.dateModalToggle = _this.dateModalToggle.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.getSelectedDate = _this.getSelectedDate.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.getSelectedTime = _this.getSelectedTime.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.handleDate = _this.handleDate.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.setPickupDate = _this.setPickupDate.bind(Order10PickupTime__assertThisInitialized(_this));
    _this.setPickupTime = _this.setPickupTime.bind(Order10PickupTime__assertThisInitialized(_this));
    return _this;
  }

  Order10PickupTime__createClass(Order10PickupTime, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        selectedTime: this.getSelectedTime()
      });
      this.setState({
        selectedDate: this.getSelectedDate()
      });
      this.setPickupDate(this.state.now);
      var h = this.getSelectedTime().split(':')[0];
      var m = this.getSelectedTime().split(':')[1];
      this.setPickupTime(h, m);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        if (this.state.pickupDate < Date.now()) {
          this.setState({
            isValidTime: false
          });
          this.props.setIsValidOrder(false);
        } else {
          this.setState({
            isValidTime: true
          });
        }
      }
    }
  }, {
    key: "getSelectedDate",
    value: function getSelectedDate() {
      return this.state.now.toISOString().slice(0, 10).replace(/-/g, '/');
    }
  }, {
    key: "getSelectedTime",
    value: function getSelectedTime() {
      var h = this.state.now.getHours();
      var m = Math.floor(this.state.now.getMinutes() / 10) * 10 + 20;

      if (m >= 60) {
        h = this.state.now.getHours() + 1;
      }

      m %= 60;

      if (m === 0) {
        m = '00';
      }

      return "".concat(h, ":").concat(m);
    }
  }, {
    key: "setPickupDate",
    value: function setPickupDate(date) {
      this.state.pickupDate.setMonth(date.getMonth());
      this.state.pickupDate.setDate(date.getDate());
      this.state.pickupDate.setFullYear(date.getFullYear());
      this.props.updateOrderDetailInfoAction('pickup_time', null, Object(util["b" /* dateToISO8601String */])(this.state.pickupDate));
    }
  }, {
    key: "setPickupTime",
    value: function setPickupTime(h, m) {
      this.state.pickupDate.setHours(h);
      this.state.pickupDate.setMinutes(m);
      this.state.pickupDate.setSeconds(0);
      this.state.pickupDate.setMilliseconds(0);
      this.props.updateOrderDetailInfoAction('pickup_time', null, Object(util["b" /* dateToISO8601String */])(this.state.pickupDate));
    }
  }, {
    key: "handleDate",
    value: function handleDate(e) {
      var _this2 = this;

      var d = new Date(e._d);
      this.setState({
        now: new Date(d.setDate(d.getDate() + 1))
      }, function () {
        _this2.setState({
          selectedDate: _this2.getSelectedDate()
        });

        _this2.setPickupDate(e._d);

        _this2.dateModalToggle();
      });
    }
  }, {
    key: "dateModalToggle",
    value: function dateModalToggle() {
      this.setState({
        dateModal: !this.state.dateModal
      });
    }
  }, {
    key: "timeModalToggle",
    value: function timeModalToggle() {
      var _this3 = this;

      // scroll To selected Time
      if (!this.state.timeModal) {
        setTimeout(function () {
          _this3.timeModal[_this3.state.selectedTime].scrollIntoView();
        }, 500);
      }

      this.setState({
        timeModal: !this.state.timeModal
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var timePopup = [];

      var _loop = function _loop(i) {
        var _loop2 = function _loop2(j) {
          if (j === 0) {
            timePopup.push(react_default.a.createElement("span", {
              key: "".concat(i, ":00"),
              id: "".concat(i, ":00"),
              ref: function ref(input) {
                _this4.timeModal["".concat(i, ":00")] = input;
              },
              role: "button",
              tabIndex: 0,
              className: "".concat(Order10PickupTime_default.a.picker__listItem),
              style: _this4.state.selectedTime === "".concat(i, ":00") ? {
                background: '#0089ec',
                color: '#fff'
              } : {},
              onClick: function onClick() {
                _this4.setState({
                  selectedTime: "".concat(i, ":00")
                }, function () {
                  var h = _this4.state.selectedTime.split(':')[0];

                  var m = _this4.state.selectedTime.split(':')[1];

                  _this4.setPickupTime(h, m);
                });

                _this4.timeModalToggle();
              },
              onKeyPress: function onKeyPress() {}
            }, "".concat(i, ":00")));
          } else {
            timePopup.push(react_default.a.createElement("span", {
              key: "".concat(i, ":").concat(j),
              id: "".concat(i, ":").concat(j),
              ref: function ref(input) {
                _this4.timeModal["".concat(i, ":").concat(j)] = input;
              },
              role: "button",
              tabIndex: 0,
              className: "".concat(Order10PickupTime_default.a.picker__listItem),
              style: _this4.state.selectedTime === "".concat(i, ":").concat(j) ? {
                background: '#0089ec',
                color: '#fff'
              } : {},
              onClick: function onClick() {
                _this4.setState({
                  selectedTime: "".concat(i, ":").concat(j)
                }, function () {
                  var h = _this4.state.selectedTime.split(':')[0];

                  var m = _this4.state.selectedTime.split(':')[1];

                  _this4.setPickupTime(h, m);
                });

                _this4.timeModalToggle();
              },
              onKeyPress: function onKeyPress() {}
            }, "".concat(i, ":").concat(j)));
          }
        };

        for (var j = 0; j < 60; j += 10) {
          _loop2(j);
        }
      };

      for (var i = 0; i <= 23; i += 1) {
        _loop(i);
      }

      return Order10PickupTime__jsx("div", {}, void 0, Order10PickupTime__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.pick_up_time_title), Order10PickupTime__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order10PickupTime__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "6"
      }, void 0, react_default.a.createElement("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        ref: function ref(input) {
          _this4.dateModal = input;
        },
        onClick: function onClick() {
          _this4.dateModal.blur();

          _this4.dateModalToggle();
        }
      }, Order10PickupTime__jsx("option", {
        className: "".concat(Order10PickupTime_default.a.optionHidden)
      }, void 0, this.state.selectedDate))), Order10PickupTime__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "6"
      }, void 0, react_default.a.createElement("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        ref: function ref(input) {
          _this4.timeModal = input;
        },
        onClick: function onClick() {
          _this4.timeModal.blur();

          _this4.timeModalToggle();
        }
      }, Order10PickupTime__jsx("option", {
        className: "".concat(Order10PickupTime_default.a.optionHidden)
      }, void 0, this.state.selectedTime))), Order10PickupTime__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidTime ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.pickup_datetime_input_warning), Order10PickupTime__jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(Order10PickupTime_default.a.infoPopup, " "),
        isOpen: this.state.dateModal,
        toggle: this.dateModalToggle,
        size: "lg"
      }, void 0, Order10PickupTime__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          height: '380px',
          overflowY: 'auto'
        }
      }, void 0, Order10PickupTime__jsx(DateTime_default.a, {
        locale: this.props.currentLocale,
        className: Order10PickupTime_default.a.picker__dateTime,
        input: false,
        timeFormat: false,
        onChange: this.handleDate // renderDay={(props, currentDate) => {
        //   if (
        //     new Date().getMonth() === currentDate.month() &&
        //     new Date().getDate() === currentDate.date()
        //   ) {
        //     return (
        //       <td
        //         {...props}
        //         className={`${s2.calenderHover} ${s2.calenderToday}`}
        //       >
        //         {currentDate.date()}
        //       </td>
        //     );
        //   }
        //   return (
        //     <td {...props} className={`${s2.calenderHover}`}>
        //       {currentDate.date()}
        //     </td>
        //   );
        // }}

      }), Order10PickupTime__jsx("div", {
        style: {
          textAlign: 'center'
        }
      }, void 0, Order10PickupTime__jsx(reactstrap_es["a" /* Button */], {
        color: "link",
        className: Order10PickupTime_default.a.pickerTodayButton,
        onClick: function onClick() {
          _this4.setPickupDate(new Date());

          var today = new Date().toISOString().slice(0, 10).replace(/-/g, '/');

          _this4.setState({
            selectedDate: today
          });

          _this4.dateModalToggle();
        }
      }, void 0, this.state.modelData.order_model_data.datepicker.date.today, "\xA0\xA0", this.state.isEN === 'en' ? new Date().toISOString().slice(0, 10).replace(/-/g, '/') : ''), Order10PickupTime__jsx(reactstrap_es["a" /* Button */], {
        color: "link",
        className: Order10PickupTime_default.a.pickerClosedButton,
        onClick: function onClick() {
          _this4.dateModalToggle();
        }
      }, void 0, this.state.modelData.order_model_data.datepicker.date.close)))), Order10PickupTime__jsx(reactstrap_es["k" /* Modal */], {
        className: "".concat(Order10PickupTime_default.a.infoPopup, " "),
        contentClassName: "".concat(Order10PickupTime_default.a.picker__frame, " ").concat(Order10PickupTime_default.a.picker__wrap),
        size: "sm",
        isOpen: this.state.timeModal,
        toggle: this.timeModalToggle
      }, void 0, Order10PickupTime__jsx("ul", {}, void 0, timePopup))));
    }
  }]);

  return Order10PickupTime;
}(react_default.a.Component);

var Order10PickupTime_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    pickup_time: state.order.pickup_time,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order10PickupTime_mapDispatch = {
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order10PickupTime_Order10PickupTime = (Object(es["b" /* connect */])(Order10PickupTime_mapState, Order10PickupTime_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, Order10PickupTime_default.a)(Order10PickupTime_Order10PickupTime_Order10PickupTime)));
// EXTERNAL MODULE: ./node_modules/react-addons-update/index.js
var react_addons_update = __webpack_require__(107);
var react_addons_update_default = /*#__PURE__*/__webpack_require__.n(react_addons_update);

// CONCATENATED MODULE: ./src/routes/order/Order12AddService/Order12AddServiceDetail.js
function Order12AddServiceDetail__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order12AddServiceDetail__typeof = function _typeof(obj) { return typeof obj; }; } else { Order12AddServiceDetail__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order12AddServiceDetail__typeof(obj); }

var Order12AddServiceDetail_REACT_ELEMENT_TYPE;

function Order12AddServiceDetail__jsx(type, props, key, children) { if (!Order12AddServiceDetail_REACT_ELEMENT_TYPE) { Order12AddServiceDetail_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order12AddServiceDetail_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Order12AddServiceDetail__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order12AddServiceDetail__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order12AddServiceDetail__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order12AddServiceDetail__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order12AddServiceDetail__defineProperties(Constructor, staticProps); return Constructor; }

function Order12AddServiceDetail__possibleConstructorReturn(self, call) { if (call && (Order12AddServiceDetail__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order12AddServiceDetail__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-danger */

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // Relative import





var additionalServiceBool = {};

var Order12AddServiceDetail_Order12AddDetail =
/*#__PURE__*/
function (_React$Component) {
  Order12AddServiceDetail__inherits(Order12AddDetail, _React$Component);

  function Order12AddDetail(props) {
    var _this;

    Order12AddServiceDetail__classCallCheck(this, Order12AddDetail);

    _this = Order12AddServiceDetail__possibleConstructorReturn(this, (Order12AddDetail.__proto__ || Object.getPrototypeOf(Order12AddDetail)).call(this, props));
    _this.state = {
      service: []
    };
    return _this;
  }

  Order12AddServiceDetail__createClass(Order12AddDetail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.initAdditionalService();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.orderDetailInfo.service_type !== nextProps.orderDetailInfo.service_type || this.props.orderDetailInfo.vehicle !== nextProps.orderDetailInfo.vehicle || this.props.orderDetailInfo.goods !== nextProps.orderDetailInfo.goods) {
        this.initAdditionalService();
      }
    }
  }, {
    key: "getAdditionalService",
    value: function getAdditionalService() {
      if (this.props.lang === 'sg') {
        return this.props.modelData.additional_service[this.props.orderDetailInfo.service_type][this.props.orderDetailInfo.vehicle];
      }

      return this.props.modelData.additional_service[this.props.vehicle];
    }
  }, {
    key: "initAdditionalService",
    value: function initAdditionalService() {
      for (var i = 0; i < this.getAdditionalService().length; i += 1) {
        var currentObject = this.getAdditionalService()[i];

        if (typeof currentObject.ignore !== 'undefined' && currentObject.ignore) {//
        } else {
          additionalServiceBool[currentObject.service_code] = false;
        }
      }

      this.setState({
        service: react_addons_update_default()(this.state.service, {
          $set: additionalServiceBool
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order12AddServiceDetail__jsx("div", {}, void 0, Order12AddServiceDetail__jsx("div", {
        className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.orderAdditionalService)
      }, void 0, this.getAdditionalService().map(function (service, index) {
        return Order12AddServiceDetail__jsx("div", {
          style: typeof service.ignore !== 'undefined' && service.ignore ? {
            display: 'none'
          } : {}
        }, index.toString(), Order12AddServiceDetail__jsx(reactstrap_es["h" /* FormGroup */], {
          className: Order_default.a.formGroupMarginTop,
          check: true
        }, void 0, Order12AddServiceDetail__jsx(reactstrap_es["j" /* Label */], {
          check: true
        }, void 0, Order12AddServiceDetail__jsx(reactstrap_es["i" /* Input */], {
          type: "checkbox",
          name: service.title,
          checked: _this2.state.service[service.service_code],
          onClick: function onClick() {
            _this2.setState({
              service: react_addons_update_default()(_this2.state.service, _defineProperty({}, service.service_code, {
                $set: !_this2.state.service[service.service_code]
              }))
            }, function () {
              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', service.service_code, _this2.state.service[service.service_code]);
            });
          }
        }), "\xA0", Order12AddServiceDetail__jsx("span", {
          role: "button",
          tabIndex: 0,
          className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.label),
          htmlFor: "true",
          dangerouslySetInnerHTML: {
            __html: service.title
          },
          onClick: function onClick() {
            // this[service.title] = !this[service.title];
            _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', service.service_code, _this2.state.service[service.service_code]);
          },
          onKeyPress: function onKeyPress() {}
        }))), service.options.length > 0 && _this2.state.service[service.service_code] ? Order12AddServiceDetail__jsx("div", {
          className: "".concat(Order_default.a.labelAdditionalOption)
        }, void 0, service.options.map(function (o, i) {
          return Order12AddServiceDetail__jsx(reactstrap_es["h" /* FormGroup */], {
            check: true
          }, i.toString(), Order12AddServiceDetail__jsx(reactstrap_es["j" /* Label */], {
            check: true
          }, void 0, Order12AddServiceDetail__jsx(reactstrap_es["i" /* Input */], {
            type: "radio",
            name: service.service_code,
            onClick: function onClick() {
              _this2[o.option_code] = !_this2[o.option_code];

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', o.option_name, o.option_code);

              _this2.forceUpdate();
            },
            defaultChecked: i === 0
          }), "\xA0", Order12AddServiceDetail__jsx("span", {
            role: "button",
            tabIndex: 0,
            className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.label),
            htmlFor: "true",
            dangerouslySetInnerHTML: {
              __html: o.title
            },
            onClick: function onClick() {
              _this2[o.option_code] = !_this2[o.option_code];

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', o.option_name, o.option_code);

              _this2.forceUpdate();
            },
            onKeyPress: function onKeyPress() {}
          })));
        })) : '');
      })));
    }
  }]);

  return Order12AddDetail;
}(react_default.a.Component);

var Order12AddServiceDetail_mapState = function mapState(state) {
  return {
    need_carry: state.order.need_carry,
    pay_by_receiver: state.order.pay_by_receiver,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order12AddServiceDetail_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order12AddServiceDetail = (Object(es["b" /* connect */])(Order12AddServiceDetail_mapState, Order12AddServiceDetail_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order12AddServiceDetail_Order12AddDetail)));
// CONCATENATED MODULE: ./src/routes/order/Order12AddService/Order12AddServiceDetailKR.js
function Order12AddServiceDetailKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order12AddServiceDetailKR__typeof = function _typeof(obj) { return typeof obj; }; } else { Order12AddServiceDetailKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order12AddServiceDetailKR__typeof(obj); }

var Order12AddServiceDetailKR_REACT_ELEMENT_TYPE;

function Order12AddServiceDetailKR__jsx(type, props, key, children) { if (!Order12AddServiceDetailKR_REACT_ELEMENT_TYPE) { Order12AddServiceDetailKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order12AddServiceDetailKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order12AddServiceDetailKR__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Order12AddServiceDetailKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order12AddServiceDetailKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order12AddServiceDetailKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order12AddServiceDetailKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order12AddServiceDetailKR__defineProperties(Constructor, staticProps); return Constructor; }

function Order12AddServiceDetailKR__possibleConstructorReturn(self, call) { if (call && (Order12AddServiceDetailKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order12AddServiceDetailKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-danger */

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // Relative import






var Order12AddServiceDetailKR_Order12AddDetail =
/*#__PURE__*/
function (_React$Component) {
  Order12AddServiceDetailKR__inherits(Order12AddDetail, _React$Component);

  function Order12AddDetail(props) {
    var _this;

    Order12AddServiceDetailKR__classCallCheck(this, Order12AddDetail);

    _this = Order12AddServiceDetailKR__possibleConstructorReturn(this, (Order12AddDetail.__proto__ || Object.getPrototypeOf(Order12AddDetail)).call(this, props));
    _this.state = {
      service: []
    };
    return _this;
  }

  Order12AddServiceDetailKR__createClass(Order12AddDetail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      for (var i = 0; i < this.props.modelData.additional_service[this.props.orderDetailInfo.service_type].length; i += 1) {
        var currentObject = this.props.modelData.additional_service[this.props.orderDetailInfo.service_type][i];

        if (typeof currentObject.ignore !== 'undefined' && currentObject.ignore) {//
        } else {
          this.setState({
            service: react_addons_update_default()(this.state.service, {
              $push: [false]
            })
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order12AddServiceDetailKR__jsx("div", {}, void 0, Order12AddServiceDetailKR__jsx("div", {
        className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.orderAdditionalService)
      }, void 0, this.props.modelData.additional_service[this.props.orderDetailInfo.service_type].map(function (service, index) {
        return Order12AddServiceDetailKR__jsx("div", {
          style: typeof service.ignore !== 'undefined' && service.ignore ? {
            display: 'none'
          } : {}
        }, index.toString(), Order12AddServiceDetailKR__jsx(reactstrap_es["h" /* FormGroup */], {
          className: Order_default.a.formGroupMarginTop,
          check: true
        }, void 0, Order12AddServiceDetailKR__jsx(reactstrap_es["j" /* Label */], {
          check: true
        }, void 0, Order12AddServiceDetailKR__jsx(reactstrap_es["i" /* Input */], {
          type: "checkbox",
          name: ['is_raining', 'is_snowing'].includes(service.service_code) ? 'group' : service.title,
          checked: _this2.state.service[index],
          onClick: function onClick() {
            _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', service.service_code, !_this2.state.service[index]);

            if (service.service_code === 'is_raining') {
              _this2.state.service[1] = false;

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'is_snowing', false);
            }

            if (service.service_code === 'is_snowing') {
              _this2.state.service[0] = false;

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'is_raining', false);
            }

            _this2.setState({
              service: react_addons_update_default()(_this2.state.service, Order12AddServiceDetailKR__defineProperty({}, index, {
                $set: !_this2.state.service[index]
              }))
            });

            _this2.forceUpdate();
          }
        }), "\xA0", Order12AddServiceDetailKR__jsx("span", {
          role: "button",
          tabIndex: 0,
          className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.label),
          htmlFor: "true",
          dangerouslySetInnerHTML: {
            __html: service.title
          },
          onClick: function onClick() {
            // this[service.title] = !this[service.title];
            _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', service.service_code, _this2.state.service[index]);
          },
          onKeyPress: function onKeyPress() {}
        }))), service.options.length > 0 && _this2.state.service[index] ? Order12AddServiceDetailKR__jsx("div", {
          className: "".concat(Order_default.a.labelAdditionalOption)
        }, void 0, service.options.map(function (o, i) {
          return Order12AddServiceDetailKR__jsx(reactstrap_es["h" /* FormGroup */], {
            check: true
          }, void 0, Order12AddServiceDetailKR__jsx(reactstrap_es["j" /* Label */], {
            check: true
          }, void 0, Order12AddServiceDetailKR__jsx(reactstrap_es["i" /* Input */], {
            type: "radio",
            name: service.service_code,
            onClick: function onClick() {
              _this2[o.title] = !_this2[o.title];

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', o.option_name, o.option_code);

              _this2.forceUpdate();
            },
            defaultChecked: i === 0
          }), "\xA0", Order12AddServiceDetailKR__jsx("span", {
            role: "button",
            tabIndex: 0,
            className: "".concat(Order_default.a.orderAdditionalService, " ").concat(Order_default.a.label),
            htmlFor: "true",
            dangerouslySetInnerHTML: {
              __html: o.title
            },
            onClick: function onClick() {
              _this2[o.title] = !_this2[o.title];

              _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', o.option_name, o.option_code);

              _this2.forceUpdate();
            },
            onKeyPress: function onKeyPress() {}
          })));
        })) : '');
      })));
    }
  }]);

  return Order12AddDetail;
}(react_default.a.Component);

var Order12AddServiceDetailKR_mapState = function mapState(state) {
  return {
    need_carry: state.order.need_carry,
    pay_by_receiver: state.order.pay_by_receiver,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order12AddServiceDetailKR_mapDispatch = {
  setNeedCart: actions_order["n" /* setNeedCart */],
  setCartCount: actions_order["f" /* setCartCount */],
  setNeedCarry: actions_order["m" /* setNeedCarry */],
  setPayByReceiver: actions_order["r" /* setPayByReceiver */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order12AddServiceDetailKR = (Object(es["b" /* connect */])(Order12AddServiceDetailKR_mapState, Order12AddServiceDetailKR_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order12AddServiceDetailKR_Order12AddDetail)));
// EXTERNAL MODULE: ./src/routes/order/popup/serviceDetailDialog.sass
var popup_serviceDetailDialog = __webpack_require__(1836);
var serviceDetailDialog_default = /*#__PURE__*/__webpack_require__.n(popup_serviceDetailDialog);

// CONCATENATED MODULE: ./src/routes/order/popup/serviceDetailDialog.js
function serviceDetailDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { serviceDetailDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { serviceDetailDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return serviceDetailDialog__typeof(obj); }

var serviceDetailDialog_REACT_ELEMENT_TYPE;

function serviceDetailDialog__jsx(type, props, key, children) { if (!serviceDetailDialog_REACT_ELEMENT_TYPE) { serviceDetailDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: serviceDetailDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function serviceDetailDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function serviceDetailDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function serviceDetailDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) serviceDetailDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) serviceDetailDialog__defineProperties(Constructor, staticProps); return Constructor; }

function serviceDetailDialog__possibleConstructorReturn(self, call) { if (call && (serviceDetailDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function serviceDetailDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function serviceDetailDialog__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }










var serviceDetailDialog__ref = serviceDetailDialog__jsx("br", {});

var serviceDetailDialog__ref2 = serviceDetailDialog__jsx("hr", {});

var serviceDetailDialog__ref3 = serviceDetailDialog__jsx("hr", {});

var _ref4 = serviceDetailDialog__jsx("hr", {});

var serviceDetailDialog_serviceDetailDialog =
/*#__PURE__*/
function (_React$Component) {
  serviceDetailDialog__inherits(serviceDetailDialog, _React$Component);

  function serviceDetailDialog(props) {
    var _this;

    serviceDetailDialog__classCallCheck(this, serviceDetailDialog);

    _this = serviceDetailDialog__possibleConstructorReturn(this, (serviceDetailDialog.__proto__ || Object.getPrototypeOf(serviceDetailDialog)).call(this, props));
    var langType = props.currentLocale.split('-')[0]; // en-SG

    var lang = props.currentLocale.split('-')[1].toLowerCase();

    if (lang === 'hk') {
      langType = "".concat(langType, "-").concat(lang);
    } else {
      langType = lang;
    }

    _this.state = {
      modal: props.modal,
      modelDataText: __webpack_require__(920)("./".concat(lang, "/").concat(langType, ".json"))
    };
    _this.toggle = _this.toggle.bind(serviceDetailDialog__assertThisInitialized(_this));
    return _this;
  }

  serviceDetailDialog__createClass(serviceDetailDialog, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.modal === true && this.props.modal !== true) {
        this.setState({
          modal: true
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var _this2 = this;

      this.setState({
        modal: !this.state.modal
      }, function () {
        _this2.props.onClickShow(_this2.state.modal);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return serviceDetailDialog__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.state.modal,
        toggle: this.toggle,
        id: "serviceDetail",
        contentClassName: " ".concat(serviceDetailDialog_default.a.resizeModalWidth, " ").concat(serviceDetailDialog_default.a.detailServicefontSize),
        className: "".concat(serviceDetailDialog_default.a.serviceDetail, " ").concat(style_default.a.infoPopup, " ").concat(serviceDetailDialog_default.a.resizeModalPosition, " ").concat(serviceDetailDialog_default.a.infoNoRadiusAndResize),
        zIndex: 9999,
        style: {
          fontFamily: 'Helvetica,sans-serif'
        },
        size: "lg"
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: this.toggle,
        className: "".concat(serviceDetailDialog_default.a.infoCloseRightButton)
      }), serviceDetailDialog__jsx(reactstrap_es["m" /* ModalHeader */], {
        style: {
          color: 'white',
          backgroundColor: '#006a96',
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px'
        },
        className: "".concat(serviceDetailDialog_default.a.modalHeader)
      }, void 0, serviceDetailDialog__jsx("span", {
        style: {
          margin: '54px 40px 30px',
          fontSize: '33px'
        }
      }, void 0, this.state.modelDataText.order.service_content_headline)), serviceDetailDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          padding: '30px 60px 60px 40px'
        }
      }, void 0, serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceDetailContainer, " text-centered"),
        "data-close": "false"
      }, void 0, serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceDetailContentContainer)
      }, void 0, serviceDetailDialog__jsx("p", {}, void 0, this.state.modelDataText.order.service_content_content), serviceDetailDialog__ref, serviceDetailDialog__jsx("div", {}, void 0, serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceDetailDescHeadline, " ").concat(style_default.a.globalTextBlue)
      }, void 0, serviceDetailDialog__jsx("h2", {
        className: "".concat(serviceDetailDialog_default.a.h2MarginBottom)
      }, void 0, this.state.modelDataText.order.service_content_fleets_header)), serviceDetailDialog__ref2, serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_van_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_van_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_10ftlorry_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_10ftlorry_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_14ftlorry_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_icon_ser_14ftlorry_body))), serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceAddtionalType)
      }, void 0, serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceDetailDescHeadline, " ").concat(style_default.a.globalTextBlue)
      }, void 0, serviceDetailDialog__jsx("h2", {
        className: "".concat(serviceDetailDialog_default.a.h2MarginBottom)
      }, void 0, this.state.modelDataText.order.service_content_additional_header)), serviceDetailDialog__ref3, serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_english_speaking_driver_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_english_speaking_driver_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_goodsg_longer_than_6ft_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_goodsg_longer_than_6ft_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_borrow_carts_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_borrow_carts_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_forklift_rental_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_forklift_rental_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_mover_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_mover_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_pets_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_pets_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_new_vehicle_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_new_vehicle_body)), serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        xs: "2",
        sm: "2",
        md: "2",
        className: "".concat(serviceDetailDialog_default.a.orderSmallTitle)
      }, void 0, this.state.modelDataText.order.service_content_dumper_construction_waste_title), serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {
        md: "10"
      }, void 0, this.state.modelDataText.order.service_content_dumper_construction_waste_body))), serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceAddtionalType)
      }, void 0, serviceDetailDialog__jsx("div", {
        className: "".concat(serviceDetailDialog_default.a.serviceDetailDescHeadline, " ").concat(style_default.a.globalTextBlue)
      }, void 0, serviceDetailDialog__jsx("h2", {
        className: "".concat(serviceDetailDialog_default.a.h2MarginBottom)
      }, void 0, this.state.modelDataText.order.service_content_hourly_header)), _ref4, serviceDetailDialog__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(serviceDetailDialog_default.a.serviceVehicleType)
      }, void 0, serviceDetailDialog__jsx(reactstrap_es["b" /* Col */], {}, void 0, this.state.modelDataText.order.service_content_hourly_rental_body)))))));
    }
  }]);

  return serviceDetailDialog;
}(react_default.a.Component);

var serviceDetailDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

/* harmony default export */ var order_popup_serviceDetailDialog = (Object(es["b" /* connect */])(serviceDetailDialog_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, serviceDetailDialog_default.a)(serviceDetailDialog_serviceDetailDialog)));
// CONCATENATED MODULE: ./src/routes/order/Order12AddService/Order12AddService.js
function Order12AddService__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order12AddService__typeof = function _typeof(obj) { return typeof obj; }; } else { Order12AddService__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order12AddService__typeof(obj); }

var Order12AddService_REACT_ELEMENT_TYPE;

function Order12AddService__jsx(type, props, key, children) { if (!Order12AddService_REACT_ELEMENT_TYPE) { Order12AddService_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order12AddService_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order12AddService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order12AddService__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order12AddService__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order12AddService__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order12AddService__defineProperties(Constructor, staticProps); return Constructor; }

function Order12AddService__possibleConstructorReturn(self, call) { if (call && (Order12AddService__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order12AddService__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order12AddService__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import








var Order12AddService_Order12AddService =
/*#__PURE__*/
function (_React$Component) {
  Order12AddService__inherits(Order12AddService, _React$Component);

  function Order12AddService(props) {
    var _this;

    Order12AddService__classCallCheck(this, Order12AddService);

    _this = Order12AddService__possibleConstructorReturn(this, (Order12AddService.__proto__ || Object.getPrototypeOf(Order12AddService)).call(this, props));
    _this.state = {
      isShowServiceDetailDialog: false
    };
    _this.onClickShowServiceDetailDialog = _this.onClickShowServiceDetailDialog.bind(Order12AddService__assertThisInitialized(_this));
    return _this;
  }

  Order12AddService__createClass(Order12AddService, [{
    key: "onClickShowServiceDetailDialog",
    value: function onClickShowServiceDetailDialog(modal) {
      this.setState({
        isShowServiceDetailDialog: modal
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order12AddService__jsx("div", {}, void 0, Order12AddService__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_additional_service_title, Order12AddService__jsx("span", {
        style: this.props.lang !== 'hk' ? {
          display: 'none'
        } : {},
        className: "".concat(Order_default.a.serviceDetail, " ").concat(Order_default.a.orderFunctionText),
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this2.onClickShowServiceDetailDialog(true);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, "\xA0", this.props.modelData.additional_service.button_service_detail)), this.props.orderDetailInfo.vehicle !== '' && this.props.lang !== 'kr' ? Order12AddService__jsx("div", {
        className: "".concat(Order_default.a.serviceOption)
      }, void 0, Order12AddService__jsx(Order12AddServiceDetail, {
        modelData: this.props.modelData,
        modelDataText: this.props.modelDataText,
        vehicle: this.props.vehicle,
        lang: this.props.lang
      })) : '', this.props.lang === 'kr' ? Order12AddService__jsx("div", {
        className: "".concat(Order_default.a.serviceOption)
      }, void 0, Order12AddService__jsx(Order12AddServiceDetailKR, {
        modelData: this.props.modelData,
        modelDataText: this.props.modelDataText,
        vehicle: this.props.vehicle
      })) : '', Order12AddService__jsx(order_popup_serviceDetailDialog, {
        modal: this.state.isShowServiceDetailDialog,
        onClickShow: this.onClickShowServiceDetailDialog
      }));
    }
  }]);

  return Order12AddService;
}(react_default.a.Component);

var Order12AddService_mapState = function mapState(state) {
  return {
    vehicle: state.order.vehicle,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var order_Order12AddService_Order12AddService = (Object(es["b" /* connect */])(Order12AddService_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order12AddService_Order12AddService)));
// CONCATENATED MODULE: ./src/routes/order/Order13Remarks/Order13RemarksAddPhoto.js
function Order13RemarksAddPhoto__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order13RemarksAddPhoto__typeof = function _typeof(obj) { return typeof obj; }; } else { Order13RemarksAddPhoto__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order13RemarksAddPhoto__typeof(obj); }

var Order13RemarksAddPhoto_REACT_ELEMENT_TYPE;

function Order13RemarksAddPhoto__jsx(type, props, key, children) { if (!Order13RemarksAddPhoto_REACT_ELEMENT_TYPE) { Order13RemarksAddPhoto_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order13RemarksAddPhoto_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order13RemarksAddPhoto__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order13RemarksAddPhoto__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order13RemarksAddPhoto__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order13RemarksAddPhoto__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order13RemarksAddPhoto__defineProperties(Constructor, staticProps); return Constructor; }

function Order13RemarksAddPhoto__possibleConstructorReturn(self, call) { if (call && (Order13RemarksAddPhoto__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order13RemarksAddPhoto__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order13RemarksAddPhoto__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import





var imageInitValue = {};

var Order13RemarksAddPhoto_Order13RemarksAddPhoto =
/*#__PURE__*/
function (_React$Component) {
  Order13RemarksAddPhoto__inherits(Order13RemarksAddPhoto, _React$Component);

  function Order13RemarksAddPhoto(props) {
    var _this;

    Order13RemarksAddPhoto__classCallCheck(this, Order13RemarksAddPhoto);

    _this = Order13RemarksAddPhoto__possibleConstructorReturn(this, (Order13RemarksAddPhoto.__proto__ || Object.getPrototypeOf(Order13RemarksAddPhoto)).call(this, props));
    _this.state = {
      image: imageInitValue
    };
    _this.onClickUpdateImage = _this.onClickUpdateImage.bind(Order13RemarksAddPhoto__assertThisInitialized(_this));
    _this.onClickCancelImage = _this.onClickCancelImage.bind(Order13RemarksAddPhoto__assertThisInitialized(_this));
    _this.readFile = _this.readFile.bind(Order13RemarksAddPhoto__assertThisInitialized(_this));
    _this.searchIndex = _this.searchIndex.bind(Order13RemarksAddPhoto__assertThisInitialized(_this));
    return _this;
  }

  Order13RemarksAddPhoto__createClass(Order13RemarksAddPhoto, [{
    key: "onClickUpdateImage",
    value: function onClickUpdateImage() {
      this.image.click();
    }
  }, {
    key: "onClickCancelImage",
    value: function onClickCancelImage() {
      var index = this.searchIndex(this.state.image.base64);
      this.setState({
        image: imageInitValue
      });
      this.props.removeImageComponent(index);
      this.props.removeOrderImage(index);
    }
  }, {
    key: "readFile",
    value: function readFile(e) {
      var _this2 = this;

      var file = e.target.files[0];

      if (file !== null && typeof file !== 'undefined') {
        if (file.size > 2000000) {
          this.props.setIsImgTooLarge(true);
        } else {
          this.props.setIsImgTooLarge(false);
          var FR = new FileReader();

          FR.onload = function (event) {
            var base64 = event.target.result; // ensure no duplicate photo

            if (_this2.searchIndex(base64) !== -1) {
              return null;
            }

            FR.abort();
            var FR2 = new FileReader();

            FR2.onload = function (es) {
              var image = {
                // image base64 format
                base64: base64,
                // text & type for upload to server
                text: es.target.result,
                type: file.type
              }; // new image

              if (Object.keys(_this2.state.image).length === 0) {
                _this2.props.updateOrderImage(image, _this2.props.images.length - 1);

                _this2.props.addOrderImage(imageInitValue);

                _this2.props.addImageComponent(false);
              } else {
                _this2.props.updateOrderImage(image, _this2.searchIndex(_this2.state.image.base64));
              }

              _this2.setState({
                image: image
              });
            };

            FR2.readAsText(file);
            return true;
          };

          FR.readAsDataURL(file);
        }
      }
    }
  }, {
    key: "searchIndex",
    value: function searchIndex(image) {
      for (var i = 0; i < this.props.images.length; i += 1) {
        if (this.props.images[i].base64 === image) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return Order13RemarksAddPhoto__jsx("span", {}, void 0, react_default.a.createElement("input", {
        ref: function ref(input) {
          _this3.image = input;
        },
        type: "file",
        className: "".concat(Order_default.a.uploadFile),
        onChange: this.readFile,
        accept: "image/*"
      }), Order13RemarksAddPhoto__jsx("span", {
        className: "".concat(Order_default.a.imageItem),
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.onClickUpdateImage();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order13RemarksAddPhoto__jsx("span", {
        className: Object.keys(this.state.image).length === 0 ? '' : Order_default.a.imageItemCancel,
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();

          _this3.onClickCancelImage();
        },
        onKeyPress: function onKeyPress() {}
      }), Order13RemarksAddPhoto__jsx("span", {
        className: "".concat(Order_default.a.uploadImage),
        style: Object.keys(this.state.image).length === 0 ? {} : {
          backgroundImage: "url(".concat(this.state.image.base64, ")")
        }
      })));
    }
  }]);

  return Order13RemarksAddPhoto;
}(react_default.a.Component);

var Order13RemarksAddPhoto_mapState = function mapState(state) {
  return {
    images: state.order.images
  };
};

var Order13RemarksAddPhoto_mapDispatch = {
  addOrderImage: actions_order["b" /* addOrderImage */],
  updateOrderImage: actions_order["u" /* updateOrderImage */],
  removeOrderImage: actions_order["e" /* removeOrderImage */]
};
/* harmony default export */ var Order13Remarks_Order13RemarksAddPhoto = (Object(es["b" /* connect */])(Order13RemarksAddPhoto_mapState, Order13RemarksAddPhoto_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order13RemarksAddPhoto_Order13RemarksAddPhoto)));
// CONCATENATED MODULE: ./src/routes/order/Order13Remarks/Order13Remarks.js
function Order13Remarks__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order13Remarks__typeof = function _typeof(obj) { return typeof obj; }; } else { Order13Remarks__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order13Remarks__typeof(obj); }

var Order13Remarks_REACT_ELEMENT_TYPE;

function Order13Remarks__jsx(type, props, key, children) { if (!Order13Remarks_REACT_ELEMENT_TYPE) { Order13Remarks_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order13Remarks_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order13Remarks__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order13Remarks__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order13Remarks__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order13Remarks__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order13Remarks__defineProperties(Constructor, staticProps); return Constructor; }

function Order13Remarks__possibleConstructorReturn(self, call) { if (call && (Order13Remarks__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order13Remarks__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // Relative import







var Order13Remarks_Order13Remarks =
/*#__PURE__*/
function (_React$Component) {
  Order13Remarks__inherits(Order13Remarks, _React$Component);

  function Order13Remarks(props) {
    var _this;

    Order13Remarks__classCallCheck(this, Order13Remarks);

    _this = Order13Remarks__possibleConstructorReturn(this, (Order13Remarks.__proto__ || Object.getPrototypeOf(Order13Remarks)).call(this, props));
    _this.state = {
      imageComponent: [],
      index: 0
    };
    return _this;
  }

  Order13Remarks__createClass(Order13Remarks, [{
    key: "addImageComponent",
    value: function addImageComponent(isFromAddButton) {
      // first add image
      if (isFromAddButton) {
        if (this.props.images.length < 1) {
          this.state.imageComponent.push(Order13Remarks__jsx(Order13Remarks_Order13RemarksAddPhoto, {
            addImageComponent: this.addImageComponent,
            removeImageComponent: this.removeImageComponent,
            index: this.props.images.length,
            setIsImgTooLarge: this.setIsImgTooLarge
          }, "".concat(this.props.images.length, " ").concat(new Date().toISOString())));
          this.props.addOrderImage({});
          this.setState({
            index: this.state.index + 1
          });
        }
      } else if (this.props.images.length <= 10) {
        this.state.imageComponent.push(Order13Remarks__jsx(Order13Remarks_Order13RemarksAddPhoto, {
          addImageComponent: this.addImageComponent,
          removeImageComponent: this.removeImageComponent,
          index: this.props.images.length - 1,
          setIsImgTooLarge: this.setIsImgTooLarge
        }, "".concat(this.props.images.length, " ").concat(new Date().toISOString())));
        this.setState({
          index: this.state.index + 1
        });
      }
    }
  }, {
    key: "removeImageComponent",
    value: function removeImageComponent(index) {
      this.setState({
        imageComponent: react_addons_update_default()(this.state.imageComponent, {
          $splice: [[index, 1]]
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order13Remarks__jsx("div", {
        className: Order_default.a.order13RemarkLineHeight
      }, void 0, Order13Remarks__jsx("span", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_remark_title), Order13Remarks__jsx(reactstrap_es["i" /* Input */], {
        type: "textarea",
        name: "text",
        id: "exampleText",
        rows: "4",
        placeholder: typeof this.props.modelDataText.order_remark_body !== 'undefined' ? this.props.modelDataText.order_remark_body : this.props.modelDataText.uniform_invoice_remark_input,
        style: {
          backgroundColor: '#f6f6f6',
          border: '0px'
        },
        onChange: function onChange(e) {
          _this2.props.updateOrderDetailInfoAction(_this2.props.fieldParentName, _this2.props.fieldChildName, e.target.value);
        }
      }));
    }
  }]);

  return Order13Remarks;
}(react_default.a.Component);

var Order13Remarks_mapState = function mapState(state) {
  return {
    images: state.order.images
  };
};

var Order13Remarks_mapDispatch = {
  addOrderImage: actions_order["b" /* addOrderImage */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order13Remarks_Order13Remarks = (Object(es["b" /* connect */])(Order13Remarks_mapState, Order13Remarks_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order13Remarks_Order13Remarks)));
// EXTERNAL MODULE: ./src/assets/img/icon_mail.png
var icon_mail = __webpack_require__(575);
var icon_mail_default = /*#__PURE__*/__webpack_require__.n(icon_mail);

// EXTERNAL MODULE: ./src/assets/img/icon_mail@2x.png
var icon_mail_2x = __webpack_require__(572);
var icon_mail_2x_default = /*#__PURE__*/__webpack_require__.n(icon_mail_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_avatar.png
var icon_avatar = __webpack_require__(569);
var icon_avatar_default = /*#__PURE__*/__webpack_require__.n(icon_avatar);

// EXTERNAL MODULE: ./src/assets/img/icon_avatar@2x.png
var icon_avatar_2x = __webpack_require__(568);
var icon_avatar_2x_default = /*#__PURE__*/__webpack_require__.n(icon_avatar_2x);

// CONCATENATED MODULE: ./src/routes/order/Order14ContactInfo/Order14ContactInfo.js
var Order14ContactInfo_REACT_ELEMENT_TYPE;

function Order14ContactInfo__jsx(type, props, key, children) { if (!Order14ContactInfo_REACT_ELEMENT_TYPE) { Order14ContactInfo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order14ContactInfo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order14ContactInfo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order14ContactInfo__typeof = function _typeof(obj) { return typeof obj; }; } else { Order14ContactInfo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order14ContactInfo__typeof(obj); }

function Order14ContactInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order14ContactInfo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order14ContactInfo__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order14ContactInfo__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order14ContactInfo__defineProperties(Constructor, staticProps); return Constructor; }

function Order14ContactInfo__possibleConstructorReturn(self, call) { if (call && (Order14ContactInfo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order14ContactInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order14ContactInfo__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import














var Order14ContactInfo_Order14ContactInfo =
/*#__PURE__*/
function (_React$Component) {
  Order14ContactInfo__inherits(Order14ContactInfo, _React$Component);

  function Order14ContactInfo(props) {
    var _this;

    Order14ContactInfo__classCallCheck(this, Order14ContactInfo);

    _this = Order14ContactInfo__possibleConstructorReturn(this, (Order14ContactInfo.__proto__ || Object.getPrototypeOf(Order14ContactInfo)).call(this, props));
    _this.state = {
      name: Object(auth["b" /* getAuth */])().username,
      phone: Object(auth["b" /* getAuth */])().phone,
      email: Object(auth["b" /* getAuth */])().email,
      isValidName: true,
      isValidPhone: true,
      isValidEmail: true,
      scrollToComponent: null
    };
    _this.setScrollToComponent = _this.setScrollToComponent.bind(Order14ContactInfo__assertThisInitialized(_this));
    _this.scrollToAndReturnIsValid = _this.scrollToAndReturnIsValid.bind(Order14ContactInfo__assertThisInitialized(_this));
    return _this;
  }

  Order14ContactInfo__createClass(Order14ContactInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollToComponent();
      this.onChangeName(Object(auth["b" /* getAuth */])().username);
      this.onChangePhone(Object(auth["b" /* getAuth */])().phone);
      this.onChangeEmail(Object(auth["b" /* getAuth */])().email);
      this.props.updateOrderDetailInfoAction('phone_number', null, Object(auth["b" /* getAuth */])().phone);
      this.props.updateOrderDetailInfoAction('nickname', null, Object(auth["b" /* getAuth */])().username);
      this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', Object(auth["b" /* getAuth */])().email);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
        this.props.updateOrderDetailInfoAction('phone_number', null, this.state.phone);
        this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', this.state.email);

        if (this.state.name === '') {
          this.setState({
            isValidName: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidName: true
          });
        }

        var phonePatt = new RegExp(this.props.setting.PHONE_REGEX);

        if (!phonePatt.test(this.state.phone)) {
          this.setState({
            isValidPhone: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidPhone: true
          });
        }

        var emailPatt = new RegExp(this.props.setting.EMAIL_REGEX);

        if (!emailPatt.test(this.state.email)) {
          this.setState({
            isValidEmail: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidEmail: true
          });
        }
      }
    }
  }, {
    key: "onChangeName",
    value: function onChangeName(e) {
      if (Order14ContactInfo__typeof(e) === 'object') {
        this.setState({
          name: e.target.value
        });
      } else {
        this.setState({
          name: e
        });
      }
    }
  }, {
    key: "onChangePhone",
    value: function onChangePhone(e) {
      if (Order14ContactInfo__typeof(e) === 'object') {
        this.setState({
          phone: e.target.value
        });
      } else {
        this.setState({
          phone: e
        });
      }
    }
  }, {
    key: "onChangeEmail",
    value: function onChangeEmail(e) {
      if (Order14ContactInfo__typeof(e) === 'object') {
        this.setState({
          email: e.target.value
        });
      } else {
        this.setState({
          email: e
        });
      }
    }
  }, {
    key: "setScrollToComponent",
    value: function setScrollToComponent() {
      /* eslint-disable global-require */
      this.setState({
        scrollToComponent: __webpack_require__(919)
      });
    }
  }, {
    key: "scrollToAndReturnIsValid",
    value: function scrollToAndReturnIsValid() {
      this.props.setIsValidOrder(false);
      this.state.scrollToComponent(this.Order14ContactInfo, {
        offset: -100,
        duration: 500
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order14ContactInfo__jsx(reactstrap_es["c" /* Container */], {}, void 0, react_default.a.createElement("p", {
        ref: function ref(i) {
          _this2.Order14ContactInfo = i;
        }
      }), Order14ContactInfo__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_title), Order14ContactInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_nickname_input,
        value: this.state.name,
        onChange: function onChange(e) {
          _this2.onChangeName(e);
        }
      }), Order14ContactInfo__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "ppl"
      }))), Order14ContactInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_phone_input,
        value: this.state.phone,
        onChange: function onChange(e) {
          _this2.onChangePhone(e);
        }
      }), Order14ContactInfo__jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "phone"
      }))), Order14ContactInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_email_input,
        value: this.state.email,
        onChange: function onChange(e) {
          _this2.onChangeEmail(e);
        }
      }), Order14ContactInfo__jsx("img", {
        srcSet: "".concat(icon_mail_default.a, " 1x, ").concat(icon_mail_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "email"
      }))), Order14ContactInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_nickname_input_warning), Order14ContactInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidPhone ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_phone_input_warning), Order14ContactInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidEmail ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_email_input_warning));
    }
  }]);

  return Order14ContactInfo;
}(react_default.a.Component);

var Order14ContactInfo_mapState = function mapState(state) {
  return {
    user: state.user.user,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order14ContactInfo_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */]
};
/* harmony default export */ var order_Order14ContactInfo_Order14ContactInfo = (Object(es["b" /* connect */])(Order14ContactInfo_mapState, Order14ContactInfo_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order14ContactInfo_Order14ContactInfo)));
// CONCATENATED MODULE: ./src/routes/order/Order18AddPhoto/Order18AddPhotoComponent.js
function Order18AddPhotoComponent__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order18AddPhotoComponent__typeof = function _typeof(obj) { return typeof obj; }; } else { Order18AddPhotoComponent__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order18AddPhotoComponent__typeof(obj); }

var Order18AddPhotoComponent_REACT_ELEMENT_TYPE;

function Order18AddPhotoComponent__jsx(type, props, key, children) { if (!Order18AddPhotoComponent_REACT_ELEMENT_TYPE) { Order18AddPhotoComponent_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order18AddPhotoComponent_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order18AddPhotoComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order18AddPhotoComponent__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order18AddPhotoComponent__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order18AddPhotoComponent__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order18AddPhotoComponent__defineProperties(Constructor, staticProps); return Constructor; }

function Order18AddPhotoComponent__possibleConstructorReturn(self, call) { if (call && (Order18AddPhotoComponent__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order18AddPhotoComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order18AddPhotoComponent__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import





var Order18AddPhotoComponent_imageInitValue = {};

var Order18AddPhotoComponent_Order18AddPhotoComponent =
/*#__PURE__*/
function (_React$Component) {
  Order18AddPhotoComponent__inherits(Order18AddPhotoComponent, _React$Component);

  function Order18AddPhotoComponent(props) {
    var _this;

    Order18AddPhotoComponent__classCallCheck(this, Order18AddPhotoComponent);

    _this = Order18AddPhotoComponent__possibleConstructorReturn(this, (Order18AddPhotoComponent.__proto__ || Object.getPrototypeOf(Order18AddPhotoComponent)).call(this, props));
    _this.state = {
      image: Order18AddPhotoComponent_imageInitValue,
      uploadedFileName: null
    };
    _this.onClickUpdateImage = _this.onClickUpdateImage.bind(Order18AddPhotoComponent__assertThisInitialized(_this));
    _this.onClickCancelImage = _this.onClickCancelImage.bind(Order18AddPhotoComponent__assertThisInitialized(_this));
    _this.readFile = _this.readFile.bind(Order18AddPhotoComponent__assertThisInitialized(_this));
    _this.searchIndex = _this.searchIndex.bind(Order18AddPhotoComponent__assertThisInitialized(_this));
    return _this;
  }

  Order18AddPhotoComponent__createClass(Order18AddPhotoComponent, [{
    key: "onClickUpdateImage",
    value: function onClickUpdateImage() {
      this.image.click();
    }
  }, {
    key: "onClickCancelImage",
    value: function onClickCancelImage() {
      var index = this.searchIndex(this.state.uploadedFileName);
      this.setState({
        image: Order18AddPhotoComponent_imageInitValue
      });
      this.props.removeImageComponent(index);
      this.props.removeOrderImage(index);
    }
  }, {
    key: "readFile",
    value: function readFile(e) {
      var _this2 = this;

      var file = e.target.files[0];

      if (file !== null && typeof file !== 'undefined') {
        if (file.size > 2000000) {
          this.props.setIsImgTooLarge(true);
        } else {
          this.props.setIsImgTooLarge(false);
          var FR = new FileReader();

          FR.onload = function (event) {
            var base64 = event.target.result; // ensure no duplicate photo

            if (_this2.searchIndex(file.name) !== -1) {
              return null;
            }

            FR.abort();
            var FR2 = new FileReader();

            FR2.onload = function (es) {
              var image = {
                // image base64 format
                base64: base64,
                // text & type for upload to server
                text: es.target.result,
                type: file.type
              }; // new image

              if (Object.keys(_this2.state.image).length === 0) {
                _this2.props.updateOrderImage(file, _this2.props.images.length - 1);

                _this2.props.addOrderImage(Order18AddPhotoComponent_imageInitValue);

                _this2.props.addImageComponent(false);
              } else {
                _this2.props.updateOrderImage(file, _this2.searchIndex(_this2.state.uploadedFileName));
              }

              _this2.setState({
                image: image,
                uploadedFileName: file.name
              });
            };

            FR2.readAsText(file);
            return true;
          };

          FR.readAsDataURL(file);
        }
      }
    }
  }, {
    key: "searchIndex",
    value: function searchIndex(image) {
      for (var i = 0; i < this.props.images.length; i += 1) {
        if (this.props.images[i].name === image) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return Order18AddPhotoComponent__jsx("span", {}, void 0, react_default.a.createElement("input", {
        ref: function ref(input) {
          _this3.image = input;
        },
        type: "file",
        className: "".concat(Order_default.a.uploadFile),
        onChange: this.readFile,
        accept: "image/*"
      }), Order18AddPhotoComponent__jsx("span", {
        className: "".concat(Order_default.a.imageItem),
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.onClickUpdateImage();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order18AddPhotoComponent__jsx("span", {
        className: Object.keys(this.state.image).length === 0 ? '' : Order_default.a.imageItemCancel,
        role: "button",
        tabIndex: 0,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();

          _this3.onClickCancelImage();
        },
        onKeyPress: function onKeyPress() {}
      }), Order18AddPhotoComponent__jsx("span", {
        className: "".concat(Order_default.a.uploadImage),
        style: Object.keys(this.state.image).length === 0 ? {} : {
          backgroundImage: "url(".concat(this.state.image.base64, ")")
        }
      })));
    }
  }]);

  return Order18AddPhotoComponent;
}(react_default.a.Component);

var Order18AddPhotoComponent_mapState = function mapState(state) {
  return {
    images: state.order.images
  };
};

var Order18AddPhotoComponent_mapDispatch = {
  addOrderImage: actions_order["b" /* addOrderImage */],
  updateOrderImage: actions_order["u" /* updateOrderImage */],
  removeOrderImage: actions_order["e" /* removeOrderImage */]
};
/* harmony default export */ var Order18AddPhoto_Order18AddPhotoComponent = (Object(es["b" /* connect */])(Order18AddPhotoComponent_mapState, Order18AddPhotoComponent_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order18AddPhotoComponent_Order18AddPhotoComponent)));
// EXTERNAL MODULE: ./src/assets/img/icon_question.png
var icon_question = __webpack_require__(1282);
var icon_question_default = /*#__PURE__*/__webpack_require__.n(icon_question);

// EXTERNAL MODULE: ./src/assets/img/icon_question@2x.png
var icon_question_2x = __webpack_require__(980);
var icon_question_2x_default = /*#__PURE__*/__webpack_require__.n(icon_question_2x);

// CONCATENATED MODULE: ./src/routes/order/Order18AddPhoto/Order18AddPhoto.js
function Order18AddPhoto__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order18AddPhoto__typeof = function _typeof(obj) { return typeof obj; }; } else { Order18AddPhoto__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order18AddPhoto__typeof(obj); }

var Order18AddPhoto_REACT_ELEMENT_TYPE;

function Order18AddPhoto__jsx(type, props, key, children) { if (!Order18AddPhoto_REACT_ELEMENT_TYPE) { Order18AddPhoto_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order18AddPhoto_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order18AddPhoto__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order18AddPhoto__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order18AddPhoto__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order18AddPhoto__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order18AddPhoto__defineProperties(Constructor, staticProps); return Constructor; }

function Order18AddPhoto__possibleConstructorReturn(self, call) { if (call && (Order18AddPhoto__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order18AddPhoto__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order18AddPhoto__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }


/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // Relative import










var Order18AddPhoto__ref = Order18AddPhoto__jsx("br", {});

var Order18AddPhoto_Order18AddPhoto =
/*#__PURE__*/
function (_React$Component) {
  Order18AddPhoto__inherits(Order18AddPhoto, _React$Component);

  function Order18AddPhoto(props) {
    var _this;

    Order18AddPhoto__classCallCheck(this, Order18AddPhoto);

    _this = Order18AddPhoto__possibleConstructorReturn(this, (Order18AddPhoto.__proto__ || Object.getPrototypeOf(Order18AddPhoto)).call(this, props));
    _this.state = {
      imageComponent: [],
      index: 0,

      /* eslint-disable react/no-unused-state */
      // for otheres component used
      isImgTooLarge: false,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      isShowLargeTag: false
    };
    _this.addImageComponent = _this.addImageComponent.bind(Order18AddPhoto__assertThisInitialized(_this));
    _this.removeImageComponent = _this.removeImageComponent.bind(Order18AddPhoto__assertThisInitialized(_this)); // need this function to fix

    _this.setIsImgTooLarge = _this.setIsImgTooLarge.bind(Order18AddPhoto__assertThisInitialized(_this));
    return _this;
  }

  Order18AddPhoto__createClass(Order18AddPhoto, [{
    key: "onClickQuestionButton",
    value: function onClickQuestionButton() {
      this.props.setSimpleMessage({
        header: this.props.modelDataText.order.item_fit_headline,
        body: this.props.modelDataText.order.item_fit_content
      });
      this.props.setIsShowSimpleMessageDialog();
    }
  }, {
    key: "setIsImgTooLarge",
    value: function setIsImgTooLarge(bool) {
      this.setState({
        isImgTooLarge: bool
      });
    }
  }, {
    key: "addImageComponent",
    value: function addImageComponent(isFromAddButton) {
      // first add image
      if (isFromAddButton) {
        if (this.props.images.length < 1) {
          this.state.imageComponent.push(Order18AddPhoto__jsx(Order18AddPhoto_Order18AddPhotoComponent, {
            addImageComponent: this.addImageComponent,
            removeImageComponent: this.removeImageComponent,
            index: this.props.images.length,
            setIsImgTooLarge: this.setIsImgTooLarge
          }, "".concat(this.props.images.length, " ").concat(new Date().toISOString())));
          this.props.addOrderImage({});
          this.setState({
            index: this.state.index + 1
          });
        }

        this.setIsImgTooLarge(true);
      } else if (this.props.images.length <= 10) {
        this.state.imageComponent.push(Order18AddPhoto__jsx(Order18AddPhoto_Order18AddPhotoComponent, {
          addImageComponent: this.addImageComponent,
          removeImageComponent: this.removeImageComponent,
          index: this.props.images.length - 1,
          setIsImgTooLarge: this.setIsImgTooLarge
        }, "".concat(this.props.images.length, " ").concat(new Date().toISOString())));
        this.setState({
          index: this.state.index + 1
        });
      }

      this.setState({
        isShowLargeTag: true
      });
    }
  }, {
    key: "removeImageComponent",
    value: function removeImageComponent(index) {
      this.setState({
        imageComponent: react_addons_update_default()(this.state.imageComponent, {
          $splice: [[index, 1]]
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order18AddPhoto__jsx("div", {}, void 0, Order18AddPhoto__ref, Order18AddPhoto__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order18AddPhoto__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: 6
        },
        xs: "12",
        className: Order_default.a.addPhotoButton,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this2.addImageComponent(true);
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order18AddPhoto__jsx("span", {
        className: "".concat(Order_default.a.functionIcon)
      }), Order18AddPhoto__jsx("span", {
        className: "".concat(Order_default.a.functionText)
      }, void 0, this.props.modelDataText.order.order_add_image_button), this.state.isShowLargeTag ? Order18AddPhoto__jsx("span", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_add_image_max_size_desc)
      /* gogovan website no show */
      : ''), ['kr', 'sg'].includes(this.state.lang) ? Order18AddPhoto__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: 'auto',
          offset: 6
        },
        xs: "12",
        className: "".concat(Order_default.a.addPhotoButton, " ").concat(Order_default.a.functionText),
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this2.onClickQuestionButton();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order18AddPhoto__jsx("img", {
        srcSet: "".concat(icon_question_default.a, " 1x, ").concat(icon_question_2x_default.a, " 2x"),
        height: "18",
        alt: "question"
      }), this.props.modelDataText.order.order_will_my_item_fit_into_the_vehicle) : ''), Order18AddPhoto__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.uiImageUpload
      }, void 0, Order18AddPhoto__jsx("span", {
        className: Order_default.a.uiImageTopOffset
      }, void 0, this.state.imageComponent)));
    }
  }]);

  return Order18AddPhoto;
}(react_default.a.Component);

var Order18AddPhoto_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    images: state.order.images
  };
};

var Order18AddPhoto_mapDispatch = {
  addOrderImage: actions_order["b" /* addOrderImage */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsShowSimpleMessageDialog: actions_dialog["k" /* setIsShowSimpleMessageDialog */],
  setSimpleMessage: actions_dialog["m" /* setSimpleMessage */]
};
/* harmony default export */ var order_Order18AddPhoto_Order18AddPhoto = (Object(es["b" /* connect */])(Order18AddPhoto_mapState, Order18AddPhoto_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order18AddPhoto_Order18AddPhoto)));
// CONCATENATED MODULE: ./src/routes/order/Order19Total/Order19Total.js
function Order19Total__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order19Total__typeof = function _typeof(obj) { return typeof obj; }; } else { Order19Total__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order19Total__typeof(obj); }

var Order19Total_REACT_ELEMENT_TYPE;

function Order19Total__jsx(type, props, key, children) { if (!Order19Total_REACT_ELEMENT_TYPE) { Order19Total_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order19Total_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order19Total__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order19Total__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order19Total__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order19Total__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order19Total__defineProperties(Constructor, staticProps); return Constructor; }

function Order19Total__possibleConstructorReturn(self, call) { if (call && (Order19Total__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order19Total__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order19Total__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import







var Order19Total_Order19Total =
/*#__PURE__*/
function (_React$Component) {
  Order19Total__inherits(Order19Total, _React$Component);

  function Order19Total(props) {
    var _this;

    Order19Total__classCallCheck(this, Order19Total);

    _this = Order19Total__possibleConstructorReturn(this, (Order19Total.__proto__ || Object.getPrototypeOf(Order19Total)).call(this, props));
    _this.state = {
      price: 0,
      isGetPrice: false,
      isKorea: ['kr'].includes(props.currentLocale.split('-')[1].toLowerCase()) // routes: [],
      // orderDetailInfo: props.orderDetailInfo,

    };
    _this.getPrice = _this.getPrice.bind(Order19Total__assertThisInitialized(_this));
    _this.getRouteNumber = _this.getRouteNumber.bind(Order19Total__assertThisInitialized(_this));
    _this.checkIsValidAddress = _this.checkIsValidAddress.bind(Order19Total__assertThisInitialized(_this)); // this.setOrderDetailInfo = this.setOrderDetailInfo.bind(this);

    return _this;
  }

  Order19Total__createClass(Order19Total, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var isGetPrice = false;
      isGetPrice = this.isGetPrice(this.props.orderDetailInfo.service_type, nextProps.orderDetailInfo.service_type);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.vehicle, nextProps.orderDetailInfo.vehicle);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.pickup_time, nextProps.orderDetailInfo.pickup_time);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.goods, nextProps.orderDetailInfo.goods);
      isGetPrice = isGetPrice || this.checkRemark(this.props.orderDetailInfo.order_request_detail_attributes, nextProps.orderDetailInfo.order_request_detail_attributes);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.routes, nextProps.orderDetailInfo.routes);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.waypoints_attributes, nextProps.orderDetailInfo.waypoints_attributes);
      isGetPrice = isGetPrice || this.isGetPrice(this.props.orderDetailInfo.coupon_code, nextProps.orderDetailInfo.coupon_code);

      if (isGetPrice) {
        setTimeout(function () {
          _this2.getPrice();
        }, 800);
      }
    }
  }, {
    key: "getRouteNumber",
    value: function getRouteNumber() {
      var count = [];

      for (var i = 0; i < this.props.address.length; i += 1) {
        count.push(i + 1);
      }

      return count;
    }
  }, {
    key: "getPrice",
    value: function getPrice() {
      var _this3 = this;

      if (this.checkIsValidAddress()) {
        this.props.orderDetailInfo.routes = this.getRouteNumber();
        Object(api_order["h" /* getOrderPrice */])(this.props.orderDetailInfo, this.props.currentLocale).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (typeof result.extra_message !== 'undefined') {
            if (_this3.props.orderPriceBreakdownDetail.extra_message === '') {
              _this3.props.setIsShowExtraMessageDialog();
            } else if (result.extra_message !== _this3.props.orderPriceBreakdownDetail.extra_message) {
              _this3.props.setIsShowExtraMessageDialog();
            }
          }

          _this3.props.setOrderPriceBreakdownDetail(result);

          _this3.setState({
            price: result.total
          });

          _this3.forceUpdate();
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      }
    } // detect whether need to fetch new price from server

  }, {
    key: "isGetPrice",
    value: function isGetPrice(oldItem, newItem) {
      if (oldItem === newItem) {
        this.setState({
          isGetPrice: false || this.state.isGetPrice
        });
        return false;
      }

      this.setState({
        isGetPrice: true
      });
      return true;
    } // remove remark and remark_for_admin

    /* eslint-disable class-methods-use-this */

  }, {
    key: "removeRemark",
    value: function removeRemark(item) {
      var newItem = JSON.parse(JSON.stringify(item));
      var r = 'remark';
      var r1 = 'remark_for_admin';
      delete newItem[r];
      delete newItem[r1];
      return newItem;
    }
  }, {
    key: "checkRemark",
    value: function checkRemark(oldItem, newItem) {
      var oldItem2 = this.removeRemark(oldItem);
      var newItem2 = this.removeRemark(newItem); // tostring to check 2 object which without remark or remark_for_admin

      return !(JSON.stringify(oldItem2) === JSON.stringify(newItem2));
    }
  }, {
    key: "checkIsValidAddress",
    value: function checkIsValidAddress() {
      var getPrice = true;

      if (this.props.address.length > 0) {
        // check first address whether is not volid
        for (var i = 0; i < 2; i += 1) {
          if (this.props.address[i].address === '') {
            this.setState({
              price: 0
            });
            getPrice = false;
          }
        }
      } else {
        getPrice = false;
      }

      return getPrice;
    }
  }, {
    key: "render",
    value: function render() {
      return Order19Total__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order19Total__jsx(reactstrap_es["b" /* Col */], {
        className: Order_default.a.orderPricingTotal
      }, void 0, this.props.modelDataText.price_total_amount), Order19Total__jsx(reactstrap_es["b" /* Col */], {
        className: Order_default.a.orderPricingTotalPrice
      }, void 0, this.state.price === 0 || typeof this.state.price === 'undefined' ? '--' : !this.state.isKorea ? "".concat(this.props.modelDataText.dollar_code, " ").concat(this.state.price) : "".concat(this.state.price, " ").concat(this.props.modelDataText.dollar_code)));
    }
  }]);

  return Order19Total;
}(react_default.a.Component);

Object.defineProperty(Order19Total_Order19Total, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {// order: {},
    // coupon_code: '',
  }
});

var Order19Total_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address1: state.quoting.address1,
    address2: state.quoting.address2,
    address: state.order.address,
    vehicle: state.order.vehicle,
    order: state.order,
    tunnel: state.order.tunnel,
    vehiclePrice: state.quoting.vehiclePrice,
    passenger_count: state.order.passenger_count,
    pickup_time: state.order.pickup_time,
    need_over_6ft: state.order.need_over_6ft,
    cart_count: state.order.cart_count,
    need_cart: state.order.need_cart,
    remove_net: state.order.remove_net,
    need_carry: state.order.need_carry,
    need_new_car: state.order.need_new_car,
    need_pet: state.order.need_pet,
    need_waste: state.order.need_waste,
    pay_by_receiver: state.order.pay_by_receiver,
    coupon_code: state.order.coupon_code,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order19Total_mapDispatch = {
  getOrderPrice: api_order["h" /* getOrderPrice */],
  setOrderPriceBreakdownDetail: actions_order["p" /* setOrderPriceBreakdownDetail */],
  setIsShowExtraMessageDialog: actions_dialog["e" /* setIsShowExtraMessageDialog */]
};
/* harmony default export */ var order_Order19Total_Order19Total = (Object(es["b" /* connect */])(Order19Total_mapState, Order19Total_mapDispatch)(withStyles_default()(bootstrap_default.a, Order_default.a)(Order19Total_Order19Total)));
// EXTERNAL MODULE: ./src/assets/img/icon_cross_r.png
var icon_cross_r = __webpack_require__(1242);
var icon_cross_r_default = /*#__PURE__*/__webpack_require__.n(icon_cross_r);

// EXTERNAL MODULE: ./src/assets/img/icon_cross_r@2x.png
var icon_cross_r_2x = __webpack_require__(978);
var icon_cross_r_2x_default = /*#__PURE__*/__webpack_require__.n(icon_cross_r_2x);

// CONCATENATED MODULE: ./src/routes/order/Order20Coupon/Order20Coupon.js
function Order20Coupon__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order20Coupon__typeof = function _typeof(obj) { return typeof obj; }; } else { Order20Coupon__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order20Coupon__typeof(obj); }

var Order20Coupon_REACT_ELEMENT_TYPE;

function Order20Coupon__jsx(type, props, key, children) { if (!Order20Coupon_REACT_ELEMENT_TYPE) { Order20Coupon_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order20Coupon_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order20Coupon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order20Coupon__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order20Coupon__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order20Coupon__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order20Coupon__defineProperties(Constructor, staticProps); return Constructor; }

function Order20Coupon__possibleConstructorReturn(self, call) { if (call && (Order20Coupon__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order20Coupon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order20Coupon__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import








var Order20Coupon__ref = Order20Coupon__jsx("br", {});

var Order20Coupon_Order20Coupon =
/*#__PURE__*/
function (_React$Component) {
  Order20Coupon__inherits(Order20Coupon, _React$Component);

  function Order20Coupon(props) {
    var _this;

    Order20Coupon__classCallCheck(this, Order20Coupon);

    _this = Order20Coupon__possibleConstructorReturn(this, (Order20Coupon.__proto__ || Object.getPrototypeOf(Order20Coupon)).call(this, props));
    _this.state = {
      isValidCouponCode: true,
      isShowValidCouponCode: false,
      CouponStyle: Order_default.a.couponHide,
      code: ''
    };
    _this.onClickShowCoupon = _this.onClickShowCoupon.bind(Order20Coupon__assertThisInitialized(_this));
    _this.onClickHideCoupon = _this.onClickHideCoupon.bind(Order20Coupon__assertThisInitialized(_this));
    _this.onClickClearCode = _this.onClickClearCode.bind(Order20Coupon__assertThisInitialized(_this));
    return _this;
  }

  Order20Coupon__createClass(Order20Coupon, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Checking coupon response from server
      if (typeof nextProps.orderPriceBreakdownDetail.coupon !== 'undefined') {
        if (this.props.orderPriceBreakdownDetail.coupon !== nextProps.orderPriceBreakdownDetail.coupon) {
          this.setState({
            isValidCouponCode: nextProps.orderPriceBreakdownDetail.coupon.valid
          });

          if (nextProps.orderPriceBreakdownDetail.coupon.valid) {
            if (!this.state.isShowValidCouponCode) {
              this.onClickHideCoupon();
              this.setState({
                isShowValidCouponCode: true
              });
            }
          } else {
            this.props.updateOrderDetailInfoAction('coupon_code', null, null);
          }
        }
      }
    }
  }, {
    key: "onClickShowCoupon",
    value: function onClickShowCoupon() {
      this.props.setIsShowCoupon(true);
    }
  }, {
    key: "onClickHideCoupon",
    value: function onClickHideCoupon() {
      var _this2 = this;

      this.props.setIsShowCoupon(false); // delay the anime

      this.setState({
        CouponStyle: Order_default.a.removeCoupon
      }, function () {
        setTimeout(function () {
          _this2.setState({
            CouponStyle: Order_default.a.couponHide
          });
        }, 500);
      });
    }
  }, {
    key: "onClickClearCode",
    value: function onClickClearCode() {
      this.setState({
        code: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return Order20Coupon__jsx("div", {}, void 0, Order20Coupon__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.orderPricingCoupon
      }, void 0, Order20Coupon__jsx(reactstrap_es["b" /* Col */], {
        className: Order_default.a.orderFunctionText,
        onClick: function onClick() {
          if (!_this3.state.isShowValidCouponCode) {
            _this3.onClickShowCoupon();
          }
        }
      }, void 0, this.props.modelDataText.order_promo_code_if_any_title)), Order20Coupon__jsx(reactstrap_es["n" /* Row */], {
        className: "".concat(this.props.isShowCoupon ? Order_default.a.addCoupon : this.state.CouponStyle)
      }, void 0, Order20Coupon__jsx(reactstrap_es["b" /* Col */], {
        lg: "5",
        xs: "5"
      }, void 0, Order20Coupon__jsx(reactstrap_es["i" /* Input */], {
        value: this.state.code,
        onChange: function onChange(e) {
          _this3.setState({
            code: e.target.value
          });
        },
        placeholder: this.props.modelDataText.order_promo_code_input
      }), Order20Coupon__jsx("span", {
        className: Order_default.a.couponCrossButton,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          _this3.onClickClearCode();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order20Coupon__jsx("img", {
        srcSet: "".concat(icon_cross_r_default.a, " 1x, ").concat(icon_cross_r_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "cross"
      })), !this.state.isValidCouponCode ? Order20Coupon__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal)
      }, void 0, this.props.modelDataText.order_promo_input_warning) : ''), Order20Coupon__jsx(reactstrap_es["b" /* Col */], {
        lg: "7",
        xs: "7",
        className: Order_default.a.buttonLeft
      }, void 0, Order20Coupon__jsx("button", {
        className: "".concat(style_default.a.quotingOptionItemButton, " ").concat(style_default.a.button, " ").concat(style_default.a.outlined, "\n              ").concat(style_default.a.secondary, " ").concat(style_default.a.small, " ").concat(style_default.a.dialog, " ").concat(Order_default.a.buttonStyle),
        onClick: function onClick() {
          _this3.props.updateOrderDetailInfoAction('coupon_code', null, null);

          _this3.onClickHideCoupon();
        }
      }, void 0, this.props.modelDataText.order_promo_code_cancel_button), Order20Coupon__jsx("button", {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(Order_default.a.buttonStyle),
        onClick: function onClick() {
          _this3.props.updateOrderDetailInfoAction('coupon_code', null, _this3.state.code);
        }
      }, void 0, this.props.modelDataText.order_promo_code_confirm_button))), Order20Coupon__ref, this.state.isShowValidCouponCode ? Order20Coupon__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order20Coupon__jsx(reactstrap_es["b" /* Col */], {
        lg: "6",
        xs: "6"
      }, void 0, Order20Coupon__jsx("span", {
        role: "button",
        style: {
          cursor: 'pointer'
        },
        tabIndex: 0,
        onClick: function onClick() {
          _this3.props.updateOrderDetailInfoAction('coupon_code', null, null);

          _this3.setState({
            isShowValidCouponCode: false
          });
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Order20Coupon__jsx("img", {
        srcSet: "".concat(icon_cross_r_default.a, " 1x, ").concat(icon_cross_r_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        alt: "cross"
      }), this.props.modelDataText.order_promo_code_title)), Order20Coupon__jsx(reactstrap_es["b" /* Col */], {
        lg: "6",
        xs: "6",
        style: {
          textAlign: 'right'
        }
      }, void 0, typeof this.props.orderPriceBreakdownDetail.coupon !== 'undefined' ? this.props.orderPriceBreakdownDetail.coupon.message : '')) : '');
    }
  }]);

  return Order20Coupon;
}(react_default.a.Component);

var Order20Coupon_mapState = function mapState(state) {
  return {
    isToggleOn: state.order.isToggleOn,
    isShowCoupon: state.order.isShowCoupon,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail
  };
};

var Order20Coupon_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsShowCoupon: actions_order["i" /* setIsShowCoupon */]
};
/* harmony default export */ var order_Order20Coupon_Order20Coupon = (Object(es["b" /* connect */])(Order20Coupon_mapState, Order20Coupon_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order20Coupon_Order20Coupon)));
// EXTERNAL MODULE: ./src/routes/order/Order21Confirm/Order21Confirm.sass
var Order21Confirm_Order21Confirm = __webpack_require__(1838);
var Order21Confirm_default = /*#__PURE__*/__webpack_require__.n(Order21Confirm_Order21Confirm);

// CONCATENATED MODULE: ./src/routes/order/Order21Confirm/Order21Confirm.js
function Order21Confirm__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order21Confirm__typeof = function _typeof(obj) { return typeof obj; }; } else { Order21Confirm__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order21Confirm__typeof(obj); }

var Order21Confirm_REACT_ELEMENT_TYPE;

function Order21Confirm__jsx(type, props, key, children) { if (!Order21Confirm_REACT_ELEMENT_TYPE) { Order21Confirm_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order21Confirm_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order21Confirm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order21Confirm__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order21Confirm__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order21Confirm__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order21Confirm__defineProperties(Constructor, staticProps); return Constructor; }

function Order21Confirm__possibleConstructorReturn(self, call) { if (call && (Order21Confirm__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order21Confirm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order21Confirm__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable no-shadow */
// Absolute import


 // Relative import










var Order21Confirm__ref = Order21Confirm__jsx("br", {});

var Order21Confirm_Order21Confirm_Order21Confirm =
/*#__PURE__*/
function (_React$Component) {
  Order21Confirm__inherits(Order21Confirm, _React$Component);

  function Order21Confirm(props) {
    var _this;

    Order21Confirm__classCallCheck(this, Order21Confirm);

    _this = Order21Confirm__possibleConstructorReturn(this, (Order21Confirm.__proto__ || Object.getPrototypeOf(Order21Confirm)).call(this, props));
    _this.onClickSumbitOrder = _this.onClickSumbitOrder.bind(Order21Confirm__assertThisInitialized(_this));
    return _this;
  }

  Order21Confirm__createClass(Order21Confirm, [{
    key: "onClickSumbitOrder",
    value: function onClickSumbitOrder() {
      var _this2 = this;

      this.props.setIsClickConfirmOrder(true); // init isValid value to true for checking

      this.props.setIsValidOrder(true); // get time to check order

      if (Object(localStorage["b" /* localStorageGet */])('auth.verified', false)) {
        setTimeout(function () {
          if (!_this2.props.isValidOrder) {
            _this2.props.setIsClickConfirmOrder(false);
          } else {
            // delay the click actiion, because need some time to do checking
            _this2.props.onClickConfirm();
          }
        }, 500);
      } else if (!this.props.isSendingSMS) {
        Object(api_user["g" /* sendSMS */])(this.props.currentLocale, this.props.setIsSendingSMS);
        this.props.setIsShowSMSVerfiyDialog();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return Order21Confirm__jsx("div", {}, void 0, Order21Confirm__ref, Order21Confirm__jsx("button", {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.primary, " ").concat(style_default.a.globalTextBlue),
        style: {
          width: '100%'
        },
        onClick: function onClick(e) {
          if (!_this3.props.isClickConfirmOrder) {
            e.preventDefault();

            _this3.onClickSumbitOrder();
          } else if (!Object(localStorage["b" /* localStorageGet */])('auth.verified', false)) {
            _this3.props.setIsShowSMSVerfiyDialog();
          }
        }
      }, void 0, this.props.modelDataText.order_review_order_button));
    }
  }]);

  return Order21Confirm;
}(react_default.a.Component);

var Order21Confirm_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isToggleOn: state.order.isToggleOn,
    isSendingSMS: state.dialog.isSendingSMS,
    images: state.order.images,
    isValidOrder: state.order.isValidOrder,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order21Confirm_mapDispatch = {
  setIsToggleOn: actions_order["j" /* setIsToggleOn */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */],
  setIsShowSMSVerfiyDialog: actions_dialog["h" /* setIsShowSMSVerfiyDialog */],
  setIsSendingSMS: actions_dialog["b" /* setIsSendingSMS */],
  setIsShowSMSVerfiyLoadingDialog: actions_dialog["i" /* setIsShowSMSVerfiyLoadingDialog */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */]
};
/* harmony default export */ var order_Order21Confirm_Order21Confirm = (Object(es["b" /* connect */])(Order21Confirm_mapState, Order21Confirm_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order21Confirm_default.a)(Order21Confirm_Order21Confirm_Order21Confirm)));
// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__(922);
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// EXTERNAL MODULE: ./src/routes/OrderSummary/orderSummary.sass
var orderSummary = __webpack_require__(1840);
var orderSummary_default = /*#__PURE__*/__webpack_require__.n(orderSummary);

// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummarySumbitButton.js
function OrderSummarySumbitButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummarySumbitButton__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummarySumbitButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummarySumbitButton__typeof(obj); }

var OrderSummarySumbitButton_REACT_ELEMENT_TYPE;

function OrderSummarySumbitButton__jsx(type, props, key, children) { if (!OrderSummarySumbitButton_REACT_ELEMENT_TYPE) { OrderSummarySumbitButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummarySumbitButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function OrderSummarySumbitButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummarySumbitButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummarySumbitButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummarySumbitButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummarySumbitButton__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummarySumbitButton__possibleConstructorReturn(self, call) { if (call && (OrderSummarySumbitButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummarySumbitButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function OrderSummarySumbitButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable no-shadow */
// Absolute import



 // Relative import









var OrderSummarySumbitButton_OrderSummarySumbitButton =
/*#__PURE__*/
function (_React$Component) {
  OrderSummarySumbitButton__inherits(OrderSummarySumbitButton, _React$Component);

  function OrderSummarySumbitButton(props) {
    var _this;

    OrderSummarySumbitButton__classCallCheck(this, OrderSummarySumbitButton);

    _this = OrderSummarySumbitButton__possibleConstructorReturn(this, (OrderSummarySumbitButton.__proto__ || Object.getPrototypeOf(OrderSummarySumbitButton)).call(this, props));
    _this.state = {
      isCreatingOrder: false
    };
    _this.onYes = _this.onYes.bind(OrderSummarySumbitButton__assertThisInitialized(_this));
    return _this;
  }

  OrderSummarySumbitButton__createClass(OrderSummarySumbitButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // if uploaded all client photo, create order
      if (this.props.isUploadedClientPhoto !== nextProps.isUploadedClientPhoto) {
        this.props.updateOrderDetailInfoAction('client_uploads', null, this.props.client_uploads);
        this.setState({
          isCreatingOrder: true
        });

        var orderInfo = _extends({}, this.props.orderDetailInfo, {
          client_uploads: this.props.client_uploads
        });

        Object(api_order["c" /* createOrder */])(orderInfo, this.props.currentLocale).then(function (result) {
          if (result.status === 200 || result.status === 204) {
            // go to order detail page
            result.json().then(function (order) {
              Object(localStorage["d" /* localStorageSet */])('current.order.id', order.order.id); // give time to input localStorage

              setTimeout(function () {
                window.location.href = '/show';
              }, 500);
            });
          } else {
            _this2.props.setIsUploadedClientPhoto(false);

            _this2.setState({
              isCreatingOrder: false
            });
          }
        }).catch(function (error) {
          _this2.props.setIsUploadedClientPhoto(false);

          _this2.setState({
            isCreatingOrder: false
          });

          return error;
        });
      }
    }
  }, {
    key: "onYes",
    value: function onYes() {
      Object(api_order["a" /* asyncUpload */])(this.props.images, this.props.currentLocale, this.props.addUploadedOrderImage, this.props.setIsUploadedClientPhoto);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return OrderSummarySumbitButton__jsx("div", {}, void 0, OrderSummarySumbitButton__jsx(reactstrap_es["n" /* Row */], {}, void 0, OrderSummarySumbitButton__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: '6',
          offset: 3
        },
        sm: "12"
      }, void 0, OrderSummarySumbitButton__jsx(reactstrap_es["a" /* Button */], {
        id: "summary-find-driver",
        className: "".concat(style_default.a.button, " ").concat(style_default.a.primary, " ").concat(style_default.a.globalTextBlue, " ").concat(orderSummary_default.a.buttonFull),
        onClick: function onClick() {
          _this3.onYes();
        },
        disabled: this.state.isCreatingOrder
      }, void 0, this.props.modelDataText.order_summary_order_confirm_button))), OrderSummarySumbitButton__jsx(reactstrap_es["n" /* Row */], {
        style: {
          marginTop: '10px'
        }
      }, void 0, OrderSummarySumbitButton__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: '6',
          offset: 3
        },
        sm: "12"
      }, void 0, OrderSummarySumbitButton__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " ").concat(orderSummary_default.a.buttonFull),
        onClick: function onClick() {
          _this3.props.onClickConfirm();

          _this3.props.setIsClickConfirmOrder(false);
        },
        disabled: this.state.isCreatingOrder
      }, void 0, this.props.modelDataText.order_summary_order_edit_button))));
    }
  }]);

  return OrderSummarySumbitButton;
}(react_default.a.Component);

var OrderSummarySumbitButton_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    orderDetailInfo: state.order.orderDetailInfo,
    images: state.order.images,
    client_uploads: state.order.client_uploads,
    isUploadedClientPhoto: state.order.isUploadedClientPhoto
  };
};

var OrderSummarySumbitButton_mapDispatch = {
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */],
  setIsUploadedClientPhoto: actions_order["k" /* setIsUploadedClientPhoto */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */]
};
/* harmony default export */ var OrderSummary_OrderSummarySumbitButton = (Object(es["b" /* connect */])(OrderSummarySumbitButton_mapState, OrderSummarySumbitButton_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, orderSummary_default.a)(OrderSummarySumbitButton_OrderSummarySumbitButton)));
// EXTERNAL MODULE: ./src/components/Dialog/StaticMapDialog.js
var StaticMapDialog = __webpack_require__(912);

// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary01Route/OrderSummary01Route.js
function OrderSummary01Route__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary01Route__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary01Route__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary01Route__typeof(obj); }

var OrderSummary01Route_REACT_ELEMENT_TYPE;

function OrderSummary01Route__jsx(type, props, key, children) { if (!OrderSummary01Route_REACT_ELEMENT_TYPE) { OrderSummary01Route_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary01Route_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary01Route__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary01Route__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary01Route__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary01Route__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary01Route__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary01Route__possibleConstructorReturn(self, call) { if (call && (OrderSummary01Route__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary01Route__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function OrderSummary01Route__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }










var OrderSummary01Route_OrderSummary01Route =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary01Route__inherits(OrderSummary01Route, _React$Component);

  function OrderSummary01Route(props) {
    var _this;

    OrderSummary01Route__classCallCheck(this, OrderSummary01Route);

    _this = OrderSummary01Route__possibleConstructorReturn(this, (OrderSummary01Route.__proto__ || Object.getPrototypeOf(OrderSummary01Route)).call(this, props));
    _this.state = {
      location: {},
      openStaticMap: false
    };
    _this.onClickShowStaticMap = _this.onClickShowStaticMap.bind(OrderSummary01Route__assertThisInitialized(_this));
    return _this;
  }

  OrderSummary01Route__createClass(OrderSummary01Route, [{
    key: "onClickShowStaticMap",
    value: function onClickShowStaticMap() {
      this.setState({
        openStaticMap: !this.state.openStaticMap
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return OrderSummary01Route__jsx("div", {
        className: Order_default.a.summaryLocation
      }, void 0, OrderSummary01Route__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_route_title), OrderSummary01Route__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary01Route__jsx("dl", {
        className: style_default.a.address
      }, void 0, this.props.orderDetailInfo.waypoints_attributes.map(function (i, index) {
        return OrderSummary01Route__jsx("div", {}, index.toString(), OrderSummary01Route__jsx("span", {
          className: "".concat(Order_default.a.rightText, " ").concat(style_default.a.hideMobile),
          role: "button",
          tabIndex: 0,
          onKeyPress: function onKeyPress() {},
          onClick: function onClick() {
            _this2.setState({
              location: {
                lat: i.lat,
                lon: i.lon
              }
            });

            _this2.onClickShowStaticMap();
          }
        }, void 0, _this2.props.modelDataText.order_summary_route_view_on_map_button), OrderSummary01Route__jsx("span", {
          className: "".concat(Order_default.a.rightText, " ").concat(style_default.a.showMobile),
          role: "button",
          tabIndex: 0,
          onKeyPress: function onKeyPress() {},
          onClick: function onClick() {
            _this2.setState({
              location: {
                lat: i.lat,
                lon: i.lon
              }
            });

            _this2.onClickShowStaticMap();
          }
        }, void 0, _this2.props.modelDataText.order_summary_route_view_on_map_button_mobile), OrderSummary01Route__jsx("dd", {
          style: {
            whiteSpace: 'nowrap'
          }
        }, void 0, typeof i.detail_address !== 'undefined' ? "".concat(i.detail_address, ", ").concat(i.address) : i.address.toString()));
      })), OrderSummary01Route__jsx(StaticMapDialog["a" /* default */], {
        location: this.state.location,
        onClickShow: this.onClickShowStaticMap,
        modal: this.state.openStaticMap
      }));
    }
  }]);

  return OrderSummary01Route;
}(react_default.a.Component);

var OrderSummary01Route_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary01Route_OrderSummary01Route = (Object(es["b" /* connect */])(OrderSummary01Route_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary01Route_OrderSummary01Route)));
// EXTERNAL MODULE: ./src/assets/img/icon_calendar.png
var icon_calendar = __webpack_require__(927);
var icon_calendar_default = /*#__PURE__*/__webpack_require__.n(icon_calendar);

// EXTERNAL MODULE: ./src/assets/img/icon_calendar@2x.png
var icon_calendar_2x = __webpack_require__(918);
var icon_calendar_2x_default = /*#__PURE__*/__webpack_require__.n(icon_calendar_2x);

// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary02PickupTime/OrderSummary02PickupTime.js
function OrderSummary02PickupTime__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary02PickupTime__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary02PickupTime__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary02PickupTime__typeof(obj); }

var OrderSummary02PickupTime_REACT_ELEMENT_TYPE;

function OrderSummary02PickupTime__jsx(type, props, key, children) { if (!OrderSummary02PickupTime_REACT_ELEMENT_TYPE) { OrderSummary02PickupTime_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary02PickupTime_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary02PickupTime__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary02PickupTime__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary02PickupTime__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary02PickupTime__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary02PickupTime__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary02PickupTime__possibleConstructorReturn(self, call) { if (call && (OrderSummary02PickupTime__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary02PickupTime__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OrderSummary02PickupTime_OrderSummary02PickupTime =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary02PickupTime__inherits(OrderSummary02PickupTime, _React$Component);

  function OrderSummary02PickupTime() {
    OrderSummary02PickupTime__classCallCheck(this, OrderSummary02PickupTime);

    return OrderSummary02PickupTime__possibleConstructorReturn(this, (OrderSummary02PickupTime.__proto__ || Object.getPrototypeOf(OrderSummary02PickupTime)).apply(this, arguments));
  }

  OrderSummary02PickupTime__createClass(OrderSummary02PickupTime, [{
    key: "render",
    value: function render() {
      return OrderSummary02PickupTime__jsx("div", {
        className: "".concat(style_default.a.sectionPickupTime)
      }, void 0, OrderSummary02PickupTime__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.pick_up_time_title), OrderSummary02PickupTime__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary02PickupTime__jsx("div", {}, void 0, OrderSummary02PickupTime__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_calendar_default.a, " 1x, ").concat(icon_calendar_2x_default.a, " 2x"),
        width: "24",
        alt: "user"
      }), OrderSummary02PickupTime__jsx("span", {}, void 0, this.props.value)));
    }
  }]);

  return OrderSummary02PickupTime;
}(react_default.a.Component);

var OrderSummary02PickupTime_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail
  };
};

/* harmony default export */ var OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime = (Object(es["b" /* connect */])(OrderSummary02PickupTime_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary02PickupTime_OrderSummary02PickupTime)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary03Vehicle/OrderSummary03Vehicle.js
function OrderSummary03Vehicle__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary03Vehicle__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary03Vehicle__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary03Vehicle__typeof(obj); }

var OrderSummary03Vehicle_REACT_ELEMENT_TYPE;

function OrderSummary03Vehicle__jsx(type, props, key, children) { if (!OrderSummary03Vehicle_REACT_ELEMENT_TYPE) { OrderSummary03Vehicle_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary03Vehicle_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary03Vehicle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary03Vehicle__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary03Vehicle__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary03Vehicle__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary03Vehicle__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary03Vehicle__possibleConstructorReturn(self, call) { if (call && (OrderSummary03Vehicle__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary03Vehicle__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary03Vehicle_OrderSummary03Vehicle =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary03Vehicle__inherits(OrderSummary03Vehicle, _React$Component);

  function OrderSummary03Vehicle() {
    OrderSummary03Vehicle__classCallCheck(this, OrderSummary03Vehicle);

    return OrderSummary03Vehicle__possibleConstructorReturn(this, (OrderSummary03Vehicle.__proto__ || Object.getPrototypeOf(OrderSummary03Vehicle)).apply(this, arguments));
  }

  OrderSummary03Vehicle__createClass(OrderSummary03Vehicle, [{
    key: "render",
    value: function render() {
      return OrderSummary03Vehicle__jsx("div", {
        className: "".concat(style_default.a.summaryVehicle)
      }, void 0, OrderSummary03Vehicle__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_vehicle_title), OrderSummary03Vehicle__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary03Vehicle__jsx("span", {}, void 0, this.props.modelData !== '' ? this.props.modelDataText["order_vehicle_type_".concat(this.props.orderDetailInfo.vehicle)] : this.props.modelDataText["order_vehicle_type_".concat(this.props.orderDetailInfo.vehicle)]));
    }
  }]);

  return OrderSummary03Vehicle;
}(react_default.a.Component);

Object.defineProperty(OrderSummary03Vehicle_OrderSummary03Vehicle, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    modelData: {}
  }
});

var OrderSummary03Vehicle_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary03Vehicle_OrderSummary03Vehicle = (Object(es["b" /* connect */])(OrderSummary03Vehicle_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary03Vehicle_OrderSummary03Vehicle)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary04Passenger/OrderSummary04Passenger.js
function OrderSummary04Passenger__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary04Passenger__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary04Passenger__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary04Passenger__typeof(obj); }

var OrderSummary04Passenger_REACT_ELEMENT_TYPE;

function OrderSummary04Passenger__jsx(type, props, key, children) { if (!OrderSummary04Passenger_REACT_ELEMENT_TYPE) { OrderSummary04Passenger_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary04Passenger_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary04Passenger__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary04Passenger__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary04Passenger__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary04Passenger__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary04Passenger__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary04Passenger__possibleConstructorReturn(self, call) { if (call && (OrderSummary04Passenger__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary04Passenger__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary04Passenger_OrderSummary04Passenger =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary04Passenger__inherits(OrderSummary04Passenger, _React$Component);

  function OrderSummary04Passenger() {
    OrderSummary04Passenger__classCallCheck(this, OrderSummary04Passenger);

    return OrderSummary04Passenger__possibleConstructorReturn(this, (OrderSummary04Passenger.__proto__ || Object.getPrototypeOf(OrderSummary04Passenger)).apply(this, arguments));
  }

  OrderSummary04Passenger__createClass(OrderSummary04Passenger, [{
    key: "render",
    value: function render() {
      return OrderSummary04Passenger__jsx("div", {
        className: "".concat(style_default.a.summaryTunnel)
      }, void 0, OrderSummary04Passenger__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_option_passenger_title), OrderSummary04Passenger__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary04Passenger__jsx("span", {}, void 0, this.props.orderDetailInfo.order_request_detail_attributes.passenger_count));
    }
  }]);

  return OrderSummary04Passenger;
}(react_default.a.Component);

var OrderSummary04Passenger_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary04Passenger_OrderSummary04Passenger = (Object(es["b" /* connect */])(OrderSummary04Passenger_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary04Passenger_OrderSummary04Passenger)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary05Tunnel/OrderSummary05Tunnel.js
function OrderSummary05Tunnel__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary05Tunnel__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary05Tunnel__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary05Tunnel__typeof(obj); }

var OrderSummary05Tunnel_REACT_ELEMENT_TYPE;

function OrderSummary05Tunnel__jsx(type, props, key, children) { if (!OrderSummary05Tunnel_REACT_ELEMENT_TYPE) { OrderSummary05Tunnel_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary05Tunnel_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary05Tunnel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary05Tunnel__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary05Tunnel__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary05Tunnel__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary05Tunnel__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary05Tunnel__possibleConstructorReturn(self, call) { if (call && (OrderSummary05Tunnel__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary05Tunnel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary05Tunnel_OrderSummary05Tunnel =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary05Tunnel__inherits(OrderSummary05Tunnel, _React$Component);

  function OrderSummary05Tunnel() {
    OrderSummary05Tunnel__classCallCheck(this, OrderSummary05Tunnel);

    return OrderSummary05Tunnel__possibleConstructorReturn(this, (OrderSummary05Tunnel.__proto__ || Object.getPrototypeOf(OrderSummary05Tunnel)).apply(this, arguments));
  }

  OrderSummary05Tunnel__createClass(OrderSummary05Tunnel, [{
    key: "render",
    value: function render() {
      return OrderSummary05Tunnel__jsx("div", {
        className: "".concat(style_default.a.summaryPassenger)
      }, void 0, OrderSummary05Tunnel__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_option_tunnel_title), OrderSummary05Tunnel__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary05Tunnel__jsx("span", {}, void 0, this.props.modelDataText["order_option_tunnel_".concat(this.props.orderDetailInfo.tunnel)]));
    }
  }]);

  return OrderSummary05Tunnel;
}(react_default.a.Component);

var OrderSummary05Tunnel_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary05Tunnel_OrderSummary05Tunnel = (Object(es["b" /* connect */])(OrderSummary05Tunnel_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary05Tunnel_OrderSummary05Tunnel)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary06Remark/OrderSummary06Remark.js
function OrderSummary06Remark__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary06Remark__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary06Remark__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary06Remark__typeof(obj); }

var OrderSummary06Remark_REACT_ELEMENT_TYPE;

function OrderSummary06Remark__jsx(type, props, key, children) { if (!OrderSummary06Remark_REACT_ELEMENT_TYPE) { OrderSummary06Remark_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary06Remark_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary06Remark__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary06Remark__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary06Remark__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary06Remark__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary06Remark__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary06Remark__possibleConstructorReturn(self, call) { if (call && (OrderSummary06Remark__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary06Remark__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary06Remark__ref = OrderSummary06Remark__jsx("br", {});

var OrderSummary06Remark_OrderSummary06Remark =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary06Remark__inherits(OrderSummary06Remark, _React$Component);

  function OrderSummary06Remark() {
    OrderSummary06Remark__classCallCheck(this, OrderSummary06Remark);

    return OrderSummary06Remark__possibleConstructorReturn(this, (OrderSummary06Remark.__proto__ || Object.getPrototypeOf(OrderSummary06Remark)).apply(this, arguments));
  }

  OrderSummary06Remark__createClass(OrderSummary06Remark, [{
    key: "render",
    value: function render() {
      return OrderSummary06Remark__jsx("div", {
        className: "".concat(style_default.a.summaryRemark)
      }, void 0, OrderSummary06Remark__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.currentLocale === 'ko-KR' ? this.props.modelDataText.order_summary_remark_title_show : this.props.modelDataText.order_summary_remark_title), OrderSummary06Remark__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary06Remark__jsx("p", {}, void 0, this.props.value.map(function (v, i) {
        return OrderSummary06Remark__jsx("span", {}, i.toString(), v, OrderSummary06Remark__ref);
      })), OrderSummary06Remark__jsx("div", {
        className: Order_default.a.summaryGoodsImages
      }, void 0, this.props.images.filter(function (i) {
        return Object.keys(i).length > 0;
      }).map(function (i, index) {
        return OrderSummary06Remark__jsx("div", {
          className: Order_default.a.summaryGoodsImage
        }, index.toString(), OrderSummary06Remark__jsx("img", {
          style: {
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: "url(".concat(i.base64, ")")
          },
          width: "100",
          height: "100",
          alt: ""
        }));
      })));
    }
  }]);

  return OrderSummary06Remark;
}(react_default.a.Component);

Object.defineProperty(OrderSummary06Remark_OrderSummary06Remark, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    value: [],
    images: []
  }
});

var OrderSummary06Remark_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary06Remark_OrderSummary06Remark = (Object(es["b" /* connect */])(OrderSummary06Remark_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary06Remark_OrderSummary06Remark)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary07SenderInfo/OrderSummary07SenderInfo.js
function OrderSummary07SenderInfo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary07SenderInfo__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary07SenderInfo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary07SenderInfo__typeof(obj); }

var OrderSummary07SenderInfo_REACT_ELEMENT_TYPE;

function OrderSummary07SenderInfo__jsx(type, props, key, children) { if (!OrderSummary07SenderInfo_REACT_ELEMENT_TYPE) { OrderSummary07SenderInfo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary07SenderInfo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary07SenderInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary07SenderInfo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary07SenderInfo__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary07SenderInfo__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary07SenderInfo__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary07SenderInfo__possibleConstructorReturn(self, call) { if (call && (OrderSummary07SenderInfo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary07SenderInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var OrderSummary07SenderInfo_OrderSummary07SenderInfo =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary07SenderInfo__inherits(OrderSummary07SenderInfo, _React$Component);

  function OrderSummary07SenderInfo() {
    OrderSummary07SenderInfo__classCallCheck(this, OrderSummary07SenderInfo);

    return OrderSummary07SenderInfo__possibleConstructorReturn(this, (OrderSummary07SenderInfo.__proto__ || Object.getPrototypeOf(OrderSummary07SenderInfo)).apply(this, arguments));
  }

  OrderSummary07SenderInfo__createClass(OrderSummary07SenderInfo, [{
    key: "render",
    value: function render() {
      return OrderSummary07SenderInfo__jsx("div", {
        className: "".concat(style_default.a.summarySender)
      }, void 0, OrderSummary07SenderInfo__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_title), OrderSummary07SenderInfo__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary07SenderInfo__jsx("div", {
        className: "".concat(style_default.a.summarySender)
      }, void 0, OrderSummary07SenderInfo__jsx("p", {}, void 0, OrderSummary07SenderInfo__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        alt: "user"
      }), OrderSummary07SenderInfo__jsx("span", {}, void 0, this.props.orderDetailInfo.nickname)), OrderSummary07SenderInfo__jsx("p", {}, void 0, OrderSummary07SenderInfo__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        alt: "phone"
      }), OrderSummary07SenderInfo__jsx("span", {}, void 0, this.props.orderDetailInfo.phone_number)), OrderSummary07SenderInfo__jsx("p", {}, void 0, OrderSummary07SenderInfo__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_mail_default.a, " 1x, ").concat(icon_mail_2x_default.a, " 2x"),
        width: "24",
        alt: "email"
      }), OrderSummary07SenderInfo__jsx("span", {}, void 0, this.props.orderDetailInfo.order_request_extra_attributes.email_address))));
    }
  }]);

  return OrderSummary07SenderInfo;
}(react_default.a.Component);

var OrderSummary07SenderInfo_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo = (Object(es["b" /* connect */])(OrderSummary07SenderInfo_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary07SenderInfo_OrderSummary07SenderInfo)));
// EXTERNAL MODULE: ./src/components/Dialog/bonusPriceDialog.js
var bonusPriceDialog = __webpack_require__(913);

// EXTERNAL MODULE: ./src/assets/src/scripts/gogovan/order/hk/en-hk.json
var en_hk = __webpack_require__(921);
var en_hk_default = /*#__PURE__*/__webpack_require__.n(en_hk);

// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary11Fee/OrderSummary11Fee.js
function OrderSummary11Fee__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary11Fee__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary11Fee__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary11Fee__typeof(obj); }

var OrderSummary11Fee_REACT_ELEMENT_TYPE;

function OrderSummary11Fee__jsx(type, props, key, children) { if (!OrderSummary11Fee_REACT_ELEMENT_TYPE) { OrderSummary11Fee_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary11Fee_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary11Fee__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary11Fee__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary11Fee__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary11Fee__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary11Fee__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary11Fee__possibleConstructorReturn(self, call) { if (call && (OrderSummary11Fee__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary11Fee__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var tips = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var tips2 = [0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

var OrderSummary11Fee__ref = OrderSummary11Fee__jsx("br", {});

var OrderSummary11Fee__ref2 = OrderSummary11Fee__jsx("br", {});

var OrderSummary11Fee__ref3 = OrderSummary11Fee__jsx("br", {});

var OrderSummary11Fee__ref4 = OrderSummary11Fee__jsx("br", {});

var _ref5 = OrderSummary11Fee__jsx(bonusPriceDialog["a" /* default */], {});

var OrderSummary11Fee_OrderSummary11Fee =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary11Fee__inherits(OrderSummary11Fee, _React$Component);

  function OrderSummary11Fee(props) {
    var _this;

    OrderSummary11Fee__classCallCheck(this, OrderSummary11Fee);

    _this = OrderSummary11Fee__possibleConstructorReturn(this, (OrderSummary11Fee.__proto__ || Object.getPrototypeOf(OrderSummary11Fee)).call(this, props));
    _this.state = {
      selectFee: 0,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      isKorea: ['kr'].includes(props.currentLocale.split('-')[1].toLowerCase()),
      price: props.orderPriceBreakdownDetail.total
    };
    return _this;
  }

  OrderSummary11Fee__createClass(OrderSummary11Fee, [{
    key: "getTips",
    value: function getTips() {
      if (this.state.lang === 'tw') {
        return tips.map(function (x) {
          return x * 2;
        });
      } else if (this.state.lang === 'sg') {
        return tips.map(function (x) {
          return x / 5;
        });
      } else if (this.state.lang === 'kr') {
        return tips2.map(function (x) {
          return x * 200;
        });
      }

      return tips;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return OrderSummary11Fee__jsx("div", {}, void 0, OrderSummary11Fee__jsx("div", {
        className: Order_default.a.fee
      }, void 0, OrderSummary11Fee__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_charge_title), OrderSummary11Fee__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary11Fee__jsx("span", {}, void 0, typeof this.props.orderPriceBreakdownDetail.breakdown !== 'undefined' ? Object.keys(this.props.orderPriceBreakdownDetail.breakdown).map(function (v, index) {
        return OrderSummary11Fee__jsx("div", {}, index.toString(), OrderSummary11Fee__jsx("span", {}, void 0, _this2.props.orderPriceBreakdownDetail.breakdown[v].title), OrderSummary11Fee__jsx("span", {
          className: Order_default.a.right
        }, void 0, typeof _this2.props.orderPriceBreakdownDetail.breakdown[v].value === 'number' ? !_this2.state.isKorea ? "".concat(_this2.props.modelDataText.dollar_code, " ").concat(_this2.props.orderPriceBreakdownDetail.breakdown[v].value) : "".concat(_this2.props.orderPriceBreakdownDetail.breakdown[v].value, " ").concat(_this2.props.modelDataText.dollar_code) : ''));
      }) : ''), OrderSummary11Fee__jsx("div", {
        className: "".concat(style_default.a.sectionOrderPrice),
        style: {
          float: 'left'
        }
      }, void 0, OrderSummary11Fee__jsx("span", {
        style: {
          paddingTop: '8px'
        }
      }, void 0, Object(util["d" /* returnLocaleText */])(this.props.modelDataText.order_summary_charge_tips, en_hk_default.a.order.order_summary_charge_tips)), OrderSummary11Fee__jsx("span", {
        className: "".concat(Order_default.a.functionText, " ").concat(style_default.a.globalTextBlue),
        style: {
          fontSize: '12px',
          cursor: 'pointer'
        },
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          _this2.props.setIsShowBonusPriceDialog();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, Object(util["d" /* returnLocaleText */])(this.props.modelDataText.order_summary_charge_why_tips_button, en_hk_default.a.order.order_summary_charge_why_tips_button))), OrderSummary11Fee__jsx("span", {
        className: style_default.a.orderPricingBonusPrice,
        style: {
          float: 'right'
        }
      }, void 0, OrderSummary11Fee__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " col-12"),
        style: {
          paddingRight: '5px'
        },
        onChange: function onChange(e) {
          _this2.setState({
            selectFee: parseInt(e.target.value, 10)
          });

          _this2.props.updateOrderDetailInfoAction('bonus', null, parseInt(e.target.value, 10));
        }
      }, void 0, this.getTips().map(function (i) {
        return OrderSummary11Fee__jsx("option", {
          value: i
        }, i, _this2.state.isKorea ? "".concat(i, " ").concat(_this2.props.modelDataText.dollar_code) : "".concat(_this2.props.modelDataText.dollar_code, " ").concat(i));
      })))), OrderSummary11Fee__ref, OrderSummary11Fee__ref2, OrderSummary11Fee__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, OrderSummary11Fee__jsx("hr", {
        style: {
          border: '1px solid #000',
          marginTop: 0
        }
      }), OrderSummary11Fee__jsx(reactstrap_es["n" /* Row */], {}, void 0, OrderSummary11Fee__jsx(reactstrap_es["b" /* Col */], {
        className: Order_default.a.orderPricingTotal
      }, void 0, OrderSummary11Fee__jsx("span", {}, void 0, this.props.modelDataText.price_total_amount)), OrderSummary11Fee__jsx(reactstrap_es["b" /* Col */], {
        className: Order_default.a.orderPricingTotalPrice
      }, void 0, OrderSummary11Fee__jsx("span", {}, void 0, this.state.isKorea ? '' : this.props.modelDataText.dollar_code, this.state.price + this.state.selectFee, this.state.isKorea ? this.props.modelDataText.dollar_code : '')))), OrderSummary11Fee__ref3, OrderSummary11Fee__ref4, OrderSummary11Fee__jsx("p", {
        className: style_default.a.globalTextRed
      }, void 0, OrderSummary11Fee__jsx("small", {}, void 0, Object(util["d" /* returnLocaleText */])(this.props.modelDataText.order_summary_payment_message, en_hk_default.a.order.order_summary_payment_message))), OrderSummary11Fee__jsx("small", {}, void 0, OrderSummary11Fee__jsx("a", {
        href: "/pricing",
        target: "blank",
        className: style_default.a.globalTextBlue
      }, void 0, Object(util["d" /* returnLocaleText */])(this.props.modelDataText.order_summary_payment_price_table_button, en_hk_default.a.order.order_summary_payment_price_table_button))), _ref5);
    }
  }]);

  return OrderSummary11Fee;
}(react_default.a.Component);

var OrderSummary11Fee_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var OrderSummary11Fee_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var OrderSummary_OrderSummary11Fee_OrderSummary11Fee = (Object(es["b" /* connect */])(OrderSummary11Fee_mapState, OrderSummary11Fee_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary11Fee_OrderSummary11Fee)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary13Payment/OrderSummary13Payment.js
function OrderSummary13Payment__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary13Payment__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary13Payment__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary13Payment__typeof(obj); }

var OrderSummary13Payment_REACT_ELEMENT_TYPE;

function OrderSummary13Payment__jsx(type, props, key, children) { if (!OrderSummary13Payment_REACT_ELEMENT_TYPE) { OrderSummary13Payment_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary13Payment_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary13Payment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary13Payment__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary13Payment__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary13Payment__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary13Payment__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary13Payment__possibleConstructorReturn(self, call) { if (call && (OrderSummary13Payment__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary13Payment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary13Payment_OrderSummary13Payment =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary13Payment__inherits(OrderSummary13Payment, _React$Component);

  function OrderSummary13Payment() {
    OrderSummary13Payment__classCallCheck(this, OrderSummary13Payment);

    return OrderSummary13Payment__possibleConstructorReturn(this, (OrderSummary13Payment.__proto__ || Object.getPrototypeOf(OrderSummary13Payment)).apply(this, arguments));
  }

  OrderSummary13Payment__createClass(OrderSummary13Payment, [{
    key: "render",
    value: function render() {
      return OrderSummary13Payment__jsx("div", {
        className: "".concat(style_default.a.summaryPPassenger)
      }, void 0, OrderSummary13Payment__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_payment_title), OrderSummary13Payment__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary13Payment__jsx("span", {}, void 0, this.props.modelDataText.order_summary_payment_method));
    }
  }]);

  return OrderSummary13Payment;
}(react_default.a.Component);

var OrderSummary13Payment_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary13Payment_OrderSummary13Payment = (Object(es["b" /* connect */])(OrderSummary13Payment_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary13Payment_OrderSummary13Payment)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/hkOrderSummary.js
function hkOrderSummary__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hkOrderSummary__typeof = function _typeof(obj) { return typeof obj; }; } else { hkOrderSummary__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hkOrderSummary__typeof(obj); }

var hkOrderSummary_REACT_ELEMENT_TYPE;

function hkOrderSummary__jsx(type, props, key, children) { if (!hkOrderSummary_REACT_ELEMENT_TYPE) { hkOrderSummary_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: hkOrderSummary_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function hkOrderSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hkOrderSummary__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function hkOrderSummary__createClass(Constructor, protoProps, staticProps) { if (protoProps) hkOrderSummary__defineProperties(Constructor.prototype, protoProps); if (staticProps) hkOrderSummary__defineProperties(Constructor, staticProps); return Constructor; }

function hkOrderSummary__possibleConstructorReturn(self, call) { if (call && (hkOrderSummary__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function hkOrderSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var hkOrderSummary__ref = hkOrderSummary__jsx("br", {});

var hkOrderSummary_hkOrderSummary =
/*#__PURE__*/
function (_React$Component) {
  hkOrderSummary__inherits(hkOrderSummary, _React$Component);

  function hkOrderSummary() {
    hkOrderSummary__classCallCheck(this, hkOrderSummary);

    return hkOrderSummary__possibleConstructorReturn(this, (hkOrderSummary.__proto__ || Object.getPrototypeOf(hkOrderSummary)).apply(this, arguments));
  }

  hkOrderSummary__createClass(hkOrderSummary, [{
    key: "render",
    value: function render() {
      return hkOrderSummary__jsx("div", {
        className: "".concat(Order_default.a.orderSummary),
        style: {
          display: 'block'
        }
      }, void 0, hkOrderSummary__jsx("section", {
        className: Order_default.a.orderSummary
      }, void 0, hkOrderSummary__jsx("div", {}, void 0, hkOrderSummary__jsx("h2", {}, void 0, this.props.modelDataText.order_summary_title))), hkOrderSummary__jsx(OrderSummary_OrderSummary01Route_OrderSummary01Route, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime, {
        modelDataText: this.props.modelDataText,
        value: dateformat_default()(this.props.orderDetailInfo.pickup_time, 'dd mmmm, yyyy ,HH:MM')
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary03Vehicle_OrderSummary03Vehicle, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary04Passenger_OrderSummary04Passenger, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary05Tunnel_OrderSummary05Tunnel, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary06Remark_OrderSummary06Remark, {
        modelDataText: this.props.modelDataText,
        value: [this.props.orderDetailInfo.order_request_detail_attributes.remark]
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary11Fee_OrderSummary11Fee, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__jsx(OrderSummary_OrderSummary13Payment_OrderSummary13Payment, {
        modelDataText: this.props.modelDataText
      }), hkOrderSummary__ref, hkOrderSummary__jsx(OrderSummary_OrderSummarySumbitButton, {
        modelDataText: this.props.modelDataText,
        onClickConfirm: this.props.onClickConfirm
      }));
    }
  }]);

  return hkOrderSummary;
}(react_default.a.Component);

var hkOrderSummary_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var hkOrderSummary_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var OrderSummary_hkOrderSummary = (Object(es["b" /* connect */])(hkOrderSummary_mapState, hkOrderSummary_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(hkOrderSummary_hkOrderSummary)));
// CONCATENATED MODULE: ./src/components/Dialog/extraMessageDialog.js
function extraMessageDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { extraMessageDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { extraMessageDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return extraMessageDialog__typeof(obj); }

var extraMessageDialog_REACT_ELEMENT_TYPE;

function extraMessageDialog__jsx(type, props, key, children) { if (!extraMessageDialog_REACT_ELEMENT_TYPE) { extraMessageDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: extraMessageDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function extraMessageDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function extraMessageDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function extraMessageDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) extraMessageDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) extraMessageDialog__defineProperties(Constructor, staticProps); return Constructor; }

function extraMessageDialog__possibleConstructorReturn(self, call) { if (call && (extraMessageDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function extraMessageDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var extraMessageDialog__ref = extraMessageDialog__jsx("br", {});

var extraMessageDialog_extraMessageDialog =
/*#__PURE__*/
function (_React$Component) {
  extraMessageDialog__inherits(extraMessageDialog, _React$Component);

  function extraMessageDialog(props) {
    var _this;

    extraMessageDialog__classCallCheck(this, extraMessageDialog);

    _this = extraMessageDialog__possibleConstructorReturn(this, (extraMessageDialog.__proto__ || Object.getPrototypeOf(extraMessageDialog)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    return _this;
  }

  extraMessageDialog__createClass(extraMessageDialog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var message = [];

      if (this.props.message !== '') {
        message = this.props.message.toString().replace(/\u21B5/g, '&lt;br &gt;').toString().split('\n');
      }

      return extraMessageDialog__jsx("div", {
        id: "blacklist"
      }, void 0, extraMessageDialog__jsx(reactstrap_es["k" /* Modal */], {
        size: "lg",
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this2.props.setIsShowExtraMessageDialog();
        }
      }, void 0, extraMessageDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.orderCancelcloseRightButton),
        onClick: function onClick() {
          _this2.props.setIsShowExtraMessageDialog();
        }
      }), extraMessageDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.infoContainer, " ").concat(dialog_default.a.orderCancelContainer),
        style: {
          padding: 0
        }
      }, void 0, extraMessageDialog__jsx("div", {
        className: dialog_default.a.infoContent
      }, void 0, message.map(function (i, index) {
        return extraMessageDialog__jsx("span", {}, index.toString(), ' ', i, " ", extraMessageDialog__ref);
      }), extraMessageDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " "),
        style: {
          width: '40%',
          float: 'right'
        },
        onClick: function onClick() {
          _this2.props.setIsShowExtraMessageDialog();
        }
      }, void 0, this.state.modelDataLocale.error_wrong_modal_okay_btn)))));
    }
  }]);

  return extraMessageDialog;
}(react_default.a.Component);

Object.defineProperty(extraMessageDialog_extraMessageDialog, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    message: ''
  }
});

var extraMessageDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.dialog.isShowExtraMessageDialog
  };
};

var extraMessageDialog_mapDispatch = {
  setIsShowExtraMessageDialog: actions_dialog["e" /* setIsShowExtraMessageDialog */]
};
/* harmony default export */ var Dialog_extraMessageDialog = (Object(es["b" /* connect */])(extraMessageDialog_mapState, extraMessageDialog_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(extraMessageDialog_extraMessageDialog)));
// CONCATENATED MODULE: ./src/routes/order/hkOrder.js
function hkOrder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hkOrder__typeof = function _typeof(obj) { return typeof obj; }; } else { hkOrder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hkOrder__typeof(obj); }

var hkOrder_REACT_ELEMENT_TYPE;

function hkOrder__jsx(type, props, key, children) { if (!hkOrder_REACT_ELEMENT_TYPE) { hkOrder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: hkOrder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function hkOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hkOrder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function hkOrder__createClass(Constructor, protoProps, staticProps) { if (protoProps) hkOrder__defineProperties(Constructor.prototype, protoProps); if (staticProps) hkOrder__defineProperties(Constructor, staticProps); return Constructor; }

function hkOrder__possibleConstructorReturn(self, call) { if (call && (hkOrder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function hkOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import






 // import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import





















var hkOrder_hkOrder =
/*#__PURE__*/
function (_React$Component) {
  hkOrder__inherits(hkOrder, _React$Component);

  function hkOrder() {
    hkOrder__classCallCheck(this, hkOrder);

    return hkOrder__possibleConstructorReturn(this, (hkOrder.__proto__ || Object.getPrototypeOf(hkOrder)).apply(this, arguments));
  }

  hkOrder__createClass(hkOrder, [{
    key: "render",
    value: function render() {
      // Process the dataModel first before the template rendering
      return hkOrder__jsx("div", {
        className: "".concat(Order_default.a.orderPage)
      }, void 0, hkOrder__jsx("div", {
        className: "".concat(Order_default.a.fixedContainer)
      }, void 0, hkOrder__jsx(lib_slidedown["SlideDown"], {
        closed: !this.props.isShowOrderDetail
      }, void 0, this.props.isShowOrderDetail ? hkOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, hkOrder__jsx(OrderSummary_hkOrderSummary, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm,
        modelData: this.props.modelData
      })) : ''), hkOrder__jsx(lib_slidedown["SlideDown"], {
        closed: this.props.isShowOrderDetail
      }, void 0, hkOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, hkOrder__jsx("h2", {
        className: Order_default.a.headline
      }, void 0, this.props.modelDataText.order.order_headline), hkOrder__jsx("hr", {
        className: Order_default.a.hrTitle
      }), hkOrder__jsx(order_Order01SelectVehicle_Order01SelectVehicle, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), hkOrder__jsx(reactstrap_es["n" /* Row */], {}, void 0, hkOrder__jsx(order_Order03Pessenger_Order03Pessenger, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), hkOrder__jsx(order_Order04Tunnel_Order04Tunnel, {
        modelData: this.props.modelData.order_model_data
      })), hkOrder__jsx(order09Path_Order09Path, {
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), hkOrder__jsx(order_Order10PickupTime_Order10PickupTime, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), hkOrder__jsx(order_Order12AddService_Order12AddService, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), hkOrder__jsx(order_Order14ContactInfo_Order14ContactInfo, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), hkOrder__jsx(order_Order13Remarks_Order13Remarks, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        fieldParentName: "order_request_detail_attributes",
        fieldChildName: "remark"
      }), hkOrder__jsx(order_Order18AddPhoto_Order18AddPhoto, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), hkOrder__jsx("hr", {
        className: Order_default.a.hrTotalPrice
      }), hkOrder__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, hkOrder__jsx(order_Order19Total_Order19Total, {
        modelDataText: this.props.modelDataText.order
      }), hkOrder__jsx(order_Order20Coupon_Order20Coupon, {
        modelDataText: this.props.modelDataText.order
      })), hkOrder__jsx(order_Order21Confirm_Order21Confirm, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm
      })))), hkOrder__jsx(Dialog_extraMessageDialog, {
        message: this.props.orderPriceBreakdownDetail.extra_message
      }));
    }
  }]);

  return hkOrder;
}(react_default.a.Component);

var hkOrder_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images
  };
};

var hkOrder_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var order_hkOrder = (Object(es["b" /* connect */])(hkOrder_mapState, hkOrder_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(hkOrder_hkOrder)));
// CONCATENATED MODULE: ./src/routes/order/Order14ContactInfo/Order14ContactInfoWithTW.js
var Order14ContactInfoWithTW_REACT_ELEMENT_TYPE;

function Order14ContactInfoWithTW__jsx(type, props, key, children) { if (!Order14ContactInfoWithTW_REACT_ELEMENT_TYPE) { Order14ContactInfoWithTW_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order14ContactInfoWithTW_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order14ContactInfoWithTW__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order14ContactInfoWithTW__typeof = function _typeof(obj) { return typeof obj; }; } else { Order14ContactInfoWithTW__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order14ContactInfoWithTW__typeof(obj); }

function Order14ContactInfoWithTW__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order14ContactInfoWithTW__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order14ContactInfoWithTW__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order14ContactInfoWithTW__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order14ContactInfoWithTW__defineProperties(Constructor, staticProps); return Constructor; }

function Order14ContactInfoWithTW__possibleConstructorReturn(self, call) { if (call && (Order14ContactInfoWithTW__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order14ContactInfoWithTW__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order14ContactInfoWithTW__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import












var Order14ContactInfoWithTW_Order14ContactInfoWithTW =
/*#__PURE__*/
function (_React$Component) {
  Order14ContactInfoWithTW__inherits(Order14ContactInfoWithTW, _React$Component);

  function Order14ContactInfoWithTW(props) {
    var _this;

    Order14ContactInfoWithTW__classCallCheck(this, Order14ContactInfoWithTW);

    _this = Order14ContactInfoWithTW__possibleConstructorReturn(this, (Order14ContactInfoWithTW.__proto__ || Object.getPrototypeOf(Order14ContactInfoWithTW)).call(this, props));
    _this.state = {
      name: Object(auth["b" /* getAuth */])().username,
      phone: Object(auth["b" /* getAuth */])().phone,
      phoneExt: '',
      receiverPhone: '',
      receiverName: '',
      isValidName: true,
      isValidPhone: true,
      isValidReceiverName: true,
      isValidReceiverPhone: true,
      scrollToComponent: null
    };
    _this.setScrollToComponent = _this.setScrollToComponent.bind(Order14ContactInfoWithTW__assertThisInitialized(_this));
    _this.scrollToAndReturnIsValid = _this.scrollToAndReturnIsValid.bind(Order14ContactInfoWithTW__assertThisInitialized(_this));
    return _this;
  }

  Order14ContactInfoWithTW__createClass(Order14ContactInfoWithTW, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollToComponent();
      this.onChangeName(Object(auth["b" /* getAuth */])().username);
      this.onChangePhone(Object(auth["b" /* getAuth */])().phone);
      this.props.updateOrderDetailInfoAction('phone_number', null, Object(auth["b" /* getAuth */])().phone);
      this.props.updateOrderDetailInfoAction('nickname', null, Object(auth["b" /* getAuth */])().username);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
        this.props.updateOrderDetailInfoAction('phone_number', null, this.state.phone);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', this.state.email);
        this.props.updateOrderDetailInfoAction('phone_number_ext', null, this.state.phoneExt);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'receiver_name', this.state.receiverName);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'receiver_phone_number', this.state.receiverPhone);

        if (this.state.name === '') {
          this.setState({
            isValidName: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidName: true
          });
        }

        var phonePatt = new RegExp(this.props.setting.PHONE_REGEX);

        if (!phonePatt.test(this.state.phone)) {
          this.setState({
            isValidPhone: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidPhone: true
          });
        }

        if (this.state.receiverName !== '' || this.state.receiverPhone !== '') {
          if (this.state.receiverName === '') {
            this.setState({
              isValidReceiverName: false
            });
            this.scrollToAndReturnIsValid();
          } else {
            this.setState({
              isValidReceiverName: true
            });
          }

          if (this.state.receiverPhone === '') {
            this.setState({
              isValidReceiverPhone: false
            });
            this.scrollToAndReturnIsValid();
          } else {
            this.setState({
              isValidReceiverPhone: true
            });
          }
        }
      }
    }
  }, {
    key: "onChangeName",
    value: function onChangeName(e) {
      if (Order14ContactInfoWithTW__typeof(e) === 'object') {
        this.setState({
          name: e.target.value
        });
      } else {
        this.setState({
          name: e
        });
      }
    }
  }, {
    key: "onChangePhone",
    value: function onChangePhone(e) {
      if (Order14ContactInfoWithTW__typeof(e) === 'object') {
        this.setState({
          phone: e.target.value
        });
      } else {
        this.setState({
          phone: e
        });
      }
    }
  }, {
    key: "onChangeReceiverName",
    value: function onChangeReceiverName(e) {
      if (Order14ContactInfoWithTW__typeof(e) === 'object') {
        this.setState({
          receiverName: e.target.value
        });
      } else {
        this.setState({
          receiverName: e
        });
      }
    }
  }, {
    key: "onChangeReceiverPhone",
    value: function onChangeReceiverPhone(e) {
      if (Order14ContactInfoWithTW__typeof(e) === 'object') {
        this.setState({
          receiverPhone: e.target.value
        });
      } else {
        this.setState({
          receiverPhone: e
        });
      }
    }
  }, {
    key: "onChangePhoneExt",
    value: function onChangePhoneExt(e) {
      if (Order14ContactInfoWithTW__typeof(e) === 'object') {
        this.setState({
          phoneExt: e.target.value
        });
      } else {
        this.setState({
          phoneExt: e
        });
      }
    }
  }, {
    key: "setScrollToComponent",
    value: function setScrollToComponent() {
      /* eslint-disable global-require */
      this.setState({
        scrollToComponent: __webpack_require__(919)
      });
    }
  }, {
    key: "scrollToAndReturnIsValid",
    value: function scrollToAndReturnIsValid() {
      this.props.setIsValidOrder(false);
      this.state.scrollToComponent(this.Order14ContactInfo, {
        offset: -100,
        duration: 500
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order14ContactInfoWithTW__jsx(reactstrap_es["c" /* Container */], {}, void 0, react_default.a.createElement("p", {
        ref: function ref(i) {
          _this2.Order14ContactInfo = i;
        }
      }), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {
        md: "5",
        xs: "12"
      }, void 0, Order14ContactInfoWithTW__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_title), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfoTop
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_nickname_input,
        value: this.state.name,
        onChange: function onChange(e) {
          _this2.onChangeName(e);
        }
      }), Order14ContactInfoWithTW__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "ppl"
      })), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfo
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {
        md: "9",
        xs: "9",
        style: {
          padding: 0
        }
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        style: {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          paddingRight: '20px'
        },
        placeholder: this.props.modelDataText.contact_info_phone_input,
        value: this.state.phone,
        onChange: function onChange(e) {
          _this2.onChangePhone(e);
        }
      }), Order14ContactInfoWithTW__jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "phone"
      })), Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {
        md: "3",
        xs: "3",
        style: {
          padding: 0
        }
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["i" /* Input */], {
        style: {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderLeft: '0px'
        },
        maxLength: "5",
        size: "5",
        placeholder: this.props.modelDataText.contact_info_phone_ext_input,
        value: this.state.phoneExt,
        onChange: function onChange(e) {
          _this2.onChangePhoneExt(e);
        }
      })))), Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: '5',
          offset: 1
        },
        xs: "12"
      }, void 0, Order14ContactInfoWithTW__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_receiver_title), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfoTop
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_nickname_input,
        value: this.state.receiverName,
        onChange: function onChange(e) {
          _this2.onChangeReceiverName(e);
        }
      }), Order14ContactInfoWithTW__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "ppl"
      })), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfo
      }, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_phone_input,
        value: this.state.receiverPhone,
        onChange: function onChange(e) {
          _this2.onChangeReceiverPhone(e);
        }
      }), Order14ContactInfoWithTW__jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "phone"
      })))), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfoWithTW__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_nickname_input_warning)), Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfoWithTW__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidReceiverName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_nickname_input_warning))), Order14ContactInfoWithTW__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfoWithTW__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidPhone ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_phone_input_warning)), Order14ContactInfoWithTW__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order14ContactInfoWithTW__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidReceiverPhone ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_phone_input_warning))));
    }
  }]);

  return Order14ContactInfoWithTW;
}(react_default.a.Component);

var Order14ContactInfoWithTW_mapState = function mapState(state) {
  return {
    user: state.user.user,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order14ContactInfoWithTW_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */]
};
/* harmony default export */ var Order14ContactInfo_Order14ContactInfoWithTW = (Object(es["b" /* connect */])(Order14ContactInfoWithTW_mapState, Order14ContactInfoWithTW_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order14ContactInfoWithTW_Order14ContactInfoWithTW)));
// EXTERNAL MODULE: ./src/assets/img/icon_home_address.png
var icon_home_address = __webpack_require__(1256);
var icon_home_address_default = /*#__PURE__*/__webpack_require__.n(icon_home_address);

// EXTERNAL MODULE: ./src/assets/img/icon_home_address@2x.png
var icon_home_address_2x = __webpack_require__(979);
var icon_home_address_2x_default = /*#__PURE__*/__webpack_require__.n(icon_home_address_2x);

// EXTERNAL MODULE: ./src/assets/img/icon_work_address.png
var icon_work_address = __webpack_require__(1314);
var icon_work_address_default = /*#__PURE__*/__webpack_require__.n(icon_work_address);

// EXTERNAL MODULE: ./src/assets/img/icon_work_address@2x.png
var icon_work_address_2x = __webpack_require__(981);
var icon_work_address_2x_default = /*#__PURE__*/__webpack_require__.n(icon_work_address_2x);

// CONCATENATED MODULE: ./src/routes/order/Order17InvoiceInfo/Order17InvoiceInfo.js
var Order17InvoiceInfo_REACT_ELEMENT_TYPE;

function Order17InvoiceInfo__jsx(type, props, key, children) { if (!Order17InvoiceInfo_REACT_ELEMENT_TYPE) { Order17InvoiceInfo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order17InvoiceInfo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order17InvoiceInfo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order17InvoiceInfo__typeof = function _typeof(obj) { return typeof obj; }; } else { Order17InvoiceInfo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order17InvoiceInfo__typeof(obj); }

function Order17InvoiceInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order17InvoiceInfo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order17InvoiceInfo__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order17InvoiceInfo__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order17InvoiceInfo__defineProperties(Constructor, staticProps); return Constructor; }

function Order17InvoiceInfo__possibleConstructorReturn(self, call) { if (call && (Order17InvoiceInfo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order17InvoiceInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order17InvoiceInfo__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import
















var Order17InvoiceInfo_Order17InvoiceInfo =
/*#__PURE__*/
function (_React$Component) {
  Order17InvoiceInfo__inherits(Order17InvoiceInfo, _React$Component);

  function Order17InvoiceInfo(props) {
    var _this;

    Order17InvoiceInfo__classCallCheck(this, Order17InvoiceInfo);

    _this = Order17InvoiceInfo__possibleConstructorReturn(this, (Order17InvoiceInfo.__proto__ || Object.getPrototypeOf(Order17InvoiceInfo)).call(this, props));
    _this.state = {
      email: Object(auth["b" /* getAuth */])().email,
      isValidCompanyID: true,
      isValidEmail: true,
      isValidEmailName: true,
      isValidEmailAndPostalAddress: true,
      scrollToComponent: null,
      emailName: '',
      emailCompanyID: '',
      postalAddress: ''
    };
    _this.setScrollToComponent = _this.setScrollToComponent.bind(Order17InvoiceInfo__assertThisInitialized(_this));
    _this.scrollToAndReturnIsValid = _this.scrollToAndReturnIsValid.bind(Order17InvoiceInfo__assertThisInitialized(_this));
    return _this;
  }

  Order17InvoiceInfo__createClass(Order17InvoiceInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollToComponent();
      this.onChangeEmail(Object(auth["b" /* getAuth */])().email);
      this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', Object(auth["b" /* getAuth */])().email);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        // this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', this.state.email);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_company_id', this.state.emailCompanyID);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'postal_address', this.state.postalAddress);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_name', this.state.emailName);

        if (this.state.emailName === '') {
          this.scrollToAndReturnIsValid();
          this.setState({
            isValidEmailName: false
          });
        } else {
          this.setState({
            isValidEmailName: true
          });
        }

        var emailPatt = new RegExp(this.props.setting.EMAIL_REGEX);

        if (!emailPatt.test(this.state.email)) {
          this.scrollToAndReturnIsValid();
          this.setState({
            isValidEmail: false
          });
        } else {
          this.setState({
            isValidEmail: true
          });
        }

        if (this.state.emailCompanyID !== '' && this.state.emailCompanyID.length < 8) {
          this.scrollToAndReturnIsValid();
          this.setState({
            isValidCompanyID: false
          });
        } else {
          this.setState({
            isValidCompanyID: true
          });
        }

        if (this.state.postalAddress === '' && this.state.email === '') {
          this.scrollToAndReturnIsValid();
          this.setState({
            isValidEmailAndPostalAddress: false
          });
        } else {
          this.setState({
            isValidEmailAndPostalAddress: true
          });
        }
      }
    }
  }, {
    key: "onChangeEmailName",
    value: function onChangeEmailName(e) {
      if (Order17InvoiceInfo__typeof(e) === 'object') {
        this.setState({
          emailName: e.target.value
        });
      } else {
        this.setState({
          emailName: e
        });
      }
    }
  }, {
    key: "onChangePostalAddress",
    value: function onChangePostalAddress(e) {
      if (Order17InvoiceInfo__typeof(e) === 'object') {
        this.setState({
          postalAddress: e.target.value
        });
      } else {
        this.setState({
          postalAddress: e
        });
      }
    }
  }, {
    key: "onChangeEmail",
    value: function onChangeEmail(e) {
      if (Order17InvoiceInfo__typeof(e) === 'object') {
        this.setState({
          email: e.target.value
        });
      } else {
        this.setState({
          email: e
        });
      }
    }
  }, {
    key: "onChangeEmailCompanyID",
    value: function onChangeEmailCompanyID(e) {
      if (Order17InvoiceInfo__typeof(e) === 'object') {
        this.setState({
          emailCompanyID: e.target.value
        });
      } else {
        this.setState({
          emailCompanyID: e
        });
      }
    }
  }, {
    key: "setScrollToComponent",
    value: function setScrollToComponent() {
      /* eslint-disable global-require */
      this.setState({
        scrollToComponent: __webpack_require__(919)
      });
    }
  }, {
    key: "scrollToAndReturnIsValid",
    value: function scrollToAndReturnIsValid() {
      this.props.setIsValidOrder(false);
      this.state.scrollToComponent(this.component, {
        offset: -100,
        duration: 500
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order17InvoiceInfo__jsx(reactstrap_es["c" /* Container */], {}, void 0, react_default.a.createElement("p", {
        ref: function ref(i) {
          _this2.component = i;
        }
      }), Order17InvoiceInfo__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.uniform_invoice_title), Order17InvoiceInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.uniform_invoice_email_name_input,
        value: this.state.emailName,
        onChange: function onChange(e) {
          _this2.onChangeEmailName(e);
        }
      }), Order17InvoiceInfo__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "ppl"
      }))), Order17InvoiceInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_email_input,
        value: this.state.email,
        onChange: function onChange(e) {
          _this2.onChangeEmail(e);
        }
      }), Order17InvoiceInfo__jsx("img", {
        srcSet: "".concat(icon_mail_default.a, " 1x, ").concat(icon_mail_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "email"
      }))), Order17InvoiceInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.uniform_invoice_postal_address_input,
        value: this.state.postalAddress,
        onChange: function onChange(e) {
          _this2.onChangePostalAddress(e);
        }
      }), Order17InvoiceInfo__jsx("img", {
        srcSet: "".concat(icon_home_address_default.a, " 1x, ").concat(icon_home_address_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "email"
      }))), Order17InvoiceInfo__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["b" /* Col */], {}, void 0, Order17InvoiceInfo__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.uniform_invoice_email_company_id_input,
        value: this.state.emailCompanyID,
        onChange: function onChange(e) {
          _this2.onChangeEmailCompanyID(e);
        }
      }), Order17InvoiceInfo__jsx("img", {
        srcSet: "".concat(icon_work_address_default.a, " 1x, ").concat(icon_work_address_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeft),
        alt: "email"
      }))), Order17InvoiceInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidEmailName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.uniform_invoice_email_name_input_warning), Order17InvoiceInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidCompanyID ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.uniform_invoice_email_company_id_input_warning), Order17InvoiceInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidEmail ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_email_input_warning), Order17InvoiceInfo__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidEmailAndPostalAddress ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.uniform_invoice_email_and_postal_address_input_emapty_warning));
    }
  }]);

  return Order17InvoiceInfo;
}(react_default.a.Component);

var Order17InvoiceInfo_mapState = function mapState(state) {
  return {
    user: state.user.user,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order17InvoiceInfo_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */]
};
/* harmony default export */ var order_Order17InvoiceInfo_Order17InvoiceInfo = (Object(es["b" /* connect */])(Order17InvoiceInfo_mapState, Order17InvoiceInfo_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order17InvoiceInfo_Order17InvoiceInfo)));
// CONCATENATED MODULE: ./src/routes/order/Order05Type/Order05Types.js
function Order05Types__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order05Types__typeof = function _typeof(obj) { return typeof obj; }; } else { Order05Types__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order05Types__typeof(obj); }

var Order05Types_REACT_ELEMENT_TYPE;

function Order05Types__jsx(type, props, key, children) { if (!Order05Types_REACT_ELEMENT_TYPE) { Order05Types_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order05Types_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order05Types__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order05Types__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order05Types__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order05Types__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order05Types__defineProperties(Constructor, staticProps); return Constructor; }

function Order05Types__possibleConstructorReturn(self, call) { if (call && (Order05Types__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order05Types__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import






var Order05Types_Order05Types =
/*#__PURE__*/
function (_React$Component) {
  Order05Types__inherits(Order05Types, _React$Component);

  function Order05Types() {
    Order05Types__classCallCheck(this, Order05Types);

    return Order05Types__possibleConstructorReturn(this, (Order05Types.__proto__ || Object.getPrototypeOf(Order05Types)).apply(this, arguments));
  }

  Order05Types__createClass(Order05Types, [{
    key: "onClickToggleType",
    value: function onClickToggleType(e) {
      this.props.updateOrderDetailInfoAction('goods', null, e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order05Types__jsx("div", {}, void 0, Order05Types__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05Types__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_goods_title)), Order05Types__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05Types__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this.onClickToggleType(e);
        }
      }, void 0, this.props.modelData.goods_type.goods.map(function (good, index) {
        return Order05Types__jsx("option", {
          value: good.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), good.title);
      }))), Order05Types__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05Types__jsx(reactstrap_es["i" /* Input */], {
        type: "textarea",
        name: "text",
        id: "exampleText",
        placeholder: this.props.modelDataText.order_remark_body_type,
        style: {
          backgroundColor: '#f6f6f6',
          border: '0px'
        },
        onChange: function onChange(e) {
          _this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'remark', e.target.value);
        }
      })));
    }
  }]);

  return Order05Types;
}(react_default.a.Component);

var Order05Types_mapState = function mapState(state) {
  return {
    images: state.order.images
  };
};

var Order05Types_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order05Type_Order05Types = (Object(es["b" /* connect */])(Order05Types_mapState, Order05Types_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order05Types_Order05Types)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary08ReceiverInfo/OrderSummary08ReceiverInfo.js
function OrderSummary08ReceiverInfo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary08ReceiverInfo__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary08ReceiverInfo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary08ReceiverInfo__typeof(obj); }

var OrderSummary08ReceiverInfo_REACT_ELEMENT_TYPE;

function OrderSummary08ReceiverInfo__jsx(type, props, key, children) { if (!OrderSummary08ReceiverInfo_REACT_ELEMENT_TYPE) { OrderSummary08ReceiverInfo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary08ReceiverInfo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary08ReceiverInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary08ReceiverInfo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary08ReceiverInfo__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary08ReceiverInfo__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary08ReceiverInfo__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary08ReceiverInfo__possibleConstructorReturn(self, call) { if (call && (OrderSummary08ReceiverInfo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary08ReceiverInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary08ReceiverInfo__inherits(OrderSummary08ReceiverInfo, _React$Component);

  function OrderSummary08ReceiverInfo() {
    OrderSummary08ReceiverInfo__classCallCheck(this, OrderSummary08ReceiverInfo);

    return OrderSummary08ReceiverInfo__possibleConstructorReturn(this, (OrderSummary08ReceiverInfo.__proto__ || Object.getPrototypeOf(OrderSummary08ReceiverInfo)).apply(this, arguments));
  }

  OrderSummary08ReceiverInfo__createClass(OrderSummary08ReceiverInfo, [{
    key: "render",
    value: function render() {
      return OrderSummary08ReceiverInfo__jsx("div", {
        className: "".concat(style_default.a.summarySender)
      }, void 0, OrderSummary08ReceiverInfo__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_title), OrderSummary08ReceiverInfo__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary08ReceiverInfo__jsx("div", {
        className: "".concat(style_default.a.summarySender)
      }, void 0, OrderSummary08ReceiverInfo__jsx("p", {}, void 0, OrderSummary08ReceiverInfo__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        alt: "user"
      }), OrderSummary08ReceiverInfo__jsx("span", {}, void 0, this.props.orderDetailInfo.order_request_extra_attributes.receiver_name)), OrderSummary08ReceiverInfo__jsx("p", {}, void 0, OrderSummary08ReceiverInfo__jsx("img", {
        className: Order_default.a.orderSummaryIcon,
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        alt: "phone"
      }), OrderSummary08ReceiverInfo__jsx("span", {}, void 0, this.props.orderDetailInfo.order_request_extra_attributes.receiver_phone_number))));
    }
  }]);

  return OrderSummary08ReceiverInfo;
}(react_default.a.Component);

var OrderSummary08ReceiverInfo_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo = (Object(es["b" /* connect */])(OrderSummary08ReceiverInfo_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/twOrderSummary.js
function twOrderSummary__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { twOrderSummary__typeof = function _typeof(obj) { return typeof obj; }; } else { twOrderSummary__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return twOrderSummary__typeof(obj); }

var twOrderSummary_REACT_ELEMENT_TYPE;

function twOrderSummary__jsx(type, props, key, children) { if (!twOrderSummary_REACT_ELEMENT_TYPE) { twOrderSummary_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: twOrderSummary_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function twOrderSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function twOrderSummary__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function twOrderSummary__createClass(Constructor, protoProps, staticProps) { if (protoProps) twOrderSummary__defineProperties(Constructor.prototype, protoProps); if (staticProps) twOrderSummary__defineProperties(Constructor, staticProps); return Constructor; }

function twOrderSummary__possibleConstructorReturn(self, call) { if (call && (twOrderSummary__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function twOrderSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var twOrderSummary__ref = twOrderSummary__jsx("br", {});

var twOrderSummary_hkOrderSummary =
/*#__PURE__*/
function (_React$Component) {
  twOrderSummary__inherits(hkOrderSummary, _React$Component);

  function hkOrderSummary() {
    twOrderSummary__classCallCheck(this, hkOrderSummary);

    return twOrderSummary__possibleConstructorReturn(this, (hkOrderSummary.__proto__ || Object.getPrototypeOf(hkOrderSummary)).apply(this, arguments));
  }

  twOrderSummary__createClass(hkOrderSummary, [{
    key: "render",
    value: function render() {
      return twOrderSummary__jsx("div", {
        className: "".concat(Order_default.a.orderSummary),
        style: {
          display: 'block'
        }
      }, void 0, twOrderSummary__jsx("section", {
        className: Order_default.a.orderSummary
      }, void 0, twOrderSummary__jsx("div", {}, void 0, twOrderSummary__jsx("h2", {}, void 0, this.props.modelDataText.order_summary_title))), twOrderSummary__jsx(OrderSummary_OrderSummary01Route_OrderSummary01Route, {
        modelDataText: this.props.modelDataText
      }), twOrderSummary__jsx(OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime, {
        modelDataText: this.props.modelDataText,
        value: dateformat_default()(this.props.orderDetailInfo.pickup_time, 'dd mmmm, yyyy ,HH:MM')
      }), twOrderSummary__jsx(OrderSummary_OrderSummary03Vehicle_OrderSummary03Vehicle, {
        modelDataText: this.props.modelDataText
      }), twOrderSummary__jsx(OrderSummary_OrderSummary06Remark_OrderSummary06Remark, {
        modelDataText: this.props.modelDataText,
        value: [this.props.orderDetailInfo.order_request_detail_attributes.remark, this.props.modelData.order_model_data.goods_type.goods[this.props.orderDetailInfo.goods - 1].title]
      }), twOrderSummary__jsx(OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo, {
        modelDataText: this.props.modelDataText
      }), this.props.orderDetailInfo.order_request_extra_attributes.receiver_name === '' ? '' : twOrderSummary__jsx(OrderSummary_OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo, {
        modelDataText: this.props.modelDataText
      }), twOrderSummary__jsx(OrderSummary_OrderSummary11Fee_OrderSummary11Fee, {
        modelDataText: this.props.modelDataText
      }), twOrderSummary__jsx(OrderSummary_OrderSummary13Payment_OrderSummary13Payment, {
        modelDataText: this.props.modelDataText
      }), twOrderSummary__ref, twOrderSummary__jsx(OrderSummary_OrderSummarySumbitButton, {
        modelDataText: this.props.modelDataText,
        onClickConfirm: this.props.onClickConfirm
      }));
    }
  }]);

  return hkOrderSummary;
}(react_default.a.Component);

var twOrderSummary_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var twOrderSummary_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var twOrderSummary = (Object(es["b" /* connect */])(twOrderSummary_mapState, twOrderSummary_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(twOrderSummary_hkOrderSummary)));
// CONCATENATED MODULE: ./src/routes/order/twOrder.js
function twOrder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { twOrder__typeof = function _typeof(obj) { return typeof obj; }; } else { twOrder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return twOrder__typeof(obj); }

var twOrder_REACT_ELEMENT_TYPE;

function twOrder__jsx(type, props, key, children) { if (!twOrder_REACT_ELEMENT_TYPE) { twOrder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: twOrder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function twOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function twOrder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function twOrder__createClass(Constructor, protoProps, staticProps) { if (protoProps) twOrder__defineProperties(Constructor.prototype, protoProps); if (staticProps) twOrder__defineProperties(Constructor, staticProps); return Constructor; }

function twOrder__possibleConstructorReturn(self, call) { if (call && (twOrder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function twOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import





















var twOrder_twOrder =
/*#__PURE__*/
function (_React$Component) {
  twOrder__inherits(twOrder, _React$Component);

  function twOrder() {
    twOrder__classCallCheck(this, twOrder);

    return twOrder__possibleConstructorReturn(this, (twOrder.__proto__ || Object.getPrototypeOf(twOrder)).apply(this, arguments));
  }

  twOrder__createClass(twOrder, [{
    key: "render",
    value: function render() {
      return twOrder__jsx("div", {
        className: "".concat(Order_default.a.orderPage)
      }, void 0, twOrder__jsx("div", {
        className: "".concat(Order_default.a.fixedContainer)
      }, void 0, twOrder__jsx(lib_slidedown["SlideDown"], {
        closed: !this.props.isShowOrderDetail
      }, void 0, this.props.isShowOrderDetail ? twOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, twOrder__jsx(twOrderSummary, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm,
        modelData: this.props.modelData
      })) : ''), twOrder__jsx(lib_slidedown["SlideDown"], {
        closed: this.props.isShowOrderDetail
      }, void 0, twOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, twOrder__jsx("h2", {
        className: Order_default.a.headline
      }, void 0, this.props.modelDataText.order.order_headline), twOrder__jsx("hr", {
        className: Order_default.a.hrTitle
      }), twOrder__jsx(order_Order01SelectVehicle_Order01SelectVehicle, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), twOrder__jsx(Order05Type_Order05Types, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), twOrder__jsx(order_Order18AddPhoto_Order18AddPhoto, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), twOrder__jsx(order09Path_Order09Path, {
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), twOrder__jsx(order_Order10PickupTime_Order10PickupTime, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), twOrder__jsx(order_Order12AddService_Order12AddService, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), twOrder__jsx(Order14ContactInfo_Order14ContactInfoWithTW, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), twOrder__jsx(order_Order17InvoiceInfo_Order17InvoiceInfo, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), twOrder__jsx(order_Order13Remarks_Order13Remarks, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        fieldParentName: "order_request_extra_attributes",
        fieldChildName: "remark_for_admin"
      }), twOrder__jsx("hr", {
        className: Order_default.a.hrTotalPrice
      }), twOrder__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, twOrder__jsx(order_Order19Total_Order19Total, {
        modelDataText: this.props.modelDataText.order
      }), twOrder__jsx(order_Order20Coupon_Order20Coupon, {
        modelDataText: this.props.modelDataText.order
      })), twOrder__jsx(order_Order21Confirm_Order21Confirm, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm
      })))), twOrder__jsx(Dialog_extraMessageDialog, {
        message: this.props.orderPriceBreakdownDetail.extra_message
      }));
    }
  }]);

  return twOrder;
}(react_default.a.Component);

var twOrder_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images
  };
};

var twOrder_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var order_twOrder = (Object(es["b" /* connect */])(twOrder_mapState, twOrder_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(twOrder_twOrder)));
// CONCATENATED MODULE: ./src/routes/order/Order02Rental/Order02Rental.js
function Order02Rental__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order02Rental__typeof = function _typeof(obj) { return typeof obj; }; } else { Order02Rental__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order02Rental__typeof(obj); }

var Order02Rental_REACT_ELEMENT_TYPE;

function Order02Rental__jsx(type, props, key, children) { if (!Order02Rental_REACT_ELEMENT_TYPE) { Order02Rental_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order02Rental_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order02Rental__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order02Rental__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order02Rental__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order02Rental__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order02Rental__defineProperties(Constructor, staticProps); return Constructor; }

function Order02Rental__possibleConstructorReturn(self, call) { if (call && (Order02Rental__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order02Rental__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import


 // Relative import








var Order02Rental_Order02Rental =
/*#__PURE__*/
function (_React$Component) {
  Order02Rental__inherits(Order02Rental, _React$Component);

  function Order02Rental() {
    Order02Rental__classCallCheck(this, Order02Rental);

    return Order02Rental__possibleConstructorReturn(this, (Order02Rental.__proto__ || Object.getPrototypeOf(Order02Rental)).apply(this, arguments));
  }

  Order02Rental__createClass(Order02Rental, [{
    key: "getHourlyRental",
    value: function getHourlyRental() {
      if (['ton1', 'ton2'].includes(this.props.orderDetailInfo.vehicle)) {
        return ['0', '2', '4', '6', '8', '10'];
      }

      return ['0', '6', '8', '10'];
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order02Rental__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "6"
      }, void 0, Order02Rental__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_hourly_title), Order02Rental__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          e.preventDefault();
          console.warn(e.target.value);

          _this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'rent_hours', parseInt(e.target.value, 10) === 0 ? '' : parseInt(e.target.value, 10));
        }
      }, void 0, this.getHourlyRental().map(function (i) {
        return Order02Rental__jsx("option", {
          value: i
        }, i, "".concat(i).concat(_this.props.modelDataText.order.order_hourly_hour, " "), i > 0 ? "- ".concat(i * 10).concat(_this.props.modelDataText.order.order_hourly_kms) : '');
      })));
    }
  }]);

  return Order02Rental;
}(react_default.a.Component);

var Order02Rental_mapState = function mapState(state) {
  return {
    vehiclePrice: state.quoting.vehiclePrice,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order02Rental_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order02Rental_Order02Rental = (Object(es["b" /* connect */])(Order02Rental_mapState, Order02Rental_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order02Rental_Order02Rental)));
// CONCATENATED MODULE: ./src/routes/order/Order11Movers/Order11Movers.js
function Order11Movers__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order11Movers__typeof = function _typeof(obj) { return typeof obj; }; } else { Order11Movers__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order11Movers__typeof(obj); }

var Order11Movers_REACT_ELEMENT_TYPE;

function Order11Movers__jsx(type, props, key, children) { if (!Order11Movers_REACT_ELEMENT_TYPE) { Order11Movers_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order11Movers_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order11Movers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order11Movers__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order11Movers__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order11Movers__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order11Movers__defineProperties(Constructor, staticProps); return Constructor; }

function Order11Movers__possibleConstructorReturn(self, call) { if (call && (Order11Movers__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order11Movers__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import


 // Relative import








var Order11Movers_Order11Movers =
/*#__PURE__*/
function (_React$Component) {
  Order11Movers__inherits(Order11Movers, _React$Component);

  function Order11Movers() {
    Order11Movers__classCallCheck(this, Order11Movers);

    return Order11Movers__possibleConstructorReturn(this, (Order11Movers.__proto__ || Object.getPrototypeOf(Order11Movers)).apply(this, arguments));
  }

  Order11Movers__createClass(Order11Movers, [{
    key: "getMoverSerivce",
    value: function getMoverSerivce() {
      if (this.props.lang === 'in') {
        return this.props.modelData.mover_service;
      }

      return this.props.modelData.mover_service[this.props.orderDetailInfo.service_type];
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order11Movers__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order11Movers__jsx(reactstrap_es["b" /* Col */], {
        xs: "12",
        sm: "12",
        md: "12"
      }, void 0, Order11Movers__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_movers_title), Order11Movers__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          e.preventDefault();

          _this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'num_movers', parseInt(e.target.value, 10));
        }
      }, void 0, this.getMoverSerivce().map(function (i) {
        return Order11Movers__jsx("option", {
          value: i.value
        }, i.value, i.title);
      }))));
    }
  }]);

  return Order11Movers;
}(react_default.a.Component);

var Order11Movers_mapState = function mapState(state) {
  return {
    vehiclePrice: state.quoting.vehiclePrice,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order11Movers_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var order_Order11Movers_Order11Movers = (Object(es["b" /* connect */])(Order11Movers_mapState, Order11Movers_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order11Movers_Order11Movers)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary03Vehicle/OrderSummary03VehicleIN.js
function OrderSummary03VehicleIN__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary03VehicleIN__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary03VehicleIN__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary03VehicleIN__typeof(obj); }

var OrderSummary03VehicleIN_REACT_ELEMENT_TYPE;

function OrderSummary03VehicleIN__jsx(type, props, key, children) { if (!OrderSummary03VehicleIN_REACT_ELEMENT_TYPE) { OrderSummary03VehicleIN_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary03VehicleIN_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary03VehicleIN__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary03VehicleIN__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary03VehicleIN__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary03VehicleIN__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary03VehicleIN__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary03VehicleIN__possibleConstructorReturn(self, call) { if (call && (OrderSummary03VehicleIN__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary03VehicleIN__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary03VehicleIN_OrderSummary03Vehicle =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary03VehicleIN__inherits(OrderSummary03Vehicle, _React$Component);

  function OrderSummary03Vehicle() {
    OrderSummary03VehicleIN__classCallCheck(this, OrderSummary03Vehicle);

    return OrderSummary03VehicleIN__possibleConstructorReturn(this, (OrderSummary03Vehicle.__proto__ || Object.getPrototypeOf(OrderSummary03Vehicle)).apply(this, arguments));
  }

  OrderSummary03VehicleIN__createClass(OrderSummary03Vehicle, [{
    key: "render",
    value: function render() {
      return OrderSummary03VehicleIN__jsx("div", {
        className: "".concat(style_default.a.summaryVehicle)
      }, void 0, OrderSummary03VehicleIN__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_vehicle_title), OrderSummary03VehicleIN__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary03VehicleIN__jsx("span", {}, void 0, this.props.modelData.order_model_data.vehicle_type.types[parseInt(this.props.orderDetailInfo.vehicle.substr(this.props.orderDetailInfo.vehicle.length - 1), 10) - 1].title));
    }
  }]);

  return OrderSummary03Vehicle;
}(react_default.a.Component);

Object.defineProperty(OrderSummary03VehicleIN_OrderSummary03Vehicle, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    modelData: ''
  }
});

var OrderSummary03VehicleIN_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary03VehicleIN = (Object(es["b" /* connect */])(OrderSummary03VehicleIN_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary03VehicleIN_OrderSummary03Vehicle)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/inOrderSummary.js
function inOrderSummary__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inOrderSummary__typeof = function _typeof(obj) { return typeof obj; }; } else { inOrderSummary__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inOrderSummary__typeof(obj); }

var inOrderSummary_REACT_ELEMENT_TYPE;

function inOrderSummary__jsx(type, props, key, children) { if (!inOrderSummary_REACT_ELEMENT_TYPE) { inOrderSummary_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: inOrderSummary_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function inOrderSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function inOrderSummary__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function inOrderSummary__createClass(Constructor, protoProps, staticProps) { if (protoProps) inOrderSummary__defineProperties(Constructor.prototype, protoProps); if (staticProps) inOrderSummary__defineProperties(Constructor, staticProps); return Constructor; }

function inOrderSummary__possibleConstructorReturn(self, call) { if (call && (inOrderSummary__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function inOrderSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var inOrderSummary__ref = inOrderSummary__jsx("br", {});

var inOrderSummary_inOrderSummary =
/*#__PURE__*/
function (_React$Component) {
  inOrderSummary__inherits(inOrderSummary, _React$Component);

  function inOrderSummary() {
    inOrderSummary__classCallCheck(this, inOrderSummary);

    return inOrderSummary__possibleConstructorReturn(this, (inOrderSummary.__proto__ || Object.getPrototypeOf(inOrderSummary)).apply(this, arguments));
  }

  inOrderSummary__createClass(inOrderSummary, [{
    key: "render",
    value: function render() {
      return inOrderSummary__jsx("div", {
        className: "".concat(Order_default.a.orderSummary),
        style: {
          display: 'block'
        }
      }, void 0, inOrderSummary__jsx("section", {
        className: Order_default.a.orderSummary
      }, void 0, inOrderSummary__jsx("div", {}, void 0, inOrderSummary__jsx("h2", {}, void 0, this.props.modelDataText.order_summary_title))), inOrderSummary__jsx(OrderSummary_OrderSummary01Route_OrderSummary01Route, {
        modelDataText: this.props.modelDataText
      }), inOrderSummary__jsx(OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime, {
        modelDataText: this.props.modelDataText,
        value: dateformat_default()(this.props.orderDetailInfo.pickup_time, 'dd mmmm, yyyy ,HH:MM')
      }), inOrderSummary__jsx(OrderSummary03VehicleIN, {
        modelDataText: this.props.modelDataText,
        modelData: this.props.modelData
      }), inOrderSummary__jsx(OrderSummary_OrderSummary06Remark_OrderSummary06Remark, {
        modelDataText: this.props.modelDataText,
        value: [this.props.orderDetailInfo.remark]
      }), inOrderSummary__jsx(OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo, {
        modelDataText: this.props.modelDataText
      }), inOrderSummary__jsx(OrderSummary_OrderSummary11Fee_OrderSummary11Fee, {
        modelDataText: this.props.modelDataText
      }), inOrderSummary__jsx(OrderSummary_OrderSummary13Payment_OrderSummary13Payment, {
        modelDataText: this.props.modelDataText
      }), inOrderSummary__ref, inOrderSummary__jsx(OrderSummary_OrderSummarySumbitButton, {
        modelDataText: this.props.modelDataText,
        onClickConfirm: this.props.onClickConfirm
      }));
    }
  }]);

  return inOrderSummary;
}(react_default.a.Component);

var inOrderSummary_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var inOrderSummary_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var OrderSummary_inOrderSummary = (Object(es["b" /* connect */])(inOrderSummary_mapState, inOrderSummary_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(inOrderSummary_inOrderSummary)));
// CONCATENATED MODULE: ./src/components/Dialog/simpleMessageDialog.js
function simpleMessageDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { simpleMessageDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { simpleMessageDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return simpleMessageDialog__typeof(obj); }

var simpleMessageDialog_REACT_ELEMENT_TYPE;

function simpleMessageDialog__jsx(type, props, key, children) { if (!simpleMessageDialog_REACT_ELEMENT_TYPE) { simpleMessageDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: simpleMessageDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function simpleMessageDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function simpleMessageDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function simpleMessageDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) simpleMessageDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) simpleMessageDialog__defineProperties(Constructor, staticProps); return Constructor; }

function simpleMessageDialog__possibleConstructorReturn(self, call) { if (call && (simpleMessageDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function simpleMessageDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var simpleMessageDialog_SimpleMessageDialog =
/*#__PURE__*/
function (_React$Component) {
  simpleMessageDialog__inherits(SimpleMessageDialog, _React$Component);

  function SimpleMessageDialog() {
    simpleMessageDialog__classCallCheck(this, SimpleMessageDialog);

    return simpleMessageDialog__possibleConstructorReturn(this, (SimpleMessageDialog.__proto__ || Object.getPrototypeOf(SimpleMessageDialog)).apply(this, arguments));
  }

  simpleMessageDialog__createClass(SimpleMessageDialog, [{
    key: "render",
    value: function render() {
      var _this = this;

      return simpleMessageDialog__jsx("div", {
        id: "blacklist"
      }, void 0, simpleMessageDialog__jsx(reactstrap_es["k" /* Modal */], {
        size: "lg",
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal // isOpen
        ,
        toggle: function toggle() {
          _this.props.setIsShowSimpleMessageDialog();
        }
      }, void 0, simpleMessageDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.orderCancelcloseRightButton),
        onClick: function onClick() {
          _this.props.setIsShowSimpleMessageDialog();
        }
      }), simpleMessageDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.infoContainer, " ").concat(dialog_default.a.orderCancelContainer),
        style: {
          padding: 0
        }
      }, void 0, simpleMessageDialog__jsx("div", {
        className: dialog_default.a.infoHeadline
      }, void 0, simpleMessageDialog__jsx("h2", {
        className: style_default.a.globalFontLight
      }, void 0, this.props.message.header)), simpleMessageDialog__jsx("div", {
        className: dialog_default.a.infoContent
      }, void 0, simpleMessageDialog__jsx("p", {}, void 0, this.props.message.body)))));
    }
  }]);

  return SimpleMessageDialog;
}(react_default.a.Component);

var simpleMessageDialog_mapState = function mapState(state) {
  return {
    // currentLocale: state.intl.locale,
    modal: state.dialog.isShowSimpleMessageDialog,
    message: state.dialog.simpleMessage
  };
};

var simpleMessageDialog_mapDispatch = {
  setIsShowSimpleMessageDialog: actions_dialog["k" /* setIsShowSimpleMessageDialog */]
};
/* harmony default export */ var simpleMessageDialog = (Object(es["b" /* connect */])(simpleMessageDialog_mapState, simpleMessageDialog_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(simpleMessageDialog_SimpleMessageDialog)));
// CONCATENATED MODULE: ./src/routes/order/inOrder.js
function inOrder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { inOrder__typeof = function _typeof(obj) { return typeof obj; }; } else { inOrder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return inOrder__typeof(obj); }

var inOrder_REACT_ELEMENT_TYPE;

function inOrder__jsx(type, props, key, children) { if (!inOrder_REACT_ELEMENT_TYPE) { inOrder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: inOrder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function inOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function inOrder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function inOrder__createClass(Constructor, protoProps, staticProps) { if (protoProps) inOrder__defineProperties(Constructor.prototype, protoProps); if (staticProps) inOrder__defineProperties(Constructor, staticProps); return Constructor; }

function inOrder__possibleConstructorReturn(self, call) { if (call && (inOrder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function inOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import






 // import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import






















var inOrder__ref = inOrder__jsx("br", {});

var inOrder__ref2 = inOrder__jsx(simpleMessageDialog, {});

var inOrder_twOrder =
/*#__PURE__*/
function (_React$Component) {
  inOrder__inherits(twOrder, _React$Component);

  function twOrder() {
    inOrder__classCallCheck(this, twOrder);

    return inOrder__possibleConstructorReturn(this, (twOrder.__proto__ || Object.getPrototypeOf(twOrder)).apply(this, arguments));
  }

  inOrder__createClass(twOrder, [{
    key: "render",
    value: function render() {
      // Process the dataModel first before the template rendering
      return inOrder__jsx("div", {
        className: "".concat(Order_default.a.orderPage)
      }, void 0, inOrder__jsx("div", {
        className: "".concat(Order_default.a.fixedContainer)
      }, void 0, inOrder__jsx(lib_slidedown["SlideDown"], {
        closed: !this.props.isShowOrderDetail
      }, void 0, this.props.isShowOrderDetail ? inOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, inOrder__jsx(OrderSummary_inOrderSummary, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm,
        modelData: this.props.modelData
      })) : ''), inOrder__jsx(lib_slidedown["SlideDown"], {
        closed: this.props.isShowOrderDetail
      }, void 0, inOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, inOrder__jsx("h2", {
        className: Order_default.a.headline
      }, void 0, this.props.modelDataText.order.order_headline), inOrder__jsx("hr", {
        className: Order_default.a.hrTitle
      }), inOrder__jsx(order_Order01SelectVehicle_Order01SelectVehicle, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), inOrder__jsx(reactstrap_es["n" /* Row */], {}, void 0, inOrder__jsx(order_Order02Rental_Order02Rental, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      })), inOrder__jsx(reactstrap_es["n" /* Row */], {}, void 0, inOrder__jsx(order_Order03Pessenger_Order03Pessenger, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      })), inOrder__jsx(order09Path_Order09Path, {
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), inOrder__jsx(order_Order10PickupTime_Order10PickupTime, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), inOrder__jsx(order_Order11Movers_Order11Movers, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), inOrder__ref, inOrder__jsx(order_Order13Remarks_Order13Remarks, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        fieldParentName: "order_request_detail_attributes",
        fieldChildName: "remark"
      }), inOrder__jsx(order_Order18AddPhoto_Order18AddPhoto, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), inOrder__jsx(order_Order14ContactInfo_Order14ContactInfo, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), inOrder__jsx("hr", {
        className: Order_default.a.hrTotalPrice
      }), inOrder__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, inOrder__jsx(order_Order19Total_Order19Total, {
        modelDataText: this.props.modelDataText.order
      }), inOrder__jsx(order_Order20Coupon_Order20Coupon, {
        modelDataText: this.props.modelDataText.order
      })), inOrder__jsx(order_Order21Confirm_Order21Confirm, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm
      })))), inOrder__jsx(Dialog_extraMessageDialog, {
        message: this.props.orderPriceBreakdownDetail.extra_message
      }), inOrder__ref2);
    }
  }]);

  return twOrder;
}(react_default.a.Component);

var inOrder_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images
  };
};

var inOrder_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var inOrder = (Object(es["b" /* connect */])(inOrder_mapState, inOrder_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(inOrder_twOrder)));
// CONCATENATED MODULE: ./src/ctrl/orderCtrl.js
/* eslint-disable import/prefer-default-export */
function convertFromParamToType(param, lang) {
  switch (param) {
    case 'van':
    case 'struck':
    case 'mtruck':
      return {
        type: 'van',
        inSameFile: true
      };

    case 'mudou':
    case 'ton1':
    case 'ton2':
      return {
        type: '5ton',
        inSameFile: true
      };

    case 'mudou9':
    case 'ton3':
    case 'ton4':
    case 'ton5':
    case 'ton6':
      return {
        type: '9ton',
        inSameFile: true
      };

    case 'delivery':
      if (lang === 'kr') {
        return {
          type: 'smallfreight',
          inSameFile: false
        };
      }

      return {
        type: 'courier',
        inSameFile: false
      };

    case 'transport':
      if (lang === 'kr') {
        return {
          type: 'courier',
          inSameFile: false
        };
      }

      return {
        type: 'ridewithgoodsicon',
        inSameFile: false
      };

    case 'big_cargo':
      return {
        type: 'deliveryservice',
        inSameFile: false
      };

    case 'moving':
      return {
        type: 'movingservice',
        inSameFile: false
      };

    case 'motorcycle':
      return {
        type: 'motorcycle',
        inSameFile: false
      };

    default:
      return param;
  }
} // remove orderDetailInfo key

function removeByKey(myObj, deleteKey) {
  return Object.keys(myObj).filter(function (key) {
    return key !== deleteKey;
  }).reduce(function (result, current) {
    var res = result;
    res[current] = myObj[current];
    return result;
  }, {});
}
// CONCATENATED MODULE: ./src/routes/order/Order01SelectVehicle/Order01SelectVehicleKR.js
function Order01SelectVehicleKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order01SelectVehicleKR__typeof = function _typeof(obj) { return typeof obj; }; } else { Order01SelectVehicleKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order01SelectVehicleKR__typeof(obj); }

var Order01SelectVehicleKR_REACT_ELEMENT_TYPE;

function Order01SelectVehicleKR__jsx(type, props, key, children) { if (!Order01SelectVehicleKR_REACT_ELEMENT_TYPE) { Order01SelectVehicleKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order01SelectVehicleKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order01SelectVehicleKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order01SelectVehicleKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order01SelectVehicleKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order01SelectVehicleKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order01SelectVehicleKR__defineProperties(Constructor, staticProps); return Constructor; }

function Order01SelectVehicleKR__possibleConstructorReturn(self, call) { if (call && (Order01SelectVehicleKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order01SelectVehicleKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order01SelectVehicleKR__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import








var Order01SelectVehicleKR__ref = Order01SelectVehicleKR__jsx("br", {});

var Order01SelectVehicleKR__ref2 = Order01SelectVehicleKR__jsx("br", {});

var Order01SelectVehicleKR_Order01SelectVehicle =
/*#__PURE__*/
function (_React$Component) {
  Order01SelectVehicleKR__inherits(Order01SelectVehicle, _React$Component);

  function Order01SelectVehicle(props) {
    var _this;

    Order01SelectVehicleKR__classCallCheck(this, Order01SelectVehicle);

    _this = Order01SelectVehicleKR__possibleConstructorReturn(this, (Order01SelectVehicle.__proto__ || Object.getPrototypeOf(Order01SelectVehicle)).call(this, props));
    _this.state = {
      selectedVehicle: ''
    };
    _this.onClickSelectVehicle = _this.onClickSelectVehicle.bind(Order01SelectVehicleKR__assertThisInitialized(_this));
    return _this;
  }

  Order01SelectVehicleKR__createClass(Order01SelectVehicle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onClickSelectVehicle(this.props.modelData.service_types[0].value);
    } // kr is service types, not vehicle type

  }, {
    key: "onClickSelectVehicle",
    value: function onClickSelectVehicle(type) {
      this.props.setOrderVehicleType(type);
      this.setState({
        selectedVehicle: type
      });

      if (type === 'transport') {
        this.props.updateOrderDetailInfoAction('item_type', null, 'documents');
        this.props.updateOrderDetailInfoAction('vehicle', null, '');
      } else if (type === 'big_cargo') {
        this.props.setSimpleMessage({
          header: this.props.modelDataText.order.service_not_available_headline,
          body: this.props.modelDataText.order.service_not_available_content
        });
        this.props.setIsShowSimpleMessageDialog();
      } else {
        this.props.updateOrderDetailInfoAction(null, null, removeByKey(this.props.orderDetailInfo, 'item_type'));

        if (type === 'delivery') {
          this.props.updateOrderDetailInfoAction('vehicle', null, 'damas');
        }

        if (type === 'moving') {
          this.props.updateOrderDetailInfoAction('vehicle', null, 'ton1');
        }
      }

      this.props.updateOrderDetailInfoAction('service_type', null, type);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order01SelectVehicleKR__jsx("div", {}, void 0, Order01SelectVehicleKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_vehicle_title), Order01SelectVehicleKR__jsx(reactstrap_es["n" /* Row */], {}, void 0, this.props.modelData.service_types.map(function (obj, index) {
        var img = obj.icon.toString();
        var img1 = img.split(',')[0].split(' ')[0];
        img1 = img1.split('/').reverse()[0].split('.')[0];

        var imgBlueVehicle = __webpack_require__(970)("./".concat(img1, ".png"));

        var imgBlueVehicle2 = __webpack_require__(971)("./".concat(img1, "@2x.png"));

        return Order01SelectVehicleKR__jsx(reactstrap_es["b" /* Col */], {
          xs: "12",
          sm: "12",
          md: "3"
        }, index.toString(), Order01SelectVehicleKR__jsx("div", {
          className: "".concat(_this2.state.selectedVehicle === obj.value ? Order_default.a.vehicleGridActive : [Order_default.a.vehicleGrid, Order_default.a.selectVehicle].join(' ')),
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            _this2.onClickSelectVehicle(obj.value);
          },
          onKeyPress: function onKeyPress() {}
        }, void 0, Order01SelectVehicleKR__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order01SelectVehicleKR__jsx(reactstrap_es["b" /* Col */], {
          md: "12",
          xs: "3"
        }, void 0, Order01SelectVehicleKR__jsx("img", {
          height: "45",
          alt: obj.title,
          srcSet: "".concat(imgBlueVehicle, " 1x, ").concat(imgBlueVehicle2, " 2x")
        }), Order01SelectVehicleKR__ref, Order01SelectVehicleKR__ref2), Order01SelectVehicleKR__jsx(reactstrap_es["b" /* Col */], {
          md: "12"
        }, void 0, Order01SelectVehicleKR__jsx("span", {
          dangerouslySetInnerHTML: {
            __html: obj.title
          },
          style: {
            color: '#0088bf'
          }
        })))));
      })));
    }
  }]);

  return Order01SelectVehicle;
}(react_default.a.Component);

var Order01SelectVehicleKR_mapState = function mapState(state) {
  return {
    isToggleOn: state.order.isToggleOn,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order01SelectVehicleKR_mapDispatch = {
  setOrderVehicleType: actions_order["q" /* setOrderVehicleType */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsShowSimpleMessageDialog: actions_dialog["k" /* setIsShowSimpleMessageDialog */],
  setSimpleMessage: actions_dialog["m" /* setSimpleMessage */]
};
/* harmony default export */ var Order01SelectVehicleKR = (Object(es["b" /* connect */])(Order01SelectVehicleKR_mapState, Order01SelectVehicleKR_mapDispatch)(withStyles_default()(bootstrap_default.a, Order_default.a)(Order01SelectVehicleKR_Order01SelectVehicle)));
// CONCATENATED MODULE: ./src/routes/order/Order14ContactInfo/Order14ContactInfoWithSGKR.js
var Order14ContactInfoWithSGKR_REACT_ELEMENT_TYPE;

function Order14ContactInfoWithSGKR__jsx(type, props, key, children) { if (!Order14ContactInfoWithSGKR_REACT_ELEMENT_TYPE) { Order14ContactInfoWithSGKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order14ContactInfoWithSGKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order14ContactInfoWithSGKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order14ContactInfoWithSGKR__typeof = function _typeof(obj) { return typeof obj; }; } else { Order14ContactInfoWithSGKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order14ContactInfoWithSGKR__typeof(obj); }

function Order14ContactInfoWithSGKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order14ContactInfoWithSGKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order14ContactInfoWithSGKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order14ContactInfoWithSGKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order14ContactInfoWithSGKR__defineProperties(Constructor, staticProps); return Constructor; }

function Order14ContactInfoWithSGKR__possibleConstructorReturn(self, call) { if (call && (Order14ContactInfoWithSGKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order14ContactInfoWithSGKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order14ContactInfoWithSGKR__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import














var Order14ContactInfoWithSGKR_Order14ContactInfoWithTW =
/*#__PURE__*/
function (_React$Component) {
  Order14ContactInfoWithSGKR__inherits(Order14ContactInfoWithTW, _React$Component);

  function Order14ContactInfoWithTW(props) {
    var _this;

    Order14ContactInfoWithSGKR__classCallCheck(this, Order14ContactInfoWithTW);

    _this = Order14ContactInfoWithSGKR__possibleConstructorReturn(this, (Order14ContactInfoWithTW.__proto__ || Object.getPrototypeOf(Order14ContactInfoWithTW)).call(this, props));
    _this.state = {
      name: Object(auth["b" /* getAuth */])().username,
      phone: Object(auth["b" /* getAuth */])().phone,
      email: Object(auth["b" /* getAuth */])().email,
      phoneExt: '',
      receiverPhone: '',
      receiverName: '',
      isValidName: true,
      isValidPhone: true,
      isValidEmail: true,
      isValidReceiverName: true,
      isValidReceiverPhone: true,
      scrollToComponent: null
    };
    _this.setScrollToComponent = _this.setScrollToComponent.bind(Order14ContactInfoWithSGKR__assertThisInitialized(_this));
    _this.scrollToAndReturnIsValid = _this.scrollToAndReturnIsValid.bind(Order14ContactInfoWithSGKR__assertThisInitialized(_this));
    return _this;
  }

  Order14ContactInfoWithSGKR__createClass(Order14ContactInfoWithTW, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollToComponent();
      this.onChangeName(Object(auth["b" /* getAuth */])().username);
      this.onChangePhone(Object(auth["b" /* getAuth */])().phone);
      this.onChangeEmail(Object(auth["b" /* getAuth */])().email);
      this.props.updateOrderDetailInfoAction('phone_number', null, Object(auth["b" /* getAuth */])().phone);
      this.props.updateOrderDetailInfoAction('nickname', null, Object(auth["b" /* getAuth */])().username);
      this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', Object(auth["b" /* getAuth */])().email);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
        this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
        this.props.updateOrderDetailInfoAction('phone_number', null, this.state.phone);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'email_address', this.state.email);
        this.props.updateOrderDetailInfoAction('phone_number_ext', null, this.state.phoneExt);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'receiver_name', this.state.receiverPhone);
        this.props.updateOrderDetailInfoAction('order_request_extra_attributes', 'receiver_phone_number', this.state.receiverName);

        if (this.state.name === '') {
          this.setState({
            isValidName: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidName: true
          });
        }

        var phonePatt = new RegExp(this.props.setting.PHONE_REGEX);

        if (!phonePatt.test(this.state.phone)) {
          this.setState({
            isValidPhone: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidPhone: true
          });
        }

        var emailPatt = new RegExp(this.props.setting.EMAIL_REGEX);

        if (!emailPatt.test(this.state.email)) {
          this.setState({
            isValidEmail: false
          });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({
            isValidEmail: true
          });
        }

        if (this.state.receiverName !== '' || this.state.receiverPhone !== '') {
          if (this.state.receiverName === '') {
            this.setState({
              isValidReceiverName: false
            });
            this.scrollToAndReturnIsValid();
          } else {
            this.setState({
              isValidReceiverName: true
            });
          }

          if (this.state.receiverPhone === '') {
            this.setState({
              isValidReceiverPhone: false
            });
            this.scrollToAndReturnIsValid();
          } else {
            this.setState({
              isValidReceiverPhone: true
            });
          }
        }
      }
    }
  }, {
    key: "onChangeName",
    value: function onChangeName(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          name: e.target.value
        });
      } else {
        this.setState({
          name: e
        });
      }
    }
  }, {
    key: "onChangePhone",
    value: function onChangePhone(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          phone: e.target.value
        });
      } else {
        this.setState({
          phone: e
        });
      }
    }
  }, {
    key: "onChangeEmail",
    value: function onChangeEmail(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          email: e.target.value
        });
      } else {
        this.setState({
          email: e
        });
      }
    }
  }, {
    key: "onChangeReceiverName",
    value: function onChangeReceiverName(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          receiverName: e.target.value
        });
      } else {
        this.setState({
          receiverName: e
        });
      }
    }
  }, {
    key: "onChangeReceiverPhone",
    value: function onChangeReceiverPhone(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          receiverPhone: e.target.value
        });
      } else {
        this.setState({
          receiverPhone: e
        });
      }
    }
  }, {
    key: "onChangePhoneExt",
    value: function onChangePhoneExt(e) {
      if (Order14ContactInfoWithSGKR__typeof(e) === 'object') {
        this.setState({
          phoneExt: e.target.value
        });
      } else {
        this.setState({
          phoneExt: e
        });
      }
    }
  }, {
    key: "setScrollToComponent",
    value: function setScrollToComponent() {
      /* eslint-disable global-require */
      this.setState({
        scrollToComponent: __webpack_require__(919)
      });
    }
  }, {
    key: "scrollToAndReturnIsValid",
    value: function scrollToAndReturnIsValid() {
      this.props.setIsValidOrder(false);
      this.state.scrollToComponent(this.Order14ContactInfo, {
        offset: -100,
        duration: 500
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order14ContactInfoWithSGKR__jsx(reactstrap_es["c" /* Container */], {}, void 0, react_default.a.createElement("p", {
        ref: function ref(i) {
          _this2.Order14ContactInfo = i;
        }
      }), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["b" /* Col */], {
        md: "5",
        xs: "12"
      }, void 0, Order14ContactInfoWithSGKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_title), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {
        style: {
          marginBottom: '15px',
          marginLeft: '0px'
        }
      }, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_nickname_input,
        value: this.state.name,
        onChange: function onChange(e) {
          _this2.onChangeName(e);
        }
      }), Order14ContactInfoWithSGKR__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "ppl"
      })), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfoTop
      }, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_phone_input,
        value: this.state.phone,
        onChange: function onChange(e) {
          _this2.onChangePhone(e);
        }
      }), Order14ContactInfoWithSGKR__jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        style: {
          marginBottom: '5px'
        },
        width: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "phone"
      })), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfo
      }, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_email_input,
        value: this.state.email,
        onChange: function onChange(e) {
          _this2.onChangeEmail(e);
        }
      }), Order14ContactInfoWithSGKR__jsx("img", {
        srcSet: "".concat(icon_mail_default.a, " 1x, ").concat(icon_mail_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "email"
      })), Order14ContactInfoWithSGKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_nickname_input_warning), Order14ContactInfoWithSGKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidEmail ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_email_input_warning), Order14ContactInfoWithSGKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidPhone ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_phone_input_warning)), Order14ContactInfoWithSGKR__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: '5',
          offset: 1
        },
        xs: "12"
      }, void 0, Order14ContactInfoWithSGKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.contact_info_recipient_title), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfoTop
      }, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_recipient_nickname_input,
        value: this.state.receiverName,
        onChange: function onChange(e) {
          _this2.onChangeReceiverName(e);
        }
      }), Order14ContactInfoWithSGKR__jsx("img", {
        srcSet: "".concat(icon_avatar_default.a, " 1x, ").concat(icon_avatar_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "ppl"
      })), Order14ContactInfoWithSGKR__jsx(reactstrap_es["n" /* Row */], {
        className: Order_default.a.contantInfo
      }, void 0, Order14ContactInfoWithSGKR__jsx(reactstrap_es["i" /* Input */], {
        className: "".concat(Order_default.a.iconLeft),
        placeholder: this.props.modelDataText.contact_info_recipient_phone_input,
        value: this.state.receiverPhone,
        onChange: function onChange(e) {
          _this2.onChangeReceiverPhone(e);
        }
      }), Order14ContactInfoWithSGKR__jsx("img", {
        srcSet: "".concat(icon_phone_default.a, " 1x, ").concat(icon_phone_2x_default.a, " 2x"),
        width: "24",
        height: "24",
        className: "".concat(Order_default.a.imgIconLeftTW),
        alt: "phone"
      })), Order14ContactInfoWithSGKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidReceiverName ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_nickname_input_warning), Order14ContactInfoWithSGKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText),
        style: !this.state.isValidReceiverPhone ? {} : {
          display: 'none'
        }
      }, void 0, this.props.modelDataText.contact_info_phone_input_warning))));
    }
  }]);

  return Order14ContactInfoWithTW;
}(react_default.a.Component);

var Order14ContactInfoWithSGKR_mapState = function mapState(state) {
  return {
    user: state.user.user,
    isClickConfirmOrder: state.order.isClickConfirmOrder
  };
};

var Order14ContactInfoWithSGKR_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsValidOrder: actions_order["l" /* setIsValidOrder */],
  setIsClickConfirmOrder: actions_order["h" /* setIsClickConfirmOrder */]
};
/* harmony default export */ var Order14ContactInfoWithSGKR = (Object(es["b" /* connect */])(Order14ContactInfoWithSGKR_mapState, Order14ContactInfoWithSGKR_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order14ContactInfoWithSGKR_Order14ContactInfoWithTW)));
// CONCATENATED MODULE: ./src/routes/order/Order05Type/Order05TypesKR.js
function Order05TypesKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order05TypesKR__typeof = function _typeof(obj) { return typeof obj; }; } else { Order05TypesKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order05TypesKR__typeof(obj); }

var Order05TypesKR_REACT_ELEMENT_TYPE;

function Order05TypesKR__jsx(type, props, key, children) { if (!Order05TypesKR_REACT_ELEMENT_TYPE) { Order05TypesKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order05TypesKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order05TypesKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order05TypesKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order05TypesKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order05TypesKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order05TypesKR__defineProperties(Constructor, staticProps); return Constructor; }

function Order05TypesKR__possibleConstructorReturn(self, call) { if (call && (Order05TypesKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order05TypesKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import






var Order05TypesKR__ref = Order05TypesKR__jsx("br", {});

var Order05TypesKR__ref2 = Order05TypesKR__jsx("br", {}, "2");

var Order05TypesKR_Order05TypesKR =
/*#__PURE__*/
function (_React$Component) {
  Order05TypesKR__inherits(Order05TypesKR, _React$Component);

  function Order05TypesKR(props) {
    var _this;

    Order05TypesKR__classCallCheck(this, Order05TypesKR);

    _this = Order05TypesKR__possibleConstructorReturn(this, (Order05TypesKR.__proto__ || Object.getPrototypeOf(Order05TypesKR)).call(this, props));
    _this.state = {
      itemTypes: 'documents'
    };
    return _this;
  }

  Order05TypesKR__createClass(Order05TypesKR, [{
    key: "onClickToggleType",
    value: function onClickToggleType(e) {
      this.setState({
        itemTypes: e.target.value
      });

      if (this.props.serviceTypes === 'transport') {
        this.props.updateOrderDetailInfoAction('vehicle', null, '');
        this.props.updateOrderDetailInfoAction('item_type', null, e.target.value);
      } else {
        this.props.updateOrderDetailInfoAction('item_type', null, '');
        this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value);
      }
    }
  }, {
    key: "onClickToggleItemType",
    value: function onClickToggleItemType(e) {
      this.props.updateOrderDetailInfoAction('number_of_items', null, e.target.value);
    }
  }, {
    key: "getTypesDetailOption",
    value: function getTypesDetailOption() {
      this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});

      if (this.props.serviceTypes === 'transport') {
        return this.props.modelData.goods_types;
      } else if (this.props.serviceTypes === 'delivery') {
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'passenger_count', 1);
        return this.props.modelData.vehicle_types.delivery;
      } else if (this.props.serviceTypes === 'moving') {
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'num_movers_departure', 0);
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'num_movers_destination', 0);
        return this.props.modelData.vehicle_types.moving;
      }

      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order05TypesKR__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05TypesKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_goods_title)), Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05TypesKR__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this2.onClickToggleType(e);
        }
      }, void 0, this.getTypesDetailOption().map(function (good, index) {
        return Order05TypesKR__jsx("option", {
          value: good.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), good.title);
      }))), this.props.serviceTypes === 'transport' && ['small_box', 'big_box'].includes(this.state.itemTypes) ? Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05TypesKR__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText)
      }, void 0, this.state.itemTypes === 'small_box' ? this.props.modelDataText.order_parcel_title : this.props.modelDataText.order_parcel_big_title), Order05TypesKR__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this2.props.updateOrderDetailInfoAction('number_of_items', null, e.target.value);
        }
      }, void 0, this.props.modelData.number_of_items[this.state.itemTypes].map(function (item, index) {
        return Order05TypesKR__jsx("option", {
          value: item.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), item.title);
      })), Order05TypesKR__ref) : '', this.props.serviceTypes === 'transport' ? Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05TypesKR__jsx(reactstrap_es["i" /* Input */], {
        type: "textarea",
        name: "text",
        id: "exampleText",
        placeholder: "".concat(this.props.modelDataText.order_summary_remark_title, " ").concat(this.props.modelDataText.order_summary_charge_why_tips_button),
        style: {
          backgroundColor: '#f6f6f6',
          border: '0px'
        },
        onChange: function onChange(e) {
          _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'remark', e.target.value);
        }
      })) : '', this.props.serviceTypes === 'moving' ? [Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, "0", Order05TypesKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_movers_departure_title)), Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, "1", Order05TypesKR__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'num_movers_departure', e.target.value);
        }
      }, void 0, this.props.modelData.num_movers_departure.moving.map(function (m, index) {
        return Order05TypesKR__jsx("option", {
          value: m.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), m.title);
      }))), Order05TypesKR__ref2, Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, "3", Order05TypesKR__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_movers_destination_title)), Order05TypesKR__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, "4", Order05TypesKR__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this2.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'num_movers_destination', e.target.value);
        }
      }, void 0, this.props.modelData.num_movers_departure.moving.map(function (m, index) {
        return Order05TypesKR__jsx("option", {
          value: m.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), m.title);
      })))] : '');
    }
  }]);

  return Order05TypesKR;
}(react_default.a.Component);

var Order05TypesKR_mapState = function mapState(state) {
  return {
    images: state.order.images
  };
};

var Order05TypesKR_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order05Type_Order05TypesKR = (Object(es["b" /* connect */])(Order05TypesKR_mapState, Order05TypesKR_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order05TypesKR_Order05TypesKR)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary01Route/OrderSummary01RouteKR.js
function OrderSummary01RouteKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary01RouteKR__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary01RouteKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary01RouteKR__typeof(obj); }

var OrderSummary01RouteKR_REACT_ELEMENT_TYPE;

function OrderSummary01RouteKR__jsx(type, props, key, children) { if (!OrderSummary01RouteKR_REACT_ELEMENT_TYPE) { OrderSummary01RouteKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary01RouteKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary01RouteKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary01RouteKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary01RouteKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary01RouteKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary01RouteKR__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary01RouteKR__possibleConstructorReturn(self, call) { if (call && (OrderSummary01RouteKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary01RouteKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function OrderSummary01RouteKR__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }









var OrderSummary01RouteKR_OrderSummary01Route =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary01RouteKR__inherits(OrderSummary01Route, _React$Component);

  function OrderSummary01Route(props) {
    var _this;

    OrderSummary01RouteKR__classCallCheck(this, OrderSummary01Route);

    _this = OrderSummary01RouteKR__possibleConstructorReturn(this, (OrderSummary01Route.__proto__ || Object.getPrototypeOf(OrderSummary01Route)).call(this, props));
    _this.state = {
      openStaticMap: false
    };
    _this.onClickShowStaticMap = _this.onClickShowStaticMap.bind(OrderSummary01RouteKR__assertThisInitialized(_this));
    return _this;
  }

  OrderSummary01RouteKR__createClass(OrderSummary01Route, [{
    key: "onClickShowStaticMap",
    value: function onClickShowStaticMap() {
      this.setState({
        openStaticMap: !this.state.openStaticMap
      });
    }
  }, {
    key: "render",
    value: function render() {
      return OrderSummary01RouteKR__jsx("div", {
        className: Order_default.a.summaryLocation
      }, void 0, OrderSummary01RouteKR__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_route_title), OrderSummary01RouteKR__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary01RouteKR__jsx("dl", {
        className: style_default.a.address
      }, void 0, this.props.orderDetailInfo.waypoints_attributes.map(function (i, index) {
        return OrderSummary01RouteKR__jsx("div", {}, index.toString(), OrderSummary01RouteKR__jsx("dd", {
          style: {
            whiteSpace: 'nowrap'
          }
        }, void 0, typeof i.detail_address !== 'undefined' ? "".concat(i.detail_address, ", ").concat(i.address) : i.address.toString()));
      })));
    }
  }]);

  return OrderSummary01Route;
}(react_default.a.Component);

var OrderSummary01RouteKR_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary01RouteKR = (Object(es["b" /* connect */])(OrderSummary01RouteKR_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary01RouteKR_OrderSummary01Route)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary03Vehicle/OrderSummary03VehicleKR.js
function OrderSummary03VehicleKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary03VehicleKR__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary03VehicleKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary03VehicleKR__typeof(obj); }

var OrderSummary03VehicleKR_REACT_ELEMENT_TYPE;

function OrderSummary03VehicleKR__jsx(type, props, key, children) { if (!OrderSummary03VehicleKR_REACT_ELEMENT_TYPE) { OrderSummary03VehicleKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary03VehicleKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary03VehicleKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary03VehicleKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary03VehicleKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary03VehicleKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary03VehicleKR__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary03VehicleKR__possibleConstructorReturn(self, call) { if (call && (OrderSummary03VehicleKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary03VehicleKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary03VehicleKR_OrderSummary03VehicleKR =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary03VehicleKR__inherits(OrderSummary03VehicleKR, _React$Component);

  function OrderSummary03VehicleKR() {
    OrderSummary03VehicleKR__classCallCheck(this, OrderSummary03VehicleKR);

    return OrderSummary03VehicleKR__possibleConstructorReturn(this, (OrderSummary03VehicleKR.__proto__ || Object.getPrototypeOf(OrderSummary03VehicleKR)).apply(this, arguments));
  }

  OrderSummary03VehicleKR__createClass(OrderSummary03VehicleKR, [{
    key: "getVehicleTypes",
    value: function getVehicleTypes() {
      if (this.props.orderDetailInfo.service_type === 'delivery') {
        switch (this.props.orderDetailInfo.vehicle) {
          case 'damas':
            return 0;

          case 'labo':
            return 1;

          case 'ton1':
            return 2;

          case 'ton1_2_and_ton1_4':
            return 3;

          default:
            return 4;
        }
      } else {
        switch (this.props.orderDetailInfo.vehicle) {
          case 'ton1':
            return 0;

          default:
            return 1;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return OrderSummary03VehicleKR__jsx("div", {
        className: "".concat(style_default.a.summaryVehicle)
      }, void 0, OrderSummary03VehicleKR__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_vehicle_title), OrderSummary03VehicleKR__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary03VehicleKR__jsx("span", {}, void 0, this.props.modelData.order_model_data.vehicle_types[this.props.orderDetailInfo.service_type][this.getVehicleTypes()].title));
    }
  }]);

  return OrderSummary03VehicleKR;
}(react_default.a.Component);

Object.defineProperty(OrderSummary03VehicleKR_OrderSummary03VehicleKR, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    modelData: ''
  }
});

var OrderSummary03VehicleKR_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary03Vehicle_OrderSummary03VehicleKR = (Object(es["b" /* connect */])(OrderSummary03VehicleKR_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary03VehicleKR_OrderSummary03VehicleKR)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary09Service/OrderSummary09Service.js
function OrderSummary09Service__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary09Service__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary09Service__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary09Service__typeof(obj); }

var OrderSummary09Service_REACT_ELEMENT_TYPE;

function OrderSummary09Service__jsx(type, props, key, children) { if (!OrderSummary09Service_REACT_ELEMENT_TYPE) { OrderSummary09Service_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary09Service_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary09Service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary09Service__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary09Service__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary09Service__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary09Service__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary09Service__possibleConstructorReturn(self, call) { if (call && (OrderSummary09Service__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary09Service__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary09Service_OrderSummary09Service =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary09Service__inherits(OrderSummary09Service, _React$Component);

  function OrderSummary09Service() {
    OrderSummary09Service__classCallCheck(this, OrderSummary09Service);

    return OrderSummary09Service__possibleConstructorReturn(this, (OrderSummary09Service.__proto__ || Object.getPrototypeOf(OrderSummary09Service)).apply(this, arguments));
  }

  OrderSummary09Service__createClass(OrderSummary09Service, [{
    key: "getServiceTypeIndex",
    value: function getServiceTypeIndex() {
      if (this.props.currentLocale === 'en-SG') {
        switch (this.props.orderDetailInfo.service_type) {
          case 'delivery':
            return 0;

          case 'transport':
            return 1;

          default:
            return 2;
        }
      } else {
        switch (this.props.orderDetailInfo.service_type) {
          case 'transport':
            return 0;

          case 'delivery':
            return 1;

          case 'moving':
            return 2;

          default:
            return 3;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return OrderSummary09Service__jsx("div", {
        className: "".concat(style_default.a.summaryVehicle)
      }, void 0, OrderSummary09Service__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_service_title), OrderSummary09Service__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary09Service__jsx("span", {}, void 0, this.props.modelData.order_model_data.service_types[this.getServiceTypeIndex()].title));
    }
  }]);

  return OrderSummary09Service;
}(react_default.a.Component);

var OrderSummary09Service_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary09Service_OrderSummary09Service = (Object(es["b" /* connect */])(OrderSummary09Service_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary09Service_OrderSummary09Service)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary10TransportItem/OrderSummary10TransportItem.js
function OrderSummary10TransportItem__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary10TransportItem__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary10TransportItem__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary10TransportItem__typeof(obj); }

var OrderSummary10TransportItem_REACT_ELEMENT_TYPE;

function OrderSummary10TransportItem__jsx(type, props, key, children) { if (!OrderSummary10TransportItem_REACT_ELEMENT_TYPE) { OrderSummary10TransportItem_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary10TransportItem_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary10TransportItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary10TransportItem__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary10TransportItem__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary10TransportItem__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary10TransportItem__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary10TransportItem__possibleConstructorReturn(self, call) { if (call && (OrderSummary10TransportItem__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary10TransportItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderSummary10TransportItem_OrderSummary10TransportItem =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary10TransportItem__inherits(OrderSummary10TransportItem, _React$Component);

  function OrderSummary10TransportItem() {
    OrderSummary10TransportItem__classCallCheck(this, OrderSummary10TransportItem);

    return OrderSummary10TransportItem__possibleConstructorReturn(this, (OrderSummary10TransportItem.__proto__ || Object.getPrototypeOf(OrderSummary10TransportItem)).apply(this, arguments));
  }

  OrderSummary10TransportItem__createClass(OrderSummary10TransportItem, [{
    key: "getServiceTypeIndex",
    value: function getServiceTypeIndex() {
      switch (this.props.orderDetailInfo.item_type) {
        case 'documents':
          return 0;

        case 'small_box':
          return 1;

        case 'big_box':
          return 2;

        case 'food':
          return 4;

        default:
          return 5;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return OrderSummary10TransportItem__jsx("div", {
        className: "".concat(style_default.a.summaryVehicle)
      }, void 0, OrderSummary10TransportItem__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_transport_item_title), OrderSummary10TransportItem__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary10TransportItem__jsx("span", {}, void 0, this.props.modelData.order_model_data.goods_types[this.getServiceTypeIndex()].title));
    }
  }]);

  return OrderSummary10TransportItem;
}(react_default.a.Component);

var OrderSummary10TransportItem_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

/* harmony default export */ var OrderSummary_OrderSummary10TransportItem_OrderSummary10TransportItem = (Object(es["b" /* connect */])(OrderSummary10TransportItem_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary10TransportItem_OrderSummary10TransportItem)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/OrderSummary13Payment/OrderSummary13PaymentKR.js
function OrderSummary13PaymentKR__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderSummary13PaymentKR__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderSummary13PaymentKR__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderSummary13PaymentKR__typeof(obj); }

var OrderSummary13PaymentKR_REACT_ELEMENT_TYPE;

function OrderSummary13PaymentKR__jsx(type, props, key, children) { if (!OrderSummary13PaymentKR_REACT_ELEMENT_TYPE) { OrderSummary13PaymentKR_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderSummary13PaymentKR_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderSummary13PaymentKR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderSummary13PaymentKR__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderSummary13PaymentKR__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderSummary13PaymentKR__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderSummary13PaymentKR__defineProperties(Constructor, staticProps); return Constructor; }

function OrderSummary13PaymentKR__possibleConstructorReturn(self, call) { if (call && (OrderSummary13PaymentKR__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderSummary13PaymentKR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OrderSummary13PaymentKR__ref = OrderSummary13PaymentKR__jsx("br", {}, "1");

var OrderSummary13PaymentKR_OrderSummary13Payment =
/*#__PURE__*/
function (_React$Component) {
  OrderSummary13PaymentKR__inherits(OrderSummary13Payment, _React$Component);

  function OrderSummary13Payment() {
    OrderSummary13PaymentKR__classCallCheck(this, OrderSummary13Payment);

    return OrderSummary13PaymentKR__possibleConstructorReturn(this, (OrderSummary13Payment.__proto__ || Object.getPrototypeOf(OrderSummary13Payment)).apply(this, arguments));
  }

  OrderSummary13PaymentKR__createClass(OrderSummary13Payment, [{
    key: "onClickUpdatePaymentMethod",
    value: function onClickUpdatePaymentMethod(e) {
      console.warn(e);
      this.props.updateOrderDetailInfoAction('payment_method', null, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return OrderSummary13PaymentKR__jsx("div", {
        className: "".concat(style_default.a.summaryPPassenger)
      }, void 0, OrderSummary13PaymentKR__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order_summary_payment_title), OrderSummary13PaymentKR__jsx("hr", {
        className: Order_default.a.hrBottom
      }), OrderSummary13PaymentKR__jsx(reactstrap_es["n" /* Row */], {}, void 0, this.props.modelData.order_model_data.payment_method.map(function (p) {
        return [OrderSummary13PaymentKR__jsx(reactstrap_es["b" /* Col */], {
          md: "12",
          xs: "12",
          style: {
            marginLeft: '15px'
          }
        }, "0", OrderSummary13PaymentKR__jsx(reactstrap_es["i" /* Input */], {
          type: "radio",
          name: p.option_name,
          value: p.option_code,
          checked: _this.props.orderDetailInfo.payment_method === p.option_code,
          onChange: function onChange() {
            _this.onClickUpdatePaymentMethod(p.option_code);
          }
        }), OrderSummary13PaymentKR__jsx("span", {
          style: {
            cursor: 'pointer'
          },
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            _this.onClickUpdatePaymentMethod(p.option_code);
          },
          onKeyPress: function onKeyPress() {}
        }, void 0, p.title), typeof p.details !== 'undefined' ? OrderSummary13PaymentKR__jsx("span", {
          className: Order_default.a.summaryPaymentOptionDetails
        }, void 0, p.details) : ''), OrderSummary13PaymentKR__ref];
      })));
    }
  }]);

  return OrderSummary13Payment;
}(react_default.a.Component);

var OrderSummary13PaymentKR_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var OrderSummary13PaymentKR_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var OrderSummary13PaymentKR = (Object(es["b" /* connect */])(OrderSummary13PaymentKR_mapState, OrderSummary13PaymentKR_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(OrderSummary13PaymentKR_OrderSummary13Payment)));
// EXTERNAL MODULE: ./src/assets/src/scripts/gogovan/show/kr/kr.json
var kr = __webpack_require__(923);
var kr_default = /*#__PURE__*/__webpack_require__.n(kr);

// CONCATENATED MODULE: ./src/routes/OrderSummary/krOrderSummary.js
function krOrderSummary__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { krOrderSummary__typeof = function _typeof(obj) { return typeof obj; }; } else { krOrderSummary__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return krOrderSummary__typeof(obj); }

var krOrderSummary_REACT_ELEMENT_TYPE;

function krOrderSummary__jsx(type, props, key, children) { if (!krOrderSummary_REACT_ELEMENT_TYPE) { krOrderSummary_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: krOrderSummary_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function krOrderSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function krOrderSummary__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function krOrderSummary__createClass(Constructor, protoProps, staticProps) { if (protoProps) krOrderSummary__defineProperties(Constructor.prototype, protoProps); if (staticProps) krOrderSummary__defineProperties(Constructor, staticProps); return Constructor; }

function krOrderSummary__possibleConstructorReturn(self, call) { if (call && (krOrderSummary__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function krOrderSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var krOrderSummary__ref = krOrderSummary__jsx("br", {});

var krOrderSummary_krOrderSummary =
/*#__PURE__*/
function (_React$Component) {
  krOrderSummary__inherits(krOrderSummary, _React$Component);

  function krOrderSummary() {
    krOrderSummary__classCallCheck(this, krOrderSummary);

    return krOrderSummary__possibleConstructorReturn(this, (krOrderSummary.__proto__ || Object.getPrototypeOf(krOrderSummary)).apply(this, arguments));
  }

  krOrderSummary__createClass(krOrderSummary, [{
    key: "render",
    value: function render() {
      return krOrderSummary__jsx("div", {
        className: "".concat(Order_default.a.orderSummary),
        style: {
          display: 'block'
        }
      }, void 0, krOrderSummary__jsx("section", {
        className: Order_default.a.orderSummary
      }, void 0, krOrderSummary__jsx("div", {}, void 0, krOrderSummary__jsx("h2", {}, void 0, kr_default.a.show.order_summary_title))), krOrderSummary__jsx(OrderSummary01RouteKR, {
        modelDataText: this.props.modelDataText
      }), krOrderSummary__jsx(OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime, {
        modelDataText: this.props.modelDataText,
        value: dateformat_default()(this.props.orderDetailInfo.pickup_time, 'dd mmmm, yyyy ,HH:MM')
      }), krOrderSummary__jsx(OrderSummary_OrderSummary09Service_OrderSummary09Service, {
        modelDataText: this.props.modelDataText,
        modelData: this.props.modelData
      }), typeof this.props.orderDetailInfo.item_type !== 'undefined' ? krOrderSummary__jsx(OrderSummary_OrderSummary10TransportItem_OrderSummary10TransportItem, {
        modelDataText: this.props.modelDataText,
        modelData: this.props.modelData
      }) : '', ['delivery', 'moving'].includes(this.props.orderDetailInfo.service_type) ? krOrderSummary__jsx(OrderSummary03Vehicle_OrderSummary03VehicleKR, {
        modelDataText: this.props.modelDataText,
        modelData: this.props.modelData
      }) : '', krOrderSummary__jsx(OrderSummary_OrderSummary06Remark_OrderSummary06Remark, {
        modelDataText: this.props.modelDataText,
        value: [this.props.orderDetailInfo.order_request_detail_attributes.remark]
      }), krOrderSummary__jsx(OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo, {
        modelDataText: this.props.modelDataText
      }), this.props.orderDetailInfo.order_request_extra_attributes.receiver_name === '' ? '' : krOrderSummary__jsx(OrderSummary_OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo, {
        modelDataText: this.props.modelDataText
      }), krOrderSummary__jsx(OrderSummary_OrderSummary11Fee_OrderSummary11Fee, {
        modelDataText: kr_default.a.show
      }), krOrderSummary__jsx(OrderSummary13PaymentKR, {
        modelDataText: this.props.modelDataText,
        modelData: this.props.modelData
      }), krOrderSummary__ref, krOrderSummary__jsx(OrderSummary_OrderSummarySumbitButton, {
        modelDataText: this.props.modelDataText,
        onClickConfirm: this.props.onClickConfirm
      }));
    }
  }]);

  return krOrderSummary;
}(react_default.a.Component);

var krOrderSummary_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var krOrderSummary_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var OrderSummary_krOrderSummary = (Object(es["b" /* connect */])(krOrderSummary_mapState, krOrderSummary_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(krOrderSummary_krOrderSummary)));
// CONCATENATED MODULE: ./src/routes/order/krOrder.js
function krOrder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { krOrder__typeof = function _typeof(obj) { return typeof obj; }; } else { krOrder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return krOrder__typeof(obj); }

var krOrder_REACT_ELEMENT_TYPE;

function krOrder__jsx(type, props, key, children) { if (!krOrder_REACT_ELEMENT_TYPE) { krOrder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: krOrder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function krOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function krOrder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function krOrder__createClass(Constructor, protoProps, staticProps) { if (protoProps) krOrder__defineProperties(Constructor.prototype, protoProps); if (staticProps) krOrder__defineProperties(Constructor, staticProps); return Constructor; }

function krOrder__possibleConstructorReturn(self, call) { if (call && (krOrder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function krOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import




















var krOrder__ref = krOrder__jsx("br", {});

var krOrder__ref2 = krOrder__jsx("br", {});

var krOrder__ref3 = krOrder__jsx(simpleMessageDialog, {});

var krOrder_twOrder =
/*#__PURE__*/
function (_React$Component) {
  krOrder__inherits(twOrder, _React$Component);

  function twOrder() {
    krOrder__classCallCheck(this, twOrder);

    return krOrder__possibleConstructorReturn(this, (twOrder.__proto__ || Object.getPrototypeOf(twOrder)).apply(this, arguments));
  }

  krOrder__createClass(twOrder, [{
    key: "render",
    value: function render() {
      return krOrder__jsx("div", {
        className: "".concat(Order_default.a.orderPage)
      }, void 0, krOrder__jsx("div", {
        className: "".concat(Order_default.a.fixedContainer)
      }, void 0, krOrder__jsx(lib_slidedown["SlideDown"], {
        closed: !this.props.isShowOrderDetail
      }, void 0, this.props.isShowOrderDetail && this.props.orderDetailInfo.service_type !== 'big_cargo' ? krOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, krOrder__jsx(OrderSummary_krOrderSummary, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm,
        modelData: this.props.modelData
      })) : ''), krOrder__jsx(lib_slidedown["SlideDown"], {
        closed: this.props.isShowOrderDetail
      }, void 0, krOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, krOrder__jsx("h2", {
        className: Order_default.a.headline
      }, void 0, this.props.modelDataText.order.order_headline), krOrder__jsx("hr", {
        className: Order_default.a.hrTitle
      }), krOrder__jsx(Order01SelectVehicleKR, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), krOrder__jsx("div", {
        style: this.props.orderDetailInfo.service_type === 'big_cargo' ? {
          display: 'none'
        } : {}
      }, void 0, krOrder__jsx(order09Path_Order09Path, {
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), krOrder__jsx(order_Order10PickupTime_Order10PickupTime, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), krOrder__jsx(Order05Type_Order05TypesKR, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        serviceTypes: this.props.orderDetailInfo.service_type
      }), krOrder__jsx(order_Order18AddPhoto_Order18AddPhoto, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), this.props.orderDetailInfo.service_type !== 'big_cargo' ? krOrder__jsx(order_Order12AddService_Order12AddService, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }) : '', krOrder__jsx(Order14ContactInfoWithSGKR, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), krOrder__ref, krOrder__ref2, krOrder__jsx("hr", {
        className: Order_default.a.hrTotalPrice
      }), krOrder__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, krOrder__jsx(order_Order19Total_Order19Total, {
        modelDataText: this.props.modelDataText.order
      }), krOrder__jsx(order_Order20Coupon_Order20Coupon, {
        modelDataText: this.props.modelDataText.order
      })), krOrder__jsx(order_Order21Confirm_Order21Confirm, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm
      }))))), krOrder__jsx(Dialog_extraMessageDialog, {
        message: this.props.orderPriceBreakdownDetail.extra_message
      }), krOrder__ref3);
    }
  }]);

  return twOrder;
}(react_default.a.Component);

var krOrder_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var krOrder_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var krOrder = (Object(es["b" /* connect */])(krOrder_mapState, krOrder_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(krOrder_twOrder)));
// CONCATENATED MODULE: ./src/routes/order/Order01SelectService/Order01SelectService.js
function Order01SelectService__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order01SelectService__typeof = function _typeof(obj) { return typeof obj; }; } else { Order01SelectService__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order01SelectService__typeof(obj); }

var Order01SelectService_REACT_ELEMENT_TYPE;

function Order01SelectService__jsx(type, props, key, children) { if (!Order01SelectService_REACT_ELEMENT_TYPE) { Order01SelectService_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order01SelectService_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order01SelectService__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order01SelectService__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order01SelectService__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order01SelectService__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order01SelectService__defineProperties(Constructor, staticProps); return Constructor; }

function Order01SelectService__possibleConstructorReturn(self, call) { if (call && (Order01SelectService__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order01SelectService__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import



 // Relative import









var Order01SelectService__ref = Order01SelectService__jsx("br", {});

var Order01SelectService__ref2 = Order01SelectService__jsx("br", {});

var Order01SelectService_Order01SelectService =
/*#__PURE__*/
function (_React$Component) {
  Order01SelectService__inherits(Order01SelectService, _React$Component);

  function Order01SelectService(props) {
    var _this;

    Order01SelectService__classCallCheck(this, Order01SelectService);

    _this = Order01SelectService__possibleConstructorReturn(this, (Order01SelectService.__proto__ || Object.getPrototypeOf(Order01SelectService)).call(this, props));
    _this.state = {
      selectedService: ''
    };
    return _this;
  }

  Order01SelectService__createClass(Order01SelectService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // In fact is Service not vehicle, but paramater name match other language
      var currentSelectedVehicle = Object(localStorage["b" /* localStorageGet */])('selectedVehicle', false); // get selectedVehicle, then remove this in localStorage

      if (currentSelectedVehicle !== null) {
        this.onClickSelectVehicle(currentSelectedVehicle);
        this.onClickSelectServiceTypes(currentSelectedVehicle);
      } else {
        this.onClickSelectVehicle(this.props.modelData.service_types[0].value);
      }
    }
  }, {
    key: "onClickSelectVehicle",
    value: function onClickSelectVehicle(type) {
      this.setState({
        selectedService: type
      }); // this.setState({ selectedVehicle: type });

      this.props.updateOrderDetailInfoAction('service_type', null, type);
    }
  }, {
    key: "onClickSelectServiceTypes",
    value: function onClickSelectServiceTypes(type) {
      // this.props.setOrderVehicleType(type);
      this.setState({
        selectedService: type
      });

      if (type === 'delivery') {
        this.props.updateOrderDetailInfoAction('service_type', null, type);
        this.props.updateOrderDetailInfoAction('goods', null, 'Parcel');
        this.props.updateOrderDetailInfoAction('vehicle', null, 'sedan');
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'additional_cartons', '1');
      } else {
        this.props.updateOrderDetailInfoAction(null, null, removeByKey(this.props.orderDetailInfo, 'goods')); // after delete goods, then update the orderDetailInfo

        this.props.updateOrderDetailInfoAction('service_type', null, type);
        this.props.updateOrderDetailInfoAction('vehicle', null, 'van');
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {
          num_movers: ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return Order01SelectService__jsx("div", {}, void 0, Order01SelectService__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_service_title), Order01SelectService__jsx(reactstrap_es["n" /* Row */], {}, void 0, this.props.modelData.service_types.map(function (obj, index) {
        var img = obj.icon.toString();
        var img1 = img.split(',')[0].split(' ')[0];
        img1 = img1.split('/').reverse()[0].split('.')[0];

        var imgBlueVehicle = __webpack_require__(970)("./".concat(img1, ".png"));

        var imgBlueVehicle2 = __webpack_require__(971)("./".concat(img1, "@2x.png"));

        return Order01SelectService__jsx(reactstrap_es["b" /* Col */], {
          xs: "12",
          sm: "12",
          md: "4"
        }, index.toString(), Order01SelectService__jsx("div", {
          className: "".concat(_this2.state.selectedService === obj.value ? Order_default.a.vehicleGridActive : [Order_default.a.vehicleGrid, Order_default.a.selectVehicle].join(' ')),
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            _this2.onClickSelectServiceTypes(obj.value);
          },
          onKeyPress: function onKeyPress() {}
        }, void 0, Order01SelectService__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order01SelectService__jsx(reactstrap_es["b" /* Col */], {
          md: "12",
          xs: "3"
        }, void 0, Order01SelectService__jsx("img", {
          height: "45",
          alt: obj.title,
          srcSet: "".concat(imgBlueVehicle, " 1x, ").concat(imgBlueVehicle2, " 2x")
        }), Order01SelectService__ref, Order01SelectService__ref2), Order01SelectService__jsx(reactstrap_es["b" /* Col */], {
          md: "12"
        }, void 0, Order01SelectService__jsx("span", {
          dangerouslySetInnerHTML: {
            __html: obj.title
          },
          style: {
            color: '#0088bf'
          }
        })))));
      })));
    }
  }]);

  return Order01SelectService;
}(react_default.a.Component);

var Order01SelectService_mapState = function mapState(state) {
  return {
    isToggleOn: state.order.isToggleOn,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order01SelectService_mapDispatch = {
  setOrderVehicleType: actions_order["q" /* setOrderVehicleType */],
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */],
  setIsShowSimpleMessageDialog: actions_dialog["k" /* setIsShowSimpleMessageDialog */],
  setSimpleMessage: actions_dialog["m" /* setSimpleMessage */]
};
/* harmony default export */ var order_Order01SelectService_Order01SelectService = (Object(es["b" /* connect */])(Order01SelectService_mapState, Order01SelectService_mapDispatch)(withStyles_default()(bootstrap_default.a, Order_default.a)(Order01SelectService_Order01SelectService)));
// CONCATENATED MODULE: ./src/routes/order/Order16FeeBreakdown/Order16FeeBreakdown.js
function Order16FeeBreakdown__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order16FeeBreakdown__typeof = function _typeof(obj) { return typeof obj; }; } else { Order16FeeBreakdown__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order16FeeBreakdown__typeof(obj); }

var Order16FeeBreakdown_REACT_ELEMENT_TYPE;

function Order16FeeBreakdown__jsx(type, props, key, children) { if (!Order16FeeBreakdown_REACT_ELEMENT_TYPE) { Order16FeeBreakdown_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order16FeeBreakdown_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order16FeeBreakdown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order16FeeBreakdown__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order16FeeBreakdown__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order16FeeBreakdown__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order16FeeBreakdown__defineProperties(Constructor, staticProps); return Constructor; }

function Order16FeeBreakdown__possibleConstructorReturn(self, call) { if (call && (Order16FeeBreakdown__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order16FeeBreakdown__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Order16FeeBreakdown_tips = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

var Order16FeeBreakdown__ref = Order16FeeBreakdown__jsx("br", {});

var Order16FeeBreakdown__ref2 = Order16FeeBreakdown__jsx("br", {});

var Order16FeeBreakdown_Order16FeeBreakdown =
/*#__PURE__*/
function (_React$Component) {
  Order16FeeBreakdown__inherits(Order16FeeBreakdown, _React$Component);

  function Order16FeeBreakdown() {
    Order16FeeBreakdown__classCallCheck(this, Order16FeeBreakdown);

    return Order16FeeBreakdown__possibleConstructorReturn(this, (Order16FeeBreakdown.__proto__ || Object.getPrototypeOf(Order16FeeBreakdown)).apply(this, arguments));
  }

  Order16FeeBreakdown__createClass(Order16FeeBreakdown, [{
    key: "getTips",
    value: function getTips() {
      if (this.props.currentLocale.split('-')[0].toLowerCase() === 'tw') {
        return Order16FeeBreakdown_tips.map(function (x) {
          return x * 2;
        });
      }

      return Order16FeeBreakdown_tips;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order16FeeBreakdown__jsx("div", {
        className: Order_default.a.fee
      }, void 0, Order16FeeBreakdown__jsx("p", {
        className: Order_default.a.orderSmallTitle
      }, void 0, "FEE BREAKDOWN"), Order16FeeBreakdown__jsx("hr", {
        className: Order_default.a.hrBottom
      }), Order16FeeBreakdown__jsx("span", {}, void 0, typeof this.props.orderPriceBreakdownDetail.breakdown !== 'undefined' ? Object.keys(this.props.orderPriceBreakdownDetail.breakdown).map(function (v, index) {
        return Order16FeeBreakdown__jsx("div", {}, index.toString(), Order16FeeBreakdown__jsx("span", {}, void 0, _this.props.orderPriceBreakdownDetail.breakdown[v].title), Order16FeeBreakdown__jsx("span", {
          style: {
            float: 'right'
          }
        }, void 0, typeof _this.props.orderPriceBreakdownDetail.breakdown[v].value === 'number' ? "".concat(_this.props.modelDataText.dollar_code) : '', _this.props.orderPriceBreakdownDetail.breakdown[v].value));
      }) : ''), Order16FeeBreakdown__ref, Order16FeeBreakdown__ref2);
    }
  }]);

  return Order16FeeBreakdown;
}(react_default.a.Component);

var Order16FeeBreakdown_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order16FeeBreakdown_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var order_Order16FeeBreakdown_Order16FeeBreakdown = (Object(es["b" /* connect */])(Order16FeeBreakdown_mapState, Order16FeeBreakdown_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order16FeeBreakdown_Order16FeeBreakdown)));
// CONCATENATED MODULE: ./src/routes/order/Order05Type/Order05DeliveryItemOrVehicleTypesSG.js
function Order05DeliveryItemOrVehicleTypesSG__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order05DeliveryItemOrVehicleTypesSG__typeof = function _typeof(obj) { return typeof obj; }; } else { Order05DeliveryItemOrVehicleTypesSG__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order05DeliveryItemOrVehicleTypesSG__typeof(obj); }

var Order05DeliveryItemOrVehicleTypesSG_REACT_ELEMENT_TYPE;

function Order05DeliveryItemOrVehicleTypesSG__jsx(type, props, key, children) { if (!Order05DeliveryItemOrVehicleTypesSG_REACT_ELEMENT_TYPE) { Order05DeliveryItemOrVehicleTypesSG_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order05DeliveryItemOrVehicleTypesSG_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order05DeliveryItemOrVehicleTypesSG__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order05DeliveryItemOrVehicleTypesSG__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order05DeliveryItemOrVehicleTypesSG__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order05DeliveryItemOrVehicleTypesSG__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order05DeliveryItemOrVehicleTypesSG__defineProperties(Constructor, staticProps); return Constructor; }

function Order05DeliveryItemOrVehicleTypesSG__possibleConstructorReturn(self, call) { if (call && (Order05DeliveryItemOrVehicleTypesSG__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order05DeliveryItemOrVehicleTypesSG__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import






var Order05DeliveryItemOrVehicleTypesSG__ref = Order05DeliveryItemOrVehicleTypesSG__jsx("br", {});

var Order05DeliveryItemOrVehicleTypesSG_Order05DeliveryItemOrVehicleTypesSG =
/*#__PURE__*/
function (_React$Component) {
  Order05DeliveryItemOrVehicleTypesSG__inherits(Order05DeliveryItemOrVehicleTypesSG, _React$Component);

  function Order05DeliveryItemOrVehicleTypesSG() {
    Order05DeliveryItemOrVehicleTypesSG__classCallCheck(this, Order05DeliveryItemOrVehicleTypesSG);

    return Order05DeliveryItemOrVehicleTypesSG__possibleConstructorReturn(this, (Order05DeliveryItemOrVehicleTypesSG.__proto__ || Object.getPrototypeOf(Order05DeliveryItemOrVehicleTypesSG)).apply(this, arguments));
  }

  Order05DeliveryItemOrVehicleTypesSG__createClass(Order05DeliveryItemOrVehicleTypesSG, [{
    key: "onClickToggleType",
    value: function onClickToggleType(e) {
      if (e.target.value.split(',')[0] === 'Parcel') {
        this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
        this.props.updateOrderDetailInfoAction('vehicle', null, 'sedan');
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'additional_cartons', 1);
      } else {
        this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
        this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value.split(',')[1]);
        this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
      }
    }
  }, {
    key: "onClickToggleItemType",
    value: function onClickToggleItemType(e) {
      this.props.updateOrderDetailInfoAction('goods', null, e.target.value);
    }
  }, {
    key: "onClickParcelCount",
    value: function onClickParcelCount(e) {
      var count = e.target.value;
      this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'additional_cartons', count);
      this.props.updateOrderDetailInfoAction('vehicle', null, 'sedan');
    }
  }, {
    key: "getTypesDetailOption",
    value: function getTypesDetailOption() {
      // this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
      if (this.props.serviceTypes === 'delivery') {
        return this.props.modelData.goods_types;
      }

      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order05DeliveryItemOrVehicleTypesSG__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05DeliveryItemOrVehicleTypesSG__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05DeliveryItemOrVehicleTypesSG__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_goods_title)), Order05DeliveryItemOrVehicleTypesSG__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05DeliveryItemOrVehicleTypesSG__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this.onClickToggleType(e);
        }
      }, void 0, this.getTypesDetailOption().map(function (good, index) {
        return Order05DeliveryItemOrVehicleTypesSG__jsx("option", {
          value: [good.value, good.vehicle],
          defaultValue: index === 0 ? '' : false
        }, index.toString(), good.title);
      }))), this.props.serviceTypes === 'delivery' && this.props.orderDetailInfo.goods === 'Parcel' ? Order05DeliveryItemOrVehicleTypesSG__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05DeliveryItemOrVehicleTypesSG__jsx("p", {
        className: "".concat(style_default.a.globalTextRed, " ").concat(style_default.a.globalFontNormal, " ").concat(Order_default.a.orderWarningText)
      }, void 0, this.props.modelDataText.order.order_parcel_title), Order05DeliveryItemOrVehicleTypesSG__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this.onClickParcelCount(e);
        }
      }, void 0, this.props.modelData.parcel_types.map(function (item, index) {
        return Order05DeliveryItemOrVehicleTypesSG__jsx("option", {
          value: item.value,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), item.title);
      })), Order05DeliveryItemOrVehicleTypesSG__ref) : '');
    }
  }]);

  return Order05DeliveryItemOrVehicleTypesSG;
}(react_default.a.Component);

var Order05DeliveryItemOrVehicleTypesSG_mapState = function mapState(state) {
  return {
    images: state.order.images,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order05DeliveryItemOrVehicleTypesSG_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order05Type_Order05DeliveryItemOrVehicleTypesSG = (Object(es["b" /* connect */])(Order05DeliveryItemOrVehicleTypesSG_mapState, Order05DeliveryItemOrVehicleTypesSG_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order05DeliveryItemOrVehicleTypesSG_Order05DeliveryItemOrVehicleTypesSG)));
// CONCATENATED MODULE: ./src/routes/order/Order05Type/Order05VehicleTypesSG.js
function Order05VehicleTypesSG__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order05VehicleTypesSG__typeof = function _typeof(obj) { return typeof obj; }; } else { Order05VehicleTypesSG__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order05VehicleTypesSG__typeof(obj); }

var Order05VehicleTypesSG_REACT_ELEMENT_TYPE;

function Order05VehicleTypesSG__jsx(type, props, key, children) { if (!Order05VehicleTypesSG_REACT_ELEMENT_TYPE) { Order05VehicleTypesSG_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order05VehicleTypesSG_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order05VehicleTypesSG__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order05VehicleTypesSG__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order05VehicleTypesSG__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order05VehicleTypesSG__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order05VehicleTypesSG__defineProperties(Constructor, staticProps); return Constructor; }

function Order05VehicleTypesSG__possibleConstructorReturn(self, call) { if (call && (Order05VehicleTypesSG__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order05VehicleTypesSG__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import






var Order05VehicleTypesSG_Order05DeliveryItemOrVehicleTypesSG =
/*#__PURE__*/
function (_React$Component) {
  Order05VehicleTypesSG__inherits(Order05DeliveryItemOrVehicleTypesSG, _React$Component);

  function Order05DeliveryItemOrVehicleTypesSG() {
    Order05VehicleTypesSG__classCallCheck(this, Order05DeliveryItemOrVehicleTypesSG);

    return Order05VehicleTypesSG__possibleConstructorReturn(this, (Order05DeliveryItemOrVehicleTypesSG.__proto__ || Object.getPrototypeOf(Order05DeliveryItemOrVehicleTypesSG)).apply(this, arguments));
  }

  Order05VehicleTypesSG__createClass(Order05DeliveryItemOrVehicleTypesSG, [{
    key: "onClickToggleType",
    value: function onClickToggleType(e) {
      this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value); // if (e.target.value.split(',')[0] === 'Parcel') {
      //   this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
      //   this.props.updateOrderDetailInfoAction('vehicle', null, 'sedan');
      //   this.props.updateOrderDetailInfoAction('order_request_detail_attributes', 'additional_cartons', 1);
      // } else {
      //   this.props.updateOrderDetailInfoAction('goods', null, e.target.value.split(',')[0]);
      //   this.props.updateOrderDetailInfoAction('vehicle', null, e.target.value.split(',')[1]);
      //   this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
      // }
    }
  }, {
    key: "onClickToggleItemType",
    value: function onClickToggleItemType(e) {
      this.props.updateOrderDetailInfoAction('goods', null, e.target.value);
    }
  }, {
    key: "getTypesDetailOption",
    value: function getTypesDetailOption() {
      // this.props.updateOrderDetailInfoAction('order_request_detail_attributes', null, {});
      if (this.props.serviceTypes === 'delivery') {
        return this.props.modelData.goods_types;
      }

      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return Order05VehicleTypesSG__jsx(reactstrap_es["n" /* Row */], {}, void 0, Order05VehicleTypesSG__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05VehicleTypesSG__jsx("div", {
        className: Order_default.a.orderSmallTitle
      }, void 0, this.props.modelDataText.order.order_goods_title)), Order05VehicleTypesSG__jsx(reactstrap_es["b" /* Col */], {
        md: "12",
        xs: "12"
      }, void 0, Order05VehicleTypesSG__jsx("select", {
        className: "".concat(Order_default.a.inputSelect, " ").concat(Order_default.a.backgroundDark, " ").concat(Order_default.a.simpleSelectDropdown, " ").concat(Order_default.a.icon, " ").concat(style_default.a.orderSelectHover, " col-12"),
        onChange: function onChange(e) {
          _this.onClickToggleType(e);
        }
      }, void 0, this.props.modelData.vehicle_types.map(function (v, index) {
        return Order05VehicleTypesSG__jsx("option", {
          value: v.type,
          defaultValue: index === 0 ? '' : false
        }, index.toString(), v.title);
      }))));
    }
  }]);

  return Order05DeliveryItemOrVehicleTypesSG;
}(react_default.a.Component);

var Order05VehicleTypesSG_mapState = function mapState(state) {
  return {
    images: state.order.images,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var Order05VehicleTypesSG_mapDispatch = {
  updateOrderDetailInfoAction: actions_order["t" /* updateOrderDetailInfoAction */]
};
/* harmony default export */ var Order05VehicleTypesSG = (Object(es["b" /* connect */])(Order05VehicleTypesSG_mapState, Order05VehicleTypesSG_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(Order05VehicleTypesSG_Order05DeliveryItemOrVehicleTypesSG)));
// CONCATENATED MODULE: ./src/routes/OrderSummary/sgOrderSummary.js
function sgOrderSummary__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sgOrderSummary__typeof = function _typeof(obj) { return typeof obj; }; } else { sgOrderSummary__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sgOrderSummary__typeof(obj); }

var sgOrderSummary_REACT_ELEMENT_TYPE;

function sgOrderSummary__jsx(type, props, key, children) { if (!sgOrderSummary_REACT_ELEMENT_TYPE) { sgOrderSummary_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: sgOrderSummary_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function sgOrderSummary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sgOrderSummary__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function sgOrderSummary__createClass(Constructor, protoProps, staticProps) { if (protoProps) sgOrderSummary__defineProperties(Constructor.prototype, protoProps); if (staticProps) sgOrderSummary__defineProperties(Constructor, staticProps); return Constructor; }

function sgOrderSummary__possibleConstructorReturn(self, call) { if (call && (sgOrderSummary__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function sgOrderSummary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var sgOrderSummary__ref = sgOrderSummary__jsx("br", {});

var sgOrderSummary_hkOrderSummary =
/*#__PURE__*/
function (_React$Component) {
  sgOrderSummary__inherits(hkOrderSummary, _React$Component);

  function hkOrderSummary() {
    sgOrderSummary__classCallCheck(this, hkOrderSummary);

    return sgOrderSummary__possibleConstructorReturn(this, (hkOrderSummary.__proto__ || Object.getPrototypeOf(hkOrderSummary)).apply(this, arguments));
  }

  sgOrderSummary__createClass(hkOrderSummary, [{
    key: "render",
    value: function render() {
      return sgOrderSummary__jsx("div", {
        className: "".concat(Order_default.a.orderSummary),
        style: {
          display: 'block'
        }
      }, void 0, sgOrderSummary__jsx("section", {
        className: Order_default.a.orderSummary
      }, void 0, sgOrderSummary__jsx("div", {}, void 0, sgOrderSummary__jsx("h2", {}, void 0, en_hk_default.a.order.order_summary_title))), sgOrderSummary__jsx(OrderSummary_OrderSummary01Route_OrderSummary01Route, {
        modelDataText: en_hk_default.a.order
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary02PickupTime_OrderSummary02PickupTime, {
        modelDataText: this.props.modelDataText,
        value: dateformat_default()(this.props.orderDetailInfo.pickup_time, 'dd mmmm, yyyy ,HH:MM')
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary09Service_OrderSummary09Service, {
        modelDataText: en_hk_default.a.order,
        modelData: this.props.modelData
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary03Vehicle_OrderSummary03Vehicle, {
        modelDataText: en_hk_default.a.order,
        modelData: this.props.modelData
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary06Remark_OrderSummary06Remark, {
        modelDataText: en_hk_default.a.order,
        value: [this.props.orderDetailInfo.order_request_detail_attributes.remark]
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary07SenderInfo_OrderSummary07SenderInfo, {
        modelDataText: en_hk_default.a.order
      }), this.props.orderDetailInfo.order_request_extra_attributes.receiver_name === '' ? '' : sgOrderSummary__jsx(OrderSummary_OrderSummary08ReceiverInfo_OrderSummary08ReceiverInfo, {
        modelDataText: this.props.modelDataText
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary11Fee_OrderSummary11Fee, {
        modelDataText: this.props.modelDataText
      }), sgOrderSummary__jsx(OrderSummary_OrderSummary13Payment_OrderSummary13Payment, {
        modelDataText: en_hk_default.a.order
      }), sgOrderSummary__ref, sgOrderSummary__jsx(OrderSummary_OrderSummarySumbitButton, {
        modelDataText: en_hk_default.a.order,
        onClickConfirm: this.props.onClickConfirm
      }));
    }
  }]);

  return hkOrderSummary;
}(react_default.a.Component);

var sgOrderSummary_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    remark: state.order.remark,
    passengerCount: state.order.passenger_count,
    tunnel: state.order.tunnel,
    images: state.order.images,
    vehicle: state.order.vehicle,
    pickupTime: state.order.pickup_time,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var sgOrderSummary_mapDispatch = {
  setIsShowBonusPriceDialog: actions_dialog["d" /* setIsShowBonusPriceDialog */]
};
/* harmony default export */ var sgOrderSummary = (Object(es["b" /* connect */])(sgOrderSummary_mapState, sgOrderSummary_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a)(sgOrderSummary_hkOrderSummary)));
// CONCATENATED MODULE: ./src/routes/order/sgOrder.js
function sgOrder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sgOrder__typeof = function _typeof(obj) { return typeof obj; }; } else { sgOrder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sgOrder__typeof(obj); }

var sgOrder_REACT_ELEMENT_TYPE;

function sgOrder__jsx(type, props, key, children) { if (!sgOrder_REACT_ELEMENT_TYPE) { sgOrder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: sgOrder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function sgOrder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sgOrder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function sgOrder__createClass(Constructor, protoProps, staticProps) { if (protoProps) sgOrder__defineProperties(Constructor.prototype, protoProps); if (staticProps) sgOrder__defineProperties(Constructor, staticProps); return Constructor; }

function sgOrder__possibleConstructorReturn(self, call) { if (call && (sgOrder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function sgOrder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import





 // import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import
























var sgOrder__ref = sgOrder__jsx("br", {});

var sgOrder__ref2 = sgOrder__jsx(simpleMessageDialog, {});

var sgOrder_sgOrder =
/*#__PURE__*/
function (_React$Component) {
  sgOrder__inherits(sgOrder, _React$Component);

  function sgOrder() {
    sgOrder__classCallCheck(this, sgOrder);

    return sgOrder__possibleConstructorReturn(this, (sgOrder.__proto__ || Object.getPrototypeOf(sgOrder)).apply(this, arguments));
  }

  sgOrder__createClass(sgOrder, [{
    key: "render",
    value: function render() {
      return sgOrder__jsx("div", {
        className: "".concat(Order_default.a.orderPage)
      }, void 0, sgOrder__jsx("div", {
        className: "".concat(Order_default.a.fixedContainer)
      }, void 0, sgOrder__jsx(lib_slidedown["SlideDown"], {
        closed: !this.props.isShowOrderDetail
      }, void 0, this.props.isShowOrderDetail ? sgOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, sgOrder__jsx(sgOrderSummary, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm,
        modelData: this.props.modelData
      })) : ''), sgOrder__jsx(lib_slidedown["SlideDown"], {
        closed: this.props.isShowOrderDetail
      }, void 0, sgOrder__jsx("div", {
        className: Order_default.a.formBox
      }, void 0, sgOrder__jsx("h2", {
        className: Order_default.a.headline
      }, void 0, this.props.modelDataText.order.order_headline), sgOrder__jsx("hr", {
        className: Order_default.a.hrTitle
      }), sgOrder__jsx(order_Order01SelectService_Order01SelectService, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), this.props.orderDetailInfo.service_type === 'delivery' ? sgOrder__jsx(Order05Type_Order05DeliveryItemOrVehicleTypesSG, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText,
        serviceTypes: this.props.orderDetailInfo.service_type
      }) : sgOrder__jsx(Order05VehicleTypesSG, {
        currentLocale: this.props.currentLocale,
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText,
        serviceTypes: this.props.orderDetailInfo.service_type
      }), sgOrder__jsx("div", {}, void 0, sgOrder__jsx(order09Path_Order09Path, {
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), sgOrder__jsx(order_Order10PickupTime_Order10PickupTime, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order
      }), this.props.orderDetailInfo.service_type !== 'delivery' ? sgOrder__jsx(order_Order11Movers_Order11Movers, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }) : '', sgOrder__jsx(order_Order12AddService_Order12AddService, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        lang: this.props.lang
      }), sgOrder__ref, sgOrder__jsx(order_Order13Remarks_Order13Remarks, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        fieldParentName: "order_request_detail_attributes",
        fieldChildName: "remark"
      }), sgOrder__jsx(order_Order18AddPhoto_Order18AddPhoto, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText
      }), sgOrder__jsx(Order14ContactInfoWithSGKR, {
        modelData: this.props.modelData.order_model_data,
        modelDataText: this.props.modelDataText.order,
        setting: this.props.setting
      }), sgOrder__jsx(order_Order16FeeBreakdown_Order16FeeBreakdown, {
        modelDataText: this.props.modelDataText.order
      }), sgOrder__jsx("hr", {
        className: Order_default.a.hrTotalPrice
      }), sgOrder__jsx("div", {
        className: Order_default.a.orderPricingRow
      }, void 0, sgOrder__jsx(order_Order19Total_Order19Total, {
        modelDataText: this.props.modelDataText.order
      }), sgOrder__jsx(order_Order20Coupon_Order20Coupon, {
        modelDataText: this.props.modelDataText.order
      })), sgOrder__jsx(order_Order21Confirm_Order21Confirm, {
        modelDataText: this.props.modelDataText.order,
        onClickConfirm: this.props.onClickConfirm
      }))))), sgOrder__jsx(Dialog_extraMessageDialog, {
        message: this.props.orderPriceBreakdownDetail.extra_message
      }), sgOrder__ref2);
    }
  }]);

  return sgOrder;
}(react_default.a.Component);

var sgOrder_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images,
    orderDetailInfo: state.order.orderDetailInfo
  };
};

var sgOrder_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var order_sgOrder = (Object(es["b" /* connect */])(sgOrder_mapState, sgOrder_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(sgOrder_sgOrder)));
// CONCATENATED MODULE: ./src/routes/order/Order.js
function Order__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Order__typeof = function _typeof(obj) { return typeof obj; }; } else { Order__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Order__typeof(obj); }

var Order_REACT_ELEMENT_TYPE;

function Order__jsx(type, props, key, children) { if (!Order_REACT_ELEMENT_TYPE) { Order_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Order_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Order__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Order__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Order__createClass(Constructor, protoProps, staticProps) { if (protoProps) Order__defineProperties(Constructor.prototype, protoProps); if (staticProps) Order__defineProperties(Constructor, staticProps); return Constructor; }

function Order__possibleConstructorReturn(self, call) { if (call && (Order__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Order__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Order__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// Absolute import




 // Relative import






 // import { checkIsLogin } from '../../service/userService';










var Order__ref = Order__jsx(ctrl_smsCtrl, {});

var Order_Order =
/*#__PURE__*/
function (_React$Component) {
  Order__inherits(Order, _React$Component);

  function Order(props) {
    var _this;

    Order__classCallCheck(this, Order);

    _this = Order__possibleConstructorReturn(this, (Order.__proto__ || Object.getPrototypeOf(Order)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var language = lang;

    if (lang === 'hk') {
      language = "".concat(langType, "-").concat(lang);
    }

    _this.state = {
      isShowOrderDetail: false,
      modelData: __webpack_require__(1437)("./".concat(lang, "/").concat(language, "-modelData.json")),
      modelDataText: __webpack_require__(920)("./".concat(lang, "/").concat(language, ".json")),
      setting: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json")),
      // for init order data
      orderIntiData: __webpack_require__(1020),
      lang: lang
    };
    _this.onClickConfirm = _this.onClickConfirm.bind(Order__assertThisInitialized(_this));
    return _this;
  }

  Order__createClass(Order, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.initOrderDetailInfoAction(this.state.orderIntiData.orderDetailInfo[this.state.lang]);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.style.overflowY = 'scroll';
      this.checkIsLogin();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {// localStorageRemove('addresses');
    }
  }, {
    key: "onClickConfirm",
    value: function onClickConfirm() {
      if (this.props.isValidOrder) {
        this.setState({
          isShowOrderDetail: !this.state.isShowOrderDetail
        });
      }
    }
  }, {
    key: "checkIsLogin",
    value: function checkIsLogin() {
      var _this2 = this;

      Object(api_order["i" /* getOrderRequest */])(null, this.props.currentLocale).then(function (result) {
        Object(util["a" /* IsValidResponseStatus */])(result.status, _this2.props.setisNotExpiredLogin);
      }).catch(function () {
        _this2.props.setisNotExpiredLogin();
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Process the dataModel first before the template rendering
      return Order__jsx("div", {}, void 0, this.state.lang === 'hk' ? Order__jsx(order_hkOrder, {
        modelData: this.state.modelData,
        modelDataText: this.state.modelDataText,
        setting: this.state.setting,
        lang: this.state.lang,
        onClickConfirm: this.onClickConfirm,
        isShowOrderDetail: this.state.isShowOrderDetail
      }) : '', this.state.lang === 'tw' ? Order__jsx(order_twOrder, {
        modelData: this.state.modelData,
        modelDataText: this.state.modelDataText,
        setting: this.state.setting,
        lang: this.state.lang,
        onClickConfirm: this.onClickConfirm,
        isShowOrderDetail: this.state.isShowOrderDetail
      }) : '', this.state.lang === 'in' ? Order__jsx(inOrder, {
        modelData: this.state.modelData,
        modelDataText: this.state.modelDataText,
        setting: this.state.setting,
        lang: this.state.lang,
        onClickConfirm: this.onClickConfirm,
        isShowOrderDetail: this.state.isShowOrderDetail
      }) : '', this.state.lang === 'kr' ? Order__jsx(krOrder, {
        modelData: this.state.modelData,
        modelDataText: this.state.modelDataText,
        setting: this.state.setting,
        lang: this.state.lang,
        onClickConfirm: this.onClickConfirm,
        isShowOrderDetail: this.state.isShowOrderDetail
      }) : '', this.state.lang === 'sg' ? Order__jsx(order_sgOrder, {
        modelData: this.state.modelData,
        modelDataText: this.state.modelDataText,
        setting: this.state.setting,
        lang: this.state.lang,
        onClickConfirm: this.onClickConfirm,
        isShowOrderDetail: this.state.isShowOrderDetail
      }) : '', Object(auth["b" /* getAuth */])().phone !== null && typeof Object(auth["b" /* getAuth */])().phone !== 'undefined' ? Order__ref : '');
    }
  }]);

  return Order;
}(react_default.a.Component);

var Order_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    address: state.order.address,
    isValidOrder: state.order.isValidOrder,
    orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
    images: state.order.images
  };
};

var Order_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  initOrderDetailInfoAction: actions_order["d" /* initOrderDetailInfoAction */],
  addUploadedOrderImage: actions_order["c" /* addUploadedOrderImage */]
};
/* harmony default export */ var routes_order_Order = (Object(es["b" /* connect */])(Order_mapState, Order_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, Order_default.a, slidedown_default.a)(Order_Order)));
// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 9 modules
var Layout = __webpack_require__(859);

// CONCATENATED MODULE: ./src/routes/order/index.js
var order_REACT_ELEMENT_TYPE;

function order__jsx(type, props, key, children) { if (!order_REACT_ELEMENT_TYPE) { order_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: order_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }


 // import { Provider } from 'react-redux';
// import { defineMessages } from 'react-intl';
// import { createStore } from 'redux';



var title = 'Order';

var order__ref = order__jsx(Layout["a" /* default */], {}, void 0, order__jsx(routes_order_Order, {}));

function action() {
  return {
    chunks: ['order'],
    title: title,
    component: order__ref
  };
}

/* harmony default export */ var routes_order = __webpack_exports__["default"] = (action);

/***/ })
]));


// WEBPACK FOOTER //
// order.74338757.chunk.js